var $e = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, o) {
    const i = t ? this.allAsyncListeners : this.allSyncListeners;
    let s = i.get(e);
    return !s && o && (s = /* @__PURE__ */ new Set(), i.set(e, s)), s;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, o = !1) {
    this.getListeners(e, o, !0).add(t);
  }
  removeEventListener(e, t, o = !1) {
    const i = this.getListeners(e, o, !1);
    i && (i.delete(t), i.size === 0 && (o ? this.allAsyncListeners : this.allSyncListeners).delete(e));
  }
  addGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).add(e);
  }
  removeGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).delete(e);
  }
  dispatchEvent(e) {
    this.dispatchToListeners(e, !0), this.dispatchToListeners(e, !1), this.firedEvents[e.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    const o = e.type;
    if (t && "event" in e) {
      const l = e.event;
      l instanceof Event && (e.eventPath = l.composedPath());
    }
    const { frameworkOverrides: i } = this, s = (l) => {
      const a = i ? () => i.wrapIncoming(l) : l;
      t ? this.dispatchAsync(a) : a();
    }, n = this.getListeners(o, t, !1);
    if ((n?.size ?? 0) > 0) {
      const l = new Set(n);
      for (const a of l)
        n?.has(a) && s(() => a(e));
    }
    const r = this.getGlobalListeners(t);
    if (r.size > 0) {
      const l = new Set(r);
      for (const a of l)
        s(() => a(o, e));
    }
  }
  getGlobalListeners(e) {
    return e ? this.globalAsyncListeners : this.globalSyncListeners;
  }
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  dispatchAsync(e) {
    if (this.asyncFunctionsQueue.push(e), !this.scheduled) {
      const t = () => {
        window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      };
      this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(t) : t(), this.scheduled = !0;
    }
  }
  // this happens in the next VM turn only, and empties the queue of events
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [];
    for (const t of e)
      t();
  }
};
function Ne(e) {
  return e == null || e === "" ? null : e;
}
function A(e) {
  return e != null && e !== "";
}
function H(e) {
  return !A(e);
}
function wi(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function Nl(e, t, o = !1) {
  const i = e == null, s = t == null;
  if (e?.toNumber && (e = e.toNumber()), t?.toNumber && (t = t.toNumber()), i && s)
    return 0;
  if (i)
    return -1;
  if (s)
    return 1;
  function n(r, l) {
    return r > l ? 1 : r < l ? -1 : 0;
  }
  if (typeof e != "string" || !o)
    return n(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return n(e, t);
  }
}
var zl = /[&<>"']/g, _l = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function Oo(e) {
  return e?.toString().toString() ?? null;
}
function Et(e) {
  return Oo(e)?.replace(zl, (t) => _l[t]) ?? null;
}
function ge(e) {
  return e.eRootDiv.getRootNode();
}
function N(e) {
  return ge(e).activeElement;
}
function j(e) {
  const { gos: t, eRootDiv: o } = e;
  let i = null;
  const s = t.get("getDocument");
  return s && A(s) ? i = s() : o && (i = o.ownerDocument), i && A(i) ? i : document;
}
function yn(e) {
  const t = N(e);
  return t === null || t === j(e).body;
}
function Rn(e) {
  return j(e).defaultView || window;
}
function ji(e) {
  let t = null, o = null;
  try {
    t = j(e).fullscreenElement;
  } catch {
  } finally {
    t || (t = ge(e));
    const i = t.querySelector("body");
    i ? o = i : t instanceof ShadowRoot ? o = t : t instanceof Document ? o = t?.documentElement : o = t;
  }
  return o;
}
function Ul(e) {
  return ji(e)?.clientWidth ?? (window.innerWidth || -1);
}
function $l(e) {
  return ji(e)?.clientHeight ?? (window.innerHeight || -1);
}
function de(e, t, o) {
  o == null || typeof o == "string" && o == "" ? xn(e, t) : ce(e, t, o);
}
function ce(e, t, o) {
  e.setAttribute(Pn(t), o.toString());
}
function xn(e, t) {
  e.removeAttribute(Pn(t));
}
function Pn(e) {
  return `aria-${e}`;
}
function Ie(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function Kl(e) {
  let t;
  return e === "asc" ? t = "ascending" : e === "desc" ? t = "descending" : e === "mixed" ? t = "other" : t = "none", t;
}
function jl(e) {
  return e.getAttribute("aria-label");
}
function Gt(e, t) {
  de(e, "label", t);
}
function Ht(e, t) {
  de(e, "labelledby", t);
}
function Dn(e, t) {
  de(e, "live", t);
}
function ql(e, t) {
  de(e, "atomic", t);
}
function Yl(e, t) {
  de(e, "relevant", t);
}
function Zl(e, t) {
  de(e, "invalid", t);
}
function Ql(e, t) {
  de(e, "disabled", t);
}
function Fn(e, t) {
  de(e, "hidden", t);
}
function Si(e, t) {
  ce(e, "expanded", t);
}
function Xl(e, t) {
  ce(e, "setsize", t);
}
function Jl(e, t) {
  ce(e, "posinset", t);
}
function ea(e, t) {
  ce(e, "multiselectable", t);
}
function ta(e, t) {
  ce(e, "rowcount", t);
}
function bi(e, t) {
  ce(e, "rowindex", t);
}
function oa(e, t) {
  ce(e, "colcount", t);
}
function En(e, t) {
  ce(e, "colindex", t);
}
function ia(e, t) {
  ce(e, "colspan", t);
}
function sa(e, t) {
  ce(e, "sort", t);
}
function na(e) {
  xn(e, "sort");
}
function An(e, t) {
  de(e, "selected", t);
}
function ra(e, t) {
  de(e, "controls", t);
}
function la(e, t) {
  ra(e, t.id), Ht(t, e.id);
}
function Ds(e, t) {
  de(e, "owns", t);
}
function qi(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
var aa = "[tabindex], input, select, button, textarea, [href]", Mn = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function At(e) {
  return !e || !e.matches("input, select, button, textarea") || !e.matches(Mn) ? !1 : ke(e);
}
function V(e, t, o = {}) {
  const { skipAriaHidden: i } = o;
  e.classList.toggle("ag-hidden", !t), i || Fn(e, !t);
}
function da(e, t, o = {}) {
  const { skipAriaHidden: i } = o;
  e.classList.toggle("ag-invisible", !t), i || Fn(e, !t);
}
function Tn(e, t) {
  const o = "disabled", i = t ? (n) => n.setAttribute(o, "") : (n) => n.removeAttribute(o);
  i(e);
  const s = e.querySelectorAll("input") ?? [];
  for (const n of s)
    i(n);
}
function tt(e, t, o) {
  let i = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof o == "number") {
      if (++i > o)
        break;
    } else if (e === o)
      break;
  }
  return !1;
}
function vt(e) {
  const {
    height: t,
    width: o,
    borderTopWidth: i,
    borderRightWidth: s,
    borderBottomWidth: n,
    borderLeftWidth: r,
    paddingTop: l,
    paddingRight: a,
    paddingBottom: d,
    paddingLeft: c,
    marginTop: u,
    marginRight: h,
    marginBottom: g,
    marginLeft: p,
    boxSizing: f
  } = window.getComputedStyle(e), C = Number.parseFloat;
  return {
    height: C(t || "0"),
    width: C(o || "0"),
    borderTopWidth: C(i || "0"),
    borderRightWidth: C(s || "0"),
    borderBottomWidth: C(n || "0"),
    borderLeftWidth: C(r || "0"),
    paddingTop: C(l || "0"),
    paddingRight: C(a || "0"),
    paddingBottom: C(d || "0"),
    paddingLeft: C(c || "0"),
    marginTop: C(u || "0"),
    marginRight: C(h || "0"),
    marginBottom: C(g || "0"),
    marginLeft: C(p || "0"),
    boxSizing: f
  };
}
function Yi(e) {
  const t = vt(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom - t.borderTopWidth - t.borderBottomWidth : t.height;
}
function Ot(e) {
  const t = vt(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight - t.borderLeftWidth - t.borderRightWidth : t.width;
}
function ca(e) {
  const { height: t, marginBottom: o, marginTop: i } = vt(e);
  return Math.floor(t + o + i);
}
function yi(e) {
  const { width: t, marginLeft: o, marginRight: i } = vt(e);
  return Math.floor(t + o + i);
}
function In(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: o, borderLeftWidth: i, borderRightWidth: s, borderBottomWidth: n } = vt(e);
  return {
    top: t.top + (o || 0),
    left: t.left + (i || 0),
    right: t.right + (s || 0),
    bottom: t.bottom + (n || 0)
  };
}
function vo(e, t) {
  let o = e.scrollLeft;
  return t && (o = Math.abs(o)), o;
}
function wo(e, t, o) {
  o && (t *= -1), e.scrollLeft = t;
}
function J(e) {
  for (; e?.firstChild; )
    e.firstChild.remove();
}
function Ae(e) {
  e?.parentNode && e.remove();
}
function kn(e) {
  return !!e.offsetParent;
}
function ke(e) {
  return e.checkVisibility ? e.checkVisibility({ checkVisibilityCSS: !0 }) : !(!kn(e) || window.getComputedStyle(e).visibility !== "visible");
}
function Zi(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function Ln(e, t, o) {
  o && o.nextSibling === t || (e.firstChild ? o ? o.nextSibling ? e.insertBefore(t, o.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t) : e.appendChild(t));
}
function Gn(e, t) {
  for (let o = 0; o < t.length; o++) {
    const i = t[o], s = e.children[o];
    s !== i && e.insertBefore(i, s);
  }
}
function ua(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLocaleLowerCase()}`);
}
function Kt(e, t) {
  if (t)
    for (const o of Object.keys(t)) {
      const i = t[o];
      if (!o?.length || i == null)
        continue;
      const s = ua(o), n = i.toString(), r = n.replace(/\s*!important/g, ""), l = r.length != n.length ? "important" : void 0;
      e.style.setProperty(s, r, l);
    }
}
function ha(e) {
  return () => {
    const t = e();
    return t ? Qi(t) || Hn(t) : !0;
  };
}
function Qi(e) {
  return e.clientWidth < e.scrollWidth;
}
function Hn(e) {
  return e.clientHeight < e.scrollHeight;
}
function So(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : Me(e, t);
}
function Me(e, t) {
  t = Xi(t), e.style.width = t, e.style.maxWidth = t, e.style.minWidth = t;
}
function $o(e, t) {
  t = Xi(t), e.style.height = t, e.style.maxHeight = t, e.style.minHeight = t;
}
function Xi(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function Ji(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function Ve(e, t, o) {
  o == null || o === "" ? e.removeAttribute(t) : e.setAttribute(t, o.toString());
}
function wt(e, t, o) {
  const s = Rn(e).ResizeObserver, n = s ? new s(o) : null;
  return n?.observe(t), () => n?.disconnect();
}
function Le(e, t) {
  const o = Rn(e);
  o.requestAnimationFrame ? o.requestAnimationFrame(t) : o.webkitRequestAnimationFrame ? o.webkitRequestAnimationFrame(t) : o.setTimeout(t, 0);
}
var On = "data-ref", Ko;
function Fs() {
  return Ko ?? (Ko = document.createTextNode(" ")), Ko.cloneNode();
}
function jt(e) {
  const { attrs: t, children: o, cls: i, ref: s, role: n, tag: r } = e, l = document.createElement(r);
  if (i && (l.className = i), s && l.setAttribute(On, s), n && l.setAttribute("role", n), t)
    for (const a of Object.keys(t))
      l.setAttribute(a, t[a]);
  if (o)
    if (typeof o == "string")
      l.textContent = o;
    else {
      let a = !0;
      for (const d of o)
        d && (typeof d == "string" ? (l.appendChild(document.createTextNode(d)), a = !1) : typeof d == "function" ? l.appendChild(d()) : (a && (l.appendChild(Fs()), a = !1), l.append(jt(d)), l.appendChild(Fs())));
    }
  return l;
}
var ga = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], pa = ["wheel"], jo = {}, Bn = /* @__PURE__ */ (() => {
  const e = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };
  return (o) => {
    if (typeof jo[o] == "boolean")
      return jo[o];
    const i = document.createElement(e[o] || "div");
    return o = "on" + o, jo[o] = o in i;
  };
})();
function fa(e, t) {
  return !t || !e ? !1 : ma(t).indexOf(e) >= 0;
}
function Ca(e) {
  const t = [];
  let o = e.target;
  for (; o; )
    t.push(o), o = o.parentElement;
  return t;
}
function ma(e) {
  const t = e;
  return t.path ? t.path : t.composedPath ? t.composedPath() : Ca(t);
}
function va(e, t, o) {
  const i = wa(t);
  let s;
  i != null && (s = { passive: i }), e.addEventListener(t, o, s);
}
var wa = (e) => {
  const t = ga.includes(e), o = pa.includes(e);
  if (t)
    return !0;
  if (o)
    return !1;
};
function Vn(e, t, o) {
  if (o === 0)
    return !1;
  const i = Math.abs(e.clientX - t.clientX), s = Math.abs(e.clientY - t.clientY);
  return Math.max(i, s) <= o;
}
var Mt = (e, t) => {
  const o = e.identifier;
  for (let i = 0, s = t.length; i < s; ++i) {
    const n = t[i];
    if (n.identifier === o)
      return n;
  }
  return null;
};
function Bt(e, t) {
  return e.gos.isElementInThisInstance(t.target);
}
function Sa(e, t, o) {
  const s = e.getBoundingClientRect().height, n = Ul(o) - 2, r = $l(o) - 2;
  if (!e.offsetParent)
    return;
  const a = In(e.offsetParent), { clientY: d, clientX: c } = t;
  let u = d - a.top - s / 2, h = c - a.left - 10;
  const g = j(o), p = g.defaultView || window, f = p.pageYOffset || g.documentElement.scrollTop, C = p.pageXOffset || g.documentElement.scrollLeft;
  n > 0 && h + e.clientWidth > n + C && (h = n + C - e.clientWidth), h < 0 && (h = 0), r > 0 && u + e.clientHeight > r + f && (u = r + f - e.clientHeight), u < 0 && (u = 0), e.style.left = `${h}px`, e.style.top = `${u}px`;
}
var lo = (e, ...t) => {
  for (const o of t) {
    const [i, s, n, r] = o;
    i.addEventListener(s, n, r), e.push(o);
  }
}, es = (e) => {
  if (e) {
    for (const [t, o, i, s] of e)
      t.removeEventListener(o, i, s);
    e.length = 0;
  }
}, Fe = (e) => {
  e.cancelable && e.preventDefault();
};
function ba(e, t) {
  return t;
}
function Wn(e) {
  return e?.getLocaleTextFunc() ?? ba;
}
function ya(e) {
  return (t, o, i) => e({
    key: t,
    defaultValue: o,
    variableValues: i
  });
}
function Ra(e) {
  return (t, o, i) => {
    let s = e?.[t];
    if (s && i?.length) {
      let n = 0;
      for (; !(n >= i.length || s.indexOf("${variable}") === -1); )
        s = s.replace("${variable}", i[n++]);
    }
    return s ?? o;
  };
}
var Ge = class {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.propertyListenerId = 0, this.lastChangeSetIdLookup = {}, this.isAlive = () => !this.destroyed;
  }
  preWireBeans(e) {
    this.beans = e, this.stubContext = e.context, this.eventSvc = e.eventSvc, this.gos = e.gos;
  }
  // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
  // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
  // points to a bean or component that was not properly disposed of.
  // constructor() {
  //     setTimeout(()=> {
  //         if (this.isAlive()) {
  //             let prototype: any = Object.getPrototypeOf(this);
  //             const constructor: any = prototype.constructor;
  //             const constructorString = constructor.toString();
  //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
  //             console.log('is alive ' + beanName);
  //         }
  //     }, 5000);
  // }
  destroy() {
    const { destroyFunctions: e } = this;
    for (let t = 0; t < e.length; t++)
      e[t]();
    e.length = 0, this.destroyed = !0, this.dispatchLocalEvent({ type: "destroyed" });
  }
  /** Add a local event listener against this BeanStub */
  addEventListener(e, t, o) {
    this.localEventService || (this.localEventService = new $e()), this.localEventService.addEventListener(e, t, o);
  }
  /** Remove a local event listener from this BeanStub */
  removeEventListener(e, t, o) {
    this.localEventService?.removeEventListener(e, t, o);
  }
  dispatchLocalEvent(e) {
    this.localEventService?.dispatchEvent(e);
  }
  addManagedElementListeners(e, t) {
    return this._setupListeners(e, t);
  }
  addManagedEventListeners(e) {
    return this._setupListeners(this.eventSvc, e);
  }
  addManagedListeners(e, t) {
    return this._setupListeners(e, t);
  }
  _setupListeners(e, t) {
    const o = [];
    for (const i of Object.keys(t)) {
      const s = t[i];
      s && o.push(this._setupListener(e, i, s));
    }
    return o;
  }
  _setupListener(e, t, o) {
    if (this.destroyed)
      return () => null;
    let i;
    if (xa(e))
      e.__addEventListener(t, o), i = () => (e.__removeEventListener(t, o), null);
    else {
      const s = Pa(e);
      e instanceof HTMLElement ? va(e, t, o) : s ? e.addListener(t, o) : e.addEventListener(t, o), i = s ? () => (e.removeListener(t, o), null) : () => (e.removeEventListener(t, o), null);
    }
    return this.destroyFunctions.push(i), () => (i(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== i), null);
  }
  /**
   * Setup a managed property listener for the given property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the properties service is destroyed.
   */
  setupPropertyListener(e, t) {
    const { gos: o } = this;
    o.addPropertyEventListener(e, t);
    const i = () => (o.removePropertyEventListener(e, t), null);
    return this.destroyFunctions.push(i), () => (i(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== i), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */
  addManagedPropertyListener(e, t) {
    return this.destroyed ? () => null : this.setupPropertyListener(e, t);
  }
  /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */
  addManagedPropertyListeners(e, t) {
    if (this.destroyed)
      return;
    const o = e.join("-") + this.propertyListenerId++, i = (s) => {
      if (s.changeSet) {
        if (s.changeSet && s.changeSet.id === this.lastChangeSetIdLookup[o])
          return;
        this.lastChangeSetIdLookup[o] = s.changeSet.id;
      }
      const n = {
        type: "propertyChanged",
        changeSet: s.changeSet,
        source: s.source
      };
      t(n);
    };
    for (const s of e)
      this.setupPropertyListener(s, i);
  }
  getLocaleTextFunc() {
    return Wn(this.beans.localeSvc);
  }
  addDestroyFunc(e) {
    this.isAlive() ? this.destroyFunctions.push(e) : e();
  }
  /** doesn't throw an error if `bean` is undefined */
  createOptionalManagedBean(e, t) {
    return e ? this.createManagedBean(e, t) : void 0;
  }
  createManagedBean(e, t) {
    const o = this.createBean(e, t);
    return this.addDestroyFunc(this.destroyBean.bind(this, e, t)), o;
  }
  createBean(e, t, o) {
    return (t || this.stubContext).createBean(e, o);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e, t) {
    return (t || this.stubContext).destroyBean(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e, t) {
    return (t || this.stubContext).destroyBeans(e);
  }
};
function xa(e) {
  return e.__addEventListener !== void 0;
}
function Pa(e) {
  return e.eventServiceType === "global";
}
var b = class extends Ge {
}, Es = {};
function ts(e, t) {
  Es[t] || (e(), Es[t] = !0);
}
var Da = {
  pending: !1,
  funcs: []
}, Fa = {
  pending: !1,
  funcs: []
};
function Ri(e, t = "setTimeout", o) {
  const i = t === "raf" ? Fa : Da;
  if (i.funcs.push(e), i.pending)
    return;
  i.pending = !0;
  const s = () => {
    const n = i.funcs.slice();
    i.funcs.length = 0, i.pending = !1;
    for (const r of n)
      r();
  };
  t === "raf" ? Le(o, s) : window.setTimeout(s, 0);
}
function We(e, t, o) {
  let i;
  return function(...s) {
    const n = this;
    window.clearTimeout(i), i = window.setTimeout(function() {
      e.isAlive() && t.apply(n, s);
    }, o);
  };
}
function As(e, t) {
  let o = 0;
  return function(...i) {
    const s = this, n = Date.now();
    n - o < t || (o = n, e.apply(s, i));
  };
}
function Ea(e, t, o, i = 100) {
  const s = Date.now();
  let n = null, r = !1;
  const l = () => {
    n != null && (window.clearInterval(n), n = null);
  };
  e.addDestroyFunc(l);
  const a = () => {
    const d = Date.now() - s > i;
    (t() || d) && (o(), r = !0, l());
  };
  a(), r || (n = window.setInterval(a, 10));
}
var Nn = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function Aa(e, t) {
  if (e != null) {
    if (Array.isArray(e)) {
      for (let o = 0; o < e.length; o++)
        t(o.toString(), e[o]);
      return;
    }
    for (const o of Object.keys(e).filter((i) => !Nn.has(i)))
      t(o, e[o]);
  }
}
function ee(e, t, o = !0, i = !1) {
  A(t) && Aa(t, (s, n) => {
    let r = e[s];
    r !== n && (i && r == null && n != null && typeof n == "object" && n.constructor === Object && (r = {}, e[s] = r), Ms(n) && Ms(r) && !Array.isArray(r) ? ee(r, n, o, i) : (o || n !== void 0) && (e[s] = n));
  });
}
function Ms(e) {
  return typeof e == "object" && e !== null;
}
var os = class Se {
  /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */
  static applyGlobalGridOptions(t) {
    if (!Se.gridOptions)
      return { ...t };
    let o = {};
    return ee(o, Se.gridOptions, !0, !0), Se.mergeStrategy === "deep" ? ee(o, t, !0, !0) : o = { ...o, ...t }, Se.gridOptions.context && (o.context = Se.gridOptions.context), t.context && (Se.mergeStrategy === "deep" && o.context && ee(t.context, o.context, !0, !0), o.context = t.context), o;
  }
  /**
   * Apply global grid option for a specific option key.
   * If the merge strategy is 'deep' and both global and provided values are objects, they will be merged deeply.
   * Otherwise, the provided value is returned as is.
   * @param optionKey - The key of the grid option to apply.
   * @param providedValue - The value provided to the grid instance.
   * @returns The merged value if applicable, otherwise the provided value.
   */
  static applyGlobalGridOption(t, o) {
    if (Se.mergeStrategy === "deep") {
      const i = Ma(t);
      if (i && typeof i == "object" && typeof o == "object")
        return Se.applyGlobalGridOptions({ [t]: o })[t];
    }
    return o;
  }
};
os.gridOptions = void 0;
os.mergeStrategy = "shallow";
var is = os;
function Ma(e) {
  return is.gridOptions?.[e];
}
var Ta = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !0,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipShowMode: "standard",
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  enableStrictPivotColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressMoveWhenColumnDragging: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  cellFlashDuration: 500,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  rowDragInsertDelay: 500,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressHeaderFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: !1,
  suppressServerSideFullWidthLoadingRow: !1,
  pivotMaxGeneratedColumns: -1,
  columnMenu: "new",
  reactiveCustomComponents: !0,
  suppressSetFilterByDefault: !1,
  rowNumbers: !1,
  enableFilterHandlers: !1
}, zn = "https://www.ag-grid.com";
function Vt(e, t, ...o) {
  e.get("debug") && console.log("AG Grid: " + t, ...o);
}
function Tt(e, ...t) {
  ts(() => console.warn("AG Grid: " + e, ...t), e + t?.join(""));
}
function ot(e, ...t) {
  ts(() => console.error("AG Grid: " + e, ...t), e + t?.join(""));
}
var _n = /* @__PURE__ */ new Set(), bo = {}, it = {}, ao, Un = !1, $n = !1, Ia = !1;
function ka(e) {
  const [t, o] = e.version.split(".") || [], [i, s] = ao.split(".") || [];
  return t === i && o === s;
}
function La(e) {
  ao || (ao = e.version);
  const t = (i) => `You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${i} Please update all modules to the same version.`;
  e.version ? ka(e) || ot(
    t(
      `'${e.moduleName}' is version ${e.version} but the other modules are version ${ao}.`
    )
  ) : ot(t(`'${e.moduleName}' is incompatible.`));
  const o = e.validate?.();
  o && !o.isValid && ot(`${o.message}`);
}
function Wt(e, t, o = !1) {
  o || (Un = !0), La(e);
  const i = e.rowModels ?? ["all"];
  _n.add(e);
  let s;
  t !== void 0 ? ($n = !0, it[t] === void 0 && (it[t] = {}), s = it[t]) : s = bo;
  for (const n of i)
    s[n] === void 0 && (s[n] = {}), s[n][e.moduleName] = e;
  if (e.dependsOn)
    for (const n of e.dependsOn)
      Wt(n, t, o);
}
function Ga(e) {
  delete it[e];
}
function xi(e, t, o) {
  const i = (s) => !!bo[s]?.[e] || !!it[t]?.[s]?.[e];
  return i(o) || i("all");
}
function ss() {
  return $n;
}
function Ha(e, t) {
  const o = it[e] ?? {};
  return [
    ...Object.values(bo.all ?? {}),
    ...Object.values(o.all ?? {}),
    ...Object.values(bo[t] ?? {}),
    ...Object.values(o[t] ?? {})
  ];
}
function Oa() {
  return new Set(_n);
}
function Ba() {
  return Un;
}
function Va() {
  return Ia;
}
var hS = class {
  /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */
  static register(e) {
    Wt(e, void 0);
  }
  /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */
  static registerModules(e) {
    for (const t of e)
      Wt(t, void 0);
  }
}, M = "34.3.1", Ts = 2e3, Is = 100, Kn = "_version_", jn = null, st = `${zn}/javascript-data-grid`;
function Wa(e) {
  jn = e;
}
function Na(e) {
  st = e;
}
function qn(e, t, o) {
  return jn?.(e, t) ?? [$a(e, t, o)];
}
function ns(e, t, o, i, s) {
  e(`${i ? "warning" : "error"} #${t}`, ...qn(t, o, s));
}
function za(e) {
  if (!e)
    return String(e);
  const t = {};
  for (const o of Object.keys(e))
    typeof e[o] != "object" && typeof e[o] != "function" && (t[o] = e[o]);
  return JSON.stringify(t);
}
function _a(e) {
  let t = e;
  return e instanceof Error ? t = e.toString() : typeof e == "object" && (t = za(e)), t;
}
function yo(e) {
  return e === void 0 ? "undefined" : e === null ? "null" : e;
}
function Pi(e, t) {
  return `${e}?${t.toString()}`;
}
function Ua(e, t, o) {
  const i = Array.from(t.entries()).sort((n, r) => r[1].length - n[1].length);
  let s = Pi(e, t);
  for (const [n, r] of i) {
    if (n === Kn)
      continue;
    const l = s.length - o;
    if (l <= 0)
      break;
    const a = "...", d = l + a.length, c = r.length - d > Is ? r.slice(0, r.length - d) + a : r.slice(0, Is) + a;
    t.set(n, c), s = Pi(e, t);
  }
  return s;
}
function Yn(e, t) {
  const o = new URLSearchParams();
  if (o.append(Kn, M), t)
    for (const n of Object.keys(t))
      o.append(n, _a(t[n]));
  const i = `${st}/errors/${e}`, s = Pi(i, o);
  return s.length <= Ts ? s : Ua(i, o, Ts);
}
var $a = (e, t, o) => {
  const i = Yn(e, t);
  return `${`${o ? o + ` 
` : ""}Visit ${i}`}${o ? "" : ` 
  Alternatively register the ValidationModule to see the full message in the console.`}`;
};
function F(...e) {
  ns(Tt, e[0], e[1], !0);
}
function W(...e) {
  ns(ot, e[0], e[1], !1);
}
function Dt(e, t, o) {
  ns(ot, e, t, !1, o);
}
function Ka(e, t) {
  const o = t[0];
  return `error #${o} ` + qn(o, t[1], e).join(" ");
}
function Ce(...e) {
  return Ka(void 0, e);
}
function Zn(e, t) {
  return e.get("rowModelType") === t;
}
function re(e, t) {
  return Zn(e, "clientSide");
}
function rs(e, t) {
  return Zn(e, "serverSide");
}
function Y(e, t) {
  return e.get("domLayout") === t;
}
function ze(e) {
  return xo(e) !== void 0;
}
function Qn(e) {
  return typeof e.get("getRowHeight") == "function";
}
function ja(e, t) {
  return t ? !e.get("enableStrictPivotColumnOrder") : e.get("maintainColumnOrder");
}
function Di(e, t, o = !1, i) {
  const { gos: s, environment: n } = e;
  if (i == null && (i = n.getDefaultRowHeight()), Qn(s)) {
    if (o)
      return { height: i, estimated: !0 };
    const a = {
      node: t,
      data: t.data
    }, d = s.getCallback("getRowHeight")(a);
    if (Fi(d))
      return d === 0 && F(23), { height: Math.max(1, d), estimated: !1 };
  }
  if (t.detail && s.get("masterDetail"))
    return qa(s);
  const r = s.get("rowHeight");
  return { height: r && Fi(r) ? r : i, estimated: !1 };
}
function qa(e) {
  if (e.get("detailRowAutoHeight"))
    return { height: 1, estimated: !1 };
  const t = e.get("detailRowHeight");
  return Fi(t) ? { height: t, estimated: !1 } : { height: 300, estimated: !1 };
}
function Bo(e) {
  const { environment: t, gos: o } = e, i = o.get("rowHeight");
  if (!i || H(i))
    return t.getDefaultRowHeight();
  const s = t.refreshRowHeightVariable();
  return s !== -1 ? s : (F(24), t.getDefaultRowHeight());
}
function Fi(e) {
  return !isNaN(e) && typeof e == "number" && isFinite(e);
}
function Xn(e, t, o) {
  const i = t[e.getDomDataKey()];
  return i ? i[o] : void 0;
}
function ut(e, t, o, i) {
  const s = e.getDomDataKey();
  let n = t[s];
  H(n) && (n = {}, t[s] = n), n[o] = i;
}
function nt(e) {
  return e.get("ensureDomOrder") ? !1 : e.get("animateRows");
}
function Jn(e) {
  return !(e.get("paginateChildRows") || e.get("groupHideOpenParents") || Y(e, "print"));
}
function pe(e) {
  return !e.get("autoGroupColumnDef")?.comparator && !e.get("treeData");
}
function er(e, t) {
  return t ? !1 : e.get("groupDisplayType") === "groupRows";
}
function Ya(e, t, o) {
  return !!t.group && !t.footer && er(e, o);
}
function Ei(e) {
  const t = e.getCallback("getRowId");
  return t === void 0 ? t : (o) => {
    let i = t(o);
    return typeof i != "string" && (ts(() => F(25, { id: i }), "getRowIdString"), i = String(i)), i;
  };
}
function rt(e) {
  return e?.checkboxes ?? !0;
}
function co(e) {
  return e?.mode === "multiRow" && (e.headerCheckbox ?? !0);
}
function Ro(e) {
  if (typeof e == "object")
    return e.checkboxLocation ?? "selectionColumn";
}
function qo(e) {
  return e?.hideDisabledCheckboxes ?? !1;
}
function Za(e) {
  return typeof e.get("rowSelection") != "string";
}
function ht(e) {
  const t = e.get("cellSelection");
  return t !== void 0 ? !!t : e.get("enableRangeSelection");
}
function tr(e) {
  const t = e.get("rowSelection") ?? "single";
  if (typeof t == "string") {
    const o = e.get("suppressRowClickSelection"), i = e.get("suppressRowDeselection");
    return o && i ? !1 : o ? "enableDeselection" : i ? "enableSelection" : !0;
  }
  return t.mode === "singleRow" || t.mode === "multiRow" ? t.enableClickSelection ?? !1 : !1;
}
function Qa(e) {
  const t = tr(e);
  return t === !0 || t === "enableSelection";
}
function Xa(e) {
  const t = tr(e);
  return t === !0 || t === "enableDeselection";
}
function Ai(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("isRowSelectable") : t?.isRowSelectable;
}
function xo(e) {
  const t = "beanName" in e && e.beanName === "gos" ? e.get("rowSelection") : e.rowSelection;
  if (typeof t == "string")
    switch (t) {
      case "multiple":
        return "multiRow";
      case "single":
        return "singleRow";
      default:
        return;
    }
  switch (t?.mode) {
    case "multiRow":
    case "singleRow":
      return t.mode;
    default:
      return;
  }
}
function Nt(e) {
  return xo(e) === "multiRow";
}
function Ja(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("rowMultiSelectWithClick") : t?.enableSelectionWithoutKeys ?? !1;
}
function Po(e) {
  const t = e.get("rowSelection");
  if (typeof t == "string") {
    const o = e.get("groupSelectsChildren"), i = e.get("groupSelectsFiltered");
    return o && i ? "filteredDescendants" : o ? "descendants" : "self";
  }
  return t?.mode === "multiRow" ? t.groupSelects : void 0;
}
function or(e, t = !0) {
  const o = e.get("rowSelection");
  return typeof o != "object" ? t ? "all" : void 0 : o.mode === "multiRow" ? o.selectAll : "all";
}
function ed(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? !1 : t?.mode === "multiRow" ? t.ctrlASelectsRows ?? !1 : !1;
}
function zt(e) {
  const t = Po(e);
  return t === "descendants" || t === "filteredDescendants";
}
function ks(e) {
  const t = e.get("rowSelection");
  return typeof t == "object" && t.masterSelects || "self";
}
function Do(e) {
  return e.get("columnMenu") === "legacy";
}
function td(e) {
  return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
}
function gS(e, t, o) {
  typeof e != "object" && (e = {});
  const i = { ...e };
  for (const s of o) {
    const n = t[s];
    typeof n < "u" && (i[s] = n);
  }
  return i;
}
function pS(e, t) {
  if (!e)
    return;
  const o = {};
  let i = !1;
  for (const r of Object.keys(e))
    o[r] = e[r], i = !0;
  if (!i)
    return;
  const s = {
    type: "gridOptionsChanged",
    options: o
  };
  t.dispatchEvent(s);
  const n = {
    type: "componentStateChanged",
    ...o
  };
  t.dispatchEvent(n);
}
function L(e, t) {
  return e.addCommon(t);
}
function Ls({ gos: e }, t) {
  return t.button === 2 || t.ctrlKey && e.get("allowContextMenuWithControlKey");
}
var od = {
  resizable: !0,
  sortable: !0
}, id = 0;
function ir() {
  return id++;
}
function Ke(e) {
  return e instanceof je;
}
var je = class extends b {
  constructor(e, t, o, i) {
    super(), this.colDef = e, this.userProvidedColDef = t, this.colId = o, this.primary = i, this.isColumn = !0, this.instanceId = ir(), this.autoHeaderHeight = null, this.moving = !1, this.resizing = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.colEventSvc = new $e(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.flex = null, this.colIdSanitised = Et(o);
  }
  destroy() {
    super.destroy(), this.beans.rowSpanSvc?.deregister(this);
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState() {
    const {
      colDef: e,
      beans: { sortSvc: t, pinnedCols: o, colFlex: i }
    } = this;
    t?.initCol(this);
    const s = e.hide;
    s !== void 0 ? this.visible = !s : this.visible = !e.initialHide, o?.initCol(this), i?.initCol(this);
  }
  // gets called when user provides an alternative colDef, eg
  setColDef(e, t, o) {
    const i = e.spanRows !== this.colDef.spanRows;
    this.colDef = e, this.userProvidedColDef = t, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), i && (this.beans.rowSpanSvc?.deregister(this), this.initRowSpan()), this.dispatchColEvent("colDefChanged", o);
  }
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  getParent() {
    return this.parent;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  // this is done after constructor as it uses gridOptionsService
  postConstruct() {
    this.setState(), this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip(), this.initRowSpan(), this.addPivotListener();
  }
  initDotNotation() {
    const {
      gos: e,
      colDef: { field: t, tooltipField: o }
    } = this, i = e.get("suppressFieldDotNotation");
    this.fieldContainsDots = A(t) && t.includes(".") && !i, this.tooltipFieldContainsDots = A(o) && o.includes(".") && !i;
  }
  initMinAndMaxWidths() {
    const e = this.colDef;
    this.minWidth = e.minWidth ?? this.beans.environment.getDefaultColumnMinWidth(), this.maxWidth = e.maxWidth ?? Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    this.beans.tooltipSvc?.initCol(this);
  }
  initRowSpan() {
    this.colDef.spanRows && this.beans.rowSpanSvc?.register(this);
  }
  addPivotListener() {
    const e = this.beans.pivotColDefSvc, t = this.colDef.pivotValueColumn;
    !e || !t || this.addManagedListeners(t, {
      colDefChanged: (o) => {
        const i = e.recreateColDef(this.colDef);
        this.setColDef(i, i, o.source);
      }
    });
  }
  resetActualWidth(e) {
    const t = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(t, e, !0);
  }
  calculateColInitialWidth(e) {
    let t;
    const o = e.width, i = e.initialWidth;
    return o != null ? t = o : i != null ? t = i : t = 200, Math.max(Math.min(t, this.maxWidth), this.minWidth);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(e) {
    return this.beans.showRowGroupCols?.isRowGroupDisplayed(this, e) ?? !1;
  }
  isPrimary() {
    return this.primary;
  }
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  getHighlighted() {
    return this.highlighted;
  }
  __addEventListener(e, t) {
    this.colEventSvc.addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.colEventSvc.removeEventListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(
      this.frameworkEventListenerService,
      this.colEventSvc
    );
    const o = this.frameworkEventListenerService?.wrap(e, t) ?? t;
    this.colEventSvc.addEventListener(e, o);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    const o = this.frameworkEventListenerService?.unwrap(e, t) ?? t;
    this.colEventSvc.removeEventListener(e, o);
  }
  createColumnFunctionCallbackParams(e) {
    return L(this.gos, {
      node: e,
      data: e.data,
      column: this,
      colDef: this.colDef
    });
  }
  isSuppressNavigable(e) {
    return this.beans.cellNavigation?.isSuppressNavigable(this, e) ?? !1;
  }
  isCellEditable(e) {
    return this.beans.editSvc?.isCellEditable({ rowNode: e, column: this }) ?? !1;
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(e) {
    return this.isColumnFunc(e, this.colDef.rowDrag);
  }
  isDndSource(e) {
    return this.isColumnFunc(e, this.colDef.dndSource);
  }
  isCellCheckboxSelection(e) {
    return this.beans.selectionSvc?.isCellCheckboxSelection(this, e) ?? !1;
  }
  isSuppressPaste(e) {
    return this.isColumnFunc(e, this.colDef?.suppressPaste ?? null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  /** Get value from ColDef or default if it exists. */
  getColDefValue(e) {
    return this.colDef[e] ?? od[e];
  }
  isColumnFunc(e, t) {
    if (typeof t == "boolean")
      return t;
    if (typeof t == "function") {
      const o = this.createColumnFunctionCallbackParams(e);
      return t(o);
    }
    return !1;
  }
  createColumnEvent(e, t) {
    return L(this.gos, {
      type: e,
      column: this,
      columns: [this],
      source: t
    });
  }
  isMoving() {
    return this.moving;
  }
  getSort() {
    return this.sort;
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  /** @deprecated v32 use col.getSort() === 'asc */
  isSortAscending() {
    return this.sort === "asc";
  }
  /** @deprecated v32 use col.getSort() === 'desc */
  isSortDescending() {
    return this.sort === "desc";
  }
  /** @deprecated v32 use col.getSort() === undefined */
  isSortNone() {
    return H(this.sort);
  }
  /** @deprecated v32 use col.getSort() !== undefined */
  isSorting() {
    return A(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(e, t) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchColEvent("leftChanged", t));
  }
  isFilterActive() {
    return this.filterActive;
  }
  /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */
  isHovered() {
    return F(261), !!this.beans.colHover?.isHovered(this);
  }
  setFirstRightPinned(e, t) {
    this.firstRightPinned !== e && (this.firstRightPinned = e, this.dispatchColEvent("firstRightPinnedChanged", t));
  }
  setLastLeftPinned(e, t) {
    this.lastLeftPinned !== e && (this.lastLeftPinned = e, this.dispatchColEvent("lastLeftPinnedChanged", t));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(e, t) {
    const o = e === !0;
    this.visible !== o && (this.visible = o, this.dispatchColEvent("visibleChanged", t)), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    return !this.getColDef().suppressSpanHeaderHeight;
  }
  /**
   * Returns the first parent that is not a padding group.
   */
  getFirstRealParent() {
    let e = this.getOriginalParent();
    for (; e?.isPadding(); )
      e = e.getOriginalParent();
    return e;
  }
  getColumnGroupPaddingInfo() {
    let e = this.getParent();
    if (!e?.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const t = e.getPaddingLevel() + 1;
    let o = !0;
    for (; e; ) {
      if (!e.isPadding()) {
        o = !1;
        break;
      }
      e = e.getParent();
    }
    return { numberOfParents: t, isSpanningTotal: o };
  }
  getColDef() {
    return this.colDef;
  }
  getDefinition() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  getColId() {
    return this.colId;
  }
  getId() {
    return this.colId;
  }
  getUniqueId() {
    return this.colId;
  }
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  createBaseColDefParams(e) {
    return L(this.gos, {
      node: e,
      data: e.data,
      colDef: this.colDef,
      column: this
    });
  }
  getColSpan(e) {
    if (H(this.colDef.colSpan))
      return 1;
    const t = this.createBaseColDefParams(e), o = this.colDef.colSpan(t);
    return Math.max(o, 1);
  }
  getRowSpan(e) {
    if (H(this.colDef.rowSpan))
      return 1;
    const t = this.createBaseColDefParams(e), o = this.colDef.rowSpan(t);
    return Math.max(o, 1);
  }
  setActualWidth(e, t, o = !1) {
    e = Math.max(e, this.minWidth), e = Math.min(e, this.maxWidth), this.actualWidth !== e && (this.actualWidth = e, this.flex != null && t !== "flex" && t !== "gridInitializing" && (this.flex = null), o || this.fireColumnWidthChangedEvent(t)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(e) {
    this.dispatchColEvent("widthChanged", e);
  }
  isGreaterThanMax(e) {
    return e > this.maxWidth;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex;
  }
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  dispatchColEvent(e, t, o) {
    const i = this.createColumnEvent(e, t);
    o && ee(i, o), this.colEventSvc.dispatchEvent(i);
  }
  dispatchStateUpdatedEvent(e) {
    this.colEventSvc.dispatchEvent({
      type: "columnStateUpdated",
      key: e
    });
  }
};
function $(e) {
  return e instanceof uo;
}
var uo = class extends b {
  constructor(e, t, o, i) {
    super(), this.colGroupDef = e, this.groupId = t, this.padding = o, this.level = i, this.isColumn = !1, this.expandable = !1, this.instanceId = ir(), this.expandableListenerRemoveCallback = null, this.expanded = !!e?.openByDefault;
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0), super.destroy();
  }
  reset(e, t) {
    this.colGroupDef = e, this.level = t, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return this.children ? this.children.some((e) => e.isVisible()) : !1;
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(e) {
    this.expanded = e === void 0 ? !1 : e, this.dispatchLocalEvent({ type: "expandedChanged" });
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(e) {
    this.children = e;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  forEachLeafColumn(e) {
    if (this.children)
      for (const t of this.children)
        Ke(t) ? e(t) : $(t) && t.forEachLeafColumn(e);
  }
  addLeafColumns(e) {
    if (this.children)
      for (const t of this.children)
        Ke(t) ? e.push(t) : $(t) && t.addLeafColumns(e);
  }
  getColumnGroupShow() {
    const e = this.colGroupDef;
    if (e)
      return e.columnGroupShow;
  }
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const e = this.onColumnVisibilityChanged.bind(this);
    for (const t of this.getLeafColumns())
      t.__addEventListener("visibleChanged", e);
    this.expandableListenerRemoveCallback = () => {
      for (const t of this.getLeafColumns())
        t.__removeEventListener("visibleChanged", e);
      this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let e = !1, t = !1, o = !1;
    const i = this.findChildrenRemovingPadding();
    for (let n = 0, r = i.length; n < r; n++) {
      const l = i[n];
      if (!l.isVisible())
        continue;
      const a = l.getColumnGroupShow();
      a === "open" ? (e = !0, o = !0) : a === "closed" ? (t = !0, o = !0) : (e = !0, t = !0);
    }
    const s = e && t && o;
    this.expandable !== s && (this.expandable = s, this.dispatchLocalEvent({ type: "expandableChanged" }));
  }
  findChildrenRemovingPadding() {
    const e = [], t = (o) => {
      for (const i of o)
        $(i) && i.isPadding() ? t(i.children) : e.push(i);
    };
    return t(this.children), e;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
}, sd = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
};
function Gs(e, t, o) {
  const i = {}, s = e.gos;
  return Object.assign(i, s.get("defaultColGroupDef")), Object.assign(i, t), s.validateColDef(i, o), i;
}
var nd = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = wi(e);
    let o = 0;
    for (; ; ) {
      let i = e ?? t;
      if (i ? o !== 0 && (i += "_" + o) : i = o, !this.existingKeys[i]) {
        const s = String(i);
        return e && o > 0 && F(273, { providedId: e, usedId: s }), this.existingKeys[s] = !0, s;
      }
      o++;
    }
  }
};
function G(e) {
  if (e?.length)
    return e[e.length - 1];
}
function St(e, t, o) {
  if (e === t)
    return !0;
  if (!e || !t)
    return e == null && t == null;
  const i = e.length;
  if (i !== t.length)
    return !1;
  for (let s = 0; s < i; s++)
    if (e[s] !== t[s] && !o?.(e[s], t[s]))
      return !1;
  return !0;
}
function yt(e, t) {
  if (e)
    for (const o of e)
      t(o);
}
function Pe(e, t) {
  const o = e.indexOf(t);
  o >= 0 && e.splice(o, 1);
}
function Hs(e, t, o) {
  for (let i = 0; i < t.length; i++)
    Pe(e, t[i]);
  for (let i = t.length - 1; i >= 0; i--)
    e.splice(o, 0, t[i]);
}
var Vo = "ag-Grid-AutoColumn", sr = "ag-Grid-SelectionColumn", nr = "ag-Grid-RowNumbersColumn";
function rr(e) {
  const t = [], o = (i) => {
    for (let s = 0; s < i.length; s++) {
      const n = i[s];
      Ke(n) ? t.push(n) : $(n) && o(n.getChildren());
    }
  };
  return o(e), t;
}
function be(e) {
  return e.reduce((t, o) => t + o.getActualWidth(), 0);
}
function Fo(e, t, o) {
  const i = {};
  if (!t)
    return;
  Re(null, t, (n) => {
    i[n.getInstanceId()] = n;
  }), o && Re(null, o, (n) => {
    i[n.getInstanceId()] = null;
  });
  const s = Object.values(i).filter((n) => n != null);
  e.context.destroyBeans(s);
}
function lr(e) {
  return e.getId().startsWith(Vo);
}
function He(e) {
  return (typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId)?.startsWith(sr) ?? !1;
}
function Te(e) {
  return (typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId)?.startsWith(nr) ?? !1;
}
function rd(e) {
  return He(e) || Te(e);
}
function Eo(e) {
  let t = [];
  return e instanceof Array ? t = e : typeof e == "string" && (t = e.split(",")), t;
}
function ld(e, t) {
  return St(e, t, (o, i) => o.getColId() === i.getColId());
}
function ad(e) {
  e.map = {};
  for (const t of e.list)
    e.map[t.getId()] = t;
}
function lt(e) {
  return e === "optionsUpdated" ? "gridOptionsChanged" : e;
}
function It(e, t) {
  const o = e === t, i = e.getColDef() === t, s = e.getColId() == t;
  return o || i || s;
}
var dd = (e, t) => (o, i) => {
  const s = {
    value1: void 0,
    value2: void 0
  };
  let n = !1;
  return e && (e[o] !== void 0 && (s.value1 = e[o], n = !0), A(i) && e[i] !== void 0 && (s.value2 = e[i], n = !0)), !n && t && (t[o] !== void 0 && (s.value1 = t[o]), A(i) && t[i] !== void 0 && (s.value2 = t[i])), s;
}, cd = (e, t) => {
  $(e) && e.setupExpandable(), e.originalParent = t;
};
function ud(e, t = null, o, i, s) {
  const n = new nd(), { existingCols: r, existingGroups: l, existingColKeys: a } = hd(i);
  n.addExistingKeys(a);
  const d = ar(
    e,
    t,
    0,
    o,
    r,
    n,
    l,
    s
  ), { colGroupSvc: c } = e, u = c?.findMaxDepth(d, 0) ?? 0, h = c ? c.balanceColumnTree(d, 0, u, n) : d;
  return Re(null, h, cd), {
    columnTree: h,
    treeDepth: u
  };
}
function hd(e) {
  const t = [], o = [], i = [];
  return e && Re(null, e, (s) => {
    if ($(s)) {
      const n = s;
      o.push(n);
    } else {
      const n = s;
      i.push(n.getId()), t.push(n);
    }
  }), { existingCols: t, existingGroups: o, existingColKeys: i };
}
function ar(e, t, o, i, s, n, r, l) {
  if (!t)
    return [];
  const { colGroupSvc: a } = e, d = new Array(t.length);
  for (let c = 0; c < d.length; c++) {
    const u = t[c];
    a && vd(u) ? d[c] = a.createProvidedColumnGroup(
      i,
      u,
      o,
      s,
      n,
      r,
      l
    ) : d[c] = gd(e, i, u, s, n, l);
  }
  return d;
}
function gd(e, t, o, i, s, n) {
  const r = fd(o, i);
  r && i?.splice(r.idx, 1);
  let l = r?.column;
  if (l) {
    const a = Mi(e, o, l.getColId());
    l.setColDef(a, o, n), pd(e, l, a, n);
  } else {
    const a = s.getUniqueKey(o.colId, o.field), d = Mi(e, o, a);
    l = new je(d, o, a, t), e.context.createBean(l);
  }
  return e.dataTypeSvc?.addColumnListeners(l), l;
}
function dr(e, t, o, i, s, n, r, l) {
  const { sortSvc: a, pinnedCols: d, colFlex: c } = e;
  o !== void 0 && t.setVisible(!o, l), a && (a.updateColSort(t, i, l), s !== void 0 && a.setColSortIndex(t, s)), n !== void 0 && d?.setColPinned(t, n), r !== void 0 && c?.setColFlex(t, r);
}
function pd(e, t, o, i) {
  dr(
    e,
    t,
    o.hide,
    o.sort,
    o.sortIndex,
    o.pinned,
    o.flex,
    i
  );
  const s = t.getFlex();
  if (!(s != null && s > 0))
    if (o.width != null)
      t.setActualWidth(o.width, i);
    else {
      const n = t.getActualWidth();
      t.setActualWidth(n, i);
    }
}
function fd(e, t) {
  if (t)
    for (let o = 0; o < t.length; o++) {
      const i = t[o].getUserProvidedColDef();
      if (!i)
        continue;
      if (e.colId != null) {
        if (t[o].getId() === e.colId)
          return { idx: o, column: t[o] };
        continue;
      }
      if (e.field != null) {
        if (i.field === e.field)
          return { idx: o, column: t[o] };
        continue;
      }
      if (i === e)
        return { idx: o, column: t[o] };
    }
}
function Mi(e, t, o, i) {
  const { gos: s, dataTypeSvc: n } = e, r = {}, l = s.get("defaultColDef");
  ee(r, l, !1, !0);
  const a = Cd(e, r, t, o);
  a && md(e, a, r);
  const d = r.cellDataType;
  ee(r, t, !1, !0), d !== void 0 && (r.cellDataType = d);
  const c = s.get("autoGroupColumnDef"), u = pe(s);
  return t.rowGroup && c && u && ee(
    r,
    { sort: c.sort, initialSort: c.initialSort },
    !1,
    !0
  ), n && (n.postProcess(r), n.validateColDef(r)), s.validateColDef(r, o, i), r;
}
function Cd(e, t, o, i) {
  const s = e.dataTypeSvc?.updateColDefAndGetColumnType(t, o, i), n = o.type ?? s ?? t.type;
  return t.type = n, n ? Eo(n) : void 0;
}
function md(e, t, o) {
  if (!t.length)
    return;
  const i = Object.assign({}, sd), s = e.gos.get("columnTypes") || {};
  for (const n of Object.keys(s)) {
    const r = s[n];
    n in i ? F(34, { key: n }) : (r.type && F(35), i[n] = r);
  }
  for (const n of t) {
    const r = i[n.trim()];
    r ? ee(o, r, !1, !0) : F(36, { t: n });
  }
}
function vd(e) {
  return e.children !== void 0;
}
function Re(e, t, o) {
  if (t)
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      $(s) && Re(s, s.getChildren(), o), o(s, e);
    }
}
function cr(e, t) {
  const o = [], i = [], s = [];
  return e.forEach((r) => {
    const l = r.getColDef().lockPosition;
    l === "right" ? s.push(r) : l === "left" || l === !0 ? o.push(r) : i.push(r);
  }), t.get("enableRtl") ? [...s, ...i, ...o] : [...o, ...i, ...s];
}
function ur(e, t) {
  let o = !0;
  return Re(null, t, (i) => {
    if (!$(i))
      return;
    const s = i;
    if (!s.getColGroupDef()?.marryChildren)
      return;
    const l = [];
    for (const h of s.getLeafColumns()) {
      const g = e.indexOf(h);
      l.push(g);
    }
    const a = Math.max.apply(Math, l), d = Math.min.apply(Math, l), c = a - d, u = s.getLeafColumns().length - 1;
    c > u && (o = !1);
  }), o;
}
function hr(e, t) {
  if (!e || e.length == 0)
    return;
  const o = t(e[0]);
  for (let i = 1; i < e.length; i++)
    if (o !== t(e[i]))
      return;
  return o;
}
function gr(e, t, o) {
  if (!t.length)
    return;
  const i = t.length === 1 ? t[0] : null, s = hr(t, (n) => n.getPinned());
  e.dispatchEvent({
    type: "columnPinned",
    // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
    pinned: s ?? null,
    columns: t,
    column: i,
    source: o
  });
}
function wd(e, t, o) {
  if (!t.length)
    return;
  const i = t.length === 1 ? t[0] : null, s = hr(t, (n) => n.isVisible());
  e.dispatchEvent({
    type: "columnVisible",
    visible: s,
    columns: t,
    column: i,
    source: o
  });
}
function Sd(e, t, o, i) {
  e.dispatchEvent({
    type: t,
    columns: o,
    column: o && o.length == 1 ? o[0] : null,
    source: i
  });
}
function gt(e, t, o, i, s = null) {
  t?.length && e.dispatchEvent({
    type: "columnResized",
    columns: t,
    column: t.length === 1 ? t[0] : null,
    flexColumns: s,
    finished: o,
    source: i
  });
}
function pt(e, t, o) {
  const {
    colModel: i,
    rowGroupColsSvc: s,
    pivotColsSvc: n,
    autoColSvc: r,
    selectionColSvc: l,
    colAnimation: a,
    visibleCols: d,
    pivotResultCols: c,
    environment: u,
    valueColsSvc: h,
    eventSvc: g,
    gos: p
  } = e, f = i.getColDefCols() ?? [], C = l?.getColumns();
  if (!f.length && !C?.length)
    return !1;
  if (t?.state && !t.state.forEach)
    return F(32), !1;
  const m = (y, R, x, k, I) => {
    if (!y)
      return;
    const T = dd(R, t.defaultState), _ = T("flex").value1;
    if (dr(
      e,
      y,
      T("hide").value1,
      T("sort").value1,
      T("sortIndex").value1,
      T("pinned").value1,
      _,
      o
    ), _ == null) {
      const ve = T("width").value1;
      if (ve != null) {
        const le = y.getColDef().minWidth ?? u.getDefaultColumnMinWidth();
        le != null && ve >= le && y.setActualWidth(ve, o);
      }
    }
    I || !y.isPrimary() || (h?.syncColumnWithState(y, o, T), s?.syncColumnWithState(y, o, T, x), n?.syncColumnWithState(y, o, T, k));
  }, v = (y, R, x) => {
    const k = pr(e, o), I = R.slice(), T = {}, _ = {}, ve = [], le = [], ue = [];
    let Q = 0;
    const Vl = s?.columns.slice() ?? [], Wl = n?.columns.slice() ?? [];
    for (const Z of y) {
      const bt = Z.colId;
      if (bt.startsWith(Vo)) {
        ve.push(Z), ue.push(Z);
        continue;
      }
      if (He(bt)) {
        le.push(Z), ue.push(Z);
        continue;
      }
      const qe = x(bt);
      qe ? (m(qe, Z, T, _, !1), Pe(I, qe)) : (ue.push(Z), Q += 1);
    }
    const Rs = (Z) => m(Z, null, T, _, !1);
    I.forEach(Rs), s?.sortColumns(Os.bind(s, T, Vl)), n?.sortColumns(Os.bind(n, _, Wl)), i.refreshCols(!1, o);
    const xs = (Z, bt, Uo = []) => {
      for (const qe of bt) {
        const Ps = Z(qe.colId);
        Pe(Uo, Ps), m(Ps, qe, null, null, !0);
      }
      Uo.forEach(Rs);
    };
    return xs(
      (Z) => r?.getColumn(Z) ?? null,
      ve,
      r?.getColumns()?.slice()
    ), xs(
      (Z) => l?.getColumn(Z) ?? null,
      le,
      l?.getColumns()?.slice()
    ), yd(t, i, p), d.refresh(o), g.dispatchEvent({
      type: "columnEverythingChanged",
      source: o
    }), k(), { unmatchedAndAutoStates: ue, unmatchedCount: Q };
  };
  a?.start();
  let { unmatchedAndAutoStates: S, unmatchedCount: D } = v(
    t.state || [],
    f,
    (y) => i.getColDefCol(y)
  );
  if (S.length > 0 || A(t.defaultState)) {
    const y = c?.getPivotResultCols()?.list ?? [];
    D = v(
      S,
      y,
      (R) => c?.getPivotResultCol(R) ?? null
    ).unmatchedCount;
  }
  return a?.finish(), D === 0;
}
function bd(e, t) {
  const { colModel: o, autoColSvc: i, selectionColSvc: s, eventSvc: n, gos: r } = e, l = o.getColDefCols();
  if (!l?.length)
    return;
  const a = o.getColDefColTree(), d = rr(a), c = [];
  let u = 1e3, h = 1e3;
  const g = (v) => {
    const S = fr(v);
    H(S.rowGroupIndex) && S.rowGroup && (S.rowGroupIndex = u++), H(S.pivotIndex) && S.pivot && (S.pivotIndex = h++), c.push(S);
  };
  i?.getColumns()?.forEach(g), s?.getColumns()?.forEach(g), d?.forEach(g), pt(e, { state: c }, t);
  const p = i?.getColumns() ?? [], m = [...s?.getColumns() ?? [], ...p, ...l].map((v) => ({ colId: v.colId }));
  pt(e, { state: m, applyOrder: !0 }, t), n.dispatchEvent(L(r, { type: "columnsReset", source: t }));
}
function pr(e, t) {
  const { rowGroupColsSvc: o, pivotColsSvc: i, valueColsSvc: s, colModel: n, sortSvc: r, eventSvc: l } = e, a = {
    rowGroupColumns: o?.columns.slice() ?? [],
    pivotColumns: i?.columns.slice() ?? [],
    valueColumns: s?.columns.slice() ?? []
  }, d = Ti(e), c = {};
  for (const u of d)
    c[u.colId] = u;
  return () => {
    const u = (R, x, k, I) => {
      const T = x.map(I), _ = k.map(I);
      if (St(T, _))
        return;
      const le = new Set(x);
      for (const Q of k)
        le.delete(Q) || le.add(Q);
      const ue = [...le];
      l.dispatchEvent({
        type: R,
        columns: ue,
        column: ue.length === 1 ? ue[0] : null,
        source: t
      });
    }, h = (R) => {
      const x = [];
      return n.forAllCols((k) => {
        const I = c[k.getColId()];
        I && R(I, k) && x.push(k);
      }), x;
    }, g = (R) => R.getColId();
    u(
      "columnRowGroupChanged",
      a.rowGroupColumns,
      o?.columns ?? [],
      g
    ), u(
      "columnPivotChanged",
      a.pivotColumns,
      i?.columns ?? [],
      g
    );
    const f = h((R, x) => {
      const k = R.aggFunc != null, I = k != x.isValueActive(), T = k && R.aggFunc != x.getAggFunc();
      return I || T;
    });
    f.length > 0 && Sd(l, "columnValueChanged", f, t), gt(l, h((R, x) => R.width != x.getActualWidth()), !0, t), gr(l, h((R, x) => R.pinned != x.getPinned()), t), wd(l, h((R, x) => R.hide == x.isVisible()), t);
    const D = h((R, x) => R.sort != x.getSort() || R.sortIndex != x.getSortIndex());
    D.length > 0 && r?.dispatchSortChangedEvents(t, D);
    const y = Ti(e);
    xd(d, y, t, n, l);
  };
}
function Ti(e) {
  const { colModel: t, rowGroupColsSvc: o, pivotColsSvc: i } = e, s = t.getColDefCols();
  if (H(s) || !t.isAlive())
    return [];
  const n = o?.columns, r = i?.columns, l = [], a = (c) => {
    const u = c.isRowGroupActive() && n ? n.indexOf(c) : null, h = c.isPivotActive() && r ? r.indexOf(c) : null, g = c.isValueActive() ? c.getAggFunc() : null, p = c.getSort() != null ? c.getSort() : null, f = c.getSortIndex() != null ? c.getSortIndex() : null;
    l.push({
      colId: c.getColId(),
      width: c.getActualWidth(),
      hide: !c.isVisible(),
      pinned: c.getPinned(),
      sort: p,
      sortIndex: f,
      aggFunc: g,
      rowGroup: c.isRowGroupActive(),
      rowGroupIndex: u,
      pivot: c.isPivotActive(),
      pivotIndex: h,
      flex: c.getFlex() ?? null
    });
  };
  t.forAllCols((c) => a(c));
  const d = new Map(
    t.getCols().map((c, u) => [c.getColId(), u])
  );
  return l.sort((c, u) => {
    const h = d.has(c.colId) ? d.get(c.colId) : -1, g = d.has(u.colId) ? d.get(u.colId) : -1;
    return h - g;
  }), l;
}
function fr(e) {
  const t = (p, f) => p ?? f ?? null, o = e.getColDef(), i = t(o.sort, o.initialSort), s = t(o.sortIndex, o.initialSortIndex), n = t(o.hide, o.initialHide), r = t(o.pinned, o.initialPinned), l = t(o.width, o.initialWidth), a = t(o.flex, o.initialFlex);
  let d = t(o.rowGroupIndex, o.initialRowGroupIndex), c = t(o.rowGroup, o.initialRowGroup);
  d == null && !c && (d = null, c = null);
  let u = t(o.pivotIndex, o.initialPivotIndex), h = t(o.pivot, o.initialPivot);
  u == null && !h && (u = null, h = null);
  const g = t(o.aggFunc, o.initialAggFunc);
  return {
    colId: e.getColId(),
    sort: i,
    sortIndex: s,
    hide: n,
    pinned: r,
    width: l,
    flex: a,
    rowGroup: c,
    rowGroupIndex: d,
    pivot: h,
    pivotIndex: u,
    aggFunc: g
  };
}
function yd(e, t, o) {
  if (!e.applyOrder || !e.state)
    return;
  const i = [];
  for (const s of e.state)
    s.colId != null && i.push(s.colId);
  Rd(t.cols, i, t, o);
}
function Rd(e, t, o, i) {
  if (e == null)
    return;
  let s = [];
  const n = {};
  for (const l of t) {
    if (n[l])
      continue;
    const a = e.map[l];
    a && (s.push(a), n[l] = !0);
  }
  let r = 0;
  for (const l of e.list) {
    const a = l.getColId();
    if (n[a] != null)
      continue;
    a.startsWith(Vo) ? s.splice(r++, 0, l) : s.push(l);
  }
  if (s = cr(s, i), !ur(s, o.getColTree())) {
    F(39);
    return;
  }
  e.list = s;
}
function xd(e, t, o, i, s) {
  const n = {};
  for (const c of t)
    n[c.colId] = c;
  const r = {};
  for (const c of e)
    n[c.colId] && (r[c.colId] = !0);
  const l = e.filter((c) => r[c.colId]), a = t.filter((c) => r[c.colId]), d = [];
  a.forEach((c, u) => {
    const h = l?.[u];
    if (h && h.colId !== c.colId) {
      const g = i.getCol(h.colId);
      g && d.push(g);
    }
  }), d.length && s.dispatchEvent({
    type: "columnMoved",
    columns: d,
    column: d.length === 1 ? d[0] : null,
    finished: !0,
    source: o
  });
}
var Os = (e, t, o, i) => {
  const s = e[o.getId()], n = e[i.getId()], r = s != null, l = n != null;
  if (r && l)
    return s - n;
  if (r)
    return -1;
  if (l)
    return 1;
  const a = t.indexOf(o), d = t.indexOf(i), c = a >= 0, u = d >= 0;
  return c && u ? a - d : c ? -1 : 1;
}, Pd = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colModel", this.pivotMode = !1, this.ready = !1, this.changeEventsDispatching = !1;
  }
  postConstruct() {
    this.pivotMode = this.gos.get("pivotMode"), this.addManagedPropertyListeners(
      [
        "groupDisplayType",
        "treeData",
        "treeDataDisplayType",
        "groupHideOpenParents",
        "rowNumbers",
        "hidePaddedHeaderRows"
      ],
      (e) => this.refreshAll(lt(e.source))
    ), this.addManagedPropertyListeners(
      ["defaultColDef", "defaultColGroupDef", "columnTypes", "suppressFieldDotNotation"],
      this.recreateColumnDefs.bind(this)
    ), this.addManagedPropertyListener(
      "pivotMode",
      (e) => this.setPivotMode(this.gos.get("pivotMode"), lt(e.source))
    );
  }
  // called from SyncService, when grid has finished initialising
  createColsFromColDefs(e) {
    const { beans: t } = this, {
      valueCache: o,
      colAutosize: i,
      rowGroupColsSvc: s,
      pivotColsSvc: n,
      valueColsSvc: r,
      visibleCols: l,
      eventSvc: a,
      groupHierarchyColSvc: d
    } = t, c = this.colDefs ? pr(t, e) : void 0;
    o?.expire();
    const u = this.colDefCols?.list, h = this.colDefCols?.tree, g = ud(t, this.colDefs, !0, h, e);
    Fo(t, this.colDefCols?.tree, g.columnTree);
    const p = g.columnTree, f = g.treeDepth, C = rr(p), m = {};
    for (const v of C)
      m[v.getId()] = v;
    this.colDefCols = { tree: p, treeDepth: f, list: C, map: m }, this.createColumnsForService([d], this.colDefCols, e), s?.extractCols(e, u), n?.extractCols(e, u), r?.extractCols(e, u), this.ready = !0, this.refreshCols(!0, e), l.refresh(e), a.dispatchEvent({
      type: "columnEverythingChanged",
      source: e
    }), c && (this.changeEventsDispatching = !0, c(), this.changeEventsDispatching = !1), a.dispatchEvent({
      type: "newColumnsLoaded",
      source: e
    }), e === "gridInitializing" && i?.applyAutosizeStrategy();
  }
  // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
  // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
  // setPivotMode, applyColumnState,
  // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
  // pivotResultCols.setPivotResultCols
  refreshCols(e, t) {
    if (!this.colDefCols)
      return;
    const o = this.cols?.tree;
    this.saveColOrder();
    const {
      autoColSvc: i,
      selectionColSvc: s,
      rowNumbersSvc: n,
      quickFilter: r,
      pivotResultCols: l,
      showRowGroupCols: a,
      rowAutoHeight: d,
      visibleCols: c,
      colViewport: u,
      eventSvc: h
    } = this.beans, g = this.selectCols(l, this.colDefCols);
    this.createColumnsForService([i, s, n], g, t);
    const p = ja(this.gos, this.showingPivotResult);
    (!e || p) && this.restoreColOrder(g), this.positionLockedCols(g), a?.refresh(), r?.refreshCols(), this.setColSpanActive(), d?.setAutoHeightActive(g), c.clear(), u.clear(), !St(o, this.cols.tree) && h.dispatchEvent({
      type: "gridColumnsChanged"
    });
  }
  createColumnsForService(e, t, o) {
    for (const i of e)
      i && (i.createColumns(
        t,
        (s) => {
          this.lastOrder = s(this.lastOrder), this.lastPivotOrder = s(this.lastPivotOrder);
        },
        o
      ), i.addColumns(t));
  }
  selectCols(e, t) {
    const o = e?.getPivotResultCols() ?? null;
    this.showingPivotResult = o != null;
    const { map: i, list: s, tree: n, treeDepth: r } = o ?? t;
    return this.cols = {
      list: s.slice(),
      map: { ...i },
      tree: n.slice(),
      treeDepth: r
    }, o && (o.list.some((a) => this.cols?.map[a.getColId()] !== void 0) || (this.lastPivotOrder = null)), this.cols;
  }
  getColsToShow() {
    if (!this.cols)
      return [];
    const { valueColsSvc: e, selectionColSvc: t, gos: o } = this.beans, i = this.isPivotMode() && !this.showingPivotResult, s = t?.isSelectionColumnEnabled(), n = o.get("rowNumbers"), r = e?.columns;
    return this.cols.list.filter((a) => {
      const d = lr(a);
      if (i) {
        const c = r?.includes(a);
        return d || c || s && He(a) || n && Te(a);
      } else
        return d || a.isVisible();
    });
  }
  // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
  refreshAll(e) {
    this.ready && (this.refreshCols(!1, e), this.beans.visibleCols.refresh(e));
  }
  setColsVisible(e, t = !1, o) {
    pt(
      this.beans,
      {
        state: e.map((i) => ({
          colId: typeof i == "string" ? i : i.getColId(),
          hide: !t
        }))
      },
      o
    );
  }
  /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */
  restoreColOrder(e) {
    const t = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
    if (!t)
      return;
    const o = t.filter((u) => e.map[u.getId()] != null);
    if (o.length === 0)
      return;
    if (o.length === e.list.length) {
      e.list = o;
      return;
    }
    const i = (u) => {
      const h = u.getOriginalParent();
      return h ? h.getChildren().length > 1 ? !0 : i(h) : !1;
    };
    if (!o.some((u) => i(u))) {
      const u = new Set(o);
      for (const h of e.list)
        u.has(h) || o.push(h);
      e.list = o;
      return;
    }
    const s = /* @__PURE__ */ new Map();
    for (let u = 0; u < o.length; u++) {
      const h = o[u];
      s.set(h, u);
    }
    const n = e.list.filter((u) => !s.has(u));
    if (n.length === 0) {
      e.list = o;
      return;
    }
    const r = (u, h) => {
      const g = h ? h.getOriginalParent() : u.getOriginalParent();
      if (!g)
        return null;
      let p = null, f = null;
      for (const C of g.getChildren())
        if (!(C === h || C === u)) {
          if (C instanceof je) {
            const m = s.get(C);
            if (m == null)
              continue;
            (p == null || p < m) && (p = m, f = C);
            continue;
          }
          C.forEachLeafColumn((m) => {
            const v = s.get(m);
            v != null && (p == null || p < v) && (p = v, f = m);
          });
        }
      return f ?? r(u, g);
    }, l = [], a = /* @__PURE__ */ new Map();
    for (const u of n) {
      const h = r(u, null);
      if (h == null) {
        l.push(u);
        continue;
      }
      const g = a.get(h);
      g === void 0 ? a.set(h, u) : Array.isArray(g) ? g.push(u) : a.set(h, [g, u]);
    }
    const d = new Array(e.list.length);
    let c = d.length - 1;
    for (let u = l.length - 1; u >= 0; u--)
      d[c--] = l[u];
    for (let u = o.length - 1; u >= 0; u--) {
      const h = o[u], g = a.get(h);
      if (g)
        if (Array.isArray(g))
          for (let p = g.length - 1; p >= 0; p--) {
            const f = g[p];
            d[c--] = f;
          }
        else
          d[c--] = g;
      d[c--] = h;
    }
    e.list = d;
  }
  positionLockedCols(e) {
    e.list = cr(e.list, this.gos);
  }
  saveColOrder() {
    this.showingPivotResult ? this.lastPivotOrder = this.cols?.list ?? null : this.lastOrder = this.cols?.list ?? null;
  }
  getColumnDefs(e) {
    return this.colDefCols && this.beans.colDefFactory?.getColumnDefs(
      this.colDefCols.list,
      this.showingPivotResult,
      this.lastOrder,
      this.cols?.list ?? [],
      e
    );
  }
  setColSpanActive() {
    this.colSpanActive = !!this.cols?.list.some((e) => e.getColDef().colSpan != null);
  }
  isPivotMode() {
    return this.pivotMode;
  }
  setPivotMode(e, t) {
    if (e === this.pivotMode || (this.pivotMode = e, !this.ready))
      return;
    this.refreshCols(!1, t);
    const { visibleCols: o, eventSvc: i } = this.beans;
    o.refresh(t), i.dispatchEvent({
      type: "columnPivotModeChanged"
    });
  }
  // + clientSideRowModel
  isPivotActive() {
    const e = this.beans.pivotColsSvc?.columns;
    return this.pivotMode && !!e?.length;
  }
  // called when dataTypes change
  recreateColumnDefs(e) {
    if (!this.cols)
      return;
    this.beans.autoColSvc?.updateColumns(e);
    const t = lt(e.source);
    this.createColsFromColDefs(t);
  }
  setColumnDefs(e, t) {
    this.colDefs = e, this.createColsFromColDefs(t);
  }
  destroy() {
    Fo(this.beans, this.colDefCols?.tree), super.destroy();
  }
  getColTree() {
    return this.cols?.tree ?? [];
  }
  // + columnSelectPanel
  getColDefColTree() {
    return this.colDefCols?.tree ?? [];
  }
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  getColDefCols() {
    return this.colDefCols?.list ?? null;
  }
  // + moveColumnController
  getCols() {
    return this.cols?.list ?? [];
  }
  forAllCols(e) {
    const { pivotResultCols: t, autoColSvc: o, selectionColSvc: i, groupHierarchyColSvc: s } = this.beans;
    yt(this.colDefCols?.list, e), yt(o?.columns?.list, e), yt(i?.columns?.list, e), yt(s?.columns?.list, e), yt(t?.getPivotResultCols()?.list, e);
  }
  getColsForKeys(e) {
    return e ? e.map((t) => this.getCol(t)).filter((t) => t != null) : [];
  }
  getColDefCol(e) {
    return this.colDefCols?.list ? this.getColFromCollection(e, this.colDefCols) : null;
  }
  getCol(e) {
    return e == null ? null : this.getColFromCollection(e, this.cols);
  }
  /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */
  getColById(e) {
    return this.cols?.map[e] ?? null;
  }
  getColFromCollection(e, t) {
    if (t == null)
      return null;
    const { map: o, list: i } = t;
    if (typeof e == "string" && o[e])
      return o[e];
    for (let l = 0; l < i.length; l++)
      if (It(i[l], e))
        return i[l];
    const { autoColSvc: s, selectionColSvc: n, groupHierarchyColSvc: r } = this.beans;
    return s?.getColumn(e) ?? n?.getColumn(e) ?? r?.getColumn(e) ?? null;
  }
}, Dd = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let o;
    return typeof t != "number" ? o = 0 : o = t + 1, this.existingIds[e] = o, o;
  }
};
function Wo(e, t, o) {
  return o && e.addDestroyFunc(() => t.destroyBean(o)), o ?? e;
}
var P = null, Cr = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  toggleCss(e, t) {
    if (!e)
      return;
    if (e.indexOf(" ") >= 0) {
      const i = (e || "").split(" ");
      if (i.length > 1) {
        for (const s of i)
          this.toggleCss(s, t);
        return;
      }
    }
    this.cssClassStates[e] !== t && e.length && (this.getGui()?.classList.toggle(e, t), this.cssClassStates[e] = t);
  }
}, Fd = 0, No = class extends Ge {
  constructor(e, t) {
    super(), this.suppressDataRefValidation = !1, this.displayed = !0, this.visible = !0, this.compId = Fd++, this.cssManager = new Cr(() => this.eGui), this.componentSelectors = new Map((t ?? []).map((o) => [o.selector, o])), e && this.setTemplate(e);
  }
  preConstruct() {
    this.wireTemplate(this.getGui());
    const e = "component-" + Object.getPrototypeOf(this)?.constructor?.name;
    for (const t of this.css ?? [])
      this.beans.environment.addGlobalCSS(t, e);
  }
  wireTemplate(e, t) {
    e && this.gos && (this.applyElementsToComponent(e), this.createChildComponentsFromTags(e, t));
  }
  getCompId() {
    return this.compId;
  }
  getDataRefAttribute(e) {
    return e.getAttribute ? e.getAttribute(On) : null;
  }
  applyElementsToComponent(e, t, o, i = null) {
    if (t === void 0 && (t = this.getDataRefAttribute(e)), t) {
      const s = this[t];
      if (s === P)
        this[t] = i ?? e;
      else {
        const n = o?.[t];
        if (!this.suppressDataRefValidation && !n)
          throw new Error(`data-ref: ${t} on ${this.constructor.name} with ${s}`);
      }
    }
  }
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  createChildComponentsFromTags(e, t) {
    const o = [];
    for (const i of e.childNodes ?? [])
      o.push(i);
    for (const i of o) {
      if (!(i instanceof HTMLElement))
        continue;
      const s = this.createComponentFromElement(
        i,
        (n) => {
          const r = n.getGui();
          if (r)
            for (const l of i.attributes ?? [])
              r.setAttribute(l.name, l.value);
        },
        t
      );
      if (s) {
        if (s.addItems && i.children.length) {
          this.createChildComponentsFromTags(i, t);
          const n = Array.prototype.slice.call(i.children);
          s.addItems(n);
        }
        this.swapComponentForNode(s, e, i);
      } else i.childNodes && this.createChildComponentsFromTags(i, t);
    }
  }
  createComponentFromElement(e, t, o) {
    const i = e.nodeName, s = this.getDataRefAttribute(e), n = i.indexOf("AG-") === 0, r = n ? this.componentSelectors.get(i) : null;
    let l = null;
    if (r) {
      const a = o && s ? o[s] : void 0;
      l = new r.component(a), l.setParentComponent(
        this
      ), this.createBean(l, null, t);
    } else if (n)
      throw new Error(`selector: ${i}`);
    return this.applyElementsToComponent(e, s, o, l), l;
  }
  swapComponentForNode(e, t, o) {
    const i = e.getGui();
    t.replaceChild(i, o), t.insertBefore(document.createComment(o.nodeName), i), this.addDestroyFunc(this.destroyBean.bind(this, e));
  }
  activateTabIndex(e) {
    const t = this.gos.get("tabIndex");
    e || (e = []), e.length || e.push(this.getGui());
    for (const o of e)
      o.setAttribute("tabindex", t.toString());
  }
  setTemplate(e, t, o) {
    let i;
    typeof e == "string" || e == null ? i = Zi(e) : i = jt(e), this.setTemplateFromElement(i, t, o);
  }
  setTemplateFromElement(e, t, o, i = !1) {
    if (this.eGui = e, this.suppressDataRefValidation = i, t)
      for (let s = 0; s < t.length; s++) {
        const n = t[s];
        this.componentSelectors.set(n.selector, n);
      }
    this.wireTemplate(e, o);
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  setGui(e) {
    this.eGui = e;
  }
  queryForHtmlElement(e) {
    return this.eGui.querySelector(e);
  }
  getContainerAndElement(e, t) {
    let o = t;
    return e == null ? null : (o || (o = this.eGui), Ji(e) ? {
      element: e,
      parent: o
    } : {
      element: e.getGui(),
      parent: o
    });
  }
  prependChild(e, t) {
    const { element: o, parent: i } = this.getContainerAndElement(e, t) || {};
    !o || !i || i.insertAdjacentElement("afterbegin", o);
  }
  appendChild(e, t) {
    const { element: o, parent: i } = this.getContainerAndElement(e, t) || {};
    !o || !i || i.appendChild(o);
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(e, t = {}) {
    if (e !== this.visible) {
      this.visible = e;
      const { skipAriaHidden: o } = t;
      da(this.eGui, e, { skipAriaHidden: o });
    }
  }
  setDisplayed(e, t = {}) {
    if (e !== this.displayed) {
      this.displayed = e;
      const { skipAriaHidden: o } = t;
      V(this.eGui, e, { skipAriaHidden: o });
      const i = {
        type: "displayChanged",
        visible: this.displayed
      };
      this.dispatchLocalEvent(i);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), super.destroy();
  }
  addGuiEventListener(e, t, o) {
    this.eGui.addEventListener(e, t, o), this.addDestroyFunc(() => this.eGui.removeEventListener(e, t));
  }
  addCss(e) {
    this.cssManager.toggleCss(e, !0);
  }
  removeCss(e) {
    this.cssManager.toggleCss(e, !1);
  }
  toggleCss(e, t) {
    this.cssManager.toggleCss(e, t);
  }
  registerCSS(e) {
    this.css || (this.css = []), this.css.push(e);
  }
}, O = class extends No {
};
function Ed(e, t) {
  return new _t((o) => {
    o(window.setInterval(e, t));
  });
}
var _t = class Ft {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t(
      (o) => this.onDone(o),
      (o) => this.onReject(o)
    );
  }
  static all(t) {
    return t.length ? new Ft((o) => {
      let i = t.length;
      const s = new Array(i);
      t.forEach((n, r) => {
        n.then((l) => {
          s[r] = l, i--, i === 0 && o(s);
        });
      });
    }) : Ft.resolve();
  }
  static resolve(t = null) {
    return new Ft((o) => o(t));
  }
  then(t) {
    return new Ft((o) => {
      this.status === 1 ? o(t(this.resolution)) : this.waiters.push((i) => o(t(i)));
    });
  }
  onDone(t) {
    this.status = 1, this.resolution = t;
    for (const o of this.waiters)
      o(t);
  }
  onReject(t) {
  }
};
function Ad(e) {
  return e ? e.prototype && "getGui" in e.prototype : !1;
}
function Md(e, t, o, i) {
  const { name: s } = o;
  let n, r, l, a, d, c;
  if (t) {
    const u = t, h = u[s + "Selector"], g = h ? h(i) : null, p = (f) => {
      typeof f == "string" ? n = f : f != null && f !== !0 && (e.isFrameworkComponent(f) ? l = f : r = f);
    };
    g ? (p(g.component), a = g.params, d = g.popup, c = g.popupPosition) : p(u[s]);
  }
  return { compName: n, jsComp: r, fwComp: l, paramsFromSelector: a, popupFromSelector: d, popupPositionFromSelector: c };
}
var Td = class extends b {
  constructor() {
    super(...arguments), this.beanName = "userCompFactory";
  }
  wireBeans(e) {
    this.agCompUtils = e.agCompUtils, this.registry = e.registry, this.frameworkCompWrapper = e.frameworkCompWrapper, this.gridOptions = e.gridOptions;
  }
  getCompDetailsFromGridOptions(e, t, o, i = !1) {
    return this.getCompDetails(this.gridOptions, e, t, o, i);
  }
  getCompDetails(e, t, o, i, s = !1) {
    const { name: n, cellRenderer: r } = t;
    let { compName: l, jsComp: a, fwComp: d, paramsFromSelector: c, popupFromSelector: u, popupPositionFromSelector: h } = Md(this.beans.frameworkOverrides, e, t, i), g, p;
    const f = (S) => {
      const D = this.registry.getUserComponent(n, S);
      D && (a = D.componentFromFramework ? void 0 : D.component, d = D.componentFromFramework ? D.component : void 0, g = D.params, p = D.processParams);
    };
    if (l != null && f(l), a == null && d == null && o != null && f(o), a && r && !Ad(a) && (a = this.agCompUtils?.adaptFunction(t, a)), !a && !d) {
      const { validation: S } = this.beans;
      s && (l !== o || !o) ? l ? S?.isProvidedUserComp(l) || W(50, { compName: l }) : o ? S || W(260, {
        ...this.gos.getModuleErrorParams(),
        propName: n,
        compName: o
      }) : W(216, { name: n }) : o && !S && W(146, { comp: o });
      return;
    }
    const C = this.mergeParams(
      e,
      t,
      i,
      c,
      g,
      p
    ), m = a == null, v = a ?? d;
    return {
      componentFromFramework: m,
      componentClass: v,
      params: C,
      type: t,
      popupFromSelector: u,
      popupPositionFromSelector: h,
      newAgStackInstance: () => this.newAgStackInstance(v, m, C, t)
    };
  }
  newAgStackInstance(e, t, o, i) {
    const s = !t;
    let n;
    s ? n = new e() : n = this.frameworkCompWrapper.wrap(
      e,
      i.mandatoryMethods,
      i.optionalMethods,
      i
    ), this.createBean(n);
    const r = n.init?.(o);
    return r == null ? _t.resolve(n) : r.then(() => n);
  }
  /**
   * merges params with application provided params
   * used by Floating Filter
   */
  mergeParams(e, t, o, i = null, s, n) {
    const r = { ...o, ...s }, a = e?.[t.name + "Params"];
    if (typeof a == "function") {
      const d = a(o);
      ee(r, d);
    } else typeof a == "object" && ee(r, a);
    return ee(r, i), n ? n(r) : r;
  }
}, Id = {
  name: "dragAndDropImageComponent",
  mandatoryMethods: ["setIcon", "setLabel"]
}, kd = { name: "headerComponent", optionalMethods: ["refresh"] }, Ld = { name: "innerHeaderComponent" }, Gd = { name: "innerHeaderGroupComponent" }, Hd = { name: "headerGroupComponent" }, Od = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, Bd = { name: "loadingCellRenderer", cellRenderer: !0 }, Vd = { name: "loadingOverlayComponent", optionalMethods: ["refresh"] }, Wd = { name: "noRowsOverlayComponent", optionalMethods: ["refresh"] }, Nd = {
  name: "fullWidthCellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, zd = { name: "loadingCellRenderer", cellRenderer: !0 }, _d = {
  name: "groupRowRenderer",
  optionalMethods: ["afterGuiAttached"],
  cellRenderer: !0
}, Ud = { name: "detailCellRenderer", optionalMethods: ["refresh"], cellRenderer: !0 };
function $d(e, t) {
  return e.getCompDetailsFromGridOptions(Id, "agDragAndDropImage", t, !0);
}
function Kd(e, t, o) {
  return e.getCompDetails(t, kd, "agColumnHeader", o);
}
function jd(e, t, o) {
  return e.getCompDetails(t, Ld, void 0, o);
}
function qd(e, t) {
  const o = t.columnGroup.getColGroupDef();
  return e.getCompDetails(o, Hd, "agColumnGroupHeader", t);
}
function Yd(e, t, o) {
  return e.getCompDetails(t, Gd, void 0, o);
}
function Zd(e, t) {
  return e.getCompDetailsFromGridOptions(Nd, void 0, t, !0);
}
function Qd(e, t) {
  return e.getCompDetailsFromGridOptions(zd, "agLoadingCellRenderer", t, !0);
}
function Xd(e, t) {
  return e.getCompDetailsFromGridOptions(_d, "agGroupRowRenderer", t, !0);
}
function Jd(e, t) {
  return e.getCompDetailsFromGridOptions(Ud, "agDetailCellRenderer", t, !0);
}
function Bs(e, t, o) {
  return e.getCompDetails(t, Od, void 0, o);
}
function Vs(e, t, o) {
  return e.getCompDetails(t, Bd, "agSkeletonCellRenderer", o, !0);
}
function ec(e, t) {
  return e.getCompDetailsFromGridOptions(Vd, "agLoadingOverlay", t, !0);
}
function tc(e, t) {
  return e.getCompDetailsFromGridOptions(Wd, "agNoRowsOverlay", t, !0);
}
function Ii(e) {
  const t = e;
  return t?.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
function oc(e) {
  return typeof e == "object" && !!e.getComp;
}
var w = {
  BACKSPACE: "Backspace",
  TAB: "Tab",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown",
  DELETE: "Delete",
  F2: "F2",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
  PAGE_HOME: "Home",
  PAGE_END: "End",
  // these should be used with `event.code` instead of `event.key`
  // as `event.key` changes when non-latin keyboards are used
  A: "KeyA",
  C: "KeyC",
  D: "KeyD",
  V: "KeyV",
  X: "KeyX",
  Y: "KeyY",
  Z: "KeyZ"
}, Yo, Zo, Qo, Xo, ki, Li, Jo;
function ls() {
  return Yo === void 0 && (Yo = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), Yo;
}
function mr() {
  return Zo === void 0 && (Zo = /(firefox)/i.test(navigator.userAgent)), Zo;
}
function vr() {
  return Qo === void 0 && (Qo = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), Qo;
}
function kt() {
  return Xo === void 0 && (Xo = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), Xo;
}
function Ws(e) {
  if (!e)
    return null;
  const t = e.tabIndex, o = e.getAttribute("tabIndex");
  return t === -1 && (o === null || o === "" && !mr()) ? null : t.toString();
}
function ic() {
  if (Jo !== void 0)
    return Jo;
  if (!document.body)
    return -1;
  let e = 1e6;
  const t = mr() ? 6e6 : 1e9, o = document.createElement("div");
  for (document.body.appendChild(o); ; ) {
    const i = e * 2;
    if (o.style.height = i + "px", i > t || o.clientHeight !== i)
      break;
    e = i;
  }
  return o.remove(), Jo = e, e;
}
function sc() {
  return Li == null && wr(), Li;
}
function wr() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let o = t.offsetWidth - t.clientWidth;
  o === 0 && t.clientWidth === 0 && (o = null), t.parentNode && t.remove(), o != null && (Li = o, ki = o === 0);
}
function Sr() {
  return ki == null && wr(), ki;
}
var as = "T", nc = new RegExp(`[${as} ]`), rc = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${as}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function Ns(e, t) {
  return e.toString().padStart(t, "0");
}
function zs(e, t = !0, o = as) {
  if (!e)
    return null;
  let i = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((s) => Ns(s, 2)).join("-");
  return t && (i += o + [e.getHours(), e.getMinutes(), e.getSeconds()].map((s) => Ns(s, 2)).join(":")), i;
}
function ho(e, t = !1) {
  return !!Gi(e, t);
}
function lc(e) {
  return ho(e, !0);
}
function Gi(e, t = !1, o) {
  if (!e || !rc.test(e))
    return null;
  const [i, s] = e.split(nc);
  if (!i)
    return null;
  const n = i.split("-").map((g) => Number.parseInt(g, 10));
  if (n.filter((g) => !isNaN(g)).length !== 3)
    return null;
  const [r, l, a] = n, d = new Date(r, l - 1, a);
  if (d.getFullYear() !== r || d.getMonth() !== l - 1 || d.getDate() !== a || !s && t)
    return null;
  if (!s || s === "00:00:00")
    return d;
  const [c, u, h] = s.split(":").map((g) => Number.parseInt(g, 10));
  if (c >= 0 && c < 24)
    d.setHours(c);
  else if (t)
    return null;
  if (u >= 0 && u < 60)
    d.setMinutes(u);
  else if (t)
    return null;
  if (h >= 0 && h < 60)
    d.setSeconds(h);
  else if (t)
    return null;
  return d;
}
function Hi(e) {
  const { inputValue: t, allSuggestions: o, hideIrrelevant: i, filterByPercentageOfBestMatch: s } = e;
  let n = (o ?? []).map(
    (a, d) => ({
      value: a,
      relevance: ac(t, a),
      idx: d
    })
  );
  if (n.sort((a, d) => a.relevance - d.relevance), i && (n = n.filter(
    (a) => a.relevance < Math.max(a.value.length, t.length)
  )), n.length > 0 && s && s > 0) {
    const d = n[0].relevance * s;
    n = n.filter((c) => d - c.relevance < 0);
  }
  const r = [], l = [];
  for (const a of n)
    r.push(a.value), l.push(a.idx);
  return { values: r, indices: l };
}
function ac(e, t) {
  e.length < t.length && ([e, t] = [t, e]);
  let o = [], i = [];
  const s = e.length, n = t.length;
  for (let l = 0; l <= n; l++)
    o[l] = l;
  let r = 0;
  for (let l = 1; l <= s; l++) {
    i[0] = l;
    for (let a = 1; a <= n; a++) {
      const d = e[l - 1], c = t[a - 1];
      if (d.toLocaleLowerCase() === c.toLocaleLowerCase())
        ++r, d === c && ++r, l > 1 && a > 1 && e[l - 2].toLocaleLowerCase() === t[a - 2].toLocaleLowerCase() && (++r, e[l - 2] === t[a - 2] && ++r), l < s / 2 - 10 && ++r, i[a] = o[a - 1];
      else {
        const u = i[a - 1], h = o[a], g = o[a - 1];
        i[a] = 1 + Math.min(u, h, g);
      }
    }
    [o, i] = [i, o];
  }
  return o[n] / (r + 1);
}
function dc(e) {
  return e.altKey || e.ctrlKey || e.metaKey ? !1 : e.key?.length === 1;
}
var Oi = !1, Ao = 0;
function cc(e) {
  Ao > 0 || (e.addEventListener("keydown", Mo), e.addEventListener("mousedown", Mo));
}
function uc(e) {
  Ao > 0 || (e.removeEventListener("keydown", Mo), e.removeEventListener("mousedown", Mo));
}
function Mo(e) {
  const t = Oi, o = e.type === "keydown";
  o && (e.ctrlKey || e.metaKey || e.altKey) || t !== o && (Oi = o);
}
function hc(e) {
  const t = j(e);
  return cc(t), Ao++, () => {
    Ao--, uc(t);
  };
}
function gc() {
  return Oi;
}
function at(e, t, o = !1) {
  const i = aa;
  let s = Mn;
  t && (s += ", " + t), o && (s += ', [tabindex="-1"]');
  const n = Array.prototype.slice.apply(e.querySelectorAll(i)).filter((a) => ke(a)), r = Array.prototype.slice.apply(e.querySelectorAll(s));
  return r.length ? ((a, d) => a.filter((c) => d.indexOf(c) === -1))(n, r) : n;
}
function To(e, t = !1, o = !1, i = !1) {
  const s = at(
    e,
    i ? ".ag-tab-guard" : null,
    o
  ), n = t ? G(s) : s[0];
  return n ? (n.focus({ preventScroll: !0 }), !0) : !1;
}
function qt(e, t, o, i) {
  const s = at(t, null), n = N(e);
  let r;
  r = s.indexOf(n);
  const l = r + (i ? -1 : 1);
  return l < 0 || l >= s.length ? null : s[l];
}
function pc(e, t = 5) {
  let o = 0;
  for (; e && Ws(e) === null && ++o <= t; )
    e = e.parentElement;
  return Ws(e) === null ? null : e;
}
var fc = (
  /*css*/
  ".ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}"
), Cc = class extends No {
  constructor(e, t, o) {
    super(t, o), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {}, this.registerCSS(fc);
  }
  postConstruct() {
    this.addCss("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: o, labelAlignment: i, disabled: s } = this.config;
    s != null && this.setDisabled(s), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), o != null && this.setLabelWidth(o), this.setLabelAlignment(i || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    const { label: e, eLabel: t } = this;
    J(t), typeof e == "string" ? t.innerText = e + this.labelSeparator : e && t.appendChild(e), e === "" ? (V(t, !1), Ie(t, "presentation")) : (V(t, !0), Ie(t, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
  }
  getLabelId() {
    const e = this.eLabel;
    return e.id = e.id || `ag-${this.getCompId()}-label`, e.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
  }
  setLabelAlignment(e) {
    const o = this.getGui().classList;
    return o.toggle("ag-label-align-left", e === "left"), o.toggle("ag-label-align-right", e === "right"), o.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null ? this : (So(this.eLabel, e), this);
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return Tn(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
}, br = class extends Cc {
  constructor(e, t, o, i) {
    super(e, t, o), this.className = i;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: o } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), o != null && this.onValueChange(o), this.className && this.addCss(this.className), this.refreshAriaLabelledBy();
  }
  setLabel(e) {
    return super.setLabel(e), this.refreshAriaLabelledBy(), this;
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId(), o = this.getLabel();
    o == null || o == "" || jl(e) !== null ? Ht(e, "") : Ht(e, t ?? "");
  }
  setAriaLabel(e) {
    return Gt(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListeners(this, { fieldValueChanged: () => e(this.getValue()) }), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return Me(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e ? this : (this.previousValue = this.value, this.value = e, t || this.dispatchLocalEvent({ type: "fieldValueChanged" }), this);
  }
};
function mc(e) {
  return {
    tag: "div",
    role: "presentation",
    children: [
      { tag: "div", ref: "eLabel", cls: "ag-input-field-label" },
      {
        tag: "div",
        ref: "eWrapper",
        cls: "ag-wrapper ag-input-wrapper",
        role: "presentation",
        children: [{ tag: e, ref: "eInput", cls: "ag-input-field-input" }]
      }
    ]
  };
}
var vc = class extends br {
  constructor(e, t, o = "text", i = "input") {
    super(e, e?.template ?? mc(i), [], t), this.inputType = o, this.displayFieldTag = i, this.eLabel = P, this.eWrapper = P, this.eInput = P;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType(this.inputType);
    const { eLabel: e, eWrapper: t, eInput: o, className: i } = this;
    e.classList.add(`${i}-label`), t.classList.add(`${i}-input-wrapper`), o.classList.add(`${i}-input`), this.addCss("ag-input-field"), o.id = o.id || `ag-${this.getCompId()}-input`;
    const { inputName: s, inputWidth: n } = this.config;
    s != null && this.setInputName(s), n != null && this.setInputWidth(n), this.addInputListeners(), this.activateTabIndex([o]);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, {
      input: (e) => this.setValue(e.target.value)
    });
  }
  setInputType(e) {
    this.displayFieldTag === "input" && (this.inputType = e, Ve(this.eInput, "type", e));
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return So(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    const t = this.eInput;
    return t.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return Ve(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return Gt(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return Tn(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      Ve(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      Ve(this.eInput, "autocomplete", t);
    }
    return this;
  }
}, yr = class extends vc {
  constructor(e, t = "ag-checkbox", o = "checkbox") {
    super(e, t, o), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { click: this.onCheckboxClick.bind(this) }), this.addManagedElementListeners(this.eLabel, { click: this.toggle.bind(this) });
  }
  getNextValue() {
    return this.selected === void 0 ? !0 : !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    const t = this.getInputElement();
    return t.name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    if (this.isSelected() === e)
      return;
    this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0;
    const o = this.eInput;
    o.checked = e, o.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue);
  }
  dispatchChange(e, t, o) {
    this.dispatchLocalEvent({ type: "fieldValueChanged", selected: e, previousValue: t, event: o });
    const i = this.getInputElement();
    this.eventSvc.dispatchEvent({
      type: "checkboxChanged",
      id: i.id,
      name: i.name,
      selected: e,
      previousValue: t
    });
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), o = this.selected = e.target.checked;
    this.refreshSelectedClass(o), this.dispatchChange(o, t, e);
  }
  refreshSelectedClass(e) {
    const t = this.eWrapper.classList;
    t.toggle("ag-checked", e === !0), t.toggle("ag-indeterminate", e == null);
  }
}, Rr = {
  selector: "AG-CHECKBOX",
  component: yr
}, wc = (
  /*css*/
  ".ag-list-item{align-items:center;display:flex;height:var(--ag-list-item-height);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}"
), Sc = "ag-active-item", bc = (e, t) => ({
  tag: "div",
  cls: `ag-list-item ag-${e}-list-item`,
  attrs: { role: "option" },
  children: [
    {
      tag: "span",
      ref: "eText",
      children: t
    }
  ]
}), yc = class extends No {
  constructor(e, t, o) {
    super(bc(e, t)), this.label = t, this.value = o, this.eText = P;
  }
  postConstruct() {
    this.createTooltip(), this.addEventListeners();
  }
  setHighlighted(e) {
    const t = this.getGui();
    t.classList.toggle(Sc, e), An(t, e), this.dispatchLocalEvent({
      type: "itemHighlighted",
      highlighted: e
    });
  }
  getHeight() {
    return this.getGui().clientHeight;
  }
  setIndex(e, t) {
    const o = this.getGui();
    Jl(o, e), Xl(o, t);
  }
  createTooltip() {
    const e = {
      getTooltipValue: () => this.label,
      getGui: () => this.getGui(),
      getLocation: () => "UNKNOWN",
      // only show tooltips for items where the text cannot be fully displayed
      shouldDisplayTooltip: () => Qi(this.eText)
    }, t = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "highlightTooltipFeature",
        !1,
        e,
        this
      )
    );
    t && (this.tooltipFeature = t);
  }
  addEventListeners() {
    const e = this.getParentComponent();
    e && (this.addGuiEventListener("mouseover", () => {
      e.highlightItem(this);
    }), this.addGuiEventListener("mousedown", (t) => {
      t.preventDefault(), t.stopPropagation(), e.setValue(this.value);
    }));
  }
}, Rc = class extends No {
  constructor(e = "default") {
    super({ tag: "div", cls: `ag-list ag-${e}-list` }), this.cssIdentifier = e, this.options = [], this.listItems = [], this.highlightedItem = null, this.registerCSS(wc);
  }
  postConstruct() {
    const e = this.getGui();
    this.addManagedElementListeners(e, { mouseleave: () => this.clearHighlighted() });
  }
  handleKeyDown(e) {
    const t = e.key;
    switch (t) {
      case w.ENTER:
        if (!this.highlightedItem)
          this.setValue(this.getValue());
        else {
          const o = this.listItems.indexOf(this.highlightedItem);
          this.setValueByIndex(o);
        }
        break;
      case w.DOWN:
      case w.UP:
        e.preventDefault(), this.navigate(t);
        break;
      case w.PAGE_DOWN:
      case w.PAGE_UP:
      case w.PAGE_HOME:
      case w.PAGE_END:
        e.preventDefault(), this.navigateToPage(t);
        break;
    }
  }
  addOptions(e) {
    for (const t of e)
      this.addOption(t);
    return this;
  }
  addOption(e) {
    const { value: t, text: o } = e, i = o ?? t;
    return this.options.push({ value: t, text: i }), this.renderOption(t, i), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0);
    for (const e of this.listItems)
      e.destroy();
    J(this.getGui()), this.listItems = [], this.refreshAriaRole();
  }
  setValue(e, t) {
    if (this.value === e)
      return this.fireItemSelected(), this;
    if (e == null)
      return this.reset(t), this;
    const o = this.options.findIndex((i) => i.value === e);
    if (o !== -1) {
      const i = this.options[o];
      this.value = i.value, this.displayValue = i.text, this.highlightItem(this.listItems[o]), t || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(e) {
    return this.setValue(this.options[e].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const e = this.options.findIndex((t) => t.value === this.value);
    e !== -1 && this.highlightItem(this.listItems[e]);
  }
  highlightItem(e) {
    const t = e.getGui();
    if (!ke(t))
      return;
    this.clearHighlighted(), e.setHighlighted(!0), this.highlightedItem = e;
    const o = this.getGui(), { scrollTop: i, clientHeight: s } = o, { offsetTop: n, offsetHeight: r } = t;
    (n + r > i + s || n < i) && t.scrollIntoView({ block: "nearest" });
  }
  hideItemTooltip() {
    this.highlightedItem?.tooltipFeature?.attemptToHideTooltip();
  }
  destroy() {
    this.hideItemTooltip(), super.destroy();
  }
  reset(e) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), e || this.fireChangeEvent();
  }
  clearHighlighted() {
    this.highlightedItem?.setHighlighted(!1), this.highlightedItem = null;
  }
  renderOption(e, t) {
    const o = new yc(this.cssIdentifier, t, e);
    o.setParentComponent(this);
    const i = this.createManagedBean(o);
    this.listItems.push(i), this.getGui().appendChild(i.getGui());
  }
  navigate(e) {
    const t = e === w.DOWN;
    let o;
    const { listItems: i, highlightedItem: s } = this;
    if (!s)
      o = t ? i[0] : G(i);
    else {
      let r = i.indexOf(s) + (t ? 1 : -1);
      r = Math.min(Math.max(r, 0), i.length - 1), o = i[r];
    }
    this.highlightItem(o);
  }
  navigateToPage(e) {
    const { listItems: t, highlightedItem: o } = this;
    if (!o || t.length === 0)
      return;
    const i = t.indexOf(o), s = this.options.length - 1, n = t[0].getHeight(), r = Math.floor(this.getGui().clientHeight / n);
    let l = -1;
    e === w.PAGE_HOME ? l = 0 : e === w.PAGE_END ? l = s : e === w.PAGE_DOWN ? l = Math.min(i + r, s) : e === w.PAGE_UP && (l = Math.max(i - r, 0)), l !== -1 && this.highlightItem(t[l]);
  }
  refreshAriaRole() {
    Ie(this.getGui(), this.options.length === 0 ? "presentation" : "listbox");
  }
  updateIndices() {
    this.refreshAriaRole();
    const e = this.listItems, t = e.length;
    e.forEach((o, i) => {
      o.setIndex(i + 1, t);
    });
  }
  fireChangeEvent() {
    this.dispatchLocalEvent({ type: "fieldValueChanged" }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchLocalEvent({ type: "selectedItem" });
  }
}, xc = (
  /*css*/
  ".ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}"
), Pc = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
      children: [
        { tag: "div", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, Dc = class extends br {
  constructor(e) {
    if (super(e, e?.template || Pc, e?.agComponents || [], e?.className), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.eLabel = P, this.eWrapper = P, this.eDisplayField = P, this.eIcon = P, this.registerCSS(xc), this.ariaRole = e?.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: o, variableWidth: i, minPickerWidth: s, maxPickerWidth: n } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!i, o != null && this.setPickerMaxHeight(o), s != null && this.setPickerMinWidth(s), n != null && this.setPickerMaxWidth(n);
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedElementListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedElementListeners(this.eLabel, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) }), this.addManagedElementListeners(this.eWrapper, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) });
    const { pickerIcon: o, inputWidth: i } = this.config;
    if (o) {
      const s = this.beans.iconSvc.createIconNoSpan(o);
      s && this.eIcon.appendChild(s);
    }
    i != null && this.setInputWidth(i);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), Si(e, !1), this.ariaRole && Ie(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && e?.target === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    if (this.skipClick) {
      this.skipClick = !1;
      return;
    }
    this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case w.UP:
      case w.DOWN:
      case w.ENTER:
      case w.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case w.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
        break;
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || ([this.destroyMouseWheelFunc] = this.addManagedEventListeners({
      bodyScroll: () => {
        this.hidePicker();
      }
    }));
    const t = this.getLocaleTextFunc(), {
      config: { pickerAriaLabelKey: o, pickerAriaLabelValue: i, modalPicker: s = !0 },
      maxPickerHeight: n,
      minPickerWidth: r,
      maxPickerWidth: l,
      variableWidth: a,
      beans: d,
      eWrapper: c
    } = this, u = {
      modal: s,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: () => {
        const f = yn(d);
        this.beforeHidePicker(), f && this.isAlive() && this.getFocusableElement().focus();
      },
      ariaLabel: t(o, i),
      anchorToElement: c
    };
    e.style.position = "absolute";
    const h = d.popupSvc, g = h.addPopup(u);
    a ? (r && (e.style.minWidth = r), e.style.width = Xi(yi(c)), l && (e.style.maxWidth = l)) : So(e, l ?? yi(c));
    const p = n ?? `${Yi(h.getPopupParent())}px`;
    return e.style.setProperty("max-height", p), this.alignPickerToComponent(), g.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const {
      pickerGap: e,
      config: { pickerType: t },
      beans: { popupSvc: o, gos: i },
      eWrapper: s,
      pickerComponent: n
    } = this, r = i.get("enableRtl") ? "right" : "left";
    o.positionPopupByComponent({
      type: t,
      eventSource: s,
      ePopup: n.getGui(),
      position: "under",
      alignSide: r,
      keepWithinBounds: !0,
      nudgeY: e
    });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    if (!this.isAlive())
      return;
    const t = this.getAriaElement();
    Si(t, e);
    const o = this.eWrapper.classList;
    o.toggle("ag-picker-expanded", e), o.toggle("ag-picker-collapsed", !e);
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    this.pickerComponent?.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    this.hideCurrentPicker && (this.hideCurrentPicker(), this.dispatchLocalEvent({
      type: "pickerHidden"
    }));
  }
  setInputWidth(e) {
    return So(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
}, Fc = (
  /*css*/
  ".ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}"
), Ec = class extends Dc {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "selectOpen",
      ariaRole: "combobox",
      ...e
    }), this.registerCSS(Fc);
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "tooltipFeature",
        !1,
        {
          shouldDisplayTooltip: ha(() => this.eDisplayField),
          getGui: () => this.getGui()
        }
      )
    ), super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: e, value: t, placeholder: o } = this.config;
    e != null && this.addOptions(e), t != null && this.setValue(t, !0), o && t == null && (this.eDisplayField.textContent = o), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) });
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    const e = this.createBean(
      new Rc("select")
    );
    this.listComponent = e, e.setParentComponent(this);
    const t = e.getAriaElement(), o = `ag-select-list-${e.getCompId()}`;
    t.setAttribute("id", o), la(this.getAriaElement(), t), e.addManagedElementListeners(e.getGui(), {
      mousedown: (i) => {
        i?.preventDefault();
      }
    }), e.addManagedListeners(e, {
      selectedItem: () => {
        this.hidePicker(), this.dispatchLocalEvent({ type: "selectedItem" });
      },
      fieldValueChanged: () => {
        this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
      }
    });
  }
  createPickerComponent() {
    return this.listComponent;
  }
  beforeHidePicker() {
    this.listComponent?.hideItemTooltip(), super.beforeHidePicker();
  }
  onKeyDown(e) {
    const { key: t } = e;
    switch (t === w.TAB && this.hidePicker(), t) {
      case w.ENTER:
      case w.UP:
      case w.DOWN:
      case w.PAGE_UP:
      case w.PAGE_DOWN:
      case w.PAGE_HOME:
      case w.PAGE_END:
        e.preventDefault(), this.isPickerDisplayed ? this.listComponent?.handleKeyDown(e) : super.onKeyDown(e);
        break;
      case w.ESCAPE:
        super.onKeyDown(e);
        break;
      case w.SPACE:
        this.isPickerDisplayed ? e.preventDefault() : super.onKeyDown(e);
        break;
    }
  }
  showPicker() {
    const e = this.listComponent;
    e && (super.showPicker(), e.refreshHighlighted());
  }
  addOptions(e) {
    for (const t of e)
      this.addOption(t);
    return this;
  }
  addOption(e) {
    return this.listComponent.addOption(e), this;
  }
  clearOptions() {
    return this.listComponent?.clearOptions(), this.setValue(void 0, !0), this;
  }
  setValue(e, t, o) {
    const {
      listComponent: i,
      config: { placeholder: s },
      eDisplayField: n,
      tooltipFeature: r
    } = this;
    if (this.value === e || !i)
      return this;
    if (o || i.setValue(e, !0), i.getValue() === this.getValue())
      return this;
    let a = i.getDisplayValue();
    return a == null && s && (a = s), n.textContent = a, r?.setTooltipAndRefresh(a ?? null), super.setValue(e, t);
  }
  destroy() {
    this.listComponent = this.destroyBean(this.listComponent), super.destroy();
  }
}, Ac = (
  /*css*/
  ':where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-chart,.ag-dnd-ghost,.ag-external,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-resizer{pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}'
), ds = typeof window != "object" || !window?.document?.fonts?.forEach, ft = (e, t, o, i, s, n) => {
  if (ds)
    return;
  i && (e = `@layer ${CSS.escape(i)} { ${e} }`);
  let r = dt.map.get(t);
  if (r || (r = [], dt.map.set(t, r)), r.some((c) => c.css === e))
    return;
  const l = document.createElement("style");
  n && l.setAttribute("nonce", n), l.dataset.agGlobalCss = o, l.textContent = e;
  const a = { css: e, el: l, priority: s };
  let d;
  for (const c of r) {
    if (c.priority > s)
      break;
    d = c;
  }
  if (d) {
    d.el.insertAdjacentElement("afterend", l);
    const c = r.indexOf(d);
    r.splice(c + 1, 0, a);
  } else
    t.insertBefore(l, t.querySelector(":not(title, meta)")), r.push(a);
}, xr = (e, t, o, i) => {
  ft(Ac, e, "shared", t, 0, o), i?.forEach(
    (s, n) => s.forEach((r) => ft(r, e, n, t, 0, o))
  );
}, Mc = (e) => {
  dt.grids.add(e);
}, Tc = (e) => {
  if (dt.grids.delete(e), dt.grids.size === 0) {
    dt.map = /* @__PURE__ */ new WeakMap();
    for (const t of document.head.querySelectorAll("style[data-ag-global-css]"))
      t.remove();
  }
}, _s, dt = (_s = typeof window == "object" ? window : {}).agStyleInjectionState ?? (_s.agStyleInjectionState = {
  map: /* @__PURE__ */ new WeakMap(),
  grids: /* @__PURE__ */ new Set()
}), te = (e) => new Pr(e), Ee = "$default", Ic = 0, Pr = class {
  constructor({ feature: e, params: t, modeParams: o = {}, css: i, cssImports: s }) {
    this.feature = e, this.css = i, this.cssImports = s, this.modeParams = {
      // NOTE: it's important that default is defined first, putting it
      // first in iteration order, because when merging params the default
      // params override any prior modal params, so modal params in this
      // part need to come after default params to prevent them from being
      // immediately overridden.
      [Ee]: {
        ...o[Ee] ?? {},
        ...t ?? {}
      },
      ...o
    };
  }
  use(e, t, o) {
    let i = this._inject;
    if (i == null) {
      let { css: s } = this;
      if (s) {
        const n = `ag-theme-${this.feature ?? "part"}-${++Ic}`;
        typeof s == "function" && (s = s()), s = `:where(.${n}) {
${s}
}
`;
        for (const r of this.cssImports ?? [])
          s = `@import url(${JSON.stringify(r)});
${s}`;
        i = { css: s, class: n };
      } else
        i = !1;
      this._inject = i;
    }
    return i && e && ft(i.css, e, i.class, t, 1, o), i ? i.class : !1;
  }
}, kc = (e) => e.replace(/[A-Z]/g, (t) => `-${t}`).toLowerCase(), Dr = (e) => `--ag-${kc(e)}`, me = (e) => `var(${Dr(e)})`, Lc = (e, t, o) => Math.max(t, Math.min(o, e)), Gc = (e) => {
  const t = /* @__PURE__ */ new Map();
  return (o) => {
    const i = o;
    return t.has(i) || t.set(i, e(o)), t.get(i);
  };
}, oe = (e) => ({ ref: "accentColor", mix: e }), se = (e) => ({ ref: "foregroundColor", mix: e }), K = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "backgroundColor"
}), Hc = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "headerBackgroundColor"
}), q = { ref: "backgroundColor" }, Xe = { ref: "foregroundColor" }, z = { ref: "accentColor" }, Io = {
  backgroundColor: "#fff",
  foregroundColor: "#181d1f",
  borderColor: se(0.15),
  chromeBackgroundColor: K(0.02),
  browserColorScheme: "light"
}, Oc = {
  ...Io,
  textColor: Xe,
  accentColor: "#2196f3",
  invalidColor: "#e02525",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu",
    "Cantarell",
    "Helvetica Neue",
    "sans-serif"
  ],
  subtleTextColor: {
    ref: "textColor",
    mix: 0.5
  },
  borderWidth: 1,
  borderRadius: 4,
  spacing: 8,
  fontSize: 14,
  focusShadow: {
    spread: 3,
    color: oe(0.5)
  },
  focusErrorShadow: {
    spread: 3,
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.5
    }
  },
  popupShadow: "0 0 16px #00000026",
  cardShadow: "0 1px 4px 1px #00000018",
  dropdownShadow: { ref: "cardShadow" },
  listItemHeight: {
    calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
  },
  dragAndDropImageBackgroundColor: q,
  dragAndDropImageBorder: !0,
  dragAndDropImageNotAllowedBorder: {
    color: {
      ref: "invalidColor",
      onto: "dragAndDropImageBackgroundColor",
      mix: 0.5
    }
  },
  dragAndDropImageShadow: {
    ref: "popupShadow"
  },
  iconSize: 16,
  iconColor: "inherit",
  toggleButtonWidth: 28,
  toggleButtonHeight: 18,
  toggleButtonOnBackgroundColor: z,
  toggleButtonOffBackgroundColor: K(0.3),
  toggleButtonSwitchBackgroundColor: q,
  toggleButtonSwitchInset: 2,
  tooltipBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  tooltipErrorBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.1
  },
  tooltipTextColor: {
    ref: "textColor"
  },
  tooltipErrorTextColor: {
    ref: "invalidColor"
  },
  tooltipBorder: !0,
  tooltipErrorBorder: {
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.25
    }
  }
}, Bc = [
  "colorScheme",
  "color",
  "length",
  "scale",
  "borderStyle",
  "border",
  "shadow",
  "image",
  "fontFamily",
  "fontWeight",
  "duration"
], Vc = Gc((e) => (e = e.toLowerCase(), Bc.find((t) => e.endsWith(t.toLowerCase())) ?? "length")), zo = (e) => typeof e == "object" && e?.ref ? me(e.ref) : typeof e == "string" ? e : typeof e == "number" ? String(e) : !1, cs = (e) => {
  if (typeof e == "string")
    return e;
  if (e && "ref" in e) {
    const t = me(e.ref);
    return e.mix == null ? t : `color-mix(in srgb, ${e.onto ? me(e.onto) : "transparent"}, ${t} ${Lc(e.mix * 100, 0, 100)}%)`;
  }
  return !1;
}, Wc = zo, Je = (e) => typeof e == "string" ? e : typeof e == "number" ? `${e}px` : e && "calc" in e ? `calc(${e.calc.replace(/ ?[*/+] ?/g, " $& ").replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (o) => o[0] === "-" ? o : " " + me(o) + " ")})` : e && "ref" in e ? me(e.ref) : !1, Nc = zo, Bi = (e, t) => typeof e == "string" ? e : e === !0 ? Bi({}, t) : e === !1 ? t === "columnBorder" ? Bi({ color: "transparent" }, t) : "none" : e && "ref" in e ? me(e.ref) : Fr(e.style ?? "solid") + " " + Je(e.width ?? { ref: "borderWidth" }) + " " + cs(e.color ?? { ref: "borderColor" }), zc = (e) => typeof e == "string" ? e : e === !1 ? "none" : e && "ref" in e ? me(e.ref) : [
  Je(e.offsetX ?? 0),
  Je(e.offsetY ?? 0),
  Je(e.radius ?? 0),
  Je(e.spread ?? 0),
  cs(e.color ?? { ref: "foregroundColor" })
].join(" "), Fr = zo, Er = (e) => typeof e == "string" ? e.includes(",") ? e : Us(e) : e && "googleFont" in e ? Er(e.googleFont) : e && "ref" in e ? me(e.ref) : Array.isArray(e) ? e.map((t) => (typeof t == "object" && "googleFont" in t && (t = t.googleFont), Us(t))).join(", ") : !1, Us = (e) => (
  // don't quote var() expressions or quote safe identifier names, so that
  // people can specify fonts like sans-serif which are keywords not strings,
  // or var(--my-var)
  /^[\w-]+$|\w\(/.test(e) ? e : JSON.stringify(e)
), _c = zo, Ar = (e) => typeof e == "string" ? e : e && "url" in e ? `url(${JSON.stringify(e.url)})` : e && "svg" in e ? Ar({ url: `data:image/svg+xml,${encodeURIComponent(e.svg)}` }) : e && "ref" in e ? me(e.ref) : !1, Uc = (e, t, o) => typeof e == "string" ? e : typeof e == "number" ? (e >= 10 && o.warn(104, { value: e, param: t }), `${e}s`) : e && "ref" in e ? me(e.ref) : !1, $c = {
  color: cs,
  colorScheme: Wc,
  length: Je,
  scale: Nc,
  border: Bi,
  borderStyle: Fr,
  shadow: zc,
  image: Ar,
  fontFamily: Er,
  fontWeight: _c,
  duration: Uc
}, Kc = (e, t, o) => {
  const i = Vc(e);
  return $c[i](t, e, o);
}, jc = (e) => new Mr(e), Mr = class Tr {
  constructor(t, o = []) {
    this.themeLogger = t, this.parts = o;
  }
  withPart(t) {
    return typeof t == "function" && (t = t()), t instanceof Pr ? new Tr(this.themeLogger, [...this.parts, t]) : (this.themeLogger.preInitErr(259, "Invalid part", { part: t }), this);
  }
  withoutPart(t) {
    return this.withPart(te({ feature: t }));
  }
  withParams(t, o = Ee) {
    return this.withPart(
      te({
        modeParams: { [o]: t }
      })
    );
  }
  /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */
  _startUse({ styleContainer: t, cssLayer: o, nonce: i, loadThemeGoogleFonts: s, moduleCss: n }) {
    if (ds)
      return;
    Yc(), xr(t, o, i, n);
    const r = qc(this);
    if (r.length > 0)
      for (const l of r)
        s && Zc(l, i);
    for (const l of this.parts)
      l.use(t, o, i);
  }
  /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */
  _getCssClass() {
    return this._cssClassCache ?? (this._cssClassCache = $s(this.parts).map((t) => t.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
  }
  _getModeParams() {
    let t = this._paramsCache;
    if (!t) {
      const o = {
        // NOTE: defining the default mode here is important, it ensures
        // that the default mode is first in iteration order, which puts
        // it first in outputted CSS, allowing other modes to override it
        [Ee]: { ...Oc }
      };
      for (const i of $s(this.parts))
        for (const s of Object.keys(i.modeParams)) {
          const n = i.modeParams[s];
          if (n) {
            const r = o[s] ?? (o[s] = {}), l = /* @__PURE__ */ new Set();
            for (const a of Object.keys(n)) {
              const d = n[a];
              d !== void 0 && (r[a] = d, l.add(a));
            }
            if (s === Ee)
              for (const a of Object.keys(o)) {
                const d = o[a];
                if (a !== Ee)
                  for (const c of l)
                    delete d[c];
              }
          }
        }
      this._paramsCache = t = o;
    }
    return t;
  }
  /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */
  _getPerInstanceCss(t) {
    const o = "##SELECTOR##";
    let i = this._paramsCssCache;
    if (!i) {
      let s = "", n = "";
      const r = this._getModeParams();
      for (const a of Object.keys(r)) {
        const d = r[a];
        if (a !== Ee) {
          const u = `:where([data-ag-theme-mode="${typeof CSS == "object" ? CSS.escape(a) : a}"]) & {
`;
          s += u, n += u;
        }
        for (const c of Object.keys(d).sort()) {
          const u = d[c], h = Kc(c, u, this.themeLogger);
          if (h === !1)
            this.themeLogger.error(107, { key: c, value: u });
          else {
            const g = Dr(c), p = g.replace("--ag-", "--ag-inherited-");
            s += `	${g}: var(${p}, ${h});
`, n += `	${p}: var(${g});
`;
          }
        }
        a !== Ee && (s += `}
`, n += `}
`);
      }
      let l = `${o} {
${s}}
`;
      l += `:has(> ${o}):not(${o}) {
${n}}
`, this._paramsCssCache = i = l;
    }
    return i.replaceAll(o, `:where(.${t})`);
  }
}, $s = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const i of e)
    t.set(i.feature, i);
  const o = [];
  for (const i of e)
    (!i.feature || t.get(i.feature) === i) && o.push(i);
  return o;
}, qc = (e) => {
  const t = /* @__PURE__ */ new Set(), o = (n) => {
    if (Array.isArray(n))
      n.forEach(o);
    else {
      const r = n?.googleFont;
      typeof r == "string" && t.add(r);
    }
  };
  return Object.values(e._getModeParams()).flatMap((n) => Object.values(n)).forEach(o), Array.from(t).sort();
}, Ks = !1, Yc = () => {
  if (!Ks) {
    Ks = !0;
    for (const e of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))
      e.remove();
  }
}, Zc = async (e, t) => {
  const o = `@import url('https://${Qc}/css2?family=${encodeURIComponent(e)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
  ft(o, document.head, `googleFont:${e}`, void 0, 0, t);
}, Qc = "fonts.googleapis.com", Xc = 1, Jc = class {
  constructor(e) {
    this.beans = {}, this.createdBeans = [], this.destroyed = !1, this.instanceId = Xc++, e?.beanClasses && (this.beanDestroyComparator = e.beanDestroyComparator, this.init(e));
  }
  init(e) {
    this.id = e.id, this.beans.context = this, this.destroyCallback = e.destroyCallback;
    for (const t of Object.keys(e.providedBeanInstances))
      this.beans[t] = e.providedBeanInstances[t];
    for (const t of e.beanClasses) {
      const o = new t();
      o.beanName ? this.beans[o.beanName] = o : console.error(`Bean ${t.name} is missing beanName`), this.createdBeans.push(o);
    }
    for (const t of e.derivedBeans ?? []) {
      const { beanName: o, bean: i } = t(this);
      this.beans[o] = i, this.createdBeans.push(i);
    }
    e.beanInitComparator && this.createdBeans.sort(e.beanInitComparator), this.initBeans(this.createdBeans);
  }
  getBeanInstances() {
    return Object.values(this.beans);
  }
  createBean(e, t) {
    return this.initBeans([e], t), e;
  }
  initBeans(e, t) {
    const o = this.beans;
    for (const i of e)
      i.preWireBeans?.(o), i.wireBeans?.(o);
    for (const i of e)
      i.preConstruct?.();
    t && e.forEach(t);
    for (const i of e)
      i.postConstruct?.();
  }
  getBeans() {
    return this.beans;
  }
  getBean(e) {
    return this.beans[e];
  }
  getId() {
    return this.id;
  }
  destroy() {
    if (this.destroyed)
      return;
    this.destroyed = !0;
    const e = this.getBeanInstances();
    this.beanDestroyComparator && e.sort(this.beanDestroyComparator), this.destroyBeans(e), this.beans = {}, this.createdBeans = [], this.destroyCallback?.();
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e) {
    e?.destroy?.();
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e) {
    if (e)
      for (let t = 0; t < e.length; t++)
        this.destroyBean(e[t]);
    return [];
  }
  isDestroyed() {
    return this.destroyed;
  }
}, eu = 0, tu = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "environment", this.paramsClass = `ag-theme-params-${++eu}`, this.globalCSS = [];
  }
  wireBeans(e) {
    this.eRootDiv = e.eRootDiv;
  }
  postConstruct() {
    const { gos: e, eRootDiv: t } = this;
    e.setInstanceDomData(t), this.eStyleContainer = e.get("themeStyleContainer") ?? (t.getRootNode() === document ? document.head : t), this.cssLayer = e.get("themeCssLayer"), this.styleNonce = e.get("styleNonce"), this.addManagedPropertyListener("theme", () => this.handleThemeChange()), this.handleThemeChange(), this.initVariables(), this.addDestroyFunc(() => Tc(this)), this.mutationObserver = new MutationObserver(() => {
      this.fireStylesChangedEvent("themeChanged");
    }), this.addDestroyFunc(() => this.mutationObserver.disconnect());
  }
  applyThemeClasses(e, t = []) {
    const { theme: o } = this;
    let i;
    o ? i = `${this.paramsClass} ${o._getCssClass()}` : i = this.applyLegacyThemeClasses();
    for (const s of Array.from(e.classList))
      s.startsWith("ag-theme-") && e.classList.remove(s);
    if (i) {
      const s = e.className;
      e.className = `${s}${s ? " " : ""}${i}${t?.length ? " " + t.join(" ") : ""}`;
    }
  }
  applyLegacyThemeClasses() {
    let e = "";
    this.mutationObserver.disconnect();
    let t = this.eRootDiv;
    for (; t; ) {
      let o = !1;
      for (const i of Array.from(t.classList))
        i.startsWith("ag-theme-") && (o = !0, e = e ? `${e} ${i}` : i);
      o && this.mutationObserver.observe(t, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t = t.parentElement;
    }
    return e;
  }
  addGlobalCSS(e, t) {
    this.theme ? ft(e, this.eStyleContainer, t, this.cssLayer, 0, this.styleNonce) : this.globalCSS.push([e, t]);
  }
  handleThemeChange() {
    const { gos: e, theme: t } = this, o = e.get("theme");
    let i;
    if (o === "legacy")
      i = void 0;
    else {
      const s = o ?? this.getDefaultTheme();
      s instanceof Mr ? i = s : this.themeError(s);
    }
    i !== t && this.handleNewTheme(i), this.postProcessThemeChange(i, o);
  }
  handleNewTheme(e) {
    const { gos: t, eRootDiv: o, globalCSS: i } = this, s = this.getAdditionalCss();
    if (e) {
      Mc(this), xr(this.eStyleContainer, this.cssLayer, this.styleNonce, s);
      for (const [r, l] of i)
        ft(r, this.eStyleContainer, l, this.cssLayer, 0, this.styleNonce);
      i.length = 0;
    }
    this.theme = e, e?._startUse({
      loadThemeGoogleFonts: t.get("loadThemeGoogleFonts"),
      styleContainer: this.eStyleContainer,
      cssLayer: this.cssLayer,
      nonce: this.styleNonce,
      moduleCss: s
    });
    let n = this.eParamsStyle;
    if (!n) {
      n = this.eParamsStyle = jt({ tag: "style" });
      const r = t.get("styleNonce");
      r && n.setAttribute("nonce", r), o.appendChild(n);
    }
    ds || (n.textContent = e?._getPerInstanceCss(this.paramsClass) || ""), this.applyThemeClasses(o), this.fireStylesChangedEvent("themeChanged");
  }
}, ou = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "registry";
  }
  registerDynamicBeans(e) {
    if (e) {
      this.dynamicBeans ?? (this.dynamicBeans = {});
      for (const t of Object.keys(e))
        this.dynamicBeans[t] = e[t];
    }
  }
  createDynamicBean(e, t, ...o) {
    if (!this.dynamicBeans)
      throw new Error(this.getDynamicError(e, !0));
    const i = this.dynamicBeans[e];
    if (i == null) {
      if (t)
        throw new Error(this.getDynamicError(e, !1));
      return;
    }
    return new i(...o);
  }
}, iu = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "eventSvc", this.eventServiceType = "global", this.globalSvc = new $e();
  }
  addListener(e, t, o) {
    this.globalSvc.addEventListener(e, t, o);
  }
  removeListener(e, t, o) {
    this.globalSvc.removeEventListener(e, t, o);
  }
  addGlobalListener(e, t = !1) {
    this.globalSvc.addGlobalListener(e, t);
  }
  removeGlobalListener(e, t = !1) {
    this.globalSvc.removeGlobalListener(e, t);
  }
  dispatchEvent(e) {
    this.globalSvc.dispatchEvent(this.gos.addCommon(e));
  }
  dispatchEventOnce(e) {
    this.globalSvc.dispatchEventOnce(this.gos.addCommon(e));
  }
}, Xt = 0, su = 200, nu = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "popupSvc", this.popupList = [];
  }
  getPopupParent() {
    const e = this.gos.get("popupParent");
    return e || this.getDefaultPopupParent();
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: o, nudgeY: i, skipObserver: s } = e;
    this.positionPopup({
      ePopup: t,
      nudgeX: o,
      nudgeY: i,
      keepWithinBounds: !0,
      skipObserver: s,
      updatePosition: () => this.calculatePointerAlign(e.mouseEvent),
      postProcessCallback: () => this.callPostProcessPopup(e, e.type, e.ePopup, null, e.mouseEvent)
    });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  positionPopupByComponent(e) {
    const {
      ePopup: t,
      nudgeX: o,
      nudgeY: i,
      keepWithinBounds: s,
      eventSource: n,
      alignSide: r = "left",
      position: l = "over",
      type: a
    } = e, d = n.getBoundingClientRect(), c = this.getParentRect();
    this.setAlignedTo(n, t);
    const u = () => {
      let h = d.left - c.left;
      r === "right" && (h -= t.offsetWidth - d.width);
      let g;
      return l === "over" ? (g = d.top - c.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), this.shouldRenderUnderOrAbove(t, d, c, e.nudgeY || 0) === "under" ? g = d.top - c.top + d.height : g = d.top - t.offsetHeight - (i || 0) * 2 - c.top), { x: h, y: g };
    };
    this.positionPopup({
      ePopup: t,
      nudgeX: o,
      nudgeY: i,
      keepWithinBounds: s,
      updatePosition: u,
      postProcessCallback: () => this.callPostProcessPopup(e, a, t, n, null)
    });
  }
  shouldRenderUnderOrAbove(e, t, o, i) {
    const s = o.bottom - t.bottom, n = t.top - o.top, r = e.offsetHeight + i;
    return s > r ? "under" : n > r || n > s ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const o = this.getPopupIndex(e);
    if (o === -1)
      return;
    const i = this.popupList[o], { alignedToElement: s } = i;
    if (!s)
      return;
    const n = ["right", "left", "over", "above", "under"];
    for (const r of n)
      s.classList.remove(`ag-has-popup-positioned-${r}`), e.classList.remove(`ag-popup-positioned-${r}`);
    t && (s.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`));
  }
  setAlignedTo(e, t) {
    const o = this.getPopupIndex(t);
    if (o !== -1) {
      const i = this.popupList[o];
      i.alignedToElement = e;
    }
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: o, nudgeX: i, nudgeY: s, skipObserver: n, updatePosition: r } = e, l = { width: 0, height: 0 }, a = (d = !1) => {
      let { x: c, y: u } = r();
      d && t.clientWidth === l.width && t.clientHeight === l.height || (l.width = t.clientWidth, l.height = t.clientHeight, i && (c += i), s && (u += s), o && (c = this.keepXYWithinBounds(
        t,
        c,
        1
        /* Horizontal */
      ), u = this.keepXYWithinBounds(
        t,
        u,
        0
        /* Vertical */
      )), t.style.left = `${c}px`, t.style.top = `${u}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (a(), !n) {
      const d = wt(this.beans, t, () => a(!0));
      setTimeout(() => d(), su);
    }
  }
  getParentRect() {
    const e = j(this.beans);
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), In(t);
  }
  keepXYWithinBounds(e, t, o) {
    const i = o === 0, s = i ? "clientHeight" : "clientWidth", n = i ? "top" : "left", r = i ? "height" : "width", l = i ? "scrollTop" : "scrollLeft", a = j(this.beans), d = a.documentElement, c = this.getPopupParent(), u = e.getBoundingClientRect(), h = c.getBoundingClientRect(), g = a.documentElement.getBoundingClientRect(), p = c === a.body, f = Math.ceil(u[r]);
    let m = p ? (i ? ca : yi)(d) + d[l] : c[s];
    p && (m -= Math.abs(g[n] - h[n]));
    const v = m - f;
    return Math.min(Math.max(t, 0), Math.max(v, 0));
  }
  addPopup(e) {
    const { eChild: t, ariaLabel: o, ariaOwns: i, alwaysOnTop: s, positionCallback: n, anchorToElement: r } = e, l = this.getPopupIndex(t);
    if (l !== -1)
      return { hideFunc: this.popupList[l].hideFunc };
    this.initialisePopupPosition(t);
    const a = this.createPopupWrapper(t, !!s, o, i), d = this.addEventListenersToPopup({ ...e, wrapperEl: a });
    return n && n(), this.addPopupToPopupList(t, a, d, r), {
      hideFunc: d
    };
  }
  initialisePopupPosition(e) {
    const o = this.getPopupParent().getBoundingClientRect();
    A(e.style.top) || (e.style.top = `${o.top * -1}px`), A(e.style.left) || (e.style.left = `${o.left * -1}px`);
  }
  createPopupWrapper(e, t, o, i) {
    const s = this.getPopupParent(), { environment: n, gos: r } = this.beans, l = jt({ tag: "div" });
    return n.applyThemeClasses(l), l.classList.add("ag-popup"), e.classList.add(r.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), e.hasAttribute("role") || Ie(e, "dialog"), o ? Gt(e, o) : i && (e.id || (e.id = `popup-component-${Xt}`), Ds(i, e.id)), l.appendChild(e), s.appendChild(l), t ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), l;
  }
  addEventListenersToPopup(e) {
    const t = this.beans, o = j(t), { wrapperEl: i, eChild: s, closedCallback: n, afterGuiAttached: r, closeOnEsc: l, modal: a, ariaOwns: d } = e;
    let c = !1;
    const u = (f) => {
      if (!i.contains(N(t)))
        return;
      f.key === w.ESCAPE && !this.isStopPropagation(f) && p({ keyboardEvent: f });
    }, h = (f) => p({ mouseEvent: f }), g = (f) => p({ touchEvent: f }), p = (f = {}) => {
      const { mouseEvent: C, touchEvent: m, keyboardEvent: v, forceHide: S } = f;
      !S && // we don't hide popup if the event was on the child, or any
      // children of this child
      (this.isEventFromCurrentPopup({ mouseEvent: C, touchEvent: m }, s) || // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      c) || (c = !0, i.remove(), o.removeEventListener("keydown", u), o.removeEventListener("mousedown", h), o.removeEventListener("touchstart", g), o.removeEventListener("contextmenu", h), this.eventSvc.removeListener("dragStarted", h), n && n(C || m || v), this.removePopupFromPopupList(s, d));
    };
    return r && r({ hidePopup: p }), window.setTimeout(() => {
      l && o.addEventListener("keydown", u), a && (o.addEventListener("mousedown", h), this.eventSvc.addListener("dragStarted", h), o.addEventListener("touchstart", g), o.addEventListener("contextmenu", h));
    }, 0), p;
  }
  addPopupToPopupList(e, t, o, i) {
    this.popupList.push({
      element: e,
      wrapper: t,
      hideFunc: o,
      instanceId: Xt,
      isAnchored: !!i
    }), i && this.setPopupPositionRelatedToElement(e, i), Xt = Xt + 1;
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const o = this.getPopupIndex(e);
    if (o === -1)
      return;
    const i = this.popupList[o];
    if (i.stopAnchoringPromise && i.stopAnchoringPromise.then((n) => n && n()), i.stopAnchoringPromise = void 0, i.isAnchored = !1, !t)
      return;
    const s = this.keepPopupPositionedRelativeTo({
      element: t,
      ePopup: e,
      hidePopup: i.hideFunc
    });
    return i.stopAnchoringPromise = s, i.isAnchored = !0, s;
  }
  removePopupFromPopupList(e, t) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), t && Ds(t, null), this.popupList = this.popupList.filter((o) => o.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), o = t.getBoundingClientRect(), { element: i, ePopup: s } = e, n = i.getBoundingClientRect(), r = (u) => Number.parseInt(u.substring(0, u.length - 1), 10), l = (u, h) => {
      const g = o[u] - n[u], p = r(s.style[u]);
      return {
        initialDiff: g,
        lastDiff: g,
        initial: p,
        last: p,
        direction: h
      };
    }, a = l(
      "top",
      0
      /* Vertical */
    ), d = l(
      "left",
      1
      /* Horizontal */
    ), c = this.beans.frameworkOverrides;
    return new _t((u) => {
      c.wrapIncoming(() => {
        Ed(() => {
          const h = t.getBoundingClientRect(), g = i.getBoundingClientRect();
          if (g.top == 0 && g.left == 0 && g.height == 0 && g.width == 0) {
            e.hidePopup();
            return;
          }
          const f = (C, m) => {
            const v = r(s.style[m]);
            C.last !== v && (C.initial = v, C.last = v);
            const S = h[m] - g[m];
            if (S != C.lastDiff) {
              const D = this.keepXYWithinBounds(
                s,
                C.initial + C.initialDiff - S,
                C.direction
              );
              s.style[m] = `${D}px`, C.last = D;
            }
            C.lastDiff = S;
          };
          f(a, "top"), f(d, "left");
        }, 200).then((h) => {
          u(() => {
            h != null && window.clearInterval(h);
          });
        });
      }, "popupPositioning");
    });
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: o, touchEvent: i } = e, s = o || i;
    if (!s)
      return !1;
    const n = this.getPopupIndex(t);
    if (n === -1)
      return !1;
    for (let r = n; r < this.popupList.length; r++) {
      const l = this.popupList[r];
      if (fa(l.element, s))
        return !0;
    }
    return this.isElementWithinCustomPopup(s.target);
  }
  isElementWithinCustomPopup(e) {
    const t = j(this.beans);
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const o = this.getWrapper(e);
    o && (o.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(o));
  }
  /** @returns true if moved */
  bringPopupToFront(e) {
    const t = this.getPopupParent(), o = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), i = o.length, s = this.getWrapper(e);
    if (!s || i <= 1 || !t.contains(e))
      return;
    const n = [], r = [];
    for (const h of o)
      h !== s && (h.classList.contains("ag-always-on-top") ? r.push(h) : n.push(h));
    const l = [], a = r.length, u = s.classList.contains("ag-always-on-top") || !a ? [...n, ...r, s] : [...n, s, ...r];
    for (let h = 0; h <= i; h++) {
      const g = u[h];
      if (o[h] === u[h] || g === s)
        continue;
      const p = g.querySelectorAll("div");
      for (const f of p)
        f.scrollTop !== 0 && l.push([f, f.scrollTop]);
      h === 0 ? t.insertAdjacentElement("afterbegin", g) : u[h - 1].insertAdjacentElement("afterend", g);
    }
    for (; l.length; ) {
      const h = l.pop();
      h[0].scrollTop = h[1];
    }
  }
}, Ir = (e, t) => {
  if (t != null && e?.setPointerCapture)
    try {
      return e.setPointerCapture(t), e.hasPointerCapture(t);
    } catch {
    }
  return !1;
}, ru = (e, t) => {
  if (typeof PointerEvent > "u" || !(t instanceof PointerEvent))
    return null;
  const o = t.pointerId;
  if (!Ir(e, o))
    return null;
  const i = {
    eElement: e,
    pointerId: o,
    onLost(s) {
      au(i, s);
    }
  };
  return e.addEventListener("lostpointercapture", i.onLost), i;
}, lu = (e) => {
  if (!e)
    return;
  kr(e);
  const { eElement: t, pointerId: o } = e;
  if (t) {
    try {
      t.releasePointerCapture(o);
    } catch {
    }
    e.eElement = null;
  }
}, kr = (e) => {
  const { eElement: t, onLost: o } = e;
  t && o && (t.removeEventListener("lostpointercapture", o), e.onLost = null);
}, au = (e, t) => {
  kr(e);
  const { eElement: o, pointerId: i } = e;
  o && t.pointerId === i && Ir(o, i);
}, Ye, et, we = (e) => {
  if (!et)
    et = /* @__PURE__ */ new WeakSet();
  else if (et.has(e))
    return !1;
  return et.add(e), !0;
}, du = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "dragSvc", this.dragging = !1, this.drag = null, this.dragSources = [];
  }
  get startTarget() {
    return this.drag?.start.target ?? null;
  }
  /** True if there is at least one active pointer drag in any BaseDragService instance in the page */
  isPointer() {
    return !!Ye?.has(ge(this.beans));
  }
  hasPointerCapture() {
    const e = this.drag?.pointerCapture;
    return !!(e && this.beans.eRootDiv.hasPointerCapture?.(e.pointerId));
  }
  destroy() {
    this.drag && this.cancelDrag();
    const e = this.dragSources;
    for (const t of e)
      js(t);
    e.length = 0, super.destroy();
  }
  removeDragSource(e) {
    const t = this.dragSources;
    for (let o = 0, i = t.length; o < i; ++o) {
      const s = t[o];
      if (s.params === e) {
        t.splice(o, 1), js(s);
        break;
      }
    }
  }
  addDragSource(e) {
    if (!this.isAlive())
      return;
    const { eElement: t, includeTouch: o } = e, i = [];
    let s;
    if (o) {
      const d = t.style;
      d && (s = d.touchAction, d.touchAction = "none");
    }
    const n = { handlers: i, params: e, oldTouchAction: s };
    this.dragSources.push(n), lo(
      i,
      [t, "pointerdown", (d) => this.onPointerDown(e, d), { passive: !1 }],
      [t, "mousedown", (d) => this.onMouseDown(e, d)]
    );
    const a = this.gos.get("suppressTouch");
    o && !a && lo(i, [t, "touchstart", (c) => this.onTouchStart(e, c), { passive: !1 }]);
  }
  cancelDrag(e) {
    const t = this.drag;
    e ?? (e = t?.eElement), e && this.eventSvc.dispatchEvent({ type: "dragCancelled", target: e }), t?.params.onDragCancel?.(), this.destroyDrag();
  }
  shouldPreventMouseEvent(e) {
    const t = e.type;
    return (t === "mousemove" || t === "pointermove") && e.cancelable && Bt(this.beans, e) && !At(ti(e));
  }
  initDrag(e, ...t) {
    this.drag = e;
    const o = this.beans, i = (l) => this.onScroll(l), s = (l) => this.onKeyDown(l), n = ge(o), r = j(o);
    lo(
      e.handlers,
      [n, "contextmenu", Fe],
      [n, "keydown", s],
      [r, "scroll", i, { capture: !0 }],
      [r.defaultView || window, "scroll", i],
      ...t
    );
  }
  destroyDrag() {
    this.dragging = !1;
    const e = this.drag;
    if (e) {
      const t = e.rootEl;
      Ye?.get(t) === e && Ye?.delete(t), this.drag = null, lu(e.pointerCapture), es(e.handlers);
    }
  }
  // Pointer Events path (preferred when supported)
  onPointerDown(e, t) {
    if (this.isPointer())
      return;
    const o = this.beans;
    if (et?.has(t))
      return;
    const i = t.pointerType;
    if (i === "touch" && (o.gos.get("suppressTouch") || !e.includeTouch || (e.stopPropagationForTouch && t.stopPropagation(), At(ti(t)))) || !t.isPrimary || i === "mouse" && t.button !== 0)
      return;
    this.destroyDrag();
    const s = ge(o), n = e.eElement, r = t.pointerId, l = new ei(s, e, t, r);
    Ye ?? (Ye = /* @__PURE__ */ new WeakMap()), Ye.set(s, l);
    const a = (u) => {
      u.pointerId === r && this.onMouseOrPointerMove(u);
    }, d = (u) => {
      u.pointerId === r && this.onMouseOrPointerUp(u);
    }, c = (u) => {
      u.pointerId === r && we(u) && this.cancelDrag();
    };
    this.initDrag(
      l,
      [s, "pointerup", d],
      [s, "pointercancel", c],
      [s, "pointermove", a, { passive: !1 }],
      [s, "touchmove", Fe, { passive: !1 }],
      [n, "mousemove", Fe, { passive: !1 }]
    ), e.dragStartPixels === 0 ? this.onMouseOrPointerMove(t) : we(t);
  }
  // gets called whenever mouse down on any drag source
  onTouchStart(e, t) {
    if (this.gos.get("suppressTouch") || !e.includeTouch || !we(t) || At(ti(t)))
      return;
    if (e.stopPropagationForTouch && t.stopPropagation(), this.isPointer()) {
      Fe(t);
      return;
    }
    this.destroyDrag();
    const i = this.beans, s = ge(i), n = new ei(s, e, t.touches[0]), r = (d) => this.onTouchMove(d), l = (d) => this.onTouchUp(d), a = t.target ?? e.eElement;
    this.initDrag(
      n,
      [ge(i), "touchmove", Fe, { passive: !1 }],
      [a, "touchmove", r, { passive: !0 }],
      [a, "touchend", l, { passive: !0 }],
      [a, "touchcancel", l, { passive: !0 }]
    ), e.dragStartPixels === 0 && this.onMove(n.start);
  }
  // gets called whenever mouse down on any drag source
  onMouseDown(e, t) {
    if (t.button !== 0 || et?.has(t) || this.isPointer())
      return;
    const o = this.beans;
    this.destroyDrag();
    const i = new ei(ge(o), e, t), s = (l) => this.onMouseOrPointerMove(l), n = (l) => this.onMouseOrPointerUp(l), r = ge(o);
    this.initDrag(i, [r, "mousemove", s], [r, "mouseup", n]), e.dragStartPixels === 0 ? this.onMouseOrPointerMove(t) : we(t);
  }
  onScroll(e) {
    if (!we(e))
      return;
    const t = this.drag, o = t?.lastDrag;
    o && this.dragging && t.params?.onDragging(o);
  }
  /** only gets called after a mouse down - as this is only added after mouseDown and is removed when mouseUp happens */
  onMouseOrPointerMove(e) {
    we(e) && (ls() && j(this.beans).getSelection()?.removeAllRanges(), this.shouldPreventMouseEvent(e) && Fe(e), this.onMove(e));
  }
  onTouchMove(e) {
    const t = this.drag;
    if (!t || !we(e))
      return;
    const o = Mt(t.start, e.touches);
    o && (e.preventDefault(), this.onMove(o));
  }
  onMove(e) {
    const t = this.drag;
    if (!t)
      return;
    t.lastDrag = e;
    const o = t.params;
    if (!this.dragging) {
      const i = t.start, n = o.dragStartPixels ?? 4;
      if (Vn(e, i, n) || (this.dragging = !0, o.capturePointer && (t.pointerCapture = ru(this.beans.eRootDiv, e)), this.eventSvc.dispatchEvent({
        type: "dragStarted",
        target: o.eElement
      }), o.onDragStart(i), this.drag !== t) || (o.onDragging(i), this.drag !== t))
        return;
    }
    o.onDragging(e);
  }
  onTouchUp(e) {
    const t = this.drag;
    t && we(e) && this.onUp(Mt(t.start, e.changedTouches));
  }
  onMouseOrPointerUp(e) {
    we(e) && this.onUp(e);
  }
  onUp(e) {
    const t = this.drag;
    t && (e || (e = t.lastDrag), e && this.dragging && (this.dragging = !1, t.params.onDragStop(e), this.eventSvc.dispatchEvent({
      type: "dragStopped",
      target: t.params.eElement
    })), this.destroyDrag());
  }
  // shared keydown handler to cancel current drag with ESC
  onKeyDown(e) {
    e.key === w.ESCAPE && this.cancelDrag();
  }
}, js = (e) => {
  es(e.handlers);
  const t = e.oldTouchAction;
  if (t != null) {
    const o = e.params.eElement.style;
    o && (o.touchAction = t);
  }
}, ei = class {
  constructor(e, t, o, i = null) {
    this.rootEl = e, this.params = t, this.start = o, this.pointerId = i, this.handlers = [], this.lastDrag = null, this.pointerCapture = null, this.eElement = t.eElement;
  }
}, ti = (e) => {
  const t = e.target;
  return t instanceof Element ? t : null;
}, cu = class extends Ge {
  constructor() {
    super(...arguments), this.beanName = "dragAndDrop", this.dragSourceAndParamsList = [], this.dragItem = null, this.dragInitialSourcePointerOffsetX = 0, this.dragInitialSourcePointerOffsetY = 0, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.dragSource = null, this.dragImageParent = null, this.dragImageCompPromise = null, this.dragImageComp = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.dropTargets = [], this.lastDropTarget = null;
  }
  addDragSource(e, t = !1) {
    const o = {
      capturePointer: !0,
      dragSource: e,
      eElement: e.eElement,
      dragStartPixels: e.dragStartPixels,
      onDragStart: (i) => this.onDragStart(e, i),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      includeTouch: t
    };
    this.dragSourceAndParamsList.push(o), this.beans.dragSvc.addDragSource(o);
  }
  setDragImageCompIcon(e, t = !1) {
    const o = this.dragImageComp;
    o && (t || this.dragImageLastIcon !== e) && (this.dragImageLastIcon = e, o.setIcon(e, t));
  }
  removeDragSource(e) {
    const { dragSourceAndParamsList: t, beans: o } = this, i = t.find((s) => s.dragSource === e);
    i && (o.dragSvc?.removeDragSource(i), Pe(t, i));
  }
  destroy() {
    const { dragSourceAndParamsList: e, dropTargets: t, beans: o } = this, i = o.dragSvc;
    for (const s of e)
      i?.removeDragSource(s);
    e.length = 0, t.length = 0, this.clearDragAndDropProperties(), super.destroy();
  }
  nudge() {
    const e = this.lastMouseEvent;
    e && this.onDragging(e, !0);
  }
  onDragStart(e, t) {
    this.lastMouseEvent = t, this.dragSource = e, this.dragItem = e.getDragItem();
    const o = e.eElement.getBoundingClientRect();
    this.dragInitialSourcePointerOffsetX = t.clientX - o.left, this.dragInitialSourcePointerOffsetY = t.clientY - o.top, e.onDragStarted?.(), this.createAndUpdateDragImageComp(e);
  }
  onDragStop(e) {
    const { dragSource: t, lastDropTarget: o } = this;
    if (t?.onDragStopped?.(), o) {
      const i = this.dropTargetEvent(o, e, !1);
      o.onDragStop?.(i);
    }
    this.clearDragAndDropProperties();
  }
  onDragCancel() {
    const { dragSource: e, lastDropTarget: t, lastMouseEvent: o } = this;
    if (e?.onDragCancelled?.(), t && o) {
      const i = this.dropTargetEvent(t, o, !1);
      t.onDragCancel?.(i);
    }
    this.clearDragAndDropProperties();
  }
  onDragging(e, t = !1) {
    this.positionDragImageComp(e);
    const o = this.findCurrentDropTarget(e), { lastDropTarget: i, dragSource: s, dragItem: n } = this;
    let r = !1;
    if (o !== i) {
      if (r = !0, i) {
        const l = this.dropTargetEvent(i, e, t);
        i.onDragLeave?.(l);
      }
      if (i !== null && !o ? this.handleExit(s, n) : i === null && o && this.handleEnter(s, n), o) {
        const l = this.dropTargetEvent(o, e, t);
        o.onDragEnter?.(l);
      }
      this.lastDropTarget = o;
    } else if (o) {
      const l = this.dropTargetEvent(o, e, t);
      o.onDragging?.(l), l?.changed && (r = !0);
    }
    this.lastMouseEvent = e, r && this.updateDragImageComp();
  }
  clearDragAndDropProperties() {
    this.removeDragImageComp(this.dragImageComp), this.dragImageCompPromise = null, this.dragImageParent = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.lastDropTarget = null, this.dragItem = null, this.dragInitialSourcePointerOffsetX = 0, this.dragInitialSourcePointerOffsetY = 0, this.dragSource = null;
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, o = [[e.getContainer()]];
    return t ? o.concat(t) : o;
  }
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  isMouseOnDropTarget(e, t) {
    const o = this.getAllContainersFromDropTarget(t);
    let i = !1;
    const s = (l, a) => {
      for (const d of a) {
        const { width: c, height: u, left: h, right: g, top: p, bottom: f } = d.getBoundingClientRect();
        if (c === 0 || u === 0)
          return !1;
        const C = l.clientX >= h && l.clientX < g, m = l.clientY >= p && l.clientY < f;
        if (!C || !m)
          return !1;
      }
      return !0;
    };
    for (const l of o)
      if (s(e, l)) {
        i = !0;
        break;
      }
    const { eElement: n, type: r } = this.dragSource;
    return t.targetContainsSource && !t.getContainer().contains(n) ? !1 : i && t.isInterestedIn(r, n);
  }
  findCurrentDropTarget(e) {
    const t = this.dropTargets.filter((n) => this.isMouseOnDropTarget(e, n)), o = t.length;
    if (o === 0)
      return null;
    if (o === 1)
      return t[0];
    const s = ge(this.beans).elementsFromPoint(e.clientX, e.clientY);
    for (const n of s)
      for (const r of t)
        if (this.getAllContainersFromDropTarget(r).flatMap((a) => a).indexOf(n) !== -1)
          return r;
    return null;
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.find((t) => t.external && t.getContainer() === e) || null;
  }
  dropTargetEvent(e, t, o) {
    const {
      dragSource: i,
      dragItem: s,
      lastDraggingEvent: n,
      lastMouseEvent: r,
      dragInitialSourcePointerOffsetX: l,
      dragInitialSourcePointerOffsetY: a
    } = this, d = e.getContainer(), c = d.getBoundingClientRect(), { clientX: u, clientY: h } = t, g = u - (r?.clientX || 0), p = h - (r?.clientY || 0), f = this.createEvent({
      event: t,
      x: u - c.left,
      // relative x
      y: h - c.top,
      // relative y
      vDirection: p > 0 ? "down" : p < 0 ? "up" : null,
      hDirection: g < 0 ? "left" : g > 0 ? "right" : null,
      initialSourcePointerOffsetX: l,
      initialSourcePointerOffsetY: a,
      dragSource: i,
      fromNudge: o,
      dragItem: s,
      dropZoneTarget: d,
      dropTarget: n?.dropTarget ?? null,
      // updated by rowDragFeature
      changed: !!n?.changed
    });
    return this.lastDraggingEvent = f, f;
  }
  positionDragImageComp(e) {
    const t = this.dragImageComp?.getGui();
    t && Sa(t, e, this.beans);
  }
  removeDragImageComp(e) {
    this.dragImageComp === e && (this.dragImageComp = null), e && (e.getGui()?.remove(), this.destroyBean(e));
  }
  createAndUpdateDragImageComp(e) {
    const t = this.createDragImageComp(e) ?? null;
    this.dragImageCompPromise = t, t?.then((o) => {
      if (t !== this.dragImageCompPromise || !this.lastMouseEvent || !this.isAlive()) {
        this.destroyBean(o);
        return;
      }
      this.dragImageCompPromise = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0;
      const i = this.dragImageComp;
      i !== o && (this.dragImageComp = o, this.removeDragImageComp(i)), o && (this.appendDragImageComp(o), this.updateDragImageComp());
    });
  }
  appendDragImageComp(e) {
    const t = e.getGui(), o = t.style;
    o.position = "absolute", o.zIndex = "9999", this.beans.dragSvc?.hasPointerCapture() && (o.pointerEvents = "none"), this.gos.setInstanceDomData(t), this.beans.environment.applyThemeClasses(t), o.top = "20px", o.left = "20px";
    const i = ji(this.beans);
    this.dragImageParent = i, i ? i.appendChild(t) : this.warnNoBody();
  }
  updateDragImageComp() {
    const { dragImageComp: e, dragSource: t, lastDropTarget: o, lastDraggingEvent: i, dragImageLastLabel: s } = this;
    if (!e)
      return;
    this.setDragImageCompIcon(o?.getIconName?.(i) ?? null);
    let n = t?.dragItemName;
    typeof n == "function" && (n = n(i)), n || (n = ""), s !== n && (this.dragImageLastLabel = n, e.setLabel(n));
  }
}, uu = class extends cu {
  createEvent(e) {
    return L(this.gos, e);
  }
  createDragImageComp(e) {
    const { gos: t, beans: o } = this;
    return $d(
      o.userCompFactory,
      L(t, {
        dragSource: e
      })
    )?.newAgStackInstance();
  }
  handleEnter(e, t) {
    e?.onGridEnter?.(t);
  }
  handleExit(e, t) {
    e?.onGridExit?.(t);
  }
  warnNoBody() {
    F(54);
  }
  isDropZoneWithinThisGrid(e) {
    return this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.contains(e.dropZoneTarget);
  }
  registerGridDropTarget(e, t) {
    const o = {
      getContainer: e,
      isInterestedIn: (i) => i === 1 || i === 0,
      getIconName: () => "notAllowed"
    };
    this.addDropTarget(o), t.addDestroyFunc(() => this.removeDropTarget(o));
  }
};
function Lr(e, t) {
  return e + "_" + t;
}
function B(e) {
  return e instanceof Ut;
}
var Ut = class extends b {
  constructor(e, t, o, i) {
    super(), this.providedColumnGroup = e, this.groupId = t, this.partId = o, this.pinned = i, this.isColumn = !1, this.displayedChildren = [], this.autoHeaderHeight = null, this.parent = null, this.colIdSanitised = Et(this.getUniqueId());
  }
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  getUniqueId() {
    return Lr(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const e = this.getProvidedColumnGroup().getLeafColumns();
    return !e || e.length === 0 ? !1 : e.every((t) => t.isMoving());
  }
  checkLeft() {
    for (const e of this.displayedChildren)
      B(e) && e.checkLeft();
    if (this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const t = G(this.displayedChildren).getLeft();
        this.setLeft(t);
      } else {
        const e = this.displayedChildren[0].getLeft();
        this.setLeft(e);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(e) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchLocalEvent({ type: "leftChanged" }));
  }
  getPinned() {
    return this.pinned;
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  getActualWidth() {
    let e = 0;
    for (const t of this.displayedChildren ?? [])
      e += t.getActualWidth();
    return e;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let e = !1;
    for (const t of this.displayedChildren)
      t.isResizable() && (e = !0);
    return e;
  }
  getMinWidth() {
    let e = 0;
    for (const t of this.displayedChildren)
      e += t.getMinWidth();
    return e;
  }
  addChild(e) {
    this.children || (this.children = []), this.children.push(e);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  getDisplayedLeafColumns() {
    const e = [];
    return this.addDisplayedLeafColumns(e), e;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(e) {
    this.providedColumnGroup.setExpanded(e);
  }
  isAutoHeaderHeight() {
    return !!this.getColGroupDef()?.autoHeaderHeight;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  addDisplayedLeafColumns(e) {
    for (const t of this.displayedChildren ?? [])
      Ke(t) ? e.push(t) : B(t) && t.addDisplayedLeafColumns(e);
  }
  addLeafColumns(e) {
    for (const t of this.children ?? [])
      Ke(t) ? e.push(t) : B(t) && t.addLeafColumns(e);
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const e = this.getParent();
    return !this.isPadding() || !e?.isPadding() ? 0 : 1 + e.getPaddingLevel();
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let e = this;
    for (; e?.isPadding(); )
      e = e.getParent();
    if (!(e ? e.getProvidedColumnGroup().isExpandable() : !1)) {
      this.displayedChildren = this.children, this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
      return;
    }
    for (const o of this.children ?? []) {
      if (B(o) && !o.displayedChildren?.length)
        continue;
      switch (o.getColumnGroupShow()) {
        case "open":
          e.getProvidedColumnGroup().isExpanded() && this.displayedChildren.push(o);
          break;
        case "closed":
          e.getProvidedColumnGroup().isExpanded() || this.displayedChildren.push(o);
          break;
        default:
          this.displayedChildren.push(o);
          break;
      }
    }
    this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
  }
}, Vi = "row-group-", hu = "t-", gu = "b-", pu = 0, us = class {
  constructor(e) {
    this.master = !1, this.detail = void 0, this.rowIndex = null, this.key = null, this.sourceRowIndex = -1, this._leafs = void 0, this.childrenMapped = null, this.treeParent = null, this.treeNodeFlags = 0, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = pu++, this.alreadyRendered = !1, this.hovered = !1, this.__selected = !1, this.beans = e;
  }
  /** CSRM only - do not use this property internally, this is exposed to the end user only. Use `_leafs` instead. */
  get allLeafChildren() {
    const e = this._leafs;
    return e === void 0 ? this.beans.groupStage?.loadLeafs?.(this) ?? null : e;
  }
  set allLeafChildren(e) {
    this._leafs = e;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  setData(e) {
    this.setDataCommon(e, !1);
  }
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
  /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  updateData(e) {
    this.setDataCommon(e, !0);
  }
  setDataCommon(e, t) {
    const { valueCache: o, eventSvc: i } = this.beans, s = this.data;
    this.data = e, o?.onDataChanged(), this.updateDataOnDetailNode(), this.resetQuickFilterAggregateText();
    const n = this.createDataChangedEvent(e, s, t);
    if (this.__localEventService?.dispatchEvent(n), this.sibling) {
      this.sibling.data = e;
      const l = this.sibling.createDataChangedEvent(e, s, t);
      this.sibling.__localEventService?.dispatchEvent(l);
    }
    i.dispatchEvent({ type: "rowNodeDataChanged", node: this });
    const r = this.pinnedSibling;
    r && (r.data = e, r.__localEventService?.dispatchEvent(
      r.createDataChangedEvent(e, s, t)
    ), i.dispatchEvent({ type: "rowNodeDataChanged", node: r }));
  }
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  updateDataOnDetailNode() {
    const e = this.detailNode;
    e && (e.data = this.data);
  }
  createDataChangedEvent(e, t, o) {
    return {
      type: "dataChanged",
      node: this,
      oldData: t,
      newData: e,
      update: o
    };
  }
  getRowIndexString() {
    return this.rowIndex == null ? (W(13), null) : this.rowPinned === "top" ? hu + this.rowIndex : this.rowPinned === "bottom" ? gu + this.rowIndex : this.rowIndex.toString();
  }
  setDataAndId(e, t) {
    const { selectionSvc: o } = this.beans, i = o?.createDaemonNode?.(this), s = this.data;
    this.data = e, this.updateDataOnDetailNode(), this.setId(t), o && (o.updateRowSelectable(this), o.syncInRowNode(this, i));
    const n = this.createDataChangedEvent(e, s, !1);
    this.__localEventService?.dispatchEvent(n);
  }
  setId(e) {
    const t = Ei(this.beans.gos);
    if (t)
      if (this.data) {
        const o = this.parent?.getRoute() ?? [];
        this.id = t({
          data: this.data,
          parentKeys: o.length > 0 ? o : void 0,
          level: this.level,
          rowPinned: this.rowPinned
        }), this.id.startsWith(Vi) && W(14, {
          groupPrefix: Vi
        });
      } else
        this.id = void 0;
    else
      this.id = e;
  }
  setRowTop(e) {
    if (this.oldRowTop = this.rowTop, this.rowTop === e)
      return;
    this.rowTop = e, this.dispatchRowEvent("topChanged");
    const t = e !== null;
    this.displayed !== t && (this.displayed = t, this.dispatchRowEvent("displayedChanged"));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setHovered(e) {
    this.hovered = e;
  }
  isHovered() {
    return this.hovered;
  }
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  setRowHeight(e, t = !1) {
    this.rowHeight = e, this.rowHeightEstimated = t, this.dispatchRowEvent("heightChanged");
  }
  setExpanded(e, t, o) {
    this.beans.expansionSvc?.setExpanded(this, e, t, o);
  }
  /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */
  setDataValue(e, t, o) {
    const { colModel: i, valueSvc: s, gos: n, editSvc: r } = this.beans, l = typeof e != "string" ? e : i.getCol(e) ?? i.getColDefCol(e);
    if (!l)
      return !1;
    const a = s.getValueForDisplay(l, this, void 0, void 0, "api").value;
    if (n.get("readOnlyEdit")) {
      const {
        beans: { eventSvc: c },
        data: u,
        rowIndex: h,
        rowPinned: g
      } = this;
      return c.dispatchEvent({
        type: "cellEditRequest",
        event: null,
        rowIndex: h,
        rowPinned: g,
        column: l,
        colDef: l.colDef,
        data: u,
        node: this,
        oldValue: a,
        newValue: t,
        value: t,
        source: o
      }), !1;
    }
    if (r && !r.committing) {
      const c = r.setDataValue({ rowNode: this, column: l }, t, o);
      if (c != null)
        return c;
    }
    const d = s.setValue(this, l, t, o);
    return this.dispatchCellChangedEvent(l, t, a), d && this.pinnedSibling?.dispatchCellChangedEvent(l, t, a), d;
  }
  updateHasChildren() {
    let e = this.group && !this.footer || !!this.childrenAfterGroup?.length;
    const { rowChildrenSvc: t } = this.beans;
    t && (e = t.getHasChildrenValue(this)), e !== this.__hasChildren && (this.__hasChildren = !!e, this.dispatchRowEvent("hasChildrenChanged"));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  dispatchCellChangedEvent(e, t, o) {
    const i = {
      type: "cellChanged",
      node: this,
      column: e,
      newValue: t,
      oldValue: o
    };
    this.__localEventService?.dispatchEvent(i);
  }
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */
  isExpandable() {
    return this.beans.expansionSvc?.isExpandable(this) ?? !1;
  }
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  isSelected() {
    if (this.footer)
      return this.sibling.isSelected();
    const e = this.rowPinned && this.pinnedSibling;
    return e ? e.isSelected() : this.__selected;
  }
  /** Perform a depth-first search of this node and its children. */
  depthFirstSearch(e) {
    const t = this.childrenAfterGroup;
    if (t)
      for (let o = 0, i = t.length; o < i; ++o)
        t[o].depthFirstSearch(e);
    e(this);
  }
  dispatchRowEvent(e) {
    this.__localEventService?.dispatchEvent({
      type: e,
      node: this
    });
  }
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */
  setSelected(e, t = !1, o = "api") {
    this.beans.selectionSvc?.setNodesSelected({
      nodes: [this],
      newValue: e,
      clearSelection: t,
      source: o
    });
  }
  /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */
  isRowPinned() {
    return !!this.rowPinned;
  }
  __addEventListener(e, t) {
    (this.__localEventService ?? (this.__localEventService = new $e())).addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.removeLocalListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    this.beans.validation?.checkRowEvents(e);
    const o = this.__localEventService ?? (this.__localEventService = new $e());
    this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(
      this.frameworkEventListenerService,
      o
    );
    const i = this.frameworkEventListenerService?.wrap(e, t) ?? t;
    o.addEventListener(e, i);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    const o = this.frameworkEventListenerService?.unwrap(e, t) ?? t;
    this.removeLocalListener(e, o);
  }
  removeLocalListener(e, t) {
    const o = this.__localEventService;
    o && (o.removeEventListener(e, t), o.noRegisteredListenersExist() && (this.__localEventService = null));
  }
  /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */
  isFullWidthCell() {
    if (F(61), this.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this }) : !1;
  }
  /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */
  getRoute() {
    if (this.level === -1)
      return [];
    if (this.key == null)
      return;
    const e = [];
    let t = this;
    for (; t?.key != null; )
      e.push(t.key), t = t.parent;
    return e.reverse();
  }
  setRowIndex(e) {
    this.rowIndex !== e && (this.rowIndex = e, this.dispatchRowEvent("rowIndexChanged"));
  }
  setAllChildrenCount(e) {
    this.allChildrenCount !== e && (this.allChildrenCount = e, this.dispatchRowEvent("allChildrenCountChanged"));
  }
  setUiLevel(e) {
    this.uiLevel !== e && (this.uiLevel = e, this.dispatchRowEvent("uiLevelChanged"));
  }
  getFirstChild() {
    const e = this.childStore;
    return e ? e.getFirstNode() : this.childrenAfterSort?.[0] ?? null;
  }
};
function fu(e, t, o) {
  return L(t, {
    type: o,
    node: e,
    data: e.data,
    rowIndex: e.rowIndex,
    rowPinned: e.rowPinned
  });
}
var Cu = (e) => {
  for (; e?.length; ) {
    const t = e[0];
    if (t.data)
      return t;
    e = t.childrenAfterGroup;
  }
}, mu = {
  agSetColumnFilter: "agSetColumnFilterHandler",
  agMultiColumnFilter: "agMultiColumnFilterHandler",
  agGroupColumnFilter: "agGroupColumnFilterHandler",
  agNumberColumnFilter: "agNumberColumnFilterHandler",
  agDateColumnFilter: "agDateColumnFilterHandler",
  agTextColumnFilter: "agTextColumnFilterHandler"
};
new Set(Object.values(mu));
function ie(e) {
  return jt(e);
}
var Gr = "__ag_Grid_Stop_Propagation";
function Ct(e) {
  e[Gr] = !0;
}
function xe(e) {
  return e[Gr] === !0;
}
var vu = "ag-focus-managed", _o = class extends b {
  constructor(e, t = {}) {
    super(), this.eFocusable = e, this.callbacks = t, this.callbacks = {
      shouldStopEventPropagation: () => !1,
      onTabKeyDown: (o) => {
        if (o.defaultPrevented)
          return;
        const i = qt(this.beans, this.eFocusable, !1, o.shiftKey);
        i && (i.focus(), o.preventDefault());
      },
      ...t
    };
  }
  postConstruct() {
    const {
      eFocusable: e,
      callbacks: { onFocusIn: t, onFocusOut: o }
    } = this;
    e.classList.add(vu), this.addKeyDownListeners(e), t && this.addManagedElementListeners(e, { focusin: t }), o && this.addManagedElementListeners(e, { focusout: o });
  }
  addKeyDownListeners(e) {
    this.addManagedElementListeners(e, {
      keydown: (t) => {
        if (t.defaultPrevented || xe(t))
          return;
        const { callbacks: o } = this;
        if (o.shouldStopEventPropagation(t)) {
          Ct(t);
          return;
        }
        t.key === w.TAB ? o.onTabKeyDown(t) : o.handleKeyDown && o.handleKeyDown(t);
      }
    });
  }
}, ae = {
  AUTO_HEIGHT: "ag-layout-auto-height",
  NORMAL: "ag-layout-normal",
  PRINT: "ag-layout-print"
}, hs = class extends b {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.gos.get("domLayout"), t = {
      autoHeight: e === "autoHeight",
      normal: e === "normal",
      print: e === "print"
    }, o = t.autoHeight ? ae.AUTO_HEIGHT : t.print ? ae.PRINT : ae.NORMAL;
    this.view.updateLayoutClasses(o, t);
  }
}, De = "Viewport", qs = "fakeVScrollComp", oi = [
  "fakeHScrollComp",
  "centerHeader",
  "topCenter",
  "bottomCenter",
  "stickyTopCenter",
  "stickyBottomCenter"
], Ys = 100, ii = 150, wu = class extends b {
  constructor(e) {
    super(), this.clearRetryListenerFncs = [], this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.lastIsHorizontalScrollShowing = !1, this.scrollTimer = 0, this.isScrollActive = !1, this.isVerticalPositionInvalidated = !0, this.isHorizontalPositionInvalidated = !0, this.eBodyViewport = e, this.resetLastHScrollDebounced = We(
      this,
      () => this.lastScrollSource[
        1
        /* Horizontal */
      ] = null,
      ii
    ), this.resetLastVScrollDebounced = We(
      this,
      () => this.lastScrollSource[
        0
        /* Vertical */
      ] = null,
      ii
    );
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.animationFrameSvc = e.animationFrameSvc, this.visibleCols = e.visibleCols;
  }
  destroy() {
    super.destroy(), this.clearRetryListenerFncs = [], window.clearTimeout(this.scrollTimer);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl");
    const e = this.invalidateVerticalScroll.bind(this), t = this.invalidateHorizontalScroll.bind(this);
    this.addManagedEventListeners({
      displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
      bodyHeightChanged: e,
      // We only invalidate horizontal scrolling when the viewport switches
      // between scrollable and non-scrollable, avoiding unnecessary
      // invalidation on every gridSizeChanged event. If more properties
      // require invalidation, read/write DOM cycles may be needed.
      scrollGapChanged: t
    }), this.addManagedElementListeners(this.eBodyViewport, {
      scroll: e
    }), this.ctrlsSvc.whenReady(this, (o) => {
      this.centerRowsCtrl = o.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  invalidateHorizontalScroll() {
    this.isHorizontalPositionInvalidated = !0;
  }
  invalidateVerticalScroll() {
    this.isVerticalPositionInvalidated = !0;
  }
  addScrollListener() {
    this.addHorizontalScrollListeners(), this.addVerticalScrollListeners();
  }
  addHorizontalScrollListeners() {
    this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
      scroll: this.onHScroll.bind(this, De)
    });
    for (const e of oi) {
      const t = this.ctrlsSvc.get(e);
      this.registerScrollPartner(t, this.onHScroll.bind(this, e));
    }
  }
  addVerticalScrollListeners() {
    const e = this.ctrlsSvc.get("fakeVScrollComp"), t = this.gos.get("debounceVerticalScrollbar"), o = t ? We(this, this.onVScroll.bind(this, De), Ys) : this.onVScroll.bind(this, De), i = t ? We(this, this.onVScroll.bind(this, qs), Ys) : this.onVScroll.bind(this, qs);
    this.addManagedElementListeners(this.eBodyViewport, { scroll: o }), this.registerScrollPartner(e, i);
  }
  registerScrollPartner(e, t) {
    e.onScrollCallback(t);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    this.centerRowsCtrl != null && (e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft()), this.setScrollLeftForAllContainersExceptCurrent(Math.abs(e)));
  }
  setScrollLeftForAllContainersExceptCurrent(e) {
    for (const t of [...oi, De]) {
      if (this.lastScrollSource[
        1
        /* Horizontal */
      ] === t)
        continue;
      const o = this.getViewportForSource(t);
      wo(o, e, this.enableRtl);
    }
  }
  getViewportForSource(e) {
    return e === De ? this.centerRowsCtrl.eViewport : this.ctrlsSvc.get(e).eViewport;
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (t === 0 ? this.lastScrollSource[0] = e : this.lastScrollSource[1] = e, !0) : this.lastScrollSource[t] === e;
  }
  onHScroll(e) {
    if (!this.isControllingScroll(
      e,
      1
      /* Horizontal */
    ))
      return;
    const t = this.centerRowsCtrl.eViewport, { scrollLeft: o } = t;
    if (this.shouldBlockScrollUpdate(1, o, !0))
      return;
    const i = vo(this.getViewportForSource(e), this.enableRtl);
    this.doHorizontalScroll(i), this.resetLastHScrollDebounced();
  }
  onVScroll(e) {
    if (!this.isControllingScroll(
      e,
      0
      /* Vertical */
    ))
      return;
    let t;
    if (e === De ? t = this.eBodyViewport.scrollTop : t = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition(), this.shouldBlockScrollUpdate(0, t, !0))
      return;
    const { animationFrameSvc: o } = this;
    o?.setScrollTop(t), this.nextScrollTop = t, e === De ? this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, o?.active ? o.schedule() : this.scrollGridIfNeeded(!0), this.resetLastVScrollDebounced();
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(
      1
      /* Horizontal */
    ), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  isScrolling() {
    return this.isScrollActive;
  }
  fireScrollEvent(e) {
    const t = {
      type: "bodyScroll",
      direction: e === 1 ? "horizontal" : "vertical",
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.isScrollActive = !0, this.eventSvc.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = window.setTimeout(() => {
      this.scrollTimer = 0, this.isScrollActive = !1, this.eventSvc.dispatchEvent({
        ...t,
        type: "bodyScrollEnd"
      });
    }, ii);
  }
  shouldBlockScrollUpdate(e, t, o = !1) {
    return o && !kt() ? !1 : e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t);
  }
  shouldBlockVerticalScroll(e) {
    const t = Yi(this.eBodyViewport), { scrollHeight: o } = this.eBodyViewport;
    return e < 0 || e + t > o;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: o } = this.centerRowsCtrl.eViewport;
    if (this.enableRtl) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > o;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(
      0
      /* Vertical */
    );
  }
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  checkScrollLeft() {
    const e = this.scrollLeft;
    let t = !1;
    for (const o of oi)
      if (this.getViewportForSource(o).scrollLeft !== e) {
        t = !0;
        break;
      }
    t && this.onHScroll(De);
  }
  scrollGridIfNeeded(e = !1) {
    const t = this.scrollTop != this.nextScrollTop;
    return t && (this.scrollTop = this.nextScrollTop, e && this.invalidateVerticalScroll(), this.redrawRowsAfterScroll()), t;
  }
  // called by scrollHorizontally method and alignedGridsService
  setHorizontalScrollPosition(e, t = !1) {
    const i = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (this.enableRtl ? e = e > 0 ? 0 : i : e = Math.min(Math.max(e, 0), i)), wo(this.centerRowsCtrl.eViewport, Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.invalidateVerticalScroll(), this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    if (!this.isVerticalPositionInvalidated) {
      const { lastOffsetHeight: o, lastScrollTop: i } = this;
      return {
        top: i,
        bottom: i + o
      };
    }
    this.isVerticalPositionInvalidated = !1;
    const { scrollTop: e, offsetHeight: t } = this.eBodyViewport;
    return this.lastScrollTop = e, this.lastOffsetHeight = t, {
      top: e,
      bottom: e + t
    };
  }
  /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
      top: this.scrollTop,
      bottom: this.scrollTop + this.lastOffsetHeight
    } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.isHorizontalPositionInvalidated && (this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing(), this.isHorizontalPositionInvalidated = !1), this.lastIsHorizontalScrollShowing;
  }
  // called by the headerRootComp and moveColumnController
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.eViewport.scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.eViewport.scrollLeft - t;
  }
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  // Valid values for position are bottom, middle and top
  ensureNodeVisible(e, t = null) {
    const { rowModel: o } = this.beans, i = o.getRowCount();
    let s = -1;
    for (let n = 0; n < i; n++) {
      const r = o.getRow(n);
      if (typeof e == "function") {
        if (r && e(r)) {
          s = n;
          break;
        }
      } else if (e === r || e === r.data) {
        s = n;
        break;
      }
    }
    s >= 0 && this.ensureIndexVisible(s, t);
  }
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  ensureIndexVisible(e, t, o = 0) {
    if (Y(this.gos, "print"))
      return;
    const { rowModel: i } = this.beans, s = i.getRowCount();
    if (typeof e != "number" || e < 0 || e >= s) {
      F(88, { index: e });
      return;
    }
    this.clearRetryListeners();
    const { frameworkOverrides: n, pageBounds: r, rowContainerHeight: l, rowRenderer: a } = this.beans;
    n.wrapIncoming(() => {
      const d = this.ctrlsSvc.getGridBodyCtrl(), c = i.getRow(e);
      let u, h, g = 0;
      this.invalidateVerticalScroll();
      do {
        const { stickyTopHeight: p, stickyBottomHeight: f } = d, C = c.rowTop, m = c.rowHeight, v = r.getPixelOffset(), S = c.rowTop - v, D = S + c.rowHeight, y = this.getVScrollPosition(), R = l.divStretchOffset, x = y.top + R, k = y.bottom + R, I = k - x, T = l.getScrollPositionForPixel(S), _ = l.getScrollPositionForPixel(D - I), ve = Math.min((T + _) / 2, S), le = x + p > S, ue = k - f < D;
        let Q = null;
        t === "top" ? Q = T - p : t === "bottom" ? Q = _ + f : t === "middle" ? Q = ve : le ? Q = T - p : ue && (_ - T > I ? Q = T - p : Q = _ + f), Q !== null && (this.setVerticalScrollPosition(Q), a.redraw({ afterScroll: !0 })), u = C !== c.rowTop || m !== c.rowHeight, h = p !== d.stickyTopHeight || f !== d.stickyBottomHeight, g++;
      } while ((u || h) && g < 10);
      if (this.animationFrameSvc?.flushAllFrames(), o < 10 && (c?.stub || !this.beans.rowAutoHeight?.areRowsMeasured())) {
        const p = this.getVScrollPosition().top;
        this.clearRetryListenerFncs = this.addManagedEventListeners({
          bodyScroll: () => {
            const f = this.getVScrollPosition().top;
            p !== f && this.clearRetryListeners();
          },
          modelUpdated: () => {
            this.clearRetryListeners(), !(e >= i.getRowCount()) && this.ensureIndexVisible(e, t, o + 1);
          }
        });
      }
    });
  }
  clearRetryListeners() {
    for (const e of this.clearRetryListenerFncs)
      e();
    this.clearRetryListenerFncs = [];
  }
  ensureColumnVisible(e, t = "auto") {
    const { colModel: o, frameworkOverrides: i } = this.beans, s = o.getCol(e);
    if (!s || s.isPinned() || !this.visibleCols.isColDisplayed(s))
      return;
    const n = this.getPositionedHorizontalScroll(s, t);
    i.wrapIncoming(() => {
      n !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(n), this.centerRowsCtrl.onHorizontalViewportChanged(), this.animationFrameSvc?.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: o, columnAfterEnd: i } = this.isColumnOutsideViewport(e), s = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), n = this.centerRowsCtrl.getCenterWidth(), r = this.enableRtl;
    let l = (r ? o : i) || s, a = r ? i : o;
    t !== "auto" && (l = t === "start", a = t === "end");
    const d = t === "middle";
    if (l || a || d) {
      const { colLeft: c, colMiddle: u, colRight: h } = this.getColumnBounds(e);
      return d ? u - n / 2 : l ? r ? h : c : r ? c - n : h - n;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: o } = this.getViewportBounds(), { colLeft: i, colRight: s } = this.getColumnBounds(e), n = this.enableRtl, r = n ? t > s : o < s, l = n ? o < i : t > i;
    return { columnBeforeStart: r, columnAfterEnd: l };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, o = this.visibleCols.bodyWidth, i = e.getActualWidth(), s = e.getLeft(), n = t ? -1 : 1, r = t ? o - s : s, l = r + i * n, a = r + i / 2 * n;
    return { colLeft: r, colMiddle: a, colRight: l };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft(), o = t, i = e + t;
    return { start: o, end: i, width: e };
  }
}, gs = class extends b {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedEventListeners({
      columnContainerWidthChanged: e,
      displayedColumnsChanged: e,
      leftPinnedWidthChanged: e
    }), this.addSpacer && this.addManagedEventListeners({
      rightPinnedWidthChanged: e,
      scrollVisibilityChanged: e,
      scrollbarWidthChanged: e
    }), this.setWidth();
  }
  setWidth() {
    const e = Y(this.gos, "print"), { visibleCols: t, scrollVisibleSvc: o } = this.beans, i = t.bodyWidth, s = t.getColsLeftWidth(), n = t.getDisplayedColumnsRightWidth();
    let r;
    e ? r = i + s + n : (r = i, this.addSpacer && (this.gos.get("enableRtl") ? s : n) === 0 && o.verticalScrollShowing && (r += o.getScrollbarWidth())), this.callback(r);
  }
}, Su = class extends b {
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  wireBeans(e) {
    this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedEventListeners({ scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this) }), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const { beans: e, centerContainerCtrl: t, gridBodyCtrl: o } = this, i = () => {
      Le(e, () => {
        this.onCenterViewportResized();
      });
    };
    t.registerViewportResizeListener(i), o.registerBodyViewportResizeListener(i);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.scrollVisibleSvc.updateScrollGap(), this.centerContainerCtrl.isViewportInTheDOMTree()) {
      const { pinnedCols: e, colFlex: t } = this.beans;
      e?.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const o = this.centerContainerCtrl.getCenterWidth();
      o !== this.centerWidth && (this.centerWidth = o, t?.refreshFlexedColumns({
        viewportWidth: this.centerWidth,
        updateBodyWidths: !0,
        fireResizedEvent: !0
      }));
    } else
      this.bodyHeight = 0;
  }
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.scrollFeature.checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = this.gridBodyCtrl.eBodyViewport, t = Yi(e);
    this.bodyHeight !== t && (this.bodyHeight = t, this.eventSvc.dispatchEvent({
      type: "bodyHeightChanged"
    }));
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    if (!this.isAlive())
      return;
    const e = {
      horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
    };
    this.scrollVisibleSvc.setScrollsVisible(e);
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(e, t);
  }
};
function go(e, t, o, i) {
  const s = t.getColDef().cellRendererParams?.suppressMouseEventHandling;
  return Hr(e, t, o, i, s);
}
function bu(e, t, o, i) {
  const s = t?.suppressMouseEventHandling;
  return Hr(e, void 0, o, i, s);
}
function Hr(e, t, o, i, s) {
  return s ? s(
    L(e, {
      column: t,
      node: o,
      event: i
    })
  ) : !1;
}
function Or(e, t, o) {
  let i = t;
  for (; i; ) {
    const s = Xn(e, i, o);
    if (s)
      return s;
    i = i.parentElement;
  }
  return null;
}
var ko = "cellCtrl";
function ps(e, t) {
  return Or(e, t, ko);
}
var Lo = "renderedRow";
function yu(e, t) {
  return Or(e, t, Lo);
}
function Zs(e, t, o, i, s) {
  const n = i ? i.getColDef().suppressKeyboardEvent : void 0;
  if (!n)
    return !1;
  const r = L(e, {
    event: t,
    editing: s,
    column: i,
    node: o,
    data: o.data,
    colDef: i.getColDef()
  });
  return !!(n && n(r));
}
function Ru(e) {
  const { pinnedRowModel: t, rowModel: o } = e, [i, s] = [
    t?.isEmpty("top") ?? !0,
    t?.isEmpty("bottom") ?? !0
  ], n = i ? null : "top";
  let r, l;
  s ? (r = null, l = o.getRowCount() - 1) : (r = "bottom", l = t?.getPinnedBottomRowCount() ?? -1);
  const { visibleCols: a, rangeSvc: d } = e, c = a.allCols;
  !d || !c?.length || d.setCellRange({
    rowStartIndex: 0,
    rowStartPinned: n,
    rowEndIndex: l,
    rowEndPinned: r
  });
}
var xu = 65, Pu = 67, Du = 86, Fu = 68, Eu = 90, Au = 89;
function Mu(e) {
  const { keyCode: t } = e;
  let o;
  switch (t) {
    case xu:
      o = w.A;
      break;
    case Pu:
      o = w.C;
      break;
    case Du:
      o = w.V;
      break;
    case Fu:
      o = w.D;
      break;
    case Eu:
      o = w.Z;
      break;
    case Au:
      o = w.Y;
      break;
    default:
      o = e.code;
  }
  return o;
}
var Tu = class extends b {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addKeyboardListeners(), this.addMouseListeners(), this.beans.touchSvc?.mockRowContextMenu(this), this.editSvc = this.beans.editSvc;
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedElementListeners(this.element, { [e]: t });
  }
  addMouseListeners() {
    const t = ["dblclick", "contextmenu", "mouseover", "mouseout", "click", Bn("touchstart") ? "touchstart" : "mousedown"];
    for (const o of t) {
      const i = this.processMouseEvent.bind(this, o);
      this.addManagedElementListeners(this.element, { [o]: i });
    }
  }
  processMouseEvent(e, t) {
    if (!Bt(this.beans, t) || xe(t))
      return;
    const { cellCtrl: o, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    e === "contextmenu" ? (o?.column && o.dispatchCellContextMenuEvent(t), this.beans.contextMenuSvc?.handleContextMenuMouseEvent(t, void 0, i, o)) : (o && o.onMouseEvent(e, t), i && i.onMouseEvent(e, t));
  }
  getControlsForEventTarget(e) {
    const { gos: t } = this;
    return {
      cellCtrl: ps(t, e),
      rowCtrl: yu(t, e)
    };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: o, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (o ? this.processCellKeyboardEvent(o, e, t) : i?.isFullWidth() && this.processFullWidthRowKeyboardEvent(i, e, t));
  }
  processCellKeyboardEvent(e, t, o) {
    const i = this.editSvc?.isEditing(e, { withOpenEditor: !0 }) ?? !1;
    !Zs(
      this.gos,
      o,
      e.rowNode,
      e.column,
      i
    ) && t === "keydown" && (!i && this.beans.navigation?.handlePageScrollingKey(o) || e.onKeyDown(o), this.doGridOperations(o, i), dc(o) && e.processCharacter(o)), t === "keydown" && this.eventSvc.dispatchEvent(e.createEvent(o, "cellKeyDown"));
  }
  processFullWidthRowKeyboardEvent(e, t, o) {
    const { rowNode: i } = e, { focusSvc: s, navigation: n } = this.beans, l = s.getFocusedCell()?.column;
    if (!Zs(this.gos, o, i, l, !1)) {
      const d = o.key;
      if (t === "keydown")
        switch (d) {
          case w.PAGE_HOME:
          case w.PAGE_END:
          case w.PAGE_UP:
          case w.PAGE_DOWN:
            n?.handlePageScrollingKey(o, !0);
            break;
          case w.LEFT:
          case w.RIGHT:
            if (!this.gos.get("embedFullWidthRows"))
              break;
          case w.UP:
          case w.DOWN:
            e.onKeyboardNavigate(o);
            break;
          case w.TAB:
            e.onTabKeyDown(o);
            break;
        }
    }
    t === "keydown" && this.eventSvc.dispatchEvent(e.createRowEvent("cellKeyDown", o));
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !Bt(this.beans, e))
      return;
    const o = Mu(e), { clipboardSvc: i, undoRedo: s } = this.beans;
    if (o === w.A)
      return this.onCtrlAndA(e);
    if (o === w.C)
      return this.onCtrlAndC(i, e);
    if (o === w.D)
      return this.onCtrlAndD(i, e);
    if (o === w.V)
      return this.onCtrlAndV(i, e);
    if (o === w.X)
      return this.onCtrlAndX(i, e);
    if (o === w.Y)
      return this.onCtrlAndY(s);
    if (o === w.Z)
      return this.onCtrlAndZ(s, e);
  }
  onCtrlAndA(e) {
    const {
      beans: { rowModel: t, rangeSvc: o, selectionSvc: i },
      gos: s
    } = this;
    o && ht(s) && !ed(s) && t.isRowsToRender() ? Ru(this.beans) : i && i.selectAllRowNodes({ source: "keyboardSelectAll", selectAll: or(s) }), e.preventDefault();
  }
  onCtrlAndC(e, t) {
    if (!e || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    this.editSvc?.isEditing(o, { withOpenEditor: !0 }) || (t.preventDefault(), e.copyToClipboard());
  }
  onCtrlAndX(e, t) {
    if (!e || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    this.editSvc?.isEditing(o, { withOpenEditor: !0 }) || (t.preventDefault(), e.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e, t) {
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    this.editSvc?.isEditing(o, { withOpenEditor: !0 }) || e && !this.gos.get("suppressClipboardPaste") && e.pasteFromClipboard();
  }
  onCtrlAndD(e, t) {
    e && !this.gos.get("suppressClipboardPaste") && e.copyRangeDown(), t.preventDefault();
  }
  onCtrlAndZ(e, t) {
    !this.gos.get("undoRedoCellEditing") || !e || (t.preventDefault(), t.shiftKey ? e.redo("ui") : e.undo("ui"));
  }
  onCtrlAndY(e) {
    e?.redo("ui");
  }
}, Br = class extends b {
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedEventListeners({
      rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
    });
  }
  onHeightChanged(e) {
    const t = e.uiContainerHeight, o = t != null ? `${t}px` : "";
    this.eContainer.style.height = o, this.eViewport && (this.eViewport.style.height = o);
  }
}, Jt = (e) => e.topRowCtrls, eo = (e) => e.getStickyTopRowCtrls(), to = (e) => e.getStickyBottomRowCtrls(), oo = (e) => e.bottomRowCtrls, io = (e) => e.allRowCtrls, si = (e) => e.getCtrls("top"), ni = (e) => e.getCtrls("center"), ri = (e) => e.getCtrls("bottom"), Iu = {
  center: {
    type: "center",
    name: "center-cols",
    getRowCtrls: io,
    getSpannedRowCtrls: ni
  },
  left: {
    type: "left",
    name: "pinned-left-cols",
    pinnedType: "left",
    getRowCtrls: io,
    getSpannedRowCtrls: ni
  },
  right: {
    type: "right",
    name: "pinned-right-cols",
    pinnedType: "right",
    getRowCtrls: io,
    getSpannedRowCtrls: ni
  },
  fullWidth: {
    type: "fullWidth",
    name: "full-width",
    fullWidth: !0,
    getRowCtrls: io
  },
  topCenter: {
    type: "center",
    name: "floating-top",
    getRowCtrls: Jt,
    getSpannedRowCtrls: si
  },
  topLeft: {
    type: "left",
    name: "pinned-left-floating",
    container: "ag-pinned-left-floating-top",
    pinnedType: "left",
    getRowCtrls: Jt,
    getSpannedRowCtrls: si
  },
  topRight: {
    type: "right",
    name: "pinned-right-floating",
    container: "ag-pinned-right-floating-top",
    pinnedType: "right",
    getRowCtrls: Jt,
    getSpannedRowCtrls: si
  },
  topFullWidth: {
    type: "fullWidth",
    name: "floating-top-full-width",
    fullWidth: !0,
    getRowCtrls: Jt
  },
  stickyTopCenter: {
    type: "center",
    name: "sticky-top",
    getRowCtrls: eo
  },
  stickyTopLeft: {
    type: "left",
    name: "pinned-left-sticky-top",
    container: "ag-pinned-left-sticky-top",
    pinnedType: "left",
    getRowCtrls: eo
  },
  stickyTopRight: {
    type: "right",
    name: "pinned-right-sticky-top",
    container: "ag-pinned-right-sticky-top",
    pinnedType: "right",
    getRowCtrls: eo
  },
  stickyTopFullWidth: {
    type: "fullWidth",
    name: "sticky-top-full-width",
    fullWidth: !0,
    getRowCtrls: eo
  },
  stickyBottomCenter: {
    type: "center",
    name: "sticky-bottom",
    getRowCtrls: to
  },
  stickyBottomLeft: {
    type: "left",
    name: "pinned-left-sticky-bottom",
    container: "ag-pinned-left-sticky-bottom",
    pinnedType: "left",
    getRowCtrls: to
  },
  stickyBottomRight: {
    type: "right",
    name: "pinned-right-sticky-bottom",
    container: "ag-pinned-right-sticky-bottom",
    pinnedType: "right",
    getRowCtrls: to
  },
  stickyBottomFullWidth: {
    type: "fullWidth",
    name: "sticky-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: to
  },
  bottomCenter: {
    type: "center",
    name: "floating-bottom",
    getRowCtrls: oo,
    getSpannedRowCtrls: ri
  },
  bottomLeft: {
    type: "left",
    name: "pinned-left-floating-bottom",
    container: "ag-pinned-left-floating-bottom",
    pinnedType: "left",
    getRowCtrls: oo,
    getSpannedRowCtrls: ri
  },
  bottomRight: {
    type: "right",
    name: "pinned-right-floating-bottom",
    container: "ag-pinned-right-floating-bottom",
    pinnedType: "right",
    getRowCtrls: oo,
    getSpannedRowCtrls: ri
  },
  bottomFullWidth: {
    type: "fullWidth",
    name: "floating-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: oo
  }
};
function Vr(e) {
  return `ag-${Yt(e).name}-viewport`;
}
function po(e) {
  const t = Yt(e);
  return t.container ?? `ag-${t.name}-container`;
}
function ku(e) {
  return `ag-${Yt(e).name}-spanned-cells-container`;
}
function Yt(e) {
  return Iu[e];
}
var Lu = ["topCenter", "topLeft", "topRight"], Gu = ["bottomCenter", "bottomLeft", "bottomRight"], Hu = ["center", "left", "right"], Ou = ["center", "left", "right", "fullWidth"], Bu = ["stickyTopCenter", "stickyBottomCenter", "center", "topCenter", "bottomCenter"], Vu = ["left", "bottomLeft", "topLeft", "stickyTopLeft", "stickyBottomLeft"], Wu = ["right", "bottomRight", "topRight", "stickyTopRight", "stickyBottomRight"], Wr = ["stickyTopCenter", "stickyTopLeft", "stickyTopRight"], Nr = ["stickyBottomCenter", "stickyBottomLeft", "stickyBottomRight"], Nu = [
  ...Wr,
  "stickyTopFullWidth",
  ...Nr,
  "stickyBottomFullWidth"
], zu = [
  ...Lu,
  ...Gu,
  ...Hu,
  ...Wr,
  ...Nr
], _u = class extends b {
  constructor(e) {
    super(), this.name = e, this.visible = !0, this.EMPTY_CTRLS = [], this.options = Yt(e);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(["center"], () => {
      this.viewportSizeFeature = this.createManagedBean(new Su(this)), this.addManagedEventListeners({
        stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
      });
    });
  }
  onStickyTopOffsetChanged(e) {
    this.comp.setOffsetTop(`${e.offset}px`);
  }
  registerWithCtrlsService() {
    this.options.fullWidth || this.beans.ctrlsSvc.register(this.name, this);
  }
  forContainers(e, t) {
    e.indexOf(this.name) >= 0 && t();
  }
  setComp(e, t, o, i) {
    this.comp = e, this.eContainer = t, this.eSpannedContainer = o, this.eViewport = i, this.createManagedBean(new Tu(this.eViewport ?? this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder();
    const { pinnedCols: s, rangeSvc: n } = this.beans, r = () => this.onPinnedWidthChanged();
    this.forContainers(Vu, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s?.createPinnedWidthFeature(!0, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ leftPinnedWidthChanged: r });
    }), this.forContainers(Wu, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s?.createPinnedWidthFeature(!1, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ rightPinnedWidthChanged: r });
    }), this.forContainers(
      Ou,
      () => this.createManagedBean(
        new Br(this.eContainer, this.name === "center" ? i : void 0)
      )
    ), n && this.forContainers(
      zu,
      () => this.createManagedBean(n.createDragListenerFeature(this.eContainer))
    ), this.forContainers(
      Bu,
      () => this.createManagedBean(new gs((l) => this.comp.setContainerWidth(`${l}px`)))
    ), this.visible = this.isContainerVisible(), this.addListeners(), this.registerWithCtrlsService();
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  addListeners() {
    const { spannedRowRenderer: e, gos: t } = this.beans, o = this.onDisplayedColumnsChanged.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: o,
      displayedColumnsWidthChanged: o,
      displayedRowsChanged: (i) => this.onDisplayedRowsChanged(i.afterScroll)
    }), o(), this.onDisplayedRowsChanged(), e && this.options.getSpannedRowCtrls && t.get("enableCellSpan") && this.addManagedListeners(e, {
      spannedRowsUpdated: () => {
        const i = this.options.getSpannedRowCtrls(e);
        i && this.comp.setSpannedRowCtrls(i, !1);
      }
    });
  }
  listenOnDomOrder() {
    if (Nu.indexOf(this.name) >= 0) {
      this.comp.setDomOrder(!0);
      return;
    }
    const t = () => {
      const o = this.gos.get("ensureDomOrder"), i = Y(this.gos, "print");
      this.comp.setDomOrder(o || i);
    };
    this.addManagedPropertyListener("domLayout", t), t();
  }
  onDisplayedColumnsChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  addPreventScrollWhileDragging() {
    const { dragSvc: e } = this.beans;
    if (!e)
      return;
    const t = (o) => {
      e.dragging && o.cancelable && o.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", t, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", t));
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged(e = !1) {
    const t = this.getCenterWidth(), o = this.getCenterViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(t, o, e);
  }
  hasHorizontalScrollGap() {
    return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
  }
  hasVerticalScrollGap() {
    return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
  }
  getCenterWidth() {
    return Ot(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return vo(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(e) {
    const t = wt(this.beans, this.eViewport, e);
    this.addDestroyFunc(() => t());
  }
  isViewportInTheDOMTree() {
    return kn(this.eViewport);
  }
  getViewportScrollLeft() {
    return vo(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || Qi(this.eViewport);
  }
  setHorizontalScroll(e) {
    this.comp.setHorizontalScroll(e);
  }
  getHScrollPosition() {
    return {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
  }
  setCenterViewportScrollLeft(e) {
    wo(this.eViewport, e, this.enableRtl);
  }
  isContainerVisible() {
    return !(this.options.pinnedType != null) || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const e = this.isContainerVisible();
    this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(e = !1) {
    const t = this.options.getRowCtrls(this.beans.rowRenderer);
    if (!this.visible || t.length === 0) {
      this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
      return;
    }
    const o = Y(this.gos, "print"), s = this.gos.get("embedFullWidthRows") || o, n = t.filter((r) => {
      const l = r.isFullWidth();
      return this.options.fullWidth ? !s && l : s || !l;
    });
    this.comp.setRowCtrls({ rowCtrls: n, useFlushSync: e });
  }
}, zr = "ag-force-vertical-scroll", Uu = "ag-selectable", $u = "ag-column-moving", Ku = class extends b {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colModel = e.colModel, this.scrollVisibleSvc = e.scrollVisibleSvc, this.pinnedRowModel = e.pinnedRowModel, this.filterManager = e.filterManager, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  setComp(e, t, o, i, s, n, r) {
    this.comp = e, this.eGridBody = t, this.eBodyViewport = o, this.eTop = i, this.eBottom = s, this.eStickyTop = n, this.eStickyBottom = r, this.eCenterColsViewport = o.querySelector(`.${Vr("center")}`), this.eFullWidthContainer = o.querySelector(`.${po("fullWidth")}`), this.eStickyTopFullWidthContainer = n.querySelector(
      `.${po("stickyTopFullWidth")}`
    ), this.eStickyBottomFullWidthContainer = r.querySelector(
      `.${po("stickyBottomFullWidth")}`
    ), this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener(
      "enableCellTextSelection",
      (l) => this.setCellTextSelection(l.currentValue)
    ), this.createManagedBean(new hs(this.comp)), this.scrollFeature = this.createManagedBean(new wu(o)), this.beans.rowDragSvc?.setupRowDrag(o, this), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([i, o, s, n, r]), this.setGridRootRole(), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.updateScrollingClasses(), this.filterManager?.setupAdvFilterHeaderComp(i), this.ctrlsSvc.register("gridBodyCtrl", this);
  }
  addEventListeners() {
    const e = this.setFloatingHeights.bind(this), t = this.setGridRootRole.bind(this), o = this.toggleRowResizeStyles.bind(this);
    this.addManagedEventListeners({
      gridColumnsChanged: this.onGridColumnsChanged.bind(this),
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
      scrollGapChanged: this.updateScrollingClasses.bind(this),
      pinnedRowDataChanged: e,
      pinnedHeightChanged: e,
      pinnedRowsChanged: e,
      headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
      columnRowGroupChanged: t,
      columnPivotChanged: t,
      rowResizeStarted: o,
      rowResizeEnded: o
    }), this.addManagedPropertyListener("treeData", t);
  }
  toggleRowResizeStyles(e) {
    const t = e.type === "rowResizeStarted";
    this.eBodyViewport.classList.toggle("ag-prevent-animation", t);
  }
  onGridColumnsChanged() {
    const e = this.beans.colModel.getCols();
    this.comp.setColumnCount(e.length);
  }
  onScrollVisibilityChanged() {
    const { scrollVisibleSvc: e } = this, t = e.verticalScrollShowing;
    this.setVerticalScrollPaddingVisible(t), this.setStickyWidth(t), this.setStickyBottomOffsetBottom();
    const o = t && e.getScrollbarWidth() || 0, i = Sr() ? 16 : 0, s = `calc(100% + ${o + i}px)`;
    Le(this.beans, () => this.comp.setBodyViewportWidth(s)), this.updateScrollingClasses();
  }
  setGridRootRole() {
    const { rowGroupColsSvc: e, colModel: t } = this;
    let o = this.gos.get("treeData");
    if (!o) {
      const i = t.isPivotMode();
      o = (e ? e.columns.length : 0) >= (i ? 2 : 1);
    }
    this.comp.setGridRootRole(o ? "treegrid" : "grid");
  }
  addFocusListeners(e) {
    for (const t of e)
      this.addManagedElementListeners(t, {
        focusin: (o) => {
          const { target: i } = o, s = tt(i, "ag-root", t);
          t.classList.toggle("ag-has-focus", !s);
        },
        focusout: (o) => {
          const { target: i, relatedTarget: s } = o, n = t.contains(s), r = tt(
            s,
            "ag-root",
            t
          );
          tt(i, "ag-root", t) || (!n || r) && t.classList.remove("ag-has-focus");
        }
      });
  }
  // used by ColumnAnimationService
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss($u, e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss(Uu, e);
  }
  updateScrollingClasses() {
    const {
      eGridBody: { classList: e },
      scrollVisibleSvc: t
    } = this;
    e.toggle("ag-body-vertical-content-no-gap", !t.verticalScrollGap), e.toggle("ag-body-horizontal-content-no-gap", !t.horizontalScrollGap);
  }
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  disableBrowserDragging() {
    this.addManagedElementListeners(this.eGridBody, {
      dragstart: (e) => {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      }
    });
  }
  addStopEditingWhenGridLosesFocus() {
    this.beans.editSvc?.addStopEditingWhenGridLosesFocus([
      this.eBodyViewport,
      this.eBottom,
      this.eTop,
      this.eStickyTop,
      this.eStickyBottom
    ]);
  }
  updateRowCount() {
    const e = (this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.filterManager?.getHeaderRowCount() ?? 0), { rowModel: t } = this.beans, o = t.isLastRowIndexKnown() ? t.getRowCount() : -1, i = o === -1 ? -1 : e + o;
    this.comp.setRowCount(i);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? zr : null, o = Y(this.gos, "normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || o && Hn(this.eBodyViewport);
  }
  setupRowAnimationCssClass() {
    const { rowContainerHeight: e, environment: t } = this.beans;
    let o = t.sizesMeasured;
    const i = () => {
      const s = o && nt(this.gos) && !e.stretching, n = s ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(n, s);
    };
    i(), this.addManagedEventListeners({ heightScaleChanged: i }), this.addManagedPropertyListener("animateRows", i), this.addManagedEventListeners({
      gridStylesChanged: () => {
        !o && t.sizesMeasured && (o = !0, i());
      }
    });
  }
  addBodyViewportListener() {
    const {
      eBodyViewport: e,
      eStickyTop: t,
      eStickyBottom: o,
      eTop: i,
      eBottom: s,
      beans: { popupSvc: n, touchSvc: r }
    } = this, l = this.onBodyViewportContextMenu.bind(this);
    this.addManagedElementListeners(e, { contextmenu: l }), r?.mockBodyContextMenu(this, l), this.addManagedElementListeners(e, {
      wheel: this.onBodyViewportWheel.bind(this, n)
    });
    const a = this.onStickyWheel.bind(this);
    for (const c of [t, o, i, s])
      this.addManagedElementListeners(c, { wheel: a });
    const d = this.onHorizontalWheel.bind(this);
    for (const c of ["left", "right", "topLeft", "topRight", "bottomLeft", "bottomRight"])
      this.addManagedElementListeners(this.ctrlsSvc.get(c).eContainer, {
        wheel: d
      });
    this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    this.addManagedElementListeners(this.eFullWidthContainer, {
      wheel: (e) => this.onFullWidthContainerWheel(e)
    });
  }
  onFullWidthContainerWheel(e) {
    const { deltaX: t, deltaY: o, shiftKey: i } = e;
    (i || Math.abs(t) > Math.abs(o)) && Bt(this.beans, e) && this.scrollGridBodyToMatchEvent(e);
  }
  onStickyWheel(e) {
    const { deltaY: t } = e;
    this.scrollVertically(t) > 0 && e.preventDefault();
  }
  onHorizontalWheel(e) {
    const { deltaX: t, deltaY: o, shiftKey: i } = e;
    (i || Math.abs(t) > Math.abs(o)) && this.scrollGridBodyToMatchEvent(e);
  }
  scrollGridBodyToMatchEvent(e) {
    const { deltaX: t, deltaY: o } = e;
    e.preventDefault(), this.eCenterColsViewport.scrollBy({ left: t || o });
  }
  onBodyViewportContextMenu(e, t, o) {
    if (!e && !o)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || o).preventDefault();
    const { target: i } = e || t;
    (i === this.eBodyViewport || i === this.ctrlsSvc.get("center").eViewport) && this.beans.contextMenuSvc?.showContextMenu({
      mouseEvent: e,
      touchEvent: o,
      value: null,
      anchorToElement: this.eGridBody,
      source: "ui"
    });
  }
  onBodyViewportWheel(e, t) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && e?.hasAnchoredPopup() && t.preventDefault();
  }
  // called by rowDragFeature
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.scrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  setFloatingHeights() {
    const {
      pinnedRowModel: e,
      beans: { environment: t }
    } = this, o = e?.getPinnedTopTotalHeight(), i = e?.getPinnedBottomTotalHeight(), s = t.getPinnedRowBorderWidth(), n = t.getRowBorderWidth(), r = s - n, l = o ? r + o : 0, a = i ? r + i : 0;
    this.comp.setTopHeight(l), this.comp.setBottomHeight(a), this.comp.setTopInvisible(l <= 0), this.comp.setBottomInvisible(a <= 0), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  setStickyWidth(e) {
    if (!e)
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
    else {
      const t = this.scrollVisibleSvc.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    }
  }
  setStickyTopOffsetTop() {
    const t = this.ctrlsSvc.get("gridHeaderCtrl").headerHeight + (this.filterManager?.getHeaderHeight() ?? 0), o = this.pinnedRowModel?.getPinnedTopTotalHeight() ?? 0;
    let i = 0;
    t > 0 && (i += t), o > 0 && (i += o), i > 0 && (i += 1), this.comp.setStickyTopTop(`${i}px`);
  }
  setStickyBottomOffsetBottom() {
    const { pinnedRowModel: e, scrollVisibleSvc: t, comp: o } = this, i = e?.getPinnedBottomTotalHeight() ?? 0, n = t.horizontalScrollShowing && t.getScrollbarWidth() || 0, r = i + n;
    o.setStickyBottomBottom(`${r}px`);
  }
};
function ju(e, t) {
  return ps(e, t.target)?.getFocusedCellPosition() ?? null;
}
var _r = class extends O {
  constructor(e, t) {
    super(), this.direction = t, this.eViewport = P, this.eContainer = P, this.hideTimeout = 0, this.setTemplate(e);
  }
  postConstruct() {
    this.addManagedEventListeners({
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
    }), this.onScrollVisibilityChanged(), this.toggleCss("ag-apple-scrollbar", vr() || kt());
  }
  destroy() {
    super.destroy(), window.clearTimeout(this.hideTimeout);
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = Sr(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = this.getGui(), t = () => this.toggleCss("ag-scrollbar-active", !0), o = () => this.toggleCss("ag-scrollbar-active", !1);
    this.addManagedListeners(e, {
      mouseenter: t,
      mousedown: t,
      touchstart: t,
      mouseleave: o,
      touchend: o
    });
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), Le(this.beans, () => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedEventListeners({
      bodyScroll: (e) => {
        e.direction === this.direction && (this.hideTimeout && (window.clearTimeout(this.hideTimeout), this.hideTimeout = 0), this.toggleCss("ag-scrollbar-scrolling", !0));
      },
      bodyScrollEnd: () => {
        this.hideTimeout = window.setTimeout(() => {
          this.toggleCss("ag-scrollbar-scrolling", !1), this.hideTimeout = 0;
        }, 400);
      }
    });
  }
  attemptSettingScrollPosition(e) {
    const t = this.eViewport;
    Ea(
      this,
      () => ke(t),
      () => this.setScrollPosition(e),
      100
    );
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
}, qu = {
  tag: "div",
  cls: "ag-body-horizontal-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    { tag: "div", ref: "eLeftSpacer", cls: "ag-horizontal-left-spacer" },
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-horizontal-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-horizontal-scroll-container" }]
    },
    { tag: "div", ref: "eRightSpacer", cls: "ag-horizontal-right-spacer" }
  ]
}, Yu = class extends _r {
  constructor() {
    super(qu, "horizontal"), this.eLeftSpacer = P, this.eRightSpacer = P, this.setScrollVisibleDebounce = 0;
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    super.postConstruct();
    const e = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e,
      pinnedRowDataChanged: this.refreshCompBottom.bind(this)
    }), this.addManagedPropertyListener("domLayout", e), this.beans.ctrlsSvc.register("fakeHScrollComp", this), this.createManagedBean(new gs((t) => this.eContainer.style.width = `${t}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  destroy() {
    window.clearTimeout(this.setScrollVisibleDebounce), super.destroy();
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  refreshCompBottom() {
    if (!this.invisibleScrollbar)
      return;
    const e = this.beans.pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
    this.getGui().style.bottom = `${e}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const e = this.scrollVisibleSvc.verticalScrollShowing;
    let t = this.visibleCols.getDisplayedColumnsRightWidth();
    const o = !this.enableRtl && e, i = this.scrollVisibleSvc.getScrollbarWidth();
    o && (t += i), Me(this.eRightSpacer, t), this.eRightSpacer.classList.toggle("ag-scroller-corner", t <= i);
    let s = this.visibleCols.getColsLeftWidth();
    this.enableRtl && e && (s += i), Me(this.eLeftSpacer, s), this.eLeftSpacer.classList.toggle("ag-scroller-corner", s <= i);
  }
  setScrollVisible() {
    const e = this.scrollVisibleSvc.horizontalScrollShowing, t = this.invisibleScrollbar, o = this.gos.get("suppressHorizontalScroll"), i = e && this.scrollVisibleSvc.getScrollbarWidth() || 0, n = o ? 0 : i === 0 && t ? 16 : i, r = () => {
      this.setScrollVisibleDebounce = 0, this.toggleCss("ag-scrollbar-invisible", t), $o(this.getGui(), n), $o(this.eViewport, n), $o(this.eContainer, n), n || this.eContainer.style.setProperty("min-height", "1px"), this.setVisible(e, { skipAriaHidden: !0 });
    };
    window.clearTimeout(this.setScrollVisibleDebounce), e ? this.setScrollVisibleDebounce = window.setTimeout(r, 100) : r();
  }
  getScrollPosition() {
    return vo(this.eViewport, this.enableRtl);
  }
  setScrollPosition(e) {
    ke(this.eViewport) || this.attemptSettingScrollPosition(e), wo(this.eViewport, e, this.enableRtl);
  }
}, Zu = {
  selector: "AG-FAKE-HORIZONTAL-SCROLL",
  component: Yu
}, Qu = {
  tag: "div",
  cls: "ag-body-vertical-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-vertical-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-vertical-scroll-container" }]
    }
  ]
}, Xu = class extends _r {
  constructor() {
    super(Qu, "vertical");
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new Br(this.eContainer));
    const { ctrlsSvc: e } = this.beans;
    e.register("fakeVScrollComp", this), this.addManagedEventListeners({
      rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, e)
    });
  }
  setScrollVisible() {
    const { scrollVisibleSvc: e } = this.beans, t = e.verticalScrollShowing, o = this.invisibleScrollbar, i = t && e.getScrollbarWidth() || 0, s = i === 0 && o ? 16 : i;
    this.toggleCss("ag-scrollbar-invisible", o), Me(this.getGui(), s), Me(this.eViewport, s), Me(this.eContainer, s), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged(e) {
    const o = e.getGridBodyCtrl().eBodyViewport, i = this.getScrollPosition(), s = o.scrollTop;
    i != s && this.setScrollPosition(s, !0);
  }
  getScrollPosition() {
    return this.eViewport.scrollTop;
  }
  setScrollPosition(e, t) {
    !t && !ke(this.eViewport) && this.attemptSettingScrollPosition(e), this.eViewport.scrollTop = e;
  }
}, Ju = {
  selector: "AG-FAKE-VERTICAL-SCROLL",
  component: Xu
}, eh = "ag-column-first", th = "ag-column-last";
function Ur(e, t, o, i) {
  return H(e) ? [] : ih(e.headerClass, e, t, o, i);
}
function $r(e, t, o) {
  e.toggleCss(eh, o.isColAtEdge(t, "first")), e.toggleCss(th, o.isColAtEdge(t, "last"));
}
function oh(e, t, o, i) {
  return L(t, {
    // bad naming, as colDef here can be a group or a column,
    // however most people won't appreciate the difference,
    // so keeping it as colDef to avoid confusion.
    colDef: e,
    column: o,
    columnGroup: i
  });
}
function ih(e, t, o, i, s) {
  if (H(e))
    return [];
  let n;
  if (typeof e == "function") {
    const r = oh(t, o, i, s);
    n = e(r);
  } else
    n = e;
  return typeof n == "string" ? [n] : Array.isArray(n) ? [...n] : [];
}
function sh(e, t, o) {
  t.addManagedElementListeners(o, {
    keydown: (i) => {
      if (!i.defaultPrevented && i.key === w.TAB) {
        const s = i.shiftKey;
        qt(e, o, !1, s) || mt(e, s) && i.preventDefault();
      }
    }
  });
}
function nh(e, t) {
  return e.ctrlsSvc.get("gridCtrl").focusInnerElement(t);
}
function _e(e) {
  return e.gos.get("suppressHeaderFocus") || !!e.overlays?.isExclusive();
}
function fs(e) {
  return e.gos.get("suppressCellFocus") || !!e.overlays?.isExclusive();
}
function mt(e, t, o = !1) {
  const i = e.ctrlsSvc.get("gridCtrl");
  return !o && i.focusNextInnerContainer(t) ? !0 : ((o || !t && !i.isDetailGrid()) && i.forceFocusOutOfContainer(t), !1);
}
function fe(e) {
  return e.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0;
}
function Cs(e) {
  const t = [], o = e.ctrlsSvc.getHeaderRowContainerCtrls();
  for (const i of o) {
    if (!i)
      continue;
    const s = i.getGroupRowCount() || 0;
    for (let n = 0; n < s; n++) {
      const r = i.getGroupRowCtrlAtIndex(n), l = t[n];
      if (r) {
        const a = rh(e, r);
        (l == null || a > l) && (t[n] = a);
      }
    }
  }
  return t;
}
function rh(e, t) {
  let i = e.colModel.isPivotMode() ? ah(e) : jr(e);
  const s = t.getHeaderCellCtrls();
  for (const n of s) {
    const { column: r } = n, l = r.getAutoHeaderHeight();
    l != null && l > i && r.isAutoHeaderHeight() && (i = l);
  }
  return i;
}
function ms(e) {
  let o = e.colModel.isPivotMode() ? lh(e) : Zt(e);
  return e.colModel.forAllCols((i) => {
    const s = i.getAutoHeaderHeight();
    s != null && s > o && i.isAutoHeaderHeight() && (o = s);
  }), o;
}
function Zt(e) {
  return e.gos.get("headerHeight") ?? e.environment.getDefaultHeaderHeight();
}
function Kr(e) {
  return e.gos.get("floatingFiltersHeight") ?? Zt(e);
}
function jr(e) {
  return e.gos.get("groupHeaderHeight") ?? Zt(e);
}
function lh(e) {
  return e.gos.get("pivotHeaderHeight") ?? Zt(e);
}
function ah(e) {
  return e.gos.get("pivotGroupHeaderHeight") ?? jr(e);
}
function dh(e, t) {
  return e.headerRowIndex === t.headerRowIndex && e.column === t.column;
}
var ch = class extends b {
  setComp(e, t, o) {
    this.comp = e, this.eGui = t;
    const { beans: i } = this, { headerNavigation: s, touchSvc: n, ctrlsSvc: r } = i;
    s && this.createManagedBean(
      new _o(o, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addManagedEventListeners({
      columnPivotModeChanged: this.onPivotModeChanged.bind(this, i),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, i)
    }), this.onPivotModeChanged(i), this.setupHeaderHeight();
    const l = this.onHeaderContextMenu.bind(this);
    this.addManagedElementListeners(this.eGui, { contextmenu: l }), n?.mockHeaderContextMenu(this, l), r.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      e
    ), this.addManagedEventListeners({
      headerRowsChanged: e,
      columnHeaderHeightChanged: e,
      // add this to the animation frame to avoid a feedback loop
      columnGroupHeaderHeightChanged: () => Le(this.beans, () => e()),
      gridStylesChanged: e,
      advancedFilterEnabledChanged: e
    });
  }
  setHeaderHeight() {
    const { beans: e } = this;
    let t = 0;
    const o = Cs(e).reduce((n, r) => n + r, 0), i = ms(e);
    if (e.filterManager?.hasFloatingFilters() && (t += Kr(e)), t += o, t += i, this.headerHeight === t)
      return;
    this.headerHeight = t;
    const s = `${t + 1}px`;
    this.comp.setHeightAndMinHeight(s), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  onPivotModeChanged(e) {
    const t = e.colModel.isPivotMode();
    this.comp.toggleCss("ag-pivot-on", t), this.comp.toggleCss("ag-pivot-off", !t);
  }
  onDisplayedColumnsChanged(e) {
    const o = e.visibleCols.allCols.some((i) => i.isSpanHeaderHeight());
    this.comp.toggleCss("ag-header-allow-overflow", o);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), o = e.shiftKey, i = o !== t ? "LEFT" : "RIGHT", { beans: s } = this, { headerNavigation: n, focusSvc: r } = s;
    (n.navigateHorizontally(i, !0, e) || !o && r.focusOverlay(!1) || mt(s, o, !0)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    const { headerNavigation: o } = this.beans;
    switch (e.key) {
      case w.LEFT:
        t = "LEFT";
      case w.RIGHT: {
        A(t) || (t = "RIGHT"), o.navigateHorizontally(t, !1, e) && e.preventDefault();
        break;
      }
      case w.UP:
        t = "UP";
      case w.DOWN: {
        A(t) || (t = "DOWN"), o.navigateVertically(t, e) && e.preventDefault();
        break;
      }
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e, { eGui: o, beans: i } = this;
    !t && o.contains(N(i)) || o.contains(t) || (i.focusSvc.focusedHeader = null);
  }
  onHeaderContextMenu(e, t, o) {
    const { menuSvc: i, ctrlsSvc: s } = this.beans;
    if (!e && !o || !i?.isHeaderContextMenuEnabled())
      return;
    const { target: n } = e ?? t;
    (n === this.eGui || n === s.getHeaderRowContainerCtrl()?.eViewport) && i.showHeaderContextMenu(void 0, e, o);
  }
}, vs = class extends O {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, uh = {
  tag: "div",
  cls: "ag-header-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" },
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" }
  ]
}, hh = class extends vs {
  constructor(e) {
    super(uh, e), this.eResize = P, this.eHeaderCompWrapper = P, this.headerCompVersion = 0;
  }
  postConstruct() {
    const e = this.getGui(), t = () => {
      const i = this.ctrl.getSelectAllGui();
      i && (this.eResize.insertAdjacentElement("afterend", i), this.addDestroyFunc(() => i.remove()));
    }, o = {
      setWidth: (i) => e.style.width = i,
      toggleCss: (i, s) => this.toggleCss(i, s),
      setUserStyles: (i) => Kt(e, i),
      setAriaSort: (i) => i ? sa(e, i) : na(e),
      setUserCompDetails: (i) => this.setUserCompDetails(i),
      getUserCompInstance: () => this.headerComp,
      refreshSelectAllGui: t,
      removeSelectAllGui: () => this.ctrl.getSelectAllGui()?.remove()
    };
    this.ctrl.setComp(o, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0), t();
  }
  destroy() {
    this.destroyHeaderComp(), super.destroy();
  }
  destroyHeaderComp() {
    this.headerComp && (this.headerCompGui?.remove(), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(e) {
    this.headerCompVersion++;
    const t = this.headerCompVersion;
    e.newAgStackInstance().then((o) => this.afterCompCreated(t, o));
  }
  afterCompCreated(e, t) {
    if (e != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(t);
      return;
    }
    this.destroyHeaderComp(), this.headerComp = t, this.headerCompGui = t.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
  }
}, gh = {
  tag: "div",
  cls: "ag-header-group-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" },
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" }
  ]
}, ph = class extends vs {
  constructor(e) {
    super(gh, e), this.eResize = P, this.eHeaderCompWrapper = P;
  }
  postConstruct() {
    const e = this.getGui(), t = (i, s) => s != null ? e.setAttribute(i, s) : e.removeAttribute(i), o = {
      toggleCss: (i, s) => this.toggleCss(i, s),
      setUserStyles: (i) => Kt(e, i),
      setHeaderWrapperHidden: (i) => {
        i ? this.eHeaderCompWrapper.style.setProperty("display", "none") : this.eHeaderCompWrapper.style.removeProperty("display");
      },
      setHeaderWrapperMaxHeight: (i) => {
        i != null ? this.eHeaderCompWrapper.style.setProperty("max-height", `${i}px`) : this.eHeaderCompWrapper.style.removeProperty("max-height"), this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", i != null);
      },
      setResizableDisplayed: (i) => V(this.eResize, i),
      setWidth: (i) => e.style.width = i,
      setAriaExpanded: (i) => t("aria-expanded", i),
      setUserCompDetails: (i) => this.setUserCompDetails(i),
      getUserCompInstance: () => this.headerGroupComp
    };
    this.ctrl.setComp(o, e, this.eResize, this.eHeaderCompWrapper, void 0);
  }
  setUserCompDetails(e) {
    e.newAgStackInstance().then((t) => this.afterHeaderCompCreated(t));
  }
  afterHeaderCompCreated(e) {
    const t = () => this.destroyBean(e);
    if (!this.isAlive()) {
      t();
      return;
    }
    const o = this.getGui(), i = e.getGui();
    this.eHeaderCompWrapper.appendChild(i), this.addDestroyFunc(t), this.headerGroupComp = e, this.ctrl.setDragSource(o);
  }
}, fh = {
  tag: "div",
  cls: "ag-header-cell ag-floating-filter",
  role: "gridcell",
  children: [
    { tag: "div", ref: "eFloatingFilterBody", role: "presentation" },
    {
      tag: "div",
      ref: "eButtonWrapper",
      cls: "ag-floating-filter-button ag-hidden",
      role: "presentation",
      children: [
        {
          tag: "button",
          ref: "eButtonShowMainFilter",
          cls: "ag-button ag-floating-filter-button-button",
          attrs: { type: "button", tabindex: "-1" }
        }
      ]
    }
  ]
}, Ch = class extends vs {
  constructor(e) {
    super(fh, e), this.eFloatingFilterBody = P, this.eButtonWrapper = P, this.eButtonShowMainFilter = P;
  }
  postConstruct() {
    const e = this.getGui(), t = {
      toggleCss: (o, i) => this.toggleCss(o, i),
      setUserStyles: (o) => Kt(e, o),
      addOrRemoveBodyCssClass: (o, i) => this.eFloatingFilterBody.classList.toggle(o, i),
      setButtonWrapperDisplayed: (o) => V(this.eButtonWrapper, o),
      setCompDetails: (o) => this.setCompDetails(o),
      getFloatingFilterComp: () => this.compPromise,
      setWidth: (o) => e.style.width = o,
      setMenuIcon: (o) => this.eButtonShowMainFilter.appendChild(o)
    };
    this.ctrl.setComp(t, e, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
  }
  setCompDetails(e) {
    if (!e) {
      this.destroyFloatingFilterComp(), this.compPromise = null;
      return;
    }
    this.compPromise = e.newAgStackInstance(), this.compPromise.then((t) => this.afterCompCreated(t));
  }
  destroy() {
    this.destroyFloatingFilterComp(), super.destroy();
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.floatingFilterComp.getGui().remove(), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(e) {
    if (e) {
      if (!this.isAlive()) {
        this.destroyBean(e);
        return;
      }
      this.destroyFloatingFilterComp(), this.floatingFilterComp = e, this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached();
    }
  }
}, mh = class extends O {
  constructor(e) {
    super({ tag: "div", cls: e.headerRowClass, role: "row" }), this.ctrl = e, this.headerComps = {};
  }
  postConstruct() {
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), bi(this.getGui(), this.ctrl.getAriaRowIndex());
    const t = {
      setHeight: (o) => this.getGui().style.height = o,
      setTop: (o) => this.getGui().style.top = o,
      setHeaderCtrls: (o, i) => this.setHeaderCtrls(o, i),
      setWidth: (o) => this.getGui().style.width = o,
      setRowIndex: (o) => bi(this.getGui(), o)
    };
    this.ctrl.setComp(t, void 0);
  }
  destroy() {
    this.setHeaderCtrls([], !1), super.destroy();
  }
  setHeaderCtrls(e, t) {
    if (!this.isAlive())
      return;
    const o = this.headerComps;
    this.headerComps = {};
    for (const i of e) {
      const s = i.instanceId;
      let n = o[s];
      delete o[s], n == null && (n = this.createHeaderComp(i), this.getGui().appendChild(n.getGui())), this.headerComps[s] = n;
    }
    if (Object.values(o).forEach((i) => {
      i.getGui().remove(), this.destroyBean(i);
    }), t) {
      const i = Object.values(this.headerComps);
      i.sort(
        (n, r) => {
          const l = n.getCtrl().column.getLeft(), a = r.getCtrl().column.getLeft();
          return l - a;
        }
      );
      const s = i.map((n) => n.getGui());
      Gn(this.getGui(), s);
    }
  }
  createHeaderComp(e) {
    let t;
    switch (this.ctrl.type) {
      case "group":
        t = new ph(e);
        break;
      case "filter":
        t = new Ch(e);
        break;
      default:
        t = new hh(e);
        break;
    }
    return this.createBean(t), t.setParentComponent(this), t;
  }
}, qr = class extends b {
  constructor(e, t, o, i) {
    super(), this.columnOrGroup = e, this.eCell = t, this.colsSpanning = i, this.columnOrGroup = e, this.ariaEl = t.querySelector("[role=columnheader]") || t, this.beans = o;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    const { beans: e, colsSpanning: t } = this;
    return e.gos.get("enableRtl") && t ? G(t) : this.columnOrGroup;
  }
  postConstruct() {
    const e = this.onLeftChanged.bind(this);
    this.addManagedListeners(this.columnOrGroup, { leftChanged: e }), this.setLeftFirstTime(), this.addManagedEventListeners({ displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  setLeftFirstTime() {
    const { gos: e, colAnimation: t } = this.beans, o = e.get("suppressColumnMoveAnimation"), i = A(this.columnOrGroup.getOldLeft());
    t?.isActive() && i && !o ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = this.modifyLeftForPrintLayout(e, e.getOldLeft()), o = this.modifyLeftForPrintLayout(e, e.getLeft());
    this.setLeft(t), this.actualLeft = o, this.beans.colAnimation.executeNextVMTurn(() => {
      this.actualLeft === o && this.setLeft(o);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    const { gos: o, visibleCols: i } = this.beans;
    if (!Y(o, "print") || e.getPinned() === "left")
      return t;
    const n = i.getColsLeftWidth();
    if (e.getPinned() === "right") {
      const r = i.bodyWidth;
      return n + r + t;
    }
    return n + t;
  }
  setLeft(e) {
    if (A(e) && (this.eCell.style.left = `${e}px`), B(this.columnOrGroup)) {
      const t = this.columnOrGroup.getLeafColumns();
      if (!t.length)
        return;
      t.length > 1 && ia(this.ariaEl, t.length);
    }
  }
}, vh = 0, Yr = "headerCtrl", Zr = class extends b {
  constructor(e, t) {
    super(), this.column = e, this.rowCtrl = t, this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.reAttemptToFocus = !1, this.instanceId = e.getUniqueId() + "-" + vh++;
  }
  postConstruct() {
    const e = this.refreshTabIndex.bind(this);
    this.addManagedPropertyListeners(["suppressHeaderFocus"], e), this.addManagedEventListeners({
      overlayExclusiveChanged: e
    });
  }
  setComp(e, t, o, i, s) {
    t.setAttribute("col-id", this.column.colIdSanitised), this.wireComp(e, t, o, i, s), this.reAttemptToFocus && (this.reAttemptToFocus = !1, this.focus(this.lastFocusEvent ?? void 0));
  }
  shouldStopEventPropagation(e) {
    const { headerRowIndex: t, column: o } = this.beans.focusSvc.focusedHeader, i = o.getDefinition(), s = i?.suppressHeaderKeyboardEvent;
    if (!A(s))
      return !1;
    const n = L(this.gos, {
      colDef: i,
      column: o,
      headerRowIndex: t,
      event: e
    });
    return !!s(n);
  }
  getWrapperHasFocus() {
    return N(this.beans) === this.eGui;
  }
  setGui(e, t) {
    this.eGui = e, this.addDomData(t), t.addManagedListeners(this.beans.eventSvc, {
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
    }), t.addManagedElementListeners(this.eGui, {
      focus: this.onGuiFocus.bind(this)
    }), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  refreshHeaderStyles() {
    const e = this.column.getDefinition();
    if (!e)
      return;
    const { headerStyle: t } = e;
    let o;
    if (typeof t == "function") {
      const i = this.getHeaderClassParams();
      o = t(i);
    } else
      o = t;
    o && this.comp.setUserStyles(o);
  }
  onGuiFocus() {
    this.eventSvc.dispatchEvent({
      type: "headerFocused",
      column: this.column
    });
  }
  setupAutoHeight(e) {
    const { wrapperElement: t, checkMeasuringCallback: o, compBean: i } = e, { beans: s } = this, n = (u) => {
      if (!this.isAlive() || !i.isAlive())
        return;
      const { paddingTop: h, paddingBottom: g, borderBottomWidth: p, borderTopWidth: f } = vt(this.eGui), C = h + g + p + f, v = t.offsetHeight + C;
      if (u < 5) {
        const D = !j(s)?.contains(t), y = v == 0;
        if (D || y) {
          Ri(() => n(u + 1), "raf", s);
          return;
        }
      }
      this.setColHeaderHeight(this.column, v);
    };
    let r = !1, l;
    const a = () => {
      const u = this.column.isAutoHeaderHeight();
      u && !r && d(), !u && r && c();
    }, d = () => {
      r = !0, this.comp.toggleCss("ag-header-cell-auto-height", !0), n(0), l = wt(this.beans, t, () => n(0));
    }, c = () => {
      r = !1, l && l(), this.comp.toggleCss("ag-header-cell-auto-height", !1), l = void 0;
    };
    a(), i.addDestroyFunc(() => c()), i.addManagedListeners(this.column, { widthChanged: () => r && n(0) }), i.addManagedEventListeners({
      sortChanged: () => {
        r && window.setTimeout(() => n(0));
      }
    }), o && o(a);
  }
  onDisplayedColumnsChanged() {
    const { comp: e, column: t, beans: o, eGui: i } = this;
    !e || !t || !i || ($r(e, t, o.visibleCols), En(i, o.visibleCols.getAriaColIndex(t)));
  }
  addResizeAndMoveKeyboardListeners(e) {
    e.addManagedListeners(this.eGui, {
      keydown: this.onGuiKeyDown.bind(this),
      keyup: this.onGuiKeyUp.bind(this)
    });
  }
  refreshTabIndex() {
    const e = _e(this.beans);
    this.eGui && Ve(this.eGui, "tabindex", e ? null : "-1");
  }
  onGuiKeyDown(e) {
    const t = N(this.beans), o = e.key === w.LEFT || e.key === w.RIGHT;
    if (this.isResizing && (e.preventDefault(), e.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
    t !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
    !e.shiftKey && !e.altKey || ((this.isResizing || o) && (e.preventDefault(), e.stopImmediatePropagation()), !o))
      return;
    const s = e.key === w.LEFT !== this.gos.get("enableRtl") ? "left" : "right";
    if (e.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const n = this.getViewportAdjustedResizeDiff(e);
      this.resizeHeader(n, e.shiftKey), this.resizeFeature?.toggleColumnResizing(!0);
    } else
      this.moveHeader(s);
  }
  moveHeader(e) {
    this.beans.colMoves?.moveHeader(e, this.eGui, this.column, this.rowCtrl.pinned, this);
  }
  getViewportAdjustedResizeDiff(e) {
    const t = this.getResizeDiff(e), { pinnedCols: o } = this.beans;
    return o ? o.getHeaderResizeDiff(t, this.column) : t;
  }
  getResizeDiff(e) {
    const { gos: t, column: o } = this;
    let i = e.key === w.LEFT !== t.get("enableRtl");
    const s = o.getPinned(), n = t.get("enableRtl");
    return s && n !== (s === "right") && (i = !i), (i ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = window.setTimeout(() => {
      this.resizeFeature?.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(e) {
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case w.PAGE_DOWN:
      case w.PAGE_UP:
      case w.PAGE_HOME:
      case w.PAGE_END:
        t && e.preventDefault();
    }
  }
  addDomData(e) {
    const t = Yr, { eGui: o, gos: i } = this;
    ut(i, o, t, this), e.addDestroyFunc(() => ut(i, o, t, null));
  }
  focus(e) {
    if (!this.isAlive())
      return !1;
    const { eGui: t } = this;
    return t ? (t.focus(), this.lastFocusEvent = e || null) : this.reAttemptToFocus = !0, !0;
  }
  focusThis() {
    this.beans.focusSvc.focusedHeader = { headerRowIndex: this.rowCtrl.rowIndex, column: this.column };
  }
  removeDragSource() {
    this.dragSource && (this.beans.dragAndDrop?.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(e, t, o) {
    const i = e ?? t, { menuSvc: s, gos: n } = this.beans;
    n.get("preventDefaultOnContextMenu") && i.preventDefault(), s?.isHeaderContextMenuEnabled(o) && s.showHeaderContextMenu(o, e, t), this.dispatchColumnMouseEvent("columnHeaderContextMenu", o);
  }
  dispatchColumnMouseEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: e,
      column: t
    });
  }
  setColHeaderHeight(e, t) {
    if (!e.setAutoHeaderHeight(t))
      return;
    const { eventSvc: o } = this;
    e.isColumn ? o.dispatchEvent({
      type: "columnHeaderHeightChanged",
      column: e,
      columns: [e],
      source: "autosizeColumnHeaderHeight"
    }) : o.dispatchEvent({
      type: "columnGroupHeaderHeightChanged",
      columnGroup: e,
      source: "autosizeColumnGroupHeaderHeight"
    });
  }
  clearComponent() {
    this.removeDragSource(), this.resizeFeature = null, this.comp = null, this.eGui = null;
  }
  destroy() {
    super.destroy(), this.column = null, this.lastFocusEvent = null, this.rowCtrl = null;
  }
}, wh = class extends Zr {
  constructor() {
    super(...arguments), this.refreshFunctions = {}, this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
  }
  wireComp(e, t, o, i, s) {
    this.comp = e;
    const { rowCtrl: n, column: r, beans: l } = this, { colResize: a, context: d, colHover: c, rangeSvc: u } = l, h = Wo(this, d, s);
    this.setGui(t, h), this.updateState(), this.setupWidth(h), this.setupMovingCss(h), this.setupMenuClass(h), this.setupSortableClass(h), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight({
      wrapperElement: i,
      checkMeasuringCallback: (p) => this.setRefreshFunction("measuring", p),
      compBean: h
    }), this.addColumnHoverListener(h), this.setupFilterClass(h), this.setupStylesFromColDef(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(h), this.setupSelectAll(h), this.setupUserComp(), this.refreshAria(), a ? this.resizeFeature = h.createManagedBean(
      a.createResizeFeature(n.pinned, r, o, e, this)
    ) : V(o, !1), c?.createHoverFeature(h, [r], t), u?.createRangeHighlightFeature(h, r, e), h.createManagedBean(new qr(r, t, l)), h.createManagedBean(
      new _o(t, {
        shouldStopEventPropagation: (p) => this.shouldStopEventPropagation(p),
        onTabKeyDown: () => null,
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addResizeAndMoveKeyboardListeners(h), h.addManagedPropertyListeners(
      ["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader", "enableAdvancedFilter"],
      () => this.refresh()
    ), h.addManagedListeners(r, { colDefChanged: () => this.refresh() }), h.addManagedListeners(r, { headerHighlightChanged: this.onHeaderHighlightChanged.bind(this) });
    const g = () => this.checkDisplayName();
    h.addManagedEventListeners({
      columnValueChanged: g,
      columnRowGroupChanged: g,
      columnPivotChanged: g,
      headerHeightChanged: this.onHeaderHeightChanged.bind(this)
    }), h.addDestroyFunc(() => {
      this.refreshFunctions = {}, this.selectAllFeature = null, this.dragSourceElement = void 0, this.userCompDetails = null, this.userHeaderClasses.clear(), this.ariaDescriptionProperties.clear(), this.clearComponent();
    });
  }
  resizeHeader(e, t) {
    this.beans.colResize?.resizeHeader(this.column, e, t);
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, o = e.colDef;
    return L(t.gos, {
      colDef: o,
      column: e,
      floatingFilter: !1
    });
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return Kd(this.beans.userCompFactory, t, e);
  }
  createParams() {
    const { menuSvc: e, sortSvc: t, colFilter: o, gos: i } = this.beans;
    return L(i, {
      column: this.column,
      displayName: this.displayName,
      enableSorting: this.column.isSortable(),
      enableMenu: this.menuEnabled,
      enableFilterButton: this.openFilterEnabled && !!e?.isHeaderFilterButtonEnabled(this.column),
      enableFilterIcon: !!o && (!this.openFilterEnabled || Do(this.gos)),
      showColumnMenu: (n, r) => {
        e?.showColumnMenu({
          column: this.column,
          buttonElement: n,
          positionBy: "button",
          onClosedCallback: r
        });
      },
      showColumnMenuAfterMouseClick: (n, r) => {
        e?.showColumnMenu({
          column: this.column,
          mouseEvent: n,
          positionBy: "mouse",
          onClosedCallback: r
        });
      },
      showFilter: (n) => {
        e?.showFilterMenu({
          column: this.column,
          buttonElement: n,
          containerType: "columnFilter",
          positionBy: "button"
        });
      },
      progressSort: (n) => {
        t?.progressSort(this.column, !!n, "uiColumnSorted");
      },
      setSort: (n, r) => {
        t?.setSortForColumn(this.column, n, !!r, "uiColumnSorted");
      },
      eGridHeader: this.eGui,
      setTooltip: (n, r) => {
        i.assertModuleRegistered("Tooltip", 3), this.setupTooltip(n, r);
      }
    });
  }
  setupSelectAll(e) {
    const { selectionSvc: t } = this.beans;
    t && (this.selectAllFeature = e.createOptionalManagedBean(t.createSelectAllFeature(this.column)), this.selectAllFeature?.setComp(this), e.addManagedPropertyListener("rowSelection", () => {
      const o = t.createSelectAllFeature(this.column);
      o && !this.selectAllFeature ? (this.selectAllFeature = e.createManagedBean(o), this.selectAllFeature?.setComp(this), this.comp.refreshSelectAllGui()) : this.selectAllFeature && !o && (this.comp.removeSelectAllGui(), this.selectAllFeature = this.destroyBean(this.selectAllFeature));
    }));
  }
  getSelectAllGui() {
    return this.selectAllFeature?.getCheckboxGui();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e), e.key === w.SPACE && this.selectAllFeature?.onSpaceKeyDown(e), e.key === w.ENTER && this.onEnterKeyDown(e), e.key === w.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    e.ctrlKey || e.metaKey ? this.showMenuOnKeyPress(e, !0) : this.sortable && this.beans.sortSvc?.progressSort(this.column, e.shiftKey, "uiColumnSorted");
  }
  showMenuOnKeyPress(e, t) {
    const o = this.comp.getUserCompInstance();
    Qs(o) && o.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || (this.focusThis(), this.announceAriaDescription()), gc() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.eGui.contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupStylesFromColDef() {
    this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this)), this.refreshHeaderStyles();
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = this.column.getColDef(), o = Ur(t, this.gos, this.column, null), i = this.userHeaderClasses;
      this.userHeaderClasses = new Set(o);
      for (const s of o)
        i.has(s) ? i.delete(s) : this.comp.toggleCss(s, !0);
      for (const s of i)
        this.comp.toggleCss(s, !1);
    };
    this.setRefreshFunction("headerClasses", e), e();
  }
  setDragSource(e) {
    this.dragSourceElement = e, this.removeDragSource(), !(!e || !this.draggable) && (this.dragSource = this.beans.colMoves?.setDragSourceForHeader(e, this.column, this.displayName) ?? null);
  }
  updateState() {
    const { menuSvc: e } = this.beans;
    this.menuEnabled = !!e?.isColumnMenuInHeaderEnabled(this.column), this.openFilterEnabled = !!e?.isFilterMenuInHeaderEnabled(this.column), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  setRefreshFunction(e, t) {
    this.refreshFunctions[e] = t;
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria();
    for (const e of Object.values(this.refreshFunctions))
      e();
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    if (!e)
      return;
    (this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass ? this.attemptHeaderCompRefresh(e.params) : !1) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !t || !t.refresh ? !1 : t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.colNames.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !!(!this.gos.get("suppressMovableColumns") && !e.suppressMovable && !e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  setupWidth(e) {
    const t = () => {
      const o = this.column.getActualWidth();
      this.comp.setWidth(`${o}px`);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupMovingCss(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
    };
    e.addManagedListeners(this.column, { movingChanged: t }), t();
  }
  setupMenuClass(e) {
    const t = () => {
      this.comp?.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
    };
    e.addManagedListeners(this.column, { menuVisibleChanged: t }), t();
  }
  setupSortableClass(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
    };
    t(), this.setRefreshFunction("updateSortable", t), e.addManagedEventListeners({ sortChanged: this.refreshAriaSort.bind(this) });
  }
  setupFilterClass(e) {
    const t = () => {
      const o = this.column.isFilterActive();
      this.comp.toggleCss("ag-header-cell-filtered", o), this.refreshAria();
    };
    e.addManagedListeners(this.column, { filterActiveChanged: t }), t();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.toggleCss("ag-header-cell-wrap-text", t);
    };
    e(), this.setRefreshFunction("wrapText", e);
  }
  onHeaderHighlightChanged() {
    const e = this.column.getHighlighted(), t = e === 0, o = e === 1;
    this.comp.toggleCss("ag-header-highlight-before", t), this.comp.toggleCss("ag-header-highlight-after", o);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    const { eGui: e, column: t, comp: o, beans: i } = this, s = Cs(this.beans), n = s.reduce((h, g) => h + g, 0) === 0;
    if (o.toggleCss("ag-header-parent-hidden", n), !t.isSpanHeaderHeight()) {
      e.style.removeProperty("top"), e.style.removeProperty("height"), o.toggleCss("ag-header-span-height", !1), o.toggleCss("ag-header-span-total", !1);
      return;
    }
    const { numberOfParents: r, isSpanningTotal: l } = this.column.getColumnGroupPaddingInfo();
    o.toggleCss("ag-header-span-height", r > 0);
    const a = ms(i);
    if (r === 0) {
      o.toggleCss("ag-header-span-total", !1), e.style.setProperty("top", "0px"), e.style.setProperty("height", `${a}px`);
      return;
    }
    o.toggleCss("ag-header-span-total", l);
    const d = (this.column.getFirstRealParent()?.getLevel() ?? -1) + 1, c = s.length - d;
    let u = 0;
    for (let h = 0; h < c; h++)
      u += s[s.length - 1 - h];
    e.style.setProperty("top", `${-u}px`), e.style.setProperty("height", `${a + u}px`);
  }
  refreshAriaSort() {
    if (this.sortable) {
      const e = this.getLocaleTextFunc(), t = this.beans.sortSvc?.getDisplaySortForColumn(this.column) || null;
      this.comp.setAriaSort(Kl(t)), this.setAriaDescriptionProperty("sort", e("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !Do(this.gos)) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty(
        "filterButton",
        e("ariaFilterColumn", "Press CTRL ENTER to open filter")
      );
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    if (!this.eGui.contains(N(this.beans)))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((t, o) => t === "filter" ? -1 : o.charCodeAt(0) - t.charCodeAt(0)).map((t) => this.ariaDescriptionProperties.get(t)).join(". ");
    this.beans.ariaAnnounce?.announceValue(e, "columnHeader");
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener(e) {
    this.beans.colHover?.addHeaderColumnHoverListener(e, this.comp, this.column);
  }
  addActiveHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), o = () => {
      this.setActiveHeader(!0), this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
    }, i = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column);
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: o,
      contextmenu: i
    });
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e), this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column
    });
  }
  setActiveHeader(e) {
    this.comp.toggleCss("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return Qs(t) ? t.getAnchorElementForMenu(e) : this.eGui;
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function Qs(e) {
  return typeof e?.getAnchorElementForMenu == "function" && typeof e.onMenuKeyboardShortcut == "function";
}
var Sh = 0, li = class extends b {
  constructor(e, t, o) {
    super(), this.rowIndex = e, this.pinned = t, this.type = o, this.instanceId = Sh++, this.comp = null, this.allCtrls = [];
    let i = "ag-header-row-column";
    o === "group" ? i = "ag-header-row-group" : o === "filter" && (i = "ag-header-row-filter"), this.headerRowClass = `ag-header-row ${i}`;
  }
  setRowIndex(e) {
    this.rowIndex = e, this.comp?.setRowIndex(this.getAriaRowIndex()), this.onRowHeightChanged();
  }
  postConstruct() {
    this.isPrintLayout = Y(this.gos, "print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */
  areCellsRendered() {
    return this.comp ? this.allCtrls.every((e) => e.eGui != null) : !1;
  }
  /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */
  setComp(e, t, o = !0) {
    this.comp = e, t = Wo(this, this.beans.context, t), o && (this.setRowIndex(this.rowIndex), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners(t);
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners(e) {
    const t = this.onRowHeightChanged.bind(this), o = this.onDisplayedColumnsChanged.bind(this);
    e.addManagedEventListeners({
      columnResized: this.setWidth.bind(this),
      displayedColumnsChanged: o,
      virtualColumnsChanged: (i) => this.onVirtualColumnsChanged(i.afterScroll),
      columnGroupHeaderHeightChanged: t,
      columnHeaderHeightChanged: t,
      gridStylesChanged: t,
      advancedFilterEnabledChanged: t
    }), e.addManagedPropertyListener("domLayout", o), e.addManagedPropertyListener("ensureDomOrder", (i) => this.isEnsureDomOrder = i.currentValue), e.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      t
    );
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = Y(this.gos, "print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  setWidth() {
    if (!this.comp)
      return;
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { visibleCols: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    if (!this.comp)
      return;
    const { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    let e = 0;
    const t = Cs(this.beans);
    for (let s = 0; s < t.length; s++) {
      if (s === this.rowIndex && this.type === "group")
        return { topOffset: e, rowHeight: t[s] };
      e += t[s];
    }
    const o = ms(this.beans);
    if (this.type === "column")
      return { topOffset: e, rowHeight: o };
    e += o;
    const i = Kr(this.beans);
    return { topOffset: e, rowHeight: i };
  }
  onVirtualColumnsChanged(e = !1) {
    if (!this.comp)
      return;
    const t = this.getUpdatedHeaderCtrls(), o = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, o, e);
  }
  /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */
  getUpdatedHeaderCtrls() {
    const e = this.ctrlsById;
    this.ctrlsById = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const i of t)
      this.recycleAndCreateHeaderCtrls(i, this.ctrlsById, e);
    const o = (i) => {
      const { focusSvc: s, visibleCols: n } = this.beans;
      return s.isHeaderWrapperFocused(i) ? n.isVisible(i.column) : !1;
    };
    if (e)
      for (const [i, s] of e)
        o(s) ? this.ctrlsById.set(i, s) : this.destroyBean(s);
    return this.allCtrls = Array.from(this.ctrlsById.values()), this.allCtrls;
  }
  /** Get the current header cell ctrls */
  getHeaderCellCtrls() {
    return this.allCtrls;
  }
  recycleAndCreateHeaderCtrls(e, t, o) {
    if (e.isEmptyGroup())
      return;
    const i = e.getUniqueId();
    let s;
    if (o && (s = o.get(i), o.delete(i)), s && s.column != e && (this.destroyBean(s), s = void 0), s == null)
      switch (this.type) {
        case "filter": {
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerFilterCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        }
        case "group":
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerGroupCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        default:
          s = this.createBean(new wh(e, this));
          break;
      }
    t.set(i, s);
  }
  getColumnsInViewport() {
    if (!this.isPrintLayout)
      return this.getComponentsToRender();
    if (this.pinned)
      return [];
    const e = [];
    for (const t of ["left", null, "right"])
      e.push(...this.getComponentsToRender(t));
    return e;
  }
  getComponentsToRender(e = this.pinned) {
    return this.type === "group" ? this.beans.colViewport.getHeadersToRender(e, this.rowIndex) : this.beans.colViewport.getColumnHeadersToRender(e);
  }
  focusHeader(e, t) {
    const o = this.allCtrls.find((s) => s.column == e);
    return o ? o.focus(t) : !1;
  }
  destroy() {
    this.allCtrls = this.destroyBeans(this.allCtrls), this.ctrlsById = void 0, this.comp = null, super.destroy();
  }
}, bh = class extends b {
  constructor(e) {
    super(), this.pinned = e, this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [];
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t;
    const { pinnedCols: o, ctrlsSvc: i, colModel: s, colMoves: n } = this.beans;
    this.setupCenterWidth(), o?.setupHeaderPinnedWidth(this), this.setupDragAndDrop(n, this.eViewport);
    const r = this.refresh.bind(this, !0);
    this.addManagedEventListeners({
      displayedColumnsChanged: r,
      advancedFilterEnabledChanged: r
    });
    const l = `${typeof this.pinned == "string" ? this.pinned : "center"}Header`;
    i.register(l, this), s.ready && this.refresh();
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  refresh(e = !1) {
    const { focusSvc: t, filterManager: o, visibleCols: i } = this.beans;
    let s = 0;
    const n = t.getFocusHeaderToUseAfterRefresh(), r = () => {
      const u = i.headerGroupRowCount;
      s = u, e || (this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls));
      const h = this.groupsRowCtrls.length;
      if (h !== u) {
        if (h > u) {
          for (let g = u; g < h; g++)
            this.destroyBean(this.groupsRowCtrls[g]);
          this.groupsRowCtrls.length = u;
          return;
        }
        for (let g = h; g < u; g++) {
          const p = this.createBean(new li(g, this.pinned, "group"));
          this.groupsRowCtrls.push(p);
        }
      }
    }, l = () => {
      const u = s++;
      if (this.hidden) {
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        return;
      }
      this.columnsRowCtrl == null || !e ? (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.columnsRowCtrl = this.createBean(new li(u, this.pinned, "column"))) : this.columnsRowCtrl.rowIndex !== u && this.columnsRowCtrl.setRowIndex(u);
    }, a = () => {
      this.includeFloatingFilter = !!o?.hasFloatingFilters() && !this.hidden;
      const u = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter) {
        u();
        return;
      }
      e || u();
      const h = s++;
      this.filtersRowCtrl ? this.filtersRowCtrl.rowIndex !== h && this.filtersRowCtrl.setRowIndex(h) : this.filtersRowCtrl = this.createBean(new li(h, this.pinned, "filter"));
    }, d = this.getAllCtrls();
    r(), l(), a();
    const c = this.getAllCtrls();
    this.comp.setCtrls(c), this.restoreFocusOnHeader(t, n), d.length !== c.length && this.beans.eventSvc.dispatchEvent({
      type: "headerRowsChanged"
    });
  }
  getHeaderCtrlForColumn(e) {
    const t = (o) => o?.getHeaderCellCtrls().find((i) => i.column === e);
    if (Ke(e))
      return t(this.columnsRowCtrl);
    if (this.groupsRowCtrls.length !== 0)
      for (let o = 0; o < this.groupsRowCtrls.length; o++) {
        const i = t(this.groupsRowCtrls[o]);
        if (i)
          return i;
      }
  }
  getHtmlElementForColumnHeader(e) {
    return this.getHeaderCtrlForColumn(e)?.eGui ?? null;
  }
  getRowType(e) {
    return this.getAllCtrls()[e]?.type;
  }
  focusHeader(e, t, o) {
    const s = this.getAllCtrls()[e];
    return s ? s.focusHeader(t, o) : !1;
  }
  getGroupRowCount() {
    return this.groupsRowCtrls.length;
  }
  getGroupRowCtrlAtIndex(e) {
    return this.groupsRowCtrls[e];
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  destroy() {
    this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl), this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls), super.destroy();
  }
  setupDragAndDrop(e, t) {
    const o = e?.createBodyDropTarget(this.pinned, t);
    o && this.createManagedBean(o);
  }
  restoreFocusOnHeader(e, t) {
    if (!t)
      return;
    const { column: o } = t;
    o.getPinned() == this.pinned && e.focusHeaderPosition({ headerPosition: t, scroll: !1 });
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new gs((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
}, Qr = class extends O {
  constructor() {
    super();
  }
}, yh = {
  tag: "span",
  cls: "ag-overlay-loading-center"
}, Rh = class extends Qr {
  init() {
    const e = Ne(this.gos.get("overlayLoadingTemplate")?.trim());
    if (this.setTemplate(e ?? yh), !e) {
      const o = this.getLocaleTextFunc()("loadingOoo", "Loading...");
      this.getGui().textContent = o, this.beans.ariaAnnounce.announceValue(o, "overlay");
    }
  }
}, xh = { tag: "span", cls: "ag-overlay-no-rows-center" }, Ph = class extends Qr {
  init() {
    const e = Ne(this.gos.get("overlayNoRowsTemplate")?.trim());
    if (this.setTemplate(e ?? xh), !e) {
      const o = this.getLocaleTextFunc()("noRowsToShow", "No Rows To Show");
      this.getGui().textContent = o, this.beans.ariaAnnounce.announceValue(o, "overlay");
    }
  }
};
function Dh(e, t, o) {
  const i = ye(e, t, o);
  if (i) {
    const { className: n } = i;
    if (typeof n == "string" && n.includes("ag-icon") || typeof n == "object" && n["ag-icon"])
      return i;
  }
  const s = ie({ tag: "span" });
  return s.appendChild(i), s;
}
function ye(e, t, o) {
  let i = null;
  e === "smallDown" ? F(262) : e === "smallLeft" ? F(263) : e === "smallRight" && F(264);
  const s = o?.getColDef().icons;
  if (s && (i = s[e]), t.gos && !i) {
    const n = t.gos.get("icons");
    n && (i = n[e]);
  }
  if (i) {
    let n;
    if (typeof i == "function")
      n = i();
    else if (typeof i == "string")
      n = i;
    else {
      F(38, { iconName: e });
      return;
    }
    if (typeof n == "string")
      return Zi(n);
    if (Ji(n))
      return n;
    F(133, { iconName: e });
    return;
  } else {
    const n = t.registry.getIcon(e);
    return n || t.validation?.validateIcon(e), ie({
      tag: "span",
      cls: `ag-icon ag-icon-${n ?? e}`,
      role: "presentation",
      attrs: { unselectable: "on" }
    });
  }
}
var Fh = (
  /*css*/
  ".ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}.ag-dnd-ghost-not-allowed{border:var(--ag-drag-and-drop-image-not-allowed-border)}"
), Eh = {
  tag: "div",
  children: [
    {
      tag: "div",
      ref: "eGhost",
      cls: "ag-dnd-ghost ag-unselectable",
      children: [
        { tag: "span", ref: "eIcon", cls: "ag-dnd-ghost-icon ag-shake-left-to-right" },
        { tag: "div", ref: "eLabel", cls: "ag-dnd-ghost-label" }
      ]
    }
  ]
}, Ah = class extends O {
  constructor() {
    super(), this.dragSource = null, this.eIcon = P, this.eLabel = P, this.eGhost = P, this.registerCSS(Fh);
  }
  postConstruct() {
    const e = (t) => Dh(t, this.beans, null);
    this.dropIconMap = {
      pinned: e("columnMovePin"),
      hide: e("columnMoveHide"),
      move: e("columnMoveMove"),
      left: e("columnMoveLeft"),
      right: e("columnMoveRight"),
      group: e("columnMoveGroup"),
      aggregate: e("columnMoveValue"),
      pivot: e("columnMovePivot"),
      notAllowed: e("dropNotAllowed")
    };
  }
  init(e) {
    this.dragSource = e.dragSource, this.setTemplate(Eh), this.beans.environment.applyThemeClasses(this.eGhost);
  }
  destroy() {
    this.dragSource = null, super.destroy();
  }
  setIcon(e, t) {
    const { eGhost: o, eIcon: i, dragSource: s, dropIconMap: n, gos: r } = this;
    J(i);
    let l = null;
    e || (e = s?.getDefaultIconName ? s.getDefaultIconName() : "notAllowed"), l = n[e], o.classList.toggle("ag-dnd-ghost-not-allowed", e === "notAllowed"), i.classList.toggle("ag-shake-left-to-right", t), !(l === n.hide && r.get("suppressDragLeaveHidesColumns")) && l && i.appendChild(l);
  }
  setLabel(e) {
    this.eLabel.textContent = e;
  }
}, Mh = (
  /*css*/
  ".ag-checkbox-cell{height:100%}"
), Th = {
  tag: "div",
  cls: "ag-cell-wrapper ag-checkbox-cell",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, Ih = class extends O {
  constructor() {
    super(Th, [Rr]), this.eCheckbox = P, this.registerCSS(Mh);
  }
  init(e) {
    this.refresh(e);
    const { eCheckbox: t, beans: o } = this, i = t.getInputElement();
    i.setAttribute("tabindex", "-1"), Dn(i, "polite"), this.addManagedListeners(i, {
      click: (s) => {
        if (Ct(s), t.isDisabled())
          return;
        const n = t.getValue();
        this.onCheckboxChanged(n);
      },
      dblclick: (s) => {
        Ct(s);
      }
    }), this.addManagedElementListeners(e.eGridCell, {
      keydown: (s) => {
        if (s.key === w.SPACE && !t.isDisabled()) {
          e.eGridCell === N(o) && t.toggle();
          const n = t.getValue();
          this.onCheckboxChanged(n), s.preventDefault();
        }
      }
    });
  }
  refresh(e) {
    return this.params = e, this.updateCheckbox(e), !0;
  }
  updateCheckbox(e) {
    let t, o = !0;
    const { value: i, column: s, node: n } = e;
    if (n.group && s)
      if (typeof i == "boolean")
        t = i;
      else {
        const u = s.getColId();
        u.startsWith(Vo) ? t = i == null || i === "" ? void 0 : i === "true" : n.aggData && n.aggData[u] !== void 0 || n.sourceRowIndex >= 0 ? t = i ?? void 0 : o = !1;
      }
    else
      t = i ?? void 0;
    const { eCheckbox: r } = this;
    if (!o) {
      r.setDisplayed(!1);
      return;
    }
    r.setValue(t);
    const l = e.disabled ?? !s?.isCellEditable(n);
    r.setDisabled(l);
    const a = this.getLocaleTextFunc(), d = qi(a, t), c = l ? d : `${a("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${d})`;
    r.setInputAriaLabel(c);
  }
  onCheckboxChanged(e) {
    const { params: t } = this, { column: o, node: i, value: s } = t;
    this.beans?.editSvc?.setEditingCells(
      [
        {
          column: o,
          colId: o.getColId(),
          rowIndex: i.rowIndex,
          rowPinned: i.rowPinned,
          state: "changed",
          oldValue: s,
          newValue: s
        }
      ],
      { update: !0, forceRefreshOfEditCellsOnly: !0 }
    );
    const n = i.setDataValue(o, e, "renderer");
    this.beans.editSvc?.stopEditing(
      {
        rowNode: i,
        column: o
      },
      { source: this.beans.editSvc?.isBatchEditing() ? "ui" : "api" }
    ), n || this.updateCheckbox(t);
  }
};
function Qt(e) {
  return !!(e.rowPinned && e.pinnedSibling);
}
function ne(e, t, o, i) {
  const s = t === "top";
  if (!o)
    return ne(
      e,
      t,
      s ? e.getPinnedTopRow(0) : e.getPinnedBottomRow(0),
      i
    );
  if (!i) {
    const a = s ? e.getPinnedTopRowCount() : e.getPinnedBottomRowCount();
    return ne(
      e,
      t,
      o,
      s ? e.getPinnedTopRow(a - 1) : e.getPinnedBottomRow(a - 1)
    );
  }
  let n = !1, r = !1;
  const l = [];
  return e.forEachPinnedRow(t, (a) => {
    if (a === o && !n) {
      n = !0, l.push(a);
      return;
    }
    if (n && a === i) {
      r = !0, l.push(a);
      return;
    }
    n && !r && l.push(a);
  }), l;
}
var kh = {
  tag: "div",
  cls: "ag-selection-checkbox",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, Lh = class extends O {
  constructor() {
    super(kh, [Rr]), this.eCheckbox = P;
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.getLocaleTextFunc(), { rowNode: t, eCheckbox: o } = this, i = t.isSelected(), s = qi(e, i), [n, r] = t.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], l = e(n, r);
    o.setValue(i, !0), o.setInputAriaLabel(`${l} (${s})`);
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListeners(this.eCheckbox.getInputElement(), {
      // we don't want double click on this icon to open a group
      dblclick: Ct,
      click: (i) => {
        Ct(i), this.beans.selectionSvc?.handleSelectionEvent(i, this.rowNode, "checkboxSelected");
      }
    }), this.addManagedListeners(this.rowNode, {
      rowSelected: this.onSelectionChanged.bind(this),
      dataChanged: this.onDataChanged.bind(this),
      selectableChanged: this.onSelectableChanged.bind(this)
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: i, previousValue: s }) => {
      const n = typeof i == "object" ? qo(i) : void 0, r = typeof s == "object" ? qo(s) : void 0;
      n !== r && this.onSelectableChanged();
    }), Ai(this.gos) || typeof this.getIsVisible() == "function") {
      const i = this.showOrHideSelect.bind(this);
      this.addManagedEventListeners({ displayedColumnsChanged: i }), this.addManagedListeners(this.rowNode, {
        dataChanged: i,
        cellChanged: i
      }), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  showOrHideSelect() {
    const { column: e, rowNode: t, overrides: o, gos: i } = this, s = t.selectable, n = this.getIsVisible();
    let r;
    if (typeof n == "function") {
      const u = o?.callbackParams;
      if (!e)
        r = n({ ...u, node: t, data: t.data });
      else {
        const h = e.createColumnFunctionCallbackParams(t);
        r = n({ ...u, ...h });
      }
    } else
      r = n ?? !1;
    const l = s && !r || !s && r, a = s || r, d = i.get("rowSelection"), c = d && typeof d != "string" ? !qo(d) : !!e?.getColDef().showDisabledCheckboxes;
    this.setVisible(a && (l ? c : !0)), this.setDisplayed(a && (l ? c : !0)), a && this.eCheckbox.setDisabled(l), o?.removeHidden && this.setDisplayed(a);
  }
  getIsVisible() {
    const e = this.overrides;
    if (e)
      return e.isVisible;
    const t = this.gos.get("rowSelection");
    return t && typeof t != "string" ? rt(t) : this.column?.getColDef()?.checkboxSelection;
  }
}, Gh = class {
  constructor(e, t) {
    this.rowModel = e, this.pinnedRowModel = t, this.selectAll = !1, this.rootId = null, this.endId = null, this.cachedRange = [];
  }
  reset() {
    this.rootId = null, this.endId = null, this.cachedRange.length = 0;
  }
  setRoot(e) {
    this.rootId = e.id, this.endId = null, this.cachedRange.length = 0;
  }
  setEndRange(e) {
    this.endId = e.id, this.cachedRange.length = 0;
  }
  getRange() {
    if (this.cachedRange.length === 0) {
      const e = this.getRoot(), t = this.getEnd();
      if (e == null || t == null)
        return this.cachedRange;
      this.cachedRange = this.getNodesInRange(e, t) ?? [];
    }
    return this.cachedRange;
  }
  isInRange(e) {
    return this.rootId === null ? !1 : this.getRange().some((t) => t.id === e.id);
  }
  getRoot(e) {
    if (this.rootId)
      return this.getRowNode(this.rootId);
    if (e)
      return this.setRoot(e), e;
  }
  getEnd() {
    if (this.endId)
      return this.getRowNode(this.endId);
  }
  getRowNode(e) {
    let t;
    const { rowModel: o, pinnedRowModel: i } = this;
    return t ?? (t = o.getRowNode(e)), i?.isManual() && (t ?? (t = i.getPinnedRowById(e, "top")), t ?? (t = i.getPinnedRowById(e, "bottom"))), t;
  }
  /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  truncate(e) {
    const t = this.getRange();
    if (t.length === 0)
      return { keep: [], discard: [] };
    const o = t[0].id === this.rootId, i = t.findIndex((s) => s.id === e.id);
    if (i > -1) {
      const s = t.slice(0, i), n = t.slice(i + 1);
      return this.setEndRange(e), o ? { keep: s, discard: n } : { keep: n, discard: s };
    } else
      return { keep: t, discard: [] };
  }
  /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  extend(e, t = !1) {
    const o = this.getRoot();
    if (o == null) {
      const s = this.getRange().slice();
      return t && e.depthFirstSearch((n) => !n.group && s.push(n)), s.push(e), this.setRoot(e), { keep: s, discard: [] };
    }
    const i = this.getNodesInRange(o, e);
    if (!i)
      return this.setRoot(e), { keep: [e], discard: [] };
    if (i.find((s) => s.id === this.endId))
      return this.setEndRange(e), { keep: this.getRange(), discard: [] };
    {
      const s = this.getRange().slice();
      return this.setEndRange(e), { keep: this.getRange(), discard: s };
    }
  }
  getNodesInRange(e, t) {
    const { pinnedRowModel: o, rowModel: i } = this;
    if (!o?.isManual())
      return i.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && !t.rowPinned)
      return ne(o, "top", e, void 0).concat(i.getNodesInRangeForSelection(i.getRow(0), t) ?? []);
    if (e.rowPinned === "bottom" && !t.rowPinned) {
      const s = ne(o, "bottom", void 0, e), n = i.getRowCount(), r = i.getRow(n - 1);
      return (i.getNodesInRangeForSelection(t, r) ?? []).concat(s);
    }
    if (!e.rowPinned && !t.rowPinned)
      return i.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && t.rowPinned === "top")
      return ne(o, "top", e, t);
    if (e.rowPinned === "bottom" && t.rowPinned === "top") {
      const s = ne(o, "top", t, void 0), n = ne(o, "bottom", void 0, e), r = i.getRow(0), l = i.getRow(i.getRowCount() - 1);
      return s.concat(i.getNodesInRangeForSelection(r, l) ?? []).concat(n);
    }
    if (!e.rowPinned && t.rowPinned === "top")
      return ne(o, "top", t, void 0).concat(i.getNodesInRangeForSelection(i.getRow(0), e) ?? []);
    if (e.rowPinned === "top" && t.rowPinned === "bottom") {
      const s = ne(o, "top", e, void 0), n = ne(o, "bottom", void 0, t), r = i.getRow(0), l = i.getRow(i.getRowCount() - 1);
      return s.concat(i.getNodesInRangeForSelection(r, l) ?? []).concat(n);
    }
    if (e.rowPinned === "bottom" && t.rowPinned === "bottom")
      return ne(o, "bottom", e, t);
    if (!e.rowPinned && t.rowPinned === "bottom") {
      const s = ne(o, "bottom", void 0, t), n = i.getRow(i.getRowCount());
      return (i.getNodesInRangeForSelection(e, n) ?? []).concat(s);
    }
    return null;
  }
}, Hh = class extends b {
  constructor(e) {
    super(), this.column = e, this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(N(this.beans)) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e;
    const t = this.createManagedBean(new yr());
    this.cbSelectAll = t, t.addCss("ag-header-select-all"), Ie(t.getGui(), "presentation"), this.showOrHideSelectAll();
    const o = this.updateStateOfCheckbox.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: () => this.showOrHideSelectAll(),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      selectionChanged: o,
      paginationChanged: o,
      modelUpdated: o
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: i, previousValue: s }) => {
      const n = (r) => typeof r == "string" || !r || r.mode === "singleRow" ? void 0 : r.selectAll;
      n(i) !== n(s) && this.showOrHideSelectAll(), this.updateStateOfCheckbox();
    }), this.addManagedListeners(t, { fieldValueChanged: this.onCbSelectAll.bind(this) }), t.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onDisplayedColumnsChanged(e) {
    this.isAlive() && this.showOrHideSelectAll(e.source === "uiColumnMoved");
  }
  showOrHideSelectAll(e = !1) {
    const t = this.isCheckboxSelection();
    this.cbSelectAllVisible = t, this.cbSelectAll.setDisplayed(t), t && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel(e);
  }
  updateStateOfCheckbox() {
    if (!this.cbSelectAllVisible || this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.getSelectAllMode(), t = this.beans.selectionSvc, o = this.cbSelectAll, i = t.getSelectAllState(e);
    o.setValue(i);
    const s = t.hasNodesToSelect(e);
    o.setDisabled(!s), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel(e = !1) {
    const t = this.getLocaleTextFunc(), { headerCellCtrl: o, cbSelectAll: i, cbSelectAllVisible: s } = this, n = i.getValue(), r = qi(t, n), l = t("ariaRowSelectAll", "Press Space to toggle all rows selection");
    o.setAriaDescriptionProperty(
      "selectAll",
      s ? `${l} (${r})` : null
    ), i.setInputAriaLabel(t("ariaHeaderSelection", "Column with Header Selection")), e || o.announceAriaDescription();
  }
  checkSelectionType(e) {
    return Nt(this.gos) ? !0 : (F(128, { feature: e }), !1);
  }
  checkRightRowModelType(e) {
    const { gos: t, rowModel: o } = this.beans;
    return re(t) || rs(t) ? !0 : (F(129, { feature: e, rowModel: o.getType() }), !1);
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.getSelectAllMode();
    let o = "uiSelectAll";
    t === "currentPage" ? o = "uiSelectAllCurrentPage" : t === "filtered" && (o = "uiSelectAllFiltered");
    const i = { source: o, selectAll: t }, s = this.beans.selectionSvc;
    e ? s.selectAllRowNodes(i) : s.deselectAllRowNodes(i);
  }
  /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */
  isCheckboxSelection() {
    const { column: e, gos: t, beans: o } = this, n = typeof t.get("rowSelection") == "object" ? "headerCheckbox" : "headerCheckboxSelection";
    return Xr(o, e) && this.checkRightRowModelType(n) && this.checkSelectionType(n);
  }
  getSelectAllMode() {
    const e = or(this.gos, !1);
    if (e)
      return e;
    const { headerCheckboxSelectionCurrentPageOnly: t, headerCheckboxSelectionFilteredOnly: o } = this.column.getColDef();
    return t ? "currentPage" : o ? "filtered" : "all";
  }
  destroy() {
    super.destroy(), this.cbSelectAll = void 0, this.headerCellCtrl = void 0;
  }
};
function Xr({ gos: e, selectionColSvc: t }, o) {
  const i = e.get("rowSelection"), s = o.getColDef(), { headerCheckboxSelection: n } = s;
  let r = !1;
  if (typeof i == "object") {
    const a = He(o), d = lr(o);
    (Ro(i) === "autoGroupColumn" && d || a && t?.isSelectionColumnEnabled()) && (r = co(i));
  } else typeof n == "function" ? r = n(L(e, { column: o, colDef: s })) : r = !!n;
  return r;
}
var Oh = class extends b {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.selectionCtx = new Gh(t.rowModel, t.pinnedRowModel), this.addManagedPropertyListeners(["isRowSelectable", "rowSelection"], () => {
      const o = Ai(e);
      o !== this.isRowSelectable && (this.isRowSelectable = o, this.updateSelectable());
    }), this.isRowSelectable = Ai(e), this.addManagedEventListeners({
      cellValueChanged: (o) => this.updateRowSelectable(o.node),
      rowNodeDataChanged: (o) => this.updateRowSelectable(o.node)
    });
  }
  destroy() {
    super.destroy(), this.selectionCtx.reset();
  }
  createCheckboxSelectionComponent() {
    return new Lh();
  }
  createSelectAllFeature(e) {
    if (Xr(this.beans, e))
      return new Hh(e);
  }
  isMultiSelect() {
    return Nt(this.gos);
  }
  onRowCtrlSelected(e, t, o) {
    const i = !!e.rowNode.isSelected();
    e.forEachGui(o, (s) => {
      s.rowComp.toggleCss("ag-row-selected", i);
      const n = s.element;
      An(n, i), n.contains(N(this.beans)) && t(s);
    });
  }
  announceAriaRowSelection(e) {
    if (this.isRowSelectionBlocked(e))
      return;
    const t = e.isSelected(), o = this.beans.editSvc?.isEditing({ rowNode: e });
    if (!e.selectable || o)
      return;
    const s = this.getLocaleTextFunc()(
      t ? "ariaRowDeselect" : "ariaRowSelect",
      `Press SPACE to ${t ? "deselect" : "select"} this row`
    );
    this.beans.ariaAnnounce?.announceValue(s, "rowSelection");
  }
  isRowSelectionBlocked(e) {
    return !e.selectable || e.rowPinned && !Qt(e) || !ze(this.gos);
  }
  updateRowSelectable(e, t) {
    const o = e.rowPinned && e.pinnedSibling ? (
      // If row node is pinned sibling, copy selectable status over from sibling row node
      e.pinnedSibling.selectable
    ) : (
      // otherwise calculate selectable state directly
      this.isRowSelectable?.(e) ?? !0
    );
    return this.setRowSelectable(e, o, t), o;
  }
  setRowSelectable(e, t, o) {
    if (e.selectable !== t) {
      if (e.selectable = t, e.dispatchRowEvent("selectableChanged"), o)
        return;
      if (zt(this.gos)) {
        const s = this.calculateSelectedFromChildren(e);
        this.setNodesSelected({ nodes: [e], newValue: s ?? !1, source: "selectableChanged" });
        return;
      }
      e.isSelected() && !e.selectable && this.setNodesSelected({ nodes: [e], newValue: !1, source: "selectableChanged" });
    }
  }
  calculateSelectedFromChildren(e) {
    let t = !1, o = !1;
    if (!e.childrenAfterGroup?.length)
      return e.selectable ? e.__selected : null;
    for (let i = 0; i < e.childrenAfterGroup.length; i++) {
      const s = e.childrenAfterGroup[i];
      let n = s.isSelected();
      if (!s.selectable) {
        const r = this.calculateSelectedFromChildren(s);
        if (r === null)
          continue;
        n = r;
      }
      switch (n) {
        case !0:
          t = !0;
          break;
        case !1:
          o = !0;
          break;
        default:
          return;
      }
    }
    if (!(t && o))
      return t ? !0 : o ? !1 : e.selectable ? e.__selected : null;
  }
  selectRowNode(e, t, o, i = "api") {
    const s = !e.selectable && t, n = e.__selected === t;
    if (s || n)
      return !1;
    e.__selected = t, e.dispatchRowEvent("rowSelected");
    const r = e.sibling;
    r && r.footer && r.__localEventService && r.dispatchRowEvent("rowSelected");
    const l = e.pinnedSibling;
    return l?.rowPinned && l.__localEventService && l.dispatchRowEvent("rowSelected"), this.eventSvc.dispatchEvent({
      ...fu(e, this.gos, "rowSelected"),
      event: o || null,
      source: i
    }), !0;
  }
  isCellCheckboxSelection(e, t) {
    const o = this.gos.get("rowSelection");
    if (o && typeof o != "string") {
      const i = He(e) && rt(o);
      return e.isColumnFunc(t, i);
    } else
      return e.isColumnFunc(t, e.colDef.checkboxSelection);
  }
  inferNodeSelections(e, t, o, i) {
    const { gos: s, selectionCtx: n } = this, r = e.isSelected(), l = zt(s), a = Qa(s), d = Xa(s), c = this.isMultiSelect(), u = i === "rowClicked";
    if (u && !(a || d))
      return null;
    if (t && o && c) {
      const h = n.getRoot();
      if (h)
        if (h.isSelected()) {
          const g = n.isInRange(e) ? n.truncate(e) : n.extend(e, l);
          return {
            deselect: g.discard,
            select: g.keep,
            reset: !1
          };
        } else {
          const g = n.extend(e, l);
          return {
            select: [],
            deselect: g.keep,
            reset: !1
          };
        }
      else return null;
    } else if (t && c) {
      const h = n.selectAll ? this.beans.rowModel.getRow(0) : void 0, g = n.getRoot(h), p = n.isInRange(e) ? n.truncate(e) : n.extend(e, l);
      return {
        select: p.keep,
        deselect: p.discard,
        reset: n.selectAll || !!(g && !g.isSelected())
      };
    } else if (o) {
      if (u) {
        const h = !r;
        return h && !a || !h && !d ? null : (n.setRoot(e), {
          node: e,
          newValue: h,
          clearSelection: !1
        });
      }
      return n.setRoot(e), {
        node: e,
        newValue: !r,
        clearSelection: !c
      };
    } else {
      n.setRoot(e);
      const h = Ja(s), g = Po(s) === "filteredDescendants", p = u && (!h || !a);
      if (g && r === void 0 && re(s))
        return {
          node: e,
          newValue: !1,
          checkFilteredNodes: !0,
          clearSelection: !c || p
        };
      if (u) {
        const f = r ? !h : a;
        return f === r && !p || f && !a || !f && !d ? null : {
          node: e,
          newValue: f,
          clearSelection: !c || p,
          keepDescendants: e.group && l
        };
      }
      return {
        node: e,
        newValue: !r,
        clearSelection: !c || p
      };
    }
  }
}, ai = {
  TAB_GUARD: "ag-tab-guard",
  TAB_GUARD_TOP: "ag-tab-guard-top",
  TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
}, Bh = class extends b {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1, this.allowFocus = !1;
    const {
      comp: t,
      eTopGuard: o,
      eBottomGuard: i,
      focusTrapActive: s,
      forceFocusOutWhenTabGuardsAreEmpty: n,
      isFocusableContainer: r,
      focusInnerElement: l,
      onFocusIn: a,
      onFocusOut: d,
      shouldStopEventPropagation: c,
      onTabKeyDown: u,
      handleKeyDown: h,
      isEmpty: g,
      eFocusableElement: p
    } = e;
    this.comp = t, this.eTopGuard = o, this.eBottomGuard = i, this.providedFocusInnerElement = l, this.eFocusableElement = p, this.focusTrapActive = !!s, this.forceFocusOutWhenTabGuardsAreEmpty = !!n, this.isFocusableContainer = !!r, this.providedFocusIn = a, this.providedFocusOut = d, this.providedShouldStopEventPropagation = c, this.providedOnTabKeyDown = u, this.providedHandleKeyDown = h, this.providedIsEmpty = g;
  }
  postConstruct() {
    this.createManagedBean(
      new _o(this.eFocusableElement, {
        shouldStopEventPropagation: () => this.shouldStopEventPropagation(),
        onTabKeyDown: (e) => this.onTabKeyDown(e),
        handleKeyDown: (e) => this.handleKeyDown(e),
        onFocusIn: (e) => this.onFocusIn(e),
        onFocusOut: (e) => this.onFocusOut(e)
      })
    ), this.activateTabGuards();
    for (const e of [this.eTopGuard, this.eBottomGuard])
      this.addManagedElementListeners(e, { focus: this.onFocus.bind(this) });
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget) && !this.allowFocus) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = !1;
      return;
    }
    if (this.forceFocusOutWhenTabGuardsAreEmpty && (this.providedIsEmpty ? this.providedIsEmpty() : at(this.eFocusableElement, ".ag-tab-guard").length === 0)) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget))
      return;
    const t = e.target === this.eBottomGuard;
    !(this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t)) && this.forceFocusOutWhenTabGuardsAreEmpty && this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
  }
  findNextElementOutsideAndFocus(e) {
    const t = j(this.beans), o = at(t.body, null, !0), i = o.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (i === -1)
      return;
    let s, n;
    e ? (s = 0, n = i) : (s = i + 1, n = o.length);
    const r = o.slice(s, n), l = this.gos.get("tabIndex");
    r.sort((a, d) => {
      const c = Number.parseInt(a.getAttribute("tabindex") || "0"), u = Number.parseInt(d.getAttribute("tabindex") || "0");
      return u === l ? 1 : c === l ? -1 : c === 0 ? 1 : u === 0 ? -1 : c - u;
    }), r[e ? r.length - 1 : 0]?.focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || this.forcingFocusOut || (this.providedFocusIn && this.providedFocusIn(e), this.isFocusableContainer || this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const o = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), o && (o.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = at(this.eFocusableElement);
    return this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length ? (t[e ? t.length - 1 : 0].focus({ preventScroll: !0 }), !0) : !1;
  }
  getNextFocusableElement(e) {
    return qt(this.beans, this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e, t) {
    return e === this.eTopGuard && !t || e === this.eBottomGuard && (t ?? !0);
  }
  setAllowFocus(e) {
    this.allowFocus = e;
  }
}, Vh = class extends b {
  constructor(e) {
    super(), this.comp = e;
  }
  initialiseTabGuard(e) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.comp.getFocusableElement();
    const { eTopGuard: t, eBottomGuard: o, eFocusableElement: i } = this, s = [t, o], n = {
      setTabIndex: (C) => {
        for (const m of s)
          C != null ? m.setAttribute("tabindex", C) : m.removeAttribute("tabindex");
      }
    };
    this.addTabGuards(t, o);
    const {
      focusTrapActive: r = !1,
      onFocusIn: l,
      onFocusOut: a,
      focusInnerElement: d,
      handleKeyDown: c,
      onTabKeyDown: u,
      shouldStopEventPropagation: h,
      isEmpty: g,
      forceFocusOutWhenTabGuardsAreEmpty: p,
      isFocusableContainer: f
    } = e;
    this.tabGuardCtrl = this.createManagedBean(
      new Bh({
        comp: n,
        focusTrapActive: r,
        eTopGuard: t,
        eBottomGuard: o,
        eFocusableElement: i,
        onFocusIn: l,
        onFocusOut: a,
        focusInnerElement: d,
        handleKeyDown: c,
        onTabKeyDown: u,
        shouldStopEventPropagation: h,
        isEmpty: g,
        forceFocusOutWhenTabGuardsAreEmpty: p,
        isFocusableContainer: f
      })
    );
  }
  getTabGuardCtrl() {
    return this.tabGuardCtrl;
  }
  createTabGuard(e) {
    const t = j(this.beans).createElement("div"), o = e === "top" ? ai.TAB_GUARD_TOP : ai.TAB_GUARD_BOTTOM;
    return t.classList.add(ai.TAB_GUARD, o), Ie(t, "presentation"), t;
  }
  addTabGuards(e, t) {
    const o = this.eFocusableElement;
    o.insertAdjacentElement("afterbegin", e), o.insertAdjacentElement("beforeend", t);
  }
  removeAllChildrenExceptTabGuards() {
    const e = [this.eTopGuard, this.eBottomGuard];
    J(this.comp.getFocusableElement()), this.addTabGuards(...e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(e);
  }
  appendChild(e, t, o) {
    Ji(t) || (t = t.getGui());
    const { eBottomGuard: i } = this;
    i ? i.insertAdjacentElement("beforebegin", t) : e(t, o);
  }
  destroy() {
    const { eTopGuard: e, eBottomGuard: t } = this;
    Ae(e), Ae(t), super.destroy();
  }
}, Jr = class extends O {
  initialiseTabGuard(e) {
    this.tabGuardFeature = this.createManagedBean(new Vh(this)), this.tabGuardFeature.initialiseTabGuard(e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardFeature.forceFocusOutOfContainer(e);
  }
  appendChild(e, t) {
    this.tabGuardFeature.appendChild(super.appendChild.bind(this), e, t);
  }
}, Wh = 500, Nh = 550, so, zh = (e) => {
  if (!so)
    so = /* @__PURE__ */ new WeakSet();
  else if (so.has(e))
    return !1;
  return so.add(e), !0;
}, Be = class {
  constructor(e, t = !1) {
    this.eElement = e, this.preventClick = t, this.startListener = null, this.handlers = [], this.eventSvc = void 0, this.touchStart = null, this.lastTapTime = null, this.longPressTimer = 0, this.moved = !1;
  }
  addEventListener(e, t) {
    let o = this.eventSvc;
    if (!o) {
      if (o === null)
        return;
      this.eventSvc = o = new $e();
      const i = this.onTouchStart.bind(this);
      this.startListener = i, this.eElement.addEventListener("touchstart", i, { passive: !0 });
    }
    o.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.eventSvc?.removeEventListener(e, t);
  }
  onTouchStart(e) {
    if (this.touchStart || !zh(e))
      return;
    const t = e.touches[0];
    this.touchStart = t;
    const o = this.handlers;
    if (!o.length) {
      const i = this.eElement, s = i.ownerDocument, n = this.onTouchMove.bind(this), r = this.onTouchEnd.bind(this), l = this.onTouchCancel.bind(this), a = { passive: !0 }, d = { passive: !1 };
      lo(
        o,
        [i, "touchmove", n, a],
        [s, "touchcancel", l, a],
        // we set passive=false, as we want to prevent default on this event
        [s, "touchend", r, d],
        [s, "contextmenu", Fe, d]
      );
    }
    this.clearLongPress(), this.longPressTimer = window.setTimeout(() => {
      this.longPressTimer = 0, this.touchStart === t && !this.moved && (this.moved = !0, this.eventSvc?.dispatchEvent({ type: "longTap", touchStart: t, touchEvent: e }));
    }, Nh);
  }
  onTouchMove(e) {
    const { moved: t, touchStart: o } = this;
    if (!t && o) {
      const i = Mt(o, e.touches);
      i && !Vn(i, o, 4) && (this.clearLongPress(), this.moved = !0);
    }
  }
  onTouchEnd(e) {
    const t = this.touchStart;
    !t || !Mt(t, e.changedTouches) || (this.moved || (this.eventSvc?.dispatchEvent({ type: "tap", touchStart: t }), this.checkDoubleTap(t)), this.preventClick && Fe(e), this.cancel());
  }
  onTouchCancel(e) {
    const t = this.touchStart;
    !t || !Mt(t, e.changedTouches) || (this.lastTapTime = null, this.cancel());
  }
  checkDoubleTap(e) {
    let t = Date.now();
    const o = this.lastTapTime;
    o && t - o > Wh && (this.eventSvc?.dispatchEvent({ type: "doubleTap", touchStart: e }), t = null), this.lastTapTime = t;
  }
  cancel() {
    this.clearLongPress(), es(this.handlers), this.touchStart = null;
  }
  clearLongPress() {
    window.clearTimeout(this.longPressTimer), this.longPressTimer = 0, this.moved = !1;
  }
  destroy() {
    const e = this.startListener;
    e && (this.startListener = null, this.eElement.removeEventListener("touchstart", e)), this.cancel(), this.eElement = null, this.eventSvc = null;
  }
}, _h = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.batchFrameworkComps = !1, this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t(), this.baseDocLink = `${zn}/${this.frameworkName}-data-grid`, Na(this.baseDocLink);
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return this.baseDocLink + (e ? "/" + e : "");
  }
};
function Uh(e) {
  return {
    beanName: "gridApi",
    bean: e.getBean("apiFunctionSvc").api
  };
}
var $h = [
  // Validate license first
  "licenseManager",
  // core beans only
  "environment",
  "eventSvc",
  "gos",
  "paginationAutoPageSizeSvc",
  "apiFunctionSvc",
  "gridApi",
  "registry",
  "agCompUtils",
  "userCompFactory",
  "rowContainerHeight",
  "horizontalResizeSvc",
  "localeSvc",
  "pinnedRowModel",
  "dragSvc",
  "colGroupSvc",
  "visibleCols",
  "popupSvc",
  "selectionSvc",
  "colFilter",
  "quickFilter",
  "filterManager",
  "colModel",
  "headerNavigation",
  "pageBounds",
  "pagination",
  "pageBoundsListener",
  "rowSpanSvc",
  "stickyRowSvc",
  "rowRenderer",
  "expressionSvc",
  "alignedGridsSvc",
  "navigation",
  "valueCache",
  "valueSvc",
  "autoWidthCalc",
  "filterMenuFactory",
  "dragAndDrop",
  "focusSvc",
  "cellNavigation",
  "cellStyles",
  "scrollVisibleSvc",
  "sortSvc",
  "colHover",
  "colAnimation",
  "autoColSvc",
  "selectionColSvc",
  "changeDetectionSvc",
  "animationFrameSvc",
  "undoRedo",
  "colDefFactory",
  "rowStyleSvc",
  "rowNodeBlockLoader",
  "rowNodeSorter",
  "ctrlsSvc",
  "pinnedCols",
  "dataTypeSvc",
  "syncSvc",
  "overlays",
  "stateSvc",
  "expansionSvc",
  "apiEventSvc",
  "ariaAnnounce",
  "menuSvc",
  "colMoves",
  "colAutosize",
  "colFlex",
  "colResize",
  "pivotColsSvc",
  "valueColsSvc",
  "rowGroupColsSvc",
  "colNames",
  "colViewport",
  "pivotResultCols",
  "showRowGroupCols",
  "validation"
  // Have validations run last
], Xs = Object.fromEntries(
  $h.map((e, t) => [e, t])
);
function Kh(e, t) {
  const o = (e.beanName ? Xs[e.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER, i = (t.beanName ? Xs[t.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
  return o - i;
}
function jh(e, t) {
  return e?.beanName === "gridDestroySvc" ? -1 : t?.beanName === "gridDestroySvc" ? 1 : 0;
}
var qh = { tag: "div", cls: "ag-pinned-left-header", role: "rowgroup" }, Yh = { tag: "div", cls: "ag-pinned-right-header", role: "rowgroup" }, Zh = {
  tag: "div",
  cls: "ag-header-viewport",
  role: "rowgroup",
  attrs: { tabindex: "-1" },
  children: [{ tag: "div", ref: "eCenterContainer", cls: "ag-header-container", role: "presentation" }]
}, di = class extends O {
  constructor(e) {
    super(), this.eCenterContainer = P, this.headerRowComps = {}, this.rowCompsList = [], this.pinned = e;
  }
  postConstruct() {
    this.selectAndSetTemplate();
    const e = {
      setDisplayed: (o) => this.setDisplayed(o),
      setCtrls: (o) => this.setCtrls(o),
      // only gets called for center section
      setCenterWidth: (o) => this.eCenterContainer.style.width = o,
      setViewportScrollLeft: (o) => this.getGui().scrollLeft = o,
      // only gets called for pinned sections
      setPinnedContainerWidth: (o) => {
        const i = this.getGui();
        i.style.width = o, i.style.maxWidth = o, i.style.minWidth = o;
      }
    };
    this.createManagedBean(new bh(this.pinned)).setComp(e, this.getGui());
  }
  selectAndSetTemplate() {
    const e = this.pinned == "left", t = this.pinned == "right", o = e ? qh : t ? Yh : Zh;
    this.setTemplate(o), this.eRowContainer = this.eCenterContainer !== P ? this.eCenterContainer : this.getGui();
  }
  destroy() {
    this.setCtrls([]), super.destroy();
  }
  destroyRowComp(e) {
    this.destroyBean(e), e.getGui().remove();
  }
  setCtrls(e) {
    const t = this.headerRowComps;
    this.headerRowComps = {}, this.rowCompsList = [];
    let o;
    const i = (s) => {
      const n = s.getGui();
      n.parentElement != this.eRowContainer && this.eRowContainer.appendChild(n), o && Ln(this.eRowContainer, n, o), o = n;
    };
    for (const s of e) {
      const n = s.instanceId, r = t[n];
      delete t[n];
      const l = r || this.createBean(new mh(s));
      this.headerRowComps[n] = l, this.rowCompsList.push(l), i(l);
    }
    for (const s of Object.values(t))
      this.destroyRowComp(s);
  }
}, Qh = { tag: "div", cls: "ag-header", role: "presentation" }, Xh = class extends O {
  constructor() {
    super(Qh);
  }
  postConstruct() {
    const e = {
      toggleCss: (i, s) => this.toggleCss(i, s),
      setHeightAndMinHeight: (i) => {
        this.getGui().style.height = i, this.getGui().style.minHeight = i;
      }
    };
    this.createManagedBean(new ch()).setComp(e, this.getGui(), this.getFocusableElement());
    const o = (i) => {
      this.createManagedBean(i), this.appendChild(i);
    };
    o(new di("left")), o(new di(null)), o(new di("right"));
  }
}, Jh = {
  selector: "AG-HEADER-ROOT",
  component: Xh
}, eg = class extends O {
  constructor(e, t, o, i, s) {
    super(), this.cellCtrl = t, this.rendererVersion = 0, this.editorVersion = 0, this.beans = e, this.gos = e.gos, this.column = t.column, this.rowNode = t.rowNode, this.eRow = i;
    const n = ie({
      tag: "div",
      role: t.getCellAriaRole(),
      attrs: {
        "comp-id": `${this.getCompId()}`,
        "col-id": t.column.colIdSanitised
      }
    });
    this.eCell = n;
    let r;
    t.isCellSpanning() ? (r = ie({
      tag: "div",
      cls: "ag-spanned-cell-wrapper",
      role: "presentation"
    }), r.appendChild(n), this.setTemplateFromElement(r)) : this.setTemplateFromElement(n), this.cellCssManager = new Cr(() => n), this.forceWrapper = t.isForceWrapper(), this.refreshWrapper(!1);
    const l = {
      toggleCss: (a, d) => this.cellCssManager.toggleCss(a, d),
      setUserStyles: (a) => Kt(n, a),
      getFocusableElement: () => n,
      setIncludeSelection: (a) => this.includeSelection = a,
      setIncludeRowDrag: (a) => this.includeRowDrag = a,
      setIncludeDndSource: (a) => this.includeDndSource = a,
      setRenderDetails: (a, d, c) => this.setRenderDetails(a, d, c),
      setEditDetails: (a, d, c) => this.setEditDetails(a, d, c),
      getCellEditor: () => this.cellEditor || null,
      getCellRenderer: () => this.cellRenderer || null,
      getParentOfValue: () => this.getParentOfValue(),
      refreshEditStyles: (a, d) => this.refreshEditStyles(a, d)
    };
    t.setComp(l, n, r, this.eCellWrapper, o, s, void 0);
  }
  getParentOfValue() {
    return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
  }
  setRenderDetails(e, t, o) {
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const s = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), e ? !(o || s) && this.refreshCellRenderer(e) || (this.destroyRenderer(), this.createCellRendererInstance(e)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(t)), this.rowDraggingComp?.refreshVisibility();
  }
  setEditDetails(e, t, o) {
    e ? this.createCellEditorInstance(e, t, o) : this.destroyEditor();
  }
  removeControls() {
    const e = this.beans.context;
    this.checkboxSelectionComp = e.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = e.destroyBean(this.dndSourceComp), this.rowDraggingComp = e.destroyBean(this.rowDraggingComp);
  }
  // returns true if wrapper was changed
  refreshWrapper(e) {
    const t = this.includeRowDrag || this.includeDndSource || this.includeSelection, o = t || this.forceWrapper, i = o && this.eCellWrapper == null;
    i && (this.eCellWrapper = ie({ tag: "div", cls: "ag-cell-wrapper", role: "presentation" }), this.eCell.appendChild(this.eCellWrapper));
    const s = !o && this.eCellWrapper != null;
    s && (Ae(this.eCellWrapper), this.eCellWrapper = void 0), this.cellCssManager.toggleCss("ag-cell-value", !o);
    const n = !e && o, r = n && this.eCellValue == null;
    if (r) {
      const d = this.cellCtrl.getCellValueClass();
      this.eCellValue = ie({ tag: "span", cls: d, role: "presentation" }), this.eCellWrapper.appendChild(this.eCellValue);
    }
    const l = !n && this.eCellValue != null;
    l && (Ae(this.eCellValue), this.eCellValue = void 0);
    const a = i || s || r || l;
    return a && this.removeControls(), !e && t && this.addControls(), a;
  }
  addControls() {
    const { cellCtrl: e, eCellWrapper: t, eCellValue: o, includeRowDrag: i, includeDndSource: s, includeSelection: n } = this, r = (l) => {
      l && t.insertBefore(l.getGui(), o);
    };
    i && this.rowDraggingComp == null && (this.rowDraggingComp = e.createRowDragComp(), r(this.rowDraggingComp)), s && this.dndSourceComp == null && (this.dndSourceComp = e.createDndSource(), r(this.dndSourceComp)), n && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = e.createSelectionCheckbox(), r(this.checkboxSelectionComp));
  }
  createCellEditorInstance(e, t, o) {
    const i = this.editorVersion, s = e.newAgStackInstance(), { params: n } = e;
    s.then((l) => this.afterCellEditorCreated(i, l, n, t, o)), H(this.cellEditor) && n.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(e) {
    const t = this.getParentOfValue();
    J(t);
    const o = Oo(e);
    o != null && (t.textContent = o);
  }
  destroyRenderer() {
    const { context: e } = this.beans;
    this.cellRenderer = e.destroyBean(this.cellRenderer), Ae(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    const { context: e } = this.beans;
    (this.cellEditorPopupWrapper?.getGui().contains(N(this.beans)) || this.cellCtrl.hasBrowserFocus()) && this.eCell.focus({ preventScroll: !0 }), this.hideEditorPopup?.(), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), Ae(this.cellEditorGui), this.cellCtrl.disableEditorTooltipFeature(), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(e) {
    if (this.cellRenderer?.refresh == null || this.cellRendererClass !== e.componentClass)
      return !1;
    const t = this.cellRenderer.refresh(e.params);
    return t === !0 || t === void 0;
  }
  createCellRendererInstance(e) {
    const t = this.rendererVersion, o = (n) => (r) => {
      if (this.rendererVersion !== t || !this.isAlive())
        return;
      const a = n.newAgStackInstance(), d = this.afterCellRendererCreated.bind(
        this,
        t,
        n.componentClass
      );
      a?.then(d);
    }, { animationFrameSvc: i } = this.beans;
    let s;
    if (i?.active && this.firstRender ? s = (n, r = !1) => {
      i.createTask(
        o(n),
        this.rowNode.rowIndex,
        "p2",
        n.componentFromFramework,
        r
      );
    } : s = (n) => o(n)(), e.params?.deferRender && !this.cellCtrl.rowNode.group) {
      const { loadingComp: n, onReady: r } = this.cellCtrl.getDeferLoadingCellRenderer();
      n && (s(n), r.then(() => s(e, !0)));
    } else
      s(e);
  }
  afterCellRendererCreated(e, t, o) {
    if (!this.isAlive() || e !== this.rendererVersion) {
      this.beans.context.destroyBean(o);
      return;
    }
    this.cellRenderer = o, this.cellRendererClass = t;
    const s = o.getGui();
    if (this.cellRendererGui = s, s != null) {
      const n = this.getParentOfValue();
      J(n), n.appendChild(s);
    }
  }
  afterCellEditorCreated(e, t, o, i, s) {
    const n = e !== this.editorVersion, { context: r } = this.beans;
    if (n) {
      r.destroyBean(t);
      return;
    }
    if (t.isCancelBeforeStart?.()) {
      r.destroyBean(t), this.cellCtrl.stopEditing(!0);
      return;
    }
    if (!t.getGui) {
      F(97, { colId: this.column.getId() }), r.destroyBean(t);
      return;
    }
    this.cellEditor = t, this.cellEditorGui = t.getGui();
    const a = i || t.isPopup?.();
    a ? this.addPopupCellEditor(o, s) : this.addInCellEditor(), this.refreshEditStyles(!0, a), t.afterGuiAttached?.(), this.cellCtrl.enableEditorTooltipFeature(t), this.cellCtrl.cellEditorAttached();
  }
  refreshEditStyles(e, t) {
    const { cellCssManager: o } = this;
    o.toggleCss("ag-cell-inline-editing", e && !t), o.toggleCss("ag-cell-popup-editing", e && !!t), o.toggleCss("ag-cell-not-inline-editing", !e || !!t);
  }
  addInCellEditor() {
    const { eCell: e } = this;
    e.contains(N(this.beans)) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), J(this.getParentOfValue()), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(e, t) {
    const { gos: o, context: i, popupSvc: s, editSvc: n } = this.beans;
    o.get("editType") === "fullRow" && F(98);
    const r = this.cellEditorPopupWrapper = i.createBean(
      n.createPopupEditorWrapper(e)
    ), { cellEditor: l, cellEditorGui: a, eCell: d, rowNode: c, column: u, cellCtrl: h } = this, g = r.getGui();
    a && g.appendChild(a);
    const p = o.get("stopEditingWhenCellsLoseFocus"), f = t ?? l.getPopupPosition?.() ?? "over", C = o.get("enableRtl"), m = {
      ePopup: g,
      column: u,
      rowNode: c,
      type: "popupCellEditor",
      eventSource: d,
      position: f,
      alignSide: C ? "right" : "left",
      keepWithinBounds: !0
    }, v = s.positionPopupByComponent.bind(s, m), S = s.addPopup({
      modal: p,
      eChild: g,
      closeOnEsc: !0,
      closedCallback: () => {
        h.onPopupEditorClosed();
      },
      anchorToElement: d,
      positionCallback: v,
      ariaOwns: d
    });
    S && (this.hideEditorPopup = S.hideFunc);
  }
  detach() {
    this.getGui().remove();
  }
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroy() {
    this.destroyRenderer(), this.destroyEditor(), this.removeControls(), super.destroy();
  }
}, tg = class extends O {
  constructor(e, t, o) {
    super(), this.cellComps = /* @__PURE__ */ new Map(), this.beans = t, this.rowCtrl = e;
    const i = ie({ tag: "div", role: "row", attrs: { "comp-id": `${this.getCompId()}` } });
    this.setInitialStyle(i, o), this.setTemplateFromElement(i);
    const s = i.style;
    this.domOrder = this.rowCtrl.getDomOrder();
    const n = {
      setDomOrder: (r) => this.domOrder = r,
      setCellCtrls: (r) => this.setCellCtrls(r),
      showFullWidth: (r) => this.showFullWidth(r),
      getFullWidthCellRenderer: () => this.fullWidthCellRenderer,
      getFullWidthCellRendererParams: () => this.fullWidthCellRendererParams,
      toggleCss: (r, l) => this.toggleCss(r, l),
      setUserStyles: (r) => Kt(i, r),
      setTop: (r) => s.top = r,
      setTransform: (r) => s.transform = r,
      setRowIndex: (r) => i.setAttribute("row-index", r),
      setRowId: (r) => i.setAttribute("row-id", r),
      setRowBusinessKey: (r) => i.setAttribute("row-business-key", r),
      refreshFullWidth: (r) => {
        const l = r();
        return this.fullWidthCellRendererParams = l, this.fullWidthCellRenderer?.refresh?.(l) ?? !1;
      }
    };
    e.setComp(n, this.getGui(), o, void 0), this.addDestroyFunc(() => {
      e.unsetComp(o);
    });
  }
  setInitialStyle(e, t) {
    const o = this.rowCtrl.getInitialTransform(t);
    if (o)
      e.style.setProperty("transform", o);
    else {
      const i = this.rowCtrl.getInitialRowTop(t);
      i && e.style.setProperty("top", i);
    }
  }
  showFullWidth(e) {
    const t = (i) => {
      if (this.isAlive()) {
        const s = i.getGui();
        this.getGui().appendChild(s), this.rowCtrl.setupDetailRowAutoHeight(s), this.setFullWidthRowComp(i, e.params);
      } else
        this.beans.context.destroyBean(i);
    };
    e.newAgStackInstance().then(t);
  }
  setCellCtrls(e) {
    const t = new Map(this.cellComps);
    for (const o of e) {
      const i = o.instanceId;
      this.cellComps.has(i) ? t.delete(i) : this.newCellComp(o);
    }
    this.destroyCells(t), this.ensureDomOrder(e);
  }
  ensureDomOrder(e) {
    if (!this.domOrder)
      return;
    const t = [];
    for (const o of e) {
      const i = this.cellComps.get(o.instanceId);
      i && t.push(i.getGui());
    }
    Gn(this.getGui(), t);
  }
  newCellComp(e) {
    const t = this.beans.editSvc?.isEditing(e, { withOpenEditor: !0 }) ?? !1, o = new eg(this.beans, e, this.rowCtrl.printLayout, this.getGui(), t);
    this.cellComps.set(e.instanceId, o), this.getGui().appendChild(o.getGui());
  }
  destroy() {
    super.destroy(), this.destroyCells(this.cellComps);
  }
  setFullWidthRowComp(e, t) {
    this.fullWidthCellRenderer = e, this.fullWidthCellRendererParams = t, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer), this.fullWidthCellRendererParams = void 0;
    });
  }
  destroyCells(e) {
    for (const t of e.values()) {
      if (!t)
        return;
      const o = t.cellCtrl.instanceId;
      if (this.cellComps.get(o) !== t)
        return;
      t.detach(), t.destroy(), this.cellComps.delete(o);
    }
  }
};
function og(e, t, o) {
  const i = !!o.gos.get("enableCellSpan") && !!t.getSpannedRowCtrls, s = {
    tag: "div",
    ref: "eContainer",
    cls: po(e),
    role: "rowgroup"
  };
  if (t.type === "center" || i) {
    const n = {
      tag: "div",
      ref: "eSpannedContainer",
      cls: `ag-spanning-container ${ku(e)}`,
      role: "presentation"
    };
    return s.role = "presentation", {
      tag: "div",
      ref: "eViewport",
      cls: `ag-viewport ${Vr(e)}`,
      role: "rowgroup",
      children: [s, i ? n : null]
    };
  }
  return s;
}
var ig = class extends O {
  constructor(e) {
    super(), this.eViewport = P, this.eContainer = P, this.eSpannedContainer = P, this.rowCompsNoSpan = {}, this.rowCompsWithSpan = {}, this.name = e?.name, this.options = Yt(this.name);
  }
  postConstruct() {
    this.setTemplate(og(this.name, this.options, this.beans));
    const e = {
      setHorizontalScroll: (o) => this.eViewport.scrollLeft = o,
      setViewportHeight: (o) => this.eViewport.style.height = o,
      setRowCtrls: ({ rowCtrls: o }) => this.setRowCtrls(o),
      setSpannedRowCtrls: (o) => this.setRowCtrls(o, !0),
      setDomOrder: (o) => {
        this.domOrder = o;
      },
      setContainerWidth: (o) => {
        this.eContainer.style.width = o, this.eSpannedContainer && (this.eSpannedContainer.style.width = o);
      },
      setOffsetTop: (o) => {
        const i = `translateY(${o})`;
        this.eContainer.style.transform = i, this.eSpannedContainer && (this.eSpannedContainer.style.transform = i);
      }
    };
    this.createManagedBean(new _u(this.name)).setComp(e, this.eContainer, this.eSpannedContainer, this.eViewport);
  }
  destroy() {
    this.setRowCtrls([]), this.setRowCtrls([], !0), super.destroy(), this.lastPlacedElement = null;
  }
  setRowCtrls(e, t) {
    const { beans: o, options: i } = this, s = t ? this.eSpannedContainer : this.eContainer, n = t ? { ...this.rowCompsWithSpan } : { ...this.rowCompsNoSpan }, r = {};
    t ? this.rowCompsWithSpan = r : this.rowCompsNoSpan = r, this.lastPlacedElement = null;
    const l = [];
    for (const a of e) {
      const d = a.instanceId, c = n[d];
      let u;
      if (c)
        u = c, delete n[d];
      else {
        if (!a.rowNode.displayed)
          continue;
        u = new tg(a, o, i.type);
      }
      r[d] = u, l.push([u, !c]);
    }
    this.removeOldRows(Object.values(n)), this.addRowNodes(l, s);
  }
  addRowNodes(e, t) {
    const { domOrder: o } = this;
    for (const [i, s] of e) {
      const n = i.getGui();
      o ? this.ensureDomOrder(n, t) : s && t.appendChild(n);
    }
  }
  removeOldRows(e) {
    for (const t of e)
      t.getGui().remove(), t.destroy();
  }
  ensureDomOrder(e, t) {
    Ln(t, e, this.lastPlacedElement), this.lastPlacedElement = e;
  }
}, sg = {
  selector: "AG-ROW-CONTAINER",
  component: ig
};
function Rt(e, t) {
  return t.map((o) => {
    const i = `e${o[0].toUpperCase() + o.substring(1)}RowContainer`;
    return e[i] = { name: o }, {
      tag: "ag-row-container",
      ref: i,
      attrs: { name: o }
    };
  });
}
function ng(e) {
  const t = {}, o = {
    tag: "div",
    ref: "eGridRoot",
    cls: "ag-root ag-unselectable",
    children: [
      { tag: "ag-header-root" },
      {
        tag: "div",
        ref: "eTop",
        cls: "ag-floating-top",
        role: "presentation",
        children: Rt(t, ["topLeft", "topCenter", "topRight", "topFullWidth"])
      },
      {
        tag: "div",
        ref: "eBody",
        cls: "ag-body",
        role: "presentation",
        children: [
          {
            tag: "div",
            ref: "eBodyViewport",
            cls: "ag-body-viewport",
            role: "presentation",
            children: Rt(t, ["left", "center", "right", "fullWidth"])
          },
          { tag: "ag-fake-vertical-scroll" }
        ]
      },
      {
        tag: "div",
        ref: "eStickyTop",
        cls: "ag-sticky-top",
        role: "presentation",
        children: Rt(t, [
          "stickyTopLeft",
          "stickyTopCenter",
          "stickyTopRight",
          "stickyTopFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eStickyBottom",
        cls: "ag-sticky-bottom",
        role: "presentation",
        children: Rt(t, [
          "stickyBottomLeft",
          "stickyBottomCenter",
          "stickyBottomRight",
          "stickyBottomFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eBottom",
        cls: "ag-floating-bottom",
        role: "presentation",
        children: Rt(t, [
          "bottomLeft",
          "bottomCenter",
          "bottomRight",
          "bottomFullWidth"
        ])
      },
      { tag: "ag-fake-horizontal-scroll" },
      e ? { tag: "ag-overlay-wrapper" } : null
    ]
  };
  return { paramsMap: t, elementParams: o };
}
var rg = class extends O {
  constructor() {
    super(...arguments), this.eGridRoot = P, this.eBodyViewport = P, this.eStickyTop = P, this.eStickyBottom = P, this.eTop = P, this.eBottom = P, this.eBody = P;
  }
  postConstruct() {
    const { overlays: e, rangeSvc: t } = this.beans, o = e?.getOverlayWrapperSelector(), { paramsMap: i, elementParams: s } = ng(!!o);
    this.setTemplate(
      s,
      [
        ...o ? [o] : [],
        Zu,
        Ju,
        Jh,
        sg
      ],
      i
    );
    const n = (l, a) => {
      const d = `${l}px`;
      a.style.minHeight = d, a.style.height = d;
    }, r = {
      setRowAnimationCssOnBodyViewport: (l, a) => this.setRowAnimationCssOnBodyViewport(l, a),
      setColumnCount: (l) => oa(this.getGui(), l),
      setRowCount: (l) => ta(this.getGui(), l),
      setTopHeight: (l) => n(l, this.eTop),
      setBottomHeight: (l) => n(l, this.eBottom),
      setTopInvisible: (l) => this.eTop.classList.toggle("ag-invisible", l),
      setBottomInvisible: (l) => this.eBottom.classList.toggle("ag-invisible", l),
      setStickyTopHeight: (l) => this.eStickyTop.style.height = l,
      setStickyTopTop: (l) => this.eStickyTop.style.top = l,
      setStickyTopWidth: (l) => this.eStickyTop.style.width = l,
      setStickyBottomHeight: (l) => {
        this.eStickyBottom.style.height = l, this.eStickyBottom.classList.toggle("ag-invisible", l === "0px");
      },
      setStickyBottomBottom: (l) => this.eStickyBottom.style.bottom = l,
      setStickyBottomWidth: (l) => this.eStickyBottom.style.width = l,
      setColumnMovingCss: (l, a) => this.toggleCss(l, a),
      updateLayoutClasses: (l, a) => {
        const d = [this.eBodyViewport.classList, this.eBody.classList];
        for (const c of d)
          c.toggle(ae.AUTO_HEIGHT, a.autoHeight), c.toggle(ae.NORMAL, a.normal), c.toggle(ae.PRINT, a.print);
        this.toggleCss(ae.AUTO_HEIGHT, a.autoHeight), this.toggleCss(ae.NORMAL, a.normal), this.toggleCss(ae.PRINT, a.print);
      },
      setAlwaysVerticalScrollClass: (l, a) => this.eBodyViewport.classList.toggle(zr, a),
      registerBodyViewportResizeListener: (l) => {
        const a = wt(this.beans, this.eBodyViewport, l);
        this.addDestroyFunc(() => a());
      },
      setPinnedTopBottomOverflowY: (l) => this.eTop.style.overflowY = this.eBottom.style.overflowY = l,
      setCellSelectableCss: (l, a) => {
        for (const d of [this.eTop, this.eBodyViewport, this.eBottom])
          d.classList.toggle(l, a);
      },
      setBodyViewportWidth: (l) => this.eBodyViewport.style.width = l,
      setGridRootRole: (l) => Ie(this.eGridRoot, l)
    };
    this.ctrl = this.createManagedBean(new Ku()), this.ctrl.setComp(
      r,
      this.getGui(),
      this.eBodyViewport,
      this.eTop,
      this.eBottom,
      this.eStickyTop,
      this.eStickyBottom
    ), (t && ht(this.gos) || Nt(this.gos)) && ea(this.getGui(), !0);
  }
  setRowAnimationCssOnBodyViewport(e, t) {
    const o = this.eBodyViewport.classList;
    o.toggle("ag-row-animation", t), o.toggle("ag-row-no-animation", !t);
  }
}, lg = {
  selector: "AG-GRID-BODY",
  component: rg
}, ag = class extends b {
  constructor() {
    super(...arguments), this.additionalFocusableContainers = /* @__PURE__ */ new Set();
  }
  setComp(e, t, o) {
    this.view = e, this.eGridHostDiv = t, this.eGui = o, this.eGui.setAttribute("grid-id", this.beans.context.getId());
    const { dragAndDrop: i, ctrlsSvc: s } = this.beans;
    i?.registerGridDropTarget(() => this.eGui, this), this.createManagedBean(new hs(this.view)), this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
    const n = wt(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(() => n()), s.register("gridCtrl", this);
  }
  isDetailGrid() {
    return pc(this.getGui())?.getAttribute("row-id")?.startsWith("detail") || !1;
  }
  getOptionalSelectors() {
    const e = this.beans;
    return {
      paginationSelector: e.pagination?.getPaginationSelector(),
      gridHeaderDropZonesSelector: e.registry?.getSelector("AG-GRID-HEADER-DROP-ZONES"),
      sideBarSelector: e.sideBar?.getSelector(),
      statusBarSelector: e.registry?.getSelector("AG-STATUS-BAR"),
      watermarkSelector: e.licenseManager?.getWatermarkSelector()
    };
  }
  onGridSizeChanged() {
    this.eventSvc.dispatchEvent({
      type: "gridSizeChanged",
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    });
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    const { view: t } = this;
    if (e === !1)
      t.setCursor(null);
    else {
      const o = e === 1 ? "ew-resize" : "ns-resize";
      t.setCursor(o);
    }
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.getFocusableContainers(), { indexWithFocus: o, nextIndex: i } = this.getNextFocusableIndex(t, e);
    if (i < 0 || i >= t.length)
      return !1;
    if (i === 0) {
      if (o > 0) {
        const { visibleCols: s, focusSvc: n } = this.beans, r = s.allCols, l = G(r);
        if (n.focusGridView({ column: l, backwards: !0 }))
          return !0;
      }
      return !1;
    }
    return this.focusContainer(t[i], e);
  }
  focusInnerElement(e) {
    if (this.gos.getCallback("focusGridInnerElement")?.({ fromBottom: !!e }))
      return !0;
    const o = this.getFocusableContainers(), { focusSvc: i, visibleCols: s } = this.beans, n = s.allCols;
    if (e) {
      if (o.length > 1)
        return this.focusContainer(G(o), e);
      const r = G(n);
      if (i.focusGridView({ column: r, backwards: e }))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || _e(this.beans)) {
      if (i.focusGridView({ column: n[0], backwards: e }))
        return !0;
      for (let r = 1; r < o.length; r++)
        if (To(o[r].getGui(), e))
          return !0;
      return !1;
    }
    return i.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
  addFocusableContainer(e) {
    this.additionalFocusableContainers.add(e);
  }
  removeFocusableContainer(e) {
    this.additionalFocusableContainers.delete(e);
  }
  allowFocusForNextCoreContainer(e) {
    const t = this.view.getFocusableContainers(), { nextIndex: o, indexWithFocus: i } = this.getNextFocusableIndex(t, e);
    if (i === -1 || o < 0 || o >= t.length)
      return;
    const s = t[o];
    s.setAllowFocus?.(!0), setTimeout(() => {
      s.setAllowFocus?.(!1);
    });
  }
  isFocusable() {
    const e = this.beans;
    return !fs(e) || !_e(e) || !!e.sideBar?.comp?.isDisplayed();
  }
  getNextFocusableIndex(e, t) {
    const o = N(this.beans), i = e.findIndex((n) => n.getGui().contains(o)), s = i + (t ? -1 : 1);
    return {
      indexWithFocus: i,
      nextIndex: s
    };
  }
  focusContainer(e, t) {
    e.setAllowFocus?.(!0);
    const o = To(e.getGui(), t, !1, !0);
    return e.setAllowFocus?.(!1), o;
  }
  getFocusableContainers() {
    return [...this.view.getFocusableContainers(), ...this.additionalFocusableContainers];
  }
  destroy() {
    this.additionalFocusableContainers.clear(), super.destroy();
  }
}, dg = class extends Jr {
  constructor(e) {
    super(), this.gridBody = P, this.sideBar = P, this.pagination = P, this.rootWrapperBody = P, this.eGridDiv = e;
  }
  postConstruct() {
    const e = {
      destroyGridUi: () => this.destroyBean(this),
      setRtlClass: (n) => this.addCss(n),
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: (n) => {
        this.getGui().style.userSelect = n ?? "", this.getGui().style.webkitUserSelect = n ?? "";
      },
      setCursor: (n) => {
        this.getGui().style.cursor = n ?? "";
      }
    }, t = this.createManagedBean(new ag()), o = t.getOptionalSelectors(), i = this.createTemplate(o), s = [lg, ...Object.values(o).filter((n) => !!n)];
    this.setTemplate(i, s), t.setComp(e, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: () => {
      },
      focusInnerElement: (n) => t.focusInnerElement(n),
      forceFocusOutWhenTabGuardsAreEmpty: !0,
      isEmpty: () => !t.isFocusable()
    });
  }
  insertGridIntoDom() {
    const e = this.getGui();
    this.eGridDiv.appendChild(e), this.addDestroyFunc(() => {
      e.remove(), Vt(this.gos, "Grid removed from DOM");
    });
  }
  updateLayoutClasses(e, t) {
    const o = this.rootWrapperBody.classList, { AUTO_HEIGHT: i, NORMAL: s, PRINT: n } = ae, { autoHeight: r, normal: l, print: a } = t;
    o.toggle(i, r), o.toggle(s, l), o.toggle(n, a), this.toggleCss(i, r), this.toggleCss(s, l), this.toggleCss(n, a);
  }
  createTemplate(e) {
    const t = e.gridHeaderDropZonesSelector ? { tag: "ag-grid-header-drop-zones" } : null, o = e.sideBarSelector ? {
      tag: "ag-side-bar",
      ref: "sideBar"
    } : null, i = e.statusBarSelector ? { tag: "ag-status-bar" } : null, s = e.watermarkSelector ? { tag: "ag-watermark" } : null, n = e.paginationSelector ? { tag: "ag-pagination", ref: "pagination" } : null;
    return {
      tag: "div",
      cls: "ag-root-wrapper",
      role: "presentation",
      children: [
        t,
        {
          tag: "div",
          ref: "rootWrapperBody",
          cls: "ag-root-wrapper-body",
          role: "presentation",
          children: [{ tag: "ag-grid-body", ref: "gridBody" }, o]
        },
        i,
        n,
        s
      ]
    };
  }
  getFocusableElement() {
    return this.rootWrapperBody;
  }
  forceFocusOutOfContainer(e = !1) {
    if (!e && this.pagination?.isDisplayed()) {
      this.pagination.forceFocusOutOfContainer(e);
      return;
    }
    super.forceFocusOutOfContainer(e);
  }
  getFocusableContainers() {
    const e = [this.gridBody];
    for (const t of [this.sideBar, this.pagination])
      t && e.push(t);
    return e.filter((t) => ke(t.getGui()));
  }
}, E = (e, t) => {
  for (const o of Object.keys(t))
    t[o] = e;
  return t;
}, Js = {
  dispatchEvent: "CommunityCore",
  // this is always registered
  ...E("CommunityCore", {
    destroy: 0,
    getGridId: 0,
    getGridOption: 0,
    isDestroyed: 0,
    setGridOption: 0,
    updateGridOptions: 0,
    isModuleRegistered: 0
  }),
  ...E("GridState", {
    getState: 0,
    setState: 0
  }),
  ...E("SharedRowSelection", {
    setNodesSelected: 0,
    selectAll: 0,
    deselectAll: 0,
    selectAllFiltered: 0,
    deselectAllFiltered: 0,
    selectAllOnCurrentPage: 0,
    deselectAllOnCurrentPage: 0,
    getSelectedNodes: 0,
    getSelectedRows: 0
  }),
  ...E("RowApi", {
    redrawRows: 0,
    setRowNodeExpanded: 0,
    getRowNode: 0,
    addRenderedRowListener: 0,
    getRenderedNodes: 0,
    forEachNode: 0,
    getFirstDisplayedRowIndex: 0,
    getLastDisplayedRowIndex: 0,
    getDisplayedRowAtIndex: 0,
    getDisplayedRowCount: 0
  }),
  ...E("ScrollApi", {
    getVerticalPixelRange: 0,
    getHorizontalPixelRange: 0,
    ensureColumnVisible: 0,
    ensureIndexVisible: 0,
    ensureNodeVisible: 0
  }),
  ...E("KeyboardNavigation", {
    getFocusedCell: 0,
    clearFocusedCell: 0,
    setFocusedCell: 0,
    tabToNextCell: 0,
    tabToPreviousCell: 0,
    setFocusedHeader: 0
  }),
  ...E("EventApi", {
    addEventListener: 0,
    addGlobalListener: 0,
    removeEventListener: 0,
    removeGlobalListener: 0
  }),
  ...E("ValueCache", {
    expireValueCache: 0
  }),
  ...E("CellApi", {
    getCellValue: 0
  }),
  ...E("SharedMenu", {
    showColumnMenu: 0,
    hidePopupMenu: 0
  }),
  ...E("Sort", {
    onSortChanged: 0
  }),
  ...E("PinnedRow", {
    getPinnedTopRowCount: 0,
    getPinnedBottomRowCount: 0,
    getPinnedTopRow: 0,
    getPinnedBottomRow: 0,
    forEachPinnedRow: 0
  }),
  ...E("Overlay", {
    showLoadingOverlay: 0,
    showNoRowsOverlay: 0,
    hideOverlay: 0
  }),
  ...E("RenderApi", {
    setGridAriaProperty: 0,
    refreshCells: 0,
    refreshHeader: 0,
    isAnimationFrameQueueEmpty: 0,
    flushAllAnimationFrames: 0,
    getSizesForCurrentTheme: 0,
    getCellRendererInstances: 0
  }),
  ...E("HighlightChanges", {
    flashCells: 0
  }),
  ...E("RowDrag", {
    addRowDropZone: 0,
    removeRowDropZone: 0,
    getRowDropZoneParams: 0,
    getRowDropPositionIndicator: 0,
    setRowDropPositionIndicator: 0
  }),
  ...E("ColumnApi", {
    getColumnDefs: 0,
    getColumnDef: 0,
    getDisplayNameForColumn: 0,
    getColumn: 0,
    getColumns: 0,
    applyColumnState: 0,
    getColumnState: 0,
    resetColumnState: 0,
    isPinning: 0,
    isPinningLeft: 0,
    isPinningRight: 0,
    getDisplayedColAfter: 0,
    getDisplayedColBefore: 0,
    setColumnsVisible: 0,
    setColumnsPinned: 0,
    getAllGridColumns: 0,
    getDisplayedLeftColumns: 0,
    getDisplayedCenterColumns: 0,
    getDisplayedRightColumns: 0,
    getAllDisplayedColumns: 0,
    getAllDisplayedVirtualColumns: 0
  }),
  ...E("ColumnAutoSize", {
    sizeColumnsToFit: 0,
    autoSizeColumns: 0,
    autoSizeAllColumns: 0
  }),
  ...E("ColumnGroup", {
    setColumnGroupOpened: 0,
    getColumnGroup: 0,
    getProvidedColumnGroup: 0,
    getDisplayNameForColumnGroup: 0,
    getColumnGroupState: 0,
    setColumnGroupState: 0,
    resetColumnGroupState: 0,
    getLeftDisplayedColumnGroups: 0,
    getCenterDisplayedColumnGroups: 0,
    getRightDisplayedColumnGroups: 0,
    getAllDisplayedColumnGroups: 0
  }),
  ...E("ColumnMove", {
    moveColumnByIndex: 0,
    moveColumns: 0
  }),
  ...E("ColumnResize", {
    setColumnWidths: 0
  }),
  ...E("ColumnHover", {
    isColumnHovered: 0
  }),
  ...E("EditCore", {
    getCellEditorInstances: 0,
    getEditingCells: 0,
    getEditRowValues: 0,
    stopEditing: 0,
    startEditingCell: 0,
    isEditing: 0,
    validateEdit: 0
  }),
  ...E("BatchEdit", {
    startBatchEdit: 0,
    cancelBatchEdit: 0,
    commitBatchEdit: 0,
    isBatchEditing: 0
  }),
  ...E("UndoRedoEdit", {
    undoCellEditing: 0,
    redoCellEditing: 0,
    getCurrentUndoSize: 0,
    getCurrentRedoSize: 0
  }),
  ...E("FilterCore", {
    isAnyFilterPresent: 0,
    onFilterChanged: 0
  }),
  ...E("ColumnFilter", {
    isColumnFilterPresent: 0,
    getColumnFilterInstance: 0,
    destroyFilter: 0,
    setFilterModel: 0,
    getFilterModel: 0,
    getColumnFilterModel: 0,
    setColumnFilterModel: 0,
    showColumnFilter: 0,
    hideColumnFilter: 0,
    getColumnFilterHandler: 0,
    doFilterAction: 0
  }),
  ...E("QuickFilter", {
    isQuickFilterPresent: 0,
    getQuickFilter: 0,
    resetQuickFilter: 0
  }),
  ...E("Find", {
    findGetActiveMatch: 0,
    findGetTotalMatches: 0,
    findGoTo: 0,
    findNext: 0,
    findPrevious: 0,
    findGetNumMatches: 0,
    findGetParts: 0,
    findClearActive: 0,
    findRefresh: 0
  }),
  ...E("Pagination", {
    paginationIsLastPageFound: 0,
    paginationGetPageSize: 0,
    paginationGetCurrentPage: 0,
    paginationGetTotalPages: 0,
    paginationGetRowCount: 0,
    paginationGoToNextPage: 0,
    paginationGoToPreviousPage: 0,
    paginationGoToFirstPage: 0,
    paginationGoToLastPage: 0,
    paginationGoToPage: 0
  }),
  ...E("CsrmSsrmSharedApi", {
    expandAll: 0,
    collapseAll: 0
  }),
  ...E("SsrmInfiniteSharedApi", {
    setRowCount: 0,
    getCacheBlockState: 0,
    isLastRowIndexKnown: 0
  }),
  ...E("ClientSideRowModelApi", {
    onGroupExpandedOrCollapsed: 0,
    refreshClientSideRowModel: 0,
    isRowDataEmpty: 0,
    forEachLeafNode: 0,
    forEachNodeAfterFilter: 0,
    forEachNodeAfterFilterAndSort: 0,
    applyTransaction: 0,
    applyTransactionAsync: 0,
    flushAsyncTransactions: 0,
    getBestCostNodeSelection: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...E("CsvExport", {
    getDataAsCsv: 0,
    exportDataAsCsv: 0
  }),
  ...E("InfiniteRowModel", {
    refreshInfiniteCache: 0,
    purgeInfiniteCache: 0,
    getInfiniteRowCount: 0
  }),
  ...E("AdvancedFilter", {
    getAdvancedFilterModel: 0,
    setAdvancedFilterModel: 0,
    showAdvancedFilterBuilder: 0,
    hideAdvancedFilterBuilder: 0
  }),
  ...E("IntegratedCharts", {
    getChartModels: 0,
    getChartRef: 0,
    getChartImageDataURL: 0,
    downloadChart: 0,
    openChartToolPanel: 0,
    closeChartToolPanel: 0,
    createRangeChart: 0,
    createPivotChart: 0,
    createCrossFilterChart: 0,
    updateChart: 0,
    restoreChart: 0
  }),
  ...E("Clipboard", {
    copyToClipboard: 0,
    cutToClipboard: 0,
    copySelectedRowsToClipboard: 0,
    copySelectedRangeToClipboard: 0,
    copySelectedRangeDown: 0,
    pasteFromClipboard: 0
  }),
  ...E("ExcelExport", {
    getDataAsExcel: 0,
    exportDataAsExcel: 0,
    getSheetDataForExcel: 0,
    getMultipleSheetsAsExcel: 0,
    exportMultipleSheetsAsExcel: 0
  }),
  ...E("SharedMasterDetail", {
    addDetailGridInfo: 0,
    removeDetailGridInfo: 0,
    getDetailGridInfo: 0,
    forEachDetailGridInfo: 0
  }),
  ...E("ContextMenu", {
    showContextMenu: 0
  }),
  ...E("ColumnMenu", {
    showColumnChooser: 0,
    hideColumnChooser: 0
  }),
  ...E("CellSelection", {
    getCellRanges: 0,
    addCellRange: 0,
    clearRangeSelection: 0,
    clearCellSelection: 0
  }),
  ...E("SharedRowGrouping", {
    setRowGroupColumns: 0,
    removeRowGroupColumns: 0,
    addRowGroupColumns: 0,
    getRowGroupColumns: 0,
    moveRowGroupColumn: 0
  }),
  ...E("SharedAggregation", {
    addAggFuncs: 0,
    clearAggFuncs: 0,
    setColumnAggFunc: 0
  }),
  ...E("SharedPivot", {
    isPivotMode: 0,
    getPivotResultColumn: 0,
    setValueColumns: 0,
    getValueColumns: 0,
    removeValueColumns: 0,
    addValueColumns: 0,
    setPivotColumns: 0,
    removePivotColumns: 0,
    addPivotColumns: 0,
    getPivotColumns: 0,
    setPivotResultColumns: 0,
    getPivotResultColumns: 0
  }),
  ...E("ServerSideRowModelApi", {
    getServerSideSelectionState: 0,
    setServerSideSelectionState: 0,
    applyServerSideTransaction: 0,
    applyServerSideTransactionAsync: 0,
    applyServerSideRowData: 0,
    retryServerSideLoads: 0,
    flushServerSideAsyncTransactions: 0,
    refreshServerSide: 0,
    getServerSideGroupLevelState: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...E("SideBar", {
    isSideBarVisible: 0,
    setSideBarVisible: 0,
    setSideBarPosition: 0,
    openToolPanel: 0,
    closeToolPanel: 0,
    getOpenedToolPanel: 0,
    refreshToolPanel: 0,
    isToolPanelShowing: 0,
    getToolPanelInstance: 0,
    getSideBar: 0
  }),
  ...E("StatusBar", {
    getStatusPanel: 0
  }),
  ...E("AiToolkit", {
    getStructuredSchema: 0
  })
}, ci = {
  isDestroyed: () => !0,
  destroy() {
  },
  preConstruct() {
  },
  postConstruct() {
  },
  preWireBeans() {
  },
  wireBeans() {
  }
}, cg = (e, t) => e.eventSvc.dispatchEvent(t), el = class {
};
Reflect.defineProperty(el, "name", { value: "GridApi" });
var ug = class extends b {
  constructor() {
    super(), this.beanName = "apiFunctionSvc", this.api = new el(), this.fns = {
      ...ci,
      // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
      dispatchEvent: cg
    }, this.preDestroyLink = "";
    const { api: e } = this;
    for (const t of Object.keys(Js))
      e[t] = this.makeApi(t)[t];
  }
  postConstruct() {
    this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
  }
  addFunction(e, t) {
    const { fns: o, beans: i } = this;
    o !== ci && (o[e] = i?.validation?.validateApiFunction(e, t) ?? t);
  }
  makeApi(e) {
    return {
      [e]: (...t) => {
        const {
          beans: o,
          fns: { [e]: i }
        } = this;
        return i ? i(o, ...t) : this.apiNotFound(e);
      }
    };
  }
  apiNotFound(e) {
    const { beans: t, gos: o, preDestroyLink: i } = this;
    if (!t)
      F(26, { fnName: e, preDestroyLink: i });
    else {
      const s = Js[e];
      o.assertModuleRegistered(s, `api.${e}`) && F(27, { fnName: e, module: s });
    }
  }
  destroy() {
    super.destroy(), this.fns = ci, this.beans = null;
  }
};
function hg(e) {
  return e.context.getId();
}
function gg(e) {
  e.gridDestroySvc.destroy();
}
function pg(e) {
  return e.gridDestroySvc.destroyCalled;
}
function fg(e, t) {
  return e.gos.get(t);
}
function Cg(e, t, o) {
  tl(e, { [t]: o });
}
function tl(e, t) {
  e.gos.updateGridOptions({ options: t });
}
function mg(e, t) {
  const o = t.replace(/Module$/, "");
  return e.gos.isModuleRegistered(o);
}
var vg = class extends du {
  shouldPreventMouseEvent(e) {
    return this.gos.get("enableCellTextSelection") && super.shouldPreventMouseEvent(e);
  }
}, wg = class extends b {
  constructor() {
    super(...arguments), this.beanName = "horizontalResizeSvc";
  }
  addResizeBar(e) {
    const t = {
      dragStartPixels: e.dragStartPixels || 0,
      eElement: e.eResizeBar,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this, e),
      onDragging: this.onDragging.bind(this, e),
      onDragCancel: this.onDragStop.bind(this, e),
      includeTouch: !0,
      stopPropagationForTouch: !0
    }, { dragSvc: o } = this.beans;
    return o.addDragSource(t), () => o.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const o = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(o);
  }
  setResizeIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(
      1
      /* Horizontal */
    ), e.disableUserSelect(!0);
  }
  onDragStop(e) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
}, ui = class {
  constructor() {
    this.reordered = !1, this.removals = /* @__PURE__ */ new Set(), this.updates = /* @__PURE__ */ new Set(), this.adds = /* @__PURE__ */ new Set();
  }
};
function Sg(e) {
  const { rowIndex: t, rowPinned: o, column: i } = e;
  return `${t}.${o ?? "null"}.${i.getId()}`;
}
function bg(e, t) {
  const o = e.column === t.column, i = e.rowPinned === t.rowPinned, s = e.rowIndex === t.rowIndex;
  return o && i && s;
}
function yg(e, t) {
  switch (e.rowPinned) {
    case "top":
      if (t.rowPinned !== "top")
        return !0;
      break;
    case "bottom":
      if (t.rowPinned !== "bottom")
        return !1;
      break;
    default:
      if (A(t.rowPinned))
        return t.rowPinned !== "top";
      break;
  }
  return e.rowIndex < t.rowIndex;
}
function Rg(e) {
  let t = 0, o;
  const { pinnedRowModel: i, rowModel: s, pageBounds: n } = e;
  return i?.getPinnedTopRowCount() ? o = "top" : s.getRowCount() ? (o = null, t = n.getFirstRow()) : i?.getPinnedBottomRowCount() && (o = "bottom"), o === void 0 ? null : { rowIndex: t, rowPinned: o };
}
function xg(e) {
  let t, o = null;
  const { pinnedRowModel: i, pageBounds: s } = e, n = i?.getPinnedBottomRowCount(), r = i?.getPinnedTopRowCount();
  return n ? (o = "bottom", t = n - 1) : e.rowModel.getRowCount() ? t = s.getLastRow() : r && (o = "top", t = r - 1), t === void 0 ? null : { rowIndex: t, rowPinned: o };
}
function ol(e, t) {
  switch (t.rowPinned) {
    case "top":
      return e.pinnedRowModel?.getPinnedTopRow(t.rowIndex);
    case "bottom":
      return e.pinnedRowModel?.getPinnedBottomRow(t.rowIndex);
    default:
      return e.rowModel.getRow(t.rowIndex);
  }
}
function no(e, t) {
  const o = e.spannedRowRenderer?.getCellByPosition(t);
  if (o)
    return o;
  const i = e.rowRenderer.getRowByPosition(t);
  return i ? i.getCellCtrl(t.column) : null;
}
function Pg(e, t, o) {
  const { rowModel: i, pinnedRowModel: s } = e;
  let n;
  return n ?? (n = i?.getRowNode(t)), o ? n ?? (n = s?.getPinnedRowById(t, o)) : (n ?? (n = s?.getPinnedRowById(t, "top")), n ?? (n = s?.getPinnedRowById(t, "bottom"))), n;
}
function Go(e, t, o = !1) {
  const { rowIndex: i, rowPinned: s } = t, { pageBounds: n, pinnedRowModel: r, rowModel: l } = e;
  if (i === 0)
    return s === "top" ? null : s === "bottom" && l.isRowsToRender() ? { rowIndex: n.getLastRow(), rowPinned: null } : r?.isRowsToRender("top") ? { rowIndex: r.getPinnedTopRowCount() - 1, rowPinned: "top" } : null;
  if (o) {
    const a = s ? void 0 : l.getRow(i);
    return il(e, a, !0) ?? { rowIndex: i - 1, rowPinned: s };
  }
  return { rowIndex: i - 1, rowPinned: s };
}
function en(e, t, o = !1) {
  const { rowIndex: i, rowPinned: s } = t, { pageBounds: n, pinnedRowModel: r, rowModel: l } = e;
  if (Dg(e, t))
    return s === "bottom" ? null : s === "top" && l.isRowsToRender() ? { rowIndex: n.getFirstRow(), rowPinned: null } : r?.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
  if (o) {
    const a = s ? void 0 : l.getRow(i);
    return il(e, a) ?? { rowIndex: i + 1, rowPinned: s };
  }
  return { rowIndex: i + 1, rowPinned: s };
}
function il(e, t, o = !1) {
  const { gos: i, rowRenderer: s } = e;
  if (!t?.sticky || !Jn(i))
    return;
  const n = s.getStickyTopRowCtrls(), r = s.getStickyBottomRowCtrls(), l = !r.some((u) => u.rowNode.rowIndex === t.rowIndex), a = l ? n : r, d = (o ? -1 : 1) * (l ? -1 : 1);
  let c;
  for (let u = 0; u < a.length; u++)
    if (a[u].rowNode.rowIndex === t.rowIndex) {
      c = a[u + d];
      break;
    }
  return c ? { rowIndex: c.rowNode.rowIndex, rowPinned: null } : void 0;
}
function Dg(e, t) {
  const { rowPinned: o, rowIndex: i } = t, { pinnedRowModel: s, pageBounds: n } = e;
  return o === "top" ? (s?.getPinnedTopRowCount() ?? 0) - 1 <= i : o === "bottom" ? (s?.getPinnedBottomRowCount() ?? 0) - 1 <= i : n.getLastRow() <= i;
}
var Ho = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = {
      rowNode: t,
      children: null
    }, this.mapToItems[t.id] = this.pathRoot;
  }
  depthFirstSearchChangedPath(e, t) {
    const { rowNode: o, children: i } = e;
    if (i)
      for (let s = 0; s < i.length; ++s)
        this.depthFirstSearchChangedPath(i[s], t);
    t(o);
  }
  depthFirstSearchEverything(e, t, o) {
    const i = e.childrenAfterGroup;
    if (i)
      for (let s = 0, n = i.length; s < n; ++s) {
        const r = i[s];
        r.childrenAfterGroup ? this.depthFirstSearchEverything(r, t, o) : o && t(r);
      }
    t(e);
  }
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  forEachChangedNodeDepthFirst(e, t = !1, o = !1) {
    this.active && !o ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, o = 0;
    for (; !this.mapToItems[t.id]; ) {
      const i = {
        rowNode: t,
        children: null
      };
      this.mapToItems[t.id] = i, o++, t = t.parent;
    }
    return o;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let o = e;
    for (; o; ) {
      this.nodeIdsToColumns[o.id] || (this.nodeIdsToColumns[o.id] = {});
      for (const i of t)
        this.nodeIdsToColumns[o.id][i.getId()] = !0;
      o = o.parent;
    }
  }
  linkPathItems(e, t) {
    let o = e;
    for (let i = 0; i < t; i++) {
      const s = this.mapToItems[o.id], n = this.mapToItems[o.parent.id];
      n.children || (n.children = []), n.children.push(s), o = o.parent;
    }
  }
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const o = this.createPathItems(e);
    this.linkPathItems(e, o), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const o = this.nodeIdsToColumns[e.id];
    return t.filter((s) => o[s.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const o = this.nodeIdsToColumns[e.id];
    return t.filter((s) => !o[s.getId()]);
  }
}, sl = {
  moduleName: "Drag",
  version: M,
  beans: [vg]
}, Fg = {
  moduleName: "SharedDragAndDrop",
  version: M,
  beans: [uu],
  dependsOn: [sl],
  userComponents: {
    agDragAndDropImage: Ah
  },
  icons: {
    // shown on drag and drop image component icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on drag and drop image component icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on drag and drop image component icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on drag and drop image component icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on drag and drop image component icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
    // string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, Eg = {
  moduleName: "HorizontalResize",
  version: M,
  beans: [wg],
  dependsOn: [sl]
}, Ag = (
  /*css*/
  ":where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}"
), Mg = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colAnimation", this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.activeNext = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    if (this.active)
      return;
    const { gos: e } = this;
    e.get("suppressColumnMoveAnimation") || e.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0, this.activeNext = !0);
  }
  finish() {
    this.active && this.flush(
      () => this.activeNext = !1,
      () => this.active = !1
    );
  }
  executeNextVMTurn(e) {
    this.activeNext ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount, { gridBodyCtrl: t } = this;
    t.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && t.setColumnMovingCss(!1);
    });
  }
  flush(e, t) {
    const { executeNextFuncs: o, executeLaterFuncs: i } = this;
    if (o.length === 0 && i.length === 0) {
      e(), t();
      return;
    }
    const s = (n) => {
      for (; n.length; ) {
        const r = n.pop();
        r && r();
      }
    };
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e(), s(o);
      }, 0), window.setTimeout(() => {
        t(), s(i);
      }, 200);
    });
  }
};
function Tg(e, t, o) {
  e.colMoves?.moveColumnByIndex(t, o, "api");
}
function Ig(e, t, o) {
  e.colMoves?.moveColumns(t, o, "api");
}
var kg = class extends b {
  constructor(e) {
    super(), this.pinned = e, this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [];
  }
  /** Callback for when drag enters */
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    if (t)
      for (const o of t)
        o.isPrimary() && (o.isAnyFunctionActive() || (o.isAllowValue() ? this.columnsToAggregate.push(o) : o.isAllowRowGroup() ? this.columnsToGroup.push(o) : o.isAllowPivot() && this.columnsToPivot.push(o)));
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? "pinned" : "move" : null;
  }
  /** Callback for when drag leaves */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  /** Callback for when dragging */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragging(e) {
  }
  /** Callback for when drag stops */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragStop(e) {
    const { valueColsSvc: t, rowGroupColsSvc: o, pivotColsSvc: i } = this.beans;
    this.columnsToAggregate.length > 0 && t?.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop"), this.columnsToGroup.length > 0 && o?.addColumns(this.columnsToGroup, "toolPanelDragAndDrop"), this.columnsToPivot.length > 0 && i?.addColumns(this.columnsToPivot, "toolPanelDragAndDrop");
  }
  onDragCancel() {
    this.clearColumnsList();
  }
};
function Lg(e, t) {
  !t || t.length <= 1 || t.filter((i) => e.indexOf(i) < 0).length > 0 || t.sort((i, s) => {
    const n = e.indexOf(i), r = e.indexOf(s);
    return n - r;
  });
}
function Gg(e) {
  const t = [...e];
  for (const o of e) {
    let i = null, s = o.getParent();
    for (; s != null && s.getDisplayedLeafColumns().length === 1; )
      i = s, s = s.getParent();
    if (i != null) {
      const r = !!i.getColGroupDef()?.marryChildren ? (
        // when marry children is true, we also have to move hidden
        // columns within the group, so grab them from the `providedColumnGroup`
        i.getProvidedColumnGroup().getLeafColumns()
      ) : i.getLeafColumns();
      for (const l of r)
        t.includes(l) || t.push(l);
    }
  }
  return t;
}
function Hg(e, t, o, i) {
  const s = i.allCols;
  let n = null, r = null;
  for (let l = 0; l < e.length; l++) {
    const a = e[l], d = o.getProposedColumnOrder(t, a);
    if (!o.doesOrderPassRules(d))
      continue;
    const c = d.filter((h) => s.includes(h));
    if (r === null)
      r = c;
    else if (!St(c, r))
      break;
    const u = Bg(d);
    (n === null || u < n.fragCount) && (n = { move: a, fragCount: u });
  }
  return n;
}
function nl(e) {
  const { isFromHeader: t, fromLeft: o, xPosition: i, fromEnter: s, fakeEvent: n, pinned: r, gos: l, colModel: a, colMoves: d, visibleCols: c } = e;
  let { allMovingColumns: u } = e;
  t && (u = Gg(u));
  const h = u.slice();
  Lg(a.getCols(), h);
  const g = Wg({
    movingCols: h,
    draggingRight: o,
    xPosition: i,
    pinned: r,
    gos: l,
    colModel: a,
    visibleCols: c
  }), p = Og(h, a);
  if (g.length === 0)
    return;
  const f = g[0];
  if (p !== null && (t || !s) && !n && (!o && f >= p || o && f <= p))
    return;
  const m = Hg(g, h, d, c);
  if (!m)
    return;
  const v = m.move;
  if (!(v > a.getCols().length - h.length))
    return { columns: h, toIndex: v };
}
function rl(e) {
  const { columns: t, toIndex: o } = nl(e) || {}, { finished: i, colMoves: s } = e;
  return !t || o == null ? null : (s.moveColumns(t, o, "uiColumnMoved", i), i ? null : { columns: t, toIndex: o });
}
function Og(e, t) {
  const o = t.getCols(), i = e.map((a) => o.indexOf(a)).sort((a, d) => a - d), s = i[0];
  return G(i) - s !== i.length - 1 ? null : s;
}
function Bg(e) {
  function t(i) {
    const s = [];
    let n = i.getOriginalParent();
    for (; n != null; )
      s.push(n), n = n.getOriginalParent();
    return s;
  }
  let o = 0;
  for (let i = 0; i < e.length - 1; i++) {
    let s = t(e[i]), n = t(e[i + 1]);
    [s, n] = s.length > n.length ? [s, n] : [n, s];
    for (const r of s)
      n.indexOf(r) === -1 && o++;
  }
  return o;
}
function Vg(e, t) {
  switch (t) {
    case "left":
      return e.leftCols;
    case "right":
      return e.rightCols;
    default:
      return e.centerCols;
  }
}
function Wg(e) {
  const { movingCols: t, draggingRight: o, xPosition: i, pinned: s, gos: n, colModel: r, visibleCols: l } = e;
  if (n.get("suppressMovableColumns") || t.some((S) => S.getColDef().suppressMovable))
    return [];
  const d = Vg(l, s), c = r.getCols(), u = d.filter((S) => t.includes(S)), h = d.filter((S) => !t.includes(S)), g = c.filter((S) => !t.includes(S));
  let p = 0, f = i;
  if (o) {
    let S = 0;
    for (const D of u)
      S += D.getActualWidth();
    f -= S;
  }
  if (f > 0) {
    for (let S = 0; S < h.length; S++) {
      const D = h[S];
      if (f -= D.getActualWidth(), f < 0)
        break;
      p++;
    }
    o && p++;
  }
  let C;
  if (p > 0) {
    const S = h[p - 1];
    C = g.indexOf(S) + 1;
  } else
    C = g.indexOf(h[0]), C === -1 && (C = 0);
  const m = [C], v = (S, D) => S - D;
  if (o) {
    let S = C + 1;
    const D = c.length - 1;
    for (; S <= D; )
      m.push(S), S++;
    m.sort(v);
  } else {
    let S = C;
    const D = c.length - 1;
    let y = c[S];
    for (; S <= D && d.indexOf(y) < 0; )
      S++, m.push(S), y = c[S];
    S = C - 1;
    const R = 0;
    for (; S >= R; )
      m.push(S), S--;
    m.sort(v).reverse();
  }
  return m;
}
function Wi(e) {
  const { pinned: t, fromKeyboard: o, gos: i, ctrlsSvc: s, useHeaderRow: n, skipScrollPadding: r } = e;
  let l = s.getHeaderRowContainerCtrl(t)?.eViewport, { x: a } = e;
  return l ? (o && (a -= l.getBoundingClientRect().left), i.get("enableRtl") && (n && (l = l.querySelector(".ag-header-row")), a = l.clientWidth - a), t == null && !r && (a += s.get("center").getCenterViewportScrollLeft()), a) : 0;
}
function hi(e, t) {
  for (const o of e)
    o.moving = t, o.dispatchColEvent("movingChanged", "uiColumnMoved");
}
var tn = 7, Ni = 100, ro = Ni / 2, Ng = 5, zg = 100, _g = class extends b {
  constructor(e) {
    super(), this.pinned = e, this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.isCenterContainer = !A(e);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    const { pinned: e, lastDraggingEvent: t } = this, { dragItem: o } = t || {}, i = o?.columns ?? [];
    for (const s of i) {
      const n = s.getPinned();
      if (s.getColDef().lockPinned) {
        if (n == e)
          return "move";
        continue;
      }
      const r = o?.containerType;
      if (r === e || !e)
        return "move";
      if (e && (!n || r !== e))
        return "pinned";
    }
    return "notAllowed";
  }
  onDragEnter(e) {
    const t = e.dragItem, o = t.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(o, !0, "uiColumnDragged");
    else {
      const s = t.visibleState, n = (o || []).filter(
        (r) => s[r.getId()] && !r.isVisible()
      );
      this.setColumnsVisible(n, !0, "uiColumnDragged");
    }
    this.gos.get("suppressMoveWhenColumnDragging") || this.attemptToPinColumns(o, this.pinned), this.onDragging(e, !0, !0);
  }
  onDragging(e = this.lastDraggingEvent, t = !1, o = !1, i = !1) {
    const { gos: s, ctrlsSvc: n } = this.beans, r = s.get("suppressMoveWhenColumnDragging");
    if (i && !r) {
      this.finishColumnMoving();
      return;
    }
    if (this.lastDraggingEvent = e, !e || !i && H(e.hDirection))
      return;
    const l = Wi({
      x: e.x,
      pinned: this.pinned,
      gos: s,
      ctrlsSvc: n
    });
    t || this.checkCenterForScrolling(l), r ? this.handleColumnDragWhileSuppressingMovement(e, t, o, l, i) : this.handleColumnDragWhileAllowingMovement(e, t, o, l, i);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.clearHighlighted(), this.updateDragItemContainerType(), this.lastMovedInfo = null;
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  onDragCancel() {
    this.clearHighlighted(), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, o) {
    if (!e?.length)
      return;
    const i = e.filter((s) => !s.getColDef().lockVisible);
    i.length && this.beans.colModel.setColsVisible(i, t, o);
  }
  finishColumnMoving() {
    this.clearHighlighted();
    const e = this.lastMovedInfo;
    if (!e)
      return;
    const { columns: t, toIndex: o } = e;
    this.beans.colMoves.moveColumns(t, o, "uiColumnMoved", !0);
  }
  updateDragItemContainerType() {
    const { lastDraggingEvent: e } = this;
    if (this.gos.get("suppressMoveWhenColumnDragging") || !e)
      return;
    const t = e.dragItem;
    t && (t.containerType = this.pinned);
  }
  handleColumnDragWhileSuppressingMovement(e, t, o, i, s) {
    const n = this.getAllMovingColumns(e, !0);
    if (s) {
      const r = this.isAttemptingToPin(n);
      r && this.attemptToPinColumns(n, void 0, !0);
      const { fromLeft: l, xPosition: a } = this.getNormalisedXPositionInfo(n, r) || {};
      if (l == null || a == null) {
        this.finishColumnMoving();
        return;
      }
      this.moveColumnsAfterHighlight({
        allMovingColumns: n,
        xPosition: a,
        fromEnter: t,
        fakeEvent: o,
        fromLeft: l
      });
    } else {
      if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(e))
        return;
      this.highlightHoveredColumn(n, i);
    }
  }
  handleColumnDragWhileAllowingMovement(e, t, o, i, s) {
    const n = this.getAllMovingColumns(e), r = this.normaliseDirection(e.hDirection) === "right", l = e.dragSource.type === 1, a = this.getMoveColumnParams({
      allMovingColumns: n,
      isFromHeader: l,
      xPosition: i,
      fromLeft: r,
      fromEnter: t,
      fakeEvent: o
    }), d = rl({ ...a, finished: s });
    d && (this.lastMovedInfo = d);
  }
  getAllMovingColumns(e, t = !1) {
    const o = e.dragSource.getDragItem();
    let i = null;
    t ? (i = o.columnsInSplit, i || (i = o.columns)) : i = o.columns;
    const s = (n) => n.getColDef().lockPinned ? n.getPinned() == this.pinned : !0;
    return i ? i.filter(s) : [];
  }
  getMoveColumnParams(e) {
    const { allMovingColumns: t, isFromHeader: o, xPosition: i, fromLeft: s, fromEnter: n, fakeEvent: r } = e, { gos: l, colModel: a, colMoves: d, visibleCols: c } = this.beans;
    return {
      allMovingColumns: t,
      isFromHeader: o,
      fromLeft: s,
      xPosition: i,
      pinned: this.pinned,
      fromEnter: n,
      fakeEvent: r,
      gos: l,
      colModel: a,
      colMoves: d,
      visibleCols: c
    };
  }
  highlightHoveredColumn(e, t) {
    const { gos: o, colModel: i } = this.beans, s = o.get("enableRtl"), n = i.getCols().filter((c) => c.isVisible() && c.getPinned() === this.pinned);
    let r = null, l = null, a = null;
    for (const c of n) {
      if (l = c.getActualWidth(), r = this.getNormalisedColumnLeft(c, 0, s), r != null) {
        const u = r + l;
        if (r <= t && u >= t) {
          a = c;
          break;
        }
      }
      r = null, l = null;
    }
    if (a)
      e.indexOf(a) !== -1 && (a = null);
    else {
      for (let c = n.length - 1; c >= 0; c--) {
        const u = n[c], h = n[c].getParent();
        if (!h) {
          a = u;
          break;
        }
        const g = h?.getDisplayedLeafColumns();
        if (g.length) {
          a = G(g);
          break;
        }
      }
      if (!a)
        return;
      r = this.getNormalisedColumnLeft(a, 0, s), l = a.getActualWidth();
    }
    if (this.lastHighlightedColumn?.column !== a && this.clearHighlighted(), a == null || r == null || l == null)
      return;
    let d;
    t - r < l / 2 !== s ? d = 0 : d = 1, on(a, d), this.lastHighlightedColumn = { column: a, position: d };
  }
  getNormalisedXPositionInfo(e, t) {
    const { gos: o, visibleCols: i } = this.beans, s = o.get("enableRtl"), { firstMovingCol: n, column: r, position: l } = this.getColumnMoveAndTargetInfo(
      e,
      t,
      s
    );
    if (!n || !r || l == null)
      return;
    const a = i.allCols, d = a.indexOf(n), c = a.indexOf(r), u = l === 0 !== s, h = d < c || d === c && !u;
    let g = 0;
    if (u ? h && (g -= 1) : h || (g += 1), c + g === d)
      return;
    const p = a[c + g];
    if (!p)
      return;
    const f = this.getNormalisedColumnLeft(p, 20, s);
    return { fromLeft: h, xPosition: f };
  }
  getColumnMoveAndTargetInfo(e, t, o) {
    const i = this.lastHighlightedColumn || {}, { firstMovingCol: s, lastMovingCol: n } = Ug(e);
    if (!s || !n || i.column || !t)
      return {
        firstMovingCol: s,
        ...i
      };
    const l = this.getPinDirection() === "left";
    return {
      firstMovingCol: s,
      position: l ? 1 : 0,
      column: l !== o ? s : n
    };
  }
  normaliseDirection(e) {
    if (this.gos.get("enableRtl"))
      switch (e) {
        case "left":
          return "right";
        case "right":
          return "left";
      }
    return e;
  }
  getNormalisedColumnLeft(e, t, o) {
    const { gos: i, ctrlsSvc: s } = this.beans, n = e.getLeft();
    if (n == null)
      return null;
    const r = e.getActualWidth();
    return Wi({
      x: o ? n + r - t : n + t,
      pinned: e.getPinned(),
      useHeaderRow: o,
      skipScrollPadding: !0,
      gos: i,
      ctrlsSvc: s
    });
  }
  isAttemptingToPin(e) {
    const t = this.needToMoveLeft || this.needToMoveRight, o = this.failedMoveAttempts > tn;
    return t && o || e.some((i) => i.getPinned() !== this.pinned);
  }
  moveColumnsAfterHighlight(e) {
    const { allMovingColumns: t, xPosition: o, fromEnter: i, fakeEvent: s, fromLeft: n } = e, r = this.getMoveColumnParams({
      allMovingColumns: t,
      isFromHeader: !0,
      xPosition: o,
      fromLeft: n,
      fromEnter: i,
      fakeEvent: s
    }), { columns: l, toIndex: a } = nl(r) || {};
    l && a != null && (this.lastMovedInfo = {
      columns: l,
      toIndex: a
    }), this.finishColumnMoving();
  }
  clearHighlighted() {
    const { lastHighlightedColumn: e } = this;
    e && (on(e.column, null), this.lastHighlightedColumn = null);
  }
  checkCenterForScrolling(e) {
    if (!this.isCenterContainer)
      return;
    const t = this.beans.ctrlsSvc.get("center"), o = t.getCenterViewportScrollLeft(), i = o + t.getCenterWidth();
    let s, n;
    this.gos.get("enableRtl") ? (s = e < o + ro, n = e > i - ro) : (n = e < o + ro, s = e > i - ro), this.needToMoveRight = s, this.needToMoveLeft = n, n || s ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
  }
  ensureIntervalStarted() {
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), zg), this.beans.dragAndDrop.setDragImageCompIcon(this.needToMoveLeft ? "left" : "right", !0));
  }
  ensureIntervalCleared() {
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.failedMoveAttempts = 0, this.beans.dragAndDrop.setDragImageCompIcon(this.getIconName()));
  }
  moveInterval() {
    let e;
    this.intervalCount++, e = 10 + this.intervalCount * Ng, e > Ni && (e = Ni);
    let t = null;
    const o = this.gridBodyCon.scrollFeature;
    if (this.needToMoveLeft ? t = o.scrollHorizontally(-e) : this.needToMoveRight && (t = o.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const { pinnedCols: i, dragAndDrop: s, gos: n } = this.beans;
      if (this.failedMoveAttempts <= tn + 1 || !i)
        return;
      if (s.setDragImageCompIcon("pinned"), !n.get("suppressMoveWhenColumnDragging")) {
        const r = this.lastDraggingEvent?.dragItem.columns;
        this.attemptToPinColumns(r, void 0, !0);
      }
    }
  }
  getPinDirection() {
    if (this.needToMoveLeft || this.pinned === "left")
      return "left";
    if (this.needToMoveRight || this.pinned === "right")
      return "right";
  }
  attemptToPinColumns(e, t, o = !1) {
    const i = (e || []).filter((r) => !r.getColDef().lockPinned);
    if (!i.length)
      return 0;
    o && (t = this.getPinDirection());
    const { pinnedCols: s, dragAndDrop: n } = this.beans;
    return s?.setColsPinned(i, t, "uiColumnDragged"), o && n.nudge(), i.length;
  }
  destroy() {
    super.destroy(), this.lastDraggingEvent = null, this.clearHighlighted(), this.lastMovedInfo = null;
  }
};
function on(e, t) {
  e.highlighted !== t && (e.highlighted = t, e.dispatchColEvent("headerHighlightChanged", "uiColumnMoved"));
}
function Ug(e) {
  const t = e.length;
  let o, i;
  for (let s = 0; s < t; s++) {
    if (!o) {
      const n = e[s];
      n.getLeft() != null && (o = n);
    }
    if (!i) {
      const n = e[t - 1 - s];
      n.getLeft() != null && (i = n);
    }
    if (o && i)
      break;
  }
  return { firstMovingCol: o, lastMovingCol: i };
}
var $g = class extends b {
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    const { ctrlsSvc: e, dragAndDrop: t } = this.beans, o = this.pinned;
    e.whenReady(this, (i) => {
      let s;
      const n = i.gridBodyCtrl.eBodyViewport;
      switch (o) {
        case "left":
          s = [
            [n, i.left.eContainer],
            [i.bottomLeft.eContainer],
            [i.topLeft.eContainer]
          ];
          break;
        case "right":
          s = [
            [n, i.right.eContainer],
            [i.bottomRight.eContainer],
            [i.topRight.eContainer]
          ];
          break;
        default:
          s = [
            [n, i.center.eViewport],
            [i.bottomCenter.eViewport],
            [i.topCenter.eViewport]
          ];
          break;
      }
      this.eSecondaryContainers = s;
    }), this.moveColumnFeature = this.createManagedBean(new _g(o)), this.bodyDropPivotTarget = this.createManagedBean(new kg(o)), t.addDropTarget(this), this.addDestroyFunc(() => t.removeDropTarget(this));
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  isDropColumnInPivotMode(e) {
    return this.beans.colModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
  onDragCancel() {
    this.currentDropListener.onDragCancel();
  }
}, Kg = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colMoves";
  }
  moveColumnByIndex(e, t, o) {
    const i = this.beans.colModel.getCols();
    if (!i)
      return;
    const s = i[e];
    this.moveColumns([s], t, o);
  }
  moveColumns(e, t, o, i = !0) {
    const { colModel: s, colAnimation: n, visibleCols: r, eventSvc: l } = this.beans, a = s.getCols();
    if (!a)
      return;
    if (t > a.length - e.length) {
      F(30, { toIndex: t });
      return;
    }
    n?.start();
    const d = s.getColsForKeys(e);
    this.doesMovePassRules(d, t) && (Hs(s.getCols(), d, t), r.refresh(o), l.dispatchEvent({
      type: "columnMoved",
      columns: d,
      column: d.length === 1 ? d[0] : null,
      toIndex: t,
      finished: i,
      source: o
    })), n?.finish();
  }
  doesMovePassRules(e, t) {
    const o = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(o);
  }
  doesOrderPassRules(e) {
    const { colModel: t, gos: o } = this.beans;
    return !(!ur(e, t.getColTree()) || !((s) => {
      const n = (d) => d ? d === "left" || d === !0 ? -1 : 1 : 0, r = o.get("enableRtl");
      let l = r ? 1 : -1, a = !0;
      for (const d of s) {
        const c = n(d.getColDef().lockPosition);
        r ? c > l && (a = !1) : c < l && (a = !1), l = c;
      }
      return a;
    })(e));
  }
  getProposedColumnOrder(e, t) {
    const i = this.beans.colModel.getCols().slice();
    return Hs(i, e, t), i;
  }
  createBodyDropTarget(e, t) {
    return new $g(e, t);
  }
  moveHeader(e, t, o, i, s) {
    const { ctrlsSvc: n, gos: r, colModel: l, visibleCols: a, focusSvc: d } = this.beans, c = t.getBoundingClientRect(), u = c.left, h = B(o), g = h ? c.width : o.getActualWidth(), p = e === "left" !== r.get("enableRtl"), f = Wi({
      x: p ? u - 20 : u + g + 20,
      pinned: i,
      fromKeyboard: !0,
      gos: r,
      ctrlsSvc: n
    }), C = d.focusedHeader;
    rl({
      allMovingColumns: h ? o.getLeafColumns() : [o],
      isFromHeader: !0,
      fromLeft: e === "right",
      xPosition: f,
      pinned: i,
      fromEnter: !1,
      fakeEvent: !1,
      gos: r,
      colModel: l,
      colMoves: this,
      visibleCols: a,
      finished: !0
    });
    let m;
    if (h) {
      const v = o.getDisplayedLeafColumns();
      m = p ? v[0] : G(v);
    } else
      m = o;
    if (n.getScrollFeature().ensureColumnVisible(m, "auto"), (!s.isAlive() || r.get("ensureDomOrder")) && C) {
      let v;
      if (h) {
        const S = o.getGroupId(), D = o.getLeafColumns();
        if (!D.length)
          return;
        const y = D[0].getParent();
        if (!y)
          return;
        v = jg(y, S);
      } else
        v = o;
      v && d.focusHeaderPosition({
        headerPosition: {
          ...C,
          column: v
        }
      });
    }
  }
  setDragSourceForHeader(e, t, o) {
    const { gos: i, colModel: s, dragAndDrop: n, visibleCols: r } = this.beans;
    let l = !i.get("suppressDragLeaveHidesColumns");
    const a = B(t), d = a ? t.getProvidedColumnGroup().getLeafColumns() : [t], u = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => l ? "hide" : "notAllowed",
      getDragItem: a ? () => Yg(t, r.allCols) : () => qg(t),
      dragItemName: o,
      onDragStarted: () => {
        l = !i.get("suppressDragLeaveHidesColumns"), hi(d, !0);
      },
      onDragStopped: () => hi(d, !1),
      onDragCancelled: () => hi(d, !1),
      onGridEnter: (h) => {
        if (l) {
          const { columns: g = [], visibleState: p } = h ?? {}, f = a ? (m) => !p || p[m.getColId()] : () => !0, C = g.filter(
            (m) => !m.getColDef().lockVisible && f(m)
          );
          s.setColsVisible(C, !0, "uiColumnMoved");
        }
      },
      onGridExit: (h) => {
        if (l) {
          const g = h?.columns?.filter((p) => !p.getColDef().lockVisible) || [];
          s.setColsVisible(g, !1, "uiColumnMoved");
        }
      }
    };
    return n.addDragSource(u, !0), u;
  }
};
function jg(e, t) {
  for (; e; ) {
    if (e.getGroupId() === t)
      return e;
    e = e.getParent();
  }
}
function qg(e) {
  const t = {};
  return t[e.getId()] = e.isVisible(), {
    columns: [e],
    visibleState: t,
    containerType: e.pinned
  };
}
function Yg(e, t) {
  const o = e.getProvidedColumnGroup().getLeafColumns(), i = {};
  for (const l of o)
    i[l.getId()] = l.isVisible();
  const s = [];
  for (const l of t)
    o.indexOf(l) >= 0 && (s.push(l), Pe(o, l));
  for (const l of o)
    s.push(l);
  const n = [], r = e.getLeafColumns();
  for (const l of s)
    r.indexOf(l) !== -1 && n.push(l);
  return {
    columns: s,
    columnsInSplit: n,
    visibleState: i,
    containerType: n[0]?.pinned
  };
}
var Zg = {
  moduleName: "ColumnMove",
  version: M,
  beans: [Kg, Mg],
  apiFunctions: {
    moveColumnByIndex: Tg,
    moveColumns: Ig
  },
  dependsOn: [Fg],
  css: [Ag]
}, Qg = class extends b {
  constructor() {
    super(...arguments), this.beanName = "autoWidthCalc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  getPreferredWidthForColumn(e, t) {
    const o = this.getHeaderCellForColumn(e);
    if (!o)
      return -1;
    const i = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(e);
    return t || i.push(o), this.getPreferredWidthForElements(i);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.getPreferredWidthForElements([t]) : -1;
  }
  getPreferredWidthForElements(e, t) {
    const o = document.createElement("form");
    o.style.position = "fixed";
    const i = this.centerRowContainerCtrl.eContainer;
    for (const n of e)
      this.cloneItemIntoDummy(n, o);
    i.appendChild(o);
    const s = o.offsetWidth;
    return o.remove(), t = t ?? this.gos.get("autoSizePadding"), s + t;
  }
  getHeaderCellForColumn(e) {
    let t = null;
    for (const o of this.beans.ctrlsSvc.getHeaderRowContainerCtrls()) {
      const i = o.getHtmlElementForColumnHeader(e);
      i != null && (t = i);
    }
    return t;
  }
  cloneItemIntoDummy(e, t) {
    const o = e.cloneNode(!0);
    o.style.width = "", o.style.position = "static", o.style.left = "";
    const i = document.createElement("div"), s = i.classList;
    ["ag-header-cell", "ag-header-group-cell"].some((l) => o.classList.contains(l)) ? (s.add("ag-header", "ag-header-row"), i.style.position = "static") : s.add("ag-row");
    let r = e.parentElement;
    for (; r; ) {
      if (["ag-header-row", "ag-row"].some((a) => r.classList.contains(a))) {
        for (let a = 0; a < r.classList.length; a++) {
          const d = r.classList[a];
          d != "ag-row-position-absolute" && s.add(d);
        }
        break;
      }
      r = r.parentElement;
    }
    i.appendChild(o), t.appendChild(i);
  }
}, ll = {
  moduleName: "AutoWidth",
  version: M,
  beans: [Qg]
};
function Xg(e, t, o = !0, i = "api") {
  e.colResize?.setColumnWidths(t, !1, o, i);
}
var Jg = class extends b {
  constructor(e, t, o, i) {
    super(), this.comp = e, this.eResize = t, this.pinned = o, this.columnGroup = i;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable()) {
      this.comp.setResizableDisplayed(!1);
      return;
    }
    const { horizontalResizeSvc: e, gos: t, colAutosize: o } = this.beans, i = e.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, !1),
      onResizeEnd: this.onResizing.bind(this, !0)
    });
    this.addDestroyFunc(i), !t.get("suppressAutoSize") && o && this.addDestroyFunc(
      o.addColumnGroupResize(
        this.eResize,
        this.columnGroup,
        () => this.resizeLeafColumnsToFit("uiColumnResized")
      )
    );
  }
  onResizeStart(e) {
    const {
      columnsToResize: t,
      resizeStartWidth: o,
      resizeRatios: i,
      groupAfterColumns: s,
      groupAfterStartWidth: n,
      groupAfterRatios: r
    } = this.getInitialValues(e);
    this.resizeCols = t, this.resizeStartWidth = o, this.resizeRatios = i, this.resizeTakeFromCols = s, this.resizeTakeFromStartWidth = n, this.resizeTakeFromRatios = r, this.toggleColumnResizing(!0);
  }
  onResizing(e, t, o = "uiColumnResized") {
    const i = this.normaliseDragChange(t), s = this.resizeStartWidth + i;
    this.resizeColumnsFromLocalValues(s, o, e);
  }
  getInitialValues(e) {
    const t = (a) => a.reduce((d, c) => d + c.getActualWidth(), 0), o = (a, d) => a.map((c) => c.getActualWidth() / d), i = this.getColumnsToResize(), s = t(i), n = o(i, s), r = {
      columnsToResize: i,
      resizeStartWidth: s,
      resizeRatios: n
    };
    let l = null;
    if (e && (l = this.beans.colGroupSvc?.getGroupAtDirection(this.columnGroup, "After") ?? null), l) {
      const a = l.getDisplayedLeafColumns(), d = r.groupAfterColumns = a.filter(
        (u) => u.isResizable()
      ), c = r.groupAfterStartWidth = t(d);
      r.groupAfterRatios = o(d, c);
    } else
      r.groupAfterColumns = void 0, r.groupAfterStartWidth = void 0, r.groupAfterRatios = void 0;
    return r;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup), o = this.getInitialValues();
    t > o.resizeStartWidth && this.resizeColumns(o, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, o = !0) {
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const i = {
      columnsToResize: this.resizeCols,
      resizeStartWidth: this.resizeStartWidth,
      resizeRatios: this.resizeRatios,
      groupAfterColumns: this.resizeTakeFromCols,
      groupAfterStartWidth: this.resizeTakeFromStartWidth,
      groupAfterRatios: this.resizeTakeFromRatios
    };
    this.resizeColumns(i, e, t, o);
  }
  resizeColumns(e, t, o, i = !0) {
    const {
      columnsToResize: s,
      resizeStartWidth: n,
      resizeRatios: r,
      groupAfterColumns: l,
      groupAfterStartWidth: a,
      groupAfterRatios: d
    } = e, c = [];
    if (c.push({
      columns: s,
      ratios: r,
      width: t
    }), l) {
      const u = t - n;
      c.push({
        columns: l,
        ratios: d,
        width: a - u
      });
    }
    this.beans.colResize?.resizeColumnSets({
      resizeSets: c,
      finished: i,
      source: o
    }), i && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.toggleCss("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((t) => t.isResizable());
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
}, ep = class extends b {
  constructor(e, t, o, i, s) {
    super(), this.pinned = e, this.column = t, this.eResize = o, this.comp = i, this.ctrl = s;
  }
  postConstruct() {
    const e = [];
    let t, o;
    const i = () => {
      if (V(this.eResize, t), !t)
        return;
      const { horizontalResizeSvc: r, colAutosize: l } = this.beans, a = r.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      e.push(a), o && l && e.push(l.addColumnAutosizeListeners(this.eResize, this.column));
    }, s = () => {
      for (const r of e)
        r();
      e.length = 0;
    }, n = () => {
      const r = this.column.isResizable(), l = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (r !== t || l !== o) && (t = r, o = l, s(), i());
    };
    n(), this.addDestroyFunc(s), this.ctrl.setRefreshFunction("resize", n);
  }
  onResizing(e, t) {
    const { column: o, lastResizeAmount: i, resizeStartWidth: s, beans: n } = this, r = this.normaliseResizeAmount(t), l = s + r, a = [{ key: o, newWidth: l }], { pinnedCols: d, ctrlsSvc: c, colResize: u } = n;
    if (this.column.getPinned()) {
      const h = d?.leftWidth ?? 0, g = d?.rightWidth ?? 0, p = Ot(c.getGridBodyCtrl().eBodyViewport) - 50;
      if (h + g + (r - i) > p)
        return;
    }
    this.lastResizeAmount = r, u?.setColumnWidths(a, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.column.resizing = e, this.comp.toggleCss("ag-column-resizing", e);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  normaliseResizeAmount(e) {
    let t = e;
    const o = this.pinned !== "left", i = this.pinned === "right";
    return this.gos.get("enableRtl") ? o && (t *= -1) : i && (t *= -1), t;
  }
}, tp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colResize";
  }
  setColumnWidths(e, t, o, i) {
    const s = [], { colModel: n, gos: r, visibleCols: l } = this.beans;
    for (const a of e) {
      const d = n.getColDefCol(a.key) || n.getCol(a.key);
      if (!d)
        continue;
      if (s.push({
        width: a.newWidth,
        ratios: [1],
        columns: [d]
      }), r.get("colResizeDefault") === "shift" && (t = !t), t) {
        const u = l.getColAfter(d);
        if (!u)
          continue;
        const h = d.getActualWidth() - a.newWidth, g = u.getActualWidth() + h;
        s.push({
          width: g,
          ratios: [1],
          columns: [u]
        });
      }
    }
    s.length !== 0 && this.resizeColumnSets({
      resizeSets: s,
      finished: o,
      source: i
    });
  }
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  resizeColumnSets(e) {
    const { resizeSets: t, finished: o, source: i } = e;
    if (!(!t || t.every((c) => op(c)))) {
      if (o) {
        const c = t && t.length > 0 ? t[0].columns : null;
        gt(this.eventSvc, c, o, i);
      }
      return;
    }
    const n = [], r = [];
    for (const c of t) {
      const { width: u, columns: h, ratios: g } = c, p = {}, f = {};
      for (const v of h)
        r.push(v);
      let C = !0, m = 0;
      for (; C; ) {
        if (m++, m > 1e3) {
          W(31);
          break;
        }
        C = !1;
        const v = [];
        let S = 0, D = u;
        h.forEach((R, x) => {
          if (f[R.getId()])
            D -= p[R.getId()];
          else {
            v.push(R);
            const I = g[x];
            S += I;
          }
        });
        const y = 1 / S;
        v.forEach((R, x) => {
          const k = x === v.length - 1;
          let I;
          k ? I = D : (I = Math.round(g[x] * u * y), D -= I);
          const T = R.getMinWidth(), _ = R.getMaxWidth();
          I < T ? (I = T, f[R.getId()] = !0, C = !0) : _ > 0 && I > _ && (I = _, f[R.getId()] = !0, C = !0), p[R.getId()] = I;
        });
      }
      for (const v of h) {
        const S = p[v.getId()];
        v.getActualWidth() !== S && (v.setActualWidth(S, i), n.push(v));
      }
    }
    const l = n.length > 0;
    let a = [];
    if (l) {
      const { colFlex: c, visibleCols: u, colViewport: h } = this.beans;
      a = c?.refreshFlexedColumns({
        resizingCols: r,
        skipSetLeft: !0
      }) ?? [], u.setLeftValues(i), u.updateBodyWidths(), h.checkViewportColumns();
    }
    const d = r.concat(a);
    (l || o) && gt(this.eventSvc, d, o, i, a);
  }
  resizeHeader(e, t, o) {
    if (!e.isResizable())
      return;
    const i = e.getActualWidth(), s = e.getMinWidth(), n = e.getMaxWidth(), r = Math.min(Math.max(i + t, s), n);
    this.setColumnWidths([{ key: e, newWidth: r }], o, !0, "uiColumnResized");
  }
  createResizeFeature(e, t, o, i, s) {
    return new ep(e, t, o, i, s);
  }
  createGroupResizeFeature(e, t, o, i) {
    return new Jg(e, t, o, i);
  }
};
function op(e) {
  const { columns: t, width: o } = e;
  let i = 0, s = 0, n = !0;
  for (const a of t) {
    const d = a.getMinWidth();
    i += d || 0;
    const c = a.getMaxWidth();
    c > 0 ? s += c : n = !1;
  }
  const r = o >= i, l = !n || o <= s;
  return r && l;
}
var ip = {
  moduleName: "ColumnResize",
  version: M,
  beans: [tp],
  apiFunctions: {
    setColumnWidths: Xg
  },
  dependsOn: [Eg, ll]
}, sp = class extends b {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListeners(this.columnGroup, {
      displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
    }), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    for (const t of this.columnGroup.getLeafColumns())
      t.__addEventListener("widthChanged", e), t.__addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.__removeEventListener("widthChanged", e), t.__removeEventListener("visibleChanged", e);
      });
  }
  removeListenersOnChildrenColumns() {
    for (const e of this.removeChildListenersFuncs)
      e();
    this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.toggleCss("ag-hidden", e === 0);
  }
}, np = class extends Zr {
  constructor() {
    super(...arguments), this.onSuppressColMoveChange = () => {
      !this.isAlive() || this.isSuppressMoving() ? this.removeDragSource() : this.dragSource || this.setDragSource(this.eGui);
    };
  }
  wireComp(e, t, o, i, s) {
    const { column: n, beans: r } = this, { context: l, colNames: a, colHover: d, rangeSvc: c, colResize: u } = r;
    this.comp = e, s = Wo(this, l, s), this.setGui(t, s), this.displayName = a.getDisplayNameForColumnGroup(n, "header"), this.refreshHeaderStyles(), this.addClasses(), this.setupMovingCss(s), this.setupExpandable(s), this.setupTooltip(), this.setupAutoHeight({
      wrapperElement: i,
      compBean: s
    }), this.setupUserComp(), this.addHeaderMouseListeners(s), this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this)), this.refreshMaxHeaderHeight();
    const h = this.rowCtrl.pinned, g = n.getProvidedColumnGroup().getLeafColumns();
    d?.createHoverFeature(s, g, t), c?.createRangeHighlightFeature(s, n, e), s.createManagedBean(new qr(n, t, r)), s.createManagedBean(new sp(e, n)), u ? this.resizeFeature = s.createManagedBean(
      u.createGroupResizeFeature(e, o, h, n)
    ) : e.setResizableDisplayed(!1), s.createManagedBean(
      new _o(t, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: () => {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    ), this.addHighlightListeners(s, g), s.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners(s), s.addDestroyFunc(() => this.clearComponent());
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, o = e.getDefinition();
    return L(t.gos, {
      colDef: o,
      columnGroup: e,
      floatingFilter: !1
    });
  }
  refreshMaxHeaderHeight() {
    const { gos: e, comp: t } = this, o = e.get("groupHeaderHeight");
    o != null ? o === 0 ? t.setHeaderWrapperHidden(!0) : t.setHeaderWrapperMaxHeight(o) : (t.setHeaderWrapperHidden(!1), t.setHeaderWrapperMaxHeight(null));
  }
  addHighlightListeners(e, t) {
    if (this.beans.gos.get("suppressMoveWhenColumnDragging"))
      for (const o of t)
        e.addManagedListeners(o, {
          headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, o)
        });
  }
  onLeafColumnHighlightChanged(e) {
    const t = this.column.getDisplayedLeafColumns(), o = t[0] === e, i = G(t) === e;
    if (!o && !i)
      return;
    const s = e.getHighlighted(), n = !!this.rowCtrl.getHeaderCellCtrls().find((a) => a.column.isMoving());
    let r = !1, l = !1;
    if (n) {
      const a = this.beans.gos.get("enableRtl"), d = s === 1, c = s === 0;
      o && (a ? l = d : r = c), i && (a ? r = c : l = d);
    }
    this.comp.toggleCss("ag-header-highlight-before", r), this.comp.toggleCss("ag-header-highlight-after", l);
  }
  resizeHeader(e, t) {
    const { resizeFeature: o } = this;
    if (!o)
      return;
    const i = o.getInitialValues(t);
    o.resizeColumns(i, i.resizeStartWidth + e, "uiColumnResized", !0);
  }
  resizeLeafColumnsToFit(e) {
    this.resizeFeature?.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const { colGroupSvc: e, userCompFactory: t, gos: o, enterpriseMenuFactory: i } = this.beans, s = this.column, n = s.getProvidedColumnGroup(), r = L(o, {
      displayName: this.displayName,
      columnGroup: s,
      setExpanded: (a) => {
        e.setColumnGroupOpened(n, a, "gridInitializing");
      },
      setTooltip: (a, d) => {
        o.assertModuleRegistered("Tooltip", 3), this.setupTooltip(a, d);
      },
      showColumnMenu: (a, d) => i?.showMenuAfterButtonClick(
        n,
        a,
        "columnMenu",
        d
      ),
      showColumnMenuAfterMouseClick: (a, d) => i?.showMenuAfterMouseEvent(
        n,
        a,
        "columnMenu",
        d
      ),
      eGridHeader: this.eGui
    }), l = qd(t, r);
    l && this.comp.setUserCompDetails(l);
  }
  addHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), o = () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup()), i = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column.getProvidedColumnGroup());
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: o,
      contextmenu: i
    });
  }
  handleMouseOverChange(e) {
    this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column.getProvidedColumnGroup()
    });
  }
  setupTooltip(e, t) {
    this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderGroupTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupExpandable(e) {
    const t = this.column.getProvidedColumnGroup();
    this.refreshExpanded();
    const o = this.refreshExpanded.bind(this);
    e.addManagedListeners(t, {
      expandedChanged: o,
      expandableChanged: o
    });
  }
  refreshExpanded() {
    const { column: e } = this;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0), this.refreshHeaderStyles();
  }
  addClasses() {
    const { column: e } = this, t = e.getColGroupDef(), o = Ur(t, this.gos, null, e);
    e.isPadding() ? (o.push("ag-header-group-cell-no-group"), e.getLeafColumns().every((s) => s.isSpanHeaderHeight()) && o.push("ag-header-span-height")) : (o.push("ag-header-group-cell-with-group"), t?.wrapHeaderText && o.push("ag-header-cell-wrap-text"));
    for (const i of o)
      this.comp.toggleCss(i, !0);
  }
  setupMovingCss(e) {
    const { column: t } = this, i = t.getProvidedColumnGroup().getLeafColumns(), s = () => this.comp.toggleCss("ag-header-cell-moving", t.isMoving());
    for (const n of i)
      e.addManagedListeners(n, { movingChanged: s });
    s();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || this.focusThis();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (!(!this.expandable || !t) && e.key === w.ENTER) {
      const o = this.column, i = !o.isExpanded();
      this.beans.colGroupSvc.setColumnGroupOpened(
        o.getProvidedColumnGroup(),
        i,
        "uiColumnExpanded"
      );
    }
  }
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  setDragSource(e) {
    !this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), e && (this.dragSource = this.beans.colMoves?.setDragSourceForHeader(e, this.column, this.displayName) ?? null));
  }
  isSuppressMoving() {
    return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((e) => e.getColDef().suppressMovable || e.getColDef().lockPosition);
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function rp(e, t, o) {
  e.colGroupSvc?.setColumnGroupOpened(t, o, "api");
}
function lp(e, t, o) {
  return e.colGroupSvc?.getColumnGroup(t, o) ?? null;
}
function ap(e, t) {
  return e.colGroupSvc?.getProvidedColGroup(t) ?? null;
}
function dp(e, t, o) {
  return e.colNames.getDisplayNameForColumnGroup(t, o) || "";
}
function cp(e) {
  return e.colGroupSvc?.getColumnGroupState() ?? [];
}
function up(e, t) {
  e.colGroupSvc?.setColumnGroupState(t, "api");
}
function hp(e) {
  e.colGroupSvc?.resetColumnGroupState("api");
}
function gp(e) {
  return e.visibleCols.treeLeft;
}
function pp(e) {
  return e.visibleCols.treeCenter;
}
function fp(e) {
  return e.visibleCols.treeRight;
}
function Cp(e) {
  return e.visibleCols.getAllTrees();
}
function mp(e, t) {
  for (let o = 0; o < t.length; o++) {
    const i = e.indexOf(t[o]);
    i >= 0 && (e[i] = e[e.length - 1], e.pop());
  }
}
var vp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "visibleCols", this.colsAndGroupsMap = {}, this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.headerGroupRowCount = 0, this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.isBodyWidthDirty = !0;
  }
  refresh(e, t = !1) {
    const { colFlex: o, colModel: i, colGroupSvc: s, colViewport: n, selectionColSvc: r } = this.beans;
    t || this.buildTrees(i, s), s?.updateOpenClosedVisibility(), this.leftCols = gi(this.treeLeft), this.centerCols = gi(this.treeCenter), this.rightCols = gi(this.treeRight), r?.refreshVisibility(this.leftCols, this.centerCols, this.rightCols), this.joinColsAriaOrder(i), this.joinCols(), this.headerGroupRowCount = this.getHeaderRowCount(), this.setLeftValues(e), this.autoHeightCols = this.allCols.filter((l) => l.isAutoHeight()), o?.refreshFlexedColumns(), this.updateBodyWidths(), this.setFirstRightAndLastLeftPinned(i, this.leftCols, this.rightCols, e), n.checkViewportColumns(!1), this.eventSvc.dispatchEvent({
      type: "displayedColumnsChanged",
      source: e
    });
  }
  getHeaderRowCount() {
    if (!this.gos.get("hidePaddedHeaderRows"))
      return this.beans.colModel.cols.treeDepth;
    let e = 0;
    for (const t of this.allCols) {
      let o = t.getParent();
      for (; o; ) {
        if (!o.isPadding()) {
          const i = o.getProvidedColumnGroup().getLevel() + 1;
          i > e && (e = i);
          break;
        }
        o = o.getParent();
      }
    }
    return e;
  }
  // after setColumnWidth or updateGroupsAndPresentedCols
  updateBodyWidths() {
    const e = be(this.centerCols), t = be(this.leftCols), o = be(this.rightCols);
    this.isBodyWidthDirty = this.bodyWidth !== e, (this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== o) && (this.bodyWidth = e, this.leftWidth = t, this.rightWidth = o, this.eventSvc.dispatchEvent({
      type: "columnContainerWidthChanged"
    }), this.eventSvc.dispatchEvent({
      type: "displayedColumnsWidthChanged"
    }));
  }
  // sets the left pixel position of each column
  setLeftValues(e) {
    this.setLeftValuesOfCols(e), this.setLeftValuesOfGroups();
  }
  setFirstRightAndLastLeftPinned(e, t, o, i) {
    let s, n;
    this.gos.get("enableRtl") ? (s = t ? t[0] : null, n = o ? G(o) : null) : (s = t ? G(t) : null, n = o ? o[0] : null);
    for (const r of e.getCols())
      r.setLastLeftPinned(r === s, i), r.setFirstRightPinned(r === n, i);
  }
  buildTrees(e, t) {
    const o = e.getColsToShow(), i = o.filter((a) => a.getPinned() == "left"), s = o.filter((a) => a.getPinned() == "right"), n = o.filter((a) => a.getPinned() != "left" && a.getPinned() != "right"), r = new Dd(), l = (a) => t ? t.createColumnGroups(a) : a.columns;
    this.treeLeft = l({
      columns: i,
      idCreator: r,
      pinned: "left",
      oldDisplayedGroups: this.treeLeft
    }), this.treeRight = l({
      columns: s,
      idCreator: r,
      pinned: "right",
      oldDisplayedGroups: this.treeRight
    }), this.treeCenter = l({
      columns: n,
      idCreator: r,
      pinned: null,
      oldDisplayedGroups: this.treeCenter
    }), this.updateColsAndGroupsMap();
  }
  clear() {
    this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.ariaOrderColumns = [];
  }
  joinColsAriaOrder(e) {
    const t = e.getCols(), o = [], i = [], s = [];
    for (const n of t) {
      const r = n.getPinned();
      r ? r === !0 || r === "left" ? o.push(n) : s.push(n) : i.push(n);
    }
    this.ariaOrderColumns = o.concat(i).concat(s);
  }
  getAriaColIndex(e) {
    let t;
    return B(e) ? t = e.getLeafColumns()[0] : t = e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  setLeftValuesOfGroups() {
    for (const e of [this.treeLeft, this.treeRight, this.treeCenter])
      for (const t of e)
        B(t) && t.checkLeft();
  }
  setLeftValuesOfCols(e) {
    const { colModel: t } = this.beans;
    if (!t.getColDefCols())
      return;
    const i = t.getCols().slice(0), s = this.gos.get("enableRtl");
    for (const n of [this.leftCols, this.rightCols, this.centerCols]) {
      if (s) {
        let r = be(n);
        for (const l of n)
          r -= l.getActualWidth(), l.setLeft(r, e);
      } else {
        let r = 0;
        for (const l of n)
          l.setLeft(r, e), r += l.getActualWidth();
      }
      mp(i, n);
    }
    for (const n of i)
      n.setLeft(null, e);
  }
  joinCols() {
    this.gos.get("enableRtl") ? this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols) : this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
  }
  getAllTrees() {
    return this.treeLeft && this.treeRight && this.treeCenter ? this.treeLeft.concat(this.treeCenter).concat(this.treeRight) : null;
  }
  // gridPanel -> ensureColumnVisible
  isColDisplayed(e) {
    return this.allCols.indexOf(e) >= 0;
  }
  getLeftColsForRow(e) {
    const {
      leftCols: t,
      beans: { colModel: o }
    } = this;
    return o.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getRightColsForRow(e) {
    const {
      rightCols: t,
      beans: { colModel: o }
    } = this;
    return o.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getColsForRow(e, t, o, i) {
    const s = [];
    let n = null;
    for (let r = 0; r < t.length; r++) {
      const l = t[r], a = t.length - r, d = Math.min(l.getColSpan(e), a), c = [l];
      if (d > 1) {
        const h = d - 1;
        for (let g = 1; g <= h; g++)
          c.push(t[r + g]);
        r += h;
      }
      let u;
      if (o) {
        u = !1;
        for (const h of c)
          o(h) && (u = !0);
      } else
        u = !0;
      u && (s.length === 0 && n && (i && i(l)) && s.push(n), s.push(l)), n = l;
    }
    return s;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  getColBefore(e) {
    const t = this.allCols, o = t.indexOf(e);
    return o > 0 ? t[o - 1] : null;
  }
  isPinningLeft() {
    return this.leftCols.length > 0;
  }
  isPinningRight() {
    return this.rightCols.length > 0;
  }
  updateColsAndGroupsMap() {
    this.colsAndGroupsMap = {};
    const e = (t) => {
      this.colsAndGroupsMap[t.getUniqueId()] = t;
    };
    Ue(this.treeCenter, !1, e), Ue(this.treeLeft, !1, e), Ue(this.treeRight, !1, e);
  }
  isVisible(e) {
    return this.colsAndGroupsMap[e.getUniqueId()] === e;
  }
  getFirstColumn() {
    const e = this.gos.get("enableRtl"), t = ["leftCols", "centerCols", "rightCols"];
    e && t.reverse();
    for (let o = 0; o < t.length; o++) {
      const i = this[t[o]];
      if (i.length)
        return e ? G(i) : i[0];
    }
    return null;
  }
  // used by:
  // + rowRenderer -> for navigation
  getColAfter(e) {
    const t = this.allCols, o = t.indexOf(e);
    return o < t.length - 1 ? t[o + 1] : null;
  }
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  getColsLeftWidth() {
    return be(this.leftCols);
  }
  // note: this should be cached
  getDisplayedColumnsRightWidth() {
    return be(this.rightCols);
  }
  isColAtEdge(e, t) {
    const o = this.allCols;
    if (!o.length)
      return !1;
    const i = t === "first";
    let s;
    if (B(e)) {
      const n = e.getDisplayedLeafColumns();
      if (!n.length)
        return !1;
      s = i ? n[0] : G(n);
    } else
      s = e;
    return (i ? o[0] : G(o)) === s;
  }
};
function Ue(e, t, o) {
  if (e)
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      if (B(s)) {
        const n = t ? s.getDisplayedChildren() : s.getChildren();
        Ue(n, t, o);
      }
      o(s);
    }
}
function gi(e) {
  const t = [];
  return Ue(e, !0, (o) => {
    Ke(o) && t.push(o);
  }), t;
}
var wp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colGroupSvc";
  }
  getColumnGroupState() {
    const e = [], t = this.beans.colModel.getColTree();
    return Re(null, t, (o) => {
      $(o) && e.push({
        groupId: o.getGroupId(),
        open: o.isExpanded()
      });
    }), e;
  }
  resetColumnGroupState(e) {
    const t = this.beans.colModel.getColDefColTree();
    if (!t)
      return;
    const o = [];
    Re(null, t, (i) => {
      if ($(i)) {
        const s = i.getColGroupDef(), n = {
          groupId: i.getGroupId(),
          open: s ? s.openByDefault : void 0
        };
        o.push(n);
      }
    }), this.setColumnGroupState(o, e);
  }
  setColumnGroupState(e, t) {
    const { colModel: o, colAnimation: i, visibleCols: s, eventSvc: n } = this.beans;
    if (!o.getColTree().length)
      return;
    i?.start();
    const l = [];
    for (const a of e) {
      const d = a.groupId, c = a.open, u = this.getProvidedColGroup(d);
      u && u.isExpanded() !== c && (u.setExpanded(c), l.push(u));
    }
    s.refresh(t, !0), l.length && n.dispatchEvent({
      type: "columnGroupOpened",
      columnGroup: l.length === 1 ? l[0] : void 0,
      columnGroups: l
    }), i?.finish();
  }
  // called by headerRenderer - when a header is opened or closed
  setColumnGroupOpened(e, t, o) {
    let i;
    $(e) ? i = e.getId() : i = e || "", this.setColumnGroupState([{ groupId: i, open: t }], o);
  }
  getProvidedColGroup(e) {
    let t = null;
    return Re(null, this.beans.colModel.getColTree(), (o) => {
      $(o) && o.getId() === e && (t = o);
    }), t;
  }
  getGroupAtDirection(e, t) {
    const o = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), i = e.getDisplayedLeafColumns(), s = t === "After" ? G(i) : i[0], n = `getCol${t}`;
    for (; ; ) {
      const r = this.beans.visibleCols[n](s);
      if (!r)
        return null;
      const l = this.getColGroupAtLevel(r, o);
      if (l !== e)
        return l;
    }
  }
  getColGroupAtLevel(e, t) {
    let o = e.getParent(), i, s;
    for (; i = o.getProvidedColumnGroup().getLevel(), s = o.getPaddingLevel(), !(i + s <= t); )
      o = o.getParent();
    return o;
  }
  updateOpenClosedVisibility() {
    const e = this.beans.visibleCols.getAllTrees();
    Ue(e, !1, (t) => {
      B(t) && t.calculateDisplayedColumns();
    });
  }
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (B(e))
      return e;
    const o = this.beans.visibleCols.getAllTrees(), i = typeof t == "number";
    let s = null;
    return Ue(o, !1, (n) => {
      if (B(n)) {
        const r = n;
        let l;
        i ? l = e === r.getGroupId() && t === r.getPartId() : l = e === r.getGroupId(), l && (s = r);
      }
    }), s;
  }
  createColumnGroups(e) {
    const { columns: t, idCreator: o, pinned: i, oldDisplayedGroups: s, isStandaloneStructure: n } = e, r = this.mapOldGroupsById(s), l = [];
    let a = t;
    for (; a.length; ) {
      const d = a;
      a = [];
      let c = 0;
      const u = (h) => {
        const g = c;
        c = h;
        const p = d[g], C = (B(p) ? p.getProvidedColumnGroup() : p).getOriginalParent();
        if (C == null) {
          for (let v = g; v < h; v++)
            l.push(d[v]);
          return;
        }
        const m = this.createColumnGroup(
          C,
          o,
          r,
          i,
          n
        );
        for (let v = g; v < h; v++)
          m.addChild(d[v]);
        a.push(m);
      };
      for (let h = 1; h < d.length; h++) {
        const g = d[h], f = (B(g) ? g.getProvidedColumnGroup() : g).getOriginalParent(), C = d[c], v = (B(C) ? C.getProvidedColumnGroup() : C).getOriginalParent();
        f !== v && u(h);
      }
      c < d.length && u(d.length);
    }
    return n || this.setupParentsIntoCols(l, null), l;
  }
  createProvidedColumnGroup(e, t, o, i, s, n, r) {
    const l = s.getUniqueKey(t.groupId || null, null), a = Gs(this.beans, t, l), d = new uo(a, l, !1, o);
    this.createBean(d);
    const c = this.findExistingGroup(t, n);
    c && n.splice(c.idx, 1);
    const u = c?.group;
    u && d.setExpanded(u.isExpanded());
    const h = ar(
      this.beans,
      a.children,
      o + 1,
      e,
      i,
      s,
      n,
      r
    );
    return d.setChildren(h), d;
  }
  balanceColumnTree(e, t, o, i) {
    const s = [];
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      if ($(r)) {
        const l = r, a = this.balanceColumnTree(
          l.getChildren(),
          t + 1,
          o,
          i
        );
        l.setChildren(a), s.push(l);
      } else {
        let l, a;
        for (let d = t; d < o; d++) {
          const c = i.getUniqueKey(null, null), u = Gs(this.beans, null, c), h = new uo(u, c, !0, d);
          this.createBean(h), a && a.setChildren([h]), a = h, l || (l = a);
        }
        if (l && a)
          if (s.push(l), e.some((c) => $(c))) {
            a.setChildren([r]);
            continue;
          } else {
            a.setChildren(e);
            break;
          }
        s.push(r);
      }
    }
    return s;
  }
  findDepth(e) {
    let t = 0, o = e;
    for (; o?.[0] && $(o[0]); )
      t++, o = o[0].getChildren();
    return t;
  }
  findMaxDepth(e, t) {
    let o = t;
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      if ($(s)) {
        const n = s, r = this.findMaxDepth(n.getChildren(), t + 1);
        o < r && (o = r);
      }
    }
    return o;
  }
  /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */
  balanceTreeForAutoCols(e, t) {
    const o = [];
    for (const i of e) {
      let s = i;
      for (let n = t - 1; n >= 0; n--) {
        const r = new uo(null, `FAKE_PATH_${i.getId()}}_${n}`, !0, n);
        this.createBean(r), r.setChildren([s]), s.originalParent = r, s = r;
      }
      t === 0 && (i.originalParent = null), o.push(s);
    }
    return o;
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let i = 0; i < t.length; i++) {
        const s = t[i];
        if (s.getColGroupDef() && s.getId() === e.groupId)
          return { idx: i, group: s };
      }
  }
  createColumnGroup(e, t, o, i, s) {
    const n = e.getGroupId(), r = t.getInstanceIdForKey(n), l = Lr(n, r);
    let a = o[l];
    return a && a.getProvidedColumnGroup() !== e && (a = null), A(a) ? a.reset() : (a = new Ut(e, n, r, i), s || this.createBean(a)), a;
  }
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  mapOldGroupsById(e) {
    const t = {}, o = (i) => {
      for (const s of i)
        if (B(s)) {
          const n = s;
          t[s.getUniqueId()] = n, o(n.getChildren());
        }
    };
    return e && o(e), t;
  }
  setupParentsIntoCols(e, t) {
    for (const o of e ?? [])
      if (o.parent !== t && (this.beans.colViewport.colsWithinViewportHash = ""), o.parent = t, B(o)) {
        const i = o;
        this.setupParentsIntoCols(i.getChildren(), i);
      }
  }
}, Sp = {
  moduleName: "ColumnGroup",
  version: M,
  dynamicBeans: { headerGroupCellCtrl: np },
  beans: [wp],
  apiFunctions: {
    getAllDisplayedColumnGroups: Cp,
    getCenterDisplayedColumnGroups: pp,
    getColumnGroup: lp,
    getColumnGroupState: cp,
    getDisplayNameForColumnGroup: dp,
    getLeftDisplayedColumnGroups: gp,
    getProvidedColumnGroup: ap,
    getRightDisplayedColumnGroups: fp,
    resetColumnGroupState: hp,
    setColumnGroupOpened: rp,
    setColumnGroupState: up
  }
}, bp = { tag: "div", cls: "ag-skeleton-container" }, yp = class extends O {
  constructor() {
    super(bp);
  }
  init(e) {
    const t = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", t), this.addDestroyFunc(() => Ht(e.eParentOfValue)), Ht(e.eParentOfValue, t), e.deferRender ? this.setupLoading(e) : e.node.failedLoad ? this.setupFailed() : this.setupLoading(e);
  }
  setupFailed() {
    const e = this.getLocaleTextFunc();
    this.getGui().textContent = e("loadingError", "ERR");
    const t = e("ariaSkeletonCellLoadingFailed", "Row failed to load");
    Gt(this.getGui(), t);
  }
  setupLoading(e) {
    const t = ie({
      tag: "div",
      cls: "ag-skeleton-effect"
    }), o = e.node.rowIndex;
    if (o != null) {
      const n = 75 + 25 * (o % 2 === 0 ? Math.sin(o) : Math.cos(o));
      t.style.width = `${n}%`;
    }
    this.getGui().appendChild(t);
    const i = this.getLocaleTextFunc(), s = e.deferRender ? i("ariaDeferSkeletonCellLoading", "Cell is loading") : i("ariaSkeletonCellLoading", "Row data is loading");
    Gt(this.getGui(), s);
  }
  refresh(e) {
    return !1;
  }
}, Rp = {
  moduleName: "CheckboxCellRenderer",
  version: M,
  userComponents: {
    agCheckboxCellRenderer: Ih
  }
}, xp = {
  moduleName: "SkeletonCellRenderer",
  version: M,
  userComponents: {
    agSkeletonCellRenderer: yp
  }
};
function Pp(e, t) {
  const o = e.colModel.getColDefCol(t);
  return o ? o.getColDef() : null;
}
function Dp(e) {
  return e.colModel.getColumnDefs(!0);
}
function Fp(e, t, o) {
  return e.colNames.getDisplayNameForColumn(t, o) || "";
}
function Ep(e, t) {
  return e.colModel.getColDefCol(t);
}
function Ap(e) {
  return e.colModel.getColDefCols();
}
function Mp(e, t) {
  return pt(e, t, "api");
}
function Tp(e) {
  return Ti(e);
}
function Ip(e) {
  bd(e, "api");
}
function kp(e) {
  return e.visibleCols.isPinningLeft() || e.visibleCols.isPinningRight();
}
function Lp(e) {
  return e.visibleCols.isPinningLeft();
}
function Gp(e) {
  return e.visibleCols.isPinningRight();
}
function Hp(e, t) {
  return e.visibleCols.getColAfter(t);
}
function Op(e, t) {
  return e.visibleCols.getColBefore(t);
}
function Bp(e, t, o) {
  e.colModel.setColsVisible(t, o, "api");
}
function Vp(e, t, o) {
  e.pinnedCols?.setColsPinned(t, o, "api");
}
function Wp(e) {
  return e.colModel.getCols();
}
function Np(e) {
  return e.visibleCols.leftCols;
}
function zp(e) {
  return e.visibleCols.centerCols;
}
function _p(e) {
  return e.visibleCols.rightCols;
}
function Up(e) {
  return e.visibleCols.allCols;
}
function $p(e) {
  return e.colViewport.getViewportColumns();
}
function zi(e, t) {
  if (!e)
    return;
  const o = e, i = {};
  for (const s of Object.keys(o)) {
    if (t && t.indexOf(s) >= 0 || Nn.has(s))
      continue;
    const n = o[s];
    typeof n == "object" && n !== null && n.constructor === Object ? i[s] = zi(n) : i[s] = n;
  }
  return i;
}
var Kp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colDefFactory";
  }
  wireBeans(e) {
    this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc;
  }
  getColumnDefs(e, t, o, i, s = !1) {
    const n = e.slice();
    t ? n.sort((a, d) => o.indexOf(a) - o.indexOf(d)) : (o || s) && n.sort((a, d) => i.indexOf(a) - i.indexOf(d));
    const r = this.rowGroupColsSvc?.columns, l = this.pivotColsSvc?.columns;
    return this.buildColumnDefs(n, r, l);
  }
  buildColumnDefs(e, t = [], o = []) {
    const i = [], s = {};
    for (const n of e) {
      const r = this.createDefFromColumn(n, t, o);
      let l = !0, a = r, d = n.getOriginalParent(), c = null;
      for (; d; ) {
        let u = null;
        if (d.isPadding()) {
          d = d.getOriginalParent();
          continue;
        }
        const h = s[d.getGroupId()];
        if (h) {
          h.children.push(a), l = !1;
          break;
        }
        if (u = this.createDefFromGroup(d), u && (u.children = [a], s[u.groupId] = u, a = u, d = d.getOriginalParent()), d != null && c === d) {
          l = !1;
          break;
        }
        c = d;
      }
      l && i.push(a);
    }
    return i;
  }
  createDefFromGroup(e) {
    const t = zi(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, o) {
    const i = zi(e.getColDef());
    return i.colId = e.getColId(), i.width = e.getActualWidth(), i.rowGroup = e.isRowGroupActive(), i.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, i.pivot = e.isPivotActive(), i.pivotIndex = e.isPivotActive() ? o.indexOf(e) : null, i.aggFunc = e.isValueActive() ? e.getAggFunc() : null, i.hide = e.isVisible() ? void 0 : !0, i.pinned = e.isPinned() ? e.getPinned() : null, i.sort = e.getSort() ? e.getSort() : null, i.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, i;
  }
}, jp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colFlex", this.columnsHidden = !1;
  }
  refreshFlexedColumns(e = {}) {
    const t = e.source ?? "flex";
    e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth);
    const o = this.flexViewportWidth, { visibleCols: i, colDelayRenderSvc: s } = this.beans, n = i.centerCols;
    let r = -1;
    if (e.resizingCols) {
      const f = new Set(e.resizingCols);
      for (let C = n.length - 1; C >= 0; C--)
        if (f.has(n[C])) {
          r = C;
          break;
        }
    }
    let l = !1;
    const a = n.map((f, C) => {
      const m = f.getFlex(), v = m != null && m > 0 && C > r;
      return l || (l = v), {
        col: f,
        isFlex: v,
        flex: Math.max(0, m ?? 0),
        initialSize: f.getActualWidth(),
        min: f.getMinWidth(),
        max: f.getMaxWidth(),
        targetSize: 0
      };
    });
    if (l ? (s?.hideColumns("colFlex"), this.columnsHidden = !0) : this.columnsHidden && this.revealColumns(s), !o || !l)
      return [];
    let d = a.length, c = a.reduce((f, C) => f + C.flex, 0), u = o;
    const h = (f, C) => {
      f.frozenSize = C, f.col.setActualWidth(C, t), u -= C, c -= f.flex, d -= 1;
    }, g = (f) => f.frozenSize != null;
    for (const f of a)
      f.isFlex || h(f, f.initialSize);
    for (; d > 0; ) {
      const f = Math.round(c < 1 ? u * c : u);
      let C, m = 0, v = 0;
      for (const y of a) {
        if (g(y))
          continue;
        C = y, v += f * (y.flex / c);
        const R = v - m, x = Math.round(R);
        y.targetSize = x, m += x;
      }
      C && (C.targetSize += f - m);
      let S = 0;
      for (const y of a) {
        if (g(y))
          continue;
        const R = y.targetSize, x = Math.min(Math.max(R, y.min), y.max);
        S += x - R, y.violationType = x === R ? void 0 : x < R ? "max" : "min", y.targetSize = x;
      }
      const D = S === 0 ? "all" : S > 0 ? "min" : "max";
      for (const y of a)
        g(y) || (D === "all" || y.violationType === D) && h(y, y.targetSize);
    }
    e.skipSetLeft || i.setLeftValues(t), e.updateBodyWidths && i.updateBodyWidths();
    const p = a.filter((f) => f.isFlex && !f.violationType).map((f) => f.col);
    if (e.fireResizedEvent) {
      const f = a.filter((m) => m.initialSize !== m.frozenSize).map((m) => m.col), C = a.filter((m) => m.flex).map((m) => m.col);
      gt(this.eventSvc, f, !0, t, C);
    }
    return this.revealColumns(s), p;
  }
  revealColumns(e) {
    this.columnsHidden && (e?.revealColumns("colFlex"), this.columnsHidden = !1);
  }
  initCol(e) {
    const { flex: t, initialFlex: o } = e.colDef;
    t !== void 0 ? e.flex = t : o !== void 0 && (e.flex = o);
  }
  // this method should only be used by the colModel to
  // change flex when required by the applyColumnState method.
  setColFlex(e, t) {
    e.flex = t ?? null, e.dispatchStateUpdatedEvent("flex");
  }
};
function fo(e, t, o) {
  if (!t || !e)
    return;
  if (!o)
    return e[t];
  const i = t.split(".");
  let s = e;
  for (let n = 0; n < i.length; n++) {
    if (s == null)
      return;
    s = s[i[n]];
  }
  return s;
}
var qp = [
  "dateTimeString",
  "dateString",
  "text",
  "number",
  "boolean",
  "date"
], Yp = class extends b {
  constructor() {
    super(...arguments), this.beanName = "dataTypeSvc", this.dataTypeDefinitions = {}, this.isPendingInference = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [], this.columnDefinitionPropsPerDataType = {
      number() {
        return { cellEditor: "agNumberCellEditor" };
      },
      boolean() {
        return {
          cellEditor: "agCheckboxCellEditor",
          cellRenderer: "agCheckboxCellRenderer",
          getFindText: () => null,
          suppressKeyboardEvent: (e) => !!e.colDef.editable && e.event.key === w.SPACE
        };
      },
      date({ formatValue: e }) {
        return { cellEditor: "agDateCellEditor", keyCreator: e };
      },
      dateString({ formatValue: e }) {
        return { cellEditor: "agDateStringCellEditor", keyCreator: e };
      },
      dateTime(e) {
        return this.date(e);
      },
      dateTimeString(e) {
        return this.dateString(e);
      },
      object({ formatValue: e, colModel: t, colId: o }) {
        return {
          cellEditorParams: {
            useFormatter: !0
          },
          comparator: (i, s) => {
            const n = t.getColDefCol(o), r = n?.getColDef();
            if (!n || !r)
              return 0;
            const l = i == null ? "" : e({ column: n, node: null, value: i }), a = s == null ? "" : e({ column: n, node: null, value: s });
            return l === a ? 0 : l > a ? 1 : -1;
          },
          keyCreator: e
        };
      },
      text() {
        return {};
      }
    };
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  postConstruct() {
    this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.colModel.recreateColumnDefs(e);
    });
  }
  processDataTypeDefinitions() {
    const e = this.getDefaultDataTypes(), t = {}, o = {}, i = (c) => (u) => {
      const { column: h, node: g, value: p } = u;
      let f = h.getColDef().valueFormatter;
      return f === c.groupSafeValueFormatter && (f = c.valueFormatter), this.beans.valueSvc.formatValue(h, g, p, f);
    };
    for (const c of Object.keys(e)) {
      const u = e[c], h = {
        ...u,
        groupSafeValueFormatter: rn(u, this.gos)
      };
      t[c] = h, o[c] = i(h);
    }
    const s = this.gos.get("dataTypeDefinitions") ?? {}, n = {};
    for (const c of Object.keys(s)) {
      const u = s[c], h = this.processDataTypeDefinition(
        u,
        s,
        [c],
        e
      );
      h && (t[c] = h, u.dataTypeMatcher && (n[c] = u.dataTypeMatcher), o[c] = i(h));
    }
    const { valueParser: r, valueFormatter: l } = e.object, { valueParser: a, valueFormatter: d } = t.object;
    this.hasObjectValueParser = a !== r, this.hasObjectValueFormatter = d !== l, this.formatValueFuncs = o, this.dataTypeDefinitions = t, this.dataTypeMatchers = this.sortKeysInMatchers(n, e);
  }
  /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */
  sortKeysInMatchers(e, t) {
    const o = { ...e };
    for (const i of qp)
      delete o[i], o[i] = e[i] ?? t[i].dataTypeMatcher;
    return o;
  }
  processDataTypeDefinition(e, t, o, i) {
    let s;
    const n = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let r = i[n];
      const l = t[n];
      if (r && l && (r = l), !nn(e, r, n))
        return;
      s = sn(r, e);
    } else {
      if (o.includes(n)) {
        F(44);
        return;
      }
      const r = t[n];
      if (!nn(e, r, n))
        return;
      const l = this.processDataTypeDefinition(
        r,
        t,
        [...o, n],
        i
      );
      if (!l)
        return;
      s = sn(l, e);
    }
    return {
      ...s,
      groupSafeValueFormatter: rn(s, this.gos)
    };
  }
  updateColDefAndGetColumnType(e, t, o) {
    let { cellDataType: i } = t;
    const { field: s } = t;
    if (i === void 0 && (i = e.cellDataType), (i == null || i === !0) && (i = this.canInferCellDataType(e, t) ? this.inferCellDataType(s, o) : !1), !i) {
      e.cellDataType = !1;
      return;
    }
    const n = this.dataTypeDefinitions[i];
    if (!n) {
      F(47, { cellDataType: i });
      return;
    }
    return e.cellDataType = i, n.groupSafeValueFormatter && (e.valueFormatter = n.groupSafeValueFormatter), n.valueParser && (e.valueParser = n.valueParser), n.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, i, n, o), n.columnTypes;
  }
  addColumnListeners(e) {
    if (!this.isPendingInference)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const o = (i) => {
      t.add(i.key);
    };
    e.__addEventListener("columnStateUpdated", o), this.columnStateUpdateListenerDestroyFuncs.push(
      () => e.__removeEventListener("columnStateUpdated", o)
    );
  }
  canInferCellDataType(e, t) {
    const { gos: o } = this;
    if (!re(o))
      return !1;
    const i = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (pi(t, i))
      return !1;
    const s = t.type === null ? e.type : t.type;
    if (s) {
      const n = o.get("columnTypes") ?? {};
      if (Eo(s).some((l) => {
        const a = n[l.trim()];
        return a && pi(a, i);
      }))
        return !1;
    }
    return !pi(e, i);
  }
  inferCellDataType(e, t) {
    if (!e)
      return;
    let o;
    const i = this.getInitialData();
    if (i) {
      const n = e.includes(".") && !this.gos.get("suppressFieldDotNotation");
      o = fo(i, e, n);
    } else
      this.initWaitForRowData(t);
    return o == null ? void 0 : Object.keys(this.dataTypeMatchers).find(
      (n) => this.dataTypeMatchers[n](o)
    ) ?? "object";
  }
  getInitialData() {
    const e = this.gos.get("rowData");
    if (e?.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const t = this.beans.rowModel.rootNode?._leafs;
      if (t?.length)
        return t[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isPendingInference)
      return;
    this.isPendingInference = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions, { colAutosize: o, eventSvc: i } = this.beans;
    t && o && (o.shouldQueueResizeOperations = !0);
    const [s] = this.addManagedEventListeners({
      rowDataUpdateStarted: (n) => {
        const { firstRowData: r } = n;
        r && (s?.(), this.isPendingInference = !1, this.processColumnsPendingInference(r, t), this.columnStateUpdatesPendingInference = {}, t && o?.processResizeOperations(), i.dispatchEvent({
          type: "dataTypesInferred"
        }));
      }
    });
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const o = [];
    this.destroyColumnStateUpdateListeners();
    const i = {}, s = {};
    for (const n of Object.keys(this.columnStateUpdatesPendingInference)) {
      const r = this.columnStateUpdatesPendingInference[n], l = this.colModel.getCol(n);
      if (!l)
        return;
      const a = l.getColDef();
      if (!this.resetColDefIntoCol(l, "cellDataTypeInferred"))
        return;
      const d = l.getColDef();
      if (t && d.type && d.type !== a.type) {
        const c = Qp(l, r);
        c.rowGroup && c.rowGroupIndex == null && (i[n] = c), c.pivot && c.pivotIndex == null && (s[n] = c), o.push(c);
      }
    }
    t && o.push(
      ...this.generateColumnStateForRowGroupAndPivotIndexes(
        i,
        s
      )
    ), o.length && pt(this.beans, { state: o }, "cellDataTypeInferred"), this.initialData = null;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    const o = {}, { rowGroupColsSvc: i, pivotColsSvc: s } = this.beans;
    return i?.restoreColumnOrder(o, e), s?.restoreColumnOrder(o, t), Object.values(o);
  }
  resetColDefIntoCol(e, t) {
    const o = e.getUserProvidedColDef();
    if (!o)
      return !1;
    const i = Mi(this.beans, o, e.getColId());
    return e.setColDef(i, o, t), !0;
  }
  getDateStringTypeDefinition(e) {
    const { dateString: t } = this.dataTypeDefinitions;
    return e ? this.getDataTypeDefinition(e) ?? t : t;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDateIncludesTimeFlag(e) {
    return e === "dateTime" || e === "dateTimeString";
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    return this.getDataTypeDefinition(e)?.baseDataType;
  }
  checkType(e, t) {
    if (t == null)
      return !0;
    const o = this.getDataTypeDefinition(e)?.dataTypeMatcher;
    return o ? o(t) : !0;
  }
  validateColDef(e) {
    const t = (o) => F(48, { property: o });
    if (e.cellDataType === "object") {
      const { object: o } = this.dataTypeDefinitions;
      e.valueFormatter === o.groupSafeValueFormatter && !this.hasObjectValueFormatter && t("Formatter"), e.editable && e.valueParser === o.valueParser && !this.hasObjectValueParser && t("Parser");
    }
  }
  postProcess(e) {
    const t = e.cellDataType;
    if (!t || typeof t != "string")
      return;
    const { dataTypeDefinitions: o, beans: i, formatValueFuncs: s } = this, n = o[t];
    n && i.colFilter?.setColDefPropsForDataType(e, n, s[t]);
  }
  // noinspection JSUnusedGlobalSymbols
  getFormatValue(e) {
    return this.formatValueFuncs[e];
  }
  isColPendingInference(e) {
    return this.isPendingInference && !!this.columnStateUpdatesPendingInference[e];
  }
  setColDefPropertiesForBaseDataType(e, t, o, i) {
    const s = this.formatValueFuncs[t], n = this.columnDefinitionPropsPerDataType[o.baseDataType]({
      colDef: e,
      cellDataType: t,
      colModel: this.colModel,
      dataTypeDefinition: o,
      colId: i,
      formatValue: s
    });
    Object.assign(e, n);
  }
  getDateObjectTypeDef(e) {
    const t = this.getLocaleTextFunc(), o = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      valueParser: (i) => Gi(i.newValue && String(i.newValue)),
      valueFormatter: (i) => i.value == null ? "" : !(i.value instanceof Date) || isNaN(i.value.getTime()) ? t("invalidDate", "Invalid Date") : zs(i.value, o) ?? "",
      dataTypeMatcher: (i) => i instanceof Date
    };
  }
  getDateStringTypeDef(e) {
    const t = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      dateParser: (o) => Gi(o) ?? void 0,
      dateFormatter: (o) => zs(o ?? null, t) ?? void 0,
      valueParser: (o) => ho(String(o.newValue)) ? o.newValue : null,
      valueFormatter: (o) => ho(String(o.value)) ? String(o.value) : "",
      dataTypeMatcher: (o) => typeof o == "string" && ho(o)
    };
  }
  getDefaultDataTypes() {
    const e = this.getLocaleTextFunc();
    return {
      number: {
        baseDataType: "number",
        // can be empty space with legacy copy
        valueParser: (t) => t.newValue?.trim?.() === "" ? null : Number(t.newValue),
        valueFormatter: (t) => t.value == null ? "" : typeof t.value != "number" || isNaN(t.value) ? e("invalidNumber", "Invalid Number") : String(t.value),
        dataTypeMatcher: (t) => typeof t == "number"
      },
      text: {
        baseDataType: "text",
        valueParser: (t) => t.newValue === "" ? null : wi(t.newValue),
        dataTypeMatcher: (t) => typeof t == "string"
      },
      boolean: {
        baseDataType: "boolean",
        valueParser: (t) => t.newValue == null ? t.newValue : t.newValue?.trim?.() === "" ? null : String(t.newValue).toLowerCase() === "true",
        valueFormatter: (t) => t.value == null ? "" : String(t.value),
        dataTypeMatcher: (t) => typeof t == "boolean"
      },
      date: this.getDateObjectTypeDef("date"),
      dateString: this.getDateStringTypeDef("dateString"),
      dateTime: this.getDateObjectTypeDef("dateTime"),
      dateTimeString: {
        ...this.getDateStringTypeDef("dateTimeString"),
        dataTypeMatcher: (t) => typeof t == "string" && lc(t)
      },
      object: {
        baseDataType: "object",
        valueParser: () => null,
        valueFormatter: (t) => wi(t.value) ?? ""
      }
    };
  }
  destroyColumnStateUpdateListeners() {
    for (const e of this.columnStateUpdateListenerDestroyFuncs)
      e();
    this.columnStateUpdateListenerDestroyFuncs = [];
  }
  destroy() {
    this.dataTypeDefinitions = {}, this.dataTypeMatchers = {}, this.formatValueFuncs = {}, this.columnStateUpdatesPendingInference = {}, this.destroyColumnStateUpdateListeners(), super.destroy();
  }
};
function sn(e, t) {
  const o = {
    ...e,
    ...t
  };
  return e.columnTypes && t.columnTypes && t.appendColumnTypes && (o.columnTypes = [
    ...Eo(e.columnTypes),
    ...Eo(t.columnTypes)
  ]), o;
}
function nn(e, t, o) {
  return t ? t.baseDataType !== e.baseDataType ? (F(46), !1) : !0 : (F(45, { parentCellDataType: o }), !1);
}
function rn(e, t) {
  if (e.valueFormatter)
    return (o) => {
      if (o.node?.group) {
        const i = (o.colDef.pivotValueColumn ?? o.column).getAggFunc();
        if (i) {
          if (i === "first" || i === "last")
            return e.valueFormatter(o);
          if (e.baseDataType === "number" && i !== "count") {
            if (typeof o.value == "number")
              return e.valueFormatter(o);
            if (typeof o.value == "object") {
              if (!o.value)
                return;
              if ("toNumber" in o.value)
                return e.valueFormatter({
                  ...o,
                  value: o.value.toNumber()
                });
              if ("value" in o.value)
                return e.valueFormatter({
                  ...o,
                  value: o.value.value
                });
            }
          }
          return;
        }
      } else if (t.get("groupHideOpenParents") && o.column.isRowGroupActive() && typeof o.value == "string" && !e.dataTypeMatcher?.(o.value))
        return;
      return e.valueFormatter(o);
    };
}
function Zp(e, t, o, i) {
  if (!t[o])
    return !1;
  const s = e[o];
  return s === null ? (t[o] = !1, !1) : i === void 0 ? !!s : s === i;
}
function pi(e, t) {
  return [
    ["cellRenderer", "agSparklineCellRenderer"],
    ["valueGetter", void 0],
    ["valueParser", void 0],
    ["refData", void 0]
  ].some(
    ([o, i]) => Zp(e, t, o, i)
  );
}
function Qp(e, t) {
  const o = fr(e);
  for (const i of t)
    delete o[i], i === "rowGroup" ? delete o.rowGroupIndex : i === "pivot" && delete o.pivotIndex;
  return o;
}
var Xp = {
  moduleName: "DataType",
  version: M,
  beans: [Yp],
  dependsOn: [Rp]
}, Jp = {
  moduleName: "ColumnFlex",
  version: M,
  beans: [jp]
}, fS = {
  moduleName: "ColumnApi",
  version: M,
  beans: [Kp],
  apiFunctions: {
    getColumnDef: Pp,
    getDisplayNameForColumn: Fp,
    getColumn: Ep,
    getColumns: Ap,
    applyColumnState: Mp,
    getColumnState: Tp,
    resetColumnState: Ip,
    isPinning: kp,
    isPinningLeft: Lp,
    isPinningRight: Gp,
    getDisplayedColAfter: Hp,
    getDisplayedColBefore: Op,
    setColumnsVisible: Bp,
    setColumnsPinned: Vp,
    getAllGridColumns: Wp,
    getDisplayedLeftColumns: Np,
    getDisplayedCenterColumns: zp,
    getDisplayedRightColumns: _p,
    getAllDisplayedColumns: Up,
    getAllDisplayedVirtualColumns: $p,
    getColumnDefs: Dp
  }
};
function ef(e) {
  if (!e || e == null)
    return null;
  const t = /([a-z])([A-Z])/g, o = /([A-Z]+)([A-Z])([a-z])/g;
  return e.replace(t, "$1 $2").replace(o, "$1 $2$3").replace(/\./g, " ").split(" ").map((s) => s.substring(0, 1).toUpperCase() + (s.length > 1 ? s.substring(1, s.length) : "")).join(" ");
}
var tf = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colNames";
  }
  getDisplayNameForColumn(e, t, o = !1) {
    if (!e)
      return null;
    const i = this.getHeaderName(e.getColDef(), e, null, null, t), { aggColNameSvc: s } = this.beans;
    return o && s ? s.getHeaderName(e, i) : i;
  }
  getDisplayNameForProvidedColumnGroup(e, t, o) {
    const i = t?.getColGroupDef();
    return i ? this.getHeaderName(i, null, e, t, o) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  // location is where the column is going to appear, ie who is calling us
  getHeaderName(e, t, o, i, s) {
    const n = e.headerValueGetter;
    if (n) {
      const r = L(this.gos, {
        colDef: e,
        column: t,
        columnGroup: o,
        providedColumnGroup: i,
        location: s
      });
      return typeof n == "function" ? n(r) : typeof n == "string" ? this.beans.expressionSvc?.evaluate(n, r) ?? null : "";
    } else {
      if (e.headerName != null)
        return e.headerName;
      if (e.field)
        return ef(e.field);
    }
    return "";
  }
}, of = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colViewport", this.colsWithinViewport = [], this.headerColsWithinViewport = [], this.colsWithinViewportHash = "", this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.columnsToRenderLeft = [], this.columnsToRenderRight = [], this.columnsToRenderCenter = [];
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel;
  }
  postConstruct() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
  }
  setScrollPosition(e, t, o = !1) {
    const { visibleCols: i } = this, s = i.isBodyWidthDirty;
    if (!(e === this.scrollWidth && t === this.scrollPosition && !s)) {
      if (this.scrollWidth = e, this.scrollPosition = t, i.isBodyWidthDirty = !0, this.gos.get("enableRtl")) {
        const r = i.bodyWidth;
        this.viewportLeft = r - t - e, this.viewportRight = r - t;
      } else
        this.viewportLeft = t, this.viewportRight = e + t;
      this.colModel.ready && this.checkViewportColumns(o);
    }
  }
  /**
   * Returns the columns that are currently rendered in the viewport.
   */
  getColumnHeadersToRender(e) {
    switch (e) {
      case "left":
        return this.columnsToRenderLeft;
      case "right":
        return this.columnsToRenderRight;
      default:
        return this.columnsToRenderCenter;
    }
  }
  /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */
  getHeadersToRender(e, t) {
    let o;
    switch (e) {
      case "left":
        o = this.rowsOfHeadersToRenderLeft[t];
        break;
      case "right":
        o = this.rowsOfHeadersToRenderRight[t];
        break;
      default:
        o = this.rowsOfHeadersToRenderCenter[t];
        break;
    }
    return o ?? [];
  }
  extractViewportColumns() {
    const e = this.visibleCols.centerCols;
    this.isColumnVirtualisationSuppressed() ? (this.colsWithinViewport = e, this.headerColsWithinViewport = e) : (this.colsWithinViewport = e.filter(this.isColumnInRowViewport.bind(this)), this.headerColsWithinViewport = e.filter(this.isColumnInHeaderViewport.bind(this)));
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  clear() {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.colsWithinViewportHash = "";
  }
  isColumnInHeaderViewport(e) {
    return e.isAutoHeaderHeight() || sf(e) ? !0 : this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, o = t + e.getActualWidth(), i = this.viewportLeft - 200, s = this.viewportRight + 200, n = t < i && o < i, r = t > s && o > s;
    return !n && !r;
  }
  // used by Grid API only
  getViewportColumns() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    return this.colsWithinViewport.concat(e).concat(t);
  }
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  getColsWithinViewport(e) {
    if (!this.colModel.colSpanActive)
      return this.colsWithinViewport;
    const t = (n) => {
      const r = n.getLeft();
      return A(r) && r > this.viewportLeft;
    }, o = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this), { visibleCols: i } = this, s = i.centerCols;
    return i.getColsForRow(e, s, o, t);
  }
  // checks what columns are currently displayed due to column virtualisation. dispatches an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  checkViewportColumns(e = !1) {
    this.extractViewport() && this.eventSvc.dispatchEvent({
      type: "virtualColumnsChanged",
      afterScroll: e
    });
  }
  calculateHeaderRows() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    this.columnsToRenderLeft = e, this.columnsToRenderRight = t, this.columnsToRenderCenter = this.colsWithinViewport;
    const o = (i) => {
      const s = /* @__PURE__ */ new Set(), n = {};
      for (const r of i) {
        let l = r.getParent();
        const a = r.isSpanHeaderHeight();
        for (; l && !s.has(l); ) {
          if (a && l.isPadding()) {
            l = l.getParent();
            continue;
          }
          const c = l.getProvidedColumnGroup().getLevel();
          n[c] ?? (n[c] = []), n[c].push(l), s.add(l), l = l.getParent();
        }
      }
      return n;
    };
    this.rowsOfHeadersToRenderLeft = o(e), this.rowsOfHeadersToRenderRight = o(t), this.rowsOfHeadersToRenderCenter = o(this.headerColsWithinViewport);
  }
  extractViewport() {
    const e = (i) => `${i.getId()}-${i.getPinned() || "normal"}`;
    this.extractViewportColumns();
    const t = this.getViewportColumns().map(e).join("#"), o = this.colsWithinViewportHash !== t;
    return o && (this.colsWithinViewportHash = t, this.calculateHeaderRows()), o;
  }
};
function sf(e) {
  for (; e; ) {
    if (e.isAutoHeaderHeight())
      return !0;
    e = e.getParent();
  }
  return !1;
}
var nf = class extends b {
  constructor() {
    super(...arguments), this.beanName = "agCompUtils";
  }
  adaptFunction(e, t) {
    if (!e.cellRenderer)
      return null;
    class o {
      refresh() {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(s) {
        const n = t(s), r = typeof n;
        if (r === "string" || r === "number" || r === "boolean") {
          this.eGui = Zi("<span>" + n + "</span>");
          return;
        }
        if (n == null) {
          this.eGui = ie({ tag: "span" });
          return;
        }
        this.eGui = n;
      }
    }
    return o;
  }
}, rf = {
  moduleName: "CellRendererFunction",
  version: M,
  beans: [nf]
}, lf = class extends ou {
  constructor() {
    super(...arguments), this.agGridDefaults = {}, this.agGridDefaultOverrides = {}, this.jsComps = {}, this.selectors = {}, this.icons = {};
  }
  postConstruct() {
    const e = this.gos.get("components");
    if (e != null)
      for (const t of Object.keys(e))
        this.jsComps[t] = e[t];
  }
  registerModule(e) {
    const { icons: t, userComponents: o, dynamicBeans: i, selectors: s } = e;
    if (o) {
      const n = (r, l, a, d) => {
        this.agGridDefaults[r] = l, (a || d) && (this.agGridDefaultOverrides[r] = { params: a, processParams: d });
      };
      for (const r of Object.keys(o)) {
        let l = o[r];
        if (oc(l) && (l = l.getComp(this.beans)), typeof l == "object") {
          const { classImp: a, params: d, processParams: c } = l;
          n(r, a, d, c);
        } else
          n(r, l);
      }
    }
    this.registerDynamicBeans(i);
    for (const n of s ?? [])
      this.selectors[n.selector] = n;
    if (t)
      for (const n of Object.keys(t))
        this.icons[n] = t[n];
  }
  getUserComponent(e, t) {
    const o = (l, a, d, c) => ({
      componentFromFramework: a,
      component: l,
      params: d,
      processParams: c
    }), { frameworkOverrides: i } = this.beans, s = i.frameworkComponent(t, this.gos.get("components"));
    if (s != null)
      return o(s, !0);
    const n = this.jsComps[t];
    if (n) {
      const l = i.isFrameworkComponent(n);
      return o(n, l);
    }
    const r = this.agGridDefaults[t];
    if (r) {
      const l = this.agGridDefaultOverrides[t];
      return o(r, !1, l?.params, l?.processParams);
    }
    return this.beans.validation?.missingUserComponent(e, t, this.agGridDefaults, this.jsComps), null;
  }
  getSelector(e) {
    return this.selectors[e];
  }
  getIcon(e) {
    return this.icons[e];
  }
  getDynamicError(e, t) {
    return t ? Ce(279, { name: e }) : this.beans.validation?.missingDynamicBean(e) ?? Ce(256);
  }
}, af = 23, df = class extends b {
  constructor() {
    super(...arguments), this.beanName = "ctrlsSvc", this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  postConstruct() {
    this.addEventListener(
      "ready",
      () => {
        if (this.updateReady(), this.ready) {
          for (const e of this.readyCallbacks)
            e(this.params);
          this.readyCallbacks.length = 0;
        }
      },
      this.beans.frameworkOverrides.runWhenReadyAsync?.() ?? !1
    );
  }
  updateReady() {
    const e = Object.values(this.params);
    this.ready = e.length === af && e.every((t) => t?.isAlive() ?? !1);
  }
  whenReady(e, t) {
    this.ready ? t(this.params) : this.readyCallbacks.push(t), e.addDestroyFunc(() => {
      const o = this.readyCallbacks.indexOf(t);
      o >= 0 && this.readyCallbacks.splice(o, 1);
    });
  }
  register(e, t) {
    this.params[e] = t, this.updateReady(), this.ready && this.dispatchLocalEvent({ type: "ready" }), t.addDestroyFunc(() => {
      this.updateReady();
    });
  }
  get(e) {
    return this.params[e];
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    const { leftHeader: e, centerHeader: t, rightHeader: o } = this.params;
    return [e, o, t];
  }
  getHeaderRowContainerCtrl(e) {
    const t = this.params;
    switch (e) {
      case "left":
        return t.leftHeader;
      case "right":
        return t.rightHeader;
      default:
        return t.centerHeader;
    }
  }
  getScrollFeature() {
    return this.getGridBodyCtrl().scrollFeature;
  }
}, cf = (
  /*css*/
  '.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value:not(.ag-allow-overflow),.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-data-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-data-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-data-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-body,.ag-floating-bottom,.ag-floating-top{background-color:var(--ag-data-background-color)}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-data-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-virtual-list-item{height:var(--ag-list-item-height);position:absolute;width:100%}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}'
), uf = {
  wrapperBorder: !0,
  rowBorder: !0,
  headerRowBorder: !0,
  footerRowBorder: {
    ref: "rowBorder"
  },
  columnBorder: {
    style: "solid",
    width: 1,
    color: "transparent"
  },
  headerColumnBorder: !1,
  headerColumnBorderHeight: "100%",
  pinnedColumnBorder: !0,
  pinnedRowBorder: !0,
  sidePanelBorder: !0,
  sideBarPanelWidth: 250,
  sideBarBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  sideButtonBarBackgroundColor: {
    ref: "sideBarBackgroundColor"
  },
  sideButtonBarTopPadding: 0,
  sideButtonSelectedUnderlineWidth: 2,
  sideButtonSelectedUnderlineColor: "transparent",
  sideButtonSelectedUnderlineTransitionDuration: 0,
  sideButtonBackgroundColor: "transparent",
  sideButtonTextColor: { ref: "textColor" },
  sideButtonHoverBackgroundColor: { ref: "sideButtonBackgroundColor" },
  sideButtonHoverTextColor: { ref: "sideButtonTextColor" },
  sideButtonSelectedBackgroundColor: q,
  sideButtonSelectedTextColor: { ref: "sideButtonTextColor" },
  sideButtonBorder: "solid 1px transparent",
  sideButtonSelectedBorder: !0,
  sideButtonLeftPadding: { ref: "spacing" },
  sideButtonRightPadding: { ref: "spacing" },
  sideButtonVerticalPadding: { calc: "spacing * 3" },
  headerBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  headerFontFamily: {
    ref: "fontFamily"
  },
  cellFontFamily: {
    ref: "fontFamily"
  },
  headerFontWeight: 500,
  headerFontSize: {
    ref: "fontSize"
  },
  dataFontSize: {
    ref: "fontSize"
  },
  headerTextColor: {
    ref: "textColor"
  },
  headerCellHoverBackgroundColor: "transparent",
  headerCellMovingBackgroundColor: { ref: "headerCellHoverBackgroundColor" },
  headerCellBackgroundTransitionDuration: "0.2s",
  cellTextColor: {
    ref: "textColor"
  },
  rangeSelectionBorderStyle: "solid",
  rangeSelectionBorderColor: z,
  rangeSelectionBackgroundColor: oe(0.2),
  rangeSelectionChartBackgroundColor: "#0058FF1A",
  rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
  rangeSelectionHighlightColor: oe(0.5),
  rangeHeaderHighlightColor: Hc(0.08),
  rowNumbersSelectedColor: oe(0.5),
  rowHoverColor: oe(0.08),
  columnHoverColor: oe(0.05),
  selectedRowBackgroundColor: oe(0.12),
  modalOverlayBackgroundColor: {
    ref: "backgroundColor",
    mix: 0.66
  },
  dataBackgroundColor: q,
  oddRowBackgroundColor: { ref: "dataBackgroundColor" },
  wrapperBorderRadius: 8,
  cellHorizontalPadding: {
    calc: "spacing * 2 * cellHorizontalPaddingScale"
  },
  cellWidgetSpacing: {
    calc: "spacing * 1.5"
  },
  cellHorizontalPaddingScale: 1,
  rowGroupIndentSize: {
    calc: "cellWidgetSpacing + iconSize"
  },
  valueChangeDeltaUpColor: "#43a047",
  valueChangeDeltaDownColor: "#e53935",
  valueChangeValueHighlightBackgroundColor: "#16a08580",
  rowHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
  },
  rowVerticalPaddingScale: 1,
  headerHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
  },
  headerVerticalPaddingScale: 1,
  paginationPanelHeight: {
    ref: "rowHeight",
    calc: "max(rowHeight, 22px)"
  },
  dragHandleColor: se(0.7),
  headerColumnResizeHandleHeight: "30%",
  headerColumnResizeHandleWidth: 2,
  headerColumnResizeHandleColor: {
    ref: "borderColor"
  },
  widgetContainerHorizontalPadding: {
    calc: "spacing * 1.5"
  },
  widgetContainerVerticalPadding: {
    calc: "spacing * 1.5"
  },
  widgetHorizontalSpacing: {
    calc: "spacing * 1.5"
  },
  widgetVerticalSpacing: {
    ref: "spacing"
  },
  iconButtonColor: { ref: "iconColor" },
  iconButtonBackgroundColor: "transparent",
  iconButtonBackgroundSpread: 4,
  iconButtonBorderRadius: 1,
  iconButtonHoverColor: { ref: "iconButtonColor" },
  iconButtonHoverBackgroundColor: se(0.1),
  iconButtonActiveColor: z,
  iconButtonActiveBackgroundColor: oe(0.28),
  iconButtonActiveIndicatorColor: z,
  menuBorder: {
    color: se(0.2)
  },
  menuBackgroundColor: K(0.03),
  menuTextColor: K(0.95),
  menuShadow: {
    ref: "popupShadow"
  },
  menuSeparatorColor: {
    ref: "borderColor"
  },
  setFilterIndentSize: {
    ref: "iconSize"
  },
  chartMenuPanelWidth: 260,
  chartMenuLabelColor: se(0.8),
  dialogShadow: {
    ref: "popupShadow"
  },
  cellEditingBorder: {
    color: z
  },
  cellEditingShadow: { ref: "cardShadow" },
  fullRowEditInvalidBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.25
  },
  dialogBorder: {
    color: se(0.2)
  },
  panelBackgroundColor: q,
  panelTitleBarHeight: { ref: "headerHeight" },
  panelTitleBarBackgroundColor: {
    ref: "headerBackgroundColor"
  },
  panelTitleBarIconColor: {
    ref: "headerTextColor"
  },
  panelTitleBarTextColor: {
    ref: "headerTextColor"
  },
  panelTitleBarFontWeight: {
    ref: "headerFontWeight"
  },
  panelTitleBarBorder: !0,
  columnSelectIndentSize: {
    ref: "iconSize"
  },
  toolPanelSeparatorBorder: !0,
  columnDropCellBackgroundColor: se(0.07),
  columnDropCellTextColor: {
    ref: "textColor"
  },
  columnDropCellDragHandleColor: {
    ref: "textColor"
  },
  columnDropCellBorder: {
    color: se(0.13)
  },
  selectCellBackgroundColor: se(0.07),
  selectCellBorder: {
    color: se(0.13)
  },
  advancedFilterBuilderButtonBarBorder: !0,
  advancedFilterBuilderIndentSize: {
    calc: "spacing * 2 + iconSize"
  },
  advancedFilterBuilderJoinPillColor: "#f08e8d",
  advancedFilterBuilderColumnPillColor: "#a6e194",
  advancedFilterBuilderOptionPillColor: "#f3c08b",
  advancedFilterBuilderValuePillColor: "#85c0e4",
  filterPanelApplyButtonColor: q,
  filterPanelApplyButtonBackgroundColor: z,
  filterPanelCardSubtleColor: {
    ref: "textColor",
    mix: 0.7
  },
  filterPanelCardSubtleHoverColor: { ref: "textColor" },
  findMatchColor: Xe,
  findMatchBackgroundColor: "#ffff00",
  findActiveMatchColor: Xe,
  findActiveMatchBackgroundColor: "#ffa500",
  filterToolPanelGroupIndent: {
    ref: "spacing"
  },
  rowLoadingSkeletonEffectColor: se(0.15),
  statusBarLabelColor: Xe,
  statusBarLabelFontWeight: 500,
  statusBarValueColor: Xe,
  statusBarValueFontWeight: 500,
  pinnedSourceRowTextColor: {
    ref: "textColor"
  },
  pinnedSourceRowBackgroundColor: {
    ref: "dataBackgroundColor"
  },
  pinnedSourceRowFontWeight: 600,
  pinnedRowFontWeight: 600,
  pinnedRowBackgroundColor: {
    ref: "dataBackgroundColor"
  },
  pinnedRowTextColor: {
    ref: "textColor"
  }
}, hf = (
  /*css*/
  ".ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}"
), al = {
  cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
  cellBatchEditTextColor: "#422f00",
  rowBatchEditBackgroundColor: {
    ref: "cellBatchEditBackgroundColor"
  },
  rowBatchEditTextColor: {
    ref: "cellBatchEditTextColor"
  }
}, gf = {
  ...al,
  cellBatchEditTextColor: "#f3d0b3"
}, pf = () => te({
  feature: "batchEditStyle",
  params: al,
  css: hf
}), ff = /* @__PURE__ */ pf(), dl = (
  /*css*/
  ":where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}"
), cl = {
  buttonTextColor: "inherit",
  buttonFontWeight: "normal",
  buttonBackgroundColor: "transparent",
  buttonBorder: !1,
  buttonBorderRadius: { ref: "borderRadius" },
  buttonHorizontalPadding: { calc: "spacing * 2" },
  buttonVerticalPadding: { ref: "spacing" },
  buttonHoverTextColor: { ref: "buttonTextColor" },
  buttonHoverBackgroundColor: { ref: "buttonBackgroundColor" },
  buttonHoverBorder: { ref: "buttonBorder" },
  buttonActiveTextColor: { ref: "buttonHoverTextColor" },
  buttonActiveBackgroundColor: { ref: "buttonHoverBackgroundColor" },
  buttonActiveBorder: { ref: "buttonHoverBorder" },
  buttonDisabledTextColor: { ref: "inputDisabledTextColor" },
  buttonDisabledBackgroundColor: { ref: "inputDisabledBackgroundColor" },
  buttonDisabledBorder: { ref: "inputDisabledBorder" }
}, Cf = () => te({
  feature: "buttonStyle",
  params: {
    ...cl,
    buttonBackgroundColor: q,
    buttonBorder: !0,
    buttonHoverBackgroundColor: { ref: "rowHoverColor" },
    buttonActiveBorder: { color: z }
  },
  css: dl
}), mf = /* @__PURE__ */ Cf(), vf = () => te({
  feature: "buttonStyle",
  params: {
    ...cl,
    buttonBackgroundColor: q,
    buttonBorder: { color: z },
    buttonFontWeight: 600,
    buttonTextColor: z,
    buttonHoverBackgroundColor: { ref: "rowHoverColor" },
    buttonActiveBackgroundColor: z,
    buttonActiveTextColor: q
  },
  css: dl
}), wf = /* @__PURE__ */ vf(), Sf = (
  /*css*/
  ".ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}"
), bf = () => te({
  feature: "columnDropStyle",
  css: Sf
}), ws = /* @__PURE__ */ bf(), yf = {
  warn: (...e) => {
    F(e[0], e[1]);
  },
  error: (...e) => {
    W(e[0], e[1]);
  },
  preInitErr: (...e) => {
    Dt(e[0], e[2], e[1]);
  }
}, ul = () => jc(yf).withParams(uf).withPart(mf).withPart(ws).withPart(ff), Rf = (
  /*css*/
  '.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}'
), xf = () => te({
  feature: "checkboxStyle",
  params: {
    checkboxBorderWidth: 1,
    checkboxBorderRadius: {
      ref: "borderRadius"
    },
    checkboxUncheckedBackgroundColor: q,
    checkboxUncheckedBorderColor: K(0.3),
    checkboxCheckedBackgroundColor: z,
    checkboxCheckedBorderColor: { ref: "checkboxCheckedBackgroundColor" },
    checkboxCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
    },
    checkboxCheckedShapeColor: q,
    checkboxIndeterminateBackgroundColor: K(0.3),
    checkboxIndeterminateBorderColor: { ref: "checkboxIndeterminateBackgroundColor" },
    checkboxIndeterminateShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
    },
    checkboxIndeterminateShapeColor: q,
    radioCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
    }
  },
  css: Rf
}), hl = /* @__PURE__ */ xf(), Ss = () => ({
  ...Io,
  ...gf,
  backgroundColor: "hsl(217, 0%, 17%)",
  foregroundColor: "#FFF",
  chromeBackgroundColor: K(0.05),
  rowHoverColor: oe(0.15),
  selectedRowBackgroundColor: oe(0.2),
  menuBackgroundColor: K(0.1),
  browserColorScheme: "dark",
  popupShadow: "0 0px 20px #000A",
  cardShadow: "0 1px 4px 1px #000A",
  advancedFilterBuilderJoinPillColor: "#7a3a37",
  advancedFilterBuilderColumnPillColor: "#355f2d",
  advancedFilterBuilderOptionPillColor: "#5a3168",
  advancedFilterBuilderValuePillColor: "#374c86",
  filterPanelApplyButtonColor: Xe,
  findMatchColor: q,
  findActiveMatchColor: q,
  checkboxUncheckedBorderColor: K(0.4),
  toggleButtonOffBackgroundColor: K(0.4),
  rowBatchEditBackgroundColor: K(0.1)
}), Pf = () => te({
  feature: "colorScheme",
  params: Ss()
}), CS = /* @__PURE__ */ Pf(), Df = () => ({
  ...Ss(),
  backgroundColor: "#1f2836"
}), Ff = () => te({
  feature: "colorScheme",
  params: Io,
  modeParams: {
    light: Io,
    dark: Ss(),
    "dark-blue": Df()
  }
}), gl = /* @__PURE__ */ Ff(), Ef = (
  /*css*/
  `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`
), Af = /* @__PURE__ */ te({
  feature: "iconSet",
  css: Ef
}), pl = {
  aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
  arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
  asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
  chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
  "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
  columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
  contracted: '<path d="m9 18 6-6-6-6"/>',
  copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
  cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
  csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  expanded: '<path d="m15 18-6-6 6-6"/>',
  "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
  eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
  first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
  group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
  last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
  left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
  linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
  loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
  maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
  menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
  "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
  minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
  minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
  next: '<path d="m9 18 6-6-6-6"/>',
  none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
  "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
  paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
  pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
  plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
  previous: '<path d="m15 18-6-6 6-6"/>',
  right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
  "small-left": '<path d="m15 18-6-6 6-6"/>',
  "small-right": '<path d="m9 18 6-6-6-6"/>',
  tick: '<path d="M20 6 9 17l-5-5"/>',
  "tree-closed": '<path d="m9 18 6-6-6-6"/>',
  "tree-indeterminate": '<path d="M5 12h14"/>',
  "tree-open": '<path d="m6 9 6 6 6-6"/>',
  unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
  up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
  settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
}, fl = {
  "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
  "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
  "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
  "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
  "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
  "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>',
  "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
  edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>'
}, Mf = (e = {}) => {
  let t = "";
  for (const o of [...Object.keys(pl), ...Object.keys(fl)]) {
    const i = Tf(o, e.strokeWidth);
    t += `.ag-icon-${o}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(i)}'); }
`;
  }
  return t;
}, Tf = (e, t = 1.5) => {
  const o = fl[e];
  if (o)
    return o;
  const i = pl[e];
  if (!i)
    throw new Error(`Missing icon data for ${e}`);
  return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${t}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + i + "</svg>";
}, If = (e = {}) => te({
  feature: "iconSet",
  css: () => Mf(e)
}), kf = /* @__PURE__ */ If(), Lf = (
  /*css*/
  ':where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}'
), Gf = (
  /*css*/
  ".ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}"
), Hf = {
  inputBackgroundColor: "transparent",
  inputBorder: !1,
  inputBorderRadius: 0,
  inputTextColor: {
    ref: "textColor"
  },
  inputPlaceholderTextColor: {
    ref: "inputTextColor",
    mix: 0.5
  },
  inputPaddingStart: 0,
  inputHeight: {
    calc: "max(iconSize, fontSize) + spacing * 2"
  },
  inputFocusBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputFocusBorder: {
    ref: "inputBorder"
  },
  inputFocusShadow: "none",
  inputFocusTextColor: {
    ref: "inputTextColor"
  },
  inputDisabledBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputDisabledBorder: {
    ref: "inputBorder"
  },
  inputDisabledTextColor: {
    ref: "inputTextColor"
  },
  inputInvalidBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputInvalidBorder: {
    ref: "inputBorder"
  },
  inputInvalidTextColor: {
    ref: "inputTextColor"
  },
  inputIconColor: {
    ref: "inputTextColor"
  },
  pickerButtonBorder: !1,
  pickerButtonFocusBorder: { ref: "inputFocusBorder" },
  pickerButtonBackgroundColor: { ref: "backgroundColor" },
  pickerButtonFocusBackgroundColor: { ref: "backgroundColor" },
  pickerListBorder: !1,
  pickerListBackgroundColor: { ref: "backgroundColor" },
  colorPickerThumbSize: 18,
  colorPickerTrackSize: 12,
  colorPickerThumbBorderWidth: 3,
  colorPickerTrackBorderRadius: 12,
  colorPickerColorBorderRadius: 4
}, Of = () => te({
  feature: "inputStyle",
  params: {
    ...Hf,
    inputBackgroundColor: q,
    inputBorder: !0,
    inputBorderRadius: {
      ref: "borderRadius"
    },
    inputPaddingStart: {
      ref: "spacing"
    },
    inputFocusBorder: {
      color: z
    },
    inputFocusShadow: {
      ref: "focusShadow"
    },
    inputDisabledBackgroundColor: K(0.06),
    inputDisabledTextColor: {
      ref: "textColor",
      mix: 0.5
    },
    inputInvalidBorder: {
      color: { ref: "invalidColor" }
    },
    pickerButtonBorder: !0,
    pickerListBorder: !0
  },
  css: () => Lf + Gf
}), Cl = /* @__PURE__ */ Of(), ml = (
  /*css*/
  '.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}'
), vl = {
  tabBarBackgroundColor: "transparent",
  tabBarHorizontalPadding: 0,
  tabBarTopPadding: 0,
  tabBackgroundColor: "transparent",
  tabTextColor: {
    ref: "textColor"
  },
  tabHorizontalPadding: {
    ref: "spacing"
  },
  tabTopPadding: {
    ref: "spacing"
  },
  tabBottomPadding: {
    ref: "spacing"
  },
  tabSpacing: "0",
  tabHoverBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabHoverTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabSelectedTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBorderWidth: { ref: "borderWidth" },
  tabSelectedBorderColor: "transparent",
  tabSelectedUnderlineColor: "transparent",
  tabSelectedUnderlineWidth: 0,
  tabSelectedUnderlineTransitionDuration: 0,
  tabBarBorder: !1
}, Bf = () => te({
  feature: "tabStyle",
  params: {
    ...vl,
    tabBarBorder: !0,
    tabBarBackgroundColor: se(0.05),
    tabTextColor: {
      ref: "textColor",
      mix: 0.7
    },
    tabSelectedTextColor: {
      ref: "textColor"
    },
    tabHoverTextColor: {
      ref: "textColor"
    },
    tabSelectedBorderColor: {
      ref: "borderColor"
    },
    tabSelectedBackgroundColor: q
  },
  css: ml
}), Vf = /* @__PURE__ */ Bf(), Wf = () => te({
  feature: "tabStyle",
  params: {
    ...vl,
    tabBarBorder: !0,
    tabBarBackgroundColor: {
      ref: "chromeBackgroundColor"
    },
    tabHoverTextColor: z,
    tabSelectedTextColor: z,
    tabSelectedUnderlineColor: z,
    tabSelectedUnderlineWidth: 2,
    tabSelectedUnderlineTransitionDuration: "0.3s"
  },
  css: ml
}), Nf = /* @__PURE__ */ Wf(), zf = () => ul().withPart(hl).withPart(gl).withPart(kf).withPart(Vf).withPart(Cl).withPart(ws).withParams({
  fontFamily: [
    { googleFont: "IBM Plex Sans" },
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu"
  ]
}), _f = /* @__PURE__ */ zf(), Uf = () => ul().withPart(wf).withPart(hl).withPart(gl).withPart(Af).withPart(Nf).withPart(Cl).withPart(ws).withParams({
  accentColor: "#2196f3",
  selectedRowBackgroundColor: oe(0.3),
  inputFocusBorder: {
    color: oe(0.4)
  },
  focusShadow: { radius: 2, spread: 1.6, color: oe(0.4) },
  iconButtonHoverBackgroundColor: "transparent",
  iconButtonActiveBackgroundColor: "transparent",
  checkboxUncheckedBorderColor: K(0.45),
  checkboxIndeterminateBackgroundColor: K(0.45),
  checkboxIndeterminateBorderColor: K(0.45),
  checkboxBorderWidth: 2,
  checkboxBorderRadius: 2,
  fontSize: 13,
  dataFontSize: 14,
  headerFontWeight: 700,
  borderRadius: 3,
  wrapperBorderRadius: 3,
  tabSelectedUnderlineColor: z,
  tabSelectedBorderWidth: 0,
  tabSelectedUnderlineTransitionDuration: 0.3,
  sideButtonSelectedUnderlineColor: z,
  sideButtonSelectedUnderlineWidth: 2,
  sideButtonSelectedUnderlineTransitionDuration: 0.3,
  sideButtonBorder: !1,
  sideButtonSelectedBorder: !1,
  sideButtonBarTopPadding: { calc: "spacing * 3" },
  sideButtonSelectedBackgroundColor: "transparent",
  sideButtonHoverTextColor: z,
  iconButtonHoverColor: z,
  toggleButtonWidth: 28,
  toggleButtonHeight: 18,
  toggleButtonSwitchInset: 1,
  toggleButtonOffBackgroundColor: K(0.45),
  colorPickerThumbSize: 13,
  colorPickerTrackSize: 11,
  colorPickerThumbBorderWidth: 2,
  colorPickerTrackBorderRadius: 2,
  colorPickerColorBorderRadius: 2
}), mS = /* @__PURE__ */ Uf(), $f = {
  cssName: "--ag-cell-horizontal-padding",
  changeKey: "cellHorizontalPaddingChanged",
  defaultValue: 16
}, Kf = {
  cssName: "--ag-indentation-level",
  changeKey: "indentationLevelChanged",
  defaultValue: 0,
  noWarn: !0,
  cacheDefault: !0
}, jf = {
  cssName: "--ag-row-group-indent-size",
  changeKey: "rowGroupIndentSizeChanged",
  defaultValue: 0
}, ln = {
  cssName: "--ag-row-height",
  changeKey: "rowHeightChanged",
  defaultValue: 42
}, an = {
  cssName: "--ag-header-height",
  changeKey: "headerHeightChanged",
  defaultValue: 48
}, dn = {
  cssName: "--ag-list-item-height",
  changeKey: "listItemHeightChanged",
  defaultValue: 24
}, fi = {
  cssName: "--ag-row-border",
  changeKey: "rowBorderWidthChanged",
  defaultValue: 1,
  border: !0
}, cn = {
  cssName: "--ag-pinned-row-border",
  changeKey: "pinnedRowBorderWidthChanged",
  defaultValue: 1,
  border: !0
};
function qf(e, t) {
  for (const o of t.sort((i, s) => i.moduleName.localeCompare(s.moduleName))) {
    const i = o.css;
    i && e.set(`module-${o.moduleName}`, i);
  }
}
var Yf = class extends tu {
  constructor() {
    super(...arguments), this.sizeEls = /* @__PURE__ */ new Map(), this.lastKnownValues = /* @__PURE__ */ new Map(), this.sizesMeasured = !1;
  }
  initVariables() {
    this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.getSizeEl(ln), this.getSizeEl(an), this.getSizeEl(dn), this.getSizeEl(fi), this.getSizeEl(cn), this.refreshRowBorderWidthVariable();
  }
  getPinnedRowBorderWidth() {
    return this.getCSSVariablePixelValue(cn);
  }
  getRowBorderWidth() {
    return this.getCSSVariablePixelValue(fi);
  }
  getDefaultRowHeight() {
    return this.getCSSVariablePixelValue(ln);
  }
  getDefaultHeaderHeight() {
    return this.getCSSVariablePixelValue(an);
  }
  getDefaultCellHorizontalPadding() {
    return this.getCSSVariablePixelValue($f);
  }
  getCellPaddingLeft() {
    const e = this.getDefaultCellHorizontalPadding(), t = this.getCSSVariablePixelValue(Kf), o = this.getCSSVariablePixelValue(jf);
    return e - 1 + o * t;
  }
  getCellPadding() {
    const e = this.getDefaultCellHorizontalPadding() - 1;
    return this.getCellPaddingLeft() + e;
  }
  getDefaultColumnMinWidth() {
    return Math.min(36, this.getDefaultRowHeight());
  }
  getDefaultListItemHeight() {
    return this.getCSSVariablePixelValue(dn);
  }
  refreshRowHeightVariable() {
    const { eRootDiv: e } = this, t = e.style.getPropertyValue("--ag-line-height").trim(), o = this.gos.get("rowHeight");
    if (o == null || isNaN(o) || !isFinite(o))
      return t !== null && e.style.setProperty("--ag-line-height", null), -1;
    const i = `${o}px`;
    return t != i ? (e.style.setProperty("--ag-line-height", i), o) : t != "" ? Number.parseFloat(t) : -1;
  }
  getCSSVariablePixelValue(e) {
    const t = this.lastKnownValues.get(e);
    if (t != null)
      return t;
    const o = this.measureSizeEl(e);
    return o === "detached" || o === "no-styles" ? (e.cacheDefault && this.lastKnownValues.set(e, e.defaultValue), e.defaultValue) : (this.lastKnownValues.set(e, o), o);
  }
  measureSizeEl(e) {
    const t = this.getSizeEl(e);
    if (t.offsetParent == null)
      return "detached";
    const o = t.offsetWidth;
    return o === Ci ? "no-styles" : (this.sizesMeasured = !0, o);
  }
  getMeasurementContainer() {
    let e = this.eMeasurementContainer;
    return e || (e = this.eMeasurementContainer = ie({ tag: "div", cls: "ag-measurement-container" }), this.eRootDiv.appendChild(e)), e;
  }
  getSizeEl(e) {
    let t = this.sizeEls.get(e);
    if (t)
      return t;
    const o = this.getMeasurementContainer();
    t = ie({ tag: "div" });
    const { border: i, noWarn: s } = e;
    i ? (t.className = "ag-measurement-element-border", t.style.setProperty(
      "--ag-internal-measurement-border",
      `var(${e.cssName}, solid ${Ci}px)`
    )) : t.style.width = `var(${e.cssName}, ${Ci}px)`, o.appendChild(t), this.sizeEls.set(e, t);
    let n = this.measureSizeEl(e);
    n === "no-styles" && !s && F(9, { variable: e });
    const r = wt(this.beans, t, () => {
      const l = this.measureSizeEl(e);
      l === "detached" || l === "no-styles" || (this.lastKnownValues.set(e, l), l !== n && (n = l, this.fireStylesChangedEvent(e.changeKey)));
    });
    return this.addDestroyFunc(() => r()), t;
  }
  fireStylesChangedEvent(e) {
    e === "rowBorderWidthChanged" && this.refreshRowBorderWidthVariable(), this.eventSvc.dispatchEvent({
      type: "gridStylesChanged",
      [e]: !0
    });
  }
  refreshRowBorderWidthVariable() {
    const e = this.getCSSVariablePixelValue(fi);
    this.eRootDiv.style.setProperty("--ag-internal-row-border-width", `${e}px`);
  }
  postProcessThemeChange(e, t) {
    e && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded") && W(t ? 106 : 239);
  }
  getAdditionalCss() {
    const e = /* @__PURE__ */ new Map();
    return e.set("core", [cf]), qf(e, Array.from(Oa())), e;
  }
  getDefaultTheme() {
    return _f;
  }
  themeError(e) {
    W(240, { theme: e });
  }
}, Ci = 15538, Zf = class extends iu {
  postConstruct() {
    const { globalListener: e, globalSyncListener: t } = this.beans;
    e && this.addGlobalListener(e, !0), t && this.addGlobalListener(t, !1);
  }
};
function wl(e, t, o) {
  const i = e.visibleCols.headerGroupRowCount;
  if (o >= i)
    return {
      column: t,
      headerRowIndex: o
    };
  let s = t.getParent();
  for (; s && s.getProvidedColumnGroup().getLevel() > o; )
    s = s.getParent();
  const n = t.isSpanHeaderHeight();
  return !s || n && s.isPadding() ? {
    column: t,
    headerRowIndex: i
  } : {
    column: s,
    headerRowIndex: s.getProvidedColumnGroup().getLevel()
  };
}
var Qf = class extends b {
  constructor() {
    super(...arguments), this.beanName = "headerNavigation", this.currentHeaderRowWithoutSpan = -1;
  }
  postConstruct() {
    const e = this.beans;
    e.ctrlsSvc.whenReady(this, (o) => {
      this.gridBodyCon = o.gridBodyCtrl;
    });
    const t = j(e);
    this.addManagedElementListeners(t, {
      mousedown: () => {
        this.currentHeaderRowWithoutSpan = -1;
      }
    });
  }
  getHeaderPositionForColumn(e, t) {
    let o;
    const { colModel: i, colGroupSvc: s, ctrlsSvc: n } = this.beans;
    if (typeof e == "string" ? (o = i.getCol(e), o || (o = s?.getColumnGroup(e) ?? null)) : o = e, !o)
      return null;
    const l = n.getHeaderRowContainerCtrl()?.getAllCtrls(), a = G(l || []).type === "filter", d = fe(this.beans) - 1;
    let c = -1, u = o;
    for (; u; )
      c++, u = u.getParent();
    let h = c;
    return t && a && h === d - 1 && h++, h === -1 ? null : {
      headerRowIndex: h,
      column: o
    };
  }
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateVertically(e, t) {
    const { focusSvc: o, visibleCols: i } = this.beans, { focusedHeader: s } = o;
    if (!s)
      return !1;
    const { headerRowIndex: n } = s, r = s.column, l = fe(this.beans), a = this.getHeaderRowType(n), d = i.headerGroupRowCount;
    let {
      headerRowIndex: c,
      column: u,
      headerRowIndexWithoutSpan: h
    } = e === "UP" ? Xf(a, r, n) : Jf(r, n, d), g = !1;
    return c < 0 && (c = 0, u = r, g = !0), c >= l ? (c = -1, this.currentHeaderRowWithoutSpan = -1) : h !== void 0 && (this.currentHeaderRowWithoutSpan = h), !g && !u ? !1 : o.focusHeaderPosition({
      headerPosition: { headerRowIndex: c, column: u },
      allowUserOverride: !0,
      event: t
    });
  }
  /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateHorizontally(e, t = !1, o) {
    const { focusSvc: i, gos: s } = this.beans, n = { ...i.focusedHeader };
    let r, l;
    this.currentHeaderRowWithoutSpan !== -1 ? n.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = n.headerRowIndex, e === "LEFT" !== s.get("enableRtl") ? (l = "Before", r = this.findHeader(n, l)) : (l = "After", r = this.findHeader(n, l));
    const a = s.getCallback("tabToNextHeader");
    if (t && a) {
      const d = i.focusHeaderPositionFromUserFunc({
        userFunc: a,
        headerPosition: r,
        direction: l
      });
      if (d) {
        const { headerRowIndex: c } = i.focusedHeader || {};
        c != null && c != n.headerRowIndex && (this.currentHeaderRowWithoutSpan = c);
      }
      return d;
    }
    return r || !t ? i.focusHeaderPosition({
      headerPosition: r,
      direction: l,
      fromTab: t,
      allowUserOverride: !0,
      event: o
    }) : this.focusNextHeaderRow(n, l, o);
  }
  focusNextHeaderRow(e, t, o) {
    const i = this.beans, s = e.headerRowIndex;
    let n = null, r;
    const l = fe(i), a = this.beans.visibleCols.allCols;
    if (t === "Before") {
      if (s <= 0)
        return !1;
      n = G(a), r = s - 1, this.currentHeaderRowWithoutSpan -= 1;
    } else
      n = a[0], r = s + 1, this.currentHeaderRowWithoutSpan < l ? this.currentHeaderRowWithoutSpan += 1 : this.currentHeaderRowWithoutSpan = -1;
    let { column: d, headerRowIndex: c } = wl(this.beans, n, r);
    return c >= l && (c = -1), i.focusSvc.focusHeaderPosition({
      headerPosition: { column: d, headerRowIndex: c },
      direction: t,
      fromTab: !0,
      allowUserOverride: !0,
      event: o
    });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let o;
    if (B(e)) {
      const i = e.getDisplayedLeafColumns();
      o = t === "Before" ? G(i) : i[0];
    } else
      o = e;
    this.gridBodyCon.scrollFeature.ensureColumnVisible(o);
  }
  findHeader(e, t) {
    const { colGroupSvc: o, visibleCols: i } = this.beans;
    let s = e.column;
    if (s instanceof Ut) {
      const a = s.getDisplayedLeafColumns();
      s = t === "Before" ? a[0] : a[a.length - 1];
    }
    const n = t === "Before" ? i.getColBefore(s) : i.getColAfter(s);
    if (!n)
      return;
    const r = i.headerGroupRowCount;
    if (e.headerRowIndex >= r)
      return {
        headerRowIndex: e.headerRowIndex,
        column: n
      };
    const l = o?.getColGroupAtLevel(n, e.headerRowIndex);
    return l ? l.isPadding() && n.isSpanHeaderHeight() ? {
      headerRowIndex: i.headerGroupRowCount,
      column: n
    } : {
      headerRowIndex: e.headerRowIndex,
      column: l ?? n
    } : {
      headerRowIndex: n instanceof je && n.isSpanHeaderHeight() ? i.headerGroupRowCount : e.headerRowIndex,
      column: n
    };
  }
  getHeaderRowType(e) {
    const t = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
};
function Xf(e, t, o) {
  const i = o - 1;
  if (e !== "filter") {
    const s = t instanceof je && t.isSpanHeaderHeight();
    let n = t.getParent();
    for (; n && // skip if row isn't visible or col is padding and spanned
    (n.getProvidedColumnGroup().getLevel() > i || s && n.isPadding()); )
      n = n.getParent();
    if (n)
      return s ? {
        column: n,
        headerRowIndex: n.getProvidedColumnGroup().getLevel(),
        headerRowIndexWithoutSpan: i
      } : {
        column: n,
        headerRowIndex: i,
        headerRowIndexWithoutSpan: i
      };
  }
  return {
    column: t,
    headerRowIndex: i,
    headerRowIndexWithoutSpan: i
  };
}
function Jf(e, t, o) {
  const i = t + 1, s = {
    column: e,
    headerRowIndex: i,
    headerRowIndexWithoutSpan: i
  };
  if (e instanceof Ut) {
    if (i >= o)
      return {
        column: e.getDisplayedLeafColumns()[0],
        headerRowIndex: o,
        headerRowIndexWithoutSpan: i
      };
    let r = e.getDisplayedChildren()[0];
    if (r instanceof Ut && r.isPadding()) {
      const a = r.getDisplayedLeafColumns()[0];
      a.isSpanHeaderHeight() && (r = a);
    }
    s.column = r, r instanceof je && r.isSpanHeaderHeight() && (s.headerRowIndex = o, s.headerRowIndexWithoutSpan = i);
  }
  return s;
}
var eC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "focusSvc", this.focusFallbackTimeout = null, this.needsFocusRestored = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.rowRenderer = e.rowRenderer, this.navigation = e.navigation, this.filterManager = e.filterManager, this.overlays = e.overlays;
  }
  postConstruct() {
    const e = this.clearFocusedCell.bind(this);
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
      columnGroupOpened: e,
      columnRowGroupChanged: e
    }), this.addDestroyFunc(hc(this.beans));
  }
  attemptToRecoverFocus() {
    this.needsFocusRestored = !0, this.focusFallbackTimeout != null && clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
  }
  setFocusRecovered() {
    this.needsFocusRestored = !1, this.focusFallbackTimeout != null && (clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = null);
  }
  /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */
  shouldTakeFocus() {
    return this.gos.get("suppressFocusAfterRefresh") ? (this.setFocusRecovered(), !1) : this.needsFocusRestored ? (this.setFocusRecovered(), !0) : this.doesRowOrCellHaveBrowserFocus();
  }
  onColumnEverythingChanged() {
    if (!this.focusedCell)
      return;
    const e = this.focusedCell.column, t = this.colModel.getCol(e.getId());
    e !== t && this.clearFocusedCell();
  }
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  getFocusCellToUseAfterRefresh() {
    const { gos: e, focusedCell: t } = this;
    return e.get("suppressFocusAfterRefresh") || e.get("suppressCellFocus") || !t || !this.doesRowOrCellHaveBrowserFocus() ? null : t;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader || !this.isDomDataPresentInHierarchy(N(this.beans), Yr) ? null : this.focusedHeader;
  }
  /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */
  doesRowOrCellHaveBrowserFocus() {
    const e = N(this.beans);
    return this.isDomDataPresentInHierarchy(e, ko) ? !0 : this.isDomDataPresentInHierarchy(e, Lo);
  }
  isDomDataPresentInHierarchy(e, t) {
    let o = e;
    for (; o; ) {
      if (Xn(this.gos, o, t))
        return !0;
      o = o.parentNode;
    }
    return !1;
  }
  getFocusedCell() {
    return this.focusedCell;
  }
  getFocusEventParams(e) {
    const { rowIndex: t, rowPinned: o, column: i } = e, s = {
      rowIndex: t,
      rowPinned: o,
      column: i,
      isFullWidthCell: !1
    }, n = this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: o });
    return n && (s.isFullWidthCell = n.isFullWidth()), s;
  }
  clearFocusedCell() {
    if (this.focusedCell == null)
      return;
    const e = this.getFocusEventParams(this.focusedCell);
    this.focusedCell = null, this.eventSvc.dispatchEvent({
      type: "cellFocusCleared",
      ...e
    });
  }
  setFocusedCell(e) {
    this.setFocusRecovered();
    const {
      column: t,
      rowIndex: o,
      rowPinned: i,
      forceBrowserFocus: s = !1,
      preventScrollOnBrowserFocus: n = !1,
      sourceEvent: r
    } = e, l = this.colModel.getCol(t);
    if (!l) {
      this.focusedCell = null;
      return;
    }
    this.focusedCell = {
      rowIndex: o,
      rowPinned: Ne(i),
      column: l
    };
    const a = this.getFocusEventParams(this.focusedCell);
    this.eventSvc.dispatchEvent({
      type: "cellFocused",
      ...a,
      ...this.previousCellFocusParams && { previousParams: this.previousCellFocusParams },
      forceBrowserFocus: s,
      preventScrollOnBrowserFocus: n,
      sourceEvent: r
    }), this.previousCellFocusParams = a;
  }
  isCellFocused(e) {
    return this.focusedCell == null ? !1 : bg(e, this.focusedCell);
  }
  isHeaderWrapperFocused(e) {
    if (this.focusedHeader == null)
      return !1;
    const {
      column: t,
      rowCtrl: { rowIndex: o, pinned: i }
    } = e, { column: s, headerRowIndex: n } = this.focusedHeader;
    return t === s && o === n && i == s.getPinned();
  }
  focusHeaderPosition(e) {
    if (this.setFocusRecovered(), _e(this.beans))
      return !1;
    const { direction: t, fromTab: o, allowUserOverride: i, event: s, fromCell: n, rowWithoutSpanValue: r, scroll: l = !0 } = e;
    let { headerPosition: a } = e;
    if (n && this.filterManager?.isAdvFilterHeaderActive())
      return this.focusAdvancedFilter(a);
    if (i) {
      const d = this.focusedHeader, c = fe(this.beans);
      if (o) {
        const u = this.gos.getCallback("tabToNextHeader");
        u && (a = this.getHeaderPositionFromUserFunc({
          userFunc: u,
          direction: t,
          currentPosition: d,
          headerPosition: a,
          headerRowCount: c
        }));
      } else {
        const u = this.gos.getCallback("navigateToNextHeader");
        if (u && s) {
          const h = {
            key: s.key,
            previousHeaderPosition: d,
            nextHeaderPosition: a,
            headerRowCount: c,
            event: s
          };
          a = u(h);
        }
      }
    }
    return a ? this.focusProvidedHeaderPosition({
      headerPosition: a,
      direction: t,
      event: s,
      fromCell: n,
      rowWithoutSpanValue: r,
      scroll: l
    }) : !1;
  }
  focusHeaderPositionFromUserFunc(e) {
    if (_e(this.beans))
      return !1;
    const { userFunc: t, headerPosition: o, direction: i, event: s } = e, n = this.focusedHeader, r = fe(this.beans), l = this.getHeaderPositionFromUserFunc({
      userFunc: t,
      direction: i,
      currentPosition: n,
      headerPosition: o,
      headerRowCount: r
    });
    return !!l && this.focusProvidedHeaderPosition({
      headerPosition: l,
      direction: i,
      event: s
    });
  }
  getHeaderPositionFromUserFunc(e) {
    const { userFunc: t, direction: o, currentPosition: i, headerPosition: s, headerRowCount: n } = e, l = t({
      backwards: o === "Before",
      previousHeaderPosition: i,
      nextHeaderPosition: s,
      headerRowCount: n
    });
    return l === !0 ? i : l === !1 ? null : l;
  }
  focusProvidedHeaderPosition(e) {
    const { headerPosition: t, direction: o, fromCell: i, rowWithoutSpanValue: s, event: n, scroll: r = !0 } = e, { column: l, headerRowIndex: a } = t, { filterManager: d, ctrlsSvc: c, headerNavigation: u } = this.beans;
    if (this.focusedHeader && dh(e.headerPosition, this.focusedHeader))
      return !1;
    if (a === -1)
      return d?.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(t) : this.focusGridView({ column: l, event: n });
    r && u?.scrollToColumn(l, o);
    const g = c.getHeaderRowContainerCtrl(l.getPinned())?.focusHeader(t.headerRowIndex, l, n) || !1;
    return u && g && (s != null || i) && (u.currentHeaderRowWithoutSpan = s ?? -1), g;
  }
  focusFirstHeader() {
    if (this.overlays?.isExclusive() && this.focusOverlay())
      return !0;
    const e = this.visibleCols.allCols[0];
    if (!e)
      return !1;
    const t = wl(this.beans, e, 0);
    return this.focusHeaderPosition({
      headerPosition: t,
      rowWithoutSpanValue: 0
    });
  }
  focusLastHeader(e) {
    if (this.overlays?.isExclusive() && this.focusOverlay(!0))
      return !0;
    const t = fe(this.beans) - 1, o = G(this.visibleCols.allCols);
    return this.focusHeaderPosition({
      headerPosition: { headerRowIndex: t, column: o },
      rowWithoutSpanValue: -1,
      event: e
    });
  }
  focusPreviousFromFirstCell(e) {
    return this.filterManager?.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(e);
  }
  isAnyCellFocused() {
    return !!this.focusedCell;
  }
  isRowFocused(e, t) {
    return this.focusedCell == null ? !1 : this.focusedCell.rowIndex === e && this.focusedCell.rowPinned === Ne(t);
  }
  focusOverlay(e) {
    const t = this.overlays?.isVisible() && this.overlays.eWrapper?.getGui();
    return !!t && To(t, e);
  }
  focusGridView(e) {
    const { backwards: t = !1, canFocusOverlay: o = !0, event: i } = e;
    if (this.overlays?.isExclusive())
      return o && this.focusOverlay(t);
    if (fs(this.beans))
      return t && !_e(this.beans) ? this.focusLastHeader() : o && this.focusOverlay(t) ? !0 : t ? !1 : mt(this.beans, t);
    const s = t ? xg(this.beans) : Rg(this.beans);
    if (s) {
      const n = e.column ?? this.focusedHeader?.column, { rowIndex: r, rowPinned: l } = s, a = ol(this.beans, s);
      if (!n || !a || r == null)
        return !1;
      if (n.isSuppressNavigable(a)) {
        const d = this.gos.get("enableRtl");
        let c;
        return !i || i.key === w.TAB ? c = d ? w.LEFT : w.RIGHT : c = i.key, this.beans.navigation?.navigateToNextCell(
          null,
          c,
          { rowIndex: r, column: n, rowPinned: l || null },
          !0
        ), !0;
      }
      return this.navigation?.ensureCellVisible({ rowIndex: r, column: n, rowPinned: l }), t && this.rowRenderer.getRowByPosition(s)?.isFullWidth() && this.navigation?.tryToFocusFullWidthRow(s, t) || (this.setFocusedCell({
        rowIndex: r,
        column: n,
        rowPinned: Ne(l),
        forceBrowserFocus: !0
      }), this.beans.rangeSvc?.setRangeToCell({ rowIndex: r, rowPinned: l, column: n })), !0;
    }
    return !!(o && this.focusOverlay(t) || t && this.focusLastHeader());
  }
  focusAdvancedFilter(e) {
    return this.advFilterFocusColumn = e?.column, this.beans.advancedFilter?.getCtrl().focusHeaderComp() ?? !1;
  }
  focusNextFromAdvancedFilter(e, t) {
    const o = (t ? void 0 : this.advFilterFocusColumn) ?? this.visibleCols.allCols?.[0];
    return e ? this.focusHeaderPosition({
      headerPosition: {
        column: o,
        headerRowIndex: fe(this.beans) - 1
      }
    }) : this.focusGridView({ column: o });
  }
  clearAdvancedFilterColumn() {
    this.advFilterFocusColumn = void 0;
  }
}, tC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "scrollVisibleSvc";
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colAnimation = e.colAnimation;
  }
  postConstruct() {
    this.horizontalScrollShowing = this.gos.get("alwaysShowHorizontalScroll") === !0, this.verticalScrollShowing = this.gos.get("alwaysShowVerticalScroll") === !0, this.getScrollbarWidth(), this.addManagedEventListeners({
      displayedColumnsChanged: this.updateScrollVisible.bind(this),
      displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
    });
  }
  updateScrollVisible() {
    const { colAnimation: e } = this;
    e?.isActive() ? e.executeLaterVMTurn(() => {
      e.executeLaterVMTurn(() => this.updateScrollVisibleImpl());
    }) : this.updateScrollVisibleImpl();
  }
  updateScrollVisibleImpl() {
    const e = this.ctrlsSvc.get("center");
    if (!e || this.colAnimation?.isActive())
      return;
    const t = {
      horizontalScrollShowing: e.isHorizontalScrollShowing(),
      verticalScrollShowing: this.verticalScrollShowing
    };
    this.setScrollsVisible(t), this.updateScrollGap();
  }
  updateScrollGap() {
    const e = this.ctrlsSvc.get("center"), t = e.hasHorizontalScrollGap(), o = e.hasVerticalScrollGap();
    (this.horizontalScrollGap !== t || this.verticalScrollGap !== o) && (this.horizontalScrollGap = t, this.verticalScrollGap = o, this.eventSvc.dispatchEvent({
      type: "scrollGapChanged"
    }));
  }
  setScrollsVisible(e) {
    (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) && (this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing, this.eventSvc.dispatchEvent({
      type: "scrollVisibilityChanged"
    }));
  }
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const e = this.gos.get("scrollbarWidth"), o = typeof e == "number" && e >= 0 ? e : sc();
      o != null && (this.scrollbarWidth = o, this.eventSvc.dispatchEvent({
        type: "scrollbarWidthChanged"
      }));
    }
    return this.scrollbarWidth;
  }
}, oC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "gridDestroySvc", this.destroyCalled = !1;
  }
  destroy() {
    if (this.destroyCalled)
      return;
    const { stateSvc: e, ctrlsSvc: t, context: o } = this.beans;
    this.eventSvc.dispatchEvent({
      type: "gridPreDestroyed",
      state: e?.getState() ?? {}
    }), this.destroyCalled = !0, t.get("gridCtrl")?.destroyGridUi(), o.destroy(), super.destroy();
  }
}, Co = /* @__PURE__ */ new Set(["gridPreDestroyed", "fillStart", "pasteStart"]), iC = [
  "columnEverythingChanged",
  "newColumnsLoaded",
  "columnPivotModeChanged",
  "pivotMaxColumnsExceeded",
  "columnRowGroupChanged",
  "expandOrCollapseAll",
  "columnPivotChanged",
  "gridColumnsChanged",
  "columnValueChanged",
  "columnMoved",
  "columnVisible",
  "columnPinned",
  "columnGroupOpened",
  "columnResized",
  "displayedColumnsChanged",
  "virtualColumnsChanged",
  "columnHeaderMouseOver",
  "columnHeaderMouseLeave",
  "columnHeaderClicked",
  "columnHeaderContextMenu",
  "asyncTransactionsFlushed",
  "rowGroupOpened",
  "rowDataUpdated",
  "pinnedRowDataChanged",
  "pinnedRowsChanged",
  "rangeSelectionChanged",
  "cellSelectionChanged",
  "chartCreated",
  "chartRangeSelectionChanged",
  "chartOptionsChanged",
  "chartDestroyed",
  "toolPanelVisibleChanged",
  "toolPanelSizeChanged",
  "modelUpdated",
  "cutStart",
  "cutEnd",
  "pasteStart",
  "pasteEnd",
  "fillStart",
  "fillEnd",
  "cellSelectionDeleteStart",
  "cellSelectionDeleteEnd",
  "rangeDeleteStart",
  "rangeDeleteEnd",
  "undoStarted",
  "undoEnded",
  "redoStarted",
  "redoEnded",
  "cellClicked",
  "cellDoubleClicked",
  "cellMouseDown",
  "cellContextMenu",
  "cellValueChanged",
  "cellEditRequest",
  "rowValueChanged",
  "headerFocused",
  "cellFocused",
  "rowSelected",
  "selectionChanged",
  "tooltipShow",
  "tooltipHide",
  "cellKeyDown",
  "cellMouseOver",
  "cellMouseOut",
  "filterChanged",
  "filterModified",
  "filterUiChanged",
  "filterOpened",
  "floatingFilterUiChanged",
  "advancedFilterBuilderVisibleChanged",
  "sortChanged",
  "virtualRowRemoved",
  "rowClicked",
  "rowDoubleClicked",
  "gridReady",
  "gridPreDestroyed",
  "gridSizeChanged",
  "viewportChanged",
  "firstDataRendered",
  "dragStarted",
  "dragStopped",
  "dragCancelled",
  "rowEditingStarted",
  "rowEditingStopped",
  "cellEditingStarted",
  "cellEditingStopped",
  "bodyScroll",
  "bodyScrollEnd",
  "paginationChanged",
  "componentStateChanged",
  "storeRefreshed",
  "stateUpdated",
  "columnMenuVisibleChanged",
  "contextMenuVisibleChanged",
  "rowDragEnter",
  "rowDragMove",
  "rowDragLeave",
  "rowDragEnd",
  "rowDragCancel",
  "findChanged",
  "rowResizeStarted",
  "rowResizeEnded",
  "columnsReset",
  "bulkEditingStarted",
  "bulkEditingStopped",
  "batchEditingStarted",
  "batchEditingStopped"
], bs = iC.reduce(
  (e, t) => (e[t] = td(t), e),
  {}
), xt = (e, t) => ({
  tag: "span",
  ref: `eSort${e}`,
  cls: `ag-sort-indicator-icon ag-sort-${t} ag-hidden`,
  attrs: { "aria-hidden": "true" }
}), sC = {
  tag: "span",
  cls: "ag-sort-indicator-container",
  children: [
    xt("Order", "order"),
    xt("Asc", "ascending-icon"),
    xt("Desc", "descending-icon"),
    xt("Mixed", "mixed-icon"),
    xt("None", "none-icon")
  ]
}, ys = class extends O {
  constructor(e) {
    super(), this.eSortOrder = P, this.eSortAsc = P, this.eSortDesc = P, this.eSortMixed = P, this.eSortNone = P, e || this.setTemplate(sC);
  }
  attachCustomElements(e, t, o, i, s) {
    this.eSortOrder = e, this.eSortAsc = t, this.eSortDesc = o, this.eSortMixed = i, this.eSortNone = s;
  }
  setupSort(e, t = !1) {
    if (this.column = e, this.suppressOrder = t, this.setupMultiSortIndicator(), !e.isSortable() && !e.getColDef().showRowGroup)
      return;
    this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e);
    const o = this.updateIcons.bind(this), i = this.onSortChanged.bind(this);
    this.addManagedPropertyListener("unSortIcon", o), this.addManagedEventListeners({
      newColumnsLoaded: o,
      // Watch global events, as row group columns can effect their display column.
      sortChanged: i,
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: i
    }), this.onSortChanged();
  }
  addInIcon(e, t, o) {
    if (t == null)
      return;
    const i = ye(e, this.beans, o);
    i && t.appendChild(i);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const { eSortAsc: e, eSortDesc: t, eSortNone: o, column: i, gos: s, beans: n } = this, r = n.sortSvc.getDisplaySortForColumn(i);
    if (e && V(e, r === "asc", { skipAriaHidden: !0 }), t && V(t, r === "desc", { skipAriaHidden: !0 }), o) {
      const l = !i.getColDef().unSortIcon && !s.get("unSortIcon"), a = r == null;
      V(o, !l && a, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    const { eSortMixed: e, column: t, gos: o } = this;
    this.addInIcon("sortUnSort", e, t);
    const i = t.getColDef().showRowGroup;
    pe(o) && i && (this.addManagedEventListeners({
      // Watch global events, as row group columns can effect their display column.
      sortChanged: this.updateMultiSortIndicator.bind(this),
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
    }), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    const { eSortMixed: e, beans: t, column: o } = this;
    if (e) {
      const i = t.sortSvc.getDisplaySortForColumn(o) === "mixed";
      V(e, i, { skipAriaHidden: !0 });
    }
  }
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  updateSortOrder() {
    const {
      eSortOrder: e,
      column: t,
      beans: { sortSvc: o }
    } = this;
    if (!e)
      return;
    const i = o.getColumnsWithSortingOrdered(), s = o.getDisplaySortIndexForColumn(t) ?? -1, n = i.some(
      (l) => o.getDisplaySortIndexForColumn(l) ?? !1
    ), r = s >= 0 && n;
    V(e, r, { skipAriaHidden: !0 }), s >= 0 ? e.textContent = (s + 1).toString() : J(e);
  }
}, nC = {
  selector: "AG-SORT-INDICATOR",
  component: ys
}, $t = ["asc", "desc", null], rC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "sortSvc";
  }
  progressSort(e, t, o) {
    const i = this.getNextSortDirection(e);
    this.setSortForColumn(e, i, t, o);
  }
  progressSortFromEvent(e, t) {
    const i = this.gos.get("multiSortKey") === "ctrl" ? t.ctrlKey || t.metaKey : t.shiftKey;
    this.progressSort(e, i, "uiColumnSorted");
  }
  setSortForColumn(e, t, o, i) {
    t !== "asc" && t !== "desc" && (t = null);
    const { gos: s, showRowGroupCols: n } = this.beans, r = pe(s);
    let l = [e];
    if (r && e.getColDef().showRowGroup) {
      const u = n?.getSourceColumnsForGroupColumn?.(e)?.filter((h) => h.isSortable());
      u && (l = [e, ...u]);
    }
    for (const c of l)
      this.setColSort(c, t, i);
    const a = (o || s.get("alwaysMultiSort")) && !s.get("suppressMultiSort"), d = [];
    if (!a) {
      const c = this.clearSortBarTheseColumns(l, i);
      d.push(...c);
    }
    this.updateSortIndex(e), d.push(...l), this.dispatchSortChangedEvents(i, d);
  }
  updateSortIndex(e) {
    const { gos: t, colModel: o, showRowGroupCols: i } = this.beans, s = pe(t), n = i?.getShowRowGroupCol(e.getId()), r = s && n || e, l = this.getColumnsWithSortingOrdered();
    o.forAllCols((c) => this.setColSortIndex(c, null));
    const a = l.filter((c) => s && c.getColDef().showRowGroup ? !1 : c !== r);
    (r.getSort() ? [...a, r] : a).forEach((c, u) => this.setColSortIndex(c, u));
  }
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    let e = !1;
    return this.beans.colModel.forAllCols((t) => {
      t.getSort() && (e = !0);
    }), e;
  }
  dispatchSortChangedEvents(e, t) {
    const o = {
      type: "sortChanged",
      source: e
    };
    t && (o.columns = t), this.eventSvc.dispatchEvent(o);
  }
  clearSortBarTheseColumns(e, t) {
    const o = [];
    return this.beans.colModel.forAllCols((i) => {
      e.includes(i) || (i.getSort() && o.push(i), this.setColSort(i, void 0, t));
    }), o;
  }
  getNextSortDirection(e) {
    const t = e.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? $t, o = t.indexOf(e.getSort()), i = o < 0, s = o == t.length - 1;
    return i || s ? t[0] : t[o + 1];
  }
  /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */
  getIndexedSortMap() {
    const { gos: e, colModel: t, showRowGroupCols: o, rowGroupColsSvc: i } = this.beans;
    let s = [];
    if (t.forAllCols((d) => {
      d.getSort() && s.push(d);
    }), t.isPivotMode()) {
      const d = pe(e);
      s = s.filter((c) => {
        const u = !!c.getAggFunc(), h = !c.isPrimary(), g = d ? o?.getShowRowGroupCol(c.getId()) : c.getColDef().showRowGroup;
        return u || h || g;
      });
    }
    const n = i?.columns.filter((d) => !!d.getSort()) ?? [], r = {};
    s.forEach((d, c) => r[d.getId()] = c), s.sort((d, c) => {
      const u = d.getSortIndex(), h = c.getSortIndex();
      if (u != null && h != null)
        return u - h;
      if (u == null && h == null) {
        const g = r[d.getId()], p = r[c.getId()];
        return g > p ? 1 : -1;
      } else return h == null ? -1 : 1;
    });
    const l = pe(e) && !!n.length;
    l && (s = [
      ...new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        s.map((d) => o?.getShowRowGroupCol(d.getId()) ?? d)
      )
    ]);
    const a = /* @__PURE__ */ new Map();
    if (s.forEach((d, c) => a.set(d, c)), l)
      for (const d of n) {
        const c = o.getShowRowGroupCol(d.getId());
        a.set(d, a.get(c));
      }
    return a;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([, e], [, t]) => e - t).map(([e]) => e);
  }
  // used by server side row models, to sent sort to server
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      colId: e.getId()
    }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      column: e
    }));
  }
  canColumnDisplayMixedSort(e) {
    const t = pe(this.gos), o = !!e.getColDef().showRowGroup;
    return t && o;
  }
  getDisplaySortForColumn(e) {
    const t = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !t?.length)
      return e.getSort();
    const i = e.getColDef().field != null || !!e.getColDef().valueGetter ? [e, ...t] : t, s = i[0].getSort();
    return i.every((r) => r.getSort() == s) ? s : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
  setupHeader(e, t, o) {
    let i = 0;
    e.addManagedListeners(t, {
      movingChanged: () => {
        i = Date.now();
      }
    }), o && e.addManagedElementListeners(o, {
      click: (n) => {
        const r = t.isMoving(), a = Date.now() - i < 50;
        r || a || this.progressSortFromEvent(t, n);
      }
    });
    const s = () => {
      const n = t.getSort();
      if (e.toggleCss("ag-header-cell-sorted-asc", n === "asc"), e.toggleCss("ag-header-cell-sorted-desc", n === "desc"), e.toggleCss("ag-header-cell-sorted-none", !n), t.getColDef().showRowGroup) {
        const a = !this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(t)?.every(
          (d) => t.getSort() == d.getSort()
        );
        e.toggleCss("ag-header-cell-sorted-mixed", a);
      }
    };
    e.addManagedEventListeners({
      sortChanged: s,
      columnRowGroupChanged: s
    });
  }
  initCol(e) {
    const { sort: t, initialSort: o, sortIndex: i, initialSortIndex: s } = e.colDef;
    t !== void 0 ? (t === "asc" || t === "desc") && (e.sort = t) : (o === "asc" || o === "desc") && (e.sort = o), i !== void 0 ? i !== null && (e.sortIndex = i) : s !== null && (e.sortIndex = s);
  }
  updateColSort(e, t, o) {
    t !== void 0 && (t === "desc" || t === "asc" ? this.setColSort(e, t, o) : this.setColSort(e, void 0, o));
  }
  setColSort(e, t, o) {
    e.sort !== t && (e.sort = t, e.dispatchColEvent("sortChanged", o)), e.dispatchStateUpdatedEvent("sort");
  }
  setColSortIndex(e, t) {
    e.sortIndex = t, e.dispatchStateUpdatedEvent("sortIndex");
  }
  createSortIndicator(e) {
    return new ys(e);
  }
  getSortIndicatorSelector() {
    return nC;
  }
}, ct = {
  agSetColumnFilter: "SetFilter",
  agSetColumnFloatingFilter: "SetFilter",
  agMultiColumnFilter: "MultiFilter",
  agMultiColumnFloatingFilter: "MultiFilter",
  agGroupColumnFilter: "GroupFilter",
  agGroupColumnFloatingFilter: "GroupFilter",
  agGroupCellRenderer: "GroupCellRenderer",
  agGroupRowRenderer: "GroupCellRenderer",
  agRichSelect: "RichSelect",
  agRichSelectCellEditor: "RichSelect",
  agDetailCellRenderer: "SharedMasterDetail",
  agSparklineCellRenderer: "Sparklines",
  agDragAndDropImage: "SharedDragAndDrop",
  agColumnHeader: "ColumnHeaderComp",
  agColumnGroupHeader: "ColumnGroupHeaderComp",
  agSortIndicator: "Sort",
  agAnimateShowChangeCellRenderer: "HighlightChanges",
  agAnimateSlideCellRenderer: "HighlightChanges",
  agLoadingCellRenderer: "LoadingCellRenderer",
  agSkeletonCellRenderer: "SkeletonCellRenderer",
  agCheckboxCellRenderer: "CheckboxCellRenderer",
  agLoadingOverlay: "Overlay",
  agNoRowsOverlay: "Overlay",
  agTooltipComponent: "Tooltip",
  agReadOnlyFloatingFilter: "CustomFilter",
  agTextColumnFilter: "TextFilter",
  agNumberColumnFilter: "NumberFilter",
  agDateColumnFilter: "DateFilter",
  agDateInput: "DateFilter",
  agTextColumnFloatingFilter: "TextFilter",
  agNumberColumnFloatingFilter: "NumberFilter",
  agDateColumnFloatingFilter: "DateFilter",
  agCellEditor: "TextEditor",
  agSelectCellEditor: "SelectEditor",
  agTextCellEditor: "TextEditor",
  agNumberCellEditor: "NumberEditor",
  agDateCellEditor: "DateEditor",
  agDateStringCellEditor: "DateEditor",
  agCheckboxCellEditor: "CheckboxEditor",
  agLargeTextCellEditor: "LargeTextEditor",
  agMenuItem: "MenuItem",
  agColumnsToolPanel: "ColumnsToolPanel",
  agFiltersToolPanel: "FiltersToolPanel",
  agNewFiltersToolPanel: "NewFiltersToolPanel",
  agAggregationComponent: "StatusBar",
  agSelectedRowCountComponent: "StatusBar",
  agTotalRowCountComponent: "StatusBar",
  agFilteredRowCountComponent: "StatusBar",
  agTotalAndFilteredRowCountComponent: "StatusBar",
  agFindCellRenderer: "Find"
};
function un(e) {
  return `"${e}"`;
}
var lC = () => ({
  checkboxSelection: { version: "32.2", message: "Use `rowSelection.checkboxes` in `GridOptions` instead." },
  headerCheckboxSelection: {
    version: "32.2",
    message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
  },
  headerCheckboxSelectionFilteredOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
  },
  headerCheckboxSelectionCurrentPageOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
  },
  showDisabledCheckboxes: {
    version: "32.2",
    message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
  },
  rowGroupingHierarchy: {
    version: "34.3",
    message: "Use `colDef.groupHierarchy` instead."
  }
}), aC = {
  aggFunc: "SharedAggregation",
  autoHeight: "RowAutoHeight",
  cellClass: "CellStyle",
  cellClassRules: "CellStyle",
  cellEditor: ({ cellEditor: e, editable: t }) => t ? typeof e == "string" ? ct[e] ?? "CustomEditor" : "CustomEditor" : null,
  cellRenderer: ({ cellRenderer: e }) => typeof e != "string" ? null : ct[e],
  cellStyle: "CellStyle",
  columnChooserParams: "ColumnMenu",
  contextMenuItems: "ContextMenu",
  dndSource: "DragAndDrop",
  dndSourceOnRowDrag: "DragAndDrop",
  editable: ({ editable: e, cellEditor: t }) => e && !t ? "TextEditor" : null,
  enableCellChangeFlash: "HighlightChanges",
  enablePivot: "SharedPivot",
  enableRowGroup: "SharedRowGrouping",
  enableValue: "SharedAggregation",
  filter: ({ filter: e }) => e && typeof e != "string" && typeof e != "boolean" ? "CustomFilter" : typeof e == "string" ? ct[e] ?? "ColumnFilter" : "ColumnFilter",
  floatingFilter: "ColumnFilter",
  getQuickFilterText: "QuickFilter",
  headerTooltip: "Tooltip",
  headerTooltipValueGetter: "Tooltip",
  mainMenuItems: "ColumnMenu",
  menuTabs: (e) => {
    const t = ["columnsMenuTab", "generalMenuTab"];
    return e.menuTabs?.some((o) => t.includes(o)) ? "ColumnMenu" : null;
  },
  pivot: "SharedPivot",
  pivotIndex: "SharedPivot",
  rowDrag: "RowDrag",
  rowGroup: "SharedRowGrouping",
  rowGroupIndex: "SharedRowGrouping",
  tooltipField: "Tooltip",
  tooltipValueGetter: "Tooltip",
  tooltipComponentSelector: "Tooltip",
  spanRows: "CellSpan",
  groupHierarchy: "SharedRowGrouping"
}, dC = () => ({
  autoHeight: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { paginationAutoPageSize: o }) => o ? "colDef.autoHeight is not supported with paginationAutoPageSize." : null
  },
  cellRendererParams: {
    validate: (t) => (t.rowGroup != null || t.rowGroupIndex != null || t.cellRenderer === "agGroupCellRenderer") && "checkbox" in t.cellRendererParams ? 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.' : null
  },
  flex: {
    validate: (t, o) => o.autoSizeStrategy ? "colDef.flex is not supported with gridOptions.autoSizeStrategy" : null
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
  },
  headerValueGetter: {
    validate: (t) => {
      const o = t.headerValueGetter;
      return typeof o == "function" || typeof o == "string" ? null : "headerValueGetter must be a function or a valid string expression";
    }
  },
  icons: {
    validate: ({ icons: t }) => {
      if (t) {
        if (t.smallDown)
          return Ce(262);
        if (t.smallLeft)
          return Ce(263);
        if (t.smallRight)
          return Ce(264);
      }
      return null;
    }
  },
  sortingOrder: {
    validate: (t) => {
      const o = t.sortingOrder;
      if (Array.isArray(o) && o.length > 0) {
        const i = o.filter((s) => !$t.includes(s));
        if (i.length > 0)
          return `sortingOrder must be an array with elements from [${$t.map(yo).join()}], currently it includes [${i.map(yo).join()}]`;
      } else if (!Array.isArray(o) || o.length <= 0)
        return `sortingOrder must be an array with at least one element, currently it's ${o}`;
      return null;
    }
  },
  type: {
    validate: (t) => {
      const o = t.type;
      return o instanceof Array ? o.some((s) => typeof s != "string") ? "if colDef.type is supplied an array it should be of type 'string[]'" : null : typeof o == "string" ? null : "colDef.type should be of type 'string' | 'string[]'";
    }
  },
  rowSpan: {
    validate: (t, { suppressRowTransform: o }) => o ? null : "colDef.rowSpan requires suppressRowTransform to be enabled."
  },
  spanRows: {
    dependencies: {
      editable: { required: [!1, void 0] },
      rowDrag: { required: [!1, void 0] },
      colSpan: { required: [void 0] },
      rowSpan: { required: [void 0] }
    },
    validate: (t, {
      rowSelection: o,
      cellSelection: i,
      suppressRowTransform: s,
      enableCellSpan: n,
      rowDragEntireRow: r,
      enableCellTextSelection: l
    }) => typeof o == "object" && o?.mode === "singleRow" && o?.enableClickSelection ? "colDef.spanRows is not supported with rowSelection.clickSelection" : i ? "colDef.spanRows is not supported with cellSelection." : s ? "colDef.spanRows is not supported with suppressRowTransform." : n ? r ? "colDef.spanRows is not supported with rowDragEntireRow." : l ? "colDef.spanRows is not supported with enableCellTextSelection." : null : "colDef.spanRows requires enableCellSpan to be enabled."
  },
  groupHierarchy: {
    validate(t, { groupHierarchyConfig: o = {} }, i) {
      const s = /* @__PURE__ */ new Set([
        "year",
        "quarter",
        "month",
        "formattedMonth",
        "day",
        "hour",
        "minute",
        "second"
      ]), n = [];
      for (const r of t.groupHierarchy ?? []) {
        if (typeof r == "object") {
          i.validation?.validateColDef(r);
          continue;
        }
        !s.has(r) && !(r in o) && n.push(un(r));
      }
      if (n.length > 0) {
        const r = `The following parts of colDef.groupHierarchy are not recognised: ${n.join(", ")}.`, l = `Choose one of ${[...s].map(un).join(", ")}, or define your own parts in gridOptions.groupHierarchyConfig.`;
        return `${r}
${l}`;
      }
      return null;
    }
  }
}), cC = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerStyle: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  headerTooltipValueGetter: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  spanRows: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  tooltipComponentSelector: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0,
  context: void 0,
  dateComponent: void 0,
  dateComponentParams: void 0,
  getFindText: void 0,
  rowGroupingHierarchy: void 0,
  groupHierarchy: void 0
}, uC = () => Object.keys(cC), hC = () => ({
  objectName: "colDef",
  allProperties: uC(),
  docsUrl: "column-properties/",
  deprecations: lC(),
  validations: dC()
}), gC = [
  "overlayLoadingTemplate",
  "overlayNoRowsTemplate",
  "gridId",
  "quickFilterText",
  "rowModelType",
  "editType",
  "domLayout",
  "clipboardDelimiter",
  "rowGroupPanelShow",
  "multiSortKey",
  "pivotColumnGroupTotals",
  "pivotRowTotals",
  "pivotPanelShow",
  "fillHandleDirection",
  "groupDisplayType",
  "treeDataDisplayType",
  "treeDataChildrenField",
  "treeDataParentIdField",
  "colResizeDefault",
  "tooltipTrigger",
  "serverSidePivotResultFieldSeparator",
  "columnMenu",
  "tooltipShowMode",
  "invalidEditValueMode",
  "grandTotalRow",
  "themeCssLayer",
  "findSearchValue",
  "styleNonce",
  "renderingMode"
], pC = [
  "components",
  "rowStyle",
  "context",
  "autoGroupColumnDef",
  "localeText",
  "icons",
  "datasource",
  "dragAndDropImageComponentParams",
  "serverSideDatasource",
  "viewportDatasource",
  "groupRowRendererParams",
  "aggFuncs",
  "fullWidthCellRendererParams",
  "defaultColGroupDef",
  "defaultColDef",
  "defaultCsvExportParams",
  "defaultExcelExportParams",
  "columnTypes",
  "rowClassRules",
  "detailCellRendererParams",
  "loadingCellRendererParams",
  "loadingOverlayComponentParams",
  "noRowsOverlayComponentParams",
  "popupParent",
  "themeStyleContainer",
  "statusBar",
  "chartThemeOverrides",
  "customChartThemes",
  "chartToolPanelsDef",
  "dataTypeDefinitions",
  "advancedFilterParent",
  "advancedFilterBuilderParams",
  "advancedFilterParams",
  "initialState",
  "autoSizeStrategy",
  "selectionColumnDef",
  "findOptions",
  "filterHandlers",
  "groupHierarchyConfig"
], fC = [
  "sortingOrder",
  "alignedGrids",
  "rowData",
  "columnDefs",
  "excelStyles",
  "pinnedTopRowData",
  "pinnedBottomRowData",
  "chartThemes",
  "rowClass",
  "paginationPageSizeSelector"
], Sl = [
  "rowHeight",
  "detailRowHeight",
  "rowBuffer",
  "headerHeight",
  "groupHeaderHeight",
  "groupLockGroupColumns",
  "floatingFiltersHeight",
  "pivotHeaderHeight",
  "pivotGroupHeaderHeight",
  "groupDefaultExpanded",
  "pivotDefaultExpanded",
  "viewportRowModelPageSize",
  "viewportRowModelBufferSize",
  "autoSizePadding",
  "maxBlocksInCache",
  "maxConcurrentDatasourceRequests",
  "tooltipShowDelay",
  "tooltipHideDelay",
  "cacheOverflowSize",
  "paginationPageSize",
  "cacheBlockSize",
  "infiniteInitialRowCount",
  "serverSideInitialRowCount",
  "scrollbarWidth",
  "asyncTransactionWaitMillis",
  "blockLoadDebounceMillis",
  "keepDetailRowsCount",
  "undoRedoCellEditingLimit",
  "cellFlashDuration",
  "cellFadeDuration",
  "tabIndex",
  "pivotMaxGeneratedColumns",
  "rowDragInsertDelay"
], CC = ["theme", "rowSelection"], mC = [
  "cellSelection",
  "sideBar",
  "rowNumbers",
  "suppressGroupChangesColumnVisibility",
  "groupAggFiltering",
  "suppressStickyTotalRow",
  "groupHideParentOfSingleChild",
  "enableRowPinning"
], bl = [
  "loadThemeGoogleFonts",
  "suppressMakeColumnVisibleAfterUnGroup",
  "suppressRowClickSelection",
  "suppressCellFocus",
  "suppressHeaderFocus",
  "suppressHorizontalScroll",
  "groupSelectsChildren",
  "alwaysShowHorizontalScroll",
  "alwaysShowVerticalScroll",
  "debug",
  "enableBrowserTooltips",
  "enableCellExpressions",
  "groupSuppressBlankHeader",
  "suppressMenuHide",
  "suppressRowDeselection",
  "unSortIcon",
  "suppressMultiSort",
  "alwaysMultiSort",
  "singleClickEdit",
  "suppressLoadingOverlay",
  "suppressNoRowsOverlay",
  "suppressAutoSize",
  "skipHeaderOnAutoSize",
  "suppressColumnMoveAnimation",
  "suppressMoveWhenColumnDragging",
  "suppressMovableColumns",
  "suppressFieldDotNotation",
  "enableRangeSelection",
  "enableRangeHandle",
  "enableFillHandle",
  "suppressClearOnFillReduction",
  "deltaSort",
  "suppressTouch",
  "allowContextMenuWithControlKey",
  "suppressContextMenu",
  "suppressDragLeaveHidesColumns",
  "suppressRowGroupHidesColumns",
  "suppressMiddleClickScrolls",
  "suppressPreventDefaultOnMouseWheel",
  "suppressCopyRowsToClipboard",
  "copyHeadersToClipboard",
  "copyGroupHeadersToClipboard",
  "pivotMode",
  "suppressAggFuncInHeader",
  "suppressColumnVirtualisation",
  "alwaysAggregateAtRootLevel",
  "suppressFocusAfterRefresh",
  "functionsReadOnly",
  "animateRows",
  "groupSelectsFiltered",
  "groupRemoveSingleChildren",
  "groupRemoveLowestSingleChildren",
  "enableRtl",
  "enableCellSpan",
  "suppressClickEdit",
  "rowDragEntireRow",
  "rowDragManaged",
  "suppressRowDrag",
  "suppressMoveWhenRowDragging",
  "rowDragMultiRow",
  "enableGroupEdit",
  "embedFullWidthRows",
  "suppressPaginationPanel",
  "groupHideOpenParents",
  "groupAllowUnbalanced",
  "pagination",
  "paginationAutoPageSize",
  "suppressScrollOnNewData",
  "suppressScrollWhenPopupsAreOpen",
  "purgeClosedRowNodes",
  "cacheQuickFilter",
  "includeHiddenColumnsInQuickFilter",
  "ensureDomOrder",
  "accentedSort",
  "suppressChangeDetection",
  "valueCache",
  "valueCacheNeverExpires",
  "aggregateOnlyChangedColumns",
  "suppressAnimationFrame",
  "suppressExcelExport",
  "suppressCsvExport",
  "includeHiddenColumnsInAdvancedFilter",
  "suppressMultiRangeSelection",
  "enterNavigatesVerticallyAfterEdit",
  "enterNavigatesVertically",
  "suppressPropertyNamesCheck",
  "rowMultiSelectWithClick",
  "suppressRowHoverHighlight",
  "suppressRowTransform",
  "suppressClipboardPaste",
  "suppressLastEmptyLineOnPaste",
  "enableCharts",
  "suppressMaintainUnsortedOrder",
  "enableCellTextSelection",
  "suppressBrowserResizeObserver",
  "suppressMaxRenderedRowRestriction",
  "excludeChildrenWhenTreeDataFiltering",
  "tooltipMouseTrack",
  "tooltipInteraction",
  "keepDetailRows",
  "paginateChildRows",
  "preventDefaultOnContextMenu",
  "undoRedoCellEditing",
  "allowDragFromColumnsToolPanel",
  "pivotSuppressAutoColumn",
  "suppressExpandablePivotGroups",
  "debounceVerticalScrollbar",
  "detailRowAutoHeight",
  "serverSideSortAllLevels",
  "serverSideEnableClientSideSort",
  "serverSideOnlyRefreshFilteredGroups",
  "suppressAggFilteredOnly",
  "showOpenedGroup",
  "suppressClipboardApi",
  "suppressModelUpdateAfterUpdateTransaction",
  "stopEditingWhenCellsLoseFocus",
  "groupMaintainOrder",
  "columnHoverHighlight",
  "readOnlyEdit",
  "suppressRowVirtualisation",
  "enableCellEditingOnBackspace",
  "resetRowDataOnUpdate",
  "removePivotHeaderRowWhenSingleValueColumn",
  "suppressCopySingleCellRanges",
  "suppressGroupRowsSticky",
  "suppressCutToClipboard",
  "rowGroupPanelSuppressSort",
  "allowShowChangeAfterFilter",
  "enableAdvancedFilter",
  "masterDetail",
  "treeData",
  "reactiveCustomComponents",
  "applyQuickFilterBeforePivotOrAgg",
  "suppressServerSideFullWidthLoadingRow",
  "suppressAdvancedFilterEval",
  "loading",
  "maintainColumnOrder",
  "enableStrictPivotColumnOrder",
  "suppressSetFilterByDefault",
  "enableFilterHandlers",
  "suppressStartEditOnTab",
  "hidePaddedHeaderRows",
  "ssrmExpandAllAffectsAllRows"
], vC = [
  "doesExternalFilterPass",
  "processPivotResultColDef",
  "processPivotResultColGroupDef",
  "getBusinessKeyForNode",
  "isRowSelectable",
  "rowDragText",
  "groupRowRenderer",
  "dragAndDropImageComponent",
  "fullWidthCellRenderer",
  "loadingCellRenderer",
  "loadingOverlayComponent",
  "noRowsOverlayComponent",
  "detailCellRenderer",
  "quickFilterParser",
  "quickFilterMatcher",
  "getLocaleText",
  "isExternalFilterPresent",
  "getRowHeight",
  "getRowClass",
  "getRowStyle",
  "getFullRowEditValidationErrors",
  "getContextMenuItems",
  "getMainMenuItems",
  "processRowPostCreate",
  "processCellForClipboard",
  "getGroupRowAgg",
  "isFullWidthRow",
  "sendToClipboard",
  "focusGridInnerElement",
  "navigateToNextHeader",
  "tabToNextHeader",
  "navigateToNextCell",
  "tabToNextCell",
  "processCellFromClipboard",
  "getDocument",
  "postProcessPopup",
  "getChildCount",
  "getDataPath",
  "isRowMaster",
  "postSortRows",
  "processHeaderForClipboard",
  "processUnpinnedColumns",
  "processGroupHeaderForClipboard",
  "paginationNumberFormatter",
  "processDataFromClipboard",
  "getServerSideGroupKey",
  "isServerSideGroup",
  "createChartContainer",
  "getChartToolbarItems",
  "fillOperation",
  "isApplyServerSideTransaction",
  "getServerSideGroupLevelParams",
  "isServerSideGroupOpenByDefault",
  "isGroupOpenByDefault",
  "initialGroupOrderComparator",
  "loadingCellRendererSelector",
  "getRowId",
  "chartMenuItems",
  "groupTotalRow",
  "alwaysPassFilter",
  "isRowPinnable",
  "isRowPinned",
  "isRowValidDropPosition"
], wC = () => [
  ...fC,
  ...pC,
  ...gC,
  ...Sl,
  ...vC,
  ...bl,
  ...mC,
  ...CC
], SC = () => ({
  suppressLoadingOverlay: { version: "32", message: "Use `loading`=false instead." },
  enableFillHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeSelection: { version: "32.2", message: "Use `cellSelection = true` instead." },
  suppressMultiRangeSelection: {
    version: "32.2",
    message: "Use `cellSelection.suppressMultiRanges` instead."
  },
  suppressClearOnFillReduction: {
    version: "32.2",
    message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
  },
  fillHandleDirection: { version: "32.2", message: "Use `cellSelection.handle.direction` instead." },
  fillOperation: { version: "32.2", message: "Use `cellSelection.handle.setFillValue` instead." },
  suppressRowClickSelection: {
    version: "32.2",
    message: "Use `rowSelection.enableClickSelection` instead."
  },
  suppressRowDeselection: { version: "32.2", message: "Use `rowSelection.enableClickSelection` instead." },
  rowMultiSelectWithClick: {
    version: "32.2",
    message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
  },
  groupSelectsChildren: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
  },
  groupSelectsFiltered: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
  },
  isRowSelectable: { version: "32.2", message: "Use `selectionOptions.isRowSelectable` instead." },
  suppressCopySingleCellRanges: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  suppressCopyRowsToClipboard: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  onRangeSelectionChanged: { version: "32.2", message: "Use `onCellSelectionChanged` instead." },
  onRangeDeleteStart: { version: "32.2", message: "Use `onCellSelectionDeleteStart` instead." },
  onRangeDeleteEnd: { version: "32.2", message: "Use `onCellSelectionDeleteEnd` instead." },
  suppressBrowserResizeObserver: {
    version: "32.2",
    message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
  },
  onColumnEverythingChanged: {
    version: "32.2",
    message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
  },
  groupRemoveSingleChildren: {
    version: "33",
    message: "Use `groupHideParentOfSingleChild` instead."
  },
  groupRemoveLowestSingleChildren: {
    version: "33",
    message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
  },
  suppressRowGroupHidesColumns: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
  },
  suppressMakeColumnVisibleAfterUnGroup: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
  },
  unSortIcon: { version: "33", message: "Use `defaultColDef.unSortIcon` instead." },
  sortingOrder: { version: "33", message: "Use `defaultColDef.sortingOrder` instead." },
  suppressPropertyNamesCheck: {
    version: "33",
    message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
  },
  suppressAdvancedFilterEval: {
    version: "34",
    message: "Advanced filter no longer uses function evaluation, so this option has no effect."
  }
});
function he(e, t, o) {
  return typeof t == "number" || t == null ? t == null || t >= o ? null : `${e}: value should be greater than or equal to ${o}` : `${e}: value should be a number`;
}
var bC = {
  alignedGrids: "AlignedGrids",
  allowContextMenuWithControlKey: "ContextMenu",
  autoSizeStrategy: "ColumnAutoSize",
  cellSelection: "CellSelection",
  columnHoverHighlight: "ColumnHover",
  datasource: "InfiniteRowModel",
  doesExternalFilterPass: "ExternalFilter",
  editType: "EditCore",
  invalidEditValueMode: "EditCore",
  enableAdvancedFilter: "AdvancedFilter",
  enableCellSpan: "CellSpan",
  enableCharts: "IntegratedCharts",
  enableRangeSelection: "CellSelection",
  enableRowPinning: "PinnedRow",
  findSearchValue: "Find",
  getFullRowEditValidationErrors: "EditCore",
  getContextMenuItems: "ContextMenu",
  getLocaleText: "Locale",
  getMainMenuItems: "ColumnMenu",
  getRowClass: "RowStyle",
  getRowStyle: "RowStyle",
  groupTotalRow: "SharedRowGrouping",
  grandTotalRow: "ClientSideRowModelHierarchy",
  initialState: "GridState",
  isExternalFilterPresent: "ExternalFilter",
  isRowPinnable: "PinnedRow",
  isRowPinned: "PinnedRow",
  localeText: "Locale",
  masterDetail: "SharedMasterDetail",
  pagination: "Pagination",
  pinnedBottomRowData: "PinnedRow",
  pinnedTopRowData: "PinnedRow",
  pivotMode: "SharedPivot",
  pivotPanelShow: "RowGroupingPanel",
  quickFilterText: "QuickFilter",
  rowClass: "RowStyle",
  rowClassRules: "RowStyle",
  rowData: "ClientSideRowModel",
  rowDragManaged: "RowDrag",
  rowGroupPanelShow: "RowGroupingPanel",
  rowNumbers: "RowNumbers",
  rowSelection: "SharedRowSelection",
  rowStyle: "RowStyle",
  serverSideDatasource: "ServerSideRowModel",
  sideBar: "SideBar",
  statusBar: "StatusBar",
  treeData: "SharedTreeData",
  undoRedoCellEditing: "UndoRedoEdit",
  valueCache: "ValueCache",
  viewportDatasource: "ViewportRowModel"
}, yC = () => {
  const e = {
    autoSizePadding: {
      validate({ autoSizePadding: o }) {
        return he("autoSizePadding", o, 0);
      }
    },
    cacheBlockSize: {
      supportedRowModels: ["serverSide", "infinite"],
      validate({ cacheBlockSize: o }) {
        return he("cacheBlockSize", o, 1);
      }
    },
    cacheOverflowSize: {
      validate({ cacheOverflowSize: o }) {
        return he("cacheOverflowSize", o, 1);
      }
    },
    datasource: {
      supportedRowModels: ["infinite"]
    },
    domLayout: {
      validate: (o) => {
        const i = o.domLayout, s = ["autoHeight", "normal", "print"];
        return i && !s.includes(i) ? `domLayout must be one of [${s.join()}], currently it's ${i}` : null;
      }
    },
    enableFillHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeSelection: {
      dependencies: {
        rowDragEntireRow: { required: [!1, void 0] }
      }
    },
    enableRowPinning: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, pinnedTopRowData: i, pinnedBottomRowData: s }) {
        return o && (i || s) ? "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : null;
      }
    },
    isRowPinnable: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, isRowPinnable: i, pinnedTopRowData: s, pinnedBottomRowData: n }) {
        return i && (s || n) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !o && i ? "`isRowPinnable` requires `enableRowPinning` to be set." : null;
      }
    },
    isRowPinned: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, isRowPinned: i, pinnedTopRowData: s, pinnedBottomRowData: n }) {
        return i && (s || n) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !o && i ? "`isRowPinned` requires `enableRowPinning` to be set." : null;
      }
    },
    groupDefaultExpanded: {
      supportedRowModels: ["clientSide"]
    },
    groupHideOpenParents: {
      supportedRowModels: ["clientSide", "serverSide"],
      dependencies: {
        groupTotalRow: { required: [void 0, "bottom"] },
        treeData: {
          required: [void 0, !1],
          reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
        }
      }
    },
    groupHideParentOfSingleChild: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] }
      }
    },
    groupRemoveLowestSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveSingleChildren: { required: [void 0, !1] }
      }
    },
    groupRemoveSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveLowestSingleChildren: { required: [void 0, !1] }
      }
    },
    groupSelectsChildren: {
      dependencies: {
        rowSelection: { required: ["multiple"] }
      }
    },
    groupHierarchyConfig: {
      validate({ groupHierarchyConfig: o = {} }, i, s) {
        for (const n of Object.keys(o))
          s.validation?.validateColDef(o[n]);
        return null;
      }
    },
    icons: {
      validate: ({ icons: o }) => {
        if (o) {
          if (o.smallDown)
            return Ce(262);
          if (o.smallLeft)
            return Ce(263);
          if (o.smallRight)
            return Ce(264);
        }
        return null;
      }
    },
    infiniteInitialRowCount: {
      validate({ infiniteInitialRowCount: o }) {
        return he("infiniteInitialRowCount", o, 1);
      }
    },
    initialGroupOrderComparator: {
      supportedRowModels: ["clientSide"]
    },
    ssrmExpandAllAffectsAllRows: {
      validate: (o) => {
        if (typeof o.ssrmExpandAllAffectsAllRows == "boolean") {
          if (o.rowModelType !== "serverSide")
            return "'ssrmExpandAllAffectsAllRows' is only supported with the Server Side Row Model.";
          if (o.ssrmExpandAllAffectsAllRows && typeof o.getRowId != "function")
            return "'getRowId' callback must be provided for Server Side Row Model grouping to work correctly.";
        }
        return null;
      }
    },
    keepDetailRowsCount: {
      validate({ keepDetailRowsCount: o }) {
        return he("keepDetailRowsCount", o, 1);
      }
    },
    paginationPageSize: {
      validate({ paginationPageSize: o }) {
        return he("paginationPageSize", o, 1);
      }
    },
    paginationPageSizeSelector: {
      validate: (o) => {
        const i = o.paginationPageSizeSelector;
        return typeof i == "boolean" || i == null || i.length ? null : `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
      }
    },
    pivotMode: {
      dependencies: {
        treeData: {
          required: [!1, void 0],
          reason: "Pivot Mode is not supported with Tree Data."
        }
      }
    },
    quickFilterText: {
      supportedRowModels: ["clientSide"]
    },
    rowBuffer: {
      validate({ rowBuffer: o }) {
        return he("rowBuffer", o, 0);
      }
    },
    rowClass: {
      validate: (o) => typeof o.rowClass == "function" ? "rowClass should not be a function, please use getRowClass instead" : null
    },
    rowData: {
      supportedRowModels: ["clientSide"]
    },
    rowDragManaged: {
      supportedRowModels: ["clientSide"],
      dependencies: {
        pagination: {
          required: [!1, void 0]
        }
      }
    },
    rowSelection: {
      validate({ rowSelection: o }) {
        return o && typeof o == "string" ? 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.' : o && typeof o != "object" ? "Expected `RowSelectionOptions` object for the `rowSelection` property." : o && o.mode !== "multiRow" && o.mode !== "singleRow" ? `Selection mode "${o.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.` : null;
      }
    },
    rowStyle: {
      validate: (o) => {
        const i = o.rowStyle;
        return i && typeof i == "function" ? "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead" : null;
      }
    },
    serverSideDatasource: {
      supportedRowModels: ["serverSide"]
    },
    serverSideInitialRowCount: {
      supportedRowModels: ["serverSide"],
      validate({ serverSideInitialRowCount: o }) {
        return he("serverSideInitialRowCount", o, 1);
      }
    },
    serverSideOnlyRefreshFilteredGroups: {
      supportedRowModels: ["serverSide"]
    },
    serverSideSortAllLevels: {
      supportedRowModels: ["serverSide"]
    },
    sortingOrder: {
      validate: (o) => {
        const i = o.sortingOrder;
        if (Array.isArray(i) && i.length > 0) {
          const s = i.filter((n) => !$t.includes(n));
          if (s.length > 0)
            return `sortingOrder must be an array with elements from [${$t.map(yo).join()}], currently it includes [${s.map(yo).join()}]`;
        } else if (!Array.isArray(i) || i.length <= 0)
          return `sortingOrder must be an array with at least one element, currently it's ${i}`;
        return null;
      }
    },
    tooltipHideDelay: {
      validate: (o) => o.tooltipHideDelay && o.tooltipHideDelay < 0 ? "tooltipHideDelay should not be lower than 0" : null
    },
    tooltipShowDelay: {
      validate: (o) => o.tooltipShowDelay && o.tooltipShowDelay < 0 ? "tooltipShowDelay should not be lower than 0" : null
    },
    treeData: {
      supportedRowModels: ["clientSide", "serverSide"],
      validate: (o) => {
        const i = o.rowModelType ?? "clientSide";
        switch (i) {
          case "clientSide": {
            const { treeDataChildrenField: s, treeDataParentIdField: n, getDataPath: r, getRowId: l } = o;
            if (!s && !n && !r)
              return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
            if (s) {
              if (r)
                return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
              if (n)
                return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
            }
            if (n) {
              if (!l)
                return "getRowId callback not provided, tree data with parent id cannot be built.";
              if (r)
                return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
            }
            return null;
          }
          case "serverSide": {
            const s = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${i} row model.`;
            return o.isServerSideGroup && o.getServerSideGroupKey ? null : s;
          }
        }
        return null;
      }
    },
    viewportDatasource: {
      supportedRowModels: ["viewport"]
    },
    viewportRowModelBufferSize: {
      validate({ viewportRowModelBufferSize: o }) {
        return he("viewportRowModelBufferSize", o, 0);
      }
    },
    viewportRowModelPageSize: {
      validate({ viewportRowModelPageSize: o }) {
        return he("viewportRowModelPageSize", o, 1);
      }
    },
    rowDragEntireRow: {
      dependencies: {
        cellSelection: { required: [void 0] }
      }
    },
    autoGroupColumnDef: {
      validate({ autoGroupColumnDef: o, showOpenedGroup: i }) {
        return o?.field && i ? "autoGroupColumnDef.field and showOpenedGroup are not supported when used together." : o?.valueGetter && i ? "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together." : null;
      }
    },
    renderingMode: {
      validate: (o) => {
        const i = o.renderingMode, s = ["default", "legacy"];
        return i && !s.includes(i) ? `renderingMode must be one of [${s.join()}], currently it's ${i}` : null;
      }
    },
    autoSizeStrategy: {
      validate: ({ autoSizeStrategy: o }) => {
        if (!o)
          return null;
        const i = [
          "fitCellContents",
          "fitGridWidth",
          "fitProvidedWidth"
        ], s = o.type;
        return s !== "fitCellContents" && s !== "fitGridWidth" && s !== "fitProvidedWidth" ? `Invalid Auto-size strategy. \`autoSizeStrategy\` must be one of ${i.map((n) => '"' + n + '"').join(", ")}, currently it's ${s}` : s === "fitProvidedWidth" && typeof o.width != "number" ? `When using the 'fitProvidedWidth' auto-size strategy, must provide a numeric \`width\`. You provided ${o.width}` : null;
      }
    }
  }, t = {};
  for (const o of bl)
    t[o] = { expectedType: "boolean" };
  for (const o of Sl)
    t[o] = { expectedType: "number" };
  return ee(t, e), t;
}, RC = () => ({
  objectName: "gridOptions",
  allProperties: [...wC(), ...Object.values(bs)],
  propertyExceptions: ["api"],
  docsUrl: "grid-options/",
  deprecations: SC(),
  validations: yC()
}), xC = 0, PC = 0, hn = "__ag_grid_instance", DC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "gos", this.domDataKey = "__AG_" + Math.random().toString(), this.instanceId = PC++, this.gridReadyFired = !1, this.queueEvents = [], this.propEventSvc = new $e(), this.globalEventHandlerFactory = (e) => (t, o) => {
      if (!this.isAlive())
        return;
      const i = Co.has(t);
      if (i && !e || !i && e || !FC(t))
        return;
      const s = (n, r) => {
        const l = bs[n], a = this.gridOptions[l];
        typeof a == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => a(r));
      };
      if (this.gridReadyFired)
        s(t, o);
      else if (t === "gridReady") {
        s(t, o), this.gridReadyFired = !0;
        for (const n of this.queueEvents)
          s(n.eventName, n.event);
        this.queueEvents = [];
      } else
        this.queueEvents.push({ eventName: t, event: o });
    };
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, this.validation = e.validation, this.api = e.gridApi, this.gridId = e.context.getId();
  }
  // This is quicker then having code call gridOptionsService.get('context')
  get gridOptionsContext() {
    return this.gridOptions.context;
  }
  postConstruct() {
    this.validateGridOptions(this.gridOptions), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), !0), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides), this.addManagedEventListeners({
      gridOptionsChanged: ({ options: e }) => {
        this.updateGridOptions({ options: e, force: !0, source: "optionsUpdated" });
      }
    });
  }
  destroy() {
    super.destroy(), this.queueEvents = [];
  }
  /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */
  get(e) {
    return this.gridOptions[e] ?? Ta[e];
  }
  /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */
  getCallback(e) {
    return this.mergeGridCommonParams(this.gridOptions[e]);
  }
  /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */
  exists(e) {
    return A(this.gridOptions[e]);
  }
  /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */
  mergeGridCommonParams(e) {
    return e && ((o) => e(this.addCommon(o)));
  }
  updateGridOptions({
    options: e,
    force: t,
    source: o = "api"
  }) {
    const i = { id: xC++, properties: [] }, s = [], { gridOptions: n, validation: r } = this;
    for (const l of Object.keys(e)) {
      const a = is.applyGlobalGridOption(l, e[l]);
      r?.warnOnInitialPropertyUpdate(o, l);
      const d = t || typeof a == "object" && o === "api", c = n[l];
      if (d || c !== a) {
        n[l] = a;
        const u = {
          type: l,
          currentValue: a,
          previousValue: c,
          changeSet: i,
          source: o
        };
        s.push(u);
      }
    }
    this.validateGridOptions(this.gridOptions), i.properties = s.map((l) => l.type);
    for (const l of s)
      Vt(this, `Updated property ${l.type} from`, l.previousValue, " to ", l.currentValue), this.propEventSvc.dispatchEvent(l);
  }
  addPropertyEventListener(e, t) {
    this.propEventSvc.addEventListener(e, t);
  }
  removePropertyEventListener(e, t) {
    this.propEventSvc.removeEventListener(e, t);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */
  addCommon(e) {
    return e.api = this.api, e.context = this.gridOptionsContext, e;
  }
  validateOptions(e, t) {
    for (const o of Object.keys(e)) {
      const i = e[o];
      if (i == null || i === !1)
        continue;
      let s = t[o];
      typeof s == "function" && (s = s(e, this.gridOptions, this.beans)), s && this.assertModuleRegistered(s, o);
    }
  }
  validateGridOptions(e) {
    this.validateOptions(e, bC), this.validation?.processGridOptions(e);
  }
  validateColDef(e, t, o) {
    (o || !this.beans.dataTypeSvc?.isColPendingInference(t)) && (this.validateOptions(e, aC), this.validation?.validateColDef(e));
  }
  assertModuleRegistered(e, t) {
    const o = Array.isArray(e) ? e.some((i) => this.isModuleRegistered(i)) : this.isModuleRegistered(e);
    return o || W(200, {
      ...this.getModuleErrorParams(),
      moduleName: e,
      reasonOrId: t
    }), o;
  }
  getModuleErrorParams() {
    return {
      gridId: this.gridId,
      gridScoped: ss(),
      rowModelType: this.get("rowModelType"),
      isUmd: Va()
    };
  }
  isModuleRegistered(e) {
    return xi(e, this.gridId, this.get("rowModelType"));
  }
  setInstanceDomData(e) {
    e[hn] = this.instanceId;
  }
  isElementInThisInstance(e) {
    let t = e;
    for (; t; ) {
      const o = t[hn];
      if (A(o))
        return o === this.instanceId;
      t = t.parentElement;
    }
    return !1;
  }
};
function FC(e) {
  return !!bs[e];
}
function yl(e) {
  const t = { "aria-hidden": "true" };
  return {
    tag: "div",
    cls: "ag-cell-label-container",
    role: "presentation",
    children: [
      {
        tag: "span",
        ref: "eMenu",
        cls: "ag-header-icon ag-header-cell-menu-button",
        attrs: t
      },
      {
        tag: "span",
        ref: "eFilterButton",
        cls: "ag-header-icon ag-header-cell-filter-button",
        attrs: t
      },
      {
        tag: "div",
        ref: "eLabel",
        cls: "ag-header-cell-label",
        role: "presentation",
        children: [
          { tag: "span", ref: "eText", cls: "ag-header-cell-text" },
          {
            tag: "span",
            ref: "eFilter",
            cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
            attrs: t
          },
          e ? { tag: "ag-sort-indicator", ref: "eSortIndicator" } : null
        ]
      }
    ]
  };
}
var EC = yl(!0), AC = yl(!1), MC = class extends O {
  constructor() {
    super(...arguments), this.eFilter = P, this.eFilterButton = P, this.eSortIndicator = P, this.eMenu = P, this.eLabel = P, this.eText = P, this.eSortOrder = P, this.eSortAsc = P, this.eSortDesc = P, this.eSortMixed = P, this.eSortNone = P, this.isLoadingInnerComponent = !1;
  }
  refresh(e) {
    const t = this.params;
    if (this.params = e, this.workOutTemplate(e, !!this.beans?.sortSvc) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || e.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || t.enableFilterButton != e.enableFilterButton || t.enableFilterIcon != e.enableFilterIcon)
      return !1;
    if (this.innerHeaderComponent) {
      const o = { ...e };
      ee(o, e.innerHeaderComponentParams), this.innerHeaderComponent.refresh?.(o);
    } else
      this.setDisplayName(e);
    return !0;
  }
  workOutTemplate(e, t) {
    const o = e.template;
    return o ? o?.trim ? o.trim() : o : t ? EC : AC;
  }
  init(e) {
    this.params = e;
    const { sortSvc: t, touchSvc: o, rowNumbersSvc: i, userCompFactory: s } = this.beans, n = t?.getSortIndicatorSelector();
    this.currentTemplate = this.workOutTemplate(e, !!n), this.setTemplate(this.currentTemplate, n ? [n] : void 0), o?.setupForHeader(this), this.setMenu(), this.setupSort(), i?.setupForHeader(this), this.setupFilterIcon(), this.setupFilterButton(), this.workOutInnerHeaderComponent(s, e), this.setDisplayName(e);
  }
  workOutInnerHeaderComponent(e, t) {
    const o = jd(e, t, t);
    o && (this.isLoadingInnerComponent = !0, o.newAgStackInstance().then((i) => {
      this.isLoadingInnerComponent = !1, i && (this.isAlive() ? (this.innerHeaderComponent = i, this.eText && this.eText.appendChild(i.getGui())) : this.destroyBean(i));
    }));
  }
  setDisplayName(e) {
    const { displayName: t } = e, o = this.currentDisplayName;
    this.currentDisplayName = t, !(!this.eText || o === t || this.innerHeaderComponent || this.isLoadingInnerComponent) && (this.eText.textContent = Oo(t));
  }
  addInIcon(e, t, o) {
    const i = ye(e, this.beans, o);
    i && t.appendChild(i);
  }
  workOutShowMenu() {
    return this.params.enableMenu && !!this.beans.menuSvc?.isHeaderMenuButtonEnabled();
  }
  shouldSuppressMenuHide() {
    return !!this.beans.menuSvc?.isHeaderMenuButtonAlwaysShowEnabled();
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
      Ae(this.eMenu), this.eMenu = void 0;
      return;
    }
    const { gos: e, eMenu: t, params: o } = this, i = Do(e);
    this.addInIcon(i ? "menu" : "menuAlt", t, o.column), t.classList.toggle("ag-header-menu-icon", !i);
    const s = this.shouldSuppressMenuHide();
    this.currentSuppressMenuHide = s, this.addManagedElementListeners(t, { click: () => this.showColumnMenu(this.eMenu) }), this.toggleMenuAlwaysShow(s);
  }
  toggleMenuAlwaysShow(e) {
    this.eMenu?.classList.toggle("ag-header-menu-always-show", e);
  }
  showColumnMenu(e) {
    const { currentSuppressMenuHide: t, params: o } = this;
    t || this.toggleMenuAlwaysShow(!0), o.showColumnMenu(e, () => {
      t || this.toggleMenuAlwaysShow(!1);
    });
  }
  onMenuKeyboardShortcut(e) {
    const { params: t, gos: o, beans: i, eMenu: s, eFilterButton: n } = this, r = t.column, l = Do(o);
    if (e && !l) {
      if (i.menuSvc?.isFilterMenuInHeaderEnabled(r))
        return t.showFilter(n ?? s ?? this.getGui()), !0;
    } else if (t.enableMenu)
      return this.showColumnMenu(s ?? n ?? this.getGui()), !0;
    return !1;
  }
  setupSort() {
    const { sortSvc: e } = this.beans;
    if (!e)
      return;
    const { enableSorting: t, column: o } = this.params;
    if (this.currentSort = t, !this.eSortIndicator) {
      this.eSortIndicator = this.createBean(e.createSortIndicator(!0));
      const { eSortIndicator: i, eSortOrder: s, eSortAsc: n, eSortDesc: r, eSortMixed: l, eSortNone: a } = this;
      i.attachCustomElements(s, n, r, l, a);
    }
    this.eSortIndicator.setupSort(o), this.currentSort && e.setupHeader(this, o, this.eLabel);
  }
  setupFilterIcon() {
    const { eFilter: e, params: t } = this;
    if (!e)
      return;
    const o = () => {
      const i = t.column.isFilterActive();
      V(e, i, { skipAriaHidden: !0 });
    };
    this.configureFilter(t.enableFilterIcon, e, o, "filterActive");
  }
  setupFilterButton() {
    const { eFilterButton: e, params: t } = this;
    if (!e)
      return;
    this.configureFilter(
      t.enableFilterButton,
      e,
      this.onFilterChangedButton.bind(this),
      "filter"
    ) ? this.addManagedElementListeners(e, {
      click: () => t.showFilter(e)
    }) : this.eFilterButton = void 0;
  }
  configureFilter(e, t, o, i) {
    if (!e)
      return Ae(t), !1;
    const s = this.params.column;
    return this.addInIcon(i, t, s), this.addManagedListeners(s, { filterChanged: o }), o(), !0;
  }
  onFilterChangedButton() {
    const e = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", e);
  }
  getAnchorElementForMenu(e) {
    const { eFilterButton: t, eMenu: o } = this;
    return e ? t ?? o ?? this.getGui() : o ?? t ?? this.getGui();
  }
  destroy() {
    super.destroy(), this.innerHeaderComponent && (this.destroyBean(this.innerHeaderComponent), this.innerHeaderComponent = void 0);
  }
}, TC = {
  tag: "div",
  cls: "ag-header-group-cell-label",
  role: "presentation",
  children: [
    { tag: "span", ref: "agLabel", cls: "ag-header-group-text", role: "presentation" },
    { tag: "span", ref: "agOpened", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded" },
    { tag: "span", ref: "agClosed", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed" }
  ]
}, IC = class extends O {
  constructor() {
    super(TC), this.agOpened = P, this.agClosed = P, this.agLabel = P, this.isLoadingInnerComponent = !1;
  }
  init(e) {
    const { userCompFactory: t, touchSvc: o } = this.beans;
    this.params = e, this.checkWarnings(), this.workOutInnerHeaderGroupComponent(t, e), this.setupLabel(e), this.addGroupExpandIcon(e), this.setupExpandIcons(), o?.setupForHeaderGroup(this);
  }
  checkWarnings() {
    this.params.template && F(89);
  }
  workOutInnerHeaderGroupComponent(e, t) {
    const o = Yd(e, t, t);
    o && (this.isLoadingInnerComponent = !0, o.newAgStackInstance().then((i) => {
      this.isLoadingInnerComponent = !1, i && (this.isAlive() ? (this.innerHeaderGroupComponent = i, this.agLabel.appendChild(i.getGui())) : this.destroyBean(i));
    }));
  }
  setupExpandIcons() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: o },
      beans: i
    } = this;
    this.addInIcon("columnGroupOpened", e), this.addInIcon("columnGroupClosed", t);
    const s = (a) => {
      if (xe(a))
        return;
      const d = !o.isExpanded();
      i.colGroupSvc.setColumnGroupOpened(
        o.getProvidedColumnGroup(),
        d,
        "uiColumnExpanded"
      );
    };
    this.addTouchAndClickListeners(i, t, s), this.addTouchAndClickListeners(i, e, s);
    const n = (a) => {
      Ct(a);
    };
    this.addManagedElementListeners(t, { dblclick: n }), this.addManagedElementListeners(e, { dblclick: n }), this.addManagedElementListeners(this.getGui(), { dblclick: s }), this.updateIconVisibility();
    const r = o.getProvidedColumnGroup(), l = this.updateIconVisibility.bind(this);
    this.addManagedListeners(r, {
      expandedChanged: l,
      expandableChanged: l
    });
  }
  addTouchAndClickListeners(e, t, o) {
    e.touchSvc?.setupForHeaderGroupElement(this, t, o), this.addManagedElementListeners(t, { click: o });
  }
  updateIconVisibility() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: o }
    } = this;
    if (o.isExpandable()) {
      const i = o.isExpanded();
      V(e, i), V(t, !i);
    } else
      V(e, !1), V(t, !1);
  }
  addInIcon(e, t) {
    const o = ye(e, this.beans, null);
    o && t.appendChild(o);
  }
  addGroupExpandIcon(e) {
    if (!e.columnGroup.isExpandable()) {
      const { agOpened: t, agClosed: o } = this;
      V(t, !1), V(o, !1);
    }
  }
  setupLabel(e) {
    const { displayName: t, columnGroup: o } = e, i = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
    A(t) && !i && (this.agLabel.textContent = Oo(t)), this.toggleCss("ag-sticky-label", !o.getColGroupDef()?.suppressStickyLabel);
  }
  destroy() {
    super.destroy(), this.innerHeaderGroupComponent && (this.destroyBean(this.innerHeaderGroupComponent), this.innerHeaderGroupComponent = void 0);
  }
}, kC = {
  moduleName: "ColumnHeaderComp",
  version: M,
  userComponents: {
    agColumnHeader: MC
  },
  icons: {
    // button to launch legacy column menu
    menu: "menu",
    // button to launch new enterprise column menu
    menuAlt: "menu-alt"
  }
}, LC = {
  moduleName: "ColumnGroupHeaderComp",
  version: M,
  userComponents: {
    agColumnGroupHeader: IC
  },
  icons: {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted"
  }
}, GC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "animationFrameSvc", this.p1 = { list: [], sorted: !1 }, this.p2 = { list: [], sorted: !1 }, this.f1 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastScrollTop = 0, this.taskCount = 0;
  }
  setScrollTop(e) {
    this.scrollGoingDown = e >= this.lastScrollTop, e === 0 && (this.scrollGoingDown = !0), this.lastScrollTop = e;
  }
  postConstruct() {
    this.active = !this.gos.get("suppressAnimationFrame"), this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
  }
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  verify() {
    this.active === !1 && F(92);
  }
  createTask(e, t, o, i, s = !1) {
    this.verify();
    let n = o;
    i && this.batchFrameworkComps && (n = "f1");
    const r = { task: e, index: t, createOrder: ++this.taskCount, deferred: s };
    this.addTaskToList(this[n], r), this.schedule();
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort((o, i) => o.deferred !== i.deferred ? o.deferred ? -1 : 1 : o.index !== i.index ? t * (i.index - o.index) : i.createOrder - o.createOrder), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verify(), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    const { p1: t, p2: o, f1: i, destroyTasks: s, beans: n } = this, { ctrlsSvc: r, frameworkOverrides: l } = n, a = t.list, d = o.list, c = i.list, u = Date.now();
    let h = 0;
    const g = e <= 0, p = r.getScrollFeature();
    for (; g || h < e; ) {
      if (!p.scrollGridIfNeeded()) {
        let C;
        if (a.length)
          this.sortTaskList(t), C = a.pop().task;
        else if (d.length)
          this.sortTaskList(o), C = d.pop().task;
        else if (c.length)
          l.wrapOutgoing(() => {
            for (; (g || h < e) && !p.scrollGridIfNeeded(); ) {
              if (c.length)
                this.sortTaskList(i), C = c.pop().task, C();
              else
                break;
              h = Date.now() - u;
            }
          }), C = () => {
          };
        else if (s.length)
          C = s.pop();
        else
          break;
        C();
      }
      h = Date.now() - u;
    }
    a.length || d.length || c.length || s.length ? this.requestFrame() : this.ticking = !1;
  }
  flushAllFrames() {
    this.active && this.executeFrame(-1);
  }
  schedule() {
    this.active && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    Le(this.beans, e);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
}, HC = {
  moduleName: "AnimationFrame",
  version: M,
  beans: [GC]
}, OC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "iconSvc";
  }
  createIconNoSpan(e, t) {
    return ye(e, this.beans, t?.column);
  }
}, BC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "touchSvc";
  }
  mockBodyContextMenu(e, t) {
    this.mockContextMenu(e, e.eBodyViewport, t);
  }
  mockHeaderContextMenu(e, t) {
    this.mockContextMenu(e, e.eGui, t);
  }
  mockRowContextMenu(e) {
    if (!kt())
      return;
    const t = (o, i, s) => {
      const { rowCtrl: n, cellCtrl: r } = e.getControlsForEventTarget(s?.target ?? null);
      r?.column && r.dispatchCellContextMenuEvent(s ?? null), this.beans.contextMenuSvc?.handleContextMenuMouseEvent(void 0, s, n, r);
    };
    this.mockContextMenu(e, e.element, t);
  }
  handleCellDoubleClick(e, t) {
    return (() => {
      if (!kt() || Bn("dblclick"))
        return !1;
      const i = Date.now(), s = i - e.lastIPadMouseClickEvent < 200;
      return e.lastIPadMouseClickEvent = i, s;
    })() ? (e.onCellDoubleClicked(t), t.preventDefault(), !0) : !1;
  }
  setupForHeader(e) {
    const { gos: t, sortSvc: o, menuSvc: i } = this.beans;
    if (t.get("suppressTouch"))
      return;
    const { params: s, eMenu: n, eFilterButton: r } = e, l = new Be(e.getGui(), !0);
    e.addDestroyFunc(() => l.destroy());
    const a = e.shouldSuppressMenuHide(), d = a && A(n) && s.enableMenu;
    let c = l;
    if (d && (c = new Be(n, !0), e.addDestroyFunc(() => c.destroy())), s.enableMenu || i?.isHeaderContextMenuEnabled(s.column)) {
      const u = d ? "tap" : "longTap", h = (g) => s.showColumnMenuAfterMouseClick(g.touchStart);
      e.addManagedListeners(c, { [u]: h }), e.addManagedListeners(l, { longTap: h });
    }
    if (s.enableSorting) {
      const u = (h) => {
        const g = h.touchStart.target;
        a && (n?.contains(g) || r?.contains(g)) || o?.progressSort(s.column, !1, "uiColumnSorted");
      };
      e.addManagedListeners(l, { tap: u });
    }
    if (s.enableFilterButton && r) {
      const u = new Be(r, !0);
      e.addManagedListeners(u, {
        tap: () => s.showFilter(r)
      }), e.addDestroyFunc(() => u.destroy());
    }
  }
  setupForHeaderGroup(e) {
    const t = e.params;
    if (this.beans.menuSvc?.isHeaderContextMenuEnabled(
      t.columnGroup.getProvidedColumnGroup()
    )) {
      const o = new Be(t.eGridHeader, !0), i = (s) => t.showColumnMenuAfterMouseClick(s.touchStart);
      e.addManagedListeners(o, { longTap: i }), e.addDestroyFunc(() => o.destroy());
    }
  }
  setupForHeaderGroupElement(e, t, o) {
    const i = new Be(t, !0);
    e.addManagedListeners(i, { tap: o }), e.addDestroyFunc(() => i.destroy());
  }
  mockContextMenu(e, t, o) {
    if (!kt())
      return;
    const i = new Be(t), s = (n) => {
      Bt(this.beans, n.touchEvent) && o(void 0, n.touchStart, n.touchEvent);
    };
    e.addManagedListeners(i, { longTap: s }), e.addDestroyFunc(() => i.destroy());
  }
}, VC = {
  moduleName: "Touch",
  version: M,
  beans: [BC]
}, WC = class extends b {
  constructor() {
    super(...arguments), this.beanName = "cellNavigation";
  }
  wireBeans(e) {
    this.rowSpanSvc = e.rowSpanSvc;
  }
  // returns null if no cell to focus on, ie at the end of the grid
  getNextCellToFocus(e, t, o = !1) {
    return o ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const o = e === w.UP, i = e === w.DOWN, s = e === w.LEFT;
    let n, r;
    const { pageBounds: l, gos: a, visibleCols: d, pinnedRowModel: c } = this.beans, { rowPinned: u } = t;
    if (o || i)
      u && c ? o ? r = 0 : r = u === "top" ? c.getPinnedTopRowCount() - 1 : c.getPinnedBottomRowCount() - 1 : r = o ? l.getFirstRow() : l.getLastRow(), n = t.column;
    else {
      const h = a.get("enableRtl");
      r = t.rowIndex, n = (s !== h ? d.allCols : [...d.allCols].reverse()).find(
        (p) => this.isCellGoodToFocusOn({
          rowIndex: r,
          rowPinned: null,
          column: p
        })
      );
    }
    return n ? {
      rowIndex: r,
      rowPinned: u,
      column: n
    } : null;
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let o = t, i = !1;
    for (; !i; ) {
      switch (e) {
        case w.UP:
          o = this.getCellAbove(o);
          break;
        case w.DOWN:
          o = this.getCellBelow(o);
          break;
        case w.RIGHT:
          o = this.gos.get("enableRtl") ? this.getCellToLeft(o) : this.getCellToRight(o);
          break;
        case w.LEFT:
          o = this.gos.get("enableRtl") ? this.getCellToRight(o) : this.getCellToLeft(o);
          break;
        default:
          o = null, F(8, { key: e });
          break;
      }
      o ? i = this.isCellGoodToFocusOn(o) : i = !0;
    }
    return o;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let o;
    const { pinnedRowModel: i, rowModel: s } = this.beans;
    switch (e.rowPinned) {
      case "top":
        o = i?.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        o = i?.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        o = s.getRow(e.rowIndex);
        break;
    }
    return o ? !this.isSuppressNavigable(t, o) : !1;
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColBefore(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColAfter(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellBelow(e) {
    if (!e)
      return null;
    const t = this.rowSpanSvc?.getCellEnd(e) ?? e, o = en(this.beans, t, !0);
    return o ? {
      rowIndex: o.rowIndex,
      column: e.column,
      rowPinned: o.rowPinned
    } : null;
  }
  getCellAbove(e) {
    if (!e)
      return null;
    const t = this.rowSpanSvc?.getCellStart(e) ?? e, o = Go(
      this.beans,
      {
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned
      },
      !0
    );
    return o ? {
      rowIndex: o.rowIndex,
      column: e.column,
      rowPinned: o.rowPinned
    } : null;
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    const { visibleCols: t, pagination: o } = this.beans, i = t.allCols;
    let s = e.rowIndex, n = e.rowPinned, r = t.getColAfter(e.column);
    if (!r) {
      r = i[0];
      const l = en(this.beans, e, !0);
      if (H(l) || !l.rowPinned && !(o?.isRowInPage(l.rowIndex) ?? !0))
        return null;
      s = l ? l.rowIndex : null, n = l ? l.rowPinned : null;
    }
    return { rowIndex: s, column: r, rowPinned: n };
  }
  getNextTabbedCellBackwards(e) {
    const { beans: t } = this, { visibleCols: o, pagination: i } = t, s = o.allCols;
    let n = e.rowIndex, r = e.rowPinned, l = o.getColBefore(e.column);
    if (!l) {
      l = G(s);
      const a = Go(t, { rowIndex: e.rowIndex, rowPinned: e.rowPinned }, !0);
      if (H(a) || !a.rowPinned && !(i?.isRowInPage(a.rowIndex) ?? !0))
        return null;
      n = a ? a.rowIndex : null, r = a ? a.rowPinned : null;
    }
    return { rowIndex: n, column: l, rowPinned: r };
  }
  isSuppressNavigable(e, t) {
    const { suppressNavigable: o } = e.colDef;
    if (typeof o == "boolean")
      return o;
    if (typeof o == "function") {
      const i = e.createColumnFunctionCallbackParams(t);
      return o(i);
    }
    return !1;
  }
};
function NC(e) {
  return e.focusSvc.getFocusedCell();
}
function zC(e) {
  return e.focusSvc.clearFocusedCell();
}
function _C(e, t, o, i) {
  e.focusSvc.setFocusedCell({ rowIndex: t, column: o, rowPinned: i, forceBrowserFocus: !0 });
}
function UC(e, t) {
  return e.navigation?.tabToNextCell(!1, t) ?? !1;
}
function $C(e, t) {
  return e.navigation?.tabToNextCell(!0, t) ?? !1;
}
function KC(e, t, o = !1) {
  const i = e.headerNavigation?.getHeaderPositionForColumn(t, o);
  i && e.focusSvc.focusHeaderPosition({ headerPosition: i });
}
var jC = class {
  constructor() {
    this.cellValidations = /* @__PURE__ */ new Map();
  }
  getCellValidation(e) {
    const { rowNode: t, column: o } = e || {};
    return this.cellValidations?.get(t)?.get(o);
  }
  hasCellValidation(e) {
    return !e?.rowNode || !e.column ? this.cellValidations.size > 0 : !!this.getCellValidation(e);
  }
  setCellValidation(e, t) {
    const { rowNode: o, column: i } = e;
    this.cellValidations.has(o) || this.cellValidations.set(o, /* @__PURE__ */ new Map()), this.cellValidations.get(o).set(i, t);
  }
  clearCellValidation(e) {
    const { rowNode: t, column: o } = e;
    this.cellValidations.get(t)?.delete(o);
  }
  setCellValidationMap(e) {
    this.cellValidations = e;
  }
  getCellValidationMap() {
    return this.cellValidations;
  }
  clearCellValidationMap() {
    this.cellValidations.clear();
  }
}, qC = class {
  constructor() {
    this.rowValidations = /* @__PURE__ */ new Map();
  }
  getRowValidation(e) {
    const { rowNode: t } = e || {};
    return this.rowValidations.get(t);
  }
  hasRowValidation(e) {
    return e?.rowNode ? !!this.getRowValidation(e) : this.rowValidations.size > 0;
  }
  setRowValidation({ rowNode: e }, t) {
    this.rowValidations.set(e, t);
  }
  clearRowValidation({ rowNode: e }) {
    this.rowValidations.delete(e);
  }
  setRowValidationMap(e) {
    this.rowValidations = e;
  }
  getRowValidationMap() {
    return this.rowValidations;
  }
  clearRowValidationMap() {
    this.rowValidations.clear();
  }
};
function YC(e, t = {}) {
  const { rowIndex: o, rowId: i, rowCtrl: s, rowPinned: n } = t;
  if (s)
    return s;
  const { rowModel: r, rowRenderer: l } = e;
  let { rowNode: a } = t;
  return a || (i ? a = Pg(e, i, n) : o != null && (a = r.getRow(o))), l.getRowCtrls(a ? [a] : [])?.[0];
}
function ZC(e, t = {}) {
  const { cellCtrl: o, colId: i, columnId: s, column: n } = t;
  if (o)
    return o;
  const r = e.colModel.getCol(i ?? s ?? QC(n)), l = t.rowCtrl ?? YC(e, t), a = l?.getCellCtrl(r) ?? void 0;
  if (a)
    return a;
  const d = t.rowNode ?? l?.rowNode;
  if (d)
    return e.rowRenderer.getCellCtrls([d], [r])?.[0];
}
function QC(e) {
  if (e)
    return typeof e == "string" ? e : e.getColId();
}
var Rl = Symbol("unedited");
function XC(e, t = {}) {
  const o = [], i = e.rowRenderer.getCellCtrls(t.rowNodes, t.columns);
  for (const s of i) {
    const n = s.comp?.getCellEditor();
    n && o.push({
      ctrl: s,
      editor: Ii(n)
    });
  }
  return o;
}
function JC(e, t, o) {
  const i = { editorValueExists: !1 };
  if (xl(e) && (t.getValidationErrors?.()?.length ?? 0) > 0 || o?.isCancelling)
    return i;
  if (o?.isStopping) {
    const n = t?.isCancelAfterEnd?.();
    if (n)
      return { ...i, isCancelAfterEnd: n };
  }
  return {
    editorValue: t.getValue(),
    editorValueExists: !0
  };
}
function em(e, t) {
  for (const o of e.editModelSvc?.getEditPositions() ?? []) {
    const i = ZC(e, o);
    if (!i)
      continue;
    const s = i.comp?.getCellEditor();
    if (!s)
      continue;
    const { editorValue: n, editorValueExists: r, isCancelAfterEnd: l } = JC(e, s, t);
    l && e.editModelSvc?.setEdit(o, { editorState: { isCancelAfterEnd: l } }), tm(e, o, n, void 0, !r);
  }
}
function tm(e, t, o, i, s, n) {
  const { editModelSvc: r, valueSvc: l } = e;
  if (!r)
    return;
  const { rowNode: a, column: d } = t;
  if (!(a && d))
    return;
  let c = r.getEdit(t, !0);
  c?.sourceValue || (c = r.setEdit(t, {
    sourceValue: l.getValue(d, a, void 0, "api"),
    pendingValue: c ? c.editorValue : Rl
  })), r.setEdit(t, {
    editorValue: s ? c.sourceValue : o
  });
}
function xl(e) {
  const { gos: t, colModel: o } = e, i = !!t.get("getFullRowEditValidationErrors"), s = o.getColumnDefs()?.filter((r) => r.editable).some(({ cellEditorParams: r }) => {
    const { minLength: l, maxLength: a, getValidationErrors: d, min: c, max: u } = r || {};
    return l !== void 0 || a !== void 0 || d !== void 0 || c !== void 0 || u !== void 0;
  }), n = e.gridApi.getCellEditorInstances().some((r) => r.getValidationElement || r.getValidationErrors);
  return s || i || n;
}
function _i(e, t) {
  if (!xl(e))
    return;
  const o = XC(e), i = new jC(), { ariaAnnounce: s, localeSvc: n, editModelSvc: r, gos: l } = e, a = l.get("editType") === "fullRow", c = Wn(n)("ariaValidationErrorPrefix", "Cell Editor Validation");
  for (const h of o) {
    const { ctrl: g, editor: p } = h, { rowNode: f, column: C } = g, m = p.getValidationErrors?.() ?? [], v = p.getValidationElement?.(!1) || !p.isPopup?.() && g.eGui;
    if (v) {
      const S = m != null && m.length > 0, D = S ? m.join(". ") : "";
      Zl(v, S), S && s.announceValue(`${c} ${m}`, "editorValidation"), v instanceof HTMLInputElement ? v.setCustomValidity(D) : v.classList.toggle("invalid", S);
    }
    m?.length > 0 && i.setCellValidation(
      {
        rowNode: f,
        column: C
      },
      {
        errorMessages: m
      }
    );
  }
  em(e, {}), r?.setCellValidationModel(i);
  const u = /* @__PURE__ */ new Set();
  for (const { ctrl: h } of o)
    u.add(h.rowCtrl);
  if (a) {
    const h = om(e);
    r?.setRowValidationModel(h);
  }
  for (const h of u.values()) {
    h.rowEditStyleFeature?.applyRowStyles();
    for (const g of h.getAllCellCtrls())
      g.tooltipFeature?.refreshTooltip(!0), g.editorTooltipFeature?.refreshTooltip(!0), g.editStyleFeature?.applyCellStyles?.();
  }
}
var om = (e) => {
  const t = new qC(), o = e.gos.get("getFullRowEditValidationErrors"), i = e.editModelSvc?.getEditMap();
  if (!i)
    return t;
  for (const s of i.keys()) {
    const n = i.get(s);
    if (!n)
      continue;
    const r = [], { rowIndex: l, rowPinned: a } = s;
    for (const c of n.keys()) {
      const u = n.get(c);
      if (!u)
        continue;
      const { editorValue: h, pendingValue: g, sourceValue: p } = u, f = h ?? (g === Rl ? void 0 : g) ?? p;
      r.push({
        column: c,
        colId: c.getColId(),
        rowIndex: l,
        rowPinned: a,
        oldValue: p,
        newValue: f
      });
    }
    const d = o?.({ editorsState: r }) ?? [];
    d.length > 0 && t.setRowValidation(
      {
        rowNode: s
      },
      { errorMessages: d }
    );
  }
  return t;
};
function im(e, t, o, { rowNode: i, column: s }, n) {
  return L(e.gos, {
    type: o,
    node: i,
    data: i.data,
    value: n,
    column: s,
    colDef: s.getColDef(),
    rowPinned: i.rowPinned,
    event: t,
    rowIndex: i.rowIndex
  });
}
function sm(e, t = !1) {
  return e === w.DELETE ? !0 : !t && e === w.BACKSPACE ? vr() : !1;
}
var nm = class extends b {
  constructor(e, t, o, i) {
    super(), this.cellCtrl = e, this.rowNode = o, this.rowCtrl = i, this.beans = t;
  }
  init() {
    this.eGui = this.cellCtrl.eGui;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case w.ENTER:
        this.onEnterKeyDown(e);
        break;
      case w.F2:
        this.onF2KeyDown(e);
        break;
      case w.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case w.TAB:
        this.onTabKeyDown(e);
        break;
      case w.BACKSPACE:
      case w.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case w.DOWN:
      case w.UP:
      case w.RIGHT:
      case w.LEFT:
        this.onNavigationKeyDown(e, t);
        break;
    }
  }
  onNavigationKeyDown(e, t) {
    const { cellCtrl: o, beans: i } = this;
    if (!i.editSvc?.isEditing(o, { withOpenEditor: !0 })) {
      if (e.shiftKey && o.isRangeSelectionEnabled())
        this.onShiftRangeSelect(e);
      else {
        const s = o.getFocusedCellPosition();
        i.navigation?.navigateToNextCell(e, t, s, !0);
      }
      e.preventDefault();
    }
  }
  onShiftRangeSelect(e) {
    const { rangeSvc: t, navigation: o } = this.beans;
    if (!t)
      return;
    const i = t.extendLatestRangeInDirection(e);
    i && (e.key === w.LEFT || e.key === w.RIGHT ? o?.ensureColumnVisible(i.column) : o?.ensureRowVisible(i.rowIndex));
  }
  onTabKeyDown(e) {
    this.beans.navigation?.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    const { cellCtrl: o, beans: i, rowNode: s } = this, { gos: n, rangeSvc: r, eventSvc: l, editSvc: a } = i;
    if (l.dispatchEvent({ type: "keyShortcutChangedCellStart" }), sm(e, n.get("enableCellEditingOnBackspace")) && !a?.isEditing(o, { withOpenEditor: !0 })) {
      if (r && ht(n))
        r.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
      else if (o.isCellEditable()) {
        const { column: d } = o, c = this.beans.valueSvc.getDeleteValue(d, s);
        s.setDataValue(d, c, "cellClear");
      }
    } else a?.isEditing(o, { withOpenEditor: !0 }) || i.editSvc?.startEditing(o, { startedEdit: !0, event: t });
    l.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
  }
  onEnterKeyDown(e) {
    const { cellCtrl: t, beans: o } = this, { editSvc: i, navigation: s } = o, n = i?.isEditing(t, { withOpenEditor: !0 }), r = t.rowNode, l = i?.isRowEditing(r, { withOpenEditor: !0 }), a = (d) => {
      i?.startEditing(d, {
        startedEdit: !0,
        event: e,
        source: "edit"
      }) && e.preventDefault();
    };
    if (n || l) {
      if (this.isCtrlEnter(e)) {
        i?.applyBulkEdit(t, o?.rangeSvc?.getCellRanges() || []);
        return;
      }
      if (_i(o), i?.checkNavWithValidation(void 0, e) === "block-stop")
        return;
      i?.isEditing(t, { withOpenEditor: !0 }) ? i?.stopEditing(t, {
        event: e,
        source: "edit"
      }) : l && !t.isCellEditable() ? i?.stopEditing({ rowNode: r }, { event: e, source: "edit" }) : a(t);
    } else if (o.gos.get("enterNavigatesVertically")) {
      const d = e.shiftKey ? w.UP : w.DOWN;
      s?.navigateToNextCell(null, d, t.cellPosition, !1);
    } else {
      if (i?.hasValidationErrors())
        return;
      i?.hasValidationErrors(t) && i.revertSingleCellEdit(t, !0), a(t);
    }
  }
  isCtrlEnter(e) {
    return (e.ctrlKey || e.metaKey) && e.key === w.ENTER;
  }
  onF2KeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: o }
    } = this;
    o?.isEditing() && (_i(this.beans), o?.checkNavWithValidation(void 0, e) === "block-stop") || o?.startEditing(t, { startedEdit: !0, event: e });
  }
  onEscapeKeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: o }
    } = this;
    o?.checkNavWithValidation(t, e) === "block-stop" && o.revertSingleCellEdit(t), o?.stopEditing(t, {
      event: e,
      cancel: !0
    });
  }
  processCharacter(e) {
    const o = e.target !== this.eGui, {
      beans: { editSvc: i },
      cellCtrl: s
    } = this;
    if (o || i?.isEditing(s, { withOpenEditor: !0 }))
      return;
    if (e.key === w.SPACE)
      this.onSpaceKeyDown(e);
    else if (i?.isCellEditable(s, "ui")) {
      if (i?.hasValidationErrors() && !i?.hasValidationErrors(s))
        return;
      i?.startEditing(s, { startedEdit: !0, event: e, source: "api" }), !s.editCompDetails?.params?.suppressPreventDefault && e.preventDefault();
    }
  }
  onSpaceKeyDown(e) {
    const { gos: t, editSvc: o } = this.beans, { rowNode: i } = this.cellCtrl;
    !o?.isEditing(this.cellCtrl, { withOpenEditor: !0 }) && ze(t) && this.beans.selectionSvc?.handleSelectionEvent(e, i, "spaceKey"), e.preventDefault();
  }
}, rm = class extends b {
  constructor(e, t, o) {
    super(), this.cellCtrl = e, this.column = o, this.beans = t;
  }
  onMouseEvent(e, t) {
    if (!xe(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
          break;
      }
  }
  onCellClicked(e) {
    if (this.beans.touchSvc?.handleCellDoubleClick(this, e))
      return;
    const { eventSvc: t, rangeSvc: o, editSvc: i, editModelSvc: s, frameworkOverrides: n, gos: r } = this.beans, l = e.ctrlKey || e.metaKey, { cellCtrl: a } = this, { column: d, cellPosition: c, rowNode: u } = a, h = go(r, d, u, e);
    o && l && !h && o.getCellRangeCount(c) > 1 && o.intersectLastRange(!0);
    const g = a.createEvent(e, "cellClicked");
    g.isEventHandlingSuppressed = h, t.dispatchEvent(g);
    const p = d.getColDef();
    if (p.onCellClicked && window.setTimeout(() => {
      n.wrapOutgoing(() => {
        p.onCellClicked(g);
      });
    }, 0), !h && s?.getState(a) !== "editing") {
      const f = i?.isEditing(), C = s?.getCellValidationModel().getCellValidationMap().size ?? 0, m = s?.getRowValidationModel().getRowValidationMap().size ?? 0;
      if (f && (C > 0 || m > 0))
        return;
      i?.shouldStartEditing(a, e) ? i?.startEditing(a, { event: e }) : i?.shouldStopEditing(a, e) && (this.beans.gos.get("editType") === "fullRow" ? i?.stopEditing(a, {
        event: e,
        source: "edit"
      }) : i?.stopEditing(void 0, {
        event: e,
        source: "edit"
      }));
    }
  }
  onCellDoubleClicked(e) {
    const { column: t, beans: o, cellCtrl: i } = this, { eventSvc: s, frameworkOverrides: n, editSvc: r, editModelSvc: l, gos: a } = o, d = go(a, i.column, i.rowNode, e), c = t.getColDef(), u = i.createEvent(
      e,
      "cellDoubleClicked"
    );
    if (u.isEventHandlingSuppressed = d, s.dispatchEvent(u), typeof c.onCellDoubleClicked == "function" && window.setTimeout(() => {
      n.wrapOutgoing(() => {
        c.onCellDoubleClicked(u);
      });
    }, 0), !d && r?.shouldStartEditing(i, e) && l?.getState(i) !== "editing") {
      const h = r?.isEditing(), g = l?.getCellValidationModel().getCellValidationMap().size ?? 0, p = l?.getRowValidationModel().getRowValidationMap().size ?? 0;
      if (h && (g > 0 || p > 0))
        return;
      r?.startEditing(i, { event: e });
    }
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: o, shiftKey: i } = e, s = e.target, { cellCtrl: n, beans: r } = this, { eventSvc: l, rangeSvc: a, rowNumbersSvc: d, focusSvc: c, gos: u, editSvc: h } = r, { column: g, rowNode: p, cellPosition: f } = n, C = go(u, g, p, e), m = () => {
      const y = n.createEvent(e, "cellMouseDown");
      y.isEventHandlingSuppressed = C, l.dispatchEvent(y);
    };
    if (C) {
      m();
      return;
    }
    if (this.isRightClickInExistingRange(e))
      return;
    const v = a && !a.isEmpty(), S = this.containsWidget(s), D = Te(g);
    if (d && D && !d.handleMouseDownOnCell(f, e)) {
      a && e.preventDefault(), e.stopImmediatePropagation();
      return;
    }
    if (!i || !v) {
      const y = h?.isEditing(n), x = u.get("enableCellTextSelection") && e.defaultPrevented, k = (ls() || x) && !y && !At(s) && !S;
      n.focusCell(k, e);
    }
    if (i && v && !c.isCellFocused(f)) {
      e.preventDefault();
      const y = c.getFocusedCell();
      if (y) {
        const { column: R, rowIndex: x, rowPinned: k } = y;
        h?.isEditing(y) && h?.stopEditing(y), c.setFocusedCell({
          column: R,
          rowIndex: x,
          rowPinned: k,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0,
          sourceEvent: e
        });
      }
    }
    if (!S) {
      if (a) {
        D && e.preventDefault();
        const y = Ls(r, e) && D;
        if (i)
          a.extendLatestRangeToCell(f);
        else if (!y) {
          const R = t || o;
          a.setRangeToCell(f, R);
        }
      }
      m();
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeSvc: t } = this.beans;
    if (t) {
      const o = t.isCellInAnyRange(this.cellCtrl.cellPosition), i = Ls(this.beans, e);
      if (o && i)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return tt(e, "ag-selection-checkbox", 3) || tt(e, "ag-drag-handle", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: o } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOut")), o?.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: o } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOver")), o?.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const t = this.cellCtrl.eGui, o = t.contains(e.target), i = t.contains(e.relatedTarget);
    return o && i;
  }
}, lm = class extends b {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.column, this.rowNode = e.rowNode;
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListeners(this.beans.eventSvc, { newColumnsLoaded: () => this.onNewColumnsLoaded() });
  }
  init() {
    this.eSetLeft = this.cellCtrl.getRootElement(), this.eContent = this.cellCtrl.eGui;
    const e = this.cellCtrl.getCellSpan();
    if (e || (this.setupColSpan(), this.setupRowSpan()), this.onLeftChanged(), this.onWidthChanged(), e || this._legacyApplyRowSpan(), e) {
      const t = this.refreshSpanHeight.bind(this, e);
      t(), this.addManagedListeners(this.beans.eventSvc, {
        paginationChanged: t,
        recalculateRowBounds: t,
        pinnedHeightChanged: t
      });
    }
  }
  refreshSpanHeight(e) {
    const t = e.getCellHeight();
    t != null && (this.eContent.style.height = `${t}px`);
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this._legacyApplyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    St(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListeners(this.beans.eventSvc, {
      // because we are col spanning, a reorder of the cols can change what cols we are spanning over
      displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
      // because we are spanning over multiple cols, we check for width any time any cols width changes.
      // this is expensive - really we should be explicitly checking only the cols we are spanning over
      // instead of every col, however it would be tricky code to track the cols we are spanning over, so
      // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
      displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
    }));
  }
  onWidthChanged() {
    if (!this.eContent)
      return;
    const e = this.getCellWidth();
    this.eContent.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const { column: e, rowNode: t } = this, o = e.getColSpan(t), i = [];
    if (o === 1)
      i.push(e);
    else {
      let s = e;
      const n = e.getPinned();
      for (let r = 0; s && r < o && (i.push(s), s = this.beans.visibleCols.getColAfter(s), !(!s || H(s) || n !== s.getPinned())); r++)
        ;
    }
    return i;
  }
  onLeftChanged() {
    if (!this.eSetLeft)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eSetLeft.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? e = G(this.colsSpanning) : e = this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.printLayout || this.column.getPinned() === "left")
      return e;
    const { visibleCols: t } = this.beans, o = t.getColsLeftWidth();
    if (this.column.getPinned() === "right") {
      const i = t.bodyWidth;
      return o + i + (e || 0);
    }
    return o + (e || 0);
  }
  _legacyApplyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const o = Bo(this.beans) * this.rowSpan;
    this.eContent.style.height = `${o}px`, this.eContent.style.zIndex = "1";
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, am = "ag-cell", dm = "ag-cell-auto-height", cm = "ag-cell-normal-height", um = "ag-cell-focus", hm = "ag-cell-first-right-pinned", gm = "ag-cell-last-left-pinned", pm = "ag-cell-not-inline-editing", fm = "ag-cell-wrap-text", Cm = 0, mo = class extends b {
  constructor(e, t, o, i) {
    super(), this.column = e, this.rowNode = t, this.rowCtrl = i, this.rangeFeature = void 0, this.rowResizeFeature = void 0, this.positionFeature = void 0, this.customStyleFeature = void 0, this.editStyleFeature = void 0, this.mouseListener = void 0, this.keyboardListener = void 0, this.suppressRefreshCell = !1, this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.focusEventWhileNotReady = null, this.hasBeenFocused = !1, this.hasEdit = !1, this.tooltipFeature = void 0, this.editorTooltipFeature = void 0, this.beans = o, this.gos = o.gos, this.editSvc = o.editSvc, this.hasEdit = !!o.editSvc;
    const { colId: s } = e;
    this.instanceId = s + "-" + Cm++, this.createCellPosition(), this.updateAndFormatValue(!1);
  }
  addFeatures() {
    const { beans: e } = this;
    this.positionFeature = new lm(this, e), this.customStyleFeature = e.cellStyles?.createCellCustomStyleFeature(this, e), this.editStyleFeature = e.editSvc?.createCellStyleFeature(this, e), this.mouseListener = new rm(this, e, this.column), this.keyboardListener = new nm(this, e, this.rowNode, this.rowCtrl), this.enableTooltipFeature();
    const { rangeSvc: t } = e;
    t && ht(e.gos) && (this.rangeFeature = t.createCellRangeFeature(e, this)), Te(this.column) && (this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(e, this));
  }
  isCellSpanning() {
    return !1;
  }
  getCellSpan() {
  }
  removeFeatures() {
    const e = this.beans.context;
    this.positionFeature = e.destroyBean(this.positionFeature), this.editorTooltipFeature = e.destroyBean(this.editorTooltipFeature), this.customStyleFeature = e.destroyBean(this.customStyleFeature), this.editStyleFeature = e.destroyBean(this.editStyleFeature), this.mouseListener = e.destroyBean(this.mouseListener), this.keyboardListener = e.destroyBean(this.keyboardListener), this.rangeFeature = e.destroyBean(this.rangeFeature), this.rowResizeFeature = e.destroyBean(this.rowResizeFeature), this.disableTooltipFeature();
  }
  enableTooltipFeature(e, t) {
    this.tooltipFeature = this.beans.tooltipSvc?.enableCellTooltipFeature(this, e, t);
  }
  disableTooltipFeature() {
    this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
  }
  enableEditorTooltipFeature(e) {
    this.editorTooltipFeature && this.disableEditorTooltipFeature(), this.editorTooltipFeature = this.beans.tooltipSvc?.setupCellEditorTooltip(this, e), _i(this.beans);
  }
  disableEditorTooltipFeature() {
    this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
  }
  setComp(e, t, o, i, s, n, r) {
    if (this.comp = e, this.eGui = t, this.printLayout = s, r ?? (r = this), this.addDomData(r), this.addFeatures(), r.addDestroyFunc(() => this.removeFeatures()), this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.setupFocus(), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(i, r), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), this.positionFeature?.init(), this.customStyleFeature?.setComp(e), this.editStyleFeature?.setComp(e), this.tooltipFeature?.refreshTooltip(), this.keyboardListener?.init(), this.rangeFeature?.setComp(e), this.rowResizeFeature?.refreshRowResizer(), n && this.isCellEditable() || this.hasEdit && this.editSvc?.isEditing(this, { withOpenEditor: !0 }) ? this.editSvc?.startEditing(this, {
      startedEdit: !1,
      source: "api",
      silent: !0,
      continueEditing: !0
    }) : this.showValue(!1, !0), this.onCompAttachedFuncs.length) {
      for (const l of this.onCompAttachedFuncs)
        l();
      this.onCompAttachedFuncs = [];
    }
  }
  setupAutoHeight(e, t) {
    this.isAutoHeight = this.beans.rowAutoHeight?.setupCellAutoHeight(this, e, t) ?? !1;
  }
  getCellAriaRole() {
    return this.column.getColDef().cellAriaRole ?? "gridcell";
  }
  isCellRenderer() {
    const e = this.column.getColDef();
    return e.cellRenderer != null || e.cellRendererSelector != null;
  }
  getValueToDisplay() {
    return this.valueFormatted ?? this.value;
  }
  getDeferLoadingCellRenderer() {
    const { beans: e, column: t } = this, { userCompFactory: o, ctrlsSvc: i, eventSvc: s } = e, n = t.getColDef(), r = this.createCellRendererParams();
    r.deferRender = !0;
    const l = Vs(o, n, r);
    if (i.getGridBodyCtrl()?.scrollFeature?.isScrolling()) {
      let a;
      const d = new _t((u) => {
        a = u;
      }), [c] = this.addManagedListeners(s, {
        bodyScrollEnd: () => {
          a(), c();
        }
      });
      return { loadingComp: l, onReady: d };
    }
    return { loadingComp: l, onReady: _t.resolve() };
  }
  showValue(e, t) {
    const { beans: o, column: i, rowNode: s, rangeFeature: n } = this, { userCompFactory: r } = o;
    let l = this.getValueToDisplay(), a;
    const d = s.stub && s.groupData?.[i.getId()] == null, c = i.getColDef();
    if (d || this.isCellRenderer()) {
      const u = this.createCellRendererParams();
      !d || Te(i) ? a = Bs(r, c, u) : a = Vs(r, c, u);
    }
    if (!a && !d && o.findSvc?.isMatch(s, i)) {
      const u = this.createCellRendererParams();
      a = Bs(
        r,
        { ...i.getColDef(), cellRenderer: "agFindCellRenderer" },
        u
      );
    }
    if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(s, { checkSiblings: !0 })) {
      const u = this.editSvc.prepDetailsDuringBatch(this, { compDetails: a, valueToDisplay: l });
      u && (u.compDetails ? a = u.compDetails : u.valueToDisplay && (l = u.valueToDisplay));
    }
    this.comp.setRenderDetails(a, l, e), this.customRowDragComp?.refreshVisibility(), !t && n && Le(o, () => n?.refreshHandle()), this.rowResizeFeature?.refreshRowResizer();
  }
  setupControlComps() {
    const e = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(e), !0), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.comp.setIncludeSelection(this.includeSelection), this.comp.setIncludeDndSource(this.includeDndSource), this.comp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  getCellValueClass() {
    const e = "ag-cell-value", t = this.column.getColDef().cellRenderer === "agCheckboxCellRenderer";
    let o = "";
    return t && (o = " ag-allow-overflow"), `${e}${o}`;
  }
  /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  isIncludeControl(e, t = !1) {
    return (this.rowNode.rowPinned == null || t && Qt(this.rowNode)) && !!e;
  }
  isCheckboxSelection(e) {
    const { rowSelection: t, groupDisplayType: o } = this.beans.gridOptions, i = Ro(t), s = He(this.column);
    return o === "custom" && i !== "selectionColumn" && s ? !1 : e.checkboxSelection || s && typeof t == "object" && rt(t);
  }
  refreshShouldDestroy() {
    const e = this.column.getColDef(), t = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(e), !0), o = this.includeRowDrag != this.isIncludeControl(e.rowDrag), i = this.includeDndSource != this.isIncludeControl(e.dndSource), s = this.isAutoHeight != this.column.isAutoHeight();
    return t || o || i || s;
  }
  onPopupEditorClosed() {
    const { editSvc: e } = this.beans;
    e?.isEditing(this, { withOpenEditor: !0 }) && e?.stopEditing(this, { source: e?.isBatchEditing() ? "ui" : "api" });
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(e = !1) {
    const { editSvc: t } = this.beans;
    return t?.stopEditing(this, { cancel: e, source: t?.isBatchEditing() ? "ui" : "api" }) ?? !1;
  }
  createCellRendererParams() {
    const {
      value: e,
      valueFormatted: t,
      column: o,
      rowNode: i,
      comp: s,
      eGui: n,
      beans: { valueSvc: r, gos: l, editSvc: a }
    } = this;
    return L(l, {
      value: e,
      valueFormatted: t,
      getValue: () => r.getValueForDisplay(o, i).value,
      setValue: (c) => a?.setDataValue({ rowNode: i, column: o }, c) || i.setDataValue(o, c),
      formatValue: this.formatValue.bind(this),
      data: i.data,
      node: i,
      pinned: o.getPinned(),
      colDef: o.getColDef(),
      column: o,
      refreshCell: this.refreshCell.bind(this),
      eGridCell: n,
      eParentOfValue: s.getParentOfValue(),
      registerRowDragger: (c, u, h, g) => this.registerRowDragger(c, u, g),
      setTooltip: (c, u) => {
        l.assertModuleRegistered("Tooltip", 3), this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(c, u), this.tooltipFeature?.refreshTooltip();
      }
    });
  }
  onCellChanged(e) {
    e.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(e) {
    if (this.refreshShouldDestroy() ? this.rowCtrl?.recreateCell(this) : this.refreshCell(e), this.hasEdit && this.editCompDetails) {
      const { editSvc: t, comp: o } = this;
      !o?.getCellEditor() && t.isEditing(this, { withOpenEditor: !0 }) && t.startEditing(this, { startedEdit: !1, source: "api", silent: !0 });
    }
  }
  // + stop editing {force: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  refreshCell({ force: e, suppressFlash: t, newData: o } = {}) {
    const {
      editStyleFeature: i,
      customStyleFeature: s,
      rowCtrl: { rowEditStyleFeature: n },
      beans: { cellFlashSvc: r, filterManager: l },
      column: a,
      comp: d,
      suppressRefreshCell: c,
      tooltipFeature: u
    } = this;
    if (c)
      return;
    const { field: h, valueGetter: g, showRowGroup: p, enableCellChangeFlash: f } = a.getColDef(), C = h == null && g == null && p == null, m = e || C || o, v = !!d, S = this.updateAndFormatValue(v), D = m || S;
    if (v) {
      if (D) {
        this.showValue(!!o, !1);
        const y = l?.isSuppressFlashingCellsBecauseFiltering();
        !t && !y && f && r?.flashCell(this), i?.applyCellStyles?.(), s?.applyUserStyles(), s?.applyClassesFromColDef(), n?.applyRowStyles();
      }
      u?.refreshTooltip(), s?.applyCellClassRules();
    }
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  formatValue(e) {
    return this.callValueFormatter(e) ?? e;
  }
  callValueFormatter(e) {
    return this.beans.valueSvc.formatValue(this.column, this.rowNode, e);
  }
  updateAndFormatValue(e) {
    const t = this.value, o = this.valueFormatted, { value: i, valueFormatted: s } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, !0);
    return this.value = i, this.valueFormatted = s, e ? !this.valuesAreEqual(t, this.value) || this.valueFormatted != o : !0;
  }
  valuesAreEqual(e, t) {
    const o = this.column.getColDef();
    return o.equals ? o.equals(e, t) : e === t;
  }
  addDomData(e) {
    const t = this.eGui;
    ut(this.beans.gos, t, ko, this), e.addDestroyFunc(() => ut(this.beans.gos, t, ko, null));
  }
  createEvent(e, t) {
    const { rowNode: o, column: i, value: s, beans: n } = this;
    return im(n, e, t, { rowNode: o, column: i }, s);
  }
  processCharacter(e) {
    this.keyboardListener?.processCharacter(e);
  }
  onKeyDown(e) {
    this.keyboardListener?.onKeyDown(e);
  }
  onMouseEvent(e, t) {
    this.mouseListener?.onMouseEvent(e, t);
  }
  getColSpanningList() {
    return this.positionFeature?.getColSpanningList() ?? [];
  }
  onLeftChanged() {
    this.comp && this.positionFeature?.onLeftChanged();
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { comp: e, column: t, beans: o } = this;
    $r(e, t, o.visibleCols);
  }
  refreshAriaColIndex() {
    const e = this.beans.visibleCols.getAriaColIndex(this.column);
    En(this.eGui, e);
  }
  onWidthChanged() {
    return this.positionFeature?.onWidthChanged();
  }
  getRowPosition() {
    const { rowIndex: e, rowPinned: t } = this.cellPosition;
    return {
      rowIndex: e,
      rowPinned: t
    };
  }
  updateRangeBordersIfRangeCount() {
    this.comp && this.rangeFeature?.updateRangeBordersIfRangeCount();
  }
  onCellSelectionChanged() {
    this.comp && this.rangeFeature?.onCellSelectionChanged();
  }
  isRangeSelectionEnabled() {
    return this.rangeFeature != null;
  }
  focusCell(e = !1, t) {
    const o = this.editSvc?.allowedFocusTargetOnValidation(this);
    o && o !== this || this.beans.focusSvc.setFocusedCell({
      ...this.getFocusedCellPosition(),
      forceBrowserFocus: e,
      sourceEvent: t
    });
  }
  /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */
  restoreFocus(e = !1) {
    const {
      beans: { editSvc: t, focusSvc: o },
      comp: i
    } = this;
    if (!i || t?.isEditing(this) || !this.isCellFocused() || !o.shouldTakeFocus())
      return;
    const s = () => {
      if (!this.isAlive())
        return;
      const n = i.getFocusableElement();
      this.isCellFocused() && n.focus({ preventScroll: !0 });
    };
    if (e) {
      setTimeout(s, 0);
      return;
    }
    s();
  }
  onRowIndexChanged() {
    this.createCellPosition(), this.onCellFocused(), this.restoreFocus(), this.rangeFeature?.onCellSelectionChanged(), this.rowResizeFeature?.refreshRowResizer();
  }
  onSuppressCellFocusChanged(e) {
    const t = this.eGui;
    t && (Te(this.column) && (e = !0), Ve(t, "tabindex", e ? void 0 : -1));
  }
  onFirstRightPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isFirstRightPinned();
    this.comp.toggleCss(hm, e);
  }
  onLastLeftPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isLastLeftPinned();
    this.comp.toggleCss(gm, e);
  }
  /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */
  checkCellFocused() {
    return this.beans.focusSvc.isCellFocused(this.cellPosition);
  }
  isCellFocused() {
    const e = this.checkCellFocused();
    return this.hasBeenFocused || (this.hasBeenFocused = e), e;
  }
  setupFocus() {
    this.restoreFocus(!0), this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
  }
  onCellFocused(e) {
    const { beans: t } = this;
    if (fs(t))
      return;
    if (!this.comp) {
      e && (this.focusEventWhileNotReady = e);
      return;
    }
    const o = this.isCellFocused(), i = t.editSvc?.isEditing(this) ?? !1;
    if (this.comp.toggleCss(um, o), o && e?.forceBrowserFocus) {
      let s = this.comp.getFocusableElement();
      if (i) {
        const n = at(s, null, !0);
        n.length && (s = n[0]);
      }
      s.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
    }
    o && e && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    const { rowIndex: e, rowPinned: t } = this.rowNode;
    this.cellPosition = {
      rowIndex: e,
      rowPinned: Ne(t),
      column: this.column
    };
  }
  // CSS Classes that only get applied once, they never change
  applyStaticCssClasses() {
    const { comp: e } = this;
    e.toggleCss(am, !0), e.toggleCss(pm, !0);
    const t = this.column.isAutoHeight() == !0;
    e.toggleCss(dm, t), e.toggleCss(cm, !t);
  }
  onColumnHover() {
    this.beans.colHover?.onCellColumnHover(this.column, this.comp);
  }
  onColDefChanged() {
    this.comp && (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), this.editSvc?.isEditing(this) ? this.editSvc?.handleColDefChanged(this) : this.refreshOrDestroyCell({ force: !0, suppressFlash: !0 }));
  }
  setWrapText() {
    const e = this.column.getColDef().wrapText == !0;
    this.comp.toggleCss(fm, e);
  }
  dispatchCellContextMenuEvent(e) {
    const t = this.column.getColDef(), o = this.createEvent(e, "cellContextMenu"), { beans: i } = this;
    i.eventSvc.dispatchEvent(o), t.onCellContextMenu && window.setTimeout(() => {
      i.frameworkOverrides.wrapOutgoing(() => {
        t.onCellContextMenu(o);
      });
    }, 0);
  }
  getCellRenderer() {
    return this.comp?.getCellRenderer() ?? null;
  }
  destroy() {
    this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.isCellFocused() && this.hasBrowserFocus() && this.beans.focusSvc.attemptToRecoverFocus(), super.destroy();
  }
  hasBrowserFocus() {
    return this.eGui?.contains(N(this.beans)) ?? !1;
  }
  createSelectionCheckbox() {
    const e = this.beans.selectionSvc?.createCheckboxSelectionComponent();
    if (e)
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
  }
  createDndSource() {
    const e = this.beans.registry.createDynamicBean(
      "dndSourceComp",
      !1,
      this.rowNode,
      this.column,
      this.eGui
    );
    return e && this.beans.context.createBean(e), e;
  }
  registerRowDragger(e, t, o) {
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(e, t);
      return;
    }
    const i = this.createRowDragComp(e, t, o);
    i && (this.customRowDragComp = i, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(i), this.customRowDragComp = null;
    }), i.refreshVisibility());
  }
  createRowDragComp(e, t, o) {
    const i = this.beans.rowDragSvc?.createRowDragCompForCell(
      this.rowNode,
      this.column,
      () => this.value,
      e,
      t,
      o
    );
    if (i)
      return this.beans.context.createBean(i), i;
  }
  cellEditorAttached() {
    for (const e of this.onEditorAttachedFuncs)
      e();
    this.onEditorAttachedFuncs = [];
  }
  setFocusedCellPosition(e) {
  }
  getFocusedCellPosition() {
    return this.cellPosition;
  }
  // used by spannedCellCtrl
  refreshAriaRowIndex() {
  }
  /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */
  getRootElement() {
    return this.eGui;
  }
};
function Pl(e, t, o, i, s, n) {
  if (o == null && t == null)
    return;
  const r = {}, l = {}, a = (d, c) => {
    for (const u of d.split(" "))
      u.trim() != "" && c(u);
  };
  if (o) {
    const d = Object.keys(o);
    for (let c = 0; c < d.length; c++) {
      const u = d[c], h = o[u];
      let g;
      typeof h == "string" ? g = e ? e.evaluate(h, i) : !0 : typeof h == "function" && (g = h(i)), a(u, (p) => {
        g ? r[p] = !0 : l[p] = !0;
      });
    }
  }
  if (t && n)
    for (const d of Object.keys(t))
      a(d, (c) => {
        r[c] || (l[c] = !0);
      });
  n && Object.keys(l).forEach(n), Object.keys(r).forEach(s);
}
function gn(e) {
  if (e.group)
    return e.level;
  const t = e.parent;
  return t ? t.level + 1 : 0;
}
var mm = 0, Ui = class extends b {
  constructor(e, t, o, i, s) {
    super(), this.rowNode = e, this.useAnimationFrameForCreate = i, this.printLayout = s, this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.fadeInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKey = null, this.beans = t, this.gos = t.gos, this.paginationPage = t.pagination?.getCurrentPage() ?? 0, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = e.id + "-" + mm++, this.rowId = Et(e.id), this.initRowBusinessKey(), this.rowFocused = t.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = gn(this.rowNode), this.setRowType(), this.setAnimateFlags(o), this.rowStyles = this.processStylesFromGridOptions(), this.rowEditStyleFeature = t.editSvc?.createRowStyleFeature(this, t), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const e = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKey = Et(e);
  }
  updateGui(e, t) {
    e === "left" ? this.leftGui = t : e === "right" ? this.rightGui = t : e === "fullWidth" ? this.fullWidthGui = t : this.centerGui = t;
  }
  setComp(e, t, o, i) {
    const { context: s, focusSvc: n } = this.beans;
    i = Wo(this, s, i);
    const r = { rowComp: e, element: t, containerType: o, compBean: i };
    this.allRowGuis.push(r), this.updateGui(o, r), this.initialiseRowComp(r);
    const l = this.rowNode, a = this.rowType === "FullWidthLoading" || l.stub, d = !l.data && this.beans.rowModel.getType() === "infinite";
    !a && !d && !l.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    const c = this.fullWidthGui?.element;
    c && !this.beans.editSvc?.isEditing(this) && n.isRowFocused(l.rowIndex, l.rowPinned) && n.shouldTakeFocus() && setTimeout(() => c.focus({ preventScroll: !0 }), 0);
  }
  unsetComp(e) {
    this.allRowGuis = this.allRowGuis.filter((t) => t.containerType !== e), this.updateGui(e, void 0);
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(e) {
    const t = e ? "none" : "";
    for (const o of this.allRowGuis)
      o.element.style.display = t;
  }
  initialiseRowComp(e) {
    const t = this.gos;
    this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.listenOnDomOrder(e), this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(!1, e), ze(t) && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const o = e.rowComp, i = this.getInitialRowClasses(e.containerType);
    for (const s of i)
      o.toggleCss(s, !0);
    this.executeSlideAndFadeAnimations(e), this.rowNode.group && Si(e.element, this.rowNode.expanded == !0), this.setRowCompRowId(o), this.setRowCompRowBusinessKey(o), ut(t, e.element, Lo, this), e.compBean.addDestroyFunc(() => ut(t, e.element, Lo, null)), this.useAnimationFrameForCreate ? this.beans.animationFrameSvc.createTask(
      this.addHoverFunctionality.bind(this, e),
      this.rowNode.rowIndex,
      "p2",
      !1
    ) : this.addHoverFunctionality(e), this.isFullWidth() && this.setupFullWidth(e), t.get("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameSvc.addDestroyTask(() => {
      this.isAlive() && e.rowComp.toggleCss("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(e) {
    this.businessKey != null && e.setRowBusinessKey(this.businessKey);
  }
  setRowCompRowId(e) {
    const t = Et(this.rowNode.id);
    this.rowId = t, t != null && e.setRowId(t);
  }
  executeSlideAndFadeAnimations(e) {
    const { containerType: t } = e;
    this.slideInAnimation[t] && (Ri(() => {
      this.onTopChanged();
    }), this.slideInAnimation[t] = !1), this.fadeInAnimation[t] && (Ri(() => {
      e.rowComp.toggleCss("ag-opacity-zero", !1);
    }), this.fadeInAnimation[t] = !1);
  }
  addRowDraggerToRow(e) {
    const t = this.beans.rowDragSvc?.createRowDragCompForRow(this.rowNode, e.element);
    if (!t)
      return;
    const o = this.createBean(t, this.beans.context);
    this.rowDragComps.push(o), e.compBean.addDestroyFunc(() => {
      this.rowDragComps = this.rowDragComps.filter((i) => i !== o), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context), this.destroyBean(o, this.beans.context);
    });
  }
  setupFullWidth(e) {
    const t = this.getPinnedForContainer(e.containerType), o = this.createFullWidthCompDetails(e.element, t);
    e.rowComp.showFullWidth(o);
  }
  getFullWidthCellRenderers() {
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((e) => e?.rowComp?.getFullWidthCellRenderer()) : [this.fullWidthGui?.rowComp?.getFullWidthCellRenderer()];
  }
  executeProcessRowPostCreateFunc() {
    const e = this.gos.getCallback("processRowPostCreate");
    if (!e || !this.areAllContainersReady())
      return;
    const t = {
      // areAllContainersReady asserts that centerGui is not null
      eRow: this.centerGui.element,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
      node: this.rowNode,
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this)
    };
    e(t);
  }
  areAllContainersReady() {
    const {
      leftGui: e,
      centerGui: t,
      rightGui: o,
      beans: { visibleCols: i }
    } = this, s = !!e || !i.isPinningLeft(), n = !!t, r = !!o || !i.isPinningRight();
    return s && n && r;
  }
  isNodeFullWidthCell() {
    if (this.rowNode.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this.rowNode }) : !1;
  }
  setRowType() {
    const e = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents"), t = this.isNodeFullWidthCell(), o = this.gos.get("masterDetail") && this.rowNode.detail, i = this.beans.colModel.isPivotMode(), s = Ya(this.gos, this.rowNode, i);
    e ? this.rowType = "FullWidthLoading" : o ? this.rowType = "FullWidthDetail" : t ? this.rowType = "FullWidth" : s ? this.rowType = "FullWidthGroup" : this.rowType = "Normal";
  }
  updateColumnLists(e = !1, t = !1) {
    if (this.isFullWidth())
      return;
    const { animationFrameSvc: o } = this.beans;
    if (!o?.active || e || this.printLayout) {
      this.updateColumnListsImpl(t);
      return;
    }
    this.updateColumnListsPending || (o.createTask(
      () => {
        this.active && this.updateColumnListsImpl(!0);
      },
      this.rowNode.rowIndex,
      "p1",
      !1
    ), this.updateColumnListsPending = !0);
  }
  /**
   * Overridden by SpannedRowCtrl
   */
  getNewCellCtrl(e) {
    if (!this.beans.rowSpanSvc?.isCellSpanning(e, this.rowNode))
      return new mo(e, this.rowNode, this.beans, this);
  }
  /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */
  isCorrectCtrlForSpan(e) {
    return !this.beans.rowSpanSvc?.isCellSpanning(e.column, this.rowNode);
  }
  createCellCtrls(e, t, o = null) {
    const i = {
      list: [],
      map: {}
    }, s = (d, c, u) => {
      u != null ? i.list.splice(u, 0, c) : i.list.push(c), i.map[d] = c;
    }, n = [];
    for (const d of t) {
      const c = d.getInstanceId();
      let u = e.map[c];
      u && !this.isCorrectCtrlForSpan(u) && (u.destroy(), u = void 0), u || (u = this.getNewCellCtrl(d)), u && s(c, u);
    }
    for (const d of e.list) {
      const c = d.column.getInstanceId();
      if (i.map[c] != null)
        continue;
      !this.isCellEligibleToBeRemoved(d, o) ? n.push([c, d]) : d.destroy();
    }
    if (n.length)
      for (const [d, c] of n) {
        const u = i.list.findIndex((g) => g.column.getLeft() > c.column.getLeft()), h = u === -1 ? void 0 : Math.max(u - 1, 0);
        s(d, c, h);
      }
    const { focusSvc: r, visibleCols: l } = this.beans, a = r.getFocusedCell();
    if (a && a.column.getPinned() == o) {
      const d = a.column.getInstanceId();
      if (!i.map[d] && l.allCols.includes(a.column)) {
        const u = this.createFocusedCellCtrl();
        if (u) {
          const h = i.list.findIndex((p) => p.column.getLeft() > u.column.getLeft()), g = h === -1 ? void 0 : Math.max(h - 1, 0);
          s(d, u, g);
        }
      }
    }
    return i;
  }
  /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */
  createFocusedCellCtrl() {
    const { focusSvc: e, rowSpanSvc: t } = this.beans, o = e.getFocusedCell();
    if (!o)
      return;
    const i = t?.getCellSpan(o.column, this.rowNode);
    if (i) {
      if (i.firstNode !== this.rowNode || !i.doesSpanContain(o))
        return;
    } else if (!e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned))
      return;
    return this.getNewCellCtrl(o.column);
  }
  updateColumnListsImpl(e) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(e);
  }
  setCellCtrls(e) {
    for (const t of this.allRowGuis) {
      const o = this.getCellCtrlsForContainer(t.containerType);
      t.rowComp.setCellCtrls(o, e);
    }
  }
  getCellCtrlsForContainer(e) {
    switch (e) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
    }
  }
  createAllCellCtrls() {
    const e = this.beans.colViewport, t = this.beans.visibleCols;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, t.allCols), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const o = e.getColsWithinViewport(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, o);
      const i = t.getLeftColsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, i, "left");
      const s = t.getRightColsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, s, "right");
    }
  }
  isCellEligibleToBeRemoved(e, t) {
    const { column: s } = e;
    if (s.getPinned() != t || !this.isCorrectCtrlForSpan(e))
      return !0;
    const { visibleCols: n, editSvc: r } = this.beans, l = r?.isEditing(e), a = e.isCellFocused();
    return l || a ? !(n.allCols.indexOf(s) >= 0) : !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || Y(this.gos, "print");
  }
  listenOnDomOrder(e) {
    const t = () => {
      e.rowComp.setDomOrder(this.getDomOrder());
    };
    e.compBean.addManagedPropertyListeners(["domLayout", "ensureDomOrder"], t);
  }
  setAnimateFlags(e) {
    if (this.rowNode.sticky || !e)
      return;
    const t = A(this.rowNode.oldRowTop), { visibleCols: o } = this.beans, i = o.isPinningLeft(), s = o.isPinningRight();
    if (t) {
      const { slideInAnimation: n } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        n.fullWidth = !0;
        return;
      }
      n.center = !0, n.left = i, n.right = s;
    } else {
      const { fadeInAnimation: n } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        n.fullWidth = !0;
        return;
      }
      n.center = !0, n.left = i, n.right = s;
    }
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const e = (r, l) => r ? r.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(r.element, l).params) : !0, t = e(this.fullWidthGui, null), o = e(this.centerGui, null), i = e(this.leftGui, "left"), s = e(this.rightGui, "right");
    return t && o && i && s;
  }
  addListeners() {
    const { beans: e, gos: t, rowNode: o } = this, { expansionSvc: i, eventSvc: s, context: n, rowSpanSvc: r } = e;
    this.addManagedListeners(this.rowNode, {
      heightChanged: () => this.onRowHeightChanged(),
      rowSelected: () => this.onRowSelected(),
      rowIndexChanged: this.onRowIndexChanged.bind(this),
      topChanged: this.onTopChanged.bind(this),
      ...i?.getRowExpandedListeners(this) ?? {}
    }), o.detail && this.addManagedListeners(o.parent, { dataChanged: this.onRowNodeDataChanged.bind(this) }), this.addManagedListeners(o, {
      dataChanged: this.onRowNodeDataChanged.bind(this),
      cellChanged: this.postProcessCss.bind(this),
      rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
      draggingChanged: this.postProcessRowDragging.bind(this),
      uiLevelChanged: this.onUiLevelChanged.bind(this),
      rowPinned: this.onRowPinned.bind(this)
    }), this.addManagedListeners(s, {
      paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
      heightScaleChanged: this.onTopChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
      cellFocused: this.onCellFocusChanged.bind(this),
      cellFocusCleared: this.onCellFocusChanged.bind(this),
      paginationChanged: this.onPaginationChanged.bind(this),
      modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
      columnMoved: () => this.updateColumnLists()
    }), r && this.addManagedListeners(r, {
      spannedCellsUpdated: ({ pinned: l }) => {
        l && !o.rowPinned || this.updateColumnLists();
      }
    }), this.addDestroyFunc(() => {
      this.rowDragComps = this.destroyBeans(this.rowDragComps, n), this.tooltipFeature = this.destroyBean(this.tooltipFeature, n), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, n);
    }), this.addManagedPropertyListeners(
      ["rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules"],
      this.postProcessCss.bind(this)
    ), this.addManagedPropertyListener("rowDragEntireRow", () => {
      if (t.get("rowDragEntireRow")) {
        for (const a of this.allRowGuis)
          this.addRowDraggerToRow(a);
        return;
      }
      this.rowDragComps = this.destroyBeans(this.rowDragComps, n);
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListeners(this.rowNode, {
      rowIndexChanged: () => {
        for (const e of this.getAllCellCtrls())
          e.onRowIndexChanged();
      },
      cellChanged: (e) => {
        for (const t of this.getAllCellCtrls())
          t.onCellChanged(e);
      }
    });
  }
  /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */
  onRowPinned() {
    for (const e of this.allRowGuis)
      e.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
  }
  onRowNodeDataChanged(e) {
    this.refreshRow({
      suppressFlash: !e.update,
      newData: !e.update
    });
  }
  refreshRow(e) {
    if (this.isFullWidth() !== !!this.isNodeFullWidthCell()) {
      this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    if (this.isFullWidth()) {
      this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    for (const o of this.getAllCellCtrls())
      o.refreshCell(e);
    for (const o of this.allRowGuis)
      this.setRowCompRowId(o.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(o.rowComp);
    this.onRowSelected(), this.postProcessCss();
  }
  postProcessCss() {
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.rowEditStyleFeature?.applyRowStyles(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const e = this.beans.rowDropHighlightSvc, t = e?.row === this.rowNode ? e.position : "none", o = t === "above", i = t === "inside", s = t === "below", r = this.gos.get("treeData") && (s || o), l = this.rowNode.uiLevel.toString();
    for (const a of this.allRowGuis) {
      const d = a.rowComp;
      d.toggleCss("ag-row-highlight-above", o), d.toggleCss("ag-row-highlight-inside", i), d.toggleCss("ag-row-highlight-below", s), d.toggleCss("ag-row-highlight-indent", r), r ? a.element.style.setProperty("--ag-row-highlight-level", l) : a.element.style.removeProperty("--ag-row-highlight-level");
    }
  }
  postProcessRowDragging() {
    const e = this.rowNode.dragging;
    for (const t of this.allRowGuis)
      t.rowComp.toggleCss("ag-row-dragging", e);
  }
  onDisplayedColumnsChanged() {
    this.updateColumnLists(!0), this.beans.rowAutoHeight?.requestCheckAutoHeight();
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return {
      rowPinned: Ne(this.rowNode.rowPinned),
      rowIndex: this.rowNode.rowIndex
    };
  }
  onKeyboardNavigate(e) {
    const t = this.findFullWidthInfoForEvent(e);
    if (!t)
      return;
    const { rowGui: o, column: i } = t;
    if (!(o.element === e.target))
      return;
    const r = this.rowNode, { focusSvc: l, navigation: a } = this.beans, d = l.getFocusedCell(), c = {
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: d?.column ?? i
    };
    a?.navigateToNextCell(e, e.key, c, !0), e.preventDefault();
  }
  onTabKeyDown(e) {
    if (e.defaultPrevented || xe(e))
      return;
    const t = this.allRowGuis.find(
      (l) => l.element.contains(e.target)
    ), o = t ? t.element : null, i = o === e.target, s = N(this.beans);
    let n = !1;
    o && s && (n = o.contains(s) && s.classList.contains("ag-cell"));
    let r = null;
    !i && !n && (r = qt(this.beans, o, !1, e.shiftKey)), (this.isFullWidth() && i || !r) && this.beans.navigation?.onTabKeyDown(this, e);
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    const e = this.allRowGuis.find((t) => ke(t.element))?.element;
    return e ? e.getBoundingClientRect().top : 0;
  }
  onSuppressCellFocusChanged(e) {
    const t = this.isFullWidth() && e ? void 0 : this.gos.get("tabIndex");
    for (const o of this.allRowGuis)
      Ve(o.element, "tabindex", t);
  }
  onFullWidthRowFocused(e) {
    const t = this.rowNode, o = e ? this.isFullWidth() && e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned : !1;
    let i;
    if (this.fullWidthGui)
      i = this.fullWidthGui.element;
    else {
      const n = this.beans.colModel.getCol(e?.column)?.pinned;
      n ? i = n === "right" ? this.rightGui?.element : this.leftGui?.element : i = this.centerGui?.element;
    }
    i && (i.classList.toggle("ag-full-width-focus", o), o && e?.forceBrowserFocus && i.focus({ preventScroll: !0 }));
  }
  recreateCell(e) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), e.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(e, t) {
    const o = {
      list: [],
      map: {}
    };
    for (const i of e.list)
      i !== t && (o.list.push(i), o.map[i.column.getInstanceId()] = i);
    return o;
  }
  onMouseEvent(e, t) {
    switch (e) {
      case "dblclick":
        this.onRowDblClick(t);
        break;
      case "click":
        this.onRowClick(t);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(t);
        break;
    }
  }
  createRowEvent(e, t) {
    const { rowNode: o } = this;
    return L(this.gos, {
      type: e,
      node: o,
      data: o.data,
      rowIndex: o.rowIndex,
      rowPinned: o.rowPinned,
      event: t
    });
  }
  createRowEventWithSource(e, t) {
    const o = this.createRowEvent(e, t);
    return o.source = this, o;
  }
  onRowDblClick(e) {
    if (xe(e))
      return;
    const t = this.createRowEventWithSource("rowDoubleClicked", e);
    t.isEventHandlingSuppressed = this.isSuppressMouseEvent(e), this.beans.eventSvc.dispatchEvent(t);
  }
  findFullWidthInfoForEvent(e) {
    if (!e)
      return;
    const t = this.findFullWidthRowGui(e.target), o = this.getColumnForFullWidth(t);
    if (!(!t || !o))
      return { rowGui: t, column: o };
  }
  findFullWidthRowGui(e) {
    return this.allRowGuis.find((t) => t.element.contains(e));
  }
  getColumnForFullWidth(e) {
    const { visibleCols: t } = this.beans;
    switch (e?.containerType) {
      case "center":
        return t.centerCols[0];
      case "left":
        return t.leftCols[0];
      case "right":
        return t.rightCols[0];
      default:
        return t.allCols[0];
    }
  }
  onRowMouseDown(e) {
    if (this.lastMouseDownOnDragger = tt(e.target, "ag-row-drag", 3), !this.isFullWidth() || this.isSuppressMouseEvent(e))
      return;
    const { rangeSvc: t, focusSvc: o } = this.beans;
    t?.removeAllCellRanges();
    const i = this.findFullWidthInfoForEvent(e);
    if (!i)
      return;
    const { rowGui: s, column: n } = i, r = s.element, l = e.target, a = this.rowNode;
    let d = e.defaultPrevented || ls();
    r && r.contains(l) && At(l) && (d = !1), o.setFocusedCell({
      rowIndex: a.rowIndex,
      column: n,
      rowPinned: a.rowPinned,
      forceBrowserFocus: d
    });
  }
  isSuppressMouseEvent(e) {
    const { gos: t, rowNode: o } = this;
    if (this.isFullWidth()) {
      const s = this.findFullWidthRowGui(e.target);
      return bu(
        t,
        s?.rowComp.getFullWidthCellRendererParams(),
        o,
        e
      );
    }
    const i = ps(t, e.target);
    return i != null && go(t, i.column, o, e);
  }
  onRowClick(e) {
    if (xe(e) || this.lastMouseDownOnDragger)
      return;
    const o = this.isSuppressMouseEvent(e), { eventSvc: i, selectionSvc: s } = this.beans, n = this.createRowEventWithSource("rowClicked", e);
    n.isEventHandlingSuppressed = o, i.dispatchEvent(n), !o && s?.handleSelectionEvent(e, this.rowNode, "rowClicked");
  }
  setupDetailRowAutoHeight(e) {
    this.rowType === "FullWidthDetail" && this.beans.masterDetailSvc?.setupDetailRowAutoHeight(this, e);
  }
  createFullWidthCompDetails(e, t) {
    const { gos: o, rowNode: i } = this, s = L(o, {
      fullWidth: !0,
      data: i.data,
      node: i,
      value: i.key,
      valueFormatted: i.key,
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: e,
      eParentOfValue: e,
      pinned: t,
      addRenderedRowListener: this.addEventListener.bind(this),
      // This is not on the type of ICellRendererParams
      registerRowDragger: (r, l, a, d) => this.addFullWidthRowDragging(r, l, a, d),
      setTooltip: (r, l) => {
        o.assertModuleRegistered("Tooltip", 3), this.setupFullWidthRowTooltip(r, l);
      }
    }), n = this.beans.userCompFactory;
    switch (this.rowType) {
      case "FullWidthDetail":
        return Jd(n, s);
      case "FullWidthGroup": {
        const { value: r, valueFormatted: l } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, !0);
        return s.value = r, s.valueFormatted = l, Xd(n, s);
      }
      case "FullWidthLoading":
        return Qd(n, s);
      default:
        return Zd(n, s);
    }
  }
  setupFullWidthRowTooltip(e, t) {
    this.fullWidthGui && (this.tooltipFeature = this.beans.tooltipSvc?.setupFullWidthRowTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    ));
  }
  addFullWidthRowDragging(e, t, o = "", i) {
    const { rowDragSvc: s, context: n } = this.beans;
    if (!s || !this.isFullWidth())
      return;
    const r = s.createRowDragComp(
      () => o,
      this.rowNode,
      void 0,
      e,
      t,
      i
    );
    this.createBean(r, n), this.addDestroyFunc(() => {
      this.destroyBean(r, n);
    });
  }
  onUiLevelChanged() {
    const e = gn(this.rowNode);
    if (this.rowLevel != e) {
      const t = "ag-row-level-" + e, o = "ag-row-level-" + this.rowLevel;
      for (const i of this.allRowGuis)
        i.rowComp.toggleCss(t, !0), i.rowComp.toggleCss(o, !1);
    }
    this.rowLevel = e;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const e = this.isFirstRowOnPage(), t = this.isLastRowOnPage();
    if (this.firstRowOnPage !== e) {
      this.firstRowOnPage = e;
      for (const o of this.allRowGuis)
        o.rowComp.toggleCss("ag-row-first", e);
    }
    if (this.lastRowOnPage !== t) {
      this.lastRowOnPage = t;
      for (const o of this.allRowGuis)
        o.rowComp.toggleCss("ag-row-last", t);
    }
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    const e = [];
    if (this.beans.rowStyleSvc?.processClassesFromGridOptions(e, this.rowNode), !!e.length)
      for (const t of e)
        for (const o of this.allRowGuis)
          o.rowComp.toggleCss(t, !0);
  }
  postProcessRowClassRules() {
    this.beans.rowStyleSvc?.processRowClassRules(
      this.rowNode,
      (e) => {
        for (const t of this.allRowGuis)
          t.rowComp.toggleCss(e, !0);
      },
      (e) => {
        for (const t of this.allRowGuis)
          t.rowComp.toggleCss(e, !1);
      }
    );
  }
  setStylesFromGridOptions(e, t) {
    e && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(t, (o) => o.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(e) {
    return e === "left" || e === "right" ? e : null;
  }
  getInitialRowClasses(e) {
    const t = this.getPinnedForContainer(e), o = this.isFullWidth(), { rowNode: i, beans: s } = this, n = [];
    n.push("ag-row"), n.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), this.fadeInAnimation[e] && n.push("ag-opacity-zero"), n.push(i.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd"), i.isRowPinned() && (n.push("ag-row-pinned"), s.pinnedRowModel?.isManual() && n.push("ag-row-pinned-manual")), !i.isRowPinned() && i.pinnedSibling && n.push("ag-row-pinned-source"), i.isSelected() && n.push("ag-row-selected"), i.footer && n.push("ag-row-footer"), n.push("ag-row-level-" + this.rowLevel), i.stub && n.push("ag-row-loading"), o && n.push("ag-full-width-row"), s.expansionSvc?.addExpandedCss(n, i), i.dragging && n.push("ag-row-dragging");
    const { rowStyleSvc: r } = s;
    return r && (r.processClassesFromGridOptions(n, i), r.preProcessRowClassRules(n, i)), n.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), this.isFirstRowOnPage() && n.push("ag-row-first"), this.isLastRowOnPage() && n.push("ag-row-last"), o && (t === "left" && n.push("ag-cell-last-left-pinned"), t === "right" && n.push("ag-cell-first-right-pinned")), n;
  }
  processStylesFromGridOptions() {
    return this.beans.rowStyleSvc?.processStylesFromGridOptions(this.rowNode) ?? this.emptyStyle;
  }
  onRowSelected(e) {
    this.beans.selectionSvc?.onRowCtrlSelected(
      this,
      (t) => {
        (t === this.centerGui || t === this.fullWidthGui) && this.announceDescription();
      },
      e
    );
  }
  announceDescription() {
    this.beans.selectionSvc?.announceAriaRowSelection(this.rowNode);
  }
  addHoverFunctionality(e) {
    if (!this.active)
      return;
    const { element: t, compBean: o } = e, { rowNode: i, beans: s, gos: n } = this;
    o.addManagedListeners(t, {
      // We use pointer events here instead of mouse events, as pointer events
      // are more reliable for hover detection, especially with touch devices
      // or hybrid touch + mouse devices.
      pointerenter: (r) => {
        r.pointerType === "mouse" && i.dispatchRowEvent("mouseEnter");
      },
      pointerleave: (r) => {
        r.pointerType === "mouse" && i.dispatchRowEvent("mouseLeave");
      }
    }), o.addManagedListeners(i, {
      mouseEnter: () => {
        !s.dragSvc?.dragging && !n.get("suppressRowHoverHighlight") && (t.classList.add("ag-row-hover"), i.setHovered(!0));
      },
      mouseLeave: () => {
        this.resetHoveredStatus(t);
      }
    });
  }
  resetHoveredStatus(e) {
    const t = e ? [e] : this.allRowGuis.map((o) => o.element);
    for (const o of t)
      o.classList.remove("ag-row-hover");
    this.rowNode.setHovered(!1);
  }
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  roundRowTopToBounds(e) {
    const t = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition(), o = this.applyPaginationOffset(t.top, !0) - 100, i = this.applyPaginationOffset(t.bottom, !0) + 100;
    return Math.min(Math.max(o, e), i);
  }
  forEachGui(e, t) {
    if (e)
      t(e);
    else
      for (const o of this.allRowGuis)
        t(o);
  }
  isRowRendered() {
    return this.allRowGuis.length > 0;
  }
  onRowHeightChanged(e) {
    if (this.rowNode.rowHeight == null)
      return;
    const t = this.rowNode.rowHeight, o = this.beans.environment.getDefaultRowHeight(), s = Qn(this.gos) ? Di(this.beans, this.rowNode).height : void 0, n = s ? `${Math.min(o, s) - 2}px` : void 0;
    this.forEachGui(e, (r) => {
      r.element.style.height = `${t}px`, n && r.element.style.setProperty("--ag-line-height", n);
    });
  }
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroyFirstPass(e = !1) {
    this.active = !1;
    const { rowNode: t } = this;
    if (!e && nt(this.gos) && !t.sticky)
      if (t.rowTop != null) {
        const s = this.roundRowTopToBounds(t.rowTop);
        this.setRowTop(s);
      } else
        for (const s of this.allRowGuis)
          s.rowComp.toggleCss("ag-opacity-zero", !0);
    this.fullWidthGui?.element.contains(N(this.beans)) && this.beans.focusSvc.attemptToRecoverFocus(), t.setHovered(!1);
    const o = this.createRowEvent("virtualRowRemoved");
    this.dispatchLocalEvent(o), this.beans.eventSvc.dispatchEvent(o), super.destroy();
  }
  destroySecondPass() {
    this.allRowGuis.length = 0;
    const e = (t) => {
      for (const o of t.list)
        o.destroy();
      return { list: [], map: {} };
    };
    this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
  }
  setFocusedClasses(e) {
    this.forEachGui(e, (t) => {
      t.rowComp.toggleCss("ag-row-focus", this.rowFocused), t.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const { focusSvc: e } = this.beans, t = e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    t !== this.rowFocused && (this.rowFocused = t, this.setFocusedClasses());
  }
  onPaginationChanged() {
    const e = this.beans.pagination?.getCurrentPage() ?? 0;
    this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  applyPaginationOffset(e, t = !1) {
    if (this.rowNode.isRowPinned() || this.rowNode.sticky)
      return e;
    const o = this.beans.pageBounds.getPixelOffset();
    return e + o * (t ? 1 : -1);
  }
  setRowTop(e) {
    if (!this.printLayout && A(e)) {
      const t = this.applyPaginationOffset(e), s = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? t : this.beans.rowContainerHeight.getRealPixelPosition(t)}px`;
      this.setRowTopStyle(s);
    }
  }
  // the top needs to be set into the DOM element when the element is created, not updated afterwards.
  // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
  // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
  // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
  // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
  // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
  // time, the row would animate down (ie from position zero).
  getInitialRowTop(e) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(e) : void 0;
  }
  getInitialTransform(e) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(e)})`;
  }
  getInitialRowTopShared(e) {
    if (this.printLayout)
      return "";
    const t = this.rowNode;
    let o;
    if (t.sticky)
      o = t.stickyRowTop;
    else {
      const i = this.slideInAnimation[e] ? this.roundRowTopToBounds(t.oldRowTop) : t.rowTop, s = this.applyPaginationOffset(i);
      o = t.isRowPinned() ? s : this.beans.rowContainerHeight.getRealPixelPosition(s);
    }
    return o + "px";
  }
  setRowTopStyle(e) {
    for (const t of this.allRowGuis)
      this.suppressRowTransform ? t.rowComp.setTop(e) : t.rowComp.setTransform(`translateY(${e})`);
  }
  getCellCtrl(e, t = !1) {
    let o = null;
    for (const i of this.getAllCellCtrls())
      i.column == e && (o = i);
    if (o != null || t)
      return o;
    for (const i of this.getAllCellCtrls())
      i?.getColSpanningList().indexOf(e) >= 0 && (o = i);
    return o;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  updateRowIndexes(e) {
    const t = this.rowNode.getRowIndexString();
    if (t === null)
      return;
    const o = (this.beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.beans.filterManager?.getHeaderRowCount() ?? 0), i = this.rowNode.rowIndex % 2 === 0, s = o + this.rowNode.rowIndex + 1;
    this.forEachGui(e, (n) => {
      n.rowComp.setRowIndex(t), n.rowComp.toggleCss("ag-row-even", i), n.rowComp.toggleCss("ag-row-odd", !i), bi(n.element, s);
    });
  }
}, vm = class extends b {
  constructor() {
    super(), this.beanName = "navigation", this.onPageDown = As(this.onPageDown, 100), this.onPageUp = As(this.onPageUp, 100);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const o = e.key, i = e.altKey, s = e.ctrlKey || e.metaKey, n = !!this.beans.rangeSvc && e.shiftKey, r = ju(this.gos, e);
    let l = !1;
    switch (o) {
      case w.PAGE_HOME:
      case w.PAGE_END:
        !s && !i && (this.onHomeOrEndKey(o), l = !0);
        break;
      case w.LEFT:
      case w.RIGHT:
      case w.UP:
      case w.DOWN:
        if (!r)
          return !1;
        s && !i && !n && (this.onCtrlUpDownLeftRight(o, r), l = !0);
        break;
      case w.PAGE_DOWN:
      case w.PAGE_UP:
        !s && !i && (l = this.handlePageUpDown(o, r, t));
        break;
    }
    return l && e.preventDefault(), l;
  }
  handlePageUpDown(e, t, o) {
    return o && (t = this.beans.focusSvc.getFocusedCell()), t ? (e === w.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0) : !1;
  }
  navigateTo({
    scrollIndex: e,
    scrollType: t,
    scrollColumn: o,
    focusIndex: i,
    focusColumn: s,
    isAsync: n,
    rowPinned: r
  }) {
    const { scrollFeature: l } = this.gridBodyCon;
    A(o) && !o.isPinned() && l.ensureColumnVisible(o), A(e) && l.ensureIndexVisible(e, t), n || l.ensureIndexVisible(i);
    const { focusSvc: a, rangeSvc: d } = this.beans;
    a.setFocusedCell({
      rowIndex: i,
      column: s,
      rowPinned: r,
      forceBrowserFocus: !0
    }), d?.setRangeToCell({ rowIndex: i, rowPinned: r, column: s });
  }
  // this method is throttled, see the `constructor`
  onPageDown(e) {
    const t = this.beans, o = mi(t), i = this.getViewportHeight(), { pageBounds: s, rowModel: n, rowAutoHeight: r } = t, l = s.getPixelOffset(), a = o.top + i, d = n.getRowIndexAtPixel(a + l);
    r?.active ? this.navigateToNextPageWithAutoHeight(e, d) : this.navigateToNextPage(e, d);
  }
  // this method is throttled, see the `constructor`
  onPageUp(e) {
    const t = this.beans, o = mi(t), { pageBounds: i, rowModel: s, rowAutoHeight: n } = t, r = i.getPixelOffset(), l = o.top, a = s.getRowIndexAtPixel(l + r);
    n?.active ? this.navigateToNextPageWithAutoHeight(e, a, !0) : this.navigateToNextPage(e, a, !0);
  }
  navigateToNextPage(e, t, o = !1) {
    const { pageBounds: i, rowModel: s } = this.beans, n = this.getViewportHeight(), r = i.getFirstRow(), l = i.getLastRow(), a = i.getPixelOffset(), d = s.getRow(e.rowIndex), c = o ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      d?.rowHeight - n - a
    ) : n - a, u = d?.rowTop + c;
    let h = s.getRowIndexAtPixel(u + a);
    if (h === e.rowIndex) {
      const p = o ? -1 : 1;
      t = h = e.rowIndex + p;
    }
    let g;
    o ? (g = "bottom", h < r && (h = r), t < r && (t = r)) : (g = "top", h > l && (h = l), t > l && (t = l)), this.isRowTallerThanView(s.getRow(h)) && (t = h, g = "top"), this.navigateTo({
      scrollIndex: t,
      scrollType: g,
      scrollColumn: null,
      focusIndex: h,
      focusColumn: e.column
    });
  }
  navigateToNextPageWithAutoHeight(e, t, o = !1) {
    this.navigateTo({
      scrollIndex: t,
      scrollType: o ? "bottom" : "top",
      scrollColumn: null,
      focusIndex: t,
      focusColumn: e.column
    }), setTimeout(() => {
      const i = this.getNextFocusIndexForAutoHeight(e, o);
      this.navigateTo({
        scrollIndex: t,
        scrollType: o ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: i,
        focusColumn: e.column,
        isAsync: !0
      });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    const o = t ? -1 : 1, i = this.getViewportHeight(), { pageBounds: s, rowModel: n } = this.beans, r = s.getLastRow();
    let l = 0, a = e.rowIndex;
    for (; a >= 0 && a <= r; ) {
      const d = n.getRow(a);
      if (d) {
        const c = d.rowHeight ?? 0;
        if (l + c > i)
          break;
        l += c;
      }
      a += o;
    }
    return Math.max(0, Math.min(a, r));
  }
  getViewportHeight() {
    const e = this.beans, t = mi(e), o = this.beans.scrollVisibleSvc.getScrollbarWidth();
    let i = t.bottom - t.top;
    return e.ctrlsSvc.get("center").isHorizontalScrollShowing() && (i -= o), i;
  }
  isRowTallerThanView(e) {
    if (!e)
      return !1;
    const t = e.rowHeight;
    return typeof t != "number" ? !1 : t > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const o = this.beans.cellNavigation.getNextCellToFocus(e, t, !0), i = this.getNormalisedPosition(o), { rowIndex: s, rowPinned: n, column: r } = i ?? o, l = r;
    this.navigateTo({
      scrollIndex: s,
      scrollType: null,
      scrollColumn: l,
      focusIndex: s,
      focusColumn: l,
      rowPinned: n
    });
  }
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  onHomeOrEndKey(e) {
    const t = e === w.PAGE_HOME, { visibleCols: o, pageBounds: i, rowModel: s } = this.beans, n = o.allCols, r = t ? i.getFirstRow() : i.getLastRow(), l = s.getRow(r);
    if (!l)
      return;
    const a = (t ? n : [...n].reverse()).find(
      (d) => !d.isSuppressNavigable(l)
    );
    a && this.navigateTo({
      scrollIndex: r,
      scrollType: null,
      scrollColumn: a,
      focusIndex: r,
      focusColumn: a
    });
  }
  // result of keyboard event
  onTabKeyDown(e, t) {
    const o = t.shiftKey, i = this.tabToNextCellCommon(e, o, t), s = this.beans, { ctrlsSvc: n, pageBounds: r, focusSvc: l, gos: a } = s;
    if (i !== !1) {
      i ? t.preventDefault() : i === null && n.get("gridCtrl").allowFocusForNextCoreContainer(o);
      return;
    }
    if (o) {
      const { rowIndex: d, rowPinned: c } = e.getRowPosition();
      (c ? d === 0 : d === r.getFirstRow()) && (a.get("headerHeight") === 0 || _e(s) ? mt(s, !0, !0) : (t.preventDefault(), l.focusPreviousFromFirstCell(t)));
    } else
      e instanceof mo && e.focusCell(!0), (l.focusOverlay(!1) || mt(s, o)) && t.preventDefault();
  }
  // comes from API
  tabToNextCell(e, t) {
    const o = this.beans, { focusSvc: i, rowRenderer: s } = o, n = i.getFocusedCell();
    if (!n)
      return !1;
    let r = no(o, n);
    return !r && (r = s.getRowByPosition(n), !r?.isFullWidth()) ? !1 : !!this.tabToNextCellCommon(r, e, t, "api");
  }
  tabToNextCellCommon(e, t, o, i = "ui") {
    const { editSvc: s, focusSvc: n } = this.beans;
    let r;
    const l = e instanceof mo ? e : e.getAllCellCtrls()?.[0];
    return s?.isEditing() ? r = s?.moveToNextCell(l, t, o, i) : r = this.moveToNextCellNotEditing(e, t, o), r === null ? r : r || !!n.focusedHeader;
  }
  // returns null if no navigation should be performed
  moveToNextCellNotEditing(e, t, o) {
    const i = this.beans.visibleCols.allCols;
    let s;
    if (e instanceof Ui) {
      if (s = {
        ...e.getRowPosition(),
        column: t ? i[0] : G(i)
      }, this.gos.get("embedFullWidthRows") && o) {
        const r = e.findFullWidthInfoForEvent(o);
        r && (s.column = r.column);
      }
    } else
      s = e.getFocusedCellPosition();
    const n = this.findNextCellToFocusOn(s, { backwards: t, startEditing: !1 });
    if (n === !1)
      return null;
    if (n instanceof mo)
      n.focusCell(!0);
    else if (n)
      return this.tryToFocusFullWidthRow(n, t);
    return A(n);
  }
  /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */
  findNextCellToFocusOn(e, { backwards: t, startEditing: o, skipToNextEditableCell: i }) {
    let s = e;
    const n = this.beans, { cellNavigation: r, gos: l, focusSvc: a, rowRenderer: d, rangeSvc: c } = n;
    for (; ; ) {
      e !== s && (e = s), t || (s = this.getLastCellOfColSpan(s)), s = r.getNextTabbedCell(s, t);
      const u = l.getCallback("tabToNextCell");
      if (A(u)) {
        const f = u({
          backwards: t,
          editing: o,
          previousCellPosition: e,
          nextCellPosition: s || null
        });
        if (f === !0)
          s = e;
        else {
          if (f === !1)
            return !1;
          s = {
            rowIndex: f.rowIndex,
            column: f.column,
            rowPinned: f.rowPinned
          };
        }
      }
      if (!s)
        return null;
      if (s.rowIndex < 0) {
        const p = fe(n);
        return a.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: p + s.rowIndex,
            column: s.column
          },
          fromCell: !0
        }), null;
      }
      const h = l.get("editType") === "fullRow";
      if (o && (!h || i) && !this.isCellEditable(s))
        continue;
      this.ensureCellVisible(s);
      const g = no(n, s);
      if (!g) {
        const p = d.getRowByPosition(s);
        if (!p || !p.isFullWidth() || o)
          continue;
        return { ...p.getRowPosition(), column: s?.column };
      }
      if (!r.isSuppressNavigable(g.column, g.rowNode))
        return g.setFocusedCellPosition(s), c?.setRangeToCell(s), g;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return t ? e.column.isCellEditable(t) : !1;
  }
  lookupRowNodeForCell({ rowIndex: e, rowPinned: t }) {
    const { pinnedRowModel: o, rowModel: i } = this.beans;
    return t === "top" ? o?.getPinnedTopRow(e) : t === "bottom" ? o?.getPinnedBottomRow(e) : i.getRow(e);
  }
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  navigateToNextCell(e, t, o, i) {
    let s = o, n = !1;
    const r = this.beans, { cellNavigation: l, focusSvc: a, gos: d } = r;
    for (; s && (s === o || !this.isValidNavigateCell(s)); )
      d.get("enableRtl") ? t === w.LEFT && (s = this.getLastCellOfColSpan(s)) : t === w.RIGHT && (s = this.getLastCellOfColSpan(s)), s = l.getNextCellToFocus(t, s), n = H(s);
    if (n && e && e.key === w.UP && (s = {
      rowIndex: -1,
      rowPinned: null,
      column: o.column
    }), i) {
      const u = d.getCallback("navigateToNextCell");
      if (A(u)) {
        const g = u({
          key: t,
          previousCellPosition: o,
          nextCellPosition: s || null,
          event: e
        });
        A(g) ? s = {
          rowPinned: g.rowPinned,
          rowIndex: g.rowIndex,
          column: g.column
        } : s = null;
      }
    }
    if (!s)
      return;
    if (s.rowIndex < 0) {
      const u = fe(r);
      a.focusHeaderPosition({
        headerPosition: { headerRowIndex: u + s.rowIndex, column: o.column },
        event: e || void 0,
        fromCell: !0
      });
      return;
    }
    const c = this.getNormalisedPosition(s);
    c ? this.focusPosition(c) : this.tryToFocusFullWidthRow(s);
  }
  getNormalisedPosition(e) {
    if (!!this.beans.spannedRowRenderer?.getCellByPosition(e))
      return e;
    this.ensureCellVisible(e);
    const o = no(this.beans, e);
    return o ? (e = o.getFocusedCellPosition(), this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t) {
    const { visibleCols: o, rowRenderer: i, focusSvc: s, eventSvc: n } = this.beans, r = o.allCols;
    if (!i.getRowByPosition(e)?.isFullWidth())
      return !1;
    const a = s.getFocusedCell(), d = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column || (t ? G(r) : r[0])
    };
    this.focusPosition(d);
    const c = t ?? (a != null && yg(d, a));
    return n.dispatchEvent({
      type: "fullWidthRowFocused",
      rowIndex: d.rowIndex,
      rowPinned: d.rowPinned,
      column: d.column,
      isFullWidthCell: !0,
      fromBelow: c
    }), !0;
  }
  focusPosition(e) {
    const { focusSvc: t, rangeSvc: o } = this.beans;
    t.setFocusedCell({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0
    }), o?.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!ol(this.beans, e);
  }
  getLastCellOfColSpan(e) {
    const t = no(this.beans, e);
    if (!t)
      return e;
    const o = t.getColSpanningList();
    return o.length === 1 ? e : {
      rowIndex: e.rowIndex,
      column: G(o),
      rowPinned: e.rowPinned
    };
  }
  ensureCellVisible(e) {
    const t = Jn(this.gos), o = this.beans.rowModel.getRow(e.rowIndex), i = t && o?.sticky, { scrollFeature: s } = this.gridBodyCon;
    !i && H(e.rowPinned) && s.ensureIndexVisible(e.rowIndex), e.column.isPinned() || s.ensureColumnVisible(e.column);
  }
  ensureColumnVisible(e) {
    const t = this.gridBodyCon.scrollFeature;
    e.isPinned() || t.ensureColumnVisible(e);
  }
  ensureRowVisible(e) {
    this.gridBodyCon.scrollFeature.ensureIndexVisible(e);
  }
};
function mi(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
var wm = {
  moduleName: "KeyboardNavigation",
  version: M,
  beans: [vm, WC, Qf],
  apiFunctions: {
    getFocusedCell: NC,
    clearFocusedCell: zC,
    setFocusedCell: _C,
    setFocusedHeader: KC,
    tabToNextCell: UC,
    tabToPreviousCell: $C
  }
}, Sm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsListener";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this),
      recalculateRowBounds: this.calculatePages.bind(this)
    }), this.onModelUpdated();
  }
  onModelUpdated(e) {
    this.calculatePages(), this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: e?.animate ?? !1,
      newData: e?.newData ?? !1,
      newPage: e?.newPage ?? !1,
      newPageSize: e?.newPageSize ?? !1,
      keepRenderedRows: e?.keepRenderedRows ?? !1
    });
  }
  calculatePages() {
    const { pageBounds: e, pagination: t, rowModel: o } = this.beans;
    t ? t.calculatePages() : e.calculateBounds(0, o.getRowCount() - 1);
  }
}, bm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "pageBounds", this.pixelOffset = 0;
  }
  getFirstRow() {
    return this.topRowBounds?.rowIndex ?? -1;
  }
  getLastRow() {
    return this.bottomRowBounds?.rowIndex ?? -1;
  }
  getCurrentPageHeight() {
    const { topRowBounds: e, bottomRowBounds: t } = this;
    return !e || !t ? 0 : Math.max(t.rowTop + t.rowHeight - e.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    const { topRowBounds: e, bottomRowBounds: t } = this, o = e?.rowTop ?? 0, i = t ? t.rowTop + t.rowHeight : 0;
    return { pageFirstPixel: o, pageLastPixel: i };
  }
  calculateBounds(e, t) {
    const { rowModel: o } = this.beans, i = o.getRowBounds(e);
    i && (i.rowIndex = e), this.topRowBounds = i;
    const s = o.getRowBounds(t);
    s && (s.rowIndex = t), this.bottomRowBounds = s, this.calculatePixelOffset();
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  calculatePixelOffset() {
    const e = this.topRowBounds?.rowTop ?? 0;
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventSvc.dispatchEvent({ type: "paginationPixelOffsetChanged" }));
  }
}, ym = (
  /*css*/
  ".ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}"
), Rm = class extends b {
  constructor(e, t) {
    super(), this.isLeft = e, this.elements = t, this.getWidth = e ? () => this.beans.pinnedCols.leftWidth : () => this.beans.pinnedCols.rightWidth;
  }
  postConstruct() {
    this.addManagedEventListeners({
      [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
    });
  }
  onPinnedWidthChanged() {
    const e = this.getWidth(), t = e > 0;
    for (const o of this.elements)
      o && (V(o, t), Me(o, e));
  }
}, xm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "pinnedCols";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (t) => {
      this.gridBodyCtrl = t.gridBodyCtrl;
    });
    const e = this.checkContainerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e
    }), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const { gos: e, visibleCols: t, eventSvc: o } = this.beans, i = Y(e, "print"), s = i ? 0 : t.getColsLeftWidth(), n = i ? 0 : t.getDisplayedColumnsRightWidth();
    s != this.leftWidth && (this.leftWidth = s, o.dispatchEvent({ type: "leftPinnedWidthChanged" })), n != this.rightWidth && (this.rightWidth = n, o.dispatchEvent({ type: "rightPinnedWidthChanged" }));
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = this.gridBodyCtrl.eBodyViewport, t = Ot(e);
    if (t <= 50)
      return;
    const o = this.getPinnedColumnsOverflowingViewport(t - 50), i = this.gos.getCallback("processUnpinnedColumns"), { columns: s, hasLockedPinned: n } = o;
    let r = s;
    !r.length && !n || (i && (r = i({
      columns: r,
      viewportWidth: t
    })), r?.length && (r = r.filter((l) => !Te(l)), this.setColsPinned(r, null, "viewportSizeFeature")));
  }
  createPinnedWidthFeature(e, ...t) {
    return new Rm(e, t);
  }
  setColsPinned(e, t, o) {
    const { colModel: i, colAnimation: s, visibleCols: n, gos: r } = this.beans;
    if (!i.cols || !e?.length)
      return;
    if (Y(r, "print")) {
      F(37);
      return;
    }
    s?.start();
    let l;
    t === !0 || t === "left" ? l = "left" : t === "right" ? l = "right" : l = null;
    const a = [];
    for (const d of e) {
      if (!d)
        continue;
      const c = i.getCol(d);
      c && c.getPinned() !== l && (this.setColPinned(c, l), a.push(c));
    }
    a.length && (n.refresh(o), gr(this.eventSvc, a, o)), s?.finish();
  }
  initCol(e) {
    const { pinned: t, initialPinned: o } = e.colDef;
    t !== void 0 ? this.setColPinned(e, t) : this.setColPinned(e, o);
  }
  setColPinned(e, t) {
    t === !0 || t === "left" ? e.pinned = "left" : t === "right" ? e.pinned = "right" : e.pinned = null, e.dispatchStateUpdatedEvent("pinned");
  }
  setupHeaderPinnedWidth(e) {
    const { scrollVisibleSvc: t } = this.beans;
    if (e.pinned == null)
      return;
    const o = e.pinned === "left", i = e.pinned === "right";
    e.hidden = !0;
    const s = () => {
      const n = o ? this.leftWidth : this.rightWidth;
      if (n == null)
        return;
      const r = n == 0, l = e.hidden !== r, a = this.gos.get("enableRtl"), d = t.getScrollbarWidth(), u = t.verticalScrollShowing && (a && o || !a && i) ? n + d : n;
      e.comp.setPinnedContainerWidth(`${u}px`), e.comp.setDisplayed(!r), l && (e.hidden = r, e.refresh());
    };
    e.addManagedEventListeners({
      leftPinnedWidthChanged: s,
      rightPinnedWidthChanged: s,
      scrollVisibilityChanged: s,
      scrollbarWidthChanged: s
    });
  }
  getHeaderResizeDiff(e, t) {
    if (t.getPinned()) {
      const { leftWidth: i, rightWidth: s } = this, n = Ot(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
      if (i + s + e > n)
        if (n > i + s)
          e = n - i - s;
        else
          return 0;
    }
    return e;
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.rightWidth ?? 0, o = this.leftWidth ?? 0, i = t + o;
    let s = !1;
    if (i < e)
      return { columns: [], hasLockedPinned: s };
    const { visibleCols: n } = this.beans, r = [...n.leftCols], l = [...n.rightCols];
    let a = 0, d = 0;
    const c = 0, u = [];
    let h = i - c - e;
    for (; (d < r.length || a < l.length) && h > 0; ) {
      if (a < l.length) {
        const g = l[a++];
        if (g.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= g.getActualWidth(), u.push(g);
      }
      if (d < r.length && h > 0) {
        const g = r[d++];
        if (g.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= g.getActualWidth(), u.push(g);
      }
    }
    return { columns: u, hasLockedPinned: s };
  }
}, Pm = {
  moduleName: "PinnedColumn",
  version: M,
  beans: [xm],
  css: [ym]
}, Dm = class extends b {
  constructor() {
    super(), this.beanName = "ariaAnnounce", this.descriptionContainer = null, this.pendingAnnouncements = /* @__PURE__ */ new Map(), this.lastAnnouncement = "", this.updateAnnouncement = We(this, this.updateAnnouncement.bind(this), 200);
  }
  postConstruct() {
    const e = this.beans, t = j(e), o = this.descriptionContainer = t.createElement("div");
    o.classList.add("ag-aria-description-container"), Dn(o, "polite"), Yl(o, "additions text"), ql(o, !0), e.eGridDiv.appendChild(o);
  }
  /**
   * @param key used for debouncing calls
   */
  announceValue(e, t) {
    this.pendingAnnouncements.set(t, e), this.updateAnnouncement();
  }
  updateAnnouncement() {
    if (!this.descriptionContainer)
      return;
    const e = Array.from(this.pendingAnnouncements.values()).join(". ");
    this.pendingAnnouncements.clear(), this.descriptionContainer.textContent = "", setTimeout(() => {
      this.handleAnnouncementUpdate(e);
    }, 50);
  }
  handleAnnouncementUpdate(e) {
    if (!this.isAlive() || !this.descriptionContainer)
      return;
    let t = e;
    if (t == null || t.replace(/[ .]/g, "") == "") {
      this.lastAnnouncement = "";
      return;
    }
    this.lastAnnouncement === t && (t = `${t}​`), this.lastAnnouncement = t, this.descriptionContainer.textContent = t;
  }
  destroy() {
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (J(e), e.remove()), this.descriptionContainer = null, this.pendingAnnouncements.clear();
  }
}, Fm = {
  moduleName: "Aria",
  version: M,
  beans: [Dm]
}, Em = (
  /*css*/
  ":where(.ag-delay-render){.ag-cell,.ag-header-cell,.ag-header-group-cell,.ag-row,.ag-spanned-cell-wrapper{visibility:hidden}}"
), pn = "ag-delay-render", Am = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colDelayRenderSvc", this.hideRequested = !1, this.alreadyRevealed = !1, this.timesRetried = 0, this.requesters = /* @__PURE__ */ new Set();
  }
  hideColumns(e) {
    this.alreadyRevealed || this.requesters.has(e) || (this.requesters.add(e), this.hideRequested || (this.beans.ctrlsSvc.whenReady(this, (t) => {
      t.gridBodyCtrl.eGridBody.classList.add(pn);
    }), this.hideRequested = !0));
  }
  revealColumns(e) {
    if (this.alreadyRevealed || !this.isAlive() || (this.requesters.delete(e), this.requesters.size > 0))
      return;
    const { renderStatus: t, ctrlsSvc: o } = this.beans;
    if (t) {
      if (!t.areHeaderCellsRendered() && this.timesRetried < 5) {
        this.timesRetried++, setTimeout(() => this.revealColumns(e));
        return;
      }
      this.timesRetried = 0;
    }
    o.getGridBodyCtrl().eGridBody.classList.remove(pn), this.alreadyRevealed = !0;
  }
}, Mm = {
  moduleName: "ColumnDelayRender",
  version: M,
  beans: [Am],
  css: [Em]
};
function Tm(e) {
  e.overlays?.showLoadingOverlay();
}
function Im(e) {
  e.overlays?.showNoRowsOverlay();
}
function km(e) {
  e.overlays?.hideOverlay();
}
var Lm = (
  /*css*/
  ".ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}"
), Gm = {
  tag: "div",
  cls: "ag-overlay",
  role: "presentation",
  children: [
    {
      tag: "div",
      cls: "ag-overlay-panel",
      role: "presentation",
      children: [{ tag: "div", ref: "eOverlayWrapper", cls: "ag-overlay-wrapper", role: "presentation" }]
    }
  ]
}, Dl = class extends O {
  constructor() {
    super(Gm), this.eOverlayWrapper = P, this.activePromise = null, this.activeOverlay = null, this.updateListenerDestroyFunc = null, this.activeCssClass = null, this.elToFocusAfter = null, this.registerCSS(Lm);
  }
  handleKeyDown(e) {
    if (e.key !== w.TAB || e.defaultPrevented || xe(e))
      return;
    const t = this.beans;
    if (qt(t, this.eOverlayWrapper, !1, e.shiftKey))
      return;
    let i = !1;
    e.shiftKey ? i = t.focusSvc.focusGridView({
      column: G(t.visibleCols.allCols),
      backwards: !0,
      canFocusOverlay: !1
    }) : i = mt(t, !1), i && e.preventDefault();
  }
  updateLayoutClasses(e, t) {
    const o = this.eOverlayWrapper.classList, { AUTO_HEIGHT: i, NORMAL: s, PRINT: n } = ae;
    o.toggle(i, t.autoHeight), o.toggle(s, t.normal), o.toggle(n, t.print);
  }
  postConstruct() {
    this.createManagedBean(new hs(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.beans.overlays.setOverlayWrapperComp(this), this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  setWrapperTypeClass(e) {
    const t = this.eOverlayWrapper.classList;
    this.activeCssClass && t.toggle(this.activeCssClass, !1), this.activeCssClass = e, t.toggle(e, !0);
  }
  showOverlay(e, t, o, i) {
    if (this.setWrapperTypeClass(t), this.destroyActiveOverlay(), this.elToFocusAfter = null, this.activePromise = e, !!e) {
      if (this.setDisplayed(!0, { skipAriaHidden: !0 }), o && this.isGridFocused()) {
        const s = N(this.beans);
        s && !yn(this.beans) && (this.elToFocusAfter = s);
      }
      e.then((s) => {
        if (this.activePromise !== e) {
          this.activeOverlay !== s && (this.destroyBean(s), s = null);
          return;
        }
        if (this.activePromise = null, !!s) {
          if (this.activeOverlay !== s && (this.eOverlayWrapper.appendChild(s.getGui()), this.activeOverlay = s, i)) {
            const n = s;
            this.updateListenerDestroyFunc = this.addManagedPropertyListener(i, ({ currentValue: r }) => {
              n.refresh?.(L(this.gos, { ...r ?? {} }));
            });
          }
          o && this.isGridFocused() && To(this.eOverlayWrapper);
        }
      });
    }
  }
  updateOverlayWrapperPaddingTop(e) {
    this.eOverlayWrapper.style.setProperty("padding-top", `${e}px`);
  }
  destroyActiveOverlay() {
    this.activePromise = null;
    const e = this.activeOverlay;
    if (!e)
      return;
    let t = this.elToFocusAfter;
    this.activeOverlay = null, this.elToFocusAfter = null, t && !this.isGridFocused() && (t = null);
    const o = this.updateListenerDestroyFunc;
    o && (o(), this.updateListenerDestroyFunc = null), this.destroyBean(e), J(this.eOverlayWrapper), t?.focus?.({ preventScroll: !0 });
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  isGridFocused() {
    const e = N(this.beans);
    return !!e && this.beans.eGridDiv.contains(e);
  }
  destroy() {
    this.elToFocusAfter = null, this.destroyActiveOverlay(), this.beans.overlays.setOverlayWrapperComp(void 0), super.destroy();
  }
}, Hm = {
  selector: "AG-OVERLAY-WRAPPER",
  component: Dl
}, Om = class extends b {
  constructor() {
    super(...arguments), this.beanName = "overlays", this.state = 0, this.showInitialOverlay = !0, this.wrapperPadding = 0;
  }
  postConstruct() {
    this.isClientSide = re(this.gos), this.isServerSide = !this.isClientSide && rs(this.gos);
    const e = () => this.updateOverlayVisibility();
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      rowDataUpdated: e,
      gridSizeChanged: this.refreshWrapperPadding.bind(this),
      rowCountReady: () => {
        this.showInitialOverlay = !1, this.updateOverlayVisibility();
      }
    }), this.addManagedPropertyListener("loading", e);
  }
  setOverlayWrapperComp(e) {
    this.eWrapper = e, this.updateOverlayVisibility();
  }
  /** Returns true if the overlay is visible. */
  isVisible() {
    return this.state !== 0 && !!this.eWrapper;
  }
  /** Returns true if the overlay is visible and is exclusive (popup over the grid) */
  isExclusive() {
    return this.state === 1 && !!this.eWrapper;
  }
  showLoadingOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos, t = e.get("loading");
    !t && (t !== void 0 || e.get("suppressLoadingOverlay")) || this.doShowLoadingOverlay();
  }
  showNoRowsOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos;
    e.get("loading") || e.get("suppressNoRowsOverlay") || this.doShowNoRowsOverlay();
  }
  hideOverlay() {
    if (this.showInitialOverlay = !1, this.gos.get("loading")) {
      F(99);
      return;
    }
    this.doHideOverlay();
  }
  getOverlayWrapperSelector() {
    return Hm;
  }
  getOverlayWrapperCompClass() {
    return Dl;
  }
  updateOverlayVisibility() {
    if (!this.eWrapper) {
      this.state = 0;
      return;
    }
    const {
      state: e,
      isClientSide: t,
      isServerSide: o,
      beans: { gos: i, colModel: s, rowModel: n }
    } = this;
    let r = this.gos.get("loading");
    r !== void 0 && (this.showInitialOverlay = !1), this.showInitialOverlay && r === void 0 && !i.get("suppressLoadingOverlay") && (r = !i.get("columnDefs") || !s.ready || !i.get("rowData") && t), r ? e !== 1 && this.doShowLoadingOverlay() : (this.showInitialOverlay = !1, t && n.isEmpty() && !i.get("suppressNoRowsOverlay") ? e !== 2 && this.doShowNoRowsOverlay() : (e === 1 || !o && e !== 0) && this.doHideOverlay());
  }
  doShowLoadingOverlay() {
    this.eWrapper && (this.state = 1, this.showOverlay(
      ec(this.beans.userCompFactory, L(this.gos, {})),
      "ag-overlay-loading-wrapper",
      "loadingOverlayComponentParams"
    ), this.updateExclusive());
  }
  doShowNoRowsOverlay() {
    this.eWrapper && (this.state = 2, this.showOverlay(
      tc(this.beans.userCompFactory, L(this.gos, {})),
      "ag-overlay-no-rows-wrapper",
      "noRowsOverlayComponentParams"
    ), this.updateExclusive());
  }
  doHideOverlay() {
    this.eWrapper && (this.state = 0, this.eWrapper.hideOverlay(), this.updateExclusive());
  }
  showOverlay(e, t, o) {
    const i = e?.newAgStackInstance() ?? null;
    this.eWrapper?.showOverlay(i, t, this.isExclusive(), o), this.refreshWrapperPadding();
  }
  updateExclusive() {
    const e = this.exclusive;
    this.exclusive = this.isExclusive(), this.exclusive !== e && this.eventSvc.dispatchEvent({
      type: "overlayExclusiveChanged"
    });
  }
  refreshWrapperPadding() {
    const e = this.eWrapper;
    if (!e)
      return;
    let t = 0;
    this.state === 2 && (t = this.beans.ctrlsSvc.get("gridHeaderCtrl")?.headerHeight || 0), this.wrapperPadding !== t && (this.wrapperPadding = t, e.updateOverlayWrapperPaddingTop(t));
  }
}, Bm = {
  moduleName: "Overlay",
  version: M,
  userComponents: {
    agLoadingOverlay: Rh,
    agNoRowsOverlay: Ph
  },
  apiFunctions: {
    showLoadingOverlay: Tm,
    showNoRowsOverlay: Im,
    hideOverlay: km
  },
  beans: [Om]
}, Vm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "rowContainerHeight", this.scrollY = 0, this.uiBodyHeight = 0;
  }
  postConstruct() {
    this.addManagedEventListeners({ bodyHeightChanged: this.updateOffset.bind(this) }), this.maxDivHeight = ic(), Vt(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top, t = this.getUiBodyHeight();
    (e !== this.scrollY || t !== this.uiBodyHeight) && (this.scrollY = e, this.uiBodyHeight = t, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    Vt(
      this.gos,
      `RowContainerHeightService - Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`
    ), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventSvc.dispatchEvent({ type: "rowContainerHeightChanged" }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventSvc.dispatchEvent({ type: "heightScaleChanged" }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && // null happens when in print layout
    this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
    return e.bottom - e.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = this.modelHeight - this.getUiBodyHeight(), o = e / t;
    return this.maxScrollY * o;
  }
}, Wm = 400, Nm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "rowRenderer", this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        for (const n of this.getAllCellCtrls())
          n.onCellSelectionChanged();
      }, t = () => {
        for (const n of this.getAllCellCtrls())
          n.updateRangeBordersIfRangeCount();
      }, o = () => {
        this.eventSvc.addListener("cellSelectionChanged", e), this.eventSvc.addListener("columnMoved", t), this.eventSvc.addListener("columnPinned", t), this.eventSvc.addListener("columnVisible", t);
      }, i = () => {
        this.eventSvc.removeListener("cellSelectionChanged", e), this.eventSvc.removeListener("columnMoved", t), this.eventSvc.removeListener("columnPinned", t), this.eventSvc.removeListener("columnVisible", t);
      };
      this.addDestroyFunc(() => i()), this.addManagedPropertyListeners(["enableRangeSelection", "cellSelection"], () => {
        ht(this.gos) ? o() : i();
      }), ht(this.gos) && o();
    };
  }
  wireBeans(e) {
    this.pageBounds = e.pageBounds, this.colModel = e.colModel, this.pinnedRowModel = e.pinnedRowModel, this.rowModel = e.rowModel, this.focusSvc = e.focusSvc, this.rowContainerHeight = e.rowContainerHeight, this.ctrlsSvc = e.ctrlsSvc, this.editSvc = e.editSvc;
  }
  postConstruct() {
    this.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    this.addManagedEventListeners({
      paginationChanged: this.onPageLoaded.bind(this),
      pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
      pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      bodyScroll: this.onBodyScroll.bind(this),
      bodyHeightChanged: this.redraw.bind(this, {})
    }), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListener("suppressCellFocus", (i) => this.onSuppressCellFocusChanged(i.currentValue)), this.addManagedPropertyListeners(
      [
        "groupSuppressBlankHeader",
        "getBusinessKeyForNode",
        "fullWidthCellRenderer",
        "fullWidthCellRendererParams",
        "suppressStickyTotalRow",
        "groupRowRenderer",
        "groupRowRendererParams",
        // maybe only needs to refresh FW rows...
        "loadingCellRenderer",
        "loadingCellRendererParams",
        "detailCellRenderer",
        "detailCellRendererParams",
        "enableRangeSelection",
        "enableCellTextSelection"
      ],
      () => this.redrawRows()
    ), this.addManagedPropertyListener("cellSelection", ({ currentValue: i, previousValue: s }) => {
      (!s && i || s && !i) && this.redrawRows();
    });
    const { stickyRowSvc: e, gos: t, showRowGroupCols: o } = this.beans;
    if (o && this.addManagedPropertyListener("showOpenedGroup", () => {
      const i = o.getShowRowGroupCols();
      i.length && this.refreshCells({ columns: i, force: !0 });
    }), e)
      this.stickyRowFeature = e.createStickyRowFeature(
        this,
        this.createRowCon.bind(this),
        this.destroyRowCtrls.bind(this)
      );
    else {
      const i = this.gridBodyCtrl;
      i.setStickyTopHeight(0), i.setStickyBottomHeight(0);
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = Y(t, "print"), this.embedFullWidthRows = this.printLayout || t.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new zm(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    return this.stickyRowFeature?.stickyTopRowCtrls ?? [];
  }
  getStickyBottomRowCtrls() {
    return this.stickyRowFeature?.stickyBottomRowCtrls ?? [];
  }
  updateAllRowCtrls() {
    const e = Object.values(this.rowCtrlsByRowIndex), t = Object.values(this.zombieRowCtrls), o = this.cachedRowCtrls?.getEntries() ?? [];
    t.length > 0 || o.length > 0 ? this.allRowCtrls = [...e, ...t, ...o] : this.allRowCtrls = e;
  }
  /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */
  isCellBeingRendered(e, t) {
    const o = this.rowCtrlsByRowIndex[e];
    return !t || !o ? !!o : o.isFullWidth() ? !0 : !!this.beans.spannedRowRenderer?.getCellByPosition({ rowIndex: e, column: t, rowPinned: null }) || !!o.getCellCtrl(t) || !o.isRowRendered();
  }
  /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */
  updateCellFocus(e) {
    for (const t of this.getAllCellCtrls())
      t.onCellFocused(e);
    for (const t of this.getFullWidthRowCtrls())
      t.onFullWidthRowFocused(e);
  }
  /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */
  onCellFocusChanged(e) {
    if (e?.rowIndex != null && !e.rowPinned) {
      const t = this.beans.colModel.getCol(e.column) ?? void 0;
      this.isCellBeingRendered(e.rowIndex, t) || this.redraw();
    }
    this.updateCellFocus(e);
  }
  onSuppressCellFocusChanged(e) {
    for (const t of this.getAllCellCtrls())
      t.onSuppressCellFocusChanged(e);
    for (const t of this.getFullWidthRowCtrls())
      t.onSuppressCellFocusChanged(e);
  }
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  registerCellEventListeners() {
    this.addManagedEventListeners({
      cellFocused: (e) => this.onCellFocusChanged(e),
      cellFocusCleared: () => this.updateCellFocus(),
      flashCells: (e) => {
        const { cellFlashSvc: t } = this.beans;
        if (t)
          for (const o of this.getAllCellCtrls())
            t.onFlashCells(o, e);
      },
      columnHoverChanged: () => {
        for (const e of this.getAllCellCtrls())
          e.onColumnHover();
      },
      displayedColumnsChanged: () => {
        for (const e of this.getAllCellCtrls())
          e.onDisplayedColumnsChanged();
      },
      displayedColumnsWidthChanged: () => {
        if (this.printLayout)
          for (const e of this.getAllCellCtrls())
            e.onLeftChanged();
      }
    }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedEventListeners({
      gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
    }), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  removeGridColumnListeners() {
    for (const e of this.destroyFuncsForColumnListeners)
      e();
    this.destroyFuncsForColumnListeners.length = 0;
  }
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners();
    const e = this.colModel.getCols();
    for (const t of e) {
      const o = (a) => {
        for (const d of this.getAllCellCtrls())
          d.column === t && a(d);
      }, i = () => {
        o((a) => a.onLeftChanged());
      }, s = () => {
        o((a) => a.onWidthChanged());
      }, n = () => {
        o((a) => a.onFirstRightPinnedChanged());
      }, r = () => {
        o((a) => a.onLastLeftPinnedChanged());
      }, l = () => {
        o((a) => a.onColDefChanged());
      };
      t.__addEventListener("leftChanged", i), t.__addEventListener("widthChanged", s), t.__addEventListener("firstRightPinnedChanged", n), t.__addEventListener("lastLeftPinnedChanged", r), t.__addEventListener("colDefChanged", l), this.destroyFuncsForColumnListeners.push(() => {
        t.__removeEventListener("leftChanged", i), t.__removeEventListener("widthChanged", s), t.__removeEventListener("firstRightPinnedChanged", n), t.__removeEventListener("lastLeftPinnedChanged", r), t.__removeEventListener("colDefChanged", l);
      });
    }
  }
  onDomLayoutChanged() {
    const e = Y(this.gos, "print"), t = e || this.gos.get("embedFullWidthRows"), o = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, o && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = {
      recycleRows: e.keepRenderedRows,
      animate: e.animate,
      newData: e.newData,
      newPage: e.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: !0
    };
    this.redrawAfterModelUpdate(t);
  }
  /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */
  getAllCellsNotSpanningForColumn(e) {
    const t = [];
    for (const o of this.getAllRowCtrls()) {
      const i = o.getCellCtrl(e, !0)?.eGui;
      i && t.push(i);
    }
    return t;
  }
  refreshFloatingRowComps(e = !0) {
    this.refreshFloatingRows(this.topRowCtrls, "top", e), this.refreshFloatingRows(this.bottomRowCtrls, "bottom", e);
  }
  /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */
  refreshFloatingRows(e, t, o) {
    const { pinnedRowModel: i, beans: s, printLayout: n } = this, r = Object.fromEntries(e.map((a) => [a.rowNode.id, a]));
    i?.forEachPinnedRow(t, (a, d) => {
      const c = e[d];
      c && i.getPinnedRowById(c.rowNode.id, t) === void 0 && (c.destroyFirstPass(), c.destroySecondPass()), a.id in r && o ? (e[d] = r[a.id], delete r[a.id]) : e[d] = new Ui(a, s, !1, !1, n);
    });
    const l = (t === "top" ? i?.getPinnedTopRowCount() : i?.getPinnedBottomRowCount()) ?? 0;
    e.length = l;
  }
  onPinnedRowDataChanged() {
    const e = {
      recycleRows: !0
    };
    this.redrawAfterModelUpdate(e);
  }
  onPinnedRowsChanged() {
    this.redrawAfterModelUpdate({ recycleRows: !0 });
  }
  redrawRow(e, t = !1) {
    if (e.sticky)
      this.stickyRowFeature?.refreshStickyNode(e);
    else if (this.cachedRowCtrls?.has(e)) {
      this.cachedRowCtrls.removeRow(e);
      return;
    } else {
      const o = (i) => {
        const s = i[e.rowIndex];
        s && s.rowNode === e && (s.destroyFirstPass(), s.destroySecondPass(), i[e.rowIndex] = this.createRowCon(e, !1, !1));
      };
      switch (e.rowPinned) {
        case "top":
          o(this.topRowCtrls);
          break;
        case "bottom":
          o(this.bottomRowCtrls);
          break;
        default:
          o(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    const { editSvc: t } = this.beans;
    if (t?.isEditing() && (t.isBatchEditing() ? t.cleanupEditors() : t.stopEditing(void 0, { source: "api" })), e != null) {
      for (const i of e ?? [])
        this.redrawRow(i, !0);
      this.dispatchDisplayedRowsChanged(!1);
      return;
    }
    this.redrawAfterModelUpdate();
  }
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  redrawAfterModelUpdate(e = {}) {
    this.getLockOnRefresh();
    const t = this.beans.focusSvc?.getFocusCellToUseAfterRefresh();
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const o = !e.domLayoutChanged && !!e.recycleRows, i = e.animate && nt(this.gos), s = o ? this.getRowsToRecycle() : null;
    o || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender();
    const { stickyRowFeature: n, gos: r } = this;
    if (n) {
      n.checkStickyRows();
      const l = n.extraTopHeight + n.extraBottomHeight;
      l && this.updateContainerHeights(l);
    }
    this.recycleRows(s, i), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(r.get("enableRowPinning") ? o : void 0), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    const t = e.newData || e.newPage, o = this.gos.get("suppressScrollOnNewData");
    t && !o && (this.gridBodyCtrl.scrollFeature.scrollToTop(), this.stickyRowFeature?.resetOffsets());
  }
  updateContainerHeights(e = 0) {
    const { rowContainerHeight: t } = this;
    if (this.printLayout) {
      t.setModelHeight(null);
      return;
    }
    let o = this.pageBounds.getCurrentPageHeight();
    o === 0 && (o = 1), t.setModelHeight(o + e);
  }
  getLockOnRefresh() {
    if (this.refreshInProgress)
      throw new Error(Ce(252));
    this.refreshInProgress = !0, this.beans.frameworkOverrides.getLockOnRefresh?.();
  }
  releaseLockOnRefresh() {
    this.refreshInProgress = !1, this.beans.frameworkOverrides.releaseLockOnRefresh?.();
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  restoreFocusedCell(e) {
    if (!e)
      return;
    const t = this.beans.focusSvc, o = this.findPositionToFocus(e);
    if (!o) {
      t.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: fe(this.beans) - 1,
          column: e.column
        }
      });
      return;
    }
    if (e.rowIndex !== o.rowIndex || e.rowPinned != o.rowPinned) {
      t.setFocusedCell({
        ...o,
        preventScrollOnBrowserFocus: !0,
        forceBrowserFocus: !0
      });
      return;
    }
    t.doesRowOrCellHaveBrowserFocus() || this.updateCellFocus(
      L(this.gos, {
        ...o,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !0,
        type: "cellFocused"
      })
    );
  }
  findPositionToFocus(e) {
    const { pagination: t, pageBounds: o } = this.beans;
    let i = e;
    for (i.rowPinned == null && t && o && !t.isRowInPage(i.rowIndex) && (i = { rowPinned: null, rowIndex: o.getFirstRow() }); i; ) {
      if (i.rowPinned == null && o)
        if (i.rowIndex < o.getFirstRow()) {
          if (i = Go(this.beans, { rowPinned: null, rowIndex: 0 }), !i)
            return null;
        } else i.rowIndex > o.getLastRow() && (i = { rowPinned: null, rowIndex: o.getLastRow() });
      const s = this.getRowByPosition(i);
      if (s?.isAlive())
        return { ...s.getRowPosition(), column: e.column };
      i = Go(this.beans, i);
    }
    return null;
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), o = t.length;
    for (let i = 0; i < o; i++) {
      const s = t[i].getAllCellCtrls(), n = s.length;
      for (let r = 0; r < n; r++)
        e.push(s[r]);
    }
    return e;
  }
  getAllRowCtrls() {
    const { spannedRowRenderer: e } = this.beans, t = this.getStickyTopRowCtrls(), o = this.getStickyBottomRowCtrls();
    return [
      ...this.topRowCtrls,
      ...this.bottomRowCtrls,
      ...t,
      ...o,
      ...e?.getCtrls("top") ?? [],
      ...e?.getCtrls("bottom") ?? [],
      ...e?.getCtrls("center") ?? [],
      ...Object.values(this.rowCtrlsByRowIndex)
    ];
  }
  addRenderedRowListener(e, t, o) {
    const i = this.rowCtrlsByRowIndex[t];
    i && i.addEventListener(e, o);
  }
  refreshCells({ rowNodes: e, columns: t, force: o, suppressFlash: i } = {}) {
    const s = {
      force: o,
      newData: !1,
      suppressFlash: i
    };
    for (const n of this.getCellCtrls(e, t))
      n.refreshOrDestroyCell(s);
    this.refreshFullWidth(e);
  }
  refreshRows(e = {}) {
    for (const t of this.getRowCtrls(e.rowNodes))
      t.refreshRow(e);
    this.refreshFullWidth(e.rowNodes);
  }
  refreshFullWidth(e) {
    if (!e)
      return;
    let t = !1;
    for (const o of this.getRowCtrls(e)) {
      if (!o.isFullWidth())
        continue;
      o.refreshFullWidth() || (t = !0, this.redrawRow(o.rowNode, !0));
    }
    t && this.dispatchDisplayedRowsChanged(!1);
  }
  /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */
  getRowCtrls(e) {
    const t = $i(e), o = this.getAllRowCtrls();
    return !e || !t ? o : o.filter((i) => {
      const s = i.rowNode;
      return Ki(s, t);
    });
  }
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  getCellCtrls(e, t) {
    let o;
    A(t) && (o = {}, t.forEach((s) => {
      const n = this.colModel.getCol(s);
      A(n) && (o[n.getId()] = !0);
    }));
    const i = [];
    for (const s of this.getRowCtrls(e))
      for (const n of s.getAllCellCtrls()) {
        const r = n.column.getId();
        o && !o[r] || i.push(n);
      }
    return i;
  }
  destroy() {
    this.removeAllRowComps(!0), super.destroy();
  }
  removeAllRowComps(e = !1) {
    const t = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(t, e), this.stickyRowFeature?.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    for (const o of Object.keys(this.rowCtrlsByRowIndex))
      this.rowCtrlsByRowIndex[o].rowNode.id == null && e.push(o);
    this.removeRowCtrls(e);
    const t = {};
    for (const o of Object.values(this.rowCtrlsByRowIndex)) {
      const i = o.rowNode;
      t[i.id] = o;
    }
    return this.rowCtrlsByRowIndex = {}, t;
  }
  // takes array of row indexes
  removeRowCtrls(e, t = !1) {
    for (const o of e) {
      const i = this.rowCtrlsByRowIndex[o];
      i && (i.destroyFirstPass(t), i.destroySecondPass()), delete this.rowCtrlsByRowIndex[o];
    }
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  redraw(e = {}) {
    const { focusSvc: t, animationFrameSvc: o } = this.beans, { afterScroll: i } = e;
    let s;
    const n = this.stickyRowFeature;
    n && (s = t?.getFocusCellToUseAfterRefresh() || void 0);
    const r = this.firstRenderedRow, l = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let a = !1;
    if (n) {
      a = n.checkStickyRows();
      const c = n.extraTopHeight + n.extraBottomHeight;
      c && this.updateContainerHeights(c);
    }
    const d = this.firstRenderedRow !== r || this.lastRenderedRow !== l;
    if (!(i && !a && !d) && (this.getLockOnRefresh(), this.recycleRows(null, !1, i), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(i && !a), s != null)) {
      const c = t?.getFocusCellToUseAfterRefresh();
      s != null && c == null && (o?.flushAllFrames(), this.restoreFocusedCell(s));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const o = {};
    for (const n of e)
      o[n] = !0;
    const s = Object.keys(this.rowCtrlsByRowIndex).filter((n) => !o[n]);
    this.removeRowCtrls(s, t);
  }
  calculateIndexesToDraw(e) {
    const t = [];
    for (let r = this.firstRenderedRow; r <= this.lastRenderedRow; r++)
      t.push(r);
    const o = this.beans.pagination, i = this.beans.focusSvc?.getFocusedCell()?.rowIndex;
    i != null && (i < this.firstRenderedRow || i > this.lastRenderedRow) && (!o || o.isRowInPage(i)) && i < this.rowModel.getRowCount() && t.push(i);
    const s = (r) => {
      const l = r.rowNode.rowIndex;
      l == null || l === i || (l < this.firstRenderedRow || l > this.lastRenderedRow) && this.doNotUnVirtualiseRow(r) && t.push(l);
    };
    for (const r of Object.values(this.rowCtrlsByRowIndex))
      s(r);
    if (e)
      for (const r of Object.values(e))
        s(r);
    t.sort((r, l) => r - l);
    const n = [];
    for (let r = 0; r < t.length; r++) {
      const l = t[r], a = this.rowModel.getRow(l);
      a && !a.sticky && n.push(l);
    }
    return n;
  }
  recycleRows(e, t = !1, o = !1) {
    const i = this.calculateIndexesToDraw(e);
    (this.printLayout || o) && (t = !1), this.removeRowCompsNotToDraw(i, !t);
    for (const s of i)
      this.createOrUpdateRowCtrl(s, e, t, o);
    if (e) {
      const { animationFrameSvc: s } = this.beans;
      s?.active && o && !this.printLayout ? s.addDestroyTask(() => {
        this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
      }) : this.destroyRowCtrls(e, t);
    }
    this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "displayedRowsChanged",
      afterScroll: e
    });
  }
  onDisplayedColumnsChanged() {
    const { visibleCols: e } = this.beans, t = e.isPinningLeft(), o = e.isPinningRight();
    (this.pinningLeft !== t || o !== this.pinningRight) && (this.pinningLeft = t, this.pinningRight = o, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  redrawFullWidthEmbeddedRows() {
    const e = [];
    for (const t of this.getFullWidthRowCtrls()) {
      const o = t.rowNode.rowIndex;
      e.push(o.toString());
    }
    this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = $i(e);
    return this.getAllRowCtrls().filter((o) => {
      if (!o.isFullWidth())
        return !1;
      const i = o.rowNode;
      return !(t != null && !Ki(i, t));
    });
  }
  createOrUpdateRowCtrl(e, t, o, i) {
    let s, n = this.rowCtrlsByRowIndex[e];
    if (n || (s = this.rowModel.getRow(e), A(s) && A(t) && t[s.id] && s.alreadyRendered && (n = t[s.id], t[s.id] = null)), !n)
      if (s || (s = this.rowModel.getRow(e)), A(s))
        n = this.createRowCon(s, o, i);
      else
        return;
    s && (s.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = n;
  }
  destroyRowCtrls(e, t) {
    const o = [];
    if (e) {
      for (const i of Object.values(e))
        if (i) {
          if (this.cachedRowCtrls && i.isCacheable()) {
            this.cachedRowCtrls.addRow(i);
            continue;
          }
          if (i.destroyFirstPass(!t), t) {
            const s = i.instanceId;
            this.zombieRowCtrls[s] = i, o.push(() => {
              i.destroySecondPass(), delete this.zombieRowCtrls[s];
            });
          } else
            i.destroySecondPass();
        }
    }
    t && (o.push(() => {
      this.isAlive() && (this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged());
    }), window.setTimeout(() => {
      for (const i of o)
        i();
    }, Wm));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    const e = this.getRowBuffer(), t = Bo(this.beans);
    return e * t;
  }
  workOutFirstAndLastRowsToRender() {
    const { rowContainerHeight: e, pageBounds: t, rowModel: o } = this;
    e.updateOffset();
    let i, s;
    if (!o.isRowsToRender())
      i = 0, s = -1;
    else if (this.printLayout)
      this.beans.environment.refreshRowHeightVariable(), i = t.getFirstRow(), s = t.getLastRow();
    else {
      const c = this.getRowBufferInPixels(), u = this.ctrlsSvc.getScrollFeature(), h = this.gos.get("suppressRowVirtualisation");
      let g = !1, p, f;
      do {
        const D = t.getPixelOffset(), { pageFirstPixel: y, pageLastPixel: R } = t.getCurrentPagePixelRange(), x = e.divStretchOffset, k = u.getVScrollPosition(), I = k.top, T = k.bottom;
        h ? (p = y + x, f = R + x) : (p = Math.max(I + D - c, y) + x, f = Math.min(T + D + c, R) + x), this.firstVisibleVPixel = Math.max(I + D, y) + x, this.lastVisibleVPixel = Math.min(T + D, R) + x, g = this.ensureAllRowsInRangeHaveHeightsCalculated(p, f);
      } while (g);
      let C = o.getRowIndexAtPixel(p), m = o.getRowIndexAtPixel(f);
      const v = t.getFirstRow(), S = t.getLastRow();
      C < v && (C = v), m > S && (m = S), i = C, s = m;
    }
    const n = Y(this.gos, "normal"), r = this.gos.get("suppressMaxRenderedRowRestriction"), l = Math.max(this.getRowBuffer(), 500);
    n && !r && s - i > l && (s = i + l);
    const a = i !== this.firstRenderedRow, d = s !== this.lastRenderedRow;
    (a || d) && (this.firstRenderedRow = i, this.lastRenderedRow = s, this.eventSvc.dispatchEvent({
      type: "viewportChanged",
      firstRow: i,
      lastRow: s
    }));
  }
  /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */
  dispatchFirstDataRenderedEvent() {
    this.dataFirstRenderedFired || (this.dataFirstRenderedFired = !0, Le(this.beans, () => {
      this.beans.eventSvc.dispatchEvent({
        type: "firstDataRendered",
        firstRow: this.firstRenderedRow,
        lastRow: this.lastRenderedRow
      });
    }));
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    const o = this.pinnedRowModel?.ensureRowHeightsValid(), i = this.stickyRowFeature?.ensureRowHeightsValid(), { pageBounds: s, rowModel: n } = this, r = n.ensureRowHeightsValid(
      e,
      t,
      s.getFirstRow(),
      s.getLastRow()
    );
    return (r || i) && this.eventSvc.dispatchEvent({
      type: "recalculateRowBounds"
    }), i || r || o ? (this.updateContainerHeights(), !0) : !1;
  }
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  doNotUnVirtualiseRow(e) {
    const i = e.rowNode, s = this.focusSvc.isRowFocused(i.rowIndex, i.rowPinned), n = this.editSvc?.isEditing(e), r = i.detail;
    return s || n || r ? !!this.isRowPresent(i) : !1;
  }
  isRowPresent(e) {
    return this.rowModel.isRowPresent(e) ? this.beans.pagination?.isRowInPage(e.rowIndex) ?? !0 : !1;
  }
  createRowCon(e, t, o) {
    const i = this.cachedRowCtrls?.getRow(e) ?? null;
    if (i)
      return i;
    const s = o && !this.printLayout && !!this.beans.animationFrameSvc?.active;
    return new Ui(e, this.beans, t, s, this.printLayout);
  }
  getRenderedNodes() {
    const e = Object.values(this.rowCtrlsByRowIndex).map((i) => i.rowNode), t = this.getStickyTopRowCtrls().map((i) => i.rowNode), o = this.getStickyBottomRowCtrls().map((i) => i.rowNode);
    return [...t, ...e, ...o];
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: o } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[o];
        break;
      case "bottom":
        t = this.bottomRowCtrls[o];
        break;
      default:
        t = this.rowCtrlsByRowIndex[o], t || (t = this.getStickyTopRowCtrls().find((i) => i.rowNode.rowIndex === o) || null, t || (t = this.getStickyBottomRowCtrls().find((i) => i.rowNode.rowIndex === o) || null));
        break;
    }
    return t;
  }
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const i = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow) && !i;
  }
}, zm = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.rowNode.id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e?.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.rowNode != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, o = this.entriesMap[t];
    delete this.entriesMap[t], Pe(this.entriesList, o);
  }
  removeFromCache(e) {
    const t = e.rowNode.id;
    delete this.entriesMap[t], Pe(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
};
function $i(e) {
  if (!e)
    return;
  const t = {
    top: {},
    bottom: {},
    normal: {}
  };
  for (const o of e) {
    const i = o.id;
    switch (o.rowPinned) {
      case "top":
        t.top[i] = o;
        break;
      case "bottom":
        t.bottom[i] = o;
        break;
      default:
        t.normal[i] = o;
        break;
    }
  }
  return t;
}
function Ki(e, t) {
  const o = e.id;
  switch (e.rowPinned) {
    case "top":
      return t.top[o] != null;
    case "bottom":
      return t.bottom[o] != null;
    default:
      return t.normal[o] != null;
  }
}
var _m = class extends b {
  constructor() {
    super(...arguments), this.beanName = "rowNodeSorter";
  }
  postConstruct() {
    const { gos: e } = this;
    this.isAccentedSort = e.get("accentedSort"), this.primaryColumnsSortGroups = pe(e), this.addManagedPropertyListener(
      "accentedSort",
      (t) => this.isAccentedSort = t.currentValue
    ), this.addManagedPropertyListener(
      "autoGroupColumnDef",
      () => this.primaryColumnsSortGroups = pe(e)
    );
  }
  doFullSort(e, t) {
    const o = e.map((i, s) => ({
      currentPos: s,
      rowNode: i
    }));
    return o.sort(this.compareRowNodes.bind(this, t)), o.map((i) => i.rowNode);
  }
  compareRowNodes(e, t, o) {
    const i = t.rowNode, s = o.rowNode;
    for (let n = 0, r = e.length; n < r; n++) {
      const l = e[n], a = l.sort === "desc", d = this.getValue(i, l.column), c = this.getValue(s, l.column);
      let u;
      const h = this.getComparator(l, i);
      if (h ? u = h(d, c, i, s, a) : u = Nl(d, c, this.isAccentedSort), !isNaN(u) && u !== 0)
        return l.sort === "asc" ? u : u * -1;
    }
    return t.currentPos - o.currentPos;
  }
  getComparator(e, t) {
    const o = e.column, i = o.getColDef().comparator;
    if (i != null)
      return i;
    if (!o.getColDef().showRowGroup)
      return;
    const s = !t.group && o.getColDef().field;
    if (!s)
      return;
    const n = this.beans.colModel.getColDefCol(s);
    if (n)
      return n.getColDef().comparator;
  }
  getValue(e, t) {
    const { valueSvc: o, colModel: i, showRowGroupCols: s, gos: n } = this.beans;
    if (!this.primaryColumnsSortGroups)
      return o.getValue(t, e, !1);
    if (e.rowGroupColumn === t) {
      if (er(n, i.isPivotActive())) {
        const d = e.data ? e : Cu(e.childrenAfterGroup);
        return d && o.getValue(t, d, !1);
      }
      const a = s?.getShowRowGroupCol(t.getId());
      return a ? e.groupData?.[a.getId()] : void 0;
    }
    if (!(e.group && t.getColDef().showRowGroup))
      return o.getValue(t, e, !1);
  }
};
function Um(e) {
  e.sortSvc?.onSortChanged("api");
}
var Fl = {
  moduleName: "Sort",
  version: M,
  beans: [rC, _m],
  apiFunctions: {
    onSortChanged: Um
  },
  userComponents: {
    agSortIndicator: ys
  },
  icons: {
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none"
  }
}, $m = class extends b {
  constructor() {
    super(...arguments), this.beanName = "syncSvc", this.waitingForColumns = !1;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.beans.ctrlsSvc.whenReady(this, () => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    const { colModel: t, rowModel: o } = this.beans;
    t.setColumnDefs(e ?? [], "gridInitializing"), o.start();
  }
  gridReady() {
    const { eventSvc: e, gos: t } = this;
    e.dispatchEvent({
      type: "gridReady"
    }), Vt(t, `initialised successfully, enterprise = ${t.isModuleRegistered("EnterpriseCore")}`);
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t) {
      if (this.waitingForColumns) {
        this.waitingForColumns = !1, this.setColumnsAndData(t);
        return;
      }
      this.beans.colModel.setColumnDefs(t, lt(e.source));
    }
  }
}, Km = "paste", jm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "changeDetectionSvc", this.clientSideRowModel = null;
  }
  postConstruct() {
    const { gos: e, rowModel: t } = this.beans;
    re(e) && (this.clientSideRowModel = t), this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this) });
  }
  onCellValueChanged(e) {
    const { gos: t, rowRenderer: o } = this.beans;
    if (e.source === Km || t.get("suppressChangeDetection"))
      return;
    const i = e.node, s = [i], n = this.clientSideRowModel, r = n?.rootNode;
    if (r && !i.isRowPinned()) {
      const l = t.get("aggregateOnlyChangedColumns"), a = new Ho(l, r);
      a.addParentNode(i.parent, [e.column]), n.doAggregate(a), a.forEachChangedNodeDepthFirst((d) => {
        s.push(d), d.sibling && s.push(d.sibling);
      });
    }
    o.refreshCells({ rowNodes: s });
  }
}, qm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "expressionSvc", this.cache = {};
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    W(15, { expression: e });
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(
        t.value,
        t.context,
        t.oldValue,
        t.newValue,
        t.value,
        t.node,
        t.data,
        t.colDef,
        t.rowIndex,
        t.api,
        t.getValue,
        t.column,
        t.columnGroup
      );
    } catch (o) {
      return W(16, { expression: e, params: t, e: o }), null;
    }
  }
  createExpressionFunction(e) {
    const t = this.cache;
    if (t[e])
      return t[e];
    const o = this.createFunctionBody(e), i = new Function(
      "x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup",
      o
    );
    return t[e] = i, i;
  }
  createFunctionBody(e) {
    return e.includes("return") ? e : "return " + e + ";";
  }
}, Ym = {
  moduleName: "Expression",
  version: M,
  beans: [qm]
}, Zm = {
  moduleName: "ChangeDetection",
  version: M,
  beans: [jm]
}, Qm = class extends b {
  constructor() {
    super(...arguments), this.beanName = "valueSvc", this.hasEditSvc = !1, this.initialised = !1, this.isSsrm = !1;
  }
  wireBeans(e) {
    this.expressionSvc = e.expressionSvc, this.colModel = e.colModel, this.valueCache = e.valueCache, this.dataTypeSvc = e.dataTypeSvc, this.editSvc = e.editSvc, this.hasEditSvc = !!e.editSvc;
  }
  postConstruct() {
    this.initialised || this.init();
  }
  init() {
    this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this), this.isSsrm = rs(this.gos), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (t) => this.callColumnCellValueChangedHandler(t);
    this.eventSvc.addListener("cellValueChanged", e, !0), this.addDestroyFunc(() => this.eventSvc.removeListener("cellValueChanged", e, !0)), this.addManagedPropertyListener("treeData", (t) => this.isTreeData = t.currentValue);
  }
  /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */
  getValueForDisplay(e, t, o = !1, i = !1, s = "ui") {
    const { showRowGroupColValueSvc: n } = this.beans, r = !e && t.group, l = e?.colDef.showRowGroup, a = !this.isTreeData || t.footer;
    if (n && a && (r || l)) {
      const f = n.getGroupValue(t, e);
      if (f == null)
        return {
          value: null,
          valueFormatted: null
        };
      if (!o)
        return {
          value: f.value,
          valueFormatted: null
        };
      const C = n.formatAndPrefixGroupColValue(f, e, i);
      return {
        value: f.value,
        valueFormatted: C
      };
    }
    if (!e)
      return {
        value: t.key,
        valueFormatted: null
      };
    const d = t.leafGroup && this.colModel.isPivotMode(), c = t.group && t.expanded && !t.footer && !d, u = this.gos.get("groupSuppressBlankHeader") || !t.sibling, h = c && !u, g = this.getValue(e, t, h, s), p = o && !(i && e.colDef.useValueFormatterForExport === !1);
    return {
      value: g,
      valueFormatted: p ? this.formatValue(e, t, g) : null
    };
  }
  getValue(e, t, o = !1, i = "ui") {
    if (this.initialised || this.init(), !t)
      return;
    const s = e.getColDef(), n = s.field, r = e.getColId(), l = t.data;
    if (this.hasEditSvc && i === "ui") {
      const f = this.editSvc;
      if (f.isEditing()) {
        const C = f.getCellDataValue({ rowNode: t, column: e }, !0);
        if (C !== void 0)
          return C;
      }
    }
    let a;
    const d = s.showRowGroup;
    if (typeof d == "string" && (this.beans.rowGroupColsSvc?.getColumnIndex(d) ?? -1) > t.level)
      return null;
    const c = typeof d != "string" || !t.group, u = t.groupData && r in t.groupData, h = !o && t.aggData && t.aggData[r] !== void 0, g = this.isSsrm && o && !!s.aggFunc, p = this.isSsrm && t.footer && t.field && (s.showRowGroup === !0 || s.showRowGroup === t.field);
    if (this.isTreeData && h)
      a = t.aggData[r];
    else if (this.isTreeData && s.valueGetter)
      a = this.executeValueGetter(s.valueGetter, l, e, t);
    else if (this.isTreeData && n && l)
      a = fo(l, n, e.isFieldContainsDots());
    else if (u)
      a = t.groupData[r];
    else if (h)
      a = t.aggData[r];
    else if (s.valueGetter && !g) {
      if (!c)
        return a;
      a = this.executeValueGetter(s.valueGetter, l, e, t);
    } else if (p)
      a = fo(l, t.field, e.isFieldContainsDots());
    else if (n && l && !g) {
      if (!c)
        return a;
      a = fo(l, n, e.isFieldContainsDots());
    }
    if (this.cellExpressions && typeof a == "string" && a.indexOf("=") === 0) {
      const f = a.substring(1);
      a = this.executeValueGetter(f, l, e, t);
    }
    return a;
  }
  parseValue(e, t, o, i) {
    const s = e.getColDef(), n = s.valueParser;
    if (A(n)) {
      const r = L(this.gos, {
        node: t,
        data: t?.data,
        oldValue: i,
        newValue: o,
        colDef: s,
        column: e
      });
      return typeof n == "function" ? n(r) : this.expressionSvc?.evaluate(n, r);
    }
    return o;
  }
  getDeleteValue(e, t) {
    return A(e.getColDef().valueParser) ? this.parseValue(e, t, "", this.getValueForDisplay(e, t).value) ?? null : null;
  }
  formatValue(e, t, o, i, s = !0) {
    const { expressionSvc: n } = this.beans;
    let r = null, l;
    const a = e.getColDef();
    if (i ? l = i : s && (l = a.valueFormatter), l) {
      const d = t ? t.data : null, c = L(this.gos, {
        value: o,
        node: t,
        data: d,
        colDef: a,
        column: e
      });
      typeof l == "function" ? r = l(c) : r = n ? n.evaluate(l, c) : null;
    } else if (a.refData)
      return a.refData[o] || "";
    return r == null && Array.isArray(o) && (r = o.join(", ")), r;
  }
  /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */
  setValue(e, t, o, i) {
    const s = this.colModel.getColDefCol(t);
    if (!e || !s)
      return !1;
    H(e.data) && (e.data = {});
    const { field: n, valueSetter: r } = s.getColDef();
    if (H(n) && H(r))
      return F(17), !1;
    if (this.dataTypeSvc && !this.dataTypeSvc.checkType(s, o))
      return F(135), !1;
    const l = L(this.gos, {
      node: e,
      data: e.data,
      oldValue: this.getValue(s, e, void 0, i),
      newValue: o,
      colDef: s.getColDef(),
      column: s
    });
    l.newValue = o;
    let a;
    if (A(r) ? typeof r == "function" ? a = r(l) : a = this.expressionSvc?.evaluate(r, l) : a = this.setValueUsingField(e.data, n, o, s.isFieldContainsDots()), a === void 0 && (a = !0), !a)
      return !1;
    e.resetQuickFilterAggregateText(), this.valueCache?.onDataChanged();
    const d = this.getValue(s, e);
    return this.dispatchCellValueChangedEvent(e, l, d, i), e.pinnedSibling && this.dispatchCellValueChangedEvent(e.pinnedSibling, l, d, i), !0;
  }
  dispatchCellValueChangedEvent(e, t, o, i) {
    this.eventSvc.dispatchEvent({
      type: "cellValueChanged",
      event: null,
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: t.column,
      colDef: t.colDef,
      data: e.data,
      node: e,
      oldValue: t.oldValue,
      newValue: o,
      value: o,
      source: i
    });
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => {
      t({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        context: e.context
      });
    });
  }
  setValueUsingField(e, t, o, i) {
    if (!t)
      return !1;
    let s = !1;
    if (!i)
      s = e[t] === o, s || (e[t] = o);
    else {
      const n = t.split(".");
      let r = e;
      for (; n.length > 0 && r; ) {
        const l = n.shift();
        n.length === 0 ? (s = r[l] === o, s || (r[l] = o)) : r = r[l];
      }
    }
    return !s;
  }
  executeValueGetterWithValueCache(e, t, o, i) {
    const s = o.getColId(), n = this.valueCache.getValue(i, s);
    if (n !== void 0)
      return n;
    const r = this.executeValueGetterWithoutValueCache(e, t, o, i);
    return this.valueCache.setValue(i, s, r), r;
  }
  executeValueGetterWithoutValueCache(e, t, o, i) {
    const s = L(this.gos, {
      data: t,
      node: i,
      column: o,
      colDef: o.getColDef(),
      getValue: this.getValueCallback.bind(this, i)
    });
    let n;
    return typeof e == "function" ? n = e(s) : n = this.expressionSvc?.evaluate(e, s), n;
  }
  getValueCallback(e, t) {
    const o = this.colModel.getColDefCol(t);
    return o ? this.getValue(o, e) : null;
  }
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  getKeyForNode(e, t) {
    const o = this.getValue(e, t), i = e.getColDef().keyCreator;
    let s = o;
    if (i) {
      const n = L(this.gos, {
        value: o,
        colDef: e.getColDef(),
        column: e,
        node: t,
        data: t.data
      });
      s = i(n);
    }
    return typeof s == "string" || s == null || (s = String(s), s === "[object Object]" && F(121)), s;
  }
}, Xm = {
  moduleName: "CommunityCore",
  version: M,
  beans: [
    oC,
    ug,
    lf,
    Td,
    Vm,
    vp,
    Zf,
    DC,
    Pd,
    bm,
    Sm,
    Nm,
    Qm,
    eC,
    Yf,
    tC,
    df,
    $m,
    tf,
    of,
    OC
  ],
  icons: {
    // icon on select dropdowns (select cell editor, charts tool panels)
    selectOpen: "small-down",
    /** @deprecated v33 */
    smallDown: "small-down",
    /** @deprecated v33 */
    colorPicker: "color-picker",
    /** @deprecated v33 */
    smallUp: "small-up",
    /** @deprecated v33 */
    checkboxChecked: "small-up",
    /** @deprecated v33 */
    checkboxIndeterminate: "checkbox-indeterminate",
    /** @deprecated v33 */
    checkboxUnchecked: "checkbox-unchecked",
    /** @deprecated v33 */
    radioButtonOn: "radio-button-on",
    /** @deprecated v33 */
    radioButtonOff: "radio-button-off",
    /** @deprecated v33 */
    smallLeft: "small-left",
    /** @deprecated v33 */
    smallRight: "small-right"
  },
  apiFunctions: {
    getGridId: hg,
    destroy: gg,
    isDestroyed: pg,
    getGridOption: fg,
    setGridOption: Cg,
    updateGridOptions: tl,
    isModuleRegistered: mg
  },
  dependsOn: [
    Xp,
    Zg,
    ip,
    Fl,
    kC,
    Sp,
    LC,
    Bm,
    Zm,
    HC,
    wm,
    Pm,
    Fm,
    VC,
    rf,
    Jp,
    Ym,
    xp,
    Mm
  ]
}, El = {
  AdvancedFilter: 1,
  AiToolkit: 1,
  AllEnterprise: 1,
  BatchEdit: 1,
  CellSelection: 1,
  Clipboard: 1,
  ColumnMenu: 1,
  ColumnsToolPanel: 1,
  ContextMenu: 1,
  ExcelExport: 1,
  FiltersToolPanel: 1,
  Find: 1,
  GridCharts: 1,
  IntegratedCharts: 1,
  GroupFilter: 1,
  MasterDetail: 1,
  Menu: 1,
  MultiFilter: 1,
  NewFiltersToolPanel: 1,
  Pivot: 1,
  RangeSelection: 1,
  RichSelect: 1,
  RowNumbers: 1,
  RowGrouping: 1,
  RowGroupingPanel: 1,
  ServerSideRowModelApi: 1,
  ServerSideRowModel: 1,
  SetFilter: 1,
  SideBar: 1,
  Sparklines: 1,
  StatusBar: 1,
  TreeData: 1,
  ViewportRowModel: 1
}, vi = [
  "TextFilter",
  "NumberFilter",
  "DateFilter",
  "SetFilter",
  "MultiFilter",
  "GroupFilter",
  "CustomFilter"
], Jm = {
  EditCore: [
    "TextEditor",
    "NumberEditor",
    "DateEditor",
    "CheckboxEditor",
    "LargeTextEditor",
    "SelectEditor",
    "RichSelect",
    "CustomEditor"
  ],
  CheckboxCellRenderer: ["AllCommunity"],
  ClientSideRowModelHierarchy: ["RowGrouping", "Pivot", "TreeData"],
  ColumnFilter: vi,
  ColumnGroupHeaderComp: ["AllCommunity"],
  ColumnGroup: ["AllCommunity"],
  ColumnHeaderComp: ["AllCommunity"],
  ColumnMove: ["AllCommunity"],
  ColumnResize: ["AllCommunity"],
  CommunityCore: ["AllCommunity"],
  CsrmSsrmSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  RowModelSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  EnterpriseCore: ["AllEnterprise"],
  FilterCore: [...vi, "QuickFilter", "ExternalFilter", "AdvancedFilter"],
  GroupCellRenderer: ["RowGrouping", "Pivot", "TreeData", "MasterDetail", "ServerSideRowModel"],
  KeyboardNavigation: ["AllCommunity"],
  LoadingCellRenderer: ["ServerSideRowModel"],
  MenuCore: ["ColumnMenu", "ContextMenu"],
  MenuItem: ["ColumnMenu", "ContextMenu", "MultiFilter", "IntegratedCharts", "ColumnsToolPanel"],
  Overlay: ["AllCommunity"],
  PinnedColumn: ["AllCommunity"],
  SharedAggregation: ["RowGrouping", "Pivot", "TreeData", "ServerSideRowModel"],
  SharedDragAndDrop: ["AllCommunity"],
  SharedMasterDetail: ["MasterDetail", "ServerSideRowModel"],
  SharedMenu: [...vi, "ColumnMenu", "ContextMenu"],
  SharedPivot: ["Pivot", "ServerSideRowModel"],
  SharedRowGrouping: ["RowGrouping", "ServerSideRowModel"],
  SharedRowSelection: ["RowSelection", "ServerSideRowModel"],
  SkeletonCellRenderer: ["ServerSideRowModel"],
  Sort: ["AllCommunity"],
  SsrmInfiniteSharedApi: ["InfiniteRowModel", "ServerSideRowModelApi"],
  SharedTreeData: ["TreeData", "ServerSideRowModel"]
}, ev = {
  InfiniteRowModel: "infinite",
  ClientSideRowModelApi: "clientSide",
  ClientSideRowModel: "clientSide",
  ServerSideRowModelApi: "serverSide",
  ServerSideRowModel: "serverSide",
  ViewportRowModel: "viewport"
};
function tv(e, t) {
  const o = [];
  for (const i of Array.isArray(e) ? e : [e]) {
    const s = Jm[i];
    if (s)
      for (const n of s) {
        const r = ev[n];
        (!r || r === t) && o.push(n);
      }
    else
      o.push(i);
  }
  return o;
}
var Al = () => `No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `, ov = (e) => {
  const t = e.map(
    (i) => `import { ${Lt(i)} } from '${El[i] ? "ag-grid-enterprise" : "ag-grid-community"}';`
  );
  return e.some((i) => i === "IntegratedCharts" || i === "Sparklines") && t.push("import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';"), `import { ModuleRegistry } from 'ag-grid-community'; 
${t.join(` 
`)} 

ModuleRegistry.registerModules([ ${e.map((i) => Lt(i, !0)).join(", ")} ]); 

For more info see: ${st}/modules/`;
};
function Lt(e, t = !1) {
  return t && (e === "IntegratedCharts" || e === "Sparklines") ? `${e}Module.with(AgChartsEnterpriseModule)` : `${e}Module`;
}
function iv(e, t) {
  const o = t.filter((n) => n === "IntegratedCharts" || n === "Sparklines");
  let i = "";
  return !globalThis?.agCharts && o.length > 0 ? i = `Unable to use ${e} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
` : t.some((n) => El[n]) && (i = i + `Unable to use ${e} as that requires the ag-grid-enterprise script to be included.
`), i;
}
function Ml({
  moduleName: e,
  rowModelType: t
}) {
  return `To use the ${e}Module you must set the gridOption "rowModelType='${t}'"`;
}
var fn = ({
  reasonOrId: e,
  moduleName: t,
  gridScoped: o,
  gridId: i,
  rowModelType: s,
  additionalText: n,
  isUmd: r
}) => {
  const l = tv(t, s), a = typeof e == "string" ? e : lv[e];
  if (r)
    return iv(a, l);
  const d = l.filter((h) => h === "IntegratedCharts" || h === "Sparklines"), c = d.length > 0 ? `${d.map((h) => Lt(h)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
  return `${`Unable to use ${a} as ${l.length > 1 ? "one of " + l.map((h) => Lt(h)).join(", ") : Lt(l[0])} is not registered${o ? " for gridId: " + i : ""}. ${c} Check if you have registered the module:
`}
${ov(l)}` + (n ? ` 

${n}` : "");
}, Cn = (e) => `${e} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${e} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${e}.with(AgChartsEnterpriseModule)]);
    `, sv = (e) => `AG Grid: Unable to use the Clipboard API (navigator.clipboard.${e}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`, nv = {
  1: () => "`rowData` must be an array",
  2: ({ nodeId: e }) => `Duplicate node id '${e}' detected from getRowId callback, this could cause issues in your grid.`,
  3: () => "Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
  4: ({ id: e }) => `Could not find row id=${e}, data item was not found for this id`,
  5: ({ data: e }) => [
    "Could not find data item as object was not found.",
    e,
    " Consider using getRowId to help the Grid find matching row data"
  ],
  6: () => "'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'",
  7: () => "Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
  8: ({ key: e }) => `Unknown key for navigation ${e}`,
  9: ({ variable: e }) => `No value for ${e?.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${e?.defaultValue} will be used and updated when styles load.`,
  10: ({ eventType: e }) => `As of v33, the '${e}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
  11: () => "No gridOptions provided to createGrid",
  12: ({ colKey: e }) => ["column ", e, " not found"],
  13: () => "Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
  14: ({ groupPrefix: e }) => `Row IDs cannot start with ${e}, this is a reserved prefix for AG Grid's row grouping feature.`,
  15: ({ expression: e }) => ["value should be either a string or a function", e],
  16: ({ expression: e, params: t, e: o }) => [
    "Processing of the expression failed",
    "Expression = ",
    e,
    "Params = ",
    t,
    "Exception = ",
    o
  ],
  17: () => "you need either field or valueSetter set on colDef for editing to work",
  18: () => "alignedGrids contains an undefined option.",
  19: () => "alignedGrids - No api found on the linked grid.",
  20: () => `You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
  21: () => "pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
  22: ({ key: e }) => `${e} is an initial property and cannot be updated.`,
  23: () => "The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
  24: () => "row height must be a number if not using standard row model",
  25: ({ id: e }) => ["The getRowId callback must return a string. The ID ", e, " is being cast to a string."],
  26: ({ fnName: e, preDestroyLink: t }) => `Grid API function ${e}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${t}`,
  27: ({ fnName: e, module: t }) => `API function '${e}' not registered to module '${t}'`,
  28: () => "setRowCount cannot be used while using row grouping.",
  29: () => "tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
  30: ({ toIndex: e }) => [
    "tried to insert columns in invalid location, toIndex = ",
    e,
    "remember that you should not count the moving columns when calculating the new index"
  ],
  31: () => "infinite loop in resizeColumnSets",
  32: () => "applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
  33: () => "stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
  34: ({ key: e }) => `the column type '${e}' is a default column type and cannot be overridden.`,
  35: () => "Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.",
  36: ({ t: e }) => "colDef.type '" + e + "' does not correspond to defined gridOptions.columnTypes",
  37: () => "Changing the column pinning status is not allowed with domLayout='print'",
  38: ({ iconName: e }) => `provided icon '${e}' needs to be a string or a function`,
  39: () => "Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
  40: ({ e, method: t }) => `${e}
${sv(t)}`,
  41: () => "Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
  42: () => "Browser does not support document.execCommand('copy') for clipboard operations",
  43: ({ iconName: e }) => `As of v33, icon '${e}' is deprecated. Use the icon CSS name instead.`,
  44: () => 'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
  45: ({ parentCellDataType: e }) => `The data type definition ${e} does not exist.`,
  46: () => 'The "baseDataType" property of a data type definition must match that of its parent.',
  47: ({ cellDataType: e }) => `Missing data type definition - "${e}"`,
  48: ({ property: e }) => `Cell data type is "object" but no Value ${e} has been provided. Please either provide an object data type definition with a Value ${e}, or set "colDef.value${e}"`,
  49: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  50: ({ compName: e }) => `Could not find component ${e}, did you forget to configure this component?`,
  51: () => "Export cancelled. Export is not allowed as per your configuration.",
  52: () => "There is no `window` associated with the current `document`",
  53: () => "unknown value type during csv conversion",
  54: () => "Could not find document body, it is needed for drag and drop and context menu.",
  55: () => "addRowDropZone - A container target needs to be provided",
  56: () => "addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
  57: () => "unable to show popup filter, filter instantiation failed",
  58: () => "no values found for select cellEditor",
  59: () => "cannot select pinned rows",
  60: () => "cannot select node until it has finished loading",
  61: () => "since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
  62: ({ colId: e }) => `setFilterModel() - no column found for colId: ${e}`,
  63: ({ colId: e }) => `setFilterModel() - unable to fully apply model, filtering disabled for colId: ${e}`,
  64: ({ colId: e }) => `setFilterModel() - unable to fully apply model, unable to create filter for colId: ${e}`,
  65: () => "filter missing setModel method, which is needed for setFilterModel",
  66: () => "filter API missing getModel method, which is needed for getFilterModel",
  67: () => "Filter is missing isFilterActive() method",
  68: () => "Column Filter API methods have been disabled as Advanced Filters are enabled.",
  69: ({ guiFromFilter: e }) => `getGui method from filter returned ${e}; it should be a DOM element.`,
  70: ({ newFilter: e }) => `Grid option quickFilterText only supports string inputs, received: ${typeof e}`,
  71: () => "debounceMs is ignored when apply button is present",
  72: ({ keys: e }) => ["ignoring FilterOptionDef as it doesn't contain one of ", e],
  73: () => "invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'",
  74: () => "no filter options for filter",
  75: () => "Unknown button type specified",
  76: ({ filterModelType: e }) => [
    'Unexpected type of filter "',
    e,
    '", it looks like the filter was configured with incorrect Filter Options'
  ],
  77: () => "Filter model is missing 'conditions'",
  78: () => 'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
  79: () => '"filterParams.maxNumConditions" must be greater than or equal to zero.',
  80: () => '"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
  81: () => '"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
  82: ({ param: e }) => `DateFilter ${e} is not a number`,
  83: () => "DateFilter minValidYear should be <= maxValidYear",
  84: () => "DateFilter minValidDate should be <= maxValidDate",
  85: () => "DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
  86: () => "DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
  87: () => "DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
  88: ({ index: e }) => `Invalid row index for ensureIndexVisible: ${e}`,
  89: () => "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)",
  90: () => "datasource is missing getRows method",
  91: () => "Filter is missing method doesFilterPass",
  92: () => "AnimationFrameService called but animation frames are off",
  93: () => "cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
  94: ({
    paginationPageSizeOption: e,
    pageSizeSet: t,
    pageSizesSet: o,
    pageSizeOptions: i
  }) => `'paginationPageSize=${e}'${t ? "" : " (default value)"}, but ${e} is not included in${o ? "" : " the default"} paginationPageSizeSelector=[${i?.join(", ")}].`,
  95: ({
    paginationPageSizeOption: e,
    paginationPageSizeSelector: t
  }) => `Either set '${t}' to an array that includes ${e} or to 'false' to disable the page size selector.`,
  96: ({ id: e, data: t }) => [
    "Duplicate ID",
    e,
    "found for pinned row with data",
    t,
    "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
  ],
  97: ({ colId: e }) => `cellEditor for column ${e} is missing getGui() method`,
  98: () => "popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
  99: () => "Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
  // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
  //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
  101: ({
    propertyName: e,
    componentName: t,
    agGridDefaults: o,
    jsComps: i
  }) => {
    const s = [], n = [
      // Don't include the old names / internals in potential suggestions
      ...Object.keys(o ?? []).filter(
        (l) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(l)
      ),
      ...Object.keys(i ?? []).filter((l) => !!i[l])
    ], r = Hi({
      inputValue: t,
      allSuggestions: n,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return s.push(
      `Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.
`
    ), r.length > 0 && s.push(`         Did you mean: [${r.slice(0, 3)}]?
`), s.push("If using a custom component check it has been registered correctly."), s;
  },
  102: () => "selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
  103: () => "Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
  104: ({ value: e, param: t }) => `Numeric value ${e} passed to ${t} param will be interpreted as ${e} seconds. If this is intentional use "${e}s" to silence this warning.`,
  105: ({ e }) => ["chart rendering failed", e],
  106: () => `Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${st}/theming-migration/`,
  107: ({ key: e, value: t }) => `Invalid value for theme param ${e} - ${t}`,
  108: ({ e }) => ["chart update failed", e],
  109: ({ inputValue: e, allSuggestions: t }) => {
    const o = Hi({
      inputValue: e,
      allSuggestions: t,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return [
      `Could not find '${e}' aggregate function. It was configured as "aggFunc: '${e}'" but it wasn't found in the list of registered aggregations.`,
      o.length > 0 ? `         Did you mean: [${o.slice(0, 3)}]?` : "",
      "If using a custom aggregation function check it has been registered correctly."
    ].join(`
`);
  },
  110: () => "groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
  111: () => "Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
  113: () => "Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
  114: ({ component: e }) => `Could not find component with name of ${e}. Is it in Vue.components?`,
  // 115: () => 'The provided selection state should be an object.' as const,
  116: () => "Invalid selection state. The state must conform to `IServerSideSelectionState`.",
  117: () => "selectAll must be of boolean type.",
  118: () => "Infinite scrolling must be enabled in order to set the row count.",
  119: () => "Unable to instantiate filter",
  120: () => "MultiFloatingFilterComp expects MultiFilter as its parent",
  121: () => "a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
  122: () => "could not find the document, document is empty",
  123: () => "Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
  124: () => "No active charts to update.",
  125: ({ chartId: e }) => `Unable to update chart. No active chart found with ID: ${e}.`,
  126: () => "unable to restore chart as no chart model is provided",
  127: ({ allRange: e }) => `unable to create chart as ${e ? "there are no columns in the grid" : "no range is selected"}.`,
  128: ({ feature: e }) => `${e} is only available if using 'multiRow' selection mode.`,
  129: ({ feature: e, rowModel: t }) => `${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`,
  130: () => 'cannot multi select unless selection mode is "multiRow"',
  // 131: () => 'cannot range select while selecting multiple rows' as const,
  132: () => "Row selection features are not available unless `rowSelection` is enabled.",
  133: ({ iconName: e }) => `icon '${e}' function should return back a string or a dom object`,
  134: ({ iconName: e }) => `Did not find icon '${e}'`,
  135: () => "Data type of the new value does not match the cell data type of the column",
  136: () => "Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
  137: ({ type: e, currentChartType: t }) => `Unable to update chart as a '${e}' update type is not permitted on a ${t}.`,
  138: ({ chartType: e }) => `invalid chart type supplied: ${e}`,
  139: ({ customThemeName: e }) => `a custom chart theme with the name ${e} has been supplied but not added to the 'chartThemes' list`,
  140: ({ name: e }) => `no stock theme exists with the name '${e}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
  141: () => "cross filtering with row grouping is not supported.",
  142: () => "cross filtering is only supported in the client side row model.",
  143: ({ panel: e }) => `'${e}' is not a valid Chart Tool Panel name`,
  144: ({ type: e }) => `Invalid charts data panel group name supplied: '${e}'`,
  145: ({ group: e }) => `As of v32, only one charts customize panel group can be expanded at a time. '${e}' will not be expanded.`,
  146: ({ comp: e }) => `Unable to instantiate component '${e}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
  147: ({ group: e }) => `Invalid charts customize panel group name supplied: '${e}'`,
  148: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  149: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  150: () => "'seriesChartTypes' are required when the 'customCombo' chart type is specified.",
  151: ({ chartType: e }) => `invalid chartType '${e}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
  152: ({ colId: e }) => `no 'seriesChartType' found for colId = '${e}', defaulting to 'line'.`,
  153: ({ chartDataType: e }) => `unexpected chartDataType value '${e}' supplied, instead use 'category', 'series' or 'excluded'`,
  154: ({ colId: e }) => `cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${e}`,
  155: ({ option: e }) => `'${e}' is not a valid Chart Toolbar Option`,
  156: ({ panel: e }) => `Invalid panel in chartToolPanelsDef.panels: '${e}'`,
  157: ({ unrecognisedGroupIds: e }) => ["unable to find group(s) for supplied groupIds:", e],
  158: () => "can not expand a column item that does not represent a column group header",
  159: () => "Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
  160: () => "Export cancelled. Export is not allowed as per your configuration.",
  161: () => "The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
  162: ({ id: e, dataType: t }) => `Unrecognized data type for excel export [${e}.dataType=${t}]`,
  163: ({ featureName: e }) => `Excel table export does not work with ${e}. The exported Excel file will not contain any Excel tables.
 Please turn off ${e} to enable Excel table exports.`,
  164: () => "Unable to add data table to Excel sheet: A table already exists.",
  165: () => "Unable to add data table to Excel sheet: Missing required parameters.",
  166: ({ unrecognisedGroupIds: e }) => ["unable to find groups for these supplied groupIds:", e],
  167: ({ unrecognisedColIds: e }) => ["unable to find columns for these supplied colIds:", e],
  168: () => "detailCellRendererParams.template should be function or string",
  169: () => 'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
  170: ({ providedStrategy: e }) => `invalid cellRendererParams.refreshStrategy = ${e} supplied, defaulting to refreshStrategy = 'rows'.`,
  171: () => "could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
  172: () => "could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
  173: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  174: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  175: ({ menuTabName: e, itemsToConsider: t }) => [
    `Trying to render an invalid menu item '${e}'. Check that your 'menuTabs' contains one of `,
    t
  ],
  176: ({ key: e }) => `unknown menu item type ${e}`,
  177: () => "valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.",
  178: ({ colId: e }) => `column ${e} is not visible`,
  179: () => "totalValueGetter should be either a function or a string (expression)",
  180: () => "agRichSelectCellEditor requires cellEditorParams.values to be set",
  181: () => "agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
  182: () => 'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
  183: () => "Group Column Filter only works on group columns. Please use a different filter.",
  184: ({ parentGroupData: e, childNodeData: t }) => ["duplicate group keys for row data, keys should be unique", [e, t]],
  185: ({ data: e }) => ["getDataPath() should not return an empty path", [e]],
  186: ({
    rowId: e,
    rowData: t,
    duplicateRowsData: o
  }) => [
    "duplicate group keys for row data, keys should be unique",
    e,
    t,
    ...o ?? []
  ],
  187: ({ rowId: e, firstData: t, secondData: o }) => [
    `Duplicate node id ${e}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
    "first instance",
    t,
    "second instance",
    o
  ],
  188: (e) => `getRowId callback must be provided for Server Side Row Model ${e?.feature || "selection"} to work correctly.`,
  189: ({ startRow: e }) => `invalid value ${e} for startRow, the value should be >= 0`,
  190: ({ rowGroupId: e, data: t }) => [
    "null and undefined values are not allowed for server side row model keys",
    e ? `column = ${e}` : "",
    "data is ",
    t
  ],
  // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  // 192: () => `cannot use range selection when multi selecting rows` as const,
  // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
  194: ({ method: e }) => `calling gridApi.${e}() is only possible when using rowModelType=\`clientSide\`.`,
  195: ({ justCurrentPage: e }) => `selecting just ${e ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
  196: ({ key: e }) => `Provided ids must be of string type. Invalid id provided: ${e}`,
  197: () => "`toggledNodes` must be an array of string ids.",
  // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  199: () => "getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  200: fn,
  201: ({ rowModelType: e }) => `Could not find row model for rowModelType = ${e}`,
  202: () => "`getSelectedNodes` and `getSelectedRows` functions cannot be used with `groupSelectsChildren` and the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  203: () => "Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
  204: () => "Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
  205: ({ duplicateIdText: e }) => `Unable to display rows as duplicate row ids (${e}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
  206: () => "getRowId callback must be implemented for transactions to work. Transaction was ignored.",
  207: () => 'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
  208: () => "Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.",
  209: () => `Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${st}/filter-set-filter-list/#filter-value-types`,
  210: () => "Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
  211: () => "property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
  212: () => "please review all your toolPanel components, it seems like at least one of them doesn't have an id",
  213: () => "Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
  214: ({ key: e }) => `unable to lookup Tool Panel as invalid key supplied: ${e}`,
  215: ({ key: e, defaultByKey: t }) => `the key ${e} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(t ?? {}).join(",")}`,
  216: ({ name: e }) => `Missing component for '${e}'`,
  217: ({ invalidColIds: e }) => ["unable to find grid columns for the supplied colDef(s):", e],
  218: ({ property: e, defaultOffset: t }) => `${e} must be a number, the value you provided is not a valid number. Using the default of ${t}px.`,
  219: ({ property: e }) => `Property ${e} does not exist on the target object.`,
  220: ({ lineDash: e }) => `'${e}' is not a valid 'lineDash' option.`,
  221: () => "agAggregationComponent should only be used with the client and server side row model.",
  222: () => "agFilteredRowCountComponent should only be used with the client side row model.",
  223: () => "agSelectedRowCountComponent should only be used with the client and server side row model.",
  224: () => "agTotalAndFilteredRowCountComponent should only be used with the client side row model.",
  225: () => "agTotalRowCountComponent should only be used with the client side row model.",
  226: () => "viewport is missing init method.",
  227: () => "menu item icon must be DOM node or string",
  228: ({ menuItemOrString: e }) => `unrecognised menu item ${e}`,
  229: ({ index: e }) => ["invalid row index for ensureIndexVisible: ", e],
  230: () => "detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
  // @deprecated v32 mark for removal as part of v32 deprecated features
  231: () => "As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
  232: () => "Using both rowData and v-model. rowData will be ignored.",
  233: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  234: () => 'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
  235: () => 'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
  236: () => 'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
  237: () => "Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
  238: () => "setRowCount can only accept a positive row count.",
  239: () => 'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
  240: ({ theme: e }) => `theme grid option must be a Theming API theme object or the string "legacy", received: ${e}`,
  // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
  // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
  243: () => "Failed to deserialize state - each provided state object must be an object.",
  244: () => "Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
  245: () => "Failed to deserialize state - `toggledNodes` must be an array.",
  246: () => "Failed to deserialize state - Every `toggledNode` requires an associated string id.",
  247: () => `Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
  248: () => "SetFloatingFilter expects SetFilter as its parent",
  249: () => "Must supply a Value Formatter in Set Filter params when using a Key Creator",
  250: () => "Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
  251: ({ chartType: e }) => `AG Grid: Unable to create chart as an invalid chartType = '${e}' was supplied.`,
  252: () => `cannot get grid to draw rows when it is in the middle of drawing rows. 
Your code probably called a grid API method while the grid was in the render stage. 
To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). 
To see what part of your code that caused the refresh check this stacktrace.`,
  253: ({ version: e }) => ["Illegal version string: ", e],
  254: () => "Cannot create chart: no chart themes available.",
  255: ({ point: e }) => `Lone surrogate U+${e?.toString(16).toUpperCase()} is not a scalar value`,
  256: () => "Unable to initialise. See validation error, or load ValidationModule if missing.",
  257: () => Cn("IntegratedChartsModule"),
  258: () => Cn("SparklinesModule"),
  259: ({ part: e }) => `the argument to theme.withPart must be a Theming API part object, received: ${e}`,
  260: ({
    propName: e,
    compName: t,
    gridScoped: o,
    gridId: i,
    rowModelType: s
  }) => fn({
    reasonOrId: `AG Grid '${e}' component: ${t}`,
    moduleName: ct[t],
    gridId: i,
    gridScoped: o,
    rowModelType: s
  }),
  261: () => "As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
  262: () => 'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
  263: () => 'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
  264: () => 'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
  265: ({ colId: e }) => `Unable to infer chart data type for column '${e}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${st}/integrated-charts-range-chart#coldefchartdatatype .`,
  266: () => 'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
  267: () => "Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
  268: () => "Transactions aren't supported with tree data when using treeDataChildrenField",
  269: () => "When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
  270: ({ id: e, parentId: t }) => `Cycle detected for row with id='${e}' and parent id='${t}'. Resetting the parent for row with id='${e}' and showing it as a root-level node.`,
  271: ({ id: e, parentId: t }) => `Parent row not found for row with id='${e}' and parent id='${t}'. Showing row with id='${e}' as a root-level node.`,
  272: () => Al(),
  273: ({ providedId: e, usedId: t }) => `Provided column id '${e}' was already in use, ensure all column and group ids are unique. Using '${t}' instead.`,
  274: ({ prop: e }) => {
    let t = `Since v33, ${e} has been deprecated.`;
    switch (e) {
      case "maxComponentCreationTimeMs":
        t += " This property is no longer required and so will be removed in a future version.";
        break;
      case "setGridApi":
        t += " This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api ";
        break;
      case "children":
        t += " For multiple versions AgGridReact does not support children.";
        break;
    }
    return t;
  },
  275: Ml,
  276: () => "Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
  277: ({ colId: e }) => `'enableFilterHandlers' is set to true, but column '${e}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
  278: ({ colId: e }) => `Unable to create filter handler for column '${e}'`,
  279: (e) => {
  },
  // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
  280: ({ colId: e }) => `'name' must be provided for custom filter components for column '${e}`,
  281: ({ colId: e }) => `Filter for column '${e}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
  282: () => "New filter tool panel requires `enableFilterHandlers: true`.",
  283: () => "As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
  284: () => "As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
  285: () => "As of v34, use (`api.getColumnFilterModel()`) instead.",
  286: () => "As of v34, use (`api.setColumnFilterModel()`) instead.",
  287: () => "`api.doFilterAction()` requires `enableFilterHandlers = true",
  288: () => "`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
  289: ({ rowModelType: e }) => `Row Model '${e}' is not supported with Batch Editing`,
  290: ({ rowIndex: e, rowPinned: t }) => `Row with index '${e}' and pinned state '${t}' not found`,
  291: () => "License Key being set multiple times with different values. This can result in an incorrect license key being used,",
  292: ({ colId: e }) => `The Multi Filter for column '${e}' has buttons configured against the child filters. When 'enableFilterHandlers=true', buttons must instead be provided against the parent Multi Filter params. The child filter buttons will be ignored.`
};
function rv(e, t) {
  const o = nv[e];
  if (!o)
    return [`Missing error text for error id ${e}!`];
  const i = o(t), n = `
See ${Yn(e, t)}`;
  return Array.isArray(i) ? i.concat(n) : [i, n];
}
var lv = {
  1: "Charting Aggregation",
  2: "pivotResultFields",
  3: "setTooltip"
}, mn = /* @__PURE__ */ new WeakMap(), vn = /* @__PURE__ */ new WeakMap();
function vS(e, t, o) {
  if (!t)
    return W(11), {};
  const i = o;
  let s;
  if (!i?.setThemeOnGridDiv) {
    const r = ie({ tag: "div" });
    r.style.height = "100%", e.appendChild(r), e = r, s = () => e.remove();
  }
  return new dv().create(
    e,
    t,
    (r) => {
      const l = new dg(e);
      r.createBean(l);
    },
    void 0,
    o,
    s
  );
}
var av = 1, dv = class {
  create(e, t, o, i, s, n) {
    const r = is.applyGlobalGridOptions(t), l = r.gridId ?? String(av++), a = this.getRegisteredModules(s, l, r.rowModelType), d = this.createBeansList(r.rowModelType, a, l), c = this.createProvidedBeans(e, r, s);
    if (!d)
      return;
    const h = {
      providedBeanInstances: c,
      beanClasses: d,
      id: l,
      beanInitComparator: Kh,
      beanDestroyComparator: jh,
      derivedBeans: [Uh],
      destroyCallback: () => {
        vn.delete(p), mn.delete(e), Ga(l), n?.();
      }
    }, g = new Jc(h);
    this.registerModuleFeatures(g, a), o(g), g.getBean("syncSvc").start(), i?.(g);
    const p = g.getBean("gridApi");
    return mn.set(e, p), vn.set(p, e), p;
  }
  getRegisteredModules(e, t, o) {
    return Wt(Xm, void 0, !0), e?.modules?.forEach((i) => Wt(i, t)), Ha(t, wn(o));
  }
  registerModuleFeatures(e, t) {
    const o = e.getBean("registry"), i = e.getBean("apiFunctionSvc");
    for (const s of t) {
      o.registerModule(s);
      const n = s.apiFunctions;
      if (n) {
        const r = Object.keys(n);
        for (const l of r)
          i?.addFunction(l, n[l]);
      }
    }
  }
  createProvidedBeans(e, t, o) {
    let i = o ? o.frameworkOverrides : null;
    H(i) && (i = new _h());
    const s = {
      gridOptions: t,
      eGridDiv: e,
      eRootDiv: e,
      globalListener: o ? o.globalListener : null,
      globalSyncListener: o ? o.globalSyncListener : null,
      frameworkOverrides: i
    };
    return o?.providedBeanInstances && Object.assign(s, o.providedBeanInstances), s;
  }
  createBeansList(e, t, o) {
    const i = {
      clientSide: "ClientSideRowModel",
      infinite: "InfiniteRowModel",
      serverSide: "ServerSideRowModel",
      viewport: "ViewportRowModel"
    }, s = wn(e), n = i[s];
    if (!n) {
      Dt(201, { rowModelType: s }, `Unknown rowModelType ${s}.`);
      return;
    }
    if (!Ba()) {
      Dt(272, void 0, Al());
      return;
    }
    if (!e) {
      const l = Object.entries(i).filter(
        ([a, d]) => xi(d, o, a)
      );
      if (l.length == 1) {
        const [a, d] = l[0];
        if (a !== s) {
          const c = {
            moduleName: d,
            rowModelType: a
          };
          Dt(275, c, Ml(c));
          return;
        }
      }
    }
    if (!xi(n, o, s)) {
      Dt(
        200,
        {
          reasonOrId: `rowModelType = '${s}'`,
          moduleName: n,
          gridScoped: ss(),
          gridId: o,
          rowModelType: s
        },
        `Missing module ${n}Module for rowModelType ${s}.`
      );
      return;
    }
    const r = /* @__PURE__ */ new Set();
    for (const l of t)
      for (const a of l.beans ?? [])
        r.add(a);
    return Array.from(r);
  }
};
function wn(e) {
  return e ?? "clientSide";
}
function Oe(e) {
  const t = e.rowModel;
  return t.getType() === "clientSide" ? t : void 0;
}
var cv = class extends b {
  constructor() {
    super(...arguments), this.beanName = "localeSvc";
  }
  getLocaleTextFunc() {
    const e = this.gos, t = e.getCallback("getLocaleText");
    return t ? ya(t) : Ra(e.get("localeText"));
  }
}, wS = class {
  wrap(e, t, o, i) {
    const s = this.createWrapper(e, i);
    for (const n of t ?? [])
      this.createMethod(s, n, !0);
    for (const n of o ?? [])
      this.createMethod(s, n, !1);
    return s;
  }
  createMethod(e, t, o) {
    e.addMethod(t, this.createMethodProxy(e, t, o));
  }
  createMethodProxy(e, t, o) {
    return function() {
      return e.hasMethod(t) ? e.callMethod(t, arguments) : (o && F(49, { methodName: t }), null);
    };
  }
};
function uv(e, t) {
  if (typeof e != "number")
    return "";
  const o = t(), i = o("thousandSeparator", ","), s = o("decimalSeparator", ".");
  return e.toString().replace(".", s).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${i}`);
}
var hv = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipShowMode: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressTouch: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  dragAndDropImageComponent: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  groupLockGroupColumns: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0,
  renderingMode: !0,
  columnMenu: !0,
  suppressSetFilterByDefault: !0,
  getDataPath: !0,
  enableCellSpan: !0,
  enableFilterHandlers: !0,
  filterHandlers: !0
}, X = "clientSide", U = "serverSide", Ze = "infinite", gv = {
  onGroupExpandedOrCollapsed: [X],
  refreshClientSideRowModel: [X],
  isRowDataEmpty: [X],
  forEachLeafNode: [X],
  forEachNodeAfterFilter: [X],
  forEachNodeAfterFilterAndSort: [X],
  resetRowHeights: [X, U],
  applyTransaction: [X],
  applyTransactionAsync: [X],
  flushAsyncTransactions: [X],
  getBestCostNodeSelection: [X],
  getServerSideSelectionState: [U],
  setServerSideSelectionState: [U],
  applyServerSideTransaction: [U],
  applyServerSideTransactionAsync: [U],
  applyServerSideRowData: [U],
  retryServerSideLoads: [U],
  flushServerSideAsyncTransactions: [U],
  refreshServerSide: [U],
  getServerSideGroupLevelState: [U],
  refreshInfiniteCache: [Ze],
  purgeInfiniteCache: [Ze],
  getInfiniteRowCount: [Ze],
  isLastRowIndexKnown: [Ze, U],
  expandAll: [X, U],
  collapseAll: [X, U],
  onRowHeightChanged: [X, U],
  setRowCount: [Ze, U],
  getCacheBlockState: [Ze, U]
}, pv = {
  showLoadingOverlay: {
    version: "v32",
    message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
  },
  clearRangeSelection: {
    version: "v32.2",
    message: "Use `clearCellSelection` instead."
  },
  getInfiniteRowCount: {
    version: "v32.2",
    old: "getInfiniteRowCount()",
    new: "getDisplayedRowCount()"
  },
  selectAllFiltered: {
    version: "v33",
    old: "selectAllFiltered()",
    new: 'selectAll("filtered")'
  },
  deselectAllFiltered: {
    version: "v33",
    old: "deselectAllFiltered()",
    new: 'deselectAll("filtered")'
  },
  selectAllOnCurrentPage: {
    version: "v33",
    old: "selectAllOnCurrentPage()",
    new: 'selectAll("currentPage")'
  },
  deselectAllOnCurrentPage: {
    version: "v33",
    old: "deselectAllOnCurrentPage()",
    new: 'deselectAll("currentPage")'
  }
};
function fv(e, t, o) {
  const i = pv[e];
  if (i) {
    const { version: n, new: r, old: l, message: a } = i, d = l ?? e;
    return (...c) => {
      const u = r ? `Please use ${r} instead. ` : "";
      return Tt(`Since ${n} api.${d} is deprecated. ${u}${a ?? ""}`), t.apply(t, c);
    };
  }
  const s = gv[e];
  return s ? (...n) => {
    const r = o.rowModel.getType();
    if (!s.includes(r)) {
      ot(
        `api.${e} can only be called when gridOptions.rowModelType is ${s.join(" or ")}`
      );
      return;
    }
    return t.apply(t, n);
  } : t;
}
var Cv = {
  detailCellRendererCtrl: "SharedMasterDetail",
  dndSourceComp: "DragAndDrop",
  fillHandle: "CellSelection",
  groupCellRendererCtrl: "GroupCellRenderer",
  headerFilterCellCtrl: "ColumnFilter",
  headerGroupCellCtrl: "ColumnGroup",
  rangeHandle: "CellSelection",
  tooltipFeature: "Tooltip",
  highlightTooltipFeature: "Tooltip",
  tooltipStateManager: "Tooltip",
  groupStrategy: "RowGrouping",
  treeGroupStrategy: "TreeData",
  rowNumberRowResizer: "RowNumbers",
  singleCell: "EditCore",
  fullRow: "EditCore",
  agSetColumnFilterHandler: "SetFilter",
  agMultiColumnFilterHandler: "MultiFilter",
  agGroupColumnFilterHandler: "GroupFilter",
  agNumberColumnFilterHandler: "NumberFilter",
  agDateColumnFilterHandler: "DateFilter",
  agTextColumnFilterHandler: "TextFilter"
}, mv = {
  expanded: 1,
  contracted: 1,
  "tree-closed": 1,
  "tree-open": 1,
  "tree-indeterminate": 1,
  pin: 1,
  "eye-slash": 1,
  arrows: 1,
  left: 1,
  right: 1,
  group: 1,
  aggregation: 1,
  pivot: 1,
  "not-allowed": 1,
  chart: 1,
  cross: 1,
  cancel: 1,
  tick: 1,
  first: 1,
  previous: 1,
  next: 1,
  last: 1,
  linked: 1,
  unlinked: 1,
  "color-picker": 1,
  loading: 1,
  menu: 1,
  "menu-alt": 1,
  filter: 1,
  "filter-add": 1,
  columns: 1,
  maximize: 1,
  minimize: 1,
  copy: 1,
  cut: 1,
  paste: 1,
  grip: 1,
  save: 1,
  csv: 1,
  excel: 1,
  "small-down": 1,
  "small-left": 1,
  "small-right": 1,
  "small-up": 1,
  asc: 1,
  desc: 1,
  none: 1,
  up: 1,
  down: 1,
  plus: 1,
  minus: 1,
  settings: 1,
  "checkbox-checked": 1,
  "checkbox-indeterminate": 1,
  "checkbox-unchecked": 1,
  "radio-button-on": 1,
  "radio-button-off": 1,
  eye: 1,
  "column-arrow": 1,
  "un-pin": 1,
  "pinned-top": 1,
  "pinned-bottom": 1,
  "chevron-up": 1,
  "chevron-down": 1,
  "chevron-left": 1,
  "chevron-right": 1,
  edit: 1
}, vv = {
  chart: "MenuCore",
  cancel: "EnterpriseCore",
  first: "Pagination",
  previous: "Pagination",
  next: "Pagination",
  last: "Pagination",
  linked: "IntegratedCharts",
  loadingMenuItems: "MenuCore",
  unlinked: "IntegratedCharts",
  menu: "ColumnHeaderComp",
  legacyMenu: "ColumnMenu",
  filter: "ColumnFilter",
  filterActive: "ColumnFilter",
  filterAdd: "NewFiltersToolPanel",
  filterCardCollapse: "NewFiltersToolPanel",
  filterCardExpand: "NewFiltersToolPanel",
  filterCardEditing: "NewFiltersToolPanel",
  filterTab: "ColumnMenu",
  filtersToolPanel: "FiltersToolPanel",
  columns: ["MenuCore"],
  columnsToolPanel: ["ColumnsToolPanel"],
  maximize: "EnterpriseCore",
  minimize: "EnterpriseCore",
  save: "MenuCore",
  columnGroupOpened: "ColumnGroupHeaderComp",
  columnGroupClosed: "ColumnGroupHeaderComp",
  accordionOpen: "EnterpriseCore",
  accordionClosed: "EnterpriseCore",
  accordionIndeterminate: "EnterpriseCore",
  columnSelectClosed: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectOpen: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectIndeterminate: ["ColumnsToolPanel", "ColumnMenu"],
  columnMovePin: "SharedDragAndDrop",
  columnMoveHide: "SharedDragAndDrop",
  columnMoveMove: "SharedDragAndDrop",
  columnMoveLeft: "SharedDragAndDrop",
  columnMoveRight: "SharedDragAndDrop",
  columnMoveGroup: "SharedDragAndDrop",
  columnMoveValue: "SharedDragAndDrop",
  columnMovePivot: "SharedDragAndDrop",
  dropNotAllowed: "SharedDragAndDrop",
  ensureColumnVisible: ["ColumnsToolPanel", "ColumnMenu"],
  groupContracted: "GroupCellRenderer",
  groupExpanded: "GroupCellRenderer",
  setFilterGroupClosed: "SetFilter",
  setFilterGroupOpen: "SetFilter",
  setFilterGroupIndeterminate: "SetFilter",
  setFilterLoading: "SetFilter",
  close: "EnterpriseCore",
  check: "MenuItem",
  colorPicker: "CommunityCore",
  groupLoading: "LoadingCellRenderer",
  menuAlt: "ColumnHeaderComp",
  menuPin: "MenuCore",
  menuValue: "MenuCore",
  menuAddRowGroup: ["MenuCore", "ColumnsToolPanel"],
  menuRemoveRowGroup: ["MenuCore", "ColumnsToolPanel"],
  clipboardCopy: "MenuCore",
  clipboardCut: "MenuCore",
  clipboardPaste: "MenuCore",
  pivotPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  rowGroupPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  valuePanel: "ColumnsToolPanel",
  columnDrag: "EnterpriseCore",
  rowDrag: ["RowDrag", "DragAndDrop"],
  csvExport: "MenuCore",
  excelExport: "MenuCore",
  smallDown: "CommunityCore",
  selectOpen: "CommunityCore",
  richSelectOpen: "RichSelect",
  richSelectRemove: "RichSelect",
  smallLeft: "CommunityCore",
  smallRight: "CommunityCore",
  subMenuOpen: "MenuItem",
  subMenuOpenRtl: "MenuItem",
  panelDelimiter: "RowGroupingPanel",
  panelDelimiterRtl: "RowGroupingPanel",
  smallUp: "CommunityCore",
  sortAscending: ["MenuCore", "Sort"],
  sortDescending: ["MenuCore", "Sort"],
  sortUnSort: ["MenuCore", "Sort"],
  advancedFilterBuilder: "AdvancedFilter",
  advancedFilterBuilderDrag: "AdvancedFilter",
  advancedFilterBuilderInvalid: "AdvancedFilter",
  advancedFilterBuilderMoveUp: "AdvancedFilter",
  advancedFilterBuilderMoveDown: "AdvancedFilter",
  advancedFilterBuilderAdd: "AdvancedFilter",
  advancedFilterBuilderRemove: "AdvancedFilter",
  advancedFilterBuilderSelectOpen: "AdvancedFilter",
  chartsMenu: "IntegratedCharts",
  chartsMenuEdit: "IntegratedCharts",
  chartsMenuAdvancedSettings: "IntegratedCharts",
  chartsMenuAdd: "IntegratedCharts",
  chartsColorPicker: "IntegratedCharts",
  chartsThemePrevious: "IntegratedCharts",
  chartsThemeNext: "IntegratedCharts",
  chartsDownload: "IntegratedCharts",
  checkboxChecked: "CommunityCore",
  checkboxIndeterminate: "CommunityCore",
  checkboxUnchecked: "CommunityCore",
  radioButtonOn: "CommunityCore",
  radioButtonOff: "CommunityCore",
  rowPin: "PinnedRow",
  rowUnpin: "PinnedRow",
  rowPinBottom: "PinnedRow",
  rowPinTop: "PinnedRow"
}, wv = /* @__PURE__ */ new Set([
  "colorPicker",
  "smallUp",
  "checkboxChecked",
  "checkboxIndeterminate",
  "checkboxUnchecked",
  "radioButtonOn",
  "radioButtonOff",
  "smallDown",
  "smallLeft",
  "smallRight"
]), Sv = class extends b {
  constructor() {
    super(...arguments), this.beanName = "validation";
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, Wa(rv);
  }
  warnOnInitialPropertyUpdate(e, t) {
    e === "api" && hv[t] && F(22, { key: t });
  }
  processGridOptions(e) {
    this.processOptions(e, RC());
  }
  validateApiFunction(e, t) {
    return fv(e, t, this.beans);
  }
  missingUserComponent(e, t, o, i) {
    const s = ct[t];
    s ? this.gos.assertModuleRegistered(
      s,
      `AG Grid '${e}' component: ${t}`
    ) : F(101, {
      propertyName: e,
      componentName: t,
      agGridDefaults: o,
      jsComps: i
    });
  }
  missingDynamicBean(e) {
    const t = Cv[e];
    return t ? Ce(200, {
      ...this.gos.getModuleErrorParams(),
      moduleName: t,
      reasonOrId: e
    }) : void 0;
  }
  checkRowEvents(e) {
    yv.has(e) && F(10, { eventType: e });
  }
  validateIcon(e) {
    if (wv.has(e) && F(43, { iconName: e }), mv[e])
      return;
    const t = vv[e];
    if (t) {
      W(200, {
        reasonOrId: `icon '${e}'`,
        moduleName: t,
        gridScoped: ss(),
        gridId: this.beans.context.getId(),
        rowModelType: this.gos.get("rowModelType"),
        additionalText: "Alternatively, use the CSS icon name directly."
      });
      return;
    }
    F(134, { iconName: e });
  }
  isProvidedUserComp(e) {
    return !!ct[e];
  }
  /** Should only be called via the GridOptionsService */
  validateColDef(e) {
    this.processOptions(e, hC());
  }
  processOptions(e, t) {
    const { validations: o, deprecations: i, allProperties: s, propertyExceptions: n, objectName: r, docsUrl: l } = t;
    s && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(
      e,
      [...n ?? [], ...Object.keys(i)],
      s,
      r,
      l
    );
    const a = /* @__PURE__ */ new Set();
    if (Object.keys(e).forEach((c) => {
      const u = i[c];
      if (u) {
        const { message: v, version: S } = u;
        a.add(`As of v${S}, ${String(c)} is deprecated. ${v ?? ""}`);
      }
      const h = e[c];
      if (h == null || h === !1)
        return;
      const g = o[c];
      if (!g)
        return;
      const { dependencies: p, validate: f, supportedRowModels: C, expectedType: m } = g;
      if (m) {
        const v = typeof h;
        if (v !== m) {
          a.add(
            `${String(c)} should be of type '${m}' but received '${v}' (${h}).`
          );
          return;
        }
      }
      if (C) {
        const v = this.gridOptions.rowModelType ?? "clientSide";
        if (!C.includes(v)) {
          a.add(
            `${String(c)} is not supported with the '${v}' row model. It is only valid with: ${C.join(", ")}.`
          );
          return;
        }
      }
      if (p) {
        const v = this.checkForRequiredDependencies(c, p, e);
        if (v) {
          a.add(v);
          return;
        }
      }
      if (f) {
        const v = f(e, this.gridOptions, this.beans);
        if (v) {
          a.add(v);
          return;
        }
      }
    }), a.size > 0)
      for (const c of a)
        Tt(c);
  }
  checkForRequiredDependencies(e, t, o) {
    const s = Object.entries(t).filter(([n, r]) => {
      const l = o[n];
      return !r.required.includes(l);
    });
    return s.length === 0 ? null : s.map(
      ([n, r]) => `'${String(e)}' requires '${n}' to be one of [${r.required.map((l) => l === null ? "null" : l === void 0 ? "undefined" : l).join(", ")}]. ${r.reason ?? ""}`
    ).join(`
           `);
  }
  checkProperties(e, t, o, i, s) {
    const n = ["__ob__", "__v_skip", "__metadata__"], r = bv(
      Object.getOwnPropertyNames(e),
      [...n, ...t, ...o],
      o
    ), l = Object.keys(r);
    for (const a of l) {
      const d = r[a];
      let c = `invalid ${i} property '${a}' did you mean any of these: ${d.slice(0, 8).join(", ")}.`;
      o.includes("context") && (c += `
If you are trying to annotate ${i} with application data, use the '${i}.context' property instead.`), Tt(c);
    }
    if (l.length > 0 && s) {
      const a = this.beans.frameworkOverrides.getDocLink(s);
      Tt(`to see all the valid ${i} properties please check: ${a}`);
    }
  }
};
function bv(e, t, o) {
  const i = {}, s = e.filter(
    (n) => !t.some((r) => r === n)
  );
  if (s.length > 0)
    for (const n of s)
      i[n] = Hi({ inputValue: n, allSuggestions: o }).values;
  return i;
}
var yv = /* @__PURE__ */ new Set([
  "firstChildChanged",
  "lastChildChanged",
  "childIndexChanged"
]), SS = {
  moduleName: "Validation",
  version: M,
  beans: [Sv]
};
function Rv(e) {
  const t = e.sibling;
  t && (t.childrenAfterFilter = e.childrenAfterFilter);
}
var xv = class extends nu {
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedEventListeners({ gridStylesChanged: this.handleThemeChange.bind(this) });
  }
  getDefaultPopupParent() {
    return this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: o, event: i } = e, s = t.getBoundingClientRect(), n = this.getParentRect();
    this.setAlignedTo(t, o);
    let r = !1;
    const l = () => {
      const a = this.keepXYWithinBounds(
        o,
        s.top - n.top,
        0
        /* Vertical */
      ), d = o.clientWidth > 0 ? o.clientWidth : 200;
      r || (o.style.minWidth = `${d}px`, r = !0);
      const u = n.right - n.left - d;
      let h;
      return this.gos.get("enableRtl") ? (h = p(), h < 0 && (h = g(), this.setAlignedStyles(o, "left")), h > u && (h = 0, this.setAlignedStyles(o, "right"))) : (h = g(), h > u && (h = p(), this.setAlignedStyles(o, "right")), h < 0 && (h = 0, this.setAlignedStyles(o, "left"))), { x: h, y: a };
      function g() {
        return s.right - n.left - 2;
      }
      function p() {
        return s.left - n.left - d;
      }
    };
    this.positionPopup({
      ePopup: o,
      keepWithinBounds: !0,
      updatePosition: l,
      postProcessCallback: () => this.callPostProcessPopup(
        e,
        "subMenu",
        o,
        t,
        i instanceof MouseEvent ? i : void 0
      )
    });
  }
  callPostProcessPopup(e, t, o, i, s) {
    const n = this.gos.getCallback("postProcessPopup");
    if (n) {
      const { column: r, rowNode: l } = e;
      n({
        column: r,
        rowNode: l,
        ePopup: o,
        type: t,
        eventSource: i,
        mouseEvent: s
      });
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  handleThemeChange(e) {
    if (e.themeChanged) {
      const t = this.beans.environment;
      for (const o of this.popupList)
        t.applyThemeClasses(o.wrapper);
    }
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isStopPropagation(e) {
    return xe(e);
  }
}, Pv = {
  moduleName: "Popup",
  version: M,
  beans: [xv]
}, Dv = {
  paste: "api",
  rangeSvc: "api",
  fillHandle: "api",
  cellClear: "api",
  bulk: "api"
};
new Set(Object.keys(Dv));
var Fv = class extends b {
  constructor() {
    super(...arguments), this.beanName = "selectionColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("rowSelection", (e) => {
      this.onSelectionOptionsChanged(
        e.currentValue,
        e.previousValue,
        lt(e.source)
      );
    }), this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
  }
  addColumns(e) {
    const t = this.columns;
    t != null && (e.list = t.list.concat(e.list), e.tree = t.tree.concat(e.tree), ad(e));
  }
  createColumns(e, t) {
    const o = () => {
      Fo(this.beans, this.columns?.tree), this.columns = null;
    }, i = e.treeDepth, n = (this.columns?.treeDepth ?? -1) == i, r = this.generateSelectionCols();
    if (ld(r, this.columns?.list ?? []) && n)
      return;
    o();
    const { colGroupSvc: a } = this.beans, d = a?.findDepth(e.tree) ?? 0, c = a?.balanceTreeForAutoCols(r, d) ?? [];
    this.columns = {
      list: r,
      tree: c,
      treeDepth: d,
      map: {}
    }, t((h) => {
      if (!h)
        return null;
      const g = h.filter((p) => !He(p));
      return [...r, ...g];
    });
  }
  updateColumns(e) {
    const t = lt(e.source);
    for (const o of this.columns?.list ?? []) {
      const i = this.createSelectionColDef(e.currentValue);
      o.setColDef(i, null, t), pt(this.beans, { state: [{ ...i, colId: o.getColId() }] }, t);
    }
  }
  getColumn(e) {
    return this.columns?.list.find((t) => It(t, e)) ?? null;
  }
  getColumns() {
    return this.columns?.list ?? null;
  }
  isSelectionColumnEnabled() {
    const { gos: e, beans: t } = this, o = e.get("rowSelection");
    if (typeof o != "object" || !ze(e))
      return !1;
    const i = (t.autoColSvc?.getColumns()?.length ?? 0) > 0;
    if (o.checkboxLocation === "autoGroupColumn" && i)
      return !1;
    const s = !!rt(o), n = co(o);
    return s || n;
  }
  createSelectionColDef(e) {
    const { gos: t } = this, o = e ?? t.get("selectionColumnDef"), i = t.get("enableRtl"), { rowSpan: s, spanRows: n, ...r } = o ?? {};
    return {
      // overridable properties
      width: 50,
      resizable: !1,
      suppressHeaderMenuButton: !0,
      sortable: !1,
      suppressMovable: !0,
      lockPosition: i ? "right" : "left",
      comparator(l, a, d, c) {
        const u = d.isSelected(), h = c.isSelected();
        return u === h ? 0 : u ? 1 : -1;
      },
      editable: !1,
      suppressFillHandle: !0,
      pinned: null,
      // overrides
      ...r,
      // non-overridable properties
      colId: sr,
      chartDataType: "excluded"
    };
  }
  generateSelectionCols() {
    if (!this.isSelectionColumnEnabled())
      return [];
    const e = this.createSelectionColDef(), t = e.colId;
    this.gos.validateColDef(e, t, !0);
    const o = new je(e, null, t, !1);
    return this.createBean(o), [o];
  }
  onSelectionOptionsChanged(e, t, o) {
    const i = t && typeof t != "string" ? rt(t) : void 0, s = e && typeof e != "string" ? rt(e) : void 0, n = i !== s, r = t && typeof t != "string" ? co(t) : void 0, l = e && typeof e != "string" ? co(e) : void 0, a = r !== l, d = Ro(e), c = Ro(t);
    (n || a || d !== c) && this.beans.colModel.refreshAll(o);
  }
  destroy() {
    Fo(this.beans, this.columns?.tree), super.destroy();
  }
  /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */
  refreshVisibility(e, t, o) {
    if (!this.columns?.list.length)
      return;
    const i = e.length + t.length + o.length;
    if (i === 0)
      return;
    const s = this.columns.list[0];
    if (!s.isVisible())
      return;
    const n = () => {
      let a;
      switch (s.pinned) {
        case "left":
        case !0:
          a = e;
          break;
        case "right":
          a = o;
          break;
        default:
          a = t;
      }
      a && Pe(a, s);
    };
    (this.beans.rowNumbersSvc?.getColumn(nr) ? 2 : 1) === i && n();
  }
};
function Ev(e, t) {
  if (!t.nodes.every((r) => r.rowPinned && !Qt(r) ? (F(59), !1) : r.id === void 0 ? (F(60), !1) : !0))
    return;
  const { nodes: i, source: s, newValue: n } = t;
  e.selectionSvc?.setNodesSelected({ nodes: i, source: s ?? "api", newValue: n });
}
function Av(e, t, o = "apiSelectAll") {
  e.selectionSvc?.selectAllRowNodes({ source: o, selectAll: t });
}
function Mv(e, t, o = "apiSelectAll") {
  e.selectionSvc?.deselectAllRowNodes({ source: o, selectAll: t });
}
function Tv(e, t = "apiSelectAllFiltered") {
  e.selectionSvc?.selectAllRowNodes({ source: t, selectAll: "filtered" });
}
function Iv(e, t = "apiSelectAllFiltered") {
  e.selectionSvc?.deselectAllRowNodes({ source: t, selectAll: "filtered" });
}
function kv(e, t = "apiSelectAllCurrentPage") {
  e.selectionSvc?.selectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function Lv(e, t = "apiSelectAllCurrentPage") {
  e.selectionSvc?.deselectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function Gv(e) {
  return e.selectionSvc?.getSelectedNodes() ?? [];
}
function Hv(e) {
  return e.selectionSvc?.getSelectedRows() ?? [];
}
var Ov = class extends Oh {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc", this.selectedNodes = /* @__PURE__ */ new Map(), this.detailSelection = /* @__PURE__ */ new Map(), this.masterSelectsDetail = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { gos: e } = this;
    this.mode = xo(e), this.groupSelectsDescendants = zt(e), this.groupSelectsFiltered = Po(e) === "filteredDescendants", this.masterSelectsDetail = ks(e) === "detail", this.addManagedPropertyListeners(["groupSelectsChildren", "groupSelectsFiltered", "rowSelection"], () => {
      const t = zt(e), o = xo(e), i = Po(e) === "filteredDescendants";
      this.masterSelectsDetail = ks(e) === "detail", (t !== this.groupSelectsDescendants || i !== this.groupSelectsFiltered || o !== this.mode) && (this.deselectAllRowNodes({ source: "api" }), this.groupSelectsDescendants = t, this.groupSelectsFiltered = i, this.mode = o);
    }), this.addManagedEventListeners({ rowSelected: this.onRowSelected.bind(this) });
  }
  destroy() {
    super.destroy(), this.resetNodes();
  }
  handleSelectionEvent(e, t, o) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    const i = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, o);
    if (i == null)
      return 0;
    if (this.selectionCtx.selectAll = !1, "select" in i)
      return i.reset ? this.resetNodes() : this.selectRange(i.deselect, !1, o), this.selectRange(i.select, !0, o);
    {
      const s = i.checkFilteredNodes ? Il(i.node) : i.newValue;
      return this.setNodesSelected({
        nodes: [i.node],
        newValue: s,
        clearSelection: i.clearSelection,
        keepDescendants: i.keepDescendants,
        event: e,
        source: o
      });
    }
  }
  setNodesSelected({
    newValue: e,
    clearSelection: t,
    suppressFinishActions: o,
    nodes: i,
    event: s,
    source: n,
    keepDescendants: r = !1
  }) {
    if (i.length === 0)
      return 0;
    const { gos: l } = this;
    if (!ze(l) && e)
      return F(132), 0;
    if (i.length > 1 && !this.isMultiSelect())
      return F(130), 0;
    let a = 0;
    for (let d = 0; d < i.length; d++) {
      const c = i[d], u = Qe(c);
      if (u.rowPinned && !Qt(u)) {
        F(59);
        continue;
      }
      if (u.id === void 0) {
        F(60);
        continue;
      }
      this.groupSelectsFiltered && u.group && !l.get("treeData") || this.selectRowNode(u, e, s, n) && (this.detailSelection.delete(u.id), a++), this.groupSelectsDescendants && u.childrenAfterGroup?.length && (a += this.selectChildren(u, e, n));
    }
    return o || (i.length === 1 && n === "api" && this.selectionCtx.setRoot(Qe(i[0])), e && (t || !this.isMultiSelect()) && (a += this.clearOtherNodes(Qe(i[0]), r, n)), a > 0 && (this.updateGroupsFromChildrenSelections(n), this.dispatchSelectionChanged(n))), a;
  }
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  selectRange(e, t, o) {
    let i = 0;
    return e.forEach((s) => {
      const n = Qe(s);
      if (n.group && this.groupSelectsDescendants)
        return;
      this.selectRowNode(n, t, void 0, o) && i++;
    }), i > 0 && (this.updateGroupsFromChildrenSelections(o), this.dispatchSelectionChanged(o)), i;
  }
  selectChildren(e, t, o) {
    const i = this.groupSelectsFiltered ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return i ? this.setNodesSelected({
      newValue: t,
      clearSelection: !1,
      suppressFinishActions: !0,
      source: o,
      nodes: i
    }) : 0;
  }
  getSelectedNodes() {
    return Array.from(this.selectedNodes.values());
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => t.data && e.push(t.data)), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((o, i) => {
      e(o) && t.set(i, o);
    }), this.selectedNodes = t;
  }
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsDescendants)
      return !1;
    const { gos: o, rowModel: i } = this.beans;
    if (!re(o))
      return !1;
    const s = i.rootNode;
    if (!s)
      return !1;
    t || (t = new Ho(!0, s), t.active = !1);
    let n = !1;
    return t.forEachChangedNodeDepthFirst((r) => {
      if (r !== s) {
        const l = this.calculateSelectedFromChildren(r);
        n = this.selectRowNode(r, l === null ? !1 : l, void 0, e) || n;
      }
    }), n;
  }
  clearOtherNodes(e, t, o) {
    const i = /* @__PURE__ */ new Map();
    let s = 0;
    return this.selectedNodes.forEach((n) => {
      const r = n.id == e.id;
      if ((t ? !Vv(e, n) : !0) && !r) {
        const a = this.selectedNodes.get(n.id);
        s += this.setNodesSelected({
          nodes: [a],
          newValue: !1,
          clearSelection: !1,
          suppressFinishActions: !0,
          source: o
        }), this.groupSelectsDescendants && n.parent && i.set(n.parent.id, n.parent);
      }
    }), i.forEach((n) => {
      const r = this.calculateSelectedFromChildren(n);
      this.selectRowNode(n, r === null ? !1 : r, void 0, o);
    }), s;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsDescendants && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  createDaemonNode(e) {
    if (!e.id)
      return;
    const t = new us(this.beans);
    return t.id = e.id, t.data = e.data, t.__selected = e.__selected, t.level = e.level, t;
  }
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  syncInOldRowNode(e, t) {
    t && e.id !== t.id && this.selectedNodes.get(t.id) == e && this.selectedNodes.set(t.id, t);
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.__selected = !0, this.selectedNodes.set(e.id, e)) : e.__selected = !1;
  }
  reset(e) {
    const t = this.getSelectionCount();
    this.resetNodes(), t && this.dispatchSelectionChanged(e);
  }
  resetNodes() {
    this.selectedNodes.forEach((e) => {
      this.selectRowNode(e, !1);
    }), this.selectedNodes.clear();
  }
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  getBestCostNodeSelection() {
    const { gos: e, rowModel: t } = this.beans;
    if (!re(e))
      return;
    const o = t.getTopLevelNodes();
    if (o === null)
      return;
    const i = [];
    function s(n) {
      for (let r = 0, l = n.length; r < l; r++) {
        const a = n[r];
        a.isSelected() ? i.push(a) : a.group && a.childrenAfterGroup && s(a.childrenAfterGroup);
      }
    }
    return s(o), i;
  }
  isEmpty() {
    return this.getSelectionCount() === 0;
  }
  deselectAllRowNodes({ source: e, selectAll: t }) {
    const o = re(this.gos);
    let i = !1;
    const s = (n) => {
      const r = this.selectRowNode(Qe(n), !1, void 0, e);
      i || (i = r);
    };
    if (t === "currentPage" || t === "filtered") {
      if (!o) {
        W(102);
        return;
      }
      this.getNodesToSelect(t).forEach(s);
    } else
      this.selectedNodes.forEach(s), this.reset(e);
    if (this.selectionCtx.selectAll = !1, o && this.groupSelectsDescendants) {
      const n = this.updateGroupsFromChildrenSelections(e);
      i || (i = n);
    }
    i && this.dispatchSelectionChanged(e);
  }
  getSelectedCounts(e) {
    let t = 0, o = 0;
    return this.getNodesToSelect(e).forEach((i) => {
      this.groupSelectsDescendants && i.group || (i.isSelected() ? t++ : i.selectable && o++);
    }), { selectedCount: t, notSelectedCount: o };
  }
  getSelectAllState(e) {
    const { selectedCount: t, notSelectedCount: o } = this.getSelectedCounts(e);
    return Tl(t, o) ?? null;
  }
  hasNodesToSelect(e) {
    return this.getNodesToSelect(e).filter((t) => t.selectable).length > 0;
  }
  /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */
  getNodesToSelect(e) {
    if (!this.canSelectAll())
      return [];
    const t = [], o = (s) => t.push(s);
    if (e === "currentPage")
      return this.forEachNodeOnPage((s) => {
        if (!s.group) {
          o(s);
          return;
        }
        if (!s.expanded && !s.footer) {
          const n = (r) => {
            o(r), r.childrenAfterFilter?.forEach(n);
          };
          n(s);
          return;
        }
        this.groupSelectsDescendants || o(s);
      }), t;
    const i = this.beans.rowModel;
    return e === "filtered" ? (i.forEachNodeAfterFilter(o), t) : (i.forEachNode(o), t);
  }
  forEachNodeOnPage(e) {
    const { pageBounds: t, rowModel: o } = this.beans, i = t.getFirstRow(), s = t.getLastRow();
    for (let n = i; n <= s; n++) {
      const r = o.getRow(n);
      r && e(r);
    }
  }
  selectAllRowNodes(e) {
    const { gos: t, selectionCtx: o } = this;
    if (!ze(t)) {
      F(132);
      return;
    }
    if (Za(t) && !Nt(t)) {
      F(130);
      return;
    }
    if (!this.canSelectAll())
      return;
    const { source: i, selectAll: s } = e;
    let n = !1;
    if (this.getNodesToSelect(s).forEach((r) => {
      const l = this.selectRowNode(Qe(r), !0, void 0, i);
      n || (n = l);
    }), o.selectAll = !0, re(t) && this.groupSelectsDescendants) {
      const r = this.updateGroupsFromChildrenSelections(i);
      n || (n = r);
    }
    n && this.dispatchSelectionChanged(i);
  }
  getSelectionState() {
    return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
  }
  setSelectionState(e, t, o) {
    if (e || (e = []), !Array.isArray(e)) {
      W(103);
      return;
    }
    const i = new Set(e), s = [];
    this.beans.rowModel.forEachNode((n) => {
      i.has(n.id) && s.push(n);
    }), o && this.resetNodes(), this.setNodesSelected({
      newValue: !0,
      nodes: s,
      source: t
    });
  }
  canSelectAll() {
    return re(this.beans.gos);
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */
  updateSelectable(e) {
    const { gos: t, rowModel: o } = this.beans;
    if (!ze(t))
      return;
    const i = "selectableChanged", s = e !== void 0, n = re(t) && this.groupSelectsDescendants, r = [], l = (a) => {
      if (s && !a.group)
        return;
      if (n && a.group) {
        const c = a.childrenAfterGroup?.some((u) => u.selectable) ?? !1;
        this.setRowSelectable(a, c, !0);
        return;
      }
      !this.updateRowSelectable(a, !0) && a.isSelected() && r.push(a);
    };
    if (n) {
      if (e === void 0) {
        const a = o.rootNode;
        e = a ? new Ho(!1, a) : void 0;
      }
      e?.forEachChangedNodeDepthFirst(l, !s, !s);
    } else
      o.forEachNode(l);
    r.length && this.setNodesSelected({
      nodes: r,
      newValue: !1,
      source: i
    }), !s && n && this.updateGroupsFromChildrenSelections?.(i);
  }
  // only called by CSRM
  updateSelectableAfterGrouping(e) {
    this.updateSelectable(e), this.groupSelectsDescendants && this.updateGroupsFromChildrenSelections?.("rowGroupChanged", e) && this.dispatchSelectionChanged("rowGroupChanged");
  }
  refreshMasterNodeState(e, t) {
    if (!this.masterSelectsDetail)
      return;
    const o = e.detailNode?.detailGridInfo?.api;
    if (!o)
      return;
    const i = Bv(o);
    if (e.isSelected() !== i && this.selectRowNode(e, i, t, "masterDetail") && this.dispatchSelectionChanged("masterDetail"), !i) {
      const n = this.detailSelection.get(e.id) ?? /* @__PURE__ */ new Set();
      for (const r of o.getSelectedNodes())
        n.add(r.id);
      this.detailSelection.set(e.id, n);
    }
  }
  setDetailSelectionState(e, t, o) {
    if (this.masterSelectsDetail) {
      if (!Nt(t)) {
        F(269);
        return;
      }
      switch (e.isSelected()) {
        case !0: {
          o.selectAll();
          break;
        }
        case !1: {
          o.deselectAll();
          break;
        }
        case void 0: {
          const i = this.detailSelection.get(e.id);
          if (i) {
            const s = [];
            for (const n of i) {
              const r = o.getRowNode(n);
              r && s.push(r);
            }
            o.setNodesSelected({ nodes: s, newValue: !0, source: "masterDetail" });
          }
          break;
        }
      }
    }
  }
  dispatchSelectionChanged(e) {
    this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: e,
      selectedNodes: this.getSelectedNodes(),
      serverSideState: null
    });
  }
};
function Qe(e) {
  return Qt(e) ? e.pinnedSibling : e.footer ? e.sibling : e;
}
function Bv(e) {
  let t = 0, o = 0;
  return e.forEachNode((i) => {
    i.isSelected() ? t++ : i.selectable && o++;
  }), Tl(t, o);
}
function Tl(e, t) {
  if (e === 0 && t === 0)
    return !1;
  if (!(e > 0 && t > 0))
    return e > 0;
}
function Vv(e, t) {
  let o = t.parent;
  for (; o; ) {
    if (o === e)
      return !0;
    o = o.parent;
  }
  return !1;
}
function Il(e) {
  const t = e.isSelected() === !1, o = e.childrenAfterFilter?.some(Il) ?? !1;
  return t || o;
}
var Wv = {
  moduleName: "SharedRowSelection",
  version: M,
  beans: [Fv],
  apiFunctions: {
    setNodesSelected: Ev,
    selectAll: Av,
    deselectAll: Mv,
    selectAllFiltered: Tv,
    deselectAllFiltered: Iv,
    selectAllOnCurrentPage: kv,
    deselectAllOnCurrentPage: Lv,
    getSelectedNodes: Gv,
    getSelectedRows: Hv
  }
}, bS = {
  moduleName: "RowSelection",
  version: M,
  rowModels: ["clientSide", "infinite", "viewport"],
  beans: [Ov],
  dependsOn: [Wv]
};
function Nv(e) {
  e.expansionSvc?.expandAll(!0);
}
function zv(e) {
  e.expansionSvc?.expandAll(!1);
}
function kl(e) {
  e.rowModel?.onRowHeightChanged();
}
function Ll(e) {
  if (e.rowAutoHeight?.active) {
    F(3);
    return;
  }
  e.rowModel?.resetRowHeights();
}
var _v = {
  moduleName: "CsrmSsrmSharedApi",
  version: M,
  apiFunctions: { expandAll: Nv, collapseAll: zv }
}, Uv = {
  moduleName: "RowModelSharedApi",
  version: M,
  apiFunctions: { onRowHeightChanged: kl, resetRowHeights: Ll }
}, $v = class extends b {
  constructor(e) {
    super(), this.rootNode = e, this.nextId = 0, this.allNodesMap = {}, Sn(e);
  }
  getRowNode(e) {
    return this.allNodesMap[e];
  }
  setNewRowData(e) {
    const { selectionSvc: t, pinnedRowModel: o, groupStage: i } = this.beans;
    t?.reset("rowDataChanged"), o?.isManual() && o.reset(), this.dispatchRowDataUpdateStarted(e), this.allNodesMap = /* @__PURE__ */ Object.create(null), this.nextId = 0;
    const s = Sn(this.rootNode), n = new Array(e.length);
    s._leafs = n;
    let r = 0;
    const l = i?.getNestedDataGetter(), a = l ? /* @__PURE__ */ new Set() : null, d = (c, u) => {
      const h = c.level + 1;
      for (let g = 0, p = u.length; g < p; ++g) {
        const f = u[g];
        if (!f)
          continue;
        const C = this.createRowNode(f, h);
        if (C.sourceRowIndex = r, n[r++] = C, a && !a.has(f)) {
          a.add(f), C.treeParent = c;
          const m = l(f);
          m && d(C, m);
        }
      }
    };
    d(s, e), n.length = r;
  }
  setImmutableRowData(e, t) {
    const { rootNode: o, gos: i } = this;
    this.dispatchRowDataUpdateStarted(t);
    const s = Ei(i), n = e.changedRowNodes, { adds: r, updates: l } = n, a = /* @__PURE__ */ new Set(), d = [], c = this.beans.groupStage?.getNestedDataGetter();
    let u = i.get("suppressMaintainUnsortedOrder") ? void 0 : !1, h = -1, g = !1;
    const p = (m, v) => {
      if (!u && u !== void 0) {
        const S = m.sourceRowIndex;
        u = S <= h, h = S;
      }
      m.data !== v && (m.updateData(v), r.has(m) || l.add(m), !m.selectable && m.isSelected() && d.push(m));
    }, f = (m, v, S) => {
      for (let D = 0, y = v.length; D < y; ++D) {
        const R = v[D];
        if (!R)
          continue;
        let x = this.getRowNode(s({ data: R, level: S }));
        if (x ? (p(x, R), g || (g = !!c && x.treeParent !== m)) : (x = this.createRowNode(R, S), r.add(x)), !c || a.has(x)) {
          a.add(x);
          continue;
        }
        a.add(x), x.treeParent = m;
        const k = c(R);
        k && f(x, k, S + 1);
      }
    };
    f(o, t, 0);
    const C = this.deleteUnusedNodes(a, n, d) || u || r.size > 0;
    if (C) {
      const m = o._leafs ?? (o._leafs = []);
      u === void 0 ? Zv(m, a, n) : Yv(m, a) && (n.reordered = !0);
    }
    (C || g || l.size) && (e.rowDataUpdated = !0, this.deselect(d));
  }
  deleteUnusedNodes(e, { removals: t }, o) {
    const i = this.rootNode._leafs;
    for (let s = 0, n = i.length; s < n; s++) {
      const r = i[s];
      e.has(r) || (t.add(r), r.isSelected() && o.push(r), this.deleteNode(r));
    }
    return t.size > 0;
  }
  updateRowData(e, t) {
    if (this.dispatchRowDataUpdateStarted(e.add), this.beans.groupStage?.getNestedDataGetter())
      return F(268), { remove: [], update: [], add: [] };
    const o = [], i = Ei(this.gos), s = this.executeRemove(i, e, t, o), n = this.executeUpdate(i, e, t, o), r = this.executeAdd(e, t);
    return this.deselect(o), { remove: s, update: n, add: r };
  }
  executeRemove(e, { remove: t }, { adds: o, updates: i, removals: s }, n) {
    const r = this.rootNode._leafs, l = r?.length, a = t?.length;
    if (!a || !l)
      return [];
    let d = 0, c = l, u = 0, h;
    const g = new Array(a);
    for (let p = 0; p < a; ++p) {
      const f = this.lookupNode(e, t[p]);
      if (!f)
        continue;
      const C = f.sourceRowIndex;
      C < c && (c = C), C > u && (u = C), f.isSelected() && n.push(f), this.deleteNode(f), o.delete(f) ? (h ?? (h = /* @__PURE__ */ new Set()), h.add(f)) : (i.delete(f), s.add(f)), g[d++] = f;
    }
    return g.length = d, d && qv(r, c, u, s, h), g;
  }
  executeUpdate(e, { update: t }, { adds: o, updates: i }, s) {
    const n = t?.length;
    if (!n)
      return [];
    const r = new Array(n);
    let l = 0;
    for (let a = 0; a < n; a++) {
      const d = t[a], c = this.lookupNode(e, d);
      c && (c.updateData(d), !c.selectable && c.isSelected() && s.push(c), r[l++] = c, o.has(c) || i.add(c));
    }
    return r.length = l, r;
  }
  executeAdd(e, t) {
    var o;
    const i = (o = this.rootNode)._leafs ?? (o._leafs = []), s = i.length, n = e.add, r = n?.length;
    if (!r)
      return [];
    const l = s + r;
    let a = this.sanitizeAddIndex(i, e.addIndex);
    if (a < s) {
      for (let u = s - 1, h = l - 1; u >= a; --u) {
        const g = i[u];
        g.sourceRowIndex = h, i[h--] = g;
      }
      t.reordered = !0;
    }
    i.length = l;
    const d = new Array(r), c = t.adds;
    for (let u = 0; u < r; u++) {
      const h = this.createRowNode(n[u], 0);
      c.add(h), h.sourceRowIndex = a, i[a] = h, d[u] = h, a++;
    }
    return d;
  }
  dispatchRowDataUpdateStarted(e) {
    this.eventSvc.dispatchEvent({ type: "rowDataUpdateStarted", firstRowData: e?.length ? e[0] : null });
  }
  deselect(e) {
    const t = "rowDataChanged", o = this.beans.selectionSvc;
    e.length && o?.setNodesSelected({ newValue: !1, nodes: e, suppressFinishActions: !0, source: t }), o?.updateGroupsFromChildrenSelections?.(t), e.length && this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: t,
      selectedNodes: o?.getSelectedNodes() ?? null,
      serverSideState: null
    });
  }
  createRowNode(e, t) {
    const o = new us(this.beans);
    o.parent = this.rootNode, o.level = t, o.group = !1, o.expanded = !1, o.setDataAndId(e, String(this.nextId++));
    const i = o.id, s = this.allNodesMap;
    return s[i] && F(2, { nodeId: i }), s[i] = o, o;
  }
  /** Called when a node needs to be deleted */
  deleteNode(e) {
    e.clearRowTopAndRowIndex();
    const t = e.id, o = this.allNodesMap;
    o[t] === e && delete o[t];
    const i = e.pinnedSibling;
    i && this.beans.pinnedRowModel?.pinRow(i, null);
  }
  lookupNode(e, t) {
    if (!e)
      return jv(this.rootNode._leafs, t);
    const o = e({ data: t, level: 0 }), i = this.allNodesMap[o];
    return i || (W(4, { id: o }), null);
  }
  sanitizeAddIndex(e, t) {
    const o = e.length;
    if (typeof t != "number" || t < 0 || t >= o || Number.isNaN(t))
      return o;
    t = Math.ceil(t);
    const i = this.gos;
    return t > 0 && i.get("treeData") && i.get("getDataPath") && (t = Kv(e, t)), t;
  }
}, Kv = (e, t) => {
  for (let o = 0, i = e.length; o < i; o++)
    if (e[o]?.rowIndex == t - 1)
      return o + 1;
  return t;
}, Sn = (e) => {
  e.group = !0, e.level = -1, e.id = "ROOT_NODE_ID", e._leafs?.length !== 0 && (e._leafs = []);
  const t = [], o = [], i = [], s = [];
  e.childrenAfterGroup = t, e.childrenAfterSort = o, e.childrenAfterAggFilter = i, e.childrenAfterFilter = s;
  const n = e.sibling;
  return n && (n.childrenAfterGroup = t, n.childrenAfterSort = o, n.childrenAfterAggFilter = i, n.childrenAfterFilter = s, n.childrenMapped = e.childrenMapped), e.updateHasChildren(), e;
}, jv = (e, t) => {
  if (e)
    for (let o = 0, i = e.length; o < i; o++) {
      const s = e[o];
      if (s.data === t)
        return s;
    }
  return W(5, { data: t }), null;
}, qv = (e, t, o, i, s) => {
  t = Math.max(0, t);
  for (let n = t, r = e.length; n < r; ++n) {
    const l = e[n];
    n <= o && (i.has(l) || s?.has(l)) || (l.sourceRowIndex = t, e[t++] = l);
  }
  e.length = t;
}, Yv = (e, t) => {
  const o = t.size;
  e.length = o;
  let i = 0, s = !1, n = !1;
  for (const r of t) {
    const l = r.sourceRowIndex;
    l === i ? n || (n = s) : (l >= 0 ? n = !0 : s = !0, r.sourceRowIndex = i, e[i] = r), ++i;
  }
  return n;
}, Zv = (e, t, { removals: o, adds: i }) => {
  const s = e.length;
  e.length = t.size;
  let n = 0;
  for (let r = 0; r < s; ++r) {
    const l = e[r];
    o.has(l) || (n !== r && (l.sourceRowIndex = n, e[n] = l), ++n);
  }
  for (const r of i)
    r.sourceRowIndex < 0 && (r.sourceRowIndex = n, e[n++] = r);
  e.length = n;
}, Gl = (e) => {
  const t = e.childrenAfterSort, o = e.sibling;
  if (o && (o.childrenAfterSort = t), !!t)
    for (let i = 0, s = t.length - 1; i <= s; i++) {
      const n = t[i], r = i === 0, l = i === s;
      n.firstChild !== r && (n.firstChild = r, n.dispatchRowEvent("firstChildChanged")), n.lastChild !== l && (n.lastChild = l, n.dispatchRowEvent("lastChildChanged")), n.childIndex !== i && (n.childIndex = i, n.dispatchRowEvent("childIndexChanged"));
    }
}, Qv = class extends b {
  constructor() {
    super(...arguments), this.beanName = "sortStage", this.step = "sort", this.refreshProps = ["postSortRows", "groupDisplayType", "accentedSort"];
  }
  execute(e) {
    const t = this.beans.sortSvc.getSortOptions(), o = t.length > 0 && !!e.changedRowNodes && // in time we can remove this check, so that delta sort is always
    // on if transactions are present. it's off for now so that we can
    // selectively turn it on and test it with some select users before
    // rolling out to everyone.
    this.gos.get("deltaSort");
    this.sort(t, o, e.changedRowNodes, e.changedPath);
  }
  sort(e, t, o, i) {
    const { gos: s, colModel: n, rowGroupColsSvc: r, rowNodeSorter: l, rowRenderer: a, showRowGroupCols: d } = this.beans, c = s.get("groupMaintainOrder"), u = n.getCols().some((v) => v.isRowGroupActive()), h = r?.columns, g = n.isPivotMode(), p = s.getCallback("postSortRows");
    let f = !1, C;
    const m = (v) => {
      const S = g && v.leafGroup;
      let D = c && u && !v.leafGroup;
      D && (C ?? (C = this.shouldSortContainsGroupCols(e)), D && (D = !C));
      let y = null;
      if (D) {
        let R = !1;
        if (h) {
          const x = v.level + 1;
          x < h.length && (R = h[x].getSort() === null);
        }
        R || (y = ew(v));
      } else !e.length || S || (t && o ? y = Xv(l, v, o, i, e) : y = l.doFullSort(v.childrenAfterAggFilter, e));
      if (y || (y = v.childrenAfterAggFilter?.slice(0) ?? []), f || (f = v.childrenAfterSort?.[0] !== y[0]), v.childrenAfterSort = y, Gl(v), p) {
        const R = { nodes: v.childrenAfterSort };
        p(R);
      }
    };
    if (i?.forEachChangedNodeDepthFirst(m), f && s.get("groupHideOpenParents")) {
      const v = d?.getShowRowGroupCols();
      v?.length && a.refreshCells({ columns: v, force: !0 });
    }
  }
  shouldSortContainsGroupCols(e) {
    const t = e.length;
    if (!t)
      return !1;
    if (pe(this.gos)) {
      for (let o = 0; o < t; ++o) {
        const i = e[o].column;
        if (i.isPrimary() && i.isRowGroupActive())
          return !0;
      }
      return !1;
    }
    for (let o = 0; o < t; ++o)
      if (e[o].column.getColDef().showRowGroup)
        return !0;
    return !1;
  }
}, Xv = (e, t, o, i, s) => {
  const n = t.childrenAfterAggFilter, r = t.childrenAfterSort;
  if (!r)
    return e.doFullSort(n, s);
  const l = /* @__PURE__ */ new Set(), a = [], { updates: d, adds: c } = o;
  for (let h = 0, g = n.length; h < g; ++h) {
    const p = n[h];
    d.has(p) || c.has(p) || i && !i.canSkip(p) ? a.push({
      currentPos: a.length,
      rowNode: p
    }) : l.add(p);
  }
  const u = r.filter((h) => l.has(h)).map((h, g) => ({ currentPos: g, rowNode: h }));
  return a.sort((h, g) => e.compareRowNodes(s, h, g)), Jv(e, s, a, u);
}, Jv = (e, t, o, i) => {
  let s = 0, n = 0;
  const r = o.length, l = i.length, a = new Array(r + l);
  let d = 0;
  for (; s < r && n < l; ) {
    const c = o[s], u = i[n];
    e.compareRowNodes(t, c, u) < 0 ? (a[d++] = c.rowNode, ++s) : (a[d++] = u.rowNode, ++n);
  }
  for (; s < r; )
    a[d++] = o[s++].rowNode;
  for (; n < l; )
    a[d++] = i[n++].rowNode;
  return a;
}, ew = (e) => {
  const t = e.childrenAfterSort, o = e.childrenAfterAggFilter, i = t?.length, s = o?.length;
  if (!i || !s)
    return null;
  const n = new Array(s), r = /* @__PURE__ */ new Set();
  for (let a = 0; a < s; ++a)
    r.add(o[a]);
  let l = 0;
  for (let a = 0; a < i; ++a) {
    const d = t[a];
    r.delete(d) && (n[l++] = d);
  }
  if (r.size === 0 && l === i)
    return t;
  for (const a of r)
    n[l++] = a;
  return n.length = l, n;
}, tw = class extends b {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.rootNode = null, this.rowCountReady = !1, this.nodeManager = void 0, this.rowsToDisplay = [], this.rowDataUpdatedPending = !1, this.asyncTransactions = null, this.asyncTransactionsTimer = 0, this.started = !1, this.refreshingModel = !1, this.rowNodesCountReady = !1, this.stages = [], this.stagesRefreshProps = /* @__PURE__ */ new Map(), this.onRowHeightChanged_debounced = We(this, this.onRowHeightChanged.bind(this), 100);
  }
  postConstruct() {
    const e = this.beans, t = new us(e);
    this.rootNode = t, this.nodeManager = this.createBean(new $v(t));
    const o = this.refreshModel.bind(this, { step: "group" }), i = this.refreshModel.bind(this, {
      step: "group",
      // after cols change, row grouping (the first stage) could of changed
      afterColumnsChanged: !0,
      keepRenderedRows: !0,
      // we want animations cos sorting or filtering could be applied
      animate: !this.gos.get("suppressAnimationFrame")
    });
    this.addManagedEventListeners({
      newColumnsLoaded: i,
      columnRowGroupChanged: o,
      columnValueChanged: this.onValueChanged.bind(this),
      columnPivotChanged: this.refreshModel.bind(this, { step: "pivot" }),
      filterChanged: this.onFilterChanged.bind(this),
      sortChanged: this.onSortChanged.bind(this),
      columnPivotModeChanged: o,
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      gridReady: this.onGridReady.bind(this),
      rowExpansionStateChanged: this.onRowGroupOpened.bind(this)
    }), this.addPropertyListeners();
  }
  addPropertyListeners() {
    const { beans: e, stagesRefreshProps: t } = this, o = [
      e.groupStage,
      e.filterStage,
      e.pivotStage,
      e.aggStage,
      e.sortStage,
      e.filterAggStage,
      e.flattenStage
    ].filter((i) => !!i);
    this.stages = o;
    for (let i = o.length - 1; i >= 0; --i)
      for (const s of o[i].refreshProps)
        t.set(s, i);
    this.addManagedPropertyListeners([...t.keys()], (i) => {
      const s = i.changeSet?.properties;
      s && this.onPropChange(s);
    }), this.addManagedPropertyListener("rowData", () => this.onPropChange(["rowData"])), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.started = !0, this.rowNodesCountReady ? this.refreshModel({ step: "group", rowDataUpdated: !0, newData: !0 }) : this.setInitialData();
  }
  setInitialData() {
    this.gos.get("rowData") && this.onPropChange(["rowData"]);
  }
  ensureRowHeightsValid(e, t, o, i) {
    let s, n = !1;
    do {
      s = !1;
      const r = this.getRowIndexAtPixel(e), l = this.getRowIndexAtPixel(t), a = Math.max(r, o), d = Math.min(l, i);
      for (let c = a; c <= d; c++) {
        const u = this.getRow(c);
        if (u.rowHeightEstimated) {
          const h = Di(this.beans, u);
          u.setRowHeight(h.height), s = !0, n = !0;
        }
      }
      s && this.setRowTopAndRowIndex();
    } while (s);
    return n;
  }
  onPropChange(e) {
    const { nodeManager: t, gos: o, beans: i } = this, s = i.groupStage;
    if (!t)
      return;
    const n = new Set(e), r = s?.onPropChange(n);
    let l;
    n.has("rowData") ? l = o.get("rowData") : r && (l = s?.extractData()), l && !Array.isArray(l) && (l = null, F(1));
    const a = { step: "nothing", changedProps: n };
    l && (!r && !this.isEmpty() && l.length > 0 && o.exists("getRowId") && // backward compatibility - for who want old behaviour of Row IDs but NOT Immutable Data.
    !o.get("resetRowDataOnUpdate") ? (a.keepRenderedRows = !0, a.animate = !o.get("suppressAnimationFrame"), a.changedRowNodes = new ui(), t.setImmutableRowData(a, l)) : (a.rowDataUpdated = !0, a.newData = !0, t.setNewRowData(l), this.rowNodesCountReady = !0));
    const d = a.rowDataUpdated ? "group" : this.getRefreshedStage(e);
    d && (a.step = d, this.refreshModel(a));
  }
  getRefreshedStage(e) {
    const { stages: t, stagesRefreshProps: o } = this, i = t.length;
    let s = i;
    for (let n = 0, r = e.length; n < r && s; ++n)
      s = Math.min(s, o.get(e[n]) ?? s);
    return s < i ? t[s].step : null;
  }
  setRowTopAndRowIndex(e) {
    const { beans: t, rowsToDisplay: o } = this, i = t.environment.getDefaultRowHeight();
    let s = 0;
    const n = Y(this.gos, "normal");
    for (let r = 0, l = o.length; r < l; ++r) {
      const a = o[r], d = a.id;
      if (d != null && e?.add(d), a.rowHeight == null) {
        const c = Di(t, a, n, i);
        a.setRowHeight(c.height, c.estimated);
      }
      a.setRowTop(s), a.setRowIndex(r), s += a.rowHeight;
    }
  }
  clearRowTopAndRowIndex(e, t) {
    const o = e.active, i = (r) => {
      r?.id != null && !t.has(r.id) && r.clearRowTopAndRowIndex();
    }, s = (r) => {
      i(r), i(r.detailNode), i(r.sibling);
      const l = r.childrenAfterGroup;
      if (!r.hasChildren() || !l)
        return;
      const a = r.level == -1;
      if (!(o && !a && !r.expanded))
        for (let c = 0, u = l.length; c < u; ++c)
          s(l[c]);
    }, n = this.rootNode;
    n && s(n);
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay.length;
  }
  /**
   * Returns the number of rows with level === 1
   */
  getTopLevelRowCount() {
    const { rootNode: e, rowsToDisplay: t } = this;
    if (!e || !t.length)
      return 0;
    if (t[0] === e)
      return 1;
    const i = e.sibling?.displayed ? 1 : 0;
    return (e.childrenAfterSort?.length ?? 0) + i;
  }
  /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */
  getTopLevelRowDisplayedIndex(e) {
    const { beans: t, rootNode: o, rowsToDisplay: i } = this;
    if (!o || !i.length || i[0] === o)
      return e;
    const n = o.childrenAfterSort, r = (a) => {
      let d = n[a];
      if (this.gos.get("groupHideOpenParents"))
        for (; d.expanded && d.childrenAfterSort && d.childrenAfterSort.length > 0; )
          d = d.childrenAfterSort[0];
      return d.rowIndex;
    }, l = t.footerSvc;
    return l ? l?.getTopDisplayIndex(i, e, n, r) : r(e);
  }
  /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */
  getTopLevelIndexFromDisplayedIndex(e) {
    const { rootNode: t, rowsToDisplay: o } = this;
    if (!t || !o.length || o[0] === t)
      return e;
    let s = this.getRow(e);
    s.footer && (s = s.sibling);
    let n = s.parent;
    for (; n && n !== t; )
      s = n, n = s.parent;
    const r = t.childrenAfterSort?.indexOf(s) ?? -1;
    return r >= 0 ? r : e;
  }
  getRowBounds(e) {
    const t = this.rowsToDisplay[e];
    return t ? { rowTop: t.rowTop, rowHeight: t.rowHeight } : null;
  }
  onRowGroupOpened() {
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: nt(this.gos) });
  }
  onFilterChanged({ afterDataChange: e, columns: t }) {
    if (!e) {
      const i = t.length === 0 || t.some((s) => s.isPrimary()) ? "filter" : "filter_aggregates";
      this.refreshModel({ step: i, keepRenderedRows: !0, animate: nt(this.gos) });
    }
  }
  onSortChanged() {
    this.refreshModel({
      step: "sort",
      keepRenderedRows: !0,
      animate: nt(this.gos)
    });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.refreshModel({ step: this.beans.colModel.isPivotActive() ? "pivot" : "aggregate" });
  }
  createChangePath(e) {
    const t = new Ho(!1, this.rootNode);
    return t.active = e, t;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction"))
      return !1;
    const { changedRowNodes: t, newData: o, rowDataUpdated: i } = e;
    return !(!t || o || !i || t.removals.size || t.adds.size);
  }
  refreshModel(e) {
    const { nodeManager: t, beans: o, eventSvc: i, started: s, refreshingModel: n } = this;
    if (!t)
      return;
    const r = !!e.rowDataUpdated, l = e.changedPath ?? (e.changedPath = this.createChangePath(!e.newData && r));
    if (s && r && i.dispatchEvent({ type: "rowDataUpdated" }), !s || n || o.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(e)) {
      this.rowDataUpdatedPending || (this.rowDataUpdatedPending = r);
      return;
    }
    switch (this.rowDataUpdatedPending && (this.rowDataUpdatedPending = !1, e.step = "group"), this.refreshingModel = !0, o.masterDetailSvc?.refreshModel(e), r && e.step !== "group" && o.colFilter?.refreshModel(), e.step) {
      case "group":
        this.doGrouping(e);
      case "filter":
        this.doFilter(l);
      case "pivot":
        this.doPivot(l);
      case "aggregate":
        this.doAggregate(l);
      case "filter_aggregates":
        this.doFilterAggregates(l);
      case "sort":
        this.doSort(e.changedRowNodes, l);
      case "map":
        this.doRowsToDisplay();
    }
    const a = /* @__PURE__ */ new Set();
    this.setRowTopAndRowIndex(a), this.clearRowTopAndRowIndex(l, a), this.refreshingModel = !1, i.dispatchEvent({
      type: "modelUpdated",
      animate: e.animate,
      keepRenderedRows: e.keepRenderedRows,
      newData: e.newData,
      newPage: !1,
      keepUndoRedoStack: e.keepUndoRedoStack
    });
  }
  isEmpty() {
    return !this.rootNode?._leafs?.length || !this.beans.colModel?.ready;
  }
  isRowsToRender() {
    return this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let o = !1, i = !1;
    const s = [], n = zt(this.gos);
    return this.forEachNodeAfterFilterAndSort((r) => {
      if (i)
        return;
      if (o && (r === t || r === e) && (i = !0, n && r.group)) {
        Hl(s, r);
        return;
      }
      if (!o) {
        if (r !== t && r !== e)
          return;
        o = !0, t === e && (i = !0);
      }
      (!r.group || !n) && s.push(r);
    }), s;
  }
  getTopLevelNodes() {
    return this.rootNode?.childrenAfterGroup ?? null;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    const t = this.rowsToDisplay, o = t.length;
    if (this.isEmpty() || o === 0)
      return -1;
    let i = 0, s = o - 1;
    if (e <= 0)
      return 0;
    if (t[s].rowTop <= e)
      return s;
    let r = -1, l = -1;
    for (; ; ) {
      const a = Math.floor((i + s) / 2), d = t[a];
      if (this.isRowInPixel(d, e) || (d.rowTop < e ? i = a + 1 : d.rowTop > e && (s = a - 1), r === i && l === s))
        return a;
      r = i, l = s;
    }
  }
  isRowInPixel(e, t) {
    const o = e.rowTop, i = o + e.rowHeight;
    return o <= t && i > t;
  }
  forEachLeafNode(e) {
    const t = this.rootNode?._leafs;
    if (t)
      for (let o = 0, i = t.length; o < i; ++o)
        e(t[o], o);
  }
  forEachNode(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t);
  }
  forEachDisplayedNode(e) {
    const t = this.rowsToDisplay;
    for (let o = 0, i = t.length; o < i; ++o)
      e(t[o], o);
  }
  forEachNodeAfterFilter(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (o) => o.childrenAfterAggFilter);
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (o) => o.childrenAfterSort);
  }
  forEachPivotNode(e, t, o) {
    const { colModel: i, rowGroupColsSvc: s } = this.beans;
    if (!i.isPivotMode())
      return;
    if (!s?.columns.length) {
      e(this.rootNode, 0);
      return;
    }
    const n = o ? "childrenAfterSort" : "childrenAfterGroup";
    this.depthFirstSearchRowNodes(
      e,
      t,
      (r) => r.leafGroup ? null : r[n]
    );
  }
  /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */
  depthFirstSearchRowNodes(e, t = !1, o = (n) => n.childrenAfterGroup, i = this.rootNode, s = 0) {
    let n = s;
    if (!i)
      return n;
    const r = i === this.rootNode;
    if (r || e(i, n++), i.hasChildren() && !i.footer) {
      const l = o(i);
      if (l) {
        const a = this.beans.footerSvc;
        n = a?.addTotalRows(n, i, e, t, r, "top") ?? n;
        for (const d of l)
          n = this.depthFirstSearchRowNodes(e, t, o, d, n);
        return a?.addTotalRows(n, i, e, t, r, "bottom") ?? n;
      }
    }
    return n;
  }
  // it's possible to recompute the aggregate without doing the other parts + api.refreshClientSideRowModel('aggregate')
  doAggregate(e) {
    const t = this.rootNode;
    t && this.beans.aggStage?.execute({ rowNode: t, changedPath: e });
  }
  doFilterAggregates(e) {
    const t = this.rootNode, o = this.beans.filterAggStage;
    if (o) {
      o.execute({ rowNode: t, changedPath: e });
      return;
    }
    t.childrenAfterAggFilter = t.childrenAfterFilter;
  }
  doSort(e, t) {
    const o = this.beans.sortStage;
    if (o) {
      o.execute({
        rowNode: this.rootNode,
        changedRowNodes: e,
        changedPath: t
      });
      return;
    }
    t.forEachChangedNodeDepthFirst((i) => {
      i.childrenAfterSort = i.childrenAfterAggFilter.slice(0), Gl(i);
    });
  }
  doGrouping(e) {
    const t = this.rootNode, i = this.beans.groupStage?.execute({
      rowNode: t,
      changedRowNodes: e.changedRowNodes,
      changedPath: e.changedPath,
      afterColumnsChanged: !!e.afterColumnsChanged
    });
    if (i === void 0) {
      const s = t._leafs;
      t.childrenAfterGroup = s, t.updateHasChildren();
      const n = t.sibling;
      n && (n.childrenAfterGroup = s);
    }
    (i || e.rowDataUpdated) && this.beans.colFilter?.refreshModel(), !this.rowCountReady && this.rowNodesCountReady && (this.rowCountReady = !0, this.eventSvc.dispatchEventOnce({ type: "rowCountReady" }));
  }
  doFilter(e) {
    const t = this.beans.filterStage;
    if (t) {
      t.execute({ rowNode: this.rootNode, changedPath: e });
      return;
    }
    e.forEachChangedNodeDepthFirst((o) => {
      o.childrenAfterFilter = o.childrenAfterGroup, Rv(o);
    }, !0);
  }
  doPivot(e) {
    this.beans.pivotStage?.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getRowNode(e) {
    const t = this.nodeManager?.getRowNode(e);
    return typeof t == "object" ? t : typeof e == "string" && e.indexOf(Vi) === 0 ? this.beans.groupStage?.getNode(e) : void 0;
  }
  batchUpdateRowData(e, t) {
    if (!this.asyncTransactionsTimer) {
      this.asyncTransactions = [];
      const o = this.gos.get("asyncTransactionWaitMillis");
      this.asyncTransactionsTimer = setTimeout(() => this.executeBatchUpdateRowData(), o);
    }
    this.asyncTransactions.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    const e = this.asyncTransactionsTimer;
    e && (clearTimeout(e), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    const { nodeManager: e, beans: t, eventSvc: o, asyncTransactions: i } = this;
    if (!e)
      return;
    t.valueCache?.onDataChanged();
    const s = [], n = [], r = new ui();
    for (const { rowDataTransaction: l, callback: a } of i ?? []) {
      this.rowNodesCountReady = !0;
      const d = e.updateRowData(l, r);
      s.push(d), a && n.push(a.bind(null, d));
    }
    this.commitTransactions(r), n.length > 0 && setTimeout(() => {
      for (let l = 0, a = n.length; l < a; l++)
        n[l]();
    }, 0), s.length > 0 && o.dispatchEvent({ type: "asyncTransactionsFlushed", results: s }), this.asyncTransactionsTimer = 0, this.asyncTransactions = null;
  }
  /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */
  updateRowData(e) {
    const t = this.nodeManager;
    if (!t)
      return null;
    this.beans.valueCache?.onDataChanged(), this.rowNodesCountReady = !0;
    const o = new ui(), i = t.updateRowData(e, o);
    return this.commitTransactions(o), i;
  }
  /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */
  commitTransactions(e) {
    this.refreshModel({
      step: "group",
      rowDataUpdated: !0,
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedRowNodes: e,
      changedPath: this.createChangePath(!0)
    });
  }
  doRowsToDisplay() {
    const { beans: e, rootNode: t } = this, o = e.flattenStage;
    if (o) {
      this.rowsToDisplay = o.execute({ rowNode: t });
      return;
    }
    const i = this.rootNode.childrenAfterSort ?? [];
    for (const s of i)
      s.setUiLevel(0);
    this.rowsToDisplay = i;
  }
  onRowHeightChanged() {
    this.refreshModel({ step: "map", keepRenderedRows: !0, keepUndoRedoStack: !0 });
  }
  resetRowHeights() {
    const e = this.rootNode;
    if (!e)
      return;
    const t = this.resetRowHeightsForAllRowNodes();
    e.setRowHeight(e.rowHeight, !0);
    const o = e.sibling;
    o?.setRowHeight(o.rowHeight, !0), t && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const o = t.detailNode;
      o?.setRowHeight(o.rowHeight, !0);
      const i = t.sibling;
      i?.setRowHeight(i.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges(e) {
    e.rowHeightChanged && !this.beans.rowAutoHeight?.active && this.resetRowHeights();
  }
  onGridReady() {
    this.started || this.setInitialData();
  }
  destroy() {
    super.destroy(), this.nodeManager = this.destroyBean(this.nodeManager), this.started = !1, this.rootNode = null, this.rowsToDisplay = [], this.asyncTransactions = null, clearTimeout(this.asyncTransactionsTimer);
  }
  /**
   * @deprecated v33.1
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
}, Hl = (e, t) => {
  const o = t.childrenAfterGroup;
  if (o)
    for (let i = 0, s = o.length; i < s; ++i) {
      const n = o[i];
      n.data && e.push(n), n.group && Hl(e, n);
    }
};
function ow(e) {
  e.expansionSvc?.onGroupExpandedOrCollapsed();
}
function iw(e, t) {
  const o = Oe(e);
  o && ((!t || t === "everything") && (t = "group"), o.refreshModel({
    step: t,
    keepRenderedRows: !0,
    animate: !e.gos.get("suppressAnimationFrame")
  }));
}
function sw(e) {
  return Oe(e)?.isEmpty() ?? !0;
}
function nw(e, t) {
  Oe(e)?.forEachLeafNode(t);
}
function rw(e, t) {
  Oe(e)?.forEachNodeAfterFilter(t);
}
function lw(e, t) {
  Oe(e)?.forEachNodeAfterFilterAndSort(t);
}
function aw(e, t) {
  return e.frameworkOverrides.wrapIncoming(
    () => Oe(e)?.updateRowData(t)
  );
}
function dw(e, t, o) {
  e.frameworkOverrides.wrapIncoming(
    () => Oe(e)?.batchUpdateRowData(t, o)
  );
}
function cw(e) {
  e.frameworkOverrides.wrapIncoming(() => Oe(e)?.flushAsyncTransactions());
}
function uw(e) {
  return e.selectionSvc?.getBestCostNodeSelection();
}
var yS = {
  moduleName: "ClientSideRowModel",
  version: M,
  rowModels: ["clientSide"],
  beans: [tw, Qv],
  dependsOn: [Fl]
}, RS = {
  moduleName: "ClientSideRowModelApi",
  version: M,
  apiFunctions: {
    onGroupExpandedOrCollapsed: ow,
    refreshClientSideRowModel: iw,
    isRowDataEmpty: sw,
    forEachLeafNode: nw,
    forEachNodeAfterFilter: rw,
    forEachNodeAfterFilterAndSort: lw,
    applyTransaction: aw,
    applyTransactionAsync: dw,
    flushAsyncTransactions: cw,
    getBestCostNodeSelection: uw,
    resetRowHeights: Ll,
    onRowHeightChanged: kl
  },
  dependsOn: [_v, Uv]
}, hw = "↑", gw = "↓", pw = {
  tag: "span",
  children: [
    { tag: "span", ref: "eDelta", cls: "ag-value-change-delta" },
    { tag: "span", ref: "eValue", cls: "ag-value-change-value" }
  ]
}, fw = class extends O {
  constructor() {
    super(pw), this.eValue = P, this.eDelta = P, this.refreshCount = 0;
  }
  init(e) {
    this.refresh(e, !0);
  }
  showDelta(e, t) {
    const o = Math.abs(t), i = e.formatValue(o), s = A(i) ? i : o, n = t >= 0, r = this.eDelta;
    n ? r.textContent = hw + s : r.textContent = gw + s, r.classList.toggle("ag-value-change-delta-up", n), r.classList.toggle("ag-value-change-delta-down", !n);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), J(this.eDelta);
  }
  refresh(e, t = !1) {
    const { value: o, valueFormatted: i } = e, { eValue: s, lastValue: n, beans: r } = this;
    if (o === n || (A(i) ? s.textContent = i : A(o) ? s.textContent = o : J(s), r.filterManager?.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    const l = o && typeof o == "object" && "toNumber" in o ? o.toNumber() : o, a = n && typeof n == "object" && "toNumber" in n ? n.toNumber() : n;
    if (l === a)
      return !1;
    if (typeof l == "number" && typeof a == "number") {
      const d = l - a;
      this.showDelta(e, d);
    }
    return n && s.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = o, !0;
  }
}, Cw = (
  /*css*/
  ".ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}"
), mw = {
  tag: "span",
  children: [{ tag: "span", ref: "eCurrent", cls: "ag-value-slide-current" }]
}, vw = class extends O {
  constructor() {
    super(mw), this.eCurrent = P, this.refreshCount = 0, this.registerCSS(Cw);
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious?.remove();
    const { beans: t, eCurrent: o } = this, i = ie({ tag: "span", cls: "ag-value-slide-previous ag-value-slide-out" });
    this.ePrevious = i, i.textContent = o.textContent, this.getGui().insertBefore(i, o), t.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.ePrevious?.remove(), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    let o = e.value;
    if (H(o) && (o = ""), o === this.lastValue || this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering())
      return !1;
    t || this.addSlideAnimation(), this.lastValue = o;
    const i = this.eCurrent;
    return A(e.valueFormatted) ? i.textContent = e.valueFormatted : A(e.value) ? i.textContent = o : J(i), !0;
  }
}, ww = class extends b {
  constructor() {
    super(...arguments), this.beanName = "cellFlashSvc", this.nextAnimationTime = null, this.nextAnimationCycle = null, this.animations = {
      highlight: /* @__PURE__ */ new Map(),
      "data-changed": /* @__PURE__ */ new Map()
    };
  }
  animateCell(e, t, o = this.beans.gos.get("cellFlashDuration"), i = this.beans.gos.get("cellFadeDuration")) {
    const s = this.animations[t];
    s.delete(e);
    const n = Date.now(), r = n + o, l = n + o + i, a = {
      phase: "flash",
      flashEndTime: r,
      fadeEndTime: l
    };
    s.set(e, a);
    const d = `ag-cell-${t}`, c = `${d}-animation`, {
      comp: u,
      eGui: { style: h }
    } = e;
    u.toggleCss(d, !0), u.toggleCss(c, !1), h.removeProperty("transition"), h.removeProperty("transition-delay"), this.nextAnimationTime && r + 15 < this.nextAnimationTime && (clearTimeout(this.nextAnimationCycle), this.nextAnimationCycle = null, this.nextAnimationTime = null), this.nextAnimationCycle || (this.beans.frameworkOverrides.wrapIncoming(() => {
      this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), o);
    }), this.nextAnimationTime = r);
  }
  advanceAnimations() {
    const e = Date.now();
    let t = null;
    for (const o of Object.keys(this.animations)) {
      const i = this.animations[o], s = `ag-cell-${o}`, n = `${s}-animation`;
      for (const [r, l] of i) {
        if (!r.isAlive() || !r.comp) {
          i.delete(r);
          continue;
        }
        const { phase: a, flashEndTime: d, fadeEndTime: c } = l, u = a === "flash" ? d : c;
        if (!(e + 15 >= u)) {
          t = Math.min(u, t ?? 1 / 0);
          continue;
        }
        const {
          comp: g,
          eGui: { style: p }
        } = r;
        switch (a) {
          case "flash":
            g.toggleCss(s, !1), g.toggleCss(n, !0), p.transition = `background-color ${c - d}ms`, p.transitionDelay = `${d - e}ms`, t = Math.min(c, t ?? 1 / 0), l.phase = "fade";
            break;
          case "fade":
            g.toggleCss(s, !1), g.toggleCss(n, !1), p.removeProperty("transition"), p.removeProperty("transition-delay"), i.delete(r);
            break;
        }
      }
    }
    t == null ? (this.nextAnimationTime = null, this.nextAnimationCycle = null) : t && (this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), t - e), this.nextAnimationTime = t);
  }
  onFlashCells(e, t) {
    if (!e.comp)
      return;
    const o = Sg(e.cellPosition);
    t.cells[o] && this.animateCell(e, "highlight");
  }
  flashCell(e, t) {
    this.animateCell(e, "data-changed", t?.flashDuration, t?.fadeDuration);
  }
  destroy() {
    for (const e of Object.keys(this.animations))
      this.animations[e].clear();
  }
};
function Sw(e, t = {}) {
  const { cellFlashSvc: o } = e;
  o && e.frameworkOverrides.wrapIncoming(() => {
    for (const i of e.rowRenderer.getCellCtrls(t.rowNodes, t.columns))
      o.flashCell(i, t);
  });
}
var xS = {
  moduleName: "HighlightChanges",
  version: M,
  beans: [ww],
  userComponents: {
    agAnimateShowChangeCellRenderer: fw,
    agAnimateSlideCellRenderer: vw
  },
  apiFunctions: {
    flashCells: Sw
  }
};
function bw(e) {
  return e.rowModel.isLastRowIndexKnown();
}
function yw(e) {
  return e.pagination?.getPageSize() ?? 100;
}
function Rw(e) {
  return e.pagination?.getCurrentPage() ?? 0;
}
function xw(e) {
  return e.pagination?.getTotalPages() ?? 1;
}
function Pw(e) {
  return e.pagination ? e.pagination.getMasterRowCount() : e.rowModel.getRowCount();
}
function Dw(e) {
  e.pagination?.goToNextPage();
}
function Fw(e) {
  e.pagination?.goToPreviousPage();
}
function Ew(e) {
  e.pagination?.goToFirstPage();
}
function Aw(e) {
  e.pagination?.goToLastPage();
}
function Mw(e, t) {
  e.pagination?.goToPage(t);
}
var Tw = class extends b {
  constructor() {
    super(...arguments), this.beanName = "paginationAutoPageSizeSvc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowsCtrl = e.center;
      const t = this.checkPageSize.bind(this);
      this.addManagedEventListeners({
        bodyHeightChanged: t,
        scrollVisibilityChanged: t
      }), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.beans.pagination.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
    if (e > 0) {
      const t = this.beans, o = () => {
        const i = Math.max(Bo(t), 1), s = Math.floor(e / i);
        t.pagination.setPageSize(s, "autoCalculated");
      };
      this.isBodyRendered ? We(this, o, 50)() : (o(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
}, Pt = "paginationPageSizeSelector", Iw = { tag: "span", cls: "ag-paging-page-size" }, kw = class extends O {
  constructor() {
    super(Iw), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.pagination.getPageSize() || (this.pagination.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  wireBeans(e) {
    this.pagination = e.pagination;
  }
  postConstruct() {
    this.addManagedPropertyListener(Pt, () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedEventListeners({ paginationChanged: (e) => this.handlePaginationChanged(e) });
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !e?.newPageSize)
      return;
    const t = this.pagination.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && !e && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp);
  }
  reset() {
    J(this.getGui()), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get(Pt) !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.pagination.getPageSize(), o = !t || !e.includes(t);
    if (o) {
      const s = this.gos.exists("paginationPageSize"), n = this.gos.get(Pt) !== !0;
      F(94, { pageSizeSet: s, pageSizesSet: n, pageSizeOptions: e, paginationPageSizeOption: t }), n || F(95, { paginationPageSizeOption: t, paginationPageSizeSelector: Pt }), e.unshift("");
    }
    const i = String(o ? "" : t);
    this.selectPageSizeComp ? (St(this.pageSizeOptions, e) || (this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(e)), this.pageSizeOptions = e), this.selectPageSizeComp.setValue(i, !0)) : this.createPageSizeSelectorComp(e, i), this.hasEmptyOption = o;
  }
  createPageSizeSelectOptions(e) {
    return e.map((t) => ({
      value: String(t)
    }));
  }
  createPageSizeSelectorComp(e, t) {
    const o = this.getLocaleTextFunc(), i = o("pageSizeSelectorLabel", "Page Size:"), s = o("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new Ec()).addOptions(this.createPageSizeSelectOptions(e)).setValue(t).setAriaLabel(s).setLabel(i).onValueChange(() => this.handlePageSizeItemSelected()), this.appendChild(this.selectPageSizeComp);
  }
  getPageSizeSelectorValues() {
    const e = [20, 50, 100], t = this.gos.get(Pt);
    return !Array.isArray(t) || !t?.length ? e : [...t].sort((o, i) => o - i);
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
}, Lw = {
  selector: "AG-PAGE-SIZE-SELECTOR",
  component: kw
}, Gw = (
  /*css*/
  ".ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}"
), Hw = class extends Jr {
  constructor() {
    super(), this.btFirst = P, this.btPrevious = P, this.btNext = P, this.btLast = P, this.lbRecordCount = P, this.lbFirstRowOnPage = P, this.lbLastRowOnPage = P, this.lbCurrent = P, this.lbTotal = P, this.pageSizeComp = P, this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1, this.allowFocusInnerElement = !1, this.registerCSS(Gw);
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pagination = e.pagination, this.ariaAnnounce = e.ariaAnnounce;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate(), [Lw]);
    const { btFirst: t, btPrevious: o, btNext: i, btLast: s } = this;
    this.activateTabIndex([t, o, i, s]), t.insertAdjacentElement("afterbegin", ye(e ? "last" : "first", this.beans)), o.insertAdjacentElement("afterbegin", ye(e ? "next" : "previous", this.beans)), i.insertAdjacentElement("afterbegin", ye(e ? "previous" : "next", this.beans)), s.insertAdjacentElement("afterbegin", ye(e ? "first" : "last", this.beans)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(
      ["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"],
      () => this.onPageSizeRelatedOptionsChange()
    ), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.initialiseTabGuard({
      // prevent tab guard default logic
      onTabKeyDown: () => {
      },
      focusInnerElement: (n) => this.allowFocusInnerElement ? this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(n) : nh(this.beans, n),
      forceFocusOutWhenTabGuardsAreEmpty: !0
    }), this.onPaginationChanged();
  }
  setAllowFocus(e) {
    this.allowFocusInnerElement = e;
  }
  onPaginationChanged() {
    const t = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(t), t && (this.setupListeners(), this.enableOrDisableButtons(), this.updateLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
  }
  setupListeners() {
    if (!this.areListenersSetup) {
      this.addManagedEventListeners({ paginationChanged: this.onPaginationChanged.bind(this) });
      for (const e of [
        { el: this.btFirst, fn: this.onBtFirst.bind(this) },
        { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
        { el: this.btNext, fn: this.onBtNext.bind(this) },
        { el: this.btLast, fn: this.onBtLast.bind(this) }
      ]) {
        const { el: t, fn: o } = e;
        this.addManagedListeners(t, {
          click: o,
          keydown: (i) => {
            (i.key === w.ENTER || i.key === w.SPACE) && (i.preventDefault(), o());
          }
        });
      }
      sh(this.beans, this, this.getGui()), this.areListenersSetup = !0;
    }
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToFirstPage();
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    return t ? t({ value: e }) : uv(e, this.getLocaleTextFunc.bind(this));
  }
  getTemplate() {
    const e = this.getLocaleTextFunc(), t = `ag-${this.getCompId()}`;
    return {
      tag: "div",
      cls: "ag-paging-panel ag-unselectable",
      attrs: { id: `${t}` },
      children: [
        {
          tag: "ag-page-size-selector",
          ref: "pageSizeComp"
        },
        {
          tag: "span",
          cls: "ag-paging-row-summary-panel",
          children: [
            {
              tag: "span",
              ref: "lbFirstRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-first-row` }
            },
            { tag: "span", attrs: { id: `${t}-to` }, children: e("to", "to") },
            {
              tag: "span",
              ref: "lbLastRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-last-row` }
            },
            { tag: "span", attrs: { id: `${t}-of` }, children: e("of", "of") },
            {
              tag: "span",
              ref: "lbRecordCount",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-row-count` }
            }
          ]
        },
        {
          tag: "span",
          cls: "ag-paging-page-summary-panel",
          role: "presentation",
          children: [
            {
              tag: "div",
              ref: "btFirst",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("firstPage", "First Page") }
            },
            {
              tag: "div",
              ref: "btPrevious",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("previousPage", "Previous Page") }
            },
            {
              tag: "span",
              cls: "ag-paging-description",
              children: [
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-start-page`
                  },
                  children: e("page", "Page")
                },
                {
                  tag: "span",
                  ref: "lbCurrent",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-start-page-number` }
                },
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-of-page`
                  },
                  children: e("of", "of")
                },
                {
                  tag: "span",
                  ref: "lbTotal",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-of-page-number` }
                }
              ]
            },
            {
              tag: "div",
              ref: "btNext",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("nextPage", "Next Page") }
            },
            {
              tag: "div",
              ref: "btLast",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("lastPage", "Last Page") }
            }
          ]
        }
      ]
    };
  }
  onBtNext() {
    this.nextButtonDisabled || this.pagination.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.pagination.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.pagination.getCurrentPage(), t = this.rowModel.isLastRowIndexKnown(), o = this.pagination.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const i = this.isZeroPagesToDisplay(), s = e === o - 1;
    this.nextButtonDisabled = s || i, this.lastButtonDisabled = !t || i || e === o - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    Ql(e, t), e.classList.toggle("ag-disabled", t);
  }
  isZeroPagesToDisplay() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages();
    return e && t === 0;
  }
  updateLabels() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages(), o = this.pagination.getMasterRowCount(), i = e ? o : null, s = this.pagination.getCurrentPage(), n = this.pagination.getPageSize();
    let r, l;
    this.isZeroPagesToDisplay() ? r = l = 0 : (r = n * s + 1, l = r + n - 1, e && l > i && (l = i));
    const a = r + n - 1, d = !e && o < a, c = this.formatNumber(r);
    this.lbFirstRowOnPage.textContent = c;
    let u;
    const h = this.getLocaleTextFunc();
    d ? u = h("pageLastRowUnknown", "?") : u = this.formatNumber(l), this.lbLastRowOnPage.textContent = u;
    const p = t > 0 ? s + 1 : 0, f = this.formatNumber(p);
    this.lbCurrent.textContent = f;
    let C, m;
    if (e)
      C = this.formatNumber(t), m = this.formatNumber(i);
    else {
      const v = h("more", "more");
      C = v, m = v;
    }
    this.lbTotal.textContent = C, this.lbRecordCount.textContent = m, this.announceAriaStatus(c, u, m, f, C);
  }
  announceAriaStatus(e, t, o, i, s) {
    const n = this.getLocaleTextFunc(), r = n("page", "Page"), l = n("to", "to"), a = n("of", "of"), d = `${e} ${l} ${t} ${a} ${o}`, c = `${r} ${i} ${a} ${s}`;
    d !== this.ariaRowStatus && (this.ariaRowStatus = d, this.ariaAnnounce?.announceValue(d, "paginationRow")), c !== this.ariaPageStatus && (this.ariaPageStatus = c, this.ariaAnnounce?.announceValue(c, "paginationPage"));
  }
}, Ow = {
  selector: "AG-PAGINATION",
  component: Hw
}, Bw = class extends b {
  constructor() {
    super(...arguments), this.beanName = "pagination", this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.masterRowCount = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("pagination"), this.pageSizeFromGridOptions = e.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
  }
  getPaginationSelector() {
    return Ow;
  }
  isPaginateChildRows() {
    const e = this.gos;
    return e.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
    e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") ? !0 : e.get("paginateChildRows");
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages(), this.dispatchPaginationChangedEvent({ keepRenderedRows: !0 });
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    const t = this.currentPage;
    if (!this.active || t === e || typeof t != "number")
      return;
    const { editSvc: o } = this.beans;
    o?.isEditing() && (o.isBatchEditing() ? o.cleanupEditors() : o.stopEditing(void 0, { source: "api" })), this.currentPage = e, this.calculatePages(), this.dispatchPaginationChangedEvent({ newPage: !0 });
  }
  goToPageWithIndex(e) {
    if (!this.active)
      return;
    let t = e;
    this.paginateChildRows || (t = this.beans.rowModel.getTopLevelIndexFromDisplayedIndex?.(e) ?? e), this.goToPage(Math.floor(t / this.pageSize));
  }
  isRowInPage(e) {
    return this.active ? e >= this.topDisplayedRowIndex && e <= this.bottomDisplayedRowIndex : !0;
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.beans.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  /** This is only for state setting before data has been loaded */
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return A(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize") ? this.pageSizeAutoCalculated : A(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : A(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : A(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    this.pageSizeAutoCalculated = void 0, this.pageSize !== e && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0 }));
  }
  setPageSize(e, t) {
    const o = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
        break;
    }
    o !== this.pageSize && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0, keepRenderedRows: !0 }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    const e = this.totalPages;
    this.currentPage >= e && (this.currentPage = e - 1);
    const t = this.currentPage;
    (!isFinite(t) || isNaN(t) || t < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    const e = this.beans.rowModel, t = e.getTopLevelRowCount();
    if (this.masterRowCount = t, t <= 0) {
      this.setZeroRows();
      return;
    }
    const o = this.pageSize, i = t - 1;
    this.totalPages = Math.floor(i / o) + 1, this.adjustCurrentPageIfInvalid();
    const s = this.currentPage, n = o * s;
    let r = o * (s + 1) - 1;
    if (r > i && (r = i), this.topDisplayedRowIndex = e.getTopLevelRowDisplayedIndex(n), r === i)
      this.bottomDisplayedRowIndex = e.getRowCount() - 1;
    else {
      const l = e.getTopLevelRowDisplayedIndex(r + 1);
      this.bottomDisplayedRowIndex = l - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    const e = this.beans.rowModel.getRowCount();
    if (this.masterRowCount = e, e === 0) {
      this.setZeroRows();
      return;
    }
    const { pageSize: t, currentPage: o } = this, i = e - 1;
    this.totalPages = Math.floor(i / t) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = t * o, this.bottomDisplayedRowIndex = t * (o + 1) - 1, this.bottomDisplayedRowIndex > i && (this.bottomDisplayedRowIndex = i);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
  }
  dispatchPaginationChangedEvent(e) {
    const { keepRenderedRows: t = !1, newPage: o = !1, newPageSize: i = !1 } = e;
    this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: !1,
      newData: !1,
      newPage: o,
      newPageSize: i,
      keepRenderedRows: t
    });
  }
}, PS = {
  moduleName: "Pagination",
  version: M,
  beans: [Bw, Tw],
  icons: {
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last"
  },
  apiFunctions: {
    paginationIsLastPageFound: bw,
    paginationGetPageSize: yw,
    paginationGetCurrentPage: Rw,
    paginationGetTotalPages: xw,
    paginationGetRowCount: Pw,
    paginationGoToNextPage: Dw,
    paginationGoToPreviousPage: Fw,
    paginationGoToFirstPage: Ew,
    paginationGoToLastPage: Aw,
    paginationGoToPage: Mw
  },
  dependsOn: [Pv]
};
function Vw(e, t = {}) {
  const o = t ? t.rowNodes : void 0;
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.redrawRows(o));
}
function Ol(e, t, o, i, s) {
  t && (i && t.parent && t.parent.level !== -1 && Ol(e, t.parent, o, i, s), t.setExpanded(o, void 0, s));
}
function Ww(e, t) {
  return e.rowModel.getRowNode(t);
}
function Nw(e, t, o, i) {
  e.rowRenderer.addRenderedRowListener(t, o, i);
}
function zw(e) {
  return e.rowRenderer.getRenderedNodes();
}
function _w(e, t, o) {
  e.rowModel.forEachNode(t, o);
}
function Uw(e) {
  return e.rowRenderer.firstRenderedRow;
}
function $w(e) {
  return e.rowRenderer.lastRenderedRow;
}
function Kw(e, t) {
  return e.rowModel.getRow(t);
}
function jw(e) {
  return e.rowModel.getRowCount();
}
var DS = {
  moduleName: "RowApi",
  version: M,
  apiFunctions: {
    redrawRows: Vw,
    setRowNodeExpanded: Ol,
    getRowNode: Ww,
    addRenderedRowListener: Nw,
    getRenderedNodes: zw,
    forEachNode: _w,
    getFirstDisplayedRowIndex: Uw,
    getLastDisplayedRowIndex: $w,
    getDisplayedRowAtIndex: Kw,
    getDisplayedRowCount: jw
  }
};
function qw(e, t, o) {
  if (!t)
    return;
  const i = e.ctrlsSvc.getGridBodyCtrl().eGridBody, s = `aria-${t}`;
  o === null ? i.removeAttribute(s) : i.setAttribute(s, o);
}
function Yw(e, t = {}) {
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.refreshCells(t));
}
function Zw(e) {
  e.frameworkOverrides.wrapIncoming(() => {
    for (const t of e.ctrlsSvc.getHeaderRowContainerCtrls())
      t.refresh();
  });
}
function Qw(e) {
  return e.animationFrameSvc?.isQueueEmpty() ?? !0;
}
function Xw(e) {
  e.animationFrameSvc?.flushAllFrames();
}
function Jw(e) {
  return {
    rowHeight: Bo(e),
    headerHeight: Zt(e)
  };
}
function eS(e, t = {}) {
  const o = [];
  for (const n of e.rowRenderer.getCellCtrls(t.rowNodes, t.columns)) {
    const r = n.getCellRenderer();
    r != null && o.push(Ii(r));
  }
  if (t.columns?.length)
    return o;
  const i = [], s = $i(t.rowNodes);
  for (const n of e.rowRenderer.getAllRowCtrls()) {
    if (s && !Ki(n.rowNode, s) || !n.isFullWidth())
      continue;
    const r = n.getFullWidthCellRenderers();
    for (let l = 0; l < r.length; l++) {
      const a = r[l];
      a != null && i.push(Ii(a));
    }
  }
  return [...i, ...o];
}
var FS = {
  moduleName: "RenderApi",
  version: M,
  apiFunctions: {
    setGridAriaProperty: qw,
    refreshCells: Yw,
    refreshHeader: Zw,
    isAnimationFrameQueueEmpty: Qw,
    flushAllAnimationFrames: Xw,
    getSizesForCurrentTheme: Jw,
    getCellRendererInstances: eS
  }
};
function tS(e, t) {
  typeof t == "number" ? e.colAutosize?.sizeColumnsToFit(t, "api") : e.colAutosize?.sizeColumnsToFitGridBody(t);
}
function Bl({ colAutosize: e, visibleCols: t }, o, i) {
  Array.isArray(o) ? e?.autoSizeCols({ colKeys: o, skipHeader: i, source: "api" }) : e?.autoSizeCols({
    ...o,
    colKeys: o.colIds ?? t.allCols,
    source: "api"
  });
}
function oS(e, t) {
  t && typeof t == "object" ? Bl(e, t) : e.colAutosize?.autoSizeAllColumns({ source: "api", skipHeader: t });
}
var iS = class extends b {
  constructor() {
    super(...arguments), this.beanName = "colAutosize", this.timesDelayed = 0, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  postConstruct() {
    const { gos: e } = this, t = e.get("autoSizeStrategy");
    if (t) {
      let o = !1;
      const i = t.type;
      if (i === "fitGridWidth" || i === "fitProvidedWidth")
        o = !0;
      else if (i === "fitCellContents") {
        this.addManagedEventListeners({ firstDataRendered: () => this.onFirstDataRendered(t) });
        const s = e.get("rowData");
        o = s != null && s.length > 0 && re(e);
      }
      o && this.beans.colDelayRenderSvc?.hideColumns(i);
    }
  }
  autoSizeCols(e) {
    const { eventSvc: t, visibleCols: o } = this.beans;
    this.innerAutoSizeCols(e).then((i) => {
      const s = (d) => gt(t, Array.from(d), !0, "autosizeColumns");
      if (!e.scaleUpToFitGridWidth)
        return s(i);
      const n = bn(this.beans), r = (d) => o.leftCols.some((c) => It(c, d)), l = (d) => o.rightCols.some((c) => It(c, d)), a = e.colKeys.filter(
        (d) => !He(d) && !Te(d) && !r(d) && !l(d)
      );
      this.sizeColumnsToFit(n, e.source, !0, {
        defaultMaxWidth: e.defaultMaxWidth,
        defaultMinWidth: e.defaultMinWidth,
        columnLimits: e.columnLimits?.map((d) => ({ ...d, key: d.colId })),
        colKeys: a,
        onlyScaleUp: !0
      }), s(i);
    });
  }
  innerAutoSizeCols(e) {
    return new Promise((t, o) => {
      if (this.shouldQueueResizeOperations)
        return this.pushResizeOperation(() => this.innerAutoSizeCols(e).then(t, o));
      const {
        colKeys: i,
        skipHeader: s,
        skipHeaderGroups: n,
        stopAtGroup: r,
        defaultMaxWidth: l,
        defaultMinWidth: a,
        columnLimits: d = [],
        source: c = "api"
      } = e, { animationFrameSvc: u, renderStatus: h, colModel: g, autoWidthCalc: p, visibleCols: f } = this.beans;
      if (u?.flushAllFrames(), this.timesDelayed < 5 && h && (!h.areHeaderCellsRendered() || !h.areCellsRendered())) {
        this.timesDelayed++, setTimeout(() => {
          this.isAlive() && this.innerAutoSizeCols(e).then(t, o);
        });
        return;
      }
      this.timesDelayed = 0;
      const C = /* @__PURE__ */ new Set();
      let m = -1;
      const v = Object.fromEntries(
        d.map(({ colId: y, ...R }) => [y, R])
      ), S = s ?? this.gos.get("skipHeaderOnAutoSize"), D = n ?? S;
      for (; m !== 0; ) {
        m = 0;
        const y = [];
        for (const R of i) {
          if (!R || rd(R))
            continue;
          const x = g.getCol(R);
          if (!x || C.has(x))
            continue;
          const k = p.getPreferredWidthForColumn(x, S);
          if (k > 0) {
            const I = v[x.colId] ?? {};
            I.minWidth ?? (I.minWidth = a), I.maxWidth ?? (I.maxWidth = l);
            const T = sS(x, k, I);
            x.setActualWidth(T, c), C.add(x), m++;
          }
          y.push(x);
        }
        y.length && f.refresh(c);
      }
      D || this.autoSizeColumnGroupsByColumns(i, c, r), t(C);
    });
  }
  autoSizeColumn(e, t, o) {
    this.autoSizeCols({ colKeys: [e], skipHeader: o, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, o) {
    const { colModel: i, ctrlsSvc: s } = this.beans, n = /* @__PURE__ */ new Set(), r = i.getColsForKeys(e);
    for (const a of r) {
      let d = a.getParent();
      for (; d && d != o; )
        d.isPadding() || n.add(d), d = d.getParent();
    }
    let l;
    for (const a of n) {
      for (const d of s.getHeaderRowContainerCtrls())
        if (l = d.getHeaderCtrlForColumn(a), l)
          break;
      l?.resizeLeafColumnsToFit(t);
    }
  }
  autoSizeAllColumns(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeAllColumns(e));
      return;
    }
    this.autoSizeCols({ colKeys: this.beans.visibleCols.allCols, ...e });
  }
  addColumnAutosizeListeners(e, t) {
    const o = this.gos.get("skipHeaderOnAutoSize"), i = () => {
      this.autoSizeColumn(t, "uiColumnResized", o);
    };
    e.addEventListener("dblclick", i);
    const s = new Be(e);
    return s.addEventListener("doubleTap", i), () => {
      e.removeEventListener("dblclick", i), s.destroy();
    };
  }
  addColumnGroupResize(e, t, o) {
    const i = this.gos.get("skipHeaderOnAutoSize"), s = () => {
      const n = [], r = t.getDisplayedLeafColumns();
      for (const l of r)
        l.getColDef().suppressAutoSize || n.push(l.getColId());
      n.length > 0 && this.autoSizeCols({
        colKeys: n,
        skipHeader: i,
        stopAtGroup: t,
        source: "uiColumnResized"
      }), o();
    };
    return e.addEventListener("dblclick", s), () => e.removeEventListener("dblclick", s);
  }
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  sizeColumnsToFitGridBody(e, t) {
    if (!this.isAlive())
      return;
    const o = bn(this.beans);
    if (o > 0) {
      this.sizeColumnsToFit(o, "sizeColumnsToFit", !1, e);
      return;
    }
    t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, -1);
    }, 500) : F(29);
  }
  // called from api
  sizeColumnsToFit(e, t = "sizeColumnsToFit", o, i) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.sizeColumnsToFit(e, t, o, i));
      return;
    }
    const s = {};
    for (const { key: p, ...f } of i?.columnLimits ?? [])
      s[typeof p == "string" ? p : p.getColId()] = f;
    const n = this.beans.visibleCols.allCols;
    if (e <= 0 || !n.length)
      return;
    const r = be(n);
    if (i?.onlyScaleUp && r > e || e === r && n.every((f) => {
      if (f.colDef.suppressSizeToFit)
        return !0;
      const C = s?.[f.getId()], m = C?.minWidth ?? i?.defaultMinWidth, v = C?.maxWidth ?? i?.defaultMaxWidth, S = f.getActualWidth();
      return (m == null || S >= m) && (v == null || S <= v);
    }))
      return;
    const a = [], d = [];
    for (const p of n) {
      const f = i?.colKeys?.some((C) => It(p, C)) ?? !0;
      p.getColDef().suppressSizeToFit || !f ? d.push(p) : a.push(p);
    }
    const c = a.slice(0);
    let u = !1;
    const h = (p) => {
      Pe(a, p), d.push(p);
    };
    for (const p of a) {
      p.resetActualWidth(t);
      const f = s?.[p.getId()], C = f?.minWidth ?? i?.defaultMinWidth, m = f?.maxWidth ?? i?.defaultMaxWidth, v = p.getActualWidth();
      typeof C == "number" && v < C ? p.setActualWidth(C, t, !0) : typeof m == "number" && v > m && p.setActualWidth(m, t, !0);
    }
    for (; !u; ) {
      u = !0;
      const p = e - be(d);
      if (p <= 0)
        for (const f of a) {
          const C = s?.[f.getId()]?.minWidth ?? i?.defaultMinWidth ?? f.minWidth;
          f.setActualWidth(C, t, !0);
        }
      else {
        const f = p / be(a);
        let C = p;
        for (let m = a.length - 1; m >= 0; m--) {
          const v = a[m], S = s?.[v.getId()], D = S?.minWidth ?? i?.defaultMinWidth, y = S?.maxWidth ?? i?.defaultMaxWidth, R = v.getMinWidth(), x = v.getMaxWidth(), k = typeof D == "number" && D > R ? D : R, I = typeof y == "number" && y < x ? y : x;
          let T = Math.round(v.getActualWidth() * f);
          T < k ? (T = k, h(v), u = !1) : T > I ? (T = I, h(v), u = !1) : m === 0 && (T = C), v.setActualWidth(T, t, !0), C -= T;
        }
      }
    }
    for (const p of c)
      p.fireColumnWidthChangedEvent(t);
    const g = this.beans.visibleCols;
    g.setLeftValues(t), g.updateBodyWidths(), !o && gt(this.eventSvc, c, !0, t);
  }
  applyAutosizeStrategy() {
    const { gos: e, colDelayRenderSvc: t } = this.beans, o = e.get("autoSizeStrategy");
    o?.type !== "fitGridWidth" && o?.type !== "fitProvidedWidth" || setTimeout(() => {
      if (!this.isAlive())
        return;
      const i = o.type;
      if (i === "fitGridWidth") {
        const { columnLimits: s, defaultMinWidth: n, defaultMaxWidth: r } = o, l = s?.map(({ colId: a, minWidth: d, maxWidth: c }) => ({
          key: a,
          minWidth: d,
          maxWidth: c
        }));
        this.sizeColumnsToFitGridBody({
          defaultMinWidth: n,
          defaultMaxWidth: r,
          columnLimits: l
        });
      } else i === "fitProvidedWidth" && this.sizeColumnsToFit(o.width, "sizeColumnsToFit");
      t?.revealColumns(i);
    });
  }
  onFirstDataRendered({ colIds: e, ...t }) {
    setTimeout(() => {
      if (!this.isAlive())
        return;
      const o = "autosizeColumns";
      e ? this.autoSizeCols({ ...t, source: o, colKeys: e }) : this.autoSizeAllColumns({ ...t, source: o }), this.beans.colDelayRenderSvc?.revealColumns(t.type);
    });
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1;
    for (const e of this.resizeOperationQueue)
      e();
    this.resizeOperationQueue = [];
  }
  pushResizeOperation(e) {
    this.resizeOperationQueue.push(e);
  }
  destroy() {
    this.resizeOperationQueue.length = 0, super.destroy();
  }
};
function sS(e, t, o = {}) {
  const i = o.minWidth ?? e.getMinWidth();
  t < i && (t = i);
  const s = o.maxWidth ?? e.getMaxWidth();
  return t > s && (t = s), t;
}
function bn({ ctrlsSvc: e, scrollVisibleSvc: t }) {
  const o = e.getGridBodyCtrl(), s = o.isVerticalScrollShowing() ? t.getScrollbarWidth() : 0;
  return Ot(o.eGridBody) - s;
}
var ES = {
  moduleName: "ColumnAutoSize",
  version: M,
  beans: [iS],
  apiFunctions: {
    sizeColumnsToFit: tS,
    autoSizeColumns: Bl,
    autoSizeAllColumns: oS
  },
  dependsOn: [ll]
}, nS = class extends b {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.staticClasses = [], this.beans = t, this.column = e.column;
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const { column: e, cellComp: t } = this, o = e.colDef, i = o.cellClassRules, s = this.getCellClassParams(e, o);
    Pl(
      this.beans.expressionSvc,
      // if current was previous, skip
      i === this.cellClassRules ? void 0 : this.cellClassRules,
      i,
      s,
      (n) => t.toggleCss(n, !0),
      (n) => t.toggleCss(n, !1)
    ), this.cellClassRules = i;
  }
  applyUserStyles() {
    const e = this.column, t = e.colDef, o = t.cellStyle;
    if (!o)
      return;
    let i;
    if (typeof o == "function") {
      const s = this.getCellClassParams(e, t);
      i = o(s);
    } else
      i = o;
    i && this.cellComp.setUserStyles(i);
  }
  applyClassesFromColDef() {
    const { column: e, cellComp: t } = this, o = e.colDef, i = this.getCellClassParams(e, o);
    for (const n of this.staticClasses)
      t.toggleCss(n, !1);
    const s = this.beans.cellStyles.getStaticCellClasses(o, i);
    this.staticClasses = s;
    for (const n of s)
      t.toggleCss(n, !0);
  }
  getCellClassParams(e, t) {
    const { value: o, rowNode: i } = this.cellCtrl;
    return L(this.beans.gos, {
      value: o,
      data: i.data,
      node: i,
      colDef: t,
      column: e,
      rowIndex: i.rowIndex
    });
  }
}, rS = class extends b {
  constructor() {
    super(...arguments), this.beanName = "cellStyles";
  }
  processAllCellClasses(e, t, o, i) {
    Pl(
      this.beans.expressionSvc,
      void 0,
      e.cellClassRules,
      t,
      o,
      i
    ), this.processStaticCellClasses(e, t, o);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: o } = e;
    if (!o)
      return [];
    let i;
    return typeof o == "function" ? i = o(t) : i = o, typeof i == "string" && (i = [i]), i || [];
  }
  createCellCustomStyleFeature(e, t) {
    return new nS(e, t);
  }
  processStaticCellClasses(e, t, o) {
    this.getStaticCellClasses(e, t).forEach((s) => {
      o(s);
    });
  }
}, AS = {
  moduleName: "CellStyle",
  version: M,
  beans: [rS]
}, lS = class extends b {
  constructor() {
    super(...arguments), this.beanName = "apiEventSvc", this.syncListeners = /* @__PURE__ */ new Map(), this.asyncListeners = /* @__PURE__ */ new Map(), this.syncGlobalListeners = /* @__PURE__ */ new Set(), this.globalListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    this.wrapSvc = this.beans.frameworkOverrides.createGlobalEventListenerWrapper?.();
  }
  addListener(e, t) {
    const o = this.wrapSvc?.wrap(e, t) ?? t, i = !Co.has(e), s = i ? this.asyncListeners : this.syncListeners;
    s.has(e) || s.set(e, /* @__PURE__ */ new Set()), s.get(e).add(o), this.eventSvc.addListener(e, o, i);
  }
  removeListener(e, t) {
    const o = this.wrapSvc?.unwrap(e, t) ?? t, s = !!this.asyncListeners.get(e)?.delete(o);
    s || this.syncListeners.get(e)?.delete(o), this.eventSvc.removeListener(e, o, s);
  }
  addGlobalListener(e) {
    const t = this.wrapSvc?.wrapGlobal(e) ?? e, o = (n, r) => {
      Co.has(n) && t(n, r);
    }, i = (n, r) => {
      Co.has(n) || t(n, r);
    };
    this.globalListenerPairs.set(e, { syncListener: o, asyncListener: i });
    const s = this.eventSvc;
    s.addGlobalListener(o, !1), s.addGlobalListener(i, !0);
  }
  removeGlobalListener(e) {
    const { eventSvc: t, wrapSvc: o, globalListenerPairs: i } = this, s = o?.unwrapGlobal(e) ?? e;
    if (i.has(s)) {
      const { syncListener: r, asyncListener: l } = i.get(s);
      t.removeGlobalListener(r, !1), t.removeGlobalListener(l, !0), i.delete(e);
    } else
      this.syncGlobalListeners.delete(s), t.removeGlobalListener(s, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((o, i) => {
      o.forEach((s) => this.eventSvc.removeListener(i, s, t)), o.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    for (const o of e)
      this.eventSvc.removeGlobalListener(o, t);
    e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncListeners, !1), this.destroyEventListeners(this.asyncListeners, !0), this.destroyGlobalListeners(this.syncGlobalListeners, !1);
    const { globalListenerPairs: e, eventSvc: t } = this;
    e.forEach(({ syncListener: o, asyncListener: i }) => {
      t.removeGlobalListener(o, !1), t.removeGlobalListener(i, !0);
    }), e.clear();
  }
};
function aS(e, t, o) {
  e.apiEventSvc?.addListener(t, o);
}
function dS(e, t, o) {
  e.apiEventSvc?.removeListener(t, o);
}
function cS(e, t) {
  e.apiEventSvc?.addGlobalListener(t);
}
function uS(e, t) {
  e.apiEventSvc?.removeGlobalListener(t);
}
var MS = {
  moduleName: "EventApi",
  version: M,
  apiFunctions: {
    addEventListener: aS,
    addGlobalListener: cS,
    removeEventListener: dS,
    removeGlobalListener: uS
  },
  beans: [lS]
}, TS = {
  moduleName: "Locale",
  version: M,
  beans: [cv]
};
export {
  Co as ALWAYS_SYNC_GLOBAL_EVENTS,
  vc as AgAbstractInputField,
  Cc as AgAbstractLabel,
  yr as AgCheckbox,
  Rr as AgCheckboxSelector,
  je as AgColumn,
  Ut as AgColumnGroup,
  Dc as AgPickerField,
  _t as AgPromise,
  uo as AgProvidedColumnGroup,
  Ec as AgSelect,
  wS as BaseComponentWrapper,
  Oh as BaseSelectionService,
  b as BeanStub,
  AS as CellStyleModule,
  Ho as ChangedPath,
  RS as ClientSideRowModelApiModule,
  yS as ClientSideRowModelModule,
  fS as ColumnApiModule,
  ES as ColumnAutoSizeModule,
  nd as ColumnKeyCreator,
  O as Component,
  Cr as CssClassManager,
  MS as EventApiModule,
  Yu as FakeHScrollComp,
  Xu as FakeVScrollComp,
  Vo as GROUP_AUTO_COLUMN_ID,
  Ku as GridBodyCtrl,
  dv as GridCoreCreator,
  ag as GridCtrl,
  ch as GridHeaderCtrl,
  Dd as GroupInstanceIdCreator,
  bh as HeaderRowContainerCtrl,
  xS as HighlightChangesModule,
  w as KeyCode,
  $e as LocalEventService,
  TS as LocaleModule,
  cv as LocaleService,
  _o as ManagedFocusFeature,
  hS as ModuleRegistry,
  PS as PaginationModule,
  nr as ROW_NUMBERS_COLUMN_ID,
  P as RefPlaceholder,
  FS as RenderApiModule,
  DS as RowApiModule,
  _u as RowContainerCtrl,
  us as RowNode,
  bS as RowSelectionModule,
  sr as SELECTION_COLUMN_ID,
  ai as TabGuardClassNames,
  Jr as TabGuardComp,
  Bh as TabGuardCtrl,
  Vh as TabGuardFeature,
  Be as TouchListener,
  SS as ValidationModule,
  _h as VanillaFrameworkOverrides,
  Ge as _AgBeanStub,
  No as _AgComponentStub,
  Jc as _AgContext,
  mC as _BOOLEAN_MIXED_GRID_OPTIONS,
  cu as _BaseDragAndDropService,
  du as _BaseDragService,
  tu as _BaseEnvironment,
  iu as _BaseEventService,
  nu as _BasePopupService,
  ou as _BaseRegistry,
  Sp as _ColumnGroupModule,
  Zg as _ColumnMoveModule,
  _v as _CsrmSsrmSharedApiModule,
  sl as _DragModule,
  vu as _FOCUS_MANAGED_CLASS,
  wC as _GET_ALL_GRID_OPTIONS,
  MC as _HeaderComp,
  Eg as _HorizontalResizeModule,
  wm as _KeyboardNavigationModule,
  iC as _PUBLIC_EVENTS,
  bs as _PUBLIC_EVENT_HANDLERS_MAP,
  Pv as _PopupModule,
  gu as _ROW_ID_PREFIX_BOTTOM_PINNED,
  Vi as _ROW_ID_PREFIX_ROW_GROUP,
  hu as _ROW_ID_PREFIX_TOP_PINNED,
  Uv as _RowModelSharedApiModule,
  Fg as _SharedDragAndDropModule,
  Wv as _SharedRowSelectionModule,
  Fl as _SortModule,
  qf as _addAdditionalCss,
  Mi as _addColumnDefaultAndTypes,
  sh as _addFocusableContainerListener,
  L as _addGridCommonParams,
  Sa as _anchorElementToMouseMoveEvent,
  pt as _applyColumnState,
  bg as _areCellsEqual,
  ld as _areColIdsEqual,
  St as _areEqual,
  Ri as _batchCall,
  J as _clearElement,
  It as _columnsMatch,
  gS as _combineAttributesAndGridOptions,
  lt as _convertColumnEventSourceType,
  jt as _createAgElement,
  Sg as _createCellId,
  ud as _createColumnTree,
  ie as _createElement,
  fu as _createGlobalRowEvent,
  Dh as _createIcon,
  ye as _createIconNoSpan,
  We as _debounce,
  Nl as _defaultComparator,
  Fo as _destroyColumnTree,
  ts as _doOnce,
  Ce as _errMsg,
  W as _error,
  Et as _escapeString,
  A as _exists,
  at as _findFocusableElements,
  qt as _findNextFocusableElement,
  pc as _findTabbableParent,
  Cu as _firstLeaf,
  nh as _focusGridInnerElement,
  To as _focusInto,
  mt as _focusNextGridCoreContainer,
  uv as _formatNumberCommas,
  Hi as _fuzzySuggestions,
  ca as _getAbsoluteHeight,
  yi as _getAbsoluteWidth,
  N as _getActiveDomElement,
  td as _getCallbackForEvent,
  no as _getCellByPosition,
  ps as _getCellCtrlForEventTarget,
  ju as _getCellPositionForEvent,
  Bs as _getCellRendererDetails,
  Ro as _getCheckboxLocation,
  rt as _getCheckboxes,
  Oe as _getClientSideRowModel,
  Ti as _getColumnState,
  rr as _getColumnsFromTree,
  j as _getDocument,
  Rg as _getFirstRow,
  Kr as _getFloatingFiltersHeight,
  Ma as _getGlobalGridOption,
  Po as _getGroupSelection,
  zt as _getGroupSelectsDescendants,
  co as _getHeaderCheckbox,
  Ur as _getHeaderClassesFromColDef,
  Yi as _getInnerHeight,
  Ot as _getInnerWidth,
  Ai as _getIsRowSelectable,
  xg as _getLastRow,
  ya as _getLocaleTextFromFunc,
  Ra as _getLocaleTextFromMap,
  Wn as _getLocaleTextFunc,
  ji as _getPageBody,
  ge as _getRootNode,
  Go as _getRowAbove,
  en as _getRowBelow,
  po as _getRowContainerClass,
  Yt as _getRowContainerOptions,
  yu as _getRowCtrlForEventTarget,
  Bo as _getRowHeightAsNumber,
  Di as _getRowHeightForNode,
  Ei as _getRowIdCallback,
  ol as _getRowNode,
  xo as _getRowSelectionMode,
  ku as _getRowSpanContainerClass,
  Vr as _getRowViewportClass,
  Ls as _interpretAsRightClick,
  nt as _isAnimateRows,
  mr as _isBrowserFirefox,
  ls as _isBrowserSafari,
  ht as _isCellSelectionEnabled,
  re as _isClientSideRowModel,
  pe as _isColumnsSortingCoupledToGroup,
  Y as _isDomLayout,
  fa as _isElementInEventPath,
  ha as _isElementOverflowingCallback,
  dc as _isEventFromPrintableCharacter,
  Ya as _isFullWidthGroupRow,
  Qn as _isGetRowHeightFunction,
  Jn as _isGroupRowsSticky,
  er as _isGroupUseEntireRow,
  kt as _isIOSUserAgent,
  gc as _isKeyboardMode,
  Do as _isLegacyMenuEnabled,
  Nt as _isMultiRowSelection,
  Ji as _isNodeOrElement,
  yn as _isNothingFocused,
  yg as _isRowBefore,
  ze as _isRowSelection,
  rs as _isServerSideRowModel,
  xe as _isStopPropagationForAgGrid,
  Za as _isUsingNewRowSelectionAPI,
  ke as _isVisible,
  G as _last,
  Zi as _loadTemplate,
  Ne as _makeNull,
  ee as _mergeDeep,
  H as _missing,
  wt as _observeResize,
  Gi as _parseDateTimeFromString,
  pS as _processOnChange,
  Wt as _registerModule,
  na as _removeAriaSort,
  Pe as _removeFromArray,
  Ae as _removeFromParent,
  Le as _requestAnimationFrame,
  bd as _resetColumnState,
  Ru as _selectAllCells,
  zs as _serialiseDate,
  oa as _setAriaColCount,
  En as _setAriaColIndex,
  ia as _setAriaColSpan,
  ra as _setAriaControls,
  la as _setAriaControlsAndLabel,
  Ql as _setAriaDisabled,
  Si as _setAriaExpanded,
  Fn as _setAriaHidden,
  Zl as _setAriaInvalid,
  Gt as _setAriaLabel,
  Ht as _setAriaLabelledBy,
  Jl as _setAriaPosInSet,
  Ie as _setAriaRole,
  ta as _setAriaRowCount,
  bi as _setAriaRowIndex,
  An as _setAriaSelected,
  Xl as _setAriaSetSize,
  sa as _setAriaSort,
  Tn as _setDisabled,
  V as _setDisplayed,
  Me as _setFixedWidth,
  da as _setVisible,
  Ct as _stopPropagationForAgGrid,
  go as _suppressCellMouseEvent,
  Oo as _toString,
  wi as _toStringOrNull,
  Ii as _unwrapUserComp,
  ad as _updateColsMap,
  pd as _updateColumnState,
  Ea as _waitUntil,
  F as _warn,
  Tt as _warnOnce,
  wf as buttonStyleAlpine,
  mf as buttonStyleQuartz,
  hl as checkboxStyleDefault,
  CS as colorSchemeDark,
  gl as colorSchemeVariable,
  ws as columnDropStyleBordered,
  vS as createGrid,
  te as createPart,
  ul as createTheme,
  Af as iconSetAlpine,
  If as iconSetQuartz,
  kf as iconSetQuartzRegular,
  Cl as inputStyleBordered,
  Ke as isColumn,
  B as isColumnGroup,
  lr as isColumnGroupAutoCol,
  He as isColumnSelectionCol,
  $ as isProvidedColumnGroup,
  Te as isRowNumberCol,
  rd as isSpecialCol,
  kl as onRowHeightChanged,
  Ll as resetRowHeights,
  Nf as tabStyleAlpine,
  Vf as tabStyleQuartz,
  mS as themeAlpine,
  _f as themeQuartz
};
